import * as Re from "react";
import ye, { createContext as Ze, useContext as Sr, useState as He, useRef as ze, forwardRef as vt, useCallback as Cr, useEffect as Hr, useMemo as Pe } from "react";
import { enqueueSnackbar as Mh, Box as st, Popover as Oh, Button as Da, Typography as Bt, SelectAdvanceComponents as an, TextField as xs, TypoTooltip as Lh, useDebounceValue as Qo } from "@applift/factor";
import { Calendar as Nh, CaretDown as Uh, AngleLeft as Vh, AngleRight as Wh, Close as H2, Download as j2, Upload as z2, GlobeAlt as G2 } from "@applift/icons";
import Za from "clsx";
import "react-dom";
import { useQuery as ms } from "@tanstack/react-query";
import Hh from "axios";
import { useRouterState as K2 } from "@tanstack/react-router";
import { useDataDogContext as Y2 } from "@applift/platform";
var X2 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Z2(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Du = { exports: {} }, _i = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var cf;
function J2() {
  if (cf)
    return _i;
  cf = 1;
  var e = ye, r = Symbol.for("react.element"), t = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, n = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(o, u, l) {
    var c, f = {}, h = null, d = null;
    l !== void 0 && (h = "" + l), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (d = u.ref);
    for (c in u)
      a.call(u, c) && !i.hasOwnProperty(c) && (f[c] = u[c]);
    if (o && o.defaultProps)
      for (c in u = o.defaultProps, u)
        f[c] === void 0 && (f[c] = u[c]);
    return { $$typeof: r, type: o, key: h, ref: d, props: f, _owner: n.current };
  }
  return _i.Fragment = t, _i.jsx = s, _i.jsxs = s, _i;
}
var $i = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ff;
function q2() {
  return ff || (ff = 1, process.env.NODE_ENV !== "production" && function() {
    var e = ye, r = Symbol.for("react.element"), t = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), o = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), d = Symbol.for("react.offscreen"), m = Symbol.iterator, x = "@@iterator";
    function p(g) {
      if (g === null || typeof g != "object")
        return null;
      var _ = m && g[m] || g[x];
      return typeof _ == "function" ? _ : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function D(g) {
      {
        for (var _ = arguments.length, S = new Array(_ > 1 ? _ - 1 : 0), R = 1; R < _; R++)
          S[R - 1] = arguments[R];
        y("error", g, S);
      }
    }
    function y(g, _, S) {
      {
        var R = w.ReactDebugCurrentFrame, K = R.getStackAddendum();
        K !== "" && (_ += "%s", S = S.concat([K]));
        var Q = S.map(function(z) {
          return String(z);
        });
        Q.unshift("Warning: " + _), Function.prototype.apply.call(console[g], console, Q);
      }
    }
    var B = !1, L = !1, U = !1, k = !1, v = !1, b;
    b = Symbol.for("react.module.reference");
    function A(g) {
      return !!(typeof g == "string" || typeof g == "function" || g === a || g === i || v || g === n || g === l || g === c || k || g === d || B || L || U || typeof g == "object" && g !== null && (g.$$typeof === h || g.$$typeof === f || g.$$typeof === s || g.$$typeof === o || g.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      g.$$typeof === b || g.getModuleId !== void 0));
    }
    function T(g, _, S) {
      var R = g.displayName;
      if (R)
        return R;
      var K = _.displayName || _.name || "";
      return K !== "" ? S + "(" + K + ")" : S;
    }
    function C(g) {
      return g.displayName || "Context";
    }
    function I(g) {
      if (g == null)
        return null;
      if (typeof g.tag == "number" && D("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof g == "function")
        return g.displayName || g.name || null;
      if (typeof g == "string")
        return g;
      switch (g) {
        case a:
          return "Fragment";
        case t:
          return "Portal";
        case i:
          return "Profiler";
        case n:
          return "StrictMode";
        case l:
          return "Suspense";
        case c:
          return "SuspenseList";
      }
      if (typeof g == "object")
        switch (g.$$typeof) {
          case o:
            var _ = g;
            return C(_) + ".Consumer";
          case s:
            var S = g;
            return C(S._context) + ".Provider";
          case u:
            return T(g, g.render, "ForwardRef");
          case f:
            var R = g.displayName || null;
            return R !== null ? R : I(g.type) || "Memo";
          case h: {
            var K = g, Q = K._payload, z = K._init;
            try {
              return I(z(Q));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Y = Object.assign, j = 0, J, W, ce, V, ee, de, F;
    function H() {
    }
    H.__reactDisabledLog = !0;
    function P() {
      {
        if (j === 0) {
          J = console.log, W = console.info, ce = console.warn, V = console.error, ee = console.group, de = console.groupCollapsed, F = console.groupEnd;
          var g = {
            configurable: !0,
            enumerable: !0,
            value: H,
            writable: !0
          };
          Object.defineProperties(console, {
            info: g,
            log: g,
            warn: g,
            error: g,
            group: g,
            groupCollapsed: g,
            groupEnd: g
          });
        }
        j++;
      }
    }
    function N() {
      {
        if (j--, j === 0) {
          var g = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Y({}, g, {
              value: J
            }),
            info: Y({}, g, {
              value: W
            }),
            warn: Y({}, g, {
              value: ce
            }),
            error: Y({}, g, {
              value: V
            }),
            group: Y({}, g, {
              value: ee
            }),
            groupCollapsed: Y({}, g, {
              value: de
            }),
            groupEnd: Y({}, g, {
              value: F
            })
          });
        }
        j < 0 && D("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var X = w.ReactCurrentDispatcher, ae;
    function ie(g, _, S) {
      {
        if (ae === void 0)
          try {
            throw Error();
          } catch (K) {
            var R = K.stack.trim().match(/\n( *(at )?)/);
            ae = R && R[1] || "";
          }
        return `
` + ae + g;
      }
    }
    var q = !1, re;
    {
      var ve = typeof WeakMap == "function" ? WeakMap : Map;
      re = new ve();
    }
    function M(g, _) {
      if (!g || q)
        return "";
      {
        var S = re.get(g);
        if (S !== void 0)
          return S;
      }
      var R;
      q = !0;
      var K = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Q;
      Q = X.current, X.current = null, P();
      try {
        if (_) {
          var z = function() {
            throw Error();
          };
          if (Object.defineProperty(z.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(z, []);
            } catch (be) {
              R = be;
            }
            Reflect.construct(g, [], z);
          } else {
            try {
              z.call();
            } catch (be) {
              R = be;
            }
            g.call(z.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (be) {
            R = be;
          }
          g();
        }
      } catch (be) {
        if (be && R && typeof be.stack == "string") {
          for (var G = be.stack.split(`
`), Z = R.stack.split(`
`), ne = G.length - 1, oe = Z.length - 1; ne >= 1 && oe >= 0 && G[ne] !== Z[oe]; )
            oe--;
          for (; ne >= 1 && oe >= 0; ne--, oe--)
            if (G[ne] !== Z[oe]) {
              if (ne !== 1 || oe !== 1)
                do
                  if (ne--, oe--, oe < 0 || G[ne] !== Z[oe]) {
                    var me = `
` + G[ne].replace(" at new ", " at ");
                    return g.displayName && me.includes("<anonymous>") && (me = me.replace("<anonymous>", g.displayName)), typeof g == "function" && re.set(g, me), me;
                  }
                while (ne >= 1 && oe >= 0);
              break;
            }
        }
      } finally {
        q = !1, X.current = Q, N(), Error.prepareStackTrace = K;
      }
      var ue = g ? g.displayName || g.name : "", pe = ue ? ie(ue) : "";
      return typeof g == "function" && re.set(g, pe), pe;
    }
    function _e(g, _, S) {
      return M(g, !1);
    }
    function De(g) {
      var _ = g.prototype;
      return !!(_ && _.isReactComponent);
    }
    function $e(g, _, S) {
      if (g == null)
        return "";
      if (typeof g == "function")
        return M(g, De(g));
      if (typeof g == "string")
        return ie(g);
      switch (g) {
        case l:
          return ie("Suspense");
        case c:
          return ie("SuspenseList");
      }
      if (typeof g == "object")
        switch (g.$$typeof) {
          case u:
            return _e(g.render);
          case f:
            return $e(g.type, _, S);
          case h: {
            var R = g, K = R._payload, Q = R._init;
            try {
              return $e(Q(K), _, S);
            } catch {
            }
          }
        }
      return "";
    }
    var ge = Object.prototype.hasOwnProperty, fe = {}, Me = w.ReactDebugCurrentFrame;
    function Je(g) {
      if (g) {
        var _ = g._owner, S = $e(g.type, g._source, _ ? _.type : null);
        Me.setExtraStackFrame(S);
      } else
        Me.setExtraStackFrame(null);
    }
    function dr(g, _, S, R, K) {
      {
        var Q = Function.call.bind(ge);
        for (var z in g)
          if (Q(g, z)) {
            var G = void 0;
            try {
              if (typeof g[z] != "function") {
                var Z = Error((R || "React class") + ": " + S + " type `" + z + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof g[z] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Z.name = "Invariant Violation", Z;
              }
              G = g[z](_, z, R, S, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ne) {
              G = ne;
            }
            G && !(G instanceof Error) && (Je(K), D("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", R || "React class", S, z, typeof G), Je(null)), G instanceof Error && !(G.message in fe) && (fe[G.message] = !0, Je(K), D("Failed %s type: %s", S, G.message), Je(null));
          }
      }
    }
    var lr = Array.isArray;
    function Ve(g) {
      return lr(g);
    }
    function Ge(g) {
      {
        var _ = typeof Symbol == "function" && Symbol.toStringTag, S = _ && g[Symbol.toStringTag] || g.constructor.name || "Object";
        return S;
      }
    }
    function cr(g) {
      try {
        return Ae(g), !1;
      } catch {
        return !0;
      }
    }
    function Ae(g) {
      return "" + g;
    }
    function Rr(g) {
      if (cr(g))
        return D("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ge(g)), Ae(g);
    }
    var wr = w.ReactCurrentOwner, nr = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, hr, ke, Le;
    Le = {};
    function er(g) {
      if (ge.call(g, "ref")) {
        var _ = Object.getOwnPropertyDescriptor(g, "ref").get;
        if (_ && _.isReactWarning)
          return !1;
      }
      return g.ref !== void 0;
    }
    function ar(g) {
      if (ge.call(g, "key")) {
        var _ = Object.getOwnPropertyDescriptor(g, "key").get;
        if (_ && _.isReactWarning)
          return !1;
      }
      return g.key !== void 0;
    }
    function xr(g, _) {
      if (typeof g.ref == "string" && wr.current && _ && wr.current.stateNode !== _) {
        var S = I(wr.current.type);
        Le[S] || (D('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', I(wr.current.type), g.ref), Le[S] = !0);
      }
    }
    function ja(g, _) {
      {
        var S = function() {
          hr || (hr = !0, D("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", _));
        };
        S.isReactWarning = !0, Object.defineProperty(g, "key", {
          get: S,
          configurable: !0
        });
      }
    }
    function za(g, _) {
      {
        var S = function() {
          ke || (ke = !0, D("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", _));
        };
        S.isReactWarning = !0, Object.defineProperty(g, "ref", {
          get: S,
          configurable: !0
        });
      }
    }
    var E0 = function(g, _, S, R, K, Q, z) {
      var G = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: g,
        key: _,
        ref: S,
        props: z,
        // Record the component responsible for creating this element.
        _owner: Q
      };
      return G._store = {}, Object.defineProperty(G._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(G, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: R
      }), Object.defineProperty(G, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: K
      }), Object.freeze && (Object.freeze(G.props), Object.freeze(G)), G;
    };
    function Is(g, _, S, R, K) {
      {
        var Q, z = {}, G = null, Z = null;
        S !== void 0 && (Rr(S), G = "" + S), ar(_) && (Rr(_.key), G = "" + _.key), er(_) && (Z = _.ref, xr(_, K));
        for (Q in _)
          ge.call(_, Q) && !nr.hasOwnProperty(Q) && (z[Q] = _[Q]);
        if (g && g.defaultProps) {
          var ne = g.defaultProps;
          for (Q in ne)
            z[Q] === void 0 && (z[Q] = ne[Q]);
        }
        if (G || Z) {
          var oe = typeof g == "function" ? g.displayName || g.name || "Unknown" : g;
          G && ja(z, oe), Z && za(z, oe);
        }
        return E0(g, G, Z, K, R, wr.current, z);
      }
    }
    var $n = w.ReactCurrentOwner, vi = w.ReactDebugCurrentFrame;
    function va(g) {
      if (g) {
        var _ = g._owner, S = $e(g.type, g._source, _ ? _.type : null);
        vi.setExtraStackFrame(S);
      } else
        vi.setExtraStackFrame(null);
    }
    var gi;
    gi = !1;
    function ga(g) {
      return typeof g == "object" && g !== null && g.$$typeof === r;
    }
    function Bs() {
      {
        if ($n.current) {
          var g = I($n.current.type);
          if (g)
            return `

Check the render method of \`` + g + "`.";
        }
        return "";
      }
    }
    function k0(g) {
      return "";
    }
    var Ps = {};
    function T0(g) {
      {
        var _ = Bs();
        if (!_) {
          var S = typeof g == "string" ? g : g.displayName || g.name;
          S && (_ = `

Check the top-level render call using <` + S + ">.");
        }
        return _;
      }
    }
    function Ms(g, _) {
      {
        if (!g._store || g._store.validated || g.key != null)
          return;
        g._store.validated = !0;
        var S = T0(_);
        if (Ps[S])
          return;
        Ps[S] = !0;
        var R = "";
        g && g._owner && g._owner !== $n.current && (R = " It was passed a child from " + I(g._owner.type) + "."), va(g), D('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', S, R), va(null);
      }
    }
    function Os(g, _) {
      {
        if (typeof g != "object")
          return;
        if (Ve(g))
          for (var S = 0; S < g.length; S++) {
            var R = g[S];
            ga(R) && Ms(R, _);
          }
        else if (ga(g))
          g._store && (g._store.validated = !0);
        else if (g) {
          var K = p(g);
          if (typeof K == "function" && K !== g.entries)
            for (var Q = K.call(g), z; !(z = Q.next()).done; )
              ga(z.value) && Ms(z.value, _);
        }
      }
    }
    function S0(g) {
      {
        var _ = g.type;
        if (_ == null || typeof _ == "string")
          return;
        var S;
        if (typeof _ == "function")
          S = _.propTypes;
        else if (typeof _ == "object" && (_.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        _.$$typeof === f))
          S = _.propTypes;
        else
          return;
        if (S) {
          var R = I(_);
          dr(S, g.props, "prop", R, g);
        } else if (_.PropTypes !== void 0 && !gi) {
          gi = !0;
          var K = I(_);
          D("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", K || "Unknown");
        }
        typeof _.getDefaultProps == "function" && !_.getDefaultProps.isReactClassApproved && D("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function C0(g) {
      {
        for (var _ = Object.keys(g.props), S = 0; S < _.length; S++) {
          var R = _[S];
          if (R !== "children" && R !== "key") {
            va(g), D("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", R), va(null);
            break;
          }
        }
        g.ref !== null && (va(g), D("Invalid attribute `ref` supplied to `React.Fragment`."), va(null));
      }
    }
    var Dn = {};
    function Ls(g, _, S, R, K, Q) {
      {
        var z = A(g);
        if (!z) {
          var G = "";
          (g === void 0 || typeof g == "object" && g !== null && Object.keys(g).length === 0) && (G += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Z = k0();
          Z ? G += Z : G += Bs();
          var ne;
          g === null ? ne = "null" : Ve(g) ? ne = "array" : g !== void 0 && g.$$typeof === r ? (ne = "<" + (I(g.type) || "Unknown") + " />", G = " Did you accidentally export a JSX literal instead of a component?") : ne = typeof g, D("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", ne, G);
        }
        var oe = Is(g, _, S, K, Q);
        if (oe == null)
          return oe;
        if (z) {
          var me = _.children;
          if (me !== void 0)
            if (R)
              if (Ve(me)) {
                for (var ue = 0; ue < me.length; ue++)
                  Os(me[ue], g);
                Object.freeze && Object.freeze(me);
              } else
                D("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Os(me, g);
        }
        if (ge.call(_, "key")) {
          var pe = I(g), be = Object.keys(_).filter(function(Ir) {
            return Ir !== "key";
          }), rr = be.length > 0 ? "{key: someKey, " + be.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Dn[pe + rr]) {
            var ir = be.length > 0 ? "{" + be.join(": ..., ") + ": ...}" : "{}";
            D(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, rr, pe, ir, pe), Dn[pe + rr] = !0;
          }
        }
        return g === a ? C0(oe) : S0(oe), oe;
      }
    }
    function F0(g, _, S) {
      return Ls(g, _, S, !0);
    }
    function A0(g, _, S) {
      return Ls(g, _, S, !1);
    }
    var E = A0, O = F0;
    $i.Fragment = a, $i.jsx = E, $i.jsxs = O;
  }()), $i;
}
process.env.NODE_ENV === "production" ? Du.exports = J2() : Du.exports = q2();
var le = Du.exports;
function I0(e, r) {
  return e - r * Math.floor(e / r);
}
const jh = 1721426;
function Ns(e, r, t, a) {
  r = Fl(e, r);
  let n = r - 1, i = -2;
  return t <= 2 ? i = 0 : lo(r) && (i = -1), jh - 1 + 365 * n + Math.floor(n / 4) - Math.floor(n / 100) + Math.floor(n / 400) + Math.floor((367 * t - 362) / 12 + i + a);
}
function lo(e) {
  return e % 4 === 0 && (e % 100 !== 0 || e % 400 === 0);
}
function Fl(e, r) {
  return e === "BC" ? 1 - r : r;
}
function Q2(e) {
  let r = "AD";
  return e <= 0 && (r = "BC", e = 1 - e), [
    r,
    e
  ];
}
const eg = {
  standard: [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
  ],
  leapyear: [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
  ]
};
let Xn = class {
  fromJulianDay(r) {
    let t = r, a = t - jh, n = Math.floor(a / 146097), i = I0(a, 146097), s = Math.floor(i / 36524), o = I0(i, 36524), u = Math.floor(o / 1461), l = I0(o, 1461), c = Math.floor(l / 365), f = n * 400 + s * 100 + u * 4 + c + (s !== 4 && c !== 4 ? 1 : 0), [h, d] = Q2(f), m = t - Ns(h, d, 1, 1), x = 2;
    t < Ns(h, d, 3, 1) ? x = 0 : lo(d) && (x = 1);
    let p = Math.floor(((m + x) * 12 + 373) / 367), w = t - Ns(h, d, p, 1) + 1;
    return new ot(h, d, p, w);
  }
  toJulianDay(r) {
    return Ns(r.era, r.year, r.month, r.day);
  }
  getDaysInMonth(r) {
    return eg[lo(r.year) ? "leapyear" : "standard"][r.month - 1];
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getMonthsInYear(r) {
    return 12;
  }
  getDaysInYear(r) {
    return lo(r.year) ? 366 : 365;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getYearsInEra(r) {
    return 9999;
  }
  getEras() {
    return [
      "BC",
      "AD"
    ];
  }
  isInverseEra(r) {
    return r.era === "BC";
  }
  balanceDate(r) {
    r.year <= 0 && (r.era = r.era === "BC" ? "AD" : "BC", r.year = 1 - r.year);
  }
  constructor() {
    this.identifier = "gregory";
  }
};
function zh(e) {
  return pr(Date.now(), e);
}
function Ne(e) {
  return ng(zh(e));
}
function Gh(e, r) {
  return e.calendar.toJulianDay(e) - r.calendar.toJulianDay(r);
}
function rg(e, r) {
  return df(e) - df(r);
}
function df(e) {
  return e.hour * 36e5 + e.minute * 6e4 + e.second * 1e3 + e.millisecond;
}
let B0 = null;
function Kh() {
  return B0 == null && (B0 = new Intl.DateTimeFormat().resolvedOptions().timeZone), B0;
}
function Zn(e) {
  e = jt(e, new Xn());
  let r = Fl(e.era, e.year);
  return Yh(r, e.month, e.day, e.hour, e.minute, e.second, e.millisecond);
}
function Yh(e, r, t, a, n, i, s) {
  let o = /* @__PURE__ */ new Date();
  return o.setUTCHours(a, n, i, s), o.setUTCFullYear(e, r - 1, t), o.getTime();
}
function Eu(e, r) {
  if (r === "UTC")
    return 0;
  if (e > 0 && r === Kh())
    return new Date(e).getTimezoneOffset() * -6e4;
  let { year: t, month: a, day: n, hour: i, minute: s, second: o } = Xh(e, r);
  return Yh(t, a, n, i, s, o, 0) - Math.floor(e / 1e3) * 1e3;
}
const hf = /* @__PURE__ */ new Map();
function Xh(e, r) {
  let t = hf.get(r);
  t || (t = new Intl.DateTimeFormat("en-US", {
    timeZone: r,
    hour12: !1,
    era: "short",
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  }), hf.set(r, t));
  let a = t.formatToParts(new Date(e)), n = {};
  for (let i of a)
    i.type !== "literal" && (n[i.type] = i.value);
  return {
    // Firefox returns B instead of BC... https://bugzilla.mozilla.org/show_bug.cgi?id=1752253
    year: n.era === "BC" || n.era === "B" ? -n.year + 1 : +n.year,
    month: +n.month,
    day: +n.day,
    hour: n.hour === "24" ? 0 : +n.hour,
    minute: +n.minute,
    second: +n.second
  };
}
const xf = 864e5;
function tg(e, r, t, a) {
  return (t === a ? [
    t
  ] : [
    t,
    a
  ]).filter((i) => ag(e, r, i));
}
function ag(e, r, t) {
  let a = Xh(t, r);
  return e.year === a.year && e.month === a.month && e.day === a.day && e.hour === a.hour && e.minute === a.minute && e.second === a.second;
}
function Qt(e, r, t = "compatible") {
  let a = Jn(e);
  if (r === "UTC")
    return Zn(a);
  if (r === Kh() && t === "compatible") {
    a = jt(a, new Xn());
    let u = /* @__PURE__ */ new Date(), l = Fl(a.era, a.year);
    return u.setFullYear(l, a.month - 1, a.day), u.setHours(a.hour, a.minute, a.second, a.millisecond), u.getTime();
  }
  let n = Zn(a), i = Eu(n - xf, r), s = Eu(n + xf, r), o = tg(a, r, n - i, n - s);
  if (o.length === 1)
    return o[0];
  if (o.length > 1)
    switch (t) {
      case "compatible":
      case "earlier":
        return o[0];
      case "later":
        return o[o.length - 1];
      case "reject":
        throw new RangeError("Multiple possible absolute times found");
    }
  switch (t) {
    case "earlier":
      return Math.min(n - i, n - s);
    case "compatible":
    case "later":
      return Math.max(n - i, n - s);
    case "reject":
      throw new RangeError("No such absolute time found");
  }
}
function Zh(e, r, t = "compatible") {
  return new Date(Qt(e, r, t));
}
function pr(e, r) {
  let t = Eu(e, r), a = new Date(e + t), n = a.getUTCFullYear(), i = a.getUTCMonth() + 1, s = a.getUTCDate(), o = a.getUTCHours(), u = a.getUTCMinutes(), l = a.getUTCSeconds(), c = a.getUTCMilliseconds();
  return new i1(n, i, s, r, t, o, u, l, c);
}
function ng(e) {
  return new ot(e.calendar, e.era, e.year, e.month, e.day);
}
function Jn(e, r) {
  let t = 0, a = 0, n = 0, i = 0;
  if ("timeZone" in e)
    ({ hour: t, minute: a, second: n, millisecond: i } = e);
  else if ("hour" in e && !r)
    return e;
  return r && ({ hour: t, minute: a, second: n, millisecond: i } = r), new Ft(e.calendar, e.era, e.year, e.month, e.day, t, a, n, i);
}
function jt(e, r) {
  if (e.calendar.identifier === r.identifier)
    return e;
  let t = r.fromJulianDay(e.calendar.toJulianDay(e)), a = e.copy();
  return a.calendar = r, a.era = t.era, a.year = t.year, a.month = t.month, a.day = t.day, nn(a), a;
}
function Jh(e, r, t) {
  if (e instanceof i1)
    return e.timeZone === r ? e : sg(e, r);
  let a = Qt(e, r, t);
  return pr(a, r);
}
function ig(e) {
  let r = Zn(e) - e.offset;
  return new Date(r);
}
function sg(e, r) {
  let t = Zn(e) - e.offset;
  return jt(pr(t, r), e.calendar);
}
const Di = 36e5;
function e0(e, r) {
  let t = e.copy(), a = "hour" in t ? cg(t, r) : 0;
  ku(t, r.years || 0), t.calendar.balanceYearMonth && t.calendar.balanceYearMonth(t, e), t.month += r.months || 0, Tu(t), qh(t), t.day += (r.weeks || 0) * 7, t.day += r.days || 0, t.day += a, og(t), t.calendar.balanceDate && t.calendar.balanceDate(t), t.year < 1 && (t.year = 1, t.month = 1, t.day = 1);
  let n = t.calendar.getYearsInEra(t);
  if (t.year > n) {
    var i, s;
    let u = (i = (s = t.calendar).isInverseEra) === null || i === void 0 ? void 0 : i.call(s, t);
    t.year = n, t.month = u ? 1 : t.calendar.getMonthsInYear(t), t.day = u ? 1 : t.calendar.getDaysInMonth(t);
  }
  t.month < 1 && (t.month = 1, t.day = 1);
  let o = t.calendar.getMonthsInYear(t);
  return t.month > o && (t.month = o, t.day = t.calendar.getDaysInMonth(t)), t.day = Math.max(1, Math.min(t.calendar.getDaysInMonth(t), t.day)), t;
}
function ku(e, r) {
  var t, a;
  !((t = (a = e.calendar).isInverseEra) === null || t === void 0) && t.call(a, e) && (r = -r), e.year += r;
}
function Tu(e) {
  for (; e.month < 1; )
    ku(e, -1), e.month += e.calendar.getMonthsInYear(e);
  let r = 0;
  for (; e.month > (r = e.calendar.getMonthsInYear(e)); )
    e.month -= r, ku(e, 1);
}
function og(e) {
  for (; e.day < 1; )
    e.month--, Tu(e), e.day += e.calendar.getDaysInMonth(e);
  for (; e.day > e.calendar.getDaysInMonth(e); )
    e.day -= e.calendar.getDaysInMonth(e), e.month++, Tu(e);
}
function qh(e) {
  e.month = Math.max(1, Math.min(e.calendar.getMonthsInYear(e), e.month)), e.day = Math.max(1, Math.min(e.calendar.getDaysInMonth(e), e.day));
}
function nn(e) {
  e.calendar.constrainDate && e.calendar.constrainDate(e), e.year = Math.max(1, Math.min(e.calendar.getYearsInEra(e), e.year)), qh(e);
}
function Qh(e) {
  let r = {};
  for (let t in e)
    typeof e[t] == "number" && (r[t] = -e[t]);
  return r;
}
function e1(e, r) {
  return e0(e, Qh(r));
}
function Al(e, r) {
  let t = e.copy();
  return r.era != null && (t.era = r.era), r.year != null && (t.year = r.year), r.month != null && (t.month = r.month), r.day != null && (t.day = r.day), nn(t), t;
}
function yo(e, r) {
  let t = e.copy();
  return r.hour != null && (t.hour = r.hour), r.minute != null && (t.minute = r.minute), r.second != null && (t.second = r.second), r.millisecond != null && (t.millisecond = r.millisecond), lg(t), t;
}
function ug(e) {
  e.second += Math.floor(e.millisecond / 1e3), e.millisecond = Us(e.millisecond, 1e3), e.minute += Math.floor(e.second / 60), e.second = Us(e.second, 60), e.hour += Math.floor(e.minute / 60), e.minute = Us(e.minute, 60);
  let r = Math.floor(e.hour / 24);
  return e.hour = Us(e.hour, 24), r;
}
function lg(e) {
  e.millisecond = Math.max(0, Math.min(e.millisecond, 1e3)), e.second = Math.max(0, Math.min(e.second, 59)), e.minute = Math.max(0, Math.min(e.minute, 59)), e.hour = Math.max(0, Math.min(e.hour, 23));
}
function Us(e, r) {
  let t = e % r;
  return t < 0 && (t += r), t;
}
function cg(e, r) {
  return e.hour += r.hours || 0, e.minute += r.minutes || 0, e.second += r.seconds || 0, e.millisecond += r.milliseconds || 0, ug(e);
}
function Rl(e, r, t, a) {
  let n = e.copy();
  switch (r) {
    case "era": {
      let o = e.calendar.getEras(), u = o.indexOf(e.era);
      if (u < 0)
        throw new Error("Invalid era: " + e.era);
      u = aa(u, t, 0, o.length - 1, a == null ? void 0 : a.round), n.era = o[u], nn(n);
      break;
    }
    case "year":
      var i, s;
      !((i = (s = n.calendar).isInverseEra) === null || i === void 0) && i.call(s, n) && (t = -t), n.year = aa(e.year, t, -1 / 0, 9999, a == null ? void 0 : a.round), n.year === -1 / 0 && (n.year = 1), n.calendar.balanceYearMonth && n.calendar.balanceYearMonth(n, e);
      break;
    case "month":
      n.month = aa(e.month, t, 1, e.calendar.getMonthsInYear(e), a == null ? void 0 : a.round);
      break;
    case "day":
      n.day = aa(e.day, t, 1, e.calendar.getDaysInMonth(e), a == null ? void 0 : a.round);
      break;
    default:
      throw new Error("Unsupported field " + r);
  }
  return e.calendar.balanceDate && e.calendar.balanceDate(n), nn(n), n;
}
function r1(e, r, t, a) {
  let n = e.copy();
  switch (r) {
    case "hour": {
      let i = e.hour, s = 0, o = 23;
      if ((a == null ? void 0 : a.hourCycle) === 12) {
        let u = i >= 12;
        s = u ? 12 : 0, o = u ? 23 : 11;
      }
      n.hour = aa(i, t, s, o, a == null ? void 0 : a.round);
      break;
    }
    case "minute":
      n.minute = aa(e.minute, t, 0, 59, a == null ? void 0 : a.round);
      break;
    case "second":
      n.second = aa(e.second, t, 0, 59, a == null ? void 0 : a.round);
      break;
    case "millisecond":
      n.millisecond = aa(e.millisecond, t, 0, 999, a == null ? void 0 : a.round);
      break;
    default:
      throw new Error("Unsupported field " + r);
  }
  return n;
}
function aa(e, r, t, a, n = !1) {
  if (n) {
    e += Math.sign(r), e < t && (e = a);
    let i = Math.abs(r);
    r > 0 ? e = Math.ceil(e / i) * i : e = Math.floor(e / i) * i, e > a && (e = t);
  } else
    e += r, e < t ? e = a - (t - e - 1) : e > a && (e = t + (e - a - 1));
  return e;
}
function t1(e, r) {
  let t;
  if (r.years != null && r.years !== 0 || r.months != null && r.months !== 0 || r.weeks != null && r.weeks !== 0 || r.days != null && r.days !== 0) {
    let n = e0(Jn(e), {
      years: r.years,
      months: r.months,
      weeks: r.weeks,
      days: r.days
    });
    t = Qt(n, e.timeZone);
  } else
    t = Zn(e) - e.offset;
  t += r.milliseconds || 0, t += (r.seconds || 0) * 1e3, t += (r.minutes || 0) * 6e4, t += (r.hours || 0) * 36e5;
  let a = pr(t, e.timeZone);
  return jt(a, e.calendar);
}
function fg(e, r) {
  return t1(e, Qh(r));
}
function dg(e, r, t, a) {
  switch (r) {
    case "hour": {
      let n = 0, i = 23;
      if ((a == null ? void 0 : a.hourCycle) === 12) {
        let m = e.hour >= 12;
        n = m ? 12 : 0, i = m ? 23 : 11;
      }
      let s = Jn(e), o = jt(yo(s, {
        hour: n
      }), new Xn()), u = [
        Qt(o, e.timeZone, "earlier"),
        Qt(o, e.timeZone, "later")
      ].filter((m) => pr(m, e.timeZone).day === o.day)[0], l = jt(yo(s, {
        hour: i
      }), new Xn()), c = [
        Qt(l, e.timeZone, "earlier"),
        Qt(l, e.timeZone, "later")
      ].filter((m) => pr(m, e.timeZone).day === l.day).pop(), f = Zn(e) - e.offset, h = Math.floor(f / Di), d = f % Di;
      return f = aa(h, t, Math.floor(u / Di), Math.floor(c / Di), a == null ? void 0 : a.round) * Di + d, jt(pr(f, e.timeZone), e.calendar);
    }
    case "minute":
    case "second":
    case "millisecond":
      return r1(e, r, t, a);
    case "era":
    case "year":
    case "month":
    case "day": {
      let n = Rl(Jn(e), r, t, a), i = Qt(n, e.timeZone);
      return jt(pr(i, e.timeZone), e.calendar);
    }
    default:
      throw new Error("Unsupported field " + r);
  }
}
function hg(e, r, t) {
  let a = Jn(e), n = yo(Al(a, r), r);
  if (n.compare(a) === 0)
    return e;
  let i = Qt(n, e.timeZone, t);
  return jt(pr(i, e.timeZone), e.calendar);
}
const xg = /^(\d{4})-(\d{2})-(\d{2})$/, mg = /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}))?(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?$/;
function Ea(e) {
  let r = e.match(xg);
  if (!r)
    throw new Error("Invalid ISO 8601 date string: " + e);
  let t = new ot(Ht(r[1], 0, 9999), Ht(r[2], 1, 12), 1);
  return t.day = Ht(r[3], 0, t.calendar.getDaysInMonth(t)), t;
}
function Er(e) {
  let r = e.match(mg);
  if (!r)
    throw new Error("Invalid ISO 8601 date time string: " + e);
  let t = new Ft(Ht(r[1], 1, 9999), Ht(r[2], 1, 12), 1, r[4] ? Ht(r[4], 0, 23) : 0, r[5] ? Ht(r[5], 0, 59) : 0, r[6] ? Ht(r[6], 0, 59) : 0, r[7] ? Ht(r[7], 0, 1 / 0) * 1e3 : 0);
  return t.day = Ht(r[3], 0, t.calendar.getDaysInMonth(t)), t;
}
function Ht(e, r, t) {
  let a = Number(e);
  if (a < r || a > t)
    throw new RangeError(`Value out of range: ${r} <= ${a} <= ${t}`);
  return a;
}
function pg(e) {
  return `${String(e.hour).padStart(2, "0")}:${String(e.minute).padStart(2, "0")}:${String(e.second).padStart(2, "0")}${e.millisecond ? String(e.millisecond / 1e3).slice(1) : ""}`;
}
function a1(e) {
  let r = jt(e, new Xn());
  return `${String(r.year).padStart(4, "0")}-${String(r.month).padStart(2, "0")}-${String(r.day).padStart(2, "0")}`;
}
function n1(e) {
  return `${a1(e)}T${pg(e)}`;
}
function vg(e) {
  let r = Math.sign(e) < 0 ? "-" : "+";
  e = Math.abs(e);
  let t = Math.floor(e / 36e5), a = e % 36e5 / 6e4;
  return `${r}${String(t).padStart(2, "0")}:${String(a).padStart(2, "0")}`;
}
function gg(e) {
  return `${n1(e)}${vg(e.offset)}[${e.timeZone}]`;
}
function yg(e, r) {
  if (r.has(e))
    throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function at(e, r, t) {
  yg(e, r), r.set(e, t);
}
function Il(e) {
  let r = typeof e[0] == "object" ? e.shift() : new Xn(), t;
  if (typeof e[0] == "string")
    t = e.shift();
  else {
    let s = r.getEras();
    t = s[s.length - 1];
  }
  let a = e.shift(), n = e.shift(), i = e.shift();
  return [
    r,
    t,
    a,
    n,
    i
  ];
}
var bg = /* @__PURE__ */ new WeakMap();
let ot = class Su {
  /** Returns a copy of this date. */
  copy() {
    return this.era ? new Su(this.calendar, this.era, this.year, this.month, this.day) : new Su(this.calendar, this.year, this.month, this.day);
  }
  /** Returns a new `CalendarDate` with the given duration added to it. */
  add(r) {
    return e0(this, r);
  }
  /** Returns a new `CalendarDate` with the given duration subtracted from it. */
  subtract(r) {
    return e1(this, r);
  }
  /** Returns a new `CalendarDate` with the given fields set to the provided values. Other fields will be constrained accordingly. */
  set(r) {
    return Al(this, r);
  }
  /**
  * Returns a new `CalendarDate` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(r, t, a) {
    return Rl(this, r, t, a);
  }
  /** Converts the date to a native JavaScript Date object, with the time set to midnight in the given time zone. */
  toDate(r) {
    return Zh(this, r);
  }
  /** Converts the date to an ISO 8601 formatted string. */
  toString() {
    return a1(this);
  }
  /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */
  compare(r) {
    return Gh(this, r);
  }
  constructor(...r) {
    at(this, bg, {
      writable: !0,
      value: void 0
    });
    let [t, a, n, i, s] = Il(r);
    this.calendar = t, this.era = a, this.year = n, this.month = i, this.day = s, nn(this);
  }
};
var wg = /* @__PURE__ */ new WeakMap();
let Ft = class Cu {
  /** Returns a copy of this date. */
  copy() {
    return this.era ? new Cu(this.calendar, this.era, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond) : new Cu(this.calendar, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond);
  }
  /** Returns a new `CalendarDateTime` with the given duration added to it. */
  add(r) {
    return e0(this, r);
  }
  /** Returns a new `CalendarDateTime` with the given duration subtracted from it. */
  subtract(r) {
    return e1(this, r);
  }
  /** Returns a new `CalendarDateTime` with the given fields set to the provided values. Other fields will be constrained accordingly. */
  set(r) {
    return Al(yo(this, r), r);
  }
  /**
  * Returns a new `CalendarDateTime` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(r, t, a) {
    switch (r) {
      case "era":
      case "year":
      case "month":
      case "day":
        return Rl(this, r, t, a);
      default:
        return r1(this, r, t, a);
    }
  }
  /** Converts the date to a native JavaScript Date object in the given time zone. */
  toDate(r, t) {
    return Zh(this, r, t);
  }
  /** Converts the date to an ISO 8601 formatted string. */
  toString() {
    return n1(this);
  }
  /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */
  compare(r) {
    let t = Gh(this, r);
    return t === 0 ? rg(this, Jn(r)) : t;
  }
  constructor(...r) {
    at(this, wg, {
      writable: !0,
      value: void 0
    });
    let [t, a, n, i, s] = Il(r);
    this.calendar = t, this.era = a, this.year = n, this.month = i, this.day = s, this.hour = r.shift() || 0, this.minute = r.shift() || 0, this.second = r.shift() || 0, this.millisecond = r.shift() || 0, nn(this);
  }
};
var _g = /* @__PURE__ */ new WeakMap();
let i1 = class Fu {
  /** Returns a copy of this date. */
  copy() {
    return this.era ? new Fu(this.calendar, this.era, this.year, this.month, this.day, this.timeZone, this.offset, this.hour, this.minute, this.second, this.millisecond) : new Fu(this.calendar, this.year, this.month, this.day, this.timeZone, this.offset, this.hour, this.minute, this.second, this.millisecond);
  }
  /** Returns a new `ZonedDateTime` with the given duration added to it. */
  add(r) {
    return t1(this, r);
  }
  /** Returns a new `ZonedDateTime` with the given duration subtracted from it. */
  subtract(r) {
    return fg(this, r);
  }
  /** Returns a new `ZonedDateTime` with the given fields set to the provided values. Other fields will be constrained accordingly. */
  set(r, t) {
    return hg(this, r, t);
  }
  /**
  * Returns a new `ZonedDateTime` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(r, t, a) {
    return dg(this, r, t, a);
  }
  /** Converts the date to a native JavaScript Date object. */
  toDate() {
    return ig(this);
  }
  /** Converts the date to an ISO 8601 formatted string, including the UTC offset and time zone identifier. */
  toString() {
    return gg(this);
  }
  /** Converts the date to an ISO 8601 formatted string in UTC. */
  toAbsoluteString() {
    return this.toDate().toISOString();
  }
  /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */
  compare(r) {
    return this.toDate().getTime() - Jh(r, this.timeZone).toDate().getTime();
  }
  constructor(...r) {
    at(this, _g, {
      writable: !0,
      value: void 0
    });
    let [t, a, n, i, s] = Il(r), o = r.shift(), u = r.shift();
    this.calendar = t, this.era = a, this.year = n, this.month = i, this.day = s, this.timeZone = o, this.offset = u, this.hour = r.shift() || 0, this.minute = r.shift() || 0, this.second = r.shift() || 0, this.millisecond = r.shift() || 0, nn(this);
  }
};
Ze(null);
Ze(null);
Ze(null);
Ze(null);
Ze(null);
const r0 = Ze({}), bo = {
  prefix: String(Math.round(Math.random() * 1e10)),
  current: 0
}, s1 = /* @__PURE__ */ ye.createContext(bo), $g = /* @__PURE__ */ ye.createContext(!1);
let Dg = !!(typeof window < "u" && window.document && window.document.createElement), P0 = /* @__PURE__ */ new WeakMap();
function Eg(e = !1) {
  let r = Sr(s1), t = ze(null);
  if (t.current === null && !e) {
    var a, n;
    let i = (n = ye.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || n === void 0 || (a = n.ReactCurrentOwner) === null || a === void 0 ? void 0 : a.current;
    if (i) {
      let s = P0.get(i);
      s == null ? P0.set(i, {
        id: r.current,
        state: i.memoizedState
      }) : i.memoizedState !== s.state && (r.current = s.id, P0.delete(i));
    }
    t.current = ++r.current;
  }
  return t.current;
}
function kg(e) {
  let r = Sr(s1);
  r === bo && !Dg && console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
  let t = Eg(!!e), a = r === bo && process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${r.prefix}`;
  return e || `${a}-${t}`;
}
function Tg(e) {
  let r = ye.useId(), [t] = He(o1()), a = t || process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${bo.prefix}`;
  return e || `${a}-${r}`;
}
const Sg = typeof ye.useId == "function" ? Tg : kg;
function Cg() {
  return !1;
}
function Fg() {
  return !0;
}
function Ag(e) {
  return () => {
  };
}
function o1() {
  return typeof ye.useSyncExternalStore == "function" ? ye.useSyncExternalStore(Ag, Cg, Fg) : Sr($g);
}
if (typeof HTMLTemplateElement < "u") {
  const e = Object.getOwnPropertyDescriptor(Node.prototype, "firstChild").get;
  Object.defineProperty(HTMLTemplateElement.prototype, "firstChild", {
    configurable: !0,
    enumerable: !0,
    get: function() {
      return this.dataset.reactAriaHidden ? this.content.firstChild : e.call(this);
    }
  });
}
const Rg = /* @__PURE__ */ Ze(!1);
typeof DocumentFragment < "u" && new DocumentFragment();
function u1(e) {
  let r = (t, a) => Sr(Rg) ? null : e(t, a);
  return r.displayName = e.displayName || e.name, vt(r);
}
const fa = typeof document < "u" ? ye.useLayoutEffect : () => {
};
function ea(e) {
  const r = ze(null);
  return fa(() => {
    r.current = e;
  }, [
    e
  ]), Cr((...t) => {
    const a = r.current;
    return a == null ? void 0 : a(...t);
  }, []);
}
function Ig(e) {
  let [r, t] = He(e), a = ze(null), n = ea(() => {
    if (!a.current)
      return;
    let s = a.current.next();
    if (s.done) {
      a.current = null;
      return;
    }
    r === s.value ? n() : t(s.value);
  });
  fa(() => {
    a.current && n();
  });
  let i = ea((s) => {
    a.current = s(r), n();
  });
  return [
    r,
    i
  ];
}
let Bg = !!(typeof window < "u" && window.document && window.document.createElement), _a = /* @__PURE__ */ new Map();
function Pt(e) {
  let [r, t] = He(e), a = ze(null), n = Sg(r), i = Cr((s) => {
    a.current = s;
  }, []);
  return Bg && (_a.has(n) && !_a.get(n).includes(i) ? _a.set(n, [
    ..._a.get(n),
    i
  ]) : _a.set(n, [
    i
  ])), fa(() => {
    let s = n;
    return () => {
      _a.delete(s);
    };
  }, [
    n
  ]), Hr(() => {
    let s = a.current;
    s && (a.current = null, t(s));
  }), n;
}
function Pg(e, r) {
  if (e === r)
    return e;
  let t = _a.get(e);
  if (t)
    return t.forEach((n) => n(r)), r;
  let a = _a.get(r);
  return a ? (a.forEach((n) => n(e)), e) : r;
}
function wo(e = []) {
  let r = Pt(), [t, a] = Ig(r), n = Cr(() => {
    a(function* () {
      yield r, yield document.getElementById(r) ? r : void 0;
    });
  }, [
    r,
    a
  ]);
  return fa(n, [
    r,
    n,
    ...e
  ]), t;
}
function l1(...e) {
  return (...r) => {
    for (let t of e)
      typeof t == "function" && t(...r);
  };
}
const Yr = (e) => {
  var r;
  return (r = e == null ? void 0 : e.ownerDocument) !== null && r !== void 0 ? r : document;
}, At = (e) => e && "window" in e && e.window === e ? e : Yr(e).defaultView || window;
function Nr(...e) {
  let r = {
    ...e[0]
  };
  for (let t = 1; t < e.length; t++) {
    let a = e[t];
    for (let n in a) {
      let i = r[n], s = a[n];
      typeof i == "function" && typeof s == "function" && // This is a lot faster than a regex.
      n[0] === "o" && n[1] === "n" && n.charCodeAt(2) >= /* 'A' */
      65 && n.charCodeAt(2) <= /* 'Z' */
      90 ? r[n] = l1(i, s) : (n === "className" || n === "UNSAFE_className") && typeof i == "string" && typeof s == "string" ? r[n] = Za(i, s) : n === "id" && i && s ? r.id = Pg(i, s) : r[n] = s !== void 0 ? s : i;
    }
  }
  return r;
}
function Mg(...e) {
  return e.length === 1 && e[0] ? e[0] : (r) => {
    for (let t of e)
      typeof t == "function" ? t(r) : t != null && (t.current = r);
  };
}
const Og = /* @__PURE__ */ new Set([
  "id"
]), Lg = /* @__PURE__ */ new Set([
  "aria-label",
  "aria-labelledby",
  "aria-describedby",
  "aria-details"
]), Ng = /* @__PURE__ */ new Set([
  "href",
  "hrefLang",
  "target",
  "rel",
  "download",
  "ping",
  "referrerPolicy"
]), Ug = /^(data-.*)$/;
function lt(e, r = {}) {
  let { labelable: t, isLink: a, propNames: n } = r, i = {};
  for (const s in e)
    Object.prototype.hasOwnProperty.call(e, s) && (Og.has(s) || t && Lg.has(s) || a && Ng.has(s) || n != null && n.has(s) || Ug.test(s)) && (i[s] = e[s]);
  return i;
}
function ka(e) {
  if (Vg())
    e.focus({
      preventScroll: !0
    });
  else {
    let r = Wg(e);
    e.focus(), Hg(r);
  }
}
let Vs = null;
function Vg() {
  if (Vs == null) {
    Vs = !1;
    try {
      document.createElement("div").focus({
        get preventScroll() {
          return Vs = !0, !0;
        }
      });
    } catch {
    }
  }
  return Vs;
}
function Wg(e) {
  let r = e.parentNode, t = [], a = document.scrollingElement || document.documentElement;
  for (; r instanceof HTMLElement && r !== a; )
    (r.offsetHeight < r.scrollHeight || r.offsetWidth < r.scrollWidth) && t.push({
      element: r,
      scrollTop: r.scrollTop,
      scrollLeft: r.scrollLeft
    }), r = r.parentNode;
  return a instanceof HTMLElement && t.push({
    element: a,
    scrollTop: a.scrollTop,
    scrollLeft: a.scrollLeft
  }), t;
}
function Hg(e) {
  for (let { element: r, scrollTop: t, scrollLeft: a } of e)
    r.scrollTop = t, r.scrollLeft = a;
}
function t0(e) {
  var r;
  return typeof window > "u" || window.navigator == null ? !1 : ((r = window.navigator.userAgentData) === null || r === void 0 ? void 0 : r.brands.some((t) => e.test(t.brand))) || e.test(window.navigator.userAgent);
}
function Bl(e) {
  var r;
  return typeof window < "u" && window.navigator != null ? e.test(((r = window.navigator.userAgentData) === null || r === void 0 ? void 0 : r.platform) || window.navigator.platform) : !1;
}
function Na(e) {
  let r = null;
  return () => (r == null && (r = e()), r);
}
const Ki = Na(function() {
  return Bl(/^Mac/i);
}), jg = Na(function() {
  return Bl(/^iPhone/i);
}), c1 = Na(function() {
  return Bl(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  Ki() && navigator.maxTouchPoints > 1;
}), f1 = Na(function() {
  return jg() || c1();
}), zg = Na(function() {
  return t0(/AppleWebKit/i) && !Gg();
}), Gg = Na(function() {
  return t0(/Chrome/i);
}), d1 = Na(function() {
  return t0(/Android/i);
}), Kg = Na(function() {
  return t0(/Firefox/i);
});
function Yi(e, r, t = !0) {
  var a, n;
  let { metaKey: i, ctrlKey: s, altKey: o, shiftKey: u } = r;
  Kg() && (!((n = window.event) === null || n === void 0 || (a = n.type) === null || a === void 0) && a.startsWith("key")) && e.target === "_blank" && (Ki() ? i = !0 : s = !0);
  let l = zg() && Ki() && !c1() ? new KeyboardEvent("keydown", {
    keyIdentifier: "Enter",
    metaKey: i,
    ctrlKey: s,
    altKey: o,
    shiftKey: u
  }) : new MouseEvent("click", {
    metaKey: i,
    ctrlKey: s,
    altKey: o,
    shiftKey: u,
    bubbles: !0,
    cancelable: !0
  });
  Yi.isOpening = t, ka(e), e.dispatchEvent(l), Yi.isOpening = !1;
}
Yi.isOpening = !1;
let Rn = /* @__PURE__ */ new Map(), Au = /* @__PURE__ */ new Set();
function mf() {
  if (typeof window > "u")
    return;
  function e(a) {
    return "propertyName" in a;
  }
  let r = (a) => {
    if (!e(a) || !a.target)
      return;
    let n = Rn.get(a.target);
    n || (n = /* @__PURE__ */ new Set(), Rn.set(a.target, n), a.target.addEventListener("transitioncancel", t, {
      once: !0
    })), n.add(a.propertyName);
  }, t = (a) => {
    if (!e(a) || !a.target)
      return;
    let n = Rn.get(a.target);
    if (n && (n.delete(a.propertyName), n.size === 0 && (a.target.removeEventListener("transitioncancel", t), Rn.delete(a.target)), Rn.size === 0)) {
      for (let i of Au)
        i();
      Au.clear();
    }
  };
  document.body.addEventListener("transitionrun", r), document.body.addEventListener("transitionend", t);
}
typeof document < "u" && (document.readyState !== "loading" ? mf() : document.addEventListener("DOMContentLoaded", mf));
function h1(e) {
  requestAnimationFrame(() => {
    Rn.size === 0 ? e() : Au.add(e);
  });
}
function Yg() {
  let e = ze(/* @__PURE__ */ new Map()), r = Cr((n, i, s, o) => {
    let u = o != null && o.once ? (...l) => {
      e.current.delete(s), s(...l);
    } : s;
    e.current.set(s, {
      type: i,
      eventTarget: n,
      fn: u,
      options: o
    }), n.addEventListener(i, s, o);
  }, []), t = Cr((n, i, s, o) => {
    var u;
    let l = ((u = e.current.get(s)) === null || u === void 0 ? void 0 : u.fn) || s;
    n.removeEventListener(i, l, o), e.current.delete(s);
  }, []), a = Cr(() => {
    e.current.forEach((n, i) => {
      t(n.eventTarget, n.type, i, n.options);
    });
  }, [
    t
  ]);
  return Hr(() => a, [
    a
  ]), {
    addGlobalListener: r,
    removeGlobalListener: t,
    removeAllGlobalListeners: a
  };
}
function Pl(e, r) {
  let { id: t, "aria-label": a, "aria-labelledby": n } = e;
  return t = Pt(t), n && a ? n = [
    .../* @__PURE__ */ new Set([
      t,
      ...n.trim().split(/\s+/)
    ])
  ].join(" ") : n && (n = n.trim().split(/\s+/).join(" ")), !a && !n && r && (a = r), {
    id: t,
    "aria-label": a,
    "aria-labelledby": n
  };
}
function Xg(e) {
  const r = ze(null);
  return Pe(() => ({
    get current() {
      return r.current;
    },
    set current(t) {
      r.current = t, typeof e == "function" ? e(t) : e && (e.current = t);
    }
  }), [
    e
  ]);
}
function pf(e, r) {
  const t = ze(!0), a = ze(null);
  Hr(() => (t.current = !0, () => {
    t.current = !1;
  }), []), Hr(() => {
    t.current ? t.current = !1 : (!a.current || r.some((n, i) => !Object.is(n, a[i]))) && e(), a.current = r;
  }, r);
}
function Zg() {
  return typeof window.ResizeObserver < "u";
}
function x1(e) {
  const { ref: r, box: t, onResize: a } = e;
  Hr(() => {
    let n = r == null ? void 0 : r.current;
    if (n)
      if (Zg()) {
        const i = new window.ResizeObserver((s) => {
          s.length && a();
        });
        return i.observe(n, {
          box: t
        }), () => {
          n && i.unobserve(n);
        };
      } else
        return window.addEventListener("resize", a, !1), () => {
          window.removeEventListener("resize", a, !1);
        };
  }, [
    a,
    r,
    t
  ]);
}
function m1(e, r) {
  fa(() => {
    if (e && e.ref && r)
      return e.ref.current = r.current, () => {
        e.ref && (e.ref.current = null);
      };
  });
}
function Ru(e, r) {
  if (!e)
    return !1;
  let t = window.getComputedStyle(e), a = /(auto|scroll)/.test(t.overflow + t.overflowX + t.overflowY);
  return a && r && (a = e.scrollHeight !== e.clientHeight || e.scrollWidth !== e.clientWidth), a;
}
function Jg(e, r) {
  let t = e;
  for (Ru(t, r) && (t = t.parentElement); t && !Ru(t, r); )
    t = t.parentElement;
  return t || document.scrollingElement || document.documentElement;
}
function qg(e, r) {
  const t = [];
  for (; e && e !== document.documentElement; )
    Ru(e, r) && t.push(e), e = e.parentElement;
  return t;
}
let Qg = 0;
const M0 = /* @__PURE__ */ new Map();
function Ml(e) {
  let [r, t] = He();
  return fa(() => {
    if (!e)
      return;
    let a = M0.get(e);
    if (a)
      t(a.element.id);
    else {
      let n = `react-aria-description-${Qg++}`;
      t(n);
      let i = document.createElement("div");
      i.id = n, i.style.display = "none", i.textContent = e, document.body.appendChild(i), a = {
        refCount: 0,
        element: i
      }, M0.set(e, a);
    }
    return a.refCount++, () => {
      a && --a.refCount === 0 && (a.element.remove(), M0.delete(e));
    };
  }, [
    e
  ]), {
    "aria-describedby": e ? r : void 0
  };
}
function O0(e, r, t, a) {
  let n = ea(t), i = t == null;
  Hr(() => {
    if (i || !e.current)
      return;
    let s = e.current;
    return s.addEventListener(r, n, a), () => {
      s.removeEventListener(r, n, a);
    };
  }, [
    e,
    r,
    a,
    i,
    n
  ]);
}
function e3(e, r) {
  let t = vf(e, r, "left"), a = vf(e, r, "top"), n = r.offsetWidth, i = r.offsetHeight, s = e.scrollLeft, o = e.scrollTop, { borderTopWidth: u, borderLeftWidth: l } = getComputedStyle(e), c = e.scrollLeft + parseInt(l, 10), f = e.scrollTop + parseInt(u, 10), h = c + e.clientWidth, d = f + e.clientHeight;
  t <= s ? s = t - parseInt(l, 10) : t + n > h && (s += t + n - h), a <= f ? o = a - parseInt(u, 10) : a + i > d && (o += a + i - d), e.scrollLeft = s, e.scrollTop = o;
}
function vf(e, r, t) {
  const a = t === "left" ? "offsetLeft" : "offsetTop";
  let n = 0;
  for (; r.offsetParent && (n += r[a], r.offsetParent !== e); ) {
    if (r.offsetParent.contains(e)) {
      n -= e[a];
      break;
    }
    r = r.offsetParent;
  }
  return n;
}
function r3(e, r) {
  if (e && document.contains(e)) {
    let s = document.scrollingElement || document.documentElement;
    if (window.getComputedStyle(s).overflow === "hidden") {
      let u = qg(e);
      for (let l of u)
        e3(l, e);
    } else {
      var t;
      let { left: u, top: l } = e.getBoundingClientRect();
      e == null || (t = e.scrollIntoView) === null || t === void 0 || t.call(e, {
        block: "nearest"
      });
      let { left: c, top: f } = e.getBoundingClientRect();
      if (Math.abs(u - c) > 1 || Math.abs(l - f) > 1) {
        var a, n, i;
        r == null || (n = r.containingElement) === null || n === void 0 || (a = n.scrollIntoView) === null || a === void 0 || a.call(n, {
          block: "center",
          inline: "center"
        }), (i = e.scrollIntoView) === null || i === void 0 || i.call(e, {
          block: "nearest"
        });
      }
    }
  }
}
function Iu(e) {
  return e.mozInputSource === 0 && e.isTrusted ? !0 : d1() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function t3(e) {
  return !d1() && e.width === 0 && e.height === 0 || e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "mouse";
}
function p1(e, r) {
  let t = ze(null);
  return e && t.current && r(e, t.current) && (e = t.current), t.current = e, e;
}
function qn(e, r, t) {
  let [a, n] = He(e || r), i = ze(e !== void 0), s = e !== void 0;
  Hr(() => {
    let l = i.current;
    l !== s && console.warn(`WARN: A component changed from ${l ? "controlled" : "uncontrolled"} to ${s ? "controlled" : "uncontrolled"}.`), i.current = s;
  }, [
    s
  ]);
  let o = s ? e : a, u = Cr((l, ...c) => {
    let f = (h, ...d) => {
      t && (Object.is(o, h) || t(h, ...d)), s || (o = h);
    };
    typeof l == "function" ? (console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320"), n((d, ...m) => {
      let x = l(s ? o : d, ...m);
      return f(x, ...c), s ? d : x;
    })) : (s || n(l), f(l, ...c));
  }, [
    s,
    o,
    t
  ]);
  return [
    o,
    u
  ];
}
const _o = Symbol("default");
function ps({ values: e, children: r }) {
  for (let [t, a] of e)
    r = /* @__PURE__ */ ye.createElement(t.Provider, {
      value: a
    }, r);
  return r;
}
function Ua(e) {
  let { className: r, style: t, children: a, defaultClassName: n, defaultChildren: i, defaultStyle: s, values: o } = e;
  return Pe(() => {
    let u, l, c;
    return typeof r == "function" ? u = r({
      ...o,
      defaultClassName: n
    }) : u = r, typeof t == "function" ? l = t({
      ...o,
      defaultStyle: s || {}
    }) : l = t, typeof a == "function" ? c = a({
      ...o,
      defaultChildren: i
    }) : a == null ? c = i : c = a, {
      className: u ?? n,
      style: l || s ? {
        ...s,
        ...l
      } : void 0,
      children: c ?? i,
      "data-rac": ""
    };
  }, [
    r,
    t,
    a,
    n,
    i,
    s,
    o
  ]);
}
function Ol(e, r) {
  let t = Sr(e);
  if (r === null)
    return null;
  if (t && typeof t == "object" && "slots" in t && t.slots) {
    let a = new Intl.ListFormat().format(Object.keys(t.slots).map((i) => `"${i}"`));
    if (!r && !t.slots[_o])
      throw new Error(`A slot prop is required. Valid slot names are ${a}.`);
    let n = r || _o;
    if (!t.slots[n])
      throw new Error(`Invalid slot "${r}". Valid slot names are ${a}.`);
    return t.slots[n];
  }
  return t;
}
function da(e, r, t) {
  let a = Ol(t, e.slot) || {}, { ref: n, ...i } = a, s = Xg(Pe(() => Mg(r, n), [
    r,
    n
  ])), o = Nr(i, e);
  return "style" in i && i.style && "style" in e && e.style && (typeof i.style == "function" || typeof e.style == "function" ? o.style = (u) => {
    let l = typeof i.style == "function" ? i.style(u) : i.style, c = {
      ...u.defaultStyle,
      ...l
    }, f = typeof e.style == "function" ? e.style({
      ...u,
      defaultStyle: c
    }) : e.style;
    return {
      ...c,
      ...f
    };
  } : o.style = {
    ...i.style,
    ...e.style
  }), [
    o,
    s
  ];
}
function v1() {
  let [e, r] = He(!0), t = ze(!1), a = Cr((n) => {
    t.current = !0, r(!!n);
  }, []);
  return fa(() => {
    t.current || r(!1);
  }, []), [
    a,
    e
  ];
}
function g1(e) {
  const r = /^(data-.*)$/;
  let t = {};
  for (const a in e)
    r.test(a) || (t[a] = e[a]);
  return t;
}
let Bn = "default", Bu = "", co = /* @__PURE__ */ new WeakMap();
function gf(e) {
  if (f1()) {
    if (Bn === "default") {
      const r = Yr(e);
      Bu = r.documentElement.style.webkitUserSelect, r.documentElement.style.webkitUserSelect = "none";
    }
    Bn = "disabled";
  } else
    (e instanceof HTMLElement || e instanceof SVGElement) && (co.set(e, e.style.userSelect), e.style.userSelect = "none");
}
function Ws(e) {
  if (f1()) {
    if (Bn !== "disabled")
      return;
    Bn = "restoring", setTimeout(() => {
      h1(() => {
        if (Bn === "restoring") {
          const r = Yr(e);
          r.documentElement.style.webkitUserSelect === "none" && (r.documentElement.style.webkitUserSelect = Bu || ""), Bu = "", Bn = "default";
        }
      });
    }, 300);
  } else if ((e instanceof HTMLElement || e instanceof SVGElement) && e && co.has(e)) {
    let r = co.get(e);
    e.style.userSelect === "none" && (e.style.userSelect = r), e.getAttribute("style") === "" && e.removeAttribute("style"), co.delete(e);
  }
}
const y1 = ye.createContext({
  register: () => {
  }
});
y1.displayName = "PressResponderContext";
function a3(e, r) {
  return r.get ? r.get.call(e) : r.value;
}
function b1(e, r, t) {
  if (!r.has(e))
    throw new TypeError("attempted to " + t + " private field on non-instance");
  return r.get(e);
}
function n3(e, r) {
  var t = b1(e, r, "get");
  return a3(e, t);
}
function i3(e, r, t) {
  if (r.set)
    r.set.call(e, t);
  else {
    if (!r.writable)
      throw new TypeError("attempted to set read only private field");
    r.value = t;
  }
}
function yf(e, r, t) {
  var a = b1(e, r, "set");
  return i3(e, a, t), t;
}
function s3(e) {
  let r = Sr(y1);
  if (r) {
    let { register: t, ...a } = r;
    e = Nr(a, e), t();
  }
  return m1(r, e.ref), e;
}
var Hs = /* @__PURE__ */ new WeakMap();
class js {
  continuePropagation() {
    yf(this, Hs, !1);
  }
  get shouldStopPropagation() {
    return n3(this, Hs);
  }
  constructor(r, t, a, n) {
    at(this, Hs, {
      writable: !0,
      value: void 0
    }), yf(this, Hs, !0);
    var i;
    let s = (i = n == null ? void 0 : n.target) !== null && i !== void 0 ? i : a.currentTarget;
    const o = s == null ? void 0 : s.getBoundingClientRect();
    let u, l = 0, c, f = null;
    a.clientX != null && a.clientY != null && (c = a.clientX, f = a.clientY), o && (c != null && f != null ? (u = c - o.left, l = f - o.top) : (u = o.width / 2, l = o.height / 2)), this.type = r, this.pointerType = t, this.target = a.currentTarget, this.shiftKey = a.shiftKey, this.metaKey = a.metaKey, this.ctrlKey = a.ctrlKey, this.altKey = a.altKey, this.x = u, this.y = l;
  }
}
const bf = Symbol("linkClicked");
function Ll(e) {
  let {
    onPress: r,
    onPressChange: t,
    onPressStart: a,
    onPressEnd: n,
    onPressUp: i,
    isDisabled: s,
    isPressed: o,
    preventFocusOnPress: u,
    shouldCancelOnPointerExit: l,
    allowTextSelectionOnPress: c,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ref: f,
    ...h
  } = s3(e), [d, m] = He(!1), x = ze({
    isPressed: !1,
    ignoreEmulatedMouseEvents: !1,
    ignoreClickAfterPress: !1,
    didFirePressStart: !1,
    isTriggeringEvent: !1,
    activePointerId: null,
    target: null,
    isOverTarget: !1,
    pointerType: null
  }), { addGlobalListener: p, removeAllGlobalListeners: w } = Yg(), D = ea((v, b) => {
    let A = x.current;
    if (s || A.didFirePressStart)
      return !1;
    let T = !0;
    if (A.isTriggeringEvent = !0, a) {
      let C = new js("pressstart", b, v);
      a(C), T = C.shouldStopPropagation;
    }
    return t && t(!0), A.isTriggeringEvent = !1, A.didFirePressStart = !0, m(!0), T;
  }), y = ea((v, b, A = !0) => {
    let T = x.current;
    if (!T.didFirePressStart)
      return !1;
    T.ignoreClickAfterPress = !0, T.didFirePressStart = !1, T.isTriggeringEvent = !0;
    let C = !0;
    if (n) {
      let I = new js("pressend", b, v);
      n(I), C = I.shouldStopPropagation;
    }
    if (t && t(!1), m(!1), r && A && !s) {
      let I = new js("press", b, v);
      r(I), C && (C = I.shouldStopPropagation);
    }
    return T.isTriggeringEvent = !1, C;
  }), B = ea((v, b) => {
    let A = x.current;
    if (s)
      return !1;
    if (i) {
      A.isTriggeringEvent = !0;
      let T = new js("pressup", b, v);
      return i(T), A.isTriggeringEvent = !1, T.shouldStopPropagation;
    }
    return !0;
  }), L = ea((v) => {
    let b = x.current;
    b.isPressed && b.target && (b.isOverTarget && b.pointerType != null && y(qt(b.target, v), b.pointerType, !1), b.isPressed = !1, b.isOverTarget = !1, b.activePointerId = null, b.pointerType = null, w(), c || Ws(b.target));
  }), U = ea((v) => {
    l && L(v);
  }), k = Pe(() => {
    let v = x.current, b = {
      onKeyDown(T) {
        if (L0(T.nativeEvent, T.currentTarget) && T.currentTarget.contains(T.target)) {
          var C;
          _f(T.target, T.key) && T.preventDefault();
          let I = !0;
          if (!v.isPressed && !T.repeat) {
            v.target = T.currentTarget, v.isPressed = !0, I = D(T, "keyboard");
            let Y = T.currentTarget, j = (J) => {
              L0(J, Y) && !J.repeat && Y.contains(J.target) && v.target && B(qt(v.target, J), "keyboard");
            };
            p(Yr(T.currentTarget), "keyup", l1(j, A), !0);
          }
          I && T.stopPropagation(), T.metaKey && Ki() && ((C = v.metaKeyEvents) === null || C === void 0 || C.set(T.key, T.nativeEvent));
        } else
          T.key === "Meta" && (v.metaKeyEvents = /* @__PURE__ */ new Map());
      },
      onClick(T) {
        if (!(T && !T.currentTarget.contains(T.target)) && T && T.button === 0 && !v.isTriggeringEvent && !Yi.isOpening) {
          let C = !0;
          if (s && T.preventDefault(), !v.ignoreClickAfterPress && !v.ignoreEmulatedMouseEvents && !v.isPressed && (v.pointerType === "virtual" || Iu(T.nativeEvent))) {
            !s && !u && ka(T.currentTarget);
            let I = D(T, "virtual"), Y = B(T, "virtual"), j = y(T, "virtual");
            C = I && Y && j;
          }
          v.ignoreEmulatedMouseEvents = !1, v.ignoreClickAfterPress = !1, C && T.stopPropagation();
        }
      }
    }, A = (T) => {
      var C;
      if (v.isPressed && v.target && L0(T, v.target)) {
        var I;
        _f(T.target, T.key) && T.preventDefault();
        let j = T.target;
        y(qt(v.target, T), "keyboard", v.target.contains(j)), w(), T.key !== "Enter" && Nl(v.target) && v.target.contains(j) && !T[bf] && (T[bf] = !0, Yi(v.target, T, !1)), v.isPressed = !1, (I = v.metaKeyEvents) === null || I === void 0 || I.delete(T.key);
      } else if (T.key === "Meta" && (!((C = v.metaKeyEvents) === null || C === void 0) && C.size)) {
        var Y;
        let j = v.metaKeyEvents;
        v.metaKeyEvents = void 0;
        for (let J of j.values())
          (Y = v.target) === null || Y === void 0 || Y.dispatchEvent(new KeyboardEvent("keyup", J));
      }
    };
    if (typeof PointerEvent < "u") {
      b.onPointerDown = (j) => {
        if (j.button !== 0 || !j.currentTarget.contains(j.target))
          return;
        if (t3(j.nativeEvent)) {
          v.pointerType = "virtual";
          return;
        }
        N0(j.currentTarget) && j.preventDefault(), v.pointerType = j.pointerType;
        let J = !0;
        v.isPressed || (v.isPressed = !0, v.isOverTarget = !0, v.activePointerId = j.pointerId, v.target = j.currentTarget, !s && !u && ka(j.currentTarget), c || gf(v.target), J = D(j, v.pointerType), p(Yr(j.currentTarget), "pointermove", T, !1), p(Yr(j.currentTarget), "pointerup", C, !1), p(Yr(j.currentTarget), "pointercancel", Y, !1)), J && j.stopPropagation();
      }, b.onMouseDown = (j) => {
        j.currentTarget.contains(j.target) && j.button === 0 && (N0(j.currentTarget) && j.preventDefault(), j.stopPropagation());
      }, b.onPointerUp = (j) => {
        !j.currentTarget.contains(j.target) || v.pointerType === "virtual" || j.button === 0 && En(j, j.currentTarget) && B(j, v.pointerType || j.pointerType);
      };
      let T = (j) => {
        j.pointerId === v.activePointerId && (v.target && En(j, v.target) ? !v.isOverTarget && v.pointerType != null && (v.isOverTarget = !0, D(qt(v.target, j), v.pointerType)) : v.target && v.isOverTarget && v.pointerType != null && (v.isOverTarget = !1, y(qt(v.target, j), v.pointerType, !1), U(j)));
      }, C = (j) => {
        j.pointerId === v.activePointerId && v.isPressed && j.button === 0 && v.target && (En(j, v.target) && v.pointerType != null ? y(qt(v.target, j), v.pointerType) : v.isOverTarget && v.pointerType != null && y(qt(v.target, j), v.pointerType, !1), v.isPressed = !1, v.isOverTarget = !1, v.activePointerId = null, v.pointerType = null, w(), c || Ws(v.target), "ontouchend" in v.target && j.pointerType !== "mouse" && p(v.target, "touchend", I, {
          once: !0
        }));
      }, I = (j) => {
        w1(j.currentTarget) && j.preventDefault();
      }, Y = (j) => {
        L(j);
      };
      b.onDragStart = (j) => {
        j.currentTarget.contains(j.target) && L(j);
      };
    } else {
      b.onMouseDown = (I) => {
        if (I.button !== 0 || !I.currentTarget.contains(I.target))
          return;
        if (N0(I.currentTarget) && I.preventDefault(), v.ignoreEmulatedMouseEvents) {
          I.stopPropagation();
          return;
        }
        v.isPressed = !0, v.isOverTarget = !0, v.target = I.currentTarget, v.pointerType = Iu(I.nativeEvent) ? "virtual" : "mouse", !s && !u && ka(I.currentTarget), D(I, v.pointerType) && I.stopPropagation(), p(Yr(I.currentTarget), "mouseup", T, !1);
      }, b.onMouseEnter = (I) => {
        if (!I.currentTarget.contains(I.target))
          return;
        let Y = !0;
        v.isPressed && !v.ignoreEmulatedMouseEvents && v.pointerType != null && (v.isOverTarget = !0, Y = D(I, v.pointerType)), Y && I.stopPropagation();
      }, b.onMouseLeave = (I) => {
        if (!I.currentTarget.contains(I.target))
          return;
        let Y = !0;
        v.isPressed && !v.ignoreEmulatedMouseEvents && v.pointerType != null && (v.isOverTarget = !1, Y = y(I, v.pointerType, !1), U(I)), Y && I.stopPropagation();
      }, b.onMouseUp = (I) => {
        I.currentTarget.contains(I.target) && !v.ignoreEmulatedMouseEvents && I.button === 0 && B(I, v.pointerType || "mouse");
      };
      let T = (I) => {
        if (I.button === 0) {
          if (v.isPressed = !1, w(), v.ignoreEmulatedMouseEvents) {
            v.ignoreEmulatedMouseEvents = !1;
            return;
          }
          v.target && En(I, v.target) && v.pointerType != null ? y(qt(v.target, I), v.pointerType) : v.target && v.isOverTarget && v.pointerType != null && y(qt(v.target, I), v.pointerType, !1), v.isOverTarget = !1;
        }
      };
      b.onTouchStart = (I) => {
        if (!I.currentTarget.contains(I.target))
          return;
        let Y = o3(I.nativeEvent);
        if (!Y)
          return;
        v.activePointerId = Y.identifier, v.ignoreEmulatedMouseEvents = !0, v.isOverTarget = !0, v.isPressed = !0, v.target = I.currentTarget, v.pointerType = "touch", !s && !u && ka(I.currentTarget), c || gf(v.target), D(ya(v.target, I), v.pointerType) && I.stopPropagation(), p(At(I.currentTarget), "scroll", C, !0);
      }, b.onTouchMove = (I) => {
        if (!I.currentTarget.contains(I.target))
          return;
        if (!v.isPressed) {
          I.stopPropagation();
          return;
        }
        let Y = wf(I.nativeEvent, v.activePointerId), j = !0;
        Y && En(Y, I.currentTarget) ? !v.isOverTarget && v.pointerType != null && (v.isOverTarget = !0, j = D(ya(v.target, I), v.pointerType)) : v.isOverTarget && v.pointerType != null && (v.isOverTarget = !1, j = y(ya(v.target, I), v.pointerType, !1), U(ya(v.target, I))), j && I.stopPropagation();
      }, b.onTouchEnd = (I) => {
        if (!I.currentTarget.contains(I.target))
          return;
        if (!v.isPressed) {
          I.stopPropagation();
          return;
        }
        let Y = wf(I.nativeEvent, v.activePointerId), j = !0;
        Y && En(Y, I.currentTarget) && v.pointerType != null ? (B(ya(v.target, I), v.pointerType), j = y(ya(v.target, I), v.pointerType)) : v.isOverTarget && v.pointerType != null && (j = y(ya(v.target, I), v.pointerType, !1)), j && I.stopPropagation(), v.isPressed = !1, v.activePointerId = null, v.isOverTarget = !1, v.ignoreEmulatedMouseEvents = !0, v.target && !c && Ws(v.target), w();
      }, b.onTouchCancel = (I) => {
        I.currentTarget.contains(I.target) && (I.stopPropagation(), v.isPressed && L(ya(v.target, I)));
      };
      let C = (I) => {
        v.isPressed && I.target.contains(v.target) && L({
          currentTarget: v.target,
          shiftKey: !1,
          ctrlKey: !1,
          metaKey: !1,
          altKey: !1
        });
      };
      b.onDragStart = (I) => {
        I.currentTarget.contains(I.target) && L(I);
      };
    }
    return b;
  }, [
    p,
    s,
    u,
    w,
    c,
    L,
    U,
    y,
    D,
    B
  ]);
  return Hr(() => () => {
    var v;
    c || Ws((v = x.current.target) !== null && v !== void 0 ? v : void 0);
  }, [
    c
  ]), {
    isPressed: o || d,
    pressProps: Nr(h, k)
  };
}
function Nl(e) {
  return e.tagName === "A" && e.hasAttribute("href");
}
function L0(e, r) {
  const { key: t, code: a } = e, n = r, i = n.getAttribute("role");
  return (t === "Enter" || t === " " || t === "Spacebar" || a === "Space") && !(n instanceof At(n).HTMLInputElement && !_1(n, t) || n instanceof At(n).HTMLTextAreaElement || n.isContentEditable) && // Links should only trigger with Enter key
  !((i === "link" || !i && Nl(n)) && t !== "Enter");
}
function o3(e) {
  const { targetTouches: r } = e;
  return r.length > 0 ? r[0] : null;
}
function wf(e, r) {
  const t = e.changedTouches;
  for (let a = 0; a < t.length; a++) {
    const n = t[a];
    if (n.identifier === r)
      return n;
  }
  return null;
}
function ya(e, r) {
  let t = 0, a = 0;
  return r.targetTouches && r.targetTouches.length === 1 && (t = r.targetTouches[0].clientX, a = r.targetTouches[0].clientY), {
    currentTarget: e,
    shiftKey: r.shiftKey,
    ctrlKey: r.ctrlKey,
    metaKey: r.metaKey,
    altKey: r.altKey,
    clientX: t,
    clientY: a
  };
}
function qt(e, r) {
  let t = r.clientX, a = r.clientY;
  return {
    currentTarget: e,
    shiftKey: r.shiftKey,
    ctrlKey: r.ctrlKey,
    metaKey: r.metaKey,
    altKey: r.altKey,
    clientX: t,
    clientY: a
  };
}
function u3(e) {
  let r = 0, t = 0;
  return e.width !== void 0 ? r = e.width / 2 : e.radiusX !== void 0 && (r = e.radiusX), e.height !== void 0 ? t = e.height / 2 : e.radiusY !== void 0 && (t = e.radiusY), {
    top: e.clientY - t,
    right: e.clientX + r,
    bottom: e.clientY + t,
    left: e.clientX - r
  };
}
function l3(e, r) {
  return !(e.left > r.right || r.left > e.right || e.top > r.bottom || r.top > e.bottom);
}
function En(e, r) {
  let t = r.getBoundingClientRect(), a = u3(e);
  return l3(t, a);
}
function N0(e) {
  return !(e instanceof HTMLElement) || !e.hasAttribute("draggable");
}
function w1(e) {
  return e instanceof HTMLInputElement ? !1 : e instanceof HTMLButtonElement ? e.type !== "submit" && e.type !== "reset" : !Nl(e);
}
function _f(e, r) {
  return e instanceof HTMLInputElement ? !_1(e, r) : w1(e);
}
const c3 = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function _1(e, r) {
  return e.type === "checkbox" || e.type === "radio" ? r === " " : c3.has(e.type);
}
class f3 {
  isDefaultPrevented() {
    return this.nativeEvent.defaultPrevented;
  }
  preventDefault() {
    this.defaultPrevented = !0, this.nativeEvent.preventDefault();
  }
  stopPropagation() {
    this.nativeEvent.stopPropagation(), this.isPropagationStopped = () => !0;
  }
  isPropagationStopped() {
    return !1;
  }
  persist() {
  }
  constructor(r, t) {
    this.nativeEvent = t, this.target = t.target, this.currentTarget = t.currentTarget, this.relatedTarget = t.relatedTarget, this.bubbles = t.bubbles, this.cancelable = t.cancelable, this.defaultPrevented = t.defaultPrevented, this.eventPhase = t.eventPhase, this.isTrusted = t.isTrusted, this.timeStamp = t.timeStamp, this.type = r;
  }
}
function $1(e) {
  let r = ze({
    isFocused: !1,
    observer: null
  });
  fa(() => {
    const a = r.current;
    return () => {
      a.observer && (a.observer.disconnect(), a.observer = null);
    };
  }, []);
  let t = ea((a) => {
    e == null || e(a);
  });
  return Cr((a) => {
    if (a.target instanceof HTMLButtonElement || a.target instanceof HTMLInputElement || a.target instanceof HTMLTextAreaElement || a.target instanceof HTMLSelectElement) {
      r.current.isFocused = !0;
      let n = a.target, i = (s) => {
        r.current.isFocused = !1, n.disabled && t(new f3("blur", s)), r.current.observer && (r.current.observer.disconnect(), r.current.observer = null);
      };
      n.addEventListener("focusout", i, {
        once: !0
      }), r.current.observer = new MutationObserver(() => {
        if (r.current.isFocused && n.disabled) {
          var s;
          (s = r.current.observer) === null || s === void 0 || s.disconnect();
          let o = n === document.activeElement ? null : document.activeElement;
          n.dispatchEvent(new FocusEvent("blur", {
            relatedTarget: o
          })), n.dispatchEvent(new FocusEvent("focusout", {
            bubbles: !0,
            relatedTarget: o
          }));
        }
      }), r.current.observer.observe(n, {
        attributes: !0,
        attributeFilter: [
          "disabled"
        ]
      });
    }
  }, [
    t
  ]);
}
function D1(e) {
  let { isDisabled: r, onFocus: t, onBlur: a, onFocusChange: n } = e;
  const i = Cr((u) => {
    if (u.target === u.currentTarget)
      return a && a(u), n && n(!1), !0;
  }, [
    a,
    n
  ]), s = $1(i), o = Cr((u) => {
    const l = Yr(u.target);
    u.target === u.currentTarget && l.activeElement === u.target && (t && t(u), n && n(!0), s(u));
  }, [
    n,
    t,
    s
  ]);
  return {
    focusProps: {
      onFocus: !r && (t || n || a) ? o : void 0,
      onBlur: !r && (a || n) ? i : void 0
    }
  };
}
let ci = null, Pu = /* @__PURE__ */ new Set(), Oi = /* @__PURE__ */ new Map(), sn = !1, Mu = !1;
const d3 = {
  Tab: !0,
  Escape: !0
};
function Ul(e, r) {
  for (let t of Pu)
    t(e, r);
}
function h3(e) {
  return !(e.metaKey || !Ki() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $o(e) {
  sn = !0, h3(e) && (ci = "keyboard", Ul("keyboard", e));
}
function Et(e) {
  ci = "pointer", (e.type === "mousedown" || e.type === "pointerdown") && (sn = !0, Ul("pointer", e));
}
function E1(e) {
  Iu(e) && (sn = !0, ci = "virtual");
}
function k1(e) {
  e.target === window || e.target === document || (!sn && !Mu && (ci = "virtual", Ul("virtual", e)), sn = !1, Mu = !1);
}
function T1() {
  sn = !1, Mu = !0;
}
function Ou(e) {
  if (typeof window > "u" || Oi.get(At(e)))
    return;
  const r = At(e), t = Yr(e);
  let a = r.HTMLElement.prototype.focus;
  r.HTMLElement.prototype.focus = function() {
    sn = !0, a.apply(this, arguments);
  }, t.addEventListener("keydown", $o, !0), t.addEventListener("keyup", $o, !0), t.addEventListener("click", E1, !0), r.addEventListener("focus", k1, !0), r.addEventListener("blur", T1, !1), typeof PointerEvent < "u" ? (t.addEventListener("pointerdown", Et, !0), t.addEventListener("pointermove", Et, !0), t.addEventListener("pointerup", Et, !0)) : (t.addEventListener("mousedown", Et, !0), t.addEventListener("mousemove", Et, !0), t.addEventListener("mouseup", Et, !0)), r.addEventListener("beforeunload", () => {
    S1(e);
  }, {
    once: !0
  }), Oi.set(r, {
    focus: a
  });
}
const S1 = (e, r) => {
  const t = At(e), a = Yr(e);
  r && a.removeEventListener("DOMContentLoaded", r), Oi.has(t) && (t.HTMLElement.prototype.focus = Oi.get(t).focus, a.removeEventListener("keydown", $o, !0), a.removeEventListener("keyup", $o, !0), a.removeEventListener("click", E1, !0), t.removeEventListener("focus", k1, !0), t.removeEventListener("blur", T1, !1), typeof PointerEvent < "u" ? (a.removeEventListener("pointerdown", Et, !0), a.removeEventListener("pointermove", Et, !0), a.removeEventListener("pointerup", Et, !0)) : (a.removeEventListener("mousedown", Et, !0), a.removeEventListener("mousemove", Et, !0), a.removeEventListener("mouseup", Et, !0)), Oi.delete(t));
};
function x3(e) {
  const r = Yr(e);
  let t;
  return r.readyState !== "loading" ? Ou(e) : (t = () => {
    Ou(e);
  }, r.addEventListener("DOMContentLoaded", t)), () => S1(e, t);
}
typeof document < "u" && x3();
function C1() {
  return ci !== "pointer";
}
function F1() {
  return ci;
}
const m3 = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function p3(e, r, t) {
  var a;
  const n = typeof window < "u" ? At(t == null ? void 0 : t.target).HTMLInputElement : HTMLInputElement, i = typeof window < "u" ? At(t == null ? void 0 : t.target).HTMLTextAreaElement : HTMLTextAreaElement, s = typeof window < "u" ? At(t == null ? void 0 : t.target).HTMLElement : HTMLElement, o = typeof window < "u" ? At(t == null ? void 0 : t.target).KeyboardEvent : KeyboardEvent;
  return e = e || (t == null ? void 0 : t.target) instanceof n && !m3.has(t == null || (a = t.target) === null || a === void 0 ? void 0 : a.type) || (t == null ? void 0 : t.target) instanceof i || (t == null ? void 0 : t.target) instanceof s && (t == null ? void 0 : t.target.isContentEditable), !(e && r === "keyboard" && t instanceof o && !d3[t.key]);
}
function v3(e, r, t) {
  Ou(), Hr(() => {
    let a = (n, i) => {
      p3(!!(t != null && t.isTextInput), n, i) && e(C1());
    };
    return Pu.add(a), () => {
      Pu.delete(a);
    };
  }, r);
}
function a0(e) {
  let { isDisabled: r, onBlurWithin: t, onFocusWithin: a, onFocusWithinChange: n } = e, i = ze({
    isFocusWithin: !1
  }), s = Cr((l) => {
    i.current.isFocusWithin && !l.currentTarget.contains(l.relatedTarget) && (i.current.isFocusWithin = !1, t && t(l), n && n(!1));
  }, [
    t,
    n,
    i
  ]), o = $1(s), u = Cr((l) => {
    !i.current.isFocusWithin && document.activeElement === l.target && (a && a(l), n && n(!0), i.current.isFocusWithin = !0, o(l));
  }, [
    a,
    n,
    o
  ]);
  return r ? {
    focusWithinProps: {
      // These should not have been null, that would conflict in mergeProps
      onFocus: void 0,
      onBlur: void 0
    }
  } : {
    focusWithinProps: {
      onFocus: u,
      onBlur: s
    }
  };
}
let Do = !1, U0 = 0;
function Lu() {
  Do = !0, setTimeout(() => {
    Do = !1;
  }, 50);
}
function $f(e) {
  e.pointerType === "touch" && Lu();
}
function g3() {
  if (!(typeof document > "u"))
    return typeof PointerEvent < "u" ? document.addEventListener("pointerup", $f) : document.addEventListener("touchend", Lu), U0++, () => {
      U0--, !(U0 > 0) && (typeof PointerEvent < "u" ? document.removeEventListener("pointerup", $f) : document.removeEventListener("touchend", Lu));
    };
}
function Vl(e) {
  let { onHoverStart: r, onHoverChange: t, onHoverEnd: a, isDisabled: n } = e, [i, s] = He(!1), o = ze({
    isHovered: !1,
    ignoreEmulatedMouseEvents: !1,
    pointerType: "",
    target: null
  }).current;
  Hr(g3, []);
  let { hoverProps: u, triggerHoverEnd: l } = Pe(() => {
    let c = (d, m) => {
      if (o.pointerType = m, n || m === "touch" || o.isHovered || !d.currentTarget.contains(d.target))
        return;
      o.isHovered = !0;
      let x = d.currentTarget;
      o.target = x, r && r({
        type: "hoverstart",
        target: x,
        pointerType: m
      }), t && t(!0), s(!0);
    }, f = (d, m) => {
      if (o.pointerType = "", o.target = null, m === "touch" || !o.isHovered)
        return;
      o.isHovered = !1;
      let x = d.currentTarget;
      a && a({
        type: "hoverend",
        target: x,
        pointerType: m
      }), t && t(!1), s(!1);
    }, h = {};
    return typeof PointerEvent < "u" ? (h.onPointerEnter = (d) => {
      Do && d.pointerType === "mouse" || c(d, d.pointerType);
    }, h.onPointerLeave = (d) => {
      !n && d.currentTarget.contains(d.target) && f(d, d.pointerType);
    }) : (h.onTouchStart = () => {
      o.ignoreEmulatedMouseEvents = !0;
    }, h.onMouseEnter = (d) => {
      !o.ignoreEmulatedMouseEvents && !Do && c(d, "mouse"), o.ignoreEmulatedMouseEvents = !1;
    }, h.onMouseLeave = (d) => {
      !n && d.currentTarget.contains(d.target) && f(d, "mouse");
    }), {
      hoverProps: h,
      triggerHoverEnd: f
    };
  }, [
    r,
    t,
    a,
    n,
    o
  ]);
  return Hr(() => {
    n && l({
      currentTarget: o.target
    }, o.pointerType);
  }, [
    n
  ]), {
    hoverProps: u,
    isHovered: i
  };
}
function Df(e) {
  if (!e)
    return;
  let r = !0;
  return (t) => {
    let a = {
      ...t,
      preventDefault() {
        t.preventDefault();
      },
      isDefaultPrevented() {
        return t.isDefaultPrevented();
      },
      stopPropagation() {
        console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.");
      },
      continuePropagation() {
        r = !1;
      }
    };
    e(a), r && t.stopPropagation();
  };
}
function y3(e) {
  return {
    keyboardProps: e.isDisabled ? {} : {
      onKeyDown: Df(e.onKeyDown),
      onKeyUp: Df(e.onKeyUp)
    }
  };
}
function Eo(e) {
  const r = Yr(e);
  if (F1() === "virtual") {
    let t = r.activeElement;
    h1(() => {
      r.activeElement === t && e.isConnected && ka(e);
    });
  } else
    ka(e);
}
function b3(e) {
  const r = At(e);
  if (!(e instanceof r.HTMLElement) && !(e instanceof r.SVGElement))
    return !1;
  let { display: t, visibility: a } = e.style, n = t !== "none" && a !== "hidden" && a !== "collapse";
  if (n) {
    const { getComputedStyle: i } = e.ownerDocument.defaultView;
    let { display: s, visibility: o } = i(e);
    n = s !== "none" && o !== "hidden" && o !== "collapse";
  }
  return n;
}
function w3(e, r) {
  return !e.hasAttribute("hidden") && // Ignore HiddenSelect when tree walking.
  !e.hasAttribute("data-react-aria-prevent-focus") && (e.nodeName === "DETAILS" && r && r.nodeName !== "SUMMARY" ? e.hasAttribute("open") : !0);
}
function A1(e, r) {
  return e.nodeName !== "#comment" && b3(e) && w3(e, r) && (!e.parentElement || A1(e.parentElement, e));
}
const Wl = [
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[contenteditable]"
], _3 = Wl.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
Wl.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const $3 = Wl.join(':not([hidden]):not([tabindex="-1"]),');
function R1(e, r) {
  return !e || !r ? !1 : r.some((t) => t.contains(e));
}
function Ei(e, r = !1) {
  if (e != null && !r)
    try {
      Eo(e);
    } catch {
    }
  else if (e != null)
    try {
      e.focus();
    } catch {
    }
}
function Ai(e, r, t) {
  let a = r != null && r.tabbable ? $3 : _3, n = Yr(e).createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode(i) {
      var s;
      return !(r == null || (s = r.from) === null || s === void 0) && s.contains(i) ? NodeFilter.FILTER_REJECT : i.matches(a) && A1(i) && (!t || R1(i, t)) && (!(r != null && r.accept) || r.accept(i)) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  return r != null && r.from && (n.currentNode = r.from), n;
}
function Hl(e, r = {}) {
  return {
    focusNext(t = {}) {
      let a = e.current;
      if (!a)
        return null;
      let { from: n, tabbable: i = r.tabbable, wrap: s = r.wrap, accept: o = r.accept } = t, u = n || Yr(a).activeElement, l = Ai(a, {
        tabbable: i,
        accept: o
      });
      a.contains(u) && (l.currentNode = u);
      let c = l.nextNode();
      return !c && s && (l.currentNode = a, c = l.nextNode()), c && Ei(c, !0), c;
    },
    focusPrevious(t = r) {
      let a = e.current;
      if (!a)
        return null;
      let { from: n, tabbable: i = r.tabbable, wrap: s = r.wrap, accept: o = r.accept } = t, u = n || Yr(a).activeElement, l = Ai(a, {
        tabbable: i,
        accept: o
      });
      if (a.contains(u))
        l.currentNode = u;
      else {
        let f = V0(l);
        return f && Ei(f, !0), f ?? null;
      }
      let c = l.previousNode();
      if (!c && s) {
        l.currentNode = a;
        let f = V0(l);
        if (!f)
          return null;
        c = f;
      }
      return c && Ei(c, !0), c ?? null;
    },
    focusFirst(t = r) {
      let a = e.current;
      if (!a)
        return null;
      let { tabbable: n = r.tabbable, accept: i = r.accept } = t, o = Ai(a, {
        tabbable: n,
        accept: i
      }).nextNode();
      return o && Ei(o, !0), o;
    },
    focusLast(t = r) {
      let a = e.current;
      if (!a)
        return null;
      let { tabbable: n = r.tabbable, accept: i = r.accept } = t, s = Ai(a, {
        tabbable: n,
        accept: i
      }), o = V0(s);
      return o && Ei(o, !0), o ?? null;
    }
  };
}
function V0(e) {
  let r, t;
  do
    t = e.lastChild(), t && (r = t);
  while (t);
  return r;
}
class jl {
  get size() {
    return this.fastMap.size;
  }
  getTreeNode(r) {
    return this.fastMap.get(r);
  }
  addTreeNode(r, t, a) {
    let n = this.fastMap.get(t ?? null);
    if (!n)
      return;
    let i = new Ef({
      scopeRef: r
    });
    n.addChild(i), i.parent = n, this.fastMap.set(r, i), a && (i.nodeToRestore = a);
  }
  addNode(r) {
    this.fastMap.set(r.scopeRef, r);
  }
  removeTreeNode(r) {
    if (r === null)
      return;
    let t = this.fastMap.get(r);
    if (!t)
      return;
    let a = t.parent;
    for (let i of this.traverse())
      i !== t && t.nodeToRestore && i.nodeToRestore && t.scopeRef && t.scopeRef.current && R1(i.nodeToRestore, t.scopeRef.current) && (i.nodeToRestore = t.nodeToRestore);
    let n = t.children;
    a && (a.removeChild(t), n.size > 0 && n.forEach((i) => a && a.addChild(i))), this.fastMap.delete(t.scopeRef);
  }
  // Pre Order Depth First
  *traverse(r = this.root) {
    if (r.scopeRef != null && (yield r), r.children.size > 0)
      for (let t of r.children)
        yield* this.traverse(t);
  }
  clone() {
    var r;
    let t = new jl();
    var a;
    for (let n of this.traverse())
      t.addTreeNode(n.scopeRef, (a = (r = n.parent) === null || r === void 0 ? void 0 : r.scopeRef) !== null && a !== void 0 ? a : null, n.nodeToRestore);
    return t;
  }
  constructor() {
    this.fastMap = /* @__PURE__ */ new Map(), this.root = new Ef({
      scopeRef: null
    }), this.fastMap.set(null, this.root);
  }
}
class Ef {
  addChild(r) {
    this.children.add(r), r.parent = this;
  }
  removeChild(r) {
    this.children.delete(r), r.parent = void 0;
  }
  constructor(r) {
    this.children = /* @__PURE__ */ new Set(), this.contain = !1, this.scopeRef = r.scopeRef;
  }
}
new jl();
function vs(e = {}) {
  let { autoFocus: r = !1, isTextInput: t, within: a } = e, n = ze({
    isFocused: !1,
    isFocusVisible: r || C1()
  }), [i, s] = He(!1), [o, u] = He(() => n.current.isFocused && n.current.isFocusVisible), l = Cr(() => u(n.current.isFocused && n.current.isFocusVisible), []), c = Cr((d) => {
    n.current.isFocused = d, s(d), l();
  }, [
    l
  ]);
  v3((d) => {
    n.current.isFocusVisible = d, l();
  }, [], {
    isTextInput: t
  });
  let { focusProps: f } = D1({
    isDisabled: a,
    onFocusChange: c
  }), { focusWithinProps: h } = a0({
    isDisabled: !a,
    onFocusWithinChange: c
  });
  return {
    isFocused: i,
    isFocusVisible: o,
    focusProps: a ? h : f
  };
}
let D3 = /* @__PURE__ */ ye.createContext(null);
function E3(e) {
  let r = Sr(D3) || {};
  m1(r, e);
  let { ref: t, ...a } = r;
  return a;
}
function k3(e, r) {
  let { focusProps: t } = D1(e), { keyboardProps: a } = y3(e), n = Nr(t, a), i = E3(r), s = e.isDisabled ? {} : i, o = ze(e.autoFocus);
  return Hr(() => {
    o.current && r.current && Eo(r.current), o.current = !1;
  }, [
    r
  ]), {
    focusableProps: Nr({
      ...n,
      tabIndex: e.excludeFromTabOrder && !e.isDisabled ? -1 : void 0
    }, s)
  };
}
const T3 = /* @__PURE__ */ new Set([
  "Arab",
  "Syrc",
  "Samr",
  "Mand",
  "Thaa",
  "Mend",
  "Nkoo",
  "Adlm",
  "Rohg",
  "Hebr"
]), S3 = /* @__PURE__ */ new Set([
  "ae",
  "ar",
  "arc",
  "bcc",
  "bqi",
  "ckb",
  "dv",
  "fa",
  "glk",
  "he",
  "ku",
  "mzn",
  "nqo",
  "pnb",
  "ps",
  "sd",
  "ug",
  "ur",
  "yi"
]);
function I1(e) {
  if (Intl.Locale) {
    let t = new Intl.Locale(e).maximize(), a = typeof t.getTextInfo == "function" ? t.getTextInfo() : t.textInfo;
    if (a)
      return a.direction === "rtl";
    if (t.script)
      return T3.has(t.script);
  }
  let r = e.split("-")[0];
  return S3.has(r);
}
const C3 = Symbol.for("react-aria.i18n.locale");
function B1() {
  let e = typeof window < "u" && window[C3] || typeof navigator < "u" && (navigator.language || navigator.userLanguage) || "en-US";
  try {
    Intl.DateTimeFormat.supportedLocalesOf([
      e
    ]);
  } catch {
    e = "en-US";
  }
  return {
    locale: e,
    direction: I1(e) ? "rtl" : "ltr"
  };
}
let Nu = B1(), Ri = /* @__PURE__ */ new Set();
function kf() {
  Nu = B1();
  for (let e of Ri)
    e(Nu);
}
function P1() {
  let e = o1(), [r, t] = He(Nu);
  return Hr(() => (Ri.size === 0 && window.addEventListener("languagechange", kf), Ri.add(t), () => {
    Ri.delete(t), Ri.size === 0 && window.removeEventListener("languagechange", kf);
  }), []), e ? {
    locale: "en-US",
    direction: "ltr"
  } : r;
}
const M1 = /* @__PURE__ */ ye.createContext(null);
function O1(e) {
  let { locale: r, children: t } = e, a = P1(), n = ye.useMemo(() => r ? {
    locale: r,
    direction: I1(r) ? "rtl" : "ltr"
  } : a, [
    a,
    r
  ]);
  return /* @__PURE__ */ ye.createElement(M1.Provider, {
    value: n
  }, t);
}
function Kt() {
  let e = P1();
  return Sr(M1) || e;
}
const F3 = Symbol.for("react-aria.i18n.locale"), A3 = Symbol.for("react-aria.i18n.strings");
let kn, L1 = class N1 {
  /** Returns a localized string for the given key and locale. */
  getStringForLocale(r, t) {
    let n = this.getStringsForLocale(t)[r];
    if (!n)
      throw new Error(`Could not find intl message ${r} in ${t} locale`);
    return n;
  }
  /** Returns all localized strings for the given locale. */
  getStringsForLocale(r) {
    let t = this.strings[r];
    return t || (t = R3(r, this.strings, this.defaultLocale), this.strings[r] = t), t;
  }
  static getGlobalDictionaryForPackage(r) {
    if (typeof window > "u")
      return null;
    let t = window[F3];
    if (kn === void 0) {
      let n = window[A3];
      if (!n)
        return null;
      kn = {};
      for (let i in n)
        kn[i] = new N1({
          [t]: n[i]
        }, t);
    }
    let a = kn == null ? void 0 : kn[r];
    if (!a)
      throw new Error(`Strings for package "${r}" were not included by LocalizedStringProvider. Please add it to the list passed to createLocalizedStringDictionary.`);
    return a;
  }
  constructor(r, t = "en-US") {
    this.strings = Object.fromEntries(Object.entries(r).filter(([, a]) => a)), this.defaultLocale = t;
  }
};
function R3(e, r, t = "en-US") {
  if (r[e])
    return r[e];
  let a = I3(e);
  if (r[a])
    return r[a];
  for (let n in r)
    if (n.startsWith(a + "-"))
      return r[n];
  return r[t];
}
function I3(e) {
  return Intl.Locale ? new Intl.Locale(e).language : e.split("-")[0];
}
const Tf = /* @__PURE__ */ new Map(), Sf = /* @__PURE__ */ new Map();
let B3 = class {
  /** Formats a localized string for the given key with the provided variables. */
  format(r, t) {
    let a = this.strings.getStringForLocale(r, this.locale);
    return typeof a == "function" ? a(t, this) : a;
  }
  plural(r, t, a = "cardinal") {
    let n = t["=" + r];
    if (n)
      return typeof n == "function" ? n() : n;
    let i = this.locale + ":" + a, s = Tf.get(i);
    s || (s = new Intl.PluralRules(this.locale, {
      type: a
    }), Tf.set(i, s));
    let o = s.select(r);
    return n = t[o] || t.other, typeof n == "function" ? n() : n;
  }
  number(r) {
    let t = Sf.get(this.locale);
    return t || (t = new Intl.NumberFormat(this.locale), Sf.set(this.locale, t)), t.format(r);
  }
  select(r, t) {
    let a = r[t] || r.other;
    return typeof a == "function" ? a() : a;
  }
  constructor(r, t) {
    this.locale = r, this.strings = t;
  }
};
const Cf = /* @__PURE__ */ new WeakMap();
function P3(e) {
  let r = Cf.get(e);
  return r || (r = new L1(e), Cf.set(e, r)), r;
}
function M3(e, r) {
  return r && L1.getGlobalDictionaryForPackage(r) || P3(e);
}
function fi(e, r) {
  let { locale: t } = Kt(), a = M3(e, r);
  return Pe(() => new B3(t, a), [
    t,
    a
  ]);
}
let W0 = /* @__PURE__ */ new Map(), O3 = class {
  /** Formats a date as a string according to the locale and format options passed to the constructor. */
  format(r) {
    return this.formatter.format(r);
  }
  /** Formats a date to an array of parts such as separators, numbers, punctuation, and more. */
  formatToParts(r) {
    return this.formatter.formatToParts(r);
  }
  /** Formats a date range as a string. */
  formatRange(r, t) {
    if (typeof this.formatter.formatRange == "function")
      return this.formatter.formatRange(r, t);
    if (t < r)
      throw new RangeError("End date must be >= start date");
    return `${this.formatter.format(r)} – ${this.formatter.format(t)}`;
  }
  /** Formats a date range as an array of parts. */
  formatRangeToParts(r, t) {
    if (typeof this.formatter.formatRangeToParts == "function")
      return this.formatter.formatRangeToParts(r, t);
    if (t < r)
      throw new RangeError("End date must be >= start date");
    let a = this.formatter.formatToParts(r), n = this.formatter.formatToParts(t);
    return [
      ...a.map((i) => ({
        ...i,
        source: "startRange"
      })),
      {
        type: "literal",
        value: " – ",
        source: "shared"
      },
      ...n.map((i) => ({
        ...i,
        source: "endRange"
      }))
    ];
  }
  /** Returns the resolved formatting options based on the values passed to the constructor. */
  resolvedOptions() {
    let r = this.formatter.resolvedOptions();
    return U3() && (this.resolvedHourCycle || (this.resolvedHourCycle = V3(r.locale, this.options)), r.hourCycle = this.resolvedHourCycle, r.hour12 = this.resolvedHourCycle === "h11" || this.resolvedHourCycle === "h12"), r.calendar === "ethiopic-amete-alem" && (r.calendar = "ethioaa"), r;
  }
  constructor(r, t = {}) {
    this.formatter = U1(r, t), this.options = t;
  }
};
const L3 = {
  true: {
    // Only Japanese uses the h11 style for 12 hour time. All others use h12.
    ja: "h11"
  },
  false: {}
};
function U1(e, r = {}) {
  if (typeof r.hour12 == "boolean" && N3()) {
    r = {
      ...r
    };
    let n = L3[String(r.hour12)][e.split("-")[0]], i = r.hour12 ? "h12" : "h23";
    r.hourCycle = n ?? i, delete r.hour12;
  }
  let t = e + (r ? Object.entries(r).sort((n, i) => n[0] < i[0] ? -1 : 1).join() : "");
  if (W0.has(t))
    return W0.get(t);
  let a = new Intl.DateTimeFormat(e, r);
  return W0.set(t, a), a;
}
let H0 = null;
function N3() {
  return H0 == null && (H0 = new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    hour12: !1
  }).format(new Date(2020, 2, 3, 0)) === "24"), H0;
}
let j0 = null;
function U3() {
  return j0 == null && (j0 = new Intl.DateTimeFormat("fr", {
    hour: "numeric",
    hour12: !1
  }).resolvedOptions().hourCycle === "h12"), j0;
}
function V3(e, r) {
  if (!r.timeStyle && !r.hour)
    return;
  e = e.replace(/(-u-)?-nu-[a-zA-Z0-9]+/, ""), e += (e.includes("-u-") ? "" : "-u") + "-nu-latn";
  let t = U1(e, {
    ...r,
    timeZone: void 0
    // use local timezone
  }), a = parseInt(t.formatToParts(new Date(2020, 2, 3, 0)).find((i) => i.type === "hour").value, 10), n = parseInt(t.formatToParts(new Date(2020, 2, 3, 23)).find((i) => i.type === "hour").value, 10);
  if (a === 0 && n === 23)
    return "h23";
  if (a === 24 && n === 23)
    return "h24";
  if (a === 0 && n === 11)
    return "h11";
  if (a === 12 && n === 11)
    return "h12";
  throw new Error("Unexpected hour cycle result");
}
function Qn(e) {
  e = p1(e ?? {}, W3);
  let { locale: r } = Kt();
  return Pe(() => new O3(r, e), [
    r,
    e
  ]);
}
function W3(e, r) {
  if (e === r)
    return !0;
  let t = Object.keys(e), a = Object.keys(r);
  if (t.length !== a.length)
    return !1;
  for (let n of t)
    if (r[n] !== e[n])
      return !1;
  return !0;
}
function H3(e, r) {
  let {
    elementType: t = "button",
    isDisabled: a,
    onPress: n,
    onPressStart: i,
    onPressEnd: s,
    onPressUp: o,
    onPressChange: u,
    preventFocusOnPress: l,
    allowFocusWhenDisabled: c,
    // @ts-ignore
    onClick: f,
    href: h,
    target: d,
    rel: m,
    type: x = "button"
  } = e, p;
  t === "button" ? p = {
    type: x,
    disabled: a
  } : p = {
    role: "button",
    tabIndex: a ? void 0 : 0,
    href: t === "a" && !a ? h : void 0,
    target: t === "a" ? d : void 0,
    type: t === "input" ? x : void 0,
    disabled: t === "input" ? a : void 0,
    "aria-disabled": !a || t === "input" ? void 0 : a,
    rel: t === "a" ? m : void 0
  };
  let { pressProps: w, isPressed: D } = Ll({
    onPressStart: i,
    onPressEnd: s,
    onPressChange: u,
    onPress: n,
    onPressUp: o,
    isDisabled: a,
    preventFocusOnPress: l,
    ref: r
  }), { focusableProps: y } = k3(e, r);
  c && (y.tabIndex = a ? -1 : y.tabIndex);
  let B = Nr(y, w, lt(e, {
    labelable: !0
  }));
  return {
    isPressed: D,
    buttonProps: Nr(p, B, {
      "aria-haspopup": e["aria-haspopup"],
      "aria-expanded": e["aria-expanded"],
      "aria-controls": e["aria-controls"],
      "aria-pressed": e["aria-pressed"],
      onClick: (L) => {
        f && (f(L), console.warn("onClick is deprecated, please use onPress"));
      }
    })
  };
}
var V1 = {};
V1 = {
  dateRange: (e) => `${e.startDate} إلى ${e.endDate}`,
  dateSelected: (e) => `${e.date} المحدد`,
  finishRangeSelectionPrompt: "انقر لإنهاء عملية تحديد نطاق التاريخ",
  maximumDate: "آخر تاريخ متاح",
  minimumDate: "أول تاريخ متاح",
  next: "التالي",
  previous: "السابق",
  selectedDateDescription: (e) => `تاريخ محدد: ${e.date}`,
  selectedRangeDescription: (e) => `المدى الزمني المحدد: ${e.dateRange}`,
  startRangeSelectionPrompt: "انقر لبدء عملية تحديد نطاق التاريخ",
  todayDate: (e) => `اليوم، ${e.date}`,
  todayDateSelected: (e) => `اليوم، ${e.date} محدد`
};
var W1 = {};
W1 = {
  dateRange: (e) => `${e.startDate} до ${e.endDate}`,
  dateSelected: (e) => `Избрано е ${e.date}`,
  finishRangeSelectionPrompt: "Натиснете, за да довършите избора на времеви интервал",
  maximumDate: "Последна налична дата",
  minimumDate: "Първа налична дата",
  next: "Напред",
  previous: "Назад",
  selectedDateDescription: (e) => `Избрана дата: ${e.date}`,
  selectedRangeDescription: (e) => `Избран диапазон: ${e.dateRange}`,
  startRangeSelectionPrompt: "Натиснете, за да пристъпите към избора на времеви интервал",
  todayDate: (e) => `Днес, ${e.date}`,
  todayDateSelected: (e) => `Днес, ${e.date} са избрани`
};
var H1 = {};
H1 = {
  dateRange: (e) => `${e.startDate} až ${e.endDate}`,
  dateSelected: (e) => `Vybráno ${e.date}`,
  finishRangeSelectionPrompt: "Kliknutím dokončíte výběr rozsahu dat",
  maximumDate: "Poslední dostupné datum",
  minimumDate: "První dostupné datum",
  next: "Další",
  previous: "Předchozí",
  selectedDateDescription: (e) => `Vybrané datum: ${e.date}`,
  selectedRangeDescription: (e) => `Vybrané období: ${e.dateRange}`,
  startRangeSelectionPrompt: "Kliknutím zahájíte výběr rozsahu dat",
  todayDate: (e) => `Dnes, ${e.date}`,
  todayDateSelected: (e) => `Dnes, vybráno ${e.date}`
};
var j1 = {};
j1 = {
  dateRange: (e) => `${e.startDate} til ${e.endDate}`,
  dateSelected: (e) => `${e.date} valgt`,
  finishRangeSelectionPrompt: "Klik for at fuldføre valg af datoområde",
  maximumDate: "Sidste ledige dato",
  minimumDate: "Første ledige dato",
  next: "Næste",
  previous: "Forrige",
  selectedDateDescription: (e) => `Valgt dato: ${e.date}`,
  selectedRangeDescription: (e) => `Valgt interval: ${e.dateRange}`,
  startRangeSelectionPrompt: "Klik for at starte valg af datoområde",
  todayDate: (e) => `I dag, ${e.date}`,
  todayDateSelected: (e) => `I dag, ${e.date} valgt`
};
var z1 = {};
z1 = {
  dateRange: (e) => `${e.startDate} bis ${e.endDate}`,
  dateSelected: (e) => `${e.date} ausgewählt`,
  finishRangeSelectionPrompt: "Klicken, um die Auswahl des Datumsbereichs zu beenden",
  maximumDate: "Letztes verfügbares Datum",
  minimumDate: "Erstes verfügbares Datum",
  next: "Weiter",
  previous: "Zurück",
  selectedDateDescription: (e) => `Ausgewähltes Datum: ${e.date}`,
  selectedRangeDescription: (e) => `Ausgewählter Bereich: ${e.dateRange}`,
  startRangeSelectionPrompt: "Klicken, um die Auswahl des Datumsbereichs zu beginnen",
  todayDate: (e) => `Heute, ${e.date}`,
  todayDateSelected: (e) => `Heute, ${e.date} ausgewählt`
};
var G1 = {};
G1 = {
  dateRange: (e) => `${e.startDate} έως ${e.endDate}`,
  dateSelected: (e) => `Επιλέχθηκε ${e.date}`,
  finishRangeSelectionPrompt: "Κάντε κλικ για να ολοκληρώσετε την επιλογή εύρους ημερομηνιών",
  maximumDate: "Τελευταία διαθέσιμη ημερομηνία",
  minimumDate: "Πρώτη διαθέσιμη ημερομηνία",
  next: "Επόμενο",
  previous: "Προηγούμενο",
  selectedDateDescription: (e) => `Επιλεγμένη ημερομηνία: ${e.date}`,
  selectedRangeDescription: (e) => `Επιλεγμένο εύρος: ${e.dateRange}`,
  startRangeSelectionPrompt: "Κάντε κλικ για να ξεκινήσετε την επιλογή εύρους ημερομηνιών",
  todayDate: (e) => `Σήμερα, ${e.date}`,
  todayDateSelected: (e) => `Σήμερα, επιλέχτηκε ${e.date}`
};
var K1 = {};
K1 = {
  previous: "Previous",
  next: "Next",
  selectedDateDescription: (e) => `Selected Date: ${e.date}`,
  selectedRangeDescription: (e) => `Selected Range: ${e.dateRange}`,
  todayDate: (e) => `Today, ${e.date}`,
  todayDateSelected: (e) => `Today, ${e.date} selected`,
  dateSelected: (e) => `${e.date} selected`,
  startRangeSelectionPrompt: "Click to start selecting date range",
  finishRangeSelectionPrompt: "Click to finish selecting date range",
  minimumDate: "First available date",
  maximumDate: "Last available date",
  dateRange: (e) => `${e.startDate} to ${e.endDate}`
};
var Y1 = {};
Y1 = {
  dateRange: (e) => `${e.startDate} a ${e.endDate}`,
  dateSelected: (e) => `${e.date} seleccionado`,
  finishRangeSelectionPrompt: "Haga clic para terminar de seleccionar rango de fechas",
  maximumDate: "Última fecha disponible",
  minimumDate: "Primera fecha disponible",
  next: "Siguiente",
  previous: "Anterior",
  selectedDateDescription: (e) => `Fecha seleccionada: ${e.date}`,
  selectedRangeDescription: (e) => `Intervalo seleccionado: ${e.dateRange}`,
  startRangeSelectionPrompt: "Haga clic para comenzar a seleccionar un rango de fechas",
  todayDate: (e) => `Hoy, ${e.date}`,
  todayDateSelected: (e) => `Hoy, ${e.date} seleccionado`
};
var X1 = {};
X1 = {
  dateRange: (e) => `${e.startDate} kuni ${e.endDate}`,
  dateSelected: (e) => `${e.date} valitud`,
  finishRangeSelectionPrompt: "Klõpsake kuupäevavahemiku valimise lõpetamiseks",
  maximumDate: "Viimane saadaolev kuupäev",
  minimumDate: "Esimene saadaolev kuupäev",
  next: "Järgmine",
  previous: "Eelmine",
  selectedDateDescription: (e) => `Valitud kuupäev: ${e.date}`,
  selectedRangeDescription: (e) => `Valitud vahemik: ${e.dateRange}`,
  startRangeSelectionPrompt: "Klõpsake kuupäevavahemiku valimiseks",
  todayDate: (e) => `Täna, ${e.date}`,
  todayDateSelected: (e) => `Täna, ${e.date} valitud`
};
var Z1 = {};
Z1 = {
  dateRange: (e) => `${e.startDate} – ${e.endDate}`,
  dateSelected: (e) => `${e.date} valittu`,
  finishRangeSelectionPrompt: "Lopeta päivämääräalueen valinta napsauttamalla tätä.",
  maximumDate: "Viimeinen varattavissa oleva päivämäärä",
  minimumDate: "Ensimmäinen varattavissa oleva päivämäärä",
  next: "Seuraava",
  previous: "Edellinen",
  selectedDateDescription: (e) => `Valittu päivämäärä: ${e.date}`,
  selectedRangeDescription: (e) => `Valittu aikaväli: ${e.dateRange}`,
  startRangeSelectionPrompt: "Aloita päivämääräalueen valinta napsauttamalla tätä.",
  todayDate: (e) => `Tänään, ${e.date}`,
  todayDateSelected: (e) => `Tänään, ${e.date} valittu`
};
var J1 = {};
J1 = {
  dateRange: (e) => `${e.startDate} à ${e.endDate}`,
  dateSelected: (e) => `${e.date} sélectionné`,
  finishRangeSelectionPrompt: "Cliquer pour finir de sélectionner la plage de dates",
  maximumDate: "Dernière date disponible",
  minimumDate: "Première date disponible",
  next: "Suivant",
  previous: "Précédent",
  selectedDateDescription: (e) => `Date sélectionnée : ${e.date}`,
  selectedRangeDescription: (e) => `Plage sélectionnée : ${e.dateRange}`,
  startRangeSelectionPrompt: "Cliquer pour commencer à sélectionner la plage de dates",
  todayDate: (e) => `Aujourd'hui, ${e.date}`,
  todayDateSelected: (e) => `Aujourd’hui, ${e.date} sélectionné`
};
var q1 = {};
q1 = {
  dateRange: (e) => `${e.startDate} עד ${e.endDate}`,
  dateSelected: (e) => `${e.date} נבחר`,
  finishRangeSelectionPrompt: "חץ כדי לסיים את בחירת טווח התאריכים",
  maximumDate: "תאריך פנוי אחרון",
  minimumDate: "תאריך פנוי ראשון",
  next: "הבא",
  previous: "הקודם",
  selectedDateDescription: (e) => `תאריך נבחר: ${e.date}`,
  selectedRangeDescription: (e) => `טווח נבחר: ${e.dateRange}`,
  startRangeSelectionPrompt: "לחץ כדי להתחיל בבחירת טווח התאריכים",
  todayDate: (e) => `היום, ${e.date}`,
  todayDateSelected: (e) => `היום, ${e.date} נבחר`
};
var Q1 = {};
Q1 = {
  dateRange: (e) => `${e.startDate} do ${e.endDate}`,
  dateSelected: (e) => `${e.date} odabran`,
  finishRangeSelectionPrompt: "Kliknite da dovršite raspon odabranih datuma",
  maximumDate: "Posljednji raspoloživi datum",
  minimumDate: "Prvi raspoloživi datum",
  next: "Sljedeći",
  previous: "Prethodni",
  selectedDateDescription: (e) => `Odabrani datum: ${e.date}`,
  selectedRangeDescription: (e) => `Odabrani raspon: ${e.dateRange}`,
  startRangeSelectionPrompt: "Kliknite da započnete raspon odabranih datuma",
  todayDate: (e) => `Danas, ${e.date}`,
  todayDateSelected: (e) => `Danas, odabran ${e.date}`
};
var ex = {};
ex = {
  dateRange: (e) => `${e.startDate}–${e.endDate}`,
  dateSelected: (e) => `${e.date} kiválasztva`,
  finishRangeSelectionPrompt: "Kattintson a dátumtartomány kijelölésének befejezéséhez",
  maximumDate: "Utolsó elérhető dátum",
  minimumDate: "Az első elérhető dátum",
  next: "Következő",
  previous: "Előző",
  selectedDateDescription: (e) => `Kijelölt dátum: ${e.date}`,
  selectedRangeDescription: (e) => `Kijelölt tartomány: ${e.dateRange}`,
  startRangeSelectionPrompt: "Kattintson a dátumtartomány kijelölésének indításához",
  todayDate: (e) => `Ma, ${e.date}`,
  todayDateSelected: (e) => `Ma, ${e.date} kijelölve`
};
var rx = {};
rx = {
  dateRange: (e) => `Da ${e.startDate} a ${e.endDate}`,
  dateSelected: (e) => `${e.date} selezionata`,
  finishRangeSelectionPrompt: "Fai clic per completare la selezione dell’intervallo di date",
  maximumDate: "Ultima data disponibile",
  minimumDate: "Prima data disponibile",
  next: "Successivo",
  previous: "Precedente",
  selectedDateDescription: (e) => `Data selezionata: ${e.date}`,
  selectedRangeDescription: (e) => `Intervallo selezionato: ${e.dateRange}`,
  startRangeSelectionPrompt: "Fai clic per selezionare l’intervallo di date",
  todayDate: (e) => `Oggi, ${e.date}`,
  todayDateSelected: (e) => `Oggi, ${e.date} selezionata`
};
var tx = {};
tx = {
  dateRange: (e) => `${e.startDate} から ${e.endDate}`,
  dateSelected: (e) => `${e.date} を選択`,
  finishRangeSelectionPrompt: "クリックして日付範囲の選択を終了",
  maximumDate: "最終利用可能日",
  minimumDate: "最初の利用可能日",
  next: "次へ",
  previous: "前へ",
  selectedDateDescription: (e) => `選択した日付 : ${e.date}`,
  selectedRangeDescription: (e) => `選択範囲 : ${e.dateRange}`,
  startRangeSelectionPrompt: "クリックして日付範囲の選択を開始",
  todayDate: (e) => `本日、${e.date}`,
  todayDateSelected: (e) => `本日、${e.date} を選択`
};
var ax = {};
ax = {
  dateRange: (e) => `${e.startDate} ~ ${e.endDate}`,
  dateSelected: (e) => `${e.date} 선택됨`,
  finishRangeSelectionPrompt: "날짜 범위 선택을 완료하려면 클릭하십시오.",
  maximumDate: "마지막으로 사용 가능한 일자",
  minimumDate: "처음으로 사용 가능한 일자",
  next: "다음",
  previous: "이전",
  selectedDateDescription: (e) => `선택 일자: ${e.date}`,
  selectedRangeDescription: (e) => `선택 범위: ${e.dateRange}`,
  startRangeSelectionPrompt: "날짜 범위 선택을 시작하려면 클릭하십시오.",
  todayDate: (e) => `오늘, ${e.date}`,
  todayDateSelected: (e) => `오늘, ${e.date} 선택됨`
};
var nx = {};
nx = {
  dateRange: (e) => `Nuo ${e.startDate} iki ${e.endDate}`,
  dateSelected: (e) => `Pasirinkta ${e.date}`,
  finishRangeSelectionPrompt: "Spustelėkite, kad baigtumėte pasirinkti datų intervalą",
  maximumDate: "Paskutinė galima data",
  minimumDate: "Pirmoji galima data",
  next: "Paskesnis",
  previous: "Ankstesnis",
  selectedDateDescription: (e) => `Pasirinkta data: ${e.date}`,
  selectedRangeDescription: (e) => `Pasirinktas intervalas: ${e.dateRange}`,
  startRangeSelectionPrompt: "Spustelėkite, kad pradėtumėte pasirinkti datų intervalą",
  todayDate: (e) => `Šiandien, ${e.date}`,
  todayDateSelected: (e) => `Šiandien, pasirinkta ${e.date}`
};
var ix = {};
ix = {
  dateRange: (e) => `No ${e.startDate} līdz ${e.endDate}`,
  dateSelected: (e) => `Atlasīts: ${e.date}`,
  finishRangeSelectionPrompt: "Noklikšķiniet, lai pabeigtu datumu diapazona atlasi",
  maximumDate: "Pēdējais pieejamais datums",
  minimumDate: "Pirmais pieejamais datums",
  next: "Tālāk",
  previous: "Atpakaļ",
  selectedDateDescription: (e) => `Atlasītais datums: ${e.date}`,
  selectedRangeDescription: (e) => `Atlasītais diapazons: ${e.dateRange}`,
  startRangeSelectionPrompt: "Noklikšķiniet, lai sāktu datumu diapazona atlasi",
  todayDate: (e) => `Šodien, ${e.date}`,
  todayDateSelected: (e) => `Atlasīta šodiena, ${e.date}`
};
var sx = {};
sx = {
  dateRange: (e) => `${e.startDate} til ${e.endDate}`,
  dateSelected: (e) => `${e.date} valgt`,
  finishRangeSelectionPrompt: "Klikk for å fullføre valg av datoområde",
  maximumDate: "Siste tilgjengelige dato",
  minimumDate: "Første tilgjengelige dato",
  next: "Neste",
  previous: "Forrige",
  selectedDateDescription: (e) => `Valgt dato: ${e.date}`,
  selectedRangeDescription: (e) => `Valgt område: ${e.dateRange}`,
  startRangeSelectionPrompt: "Klikk for å starte valg av datoområde",
  todayDate: (e) => `I dag, ${e.date}`,
  todayDateSelected: (e) => `I dag, ${e.date} valgt`
};
var ox = {};
ox = {
  dateRange: (e) => `${e.startDate} tot ${e.endDate}`,
  dateSelected: (e) => `${e.date} geselecteerd`,
  finishRangeSelectionPrompt: "Klik om de selectie van het datumbereik te voltooien",
  maximumDate: "Laatste beschikbare datum",
  minimumDate: "Eerste beschikbare datum",
  next: "Volgende",
  previous: "Vorige",
  selectedDateDescription: (e) => `Geselecteerde datum: ${e.date}`,
  selectedRangeDescription: (e) => `Geselecteerd bereik: ${e.dateRange}`,
  startRangeSelectionPrompt: "Klik om het datumbereik te selecteren",
  todayDate: (e) => `Vandaag, ${e.date}`,
  todayDateSelected: (e) => `Vandaag, ${e.date} geselecteerd`
};
var ux = {};
ux = {
  dateRange: (e) => `${e.startDate} do ${e.endDate}`,
  dateSelected: (e) => `Wybrano ${e.date}`,
  finishRangeSelectionPrompt: "Kliknij, aby zakończyć wybór zakresu dat",
  maximumDate: "Ostatnia dostępna data",
  minimumDate: "Pierwsza dostępna data",
  next: "Dalej",
  previous: "Wstecz",
  selectedDateDescription: (e) => `Wybrana data: ${e.date}`,
  selectedRangeDescription: (e) => `Wybrany zakres: ${e.dateRange}`,
  startRangeSelectionPrompt: "Kliknij, aby rozpocząć wybór zakresu dat",
  todayDate: (e) => `Dzisiaj, ${e.date}`,
  todayDateSelected: (e) => `Dzisiaj wybrano ${e.date}`
};
var lx = {};
lx = {
  dateRange: (e) => `${e.startDate} a ${e.endDate}`,
  dateSelected: (e) => `${e.date} selecionado`,
  finishRangeSelectionPrompt: "Clique para concluir a seleção do intervalo de datas",
  maximumDate: "Última data disponível",
  minimumDate: "Primeira data disponível",
  next: "Próximo",
  previous: "Anterior",
  selectedDateDescription: (e) => `Data selecionada: ${e.date}`,
  selectedRangeDescription: (e) => `Intervalo selecionado: ${e.dateRange}`,
  startRangeSelectionPrompt: "Clique para iniciar a seleção do intervalo de datas",
  todayDate: (e) => `Hoje, ${e.date}`,
  todayDateSelected: (e) => `Hoje, ${e.date} selecionado`
};
var cx = {};
cx = {
  dateRange: (e) => `${e.startDate} a ${e.endDate}`,
  dateSelected: (e) => `${e.date} selecionado`,
  finishRangeSelectionPrompt: "Clique para terminar de selecionar o intervalo de datas",
  maximumDate: "Última data disponível",
  minimumDate: "Primeira data disponível",
  next: "Próximo",
  previous: "Anterior",
  selectedDateDescription: (e) => `Data selecionada: ${e.date}`,
  selectedRangeDescription: (e) => `Intervalo selecionado: ${e.dateRange}`,
  startRangeSelectionPrompt: "Clique para começar a selecionar o intervalo de datas",
  todayDate: (e) => `Hoje, ${e.date}`,
  todayDateSelected: (e) => `Hoje, ${e.date} selecionado`
};
var fx = {};
fx = {
  dateRange: (e) => `De la ${e.startDate} până la ${e.endDate}`,
  dateSelected: (e) => `${e.date} selectată`,
  finishRangeSelectionPrompt: "Apăsaţi pentru a finaliza selecţia razei pentru dată",
  maximumDate: "Ultima dată disponibilă",
  minimumDate: "Prima dată disponibilă",
  next: "Următorul",
  previous: "Înainte",
  selectedDateDescription: (e) => `Dată selectată: ${e.date}`,
  selectedRangeDescription: (e) => `Interval selectat: ${e.dateRange}`,
  startRangeSelectionPrompt: "Apăsaţi pentru a începe selecţia razei pentru dată",
  todayDate: (e) => `Astăzi, ${e.date}`,
  todayDateSelected: (e) => `Azi, ${e.date} selectată`
};
var dx = {};
dx = {
  dateRange: (e) => `С ${e.startDate} по ${e.endDate}`,
  dateSelected: (e) => `Выбрано ${e.date}`,
  finishRangeSelectionPrompt: "Щелкните, чтобы завершить выбор диапазона дат",
  maximumDate: "Последняя доступная дата",
  minimumDate: "Первая доступная дата",
  next: "Далее",
  previous: "Назад",
  selectedDateDescription: (e) => `Выбранная дата: ${e.date}`,
  selectedRangeDescription: (e) => `Выбранный диапазон: ${e.dateRange}`,
  startRangeSelectionPrompt: "Щелкните, чтобы начать выбор диапазона дат",
  todayDate: (e) => `Сегодня, ${e.date}`,
  todayDateSelected: (e) => `Сегодня, выбрано ${e.date}`
};
var hx = {};
hx = {
  dateRange: (e) => `Od ${e.startDate} do ${e.endDate}`,
  dateSelected: (e) => `Vybratý dátum ${e.date}`,
  finishRangeSelectionPrompt: "Kliknutím dokončíte výber rozsahu dátumov",
  maximumDate: "Posledný dostupný dátum",
  minimumDate: "Prvý dostupný dátum",
  next: "Nasledujúce",
  previous: "Predchádzajúce",
  selectedDateDescription: (e) => `Vybratý dátum: ${e.date}`,
  selectedRangeDescription: (e) => `Vybratý rozsah: ${e.dateRange}`,
  startRangeSelectionPrompt: "Kliknutím spustíte výber rozsahu dátumov",
  todayDate: (e) => `Dnes ${e.date}`,
  todayDateSelected: (e) => `Vybratý dnešný dátum ${e.date}`
};
var xx = {};
xx = {
  dateRange: (e) => `${e.startDate} do ${e.endDate}`,
  dateSelected: (e) => `${e.date} izbrano`,
  finishRangeSelectionPrompt: "Kliknite za dokončanje izbire datumskega obsega",
  maximumDate: "Zadnji razpoložljivi datum",
  minimumDate: "Prvi razpoložljivi datum",
  next: "Naprej",
  previous: "Nazaj",
  selectedDateDescription: (e) => `Izbrani datum: ${e.date}`,
  selectedRangeDescription: (e) => `Izbrano območje: ${e.dateRange}`,
  startRangeSelectionPrompt: "Kliknite za začetek izbire datumskega obsega",
  todayDate: (e) => `Danes, ${e.date}`,
  todayDateSelected: (e) => `Danes, ${e.date} izbrano`
};
var mx = {};
mx = {
  dateRange: (e) => `${e.startDate} do ${e.endDate}`,
  dateSelected: (e) => `${e.date} izabran`,
  finishRangeSelectionPrompt: "Kliknite da dovršite opseg izabranih datuma",
  maximumDate: "Zadnji raspoloživi datum",
  minimumDate: "Prvi raspoloživi datum",
  next: "Sledeći",
  previous: "Prethodni",
  selectedDateDescription: (e) => `Izabrani datum: ${e.date}`,
  selectedRangeDescription: (e) => `Izabrani period: ${e.dateRange}`,
  startRangeSelectionPrompt: "Kliknite da započnete opseg izabranih datuma",
  todayDate: (e) => `Danas, ${e.date}`,
  todayDateSelected: (e) => `Danas, izabran ${e.date}`
};
var px = {};
px = {
  dateRange: (e) => `${e.startDate} till ${e.endDate}`,
  dateSelected: (e) => `${e.date} har valts`,
  finishRangeSelectionPrompt: "Klicka för att avsluta val av datumintervall",
  maximumDate: "Sista tillgängliga datum",
  minimumDate: "Första tillgängliga datum",
  next: "Nästa",
  previous: "Föregående",
  selectedDateDescription: (e) => `Valt datum: ${e.date}`,
  selectedRangeDescription: (e) => `Valt intervall: ${e.dateRange}`,
  startRangeSelectionPrompt: "Klicka för att välja datumintervall",
  todayDate: (e) => `Idag, ${e.date}`,
  todayDateSelected: (e) => `Idag, ${e.date} har valts`
};
var vx = {};
vx = {
  dateRange: (e) => `${e.startDate} - ${e.endDate}`,
  dateSelected: (e) => `${e.date} seçildi`,
  finishRangeSelectionPrompt: "Tarih aralığı seçimini tamamlamak için tıklayın",
  maximumDate: "Son müsait tarih",
  minimumDate: "İlk müsait tarih",
  next: "Sonraki",
  previous: "Önceki",
  selectedDateDescription: (e) => `Seçilen Tarih: ${e.date}`,
  selectedRangeDescription: (e) => `Seçilen Aralık: ${e.dateRange}`,
  startRangeSelectionPrompt: "Tarih aralığı seçimini başlatmak için tıklayın",
  todayDate: (e) => `Bugün, ${e.date}`,
  todayDateSelected: (e) => `Bugün, ${e.date} seçildi`
};
var gx = {};
gx = {
  dateRange: (e) => `${e.startDate} — ${e.endDate}`,
  dateSelected: (e) => `Вибрано ${e.date}`,
  finishRangeSelectionPrompt: "Натисніть, щоб завершити вибір діапазону дат",
  maximumDate: "Остання доступна дата",
  minimumDate: "Перша доступна дата",
  next: "Наступний",
  previous: "Попередній",
  selectedDateDescription: (e) => `Вибрана дата: ${e.date}`,
  selectedRangeDescription: (e) => `Вибраний діапазон: ${e.dateRange}`,
  startRangeSelectionPrompt: "Натисніть, щоб почати вибір діапазону дат",
  todayDate: (e) => `Сьогодні, ${e.date}`,
  todayDateSelected: (e) => `Сьогодні, вибрано ${e.date}`
};
var yx = {};
yx = {
  dateRange: (e) => `${e.startDate} 至 ${e.endDate}`,
  dateSelected: (e) => `已选择 ${e.date}`,
  finishRangeSelectionPrompt: "单击以完成选择日期范围",
  maximumDate: "最后一个可用日期",
  minimumDate: "第一个可用日期",
  next: "下一页",
  previous: "上一页",
  selectedDateDescription: (e) => `选定的日期：${e.date}`,
  selectedRangeDescription: (e) => `选定的范围：${e.dateRange}`,
  startRangeSelectionPrompt: "单击以开始选择日期范围",
  todayDate: (e) => `今天，即 ${e.date}`,
  todayDateSelected: (e) => `已选择今天，即 ${e.date}`
};
var bx = {};
bx = {
  dateRange: (e) => `${e.startDate} 至 ${e.endDate}`,
  dateSelected: (e) => `已選取 ${e.date}`,
  finishRangeSelectionPrompt: "按一下以完成選取日期範圍",
  maximumDate: "最後一個可用日期",
  minimumDate: "第一個可用日期",
  next: "下一頁",
  previous: "上一頁",
  selectedDateDescription: (e) => `選定的日期：${e.date}`,
  selectedRangeDescription: (e) => `選定的範圍：${e.dateRange}`,
  startRangeSelectionPrompt: "按一下以開始選取日期範圍",
  todayDate: (e) => `今天，${e.date}`,
  todayDateSelected: (e) => `已選取今天，${e.date}`
};
var gs = {};
gs = {
  "ar-AE": V1,
  "bg-BG": W1,
  "cs-CZ": H1,
  "da-DK": j1,
  "de-DE": z1,
  "el-GR": G1,
  "en-US": K1,
  "es-ES": Y1,
  "et-EE": X1,
  "fi-FI": Z1,
  "fr-FR": J1,
  "he-IL": q1,
  "hr-HR": Q1,
  "hu-HU": ex,
  "it-IT": rx,
  "ja-JP": tx,
  "ko-KR": ax,
  "lt-LT": nx,
  "lv-LV": ix,
  "nb-NO": sx,
  "nl-NL": ox,
  "pl-PL": ux,
  "pt-BR": lx,
  "pt-PT": cx,
  "ro-RO": fx,
  "ru-RU": dx,
  "sk-SK": hx,
  "sl-SI": xx,
  "sr-SP": mx,
  "sv-SE": px,
  "tr-TR": vx,
  "uk-UA": gx,
  "zh-CN": yx,
  "zh-TW": bx
};
function z0(e, r) {
  return e - r * Math.floor(e / r);
}
const wx = 1721426;
function zs(e, r, t, a) {
  r = zl(e, r);
  let n = r - 1, i = -2;
  return t <= 2 ? i = 0 : fo(r) && (i = -1), wx - 1 + 365 * n + Math.floor(n / 4) - Math.floor(n / 100) + Math.floor(n / 400) + Math.floor((367 * t - 362) / 12 + i + a);
}
function fo(e) {
  return e % 4 === 0 && (e % 100 !== 0 || e % 400 === 0);
}
function zl(e, r) {
  return e === "BC" ? 1 - r : r;
}
function j3(e) {
  let r = "AD";
  return e <= 0 && (r = "BC", e = 1 - e), [
    r,
    e
  ];
}
const z3 = {
  standard: [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
  ],
  leapyear: [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
  ]
};
let ei = class {
  fromJulianDay(r) {
    let t = r, a = t - wx, n = Math.floor(a / 146097), i = z0(a, 146097), s = Math.floor(i / 36524), o = z0(i, 36524), u = Math.floor(o / 1461), l = z0(o, 1461), c = Math.floor(l / 365), f = n * 400 + s * 100 + u * 4 + c + (s !== 4 && c !== 4 ? 1 : 0), [h, d] = j3(f), m = t - zs(h, d, 1, 1), x = 2;
    t < zs(h, d, 3, 1) ? x = 0 : fo(d) && (x = 1);
    let p = Math.floor(((m + x) * 12 + 373) / 367), w = t - zs(h, d, p, 1) + 1;
    return new Px(h, d, p, w);
  }
  toJulianDay(r) {
    return zs(r.era, r.year, r.month, r.day);
  }
  getDaysInMonth(r) {
    return z3[fo(r.year) ? "leapyear" : "standard"][r.month - 1];
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getMonthsInYear(r) {
    return 12;
  }
  getDaysInYear(r) {
    return fo(r.year) ? 366 : 365;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getYearsInEra(r) {
    return 9999;
  }
  getEras() {
    return [
      "BC",
      "AD"
    ];
  }
  isInverseEra(r) {
    return r.era === "BC";
  }
  balanceDate(r) {
    r.year <= 0 && (r.era = r.era === "BC" ? "AD" : "BC", r.year = 1 - r.year);
  }
  constructor() {
    this.identifier = "gregory";
  }
};
const G3 = {
  "001": 1,
  AD: 1,
  AE: 6,
  AF: 6,
  AI: 1,
  AL: 1,
  AM: 1,
  AN: 1,
  AR: 1,
  AT: 1,
  AU: 1,
  AX: 1,
  AZ: 1,
  BA: 1,
  BE: 1,
  BG: 1,
  BH: 6,
  BM: 1,
  BN: 1,
  BY: 1,
  CH: 1,
  CL: 1,
  CM: 1,
  CN: 1,
  CR: 1,
  CY: 1,
  CZ: 1,
  DE: 1,
  DJ: 6,
  DK: 1,
  DZ: 6,
  EC: 1,
  EE: 1,
  EG: 6,
  ES: 1,
  FI: 1,
  FJ: 1,
  FO: 1,
  FR: 1,
  GB: 1,
  GE: 1,
  GF: 1,
  GP: 1,
  GR: 1,
  HR: 1,
  HU: 1,
  IE: 1,
  IQ: 6,
  IR: 6,
  IS: 1,
  IT: 1,
  JO: 6,
  KG: 1,
  KW: 6,
  KZ: 1,
  LB: 1,
  LI: 1,
  LK: 1,
  LT: 1,
  LU: 1,
  LV: 1,
  LY: 6,
  MC: 1,
  MD: 1,
  ME: 1,
  MK: 1,
  MN: 1,
  MQ: 1,
  MV: 5,
  MY: 1,
  NL: 1,
  NO: 1,
  NZ: 1,
  OM: 6,
  PL: 1,
  QA: 6,
  RE: 1,
  RO: 1,
  RS: 1,
  RU: 1,
  SD: 6,
  SE: 1,
  SI: 1,
  SK: 1,
  SM: 1,
  SY: 6,
  TJ: 1,
  TM: 1,
  TR: 1,
  UA: 1,
  UY: 1,
  UZ: 1,
  VA: 1,
  VN: 1,
  XK: 1
};
function ct(e, r) {
  return r = Rt(r, e.calendar), e.era === r.era && e.year === r.year && e.month === r.month && e.day === r.day;
}
function K3(e, r) {
  return e.calendar.identifier === r.calendar.identifier && e.era === r.era && e.year === r.year && e.month === r.month && e.day === r.day;
}
function Y3(e, r) {
  return ct(e, _x(r));
}
function X3(e, r) {
  let t = e.calendar.toJulianDay(e), a = Math.ceil(t + 1 - ry(r)) % 7;
  return a < 0 && (a += 7), a;
}
function Z3(e) {
  return na(Date.now(), e);
}
function _x(e) {
  return ny(Z3(e));
}
function $x(e, r) {
  return e.calendar.toJulianDay(e) - r.calendar.toJulianDay(r);
}
function J3(e, r) {
  return Ff(e) - Ff(r);
}
function Ff(e) {
  return e.hour * 36e5 + e.minute * 6e4 + e.second * 1e3 + e.millisecond;
}
let G0 = null;
function Dx() {
  return G0 == null && (G0 = new Intl.DateTimeFormat().resolvedOptions().timeZone), G0;
}
function q3(e) {
  return e.subtract({
    days: e.day - 1
  });
}
function Af(e) {
  return e.add({
    days: e.calendar.getDaysInMonth(e) - e.day
  });
}
function Q3(e, r) {
  let t = X3(e, r);
  return e.subtract({
    days: t
  });
}
const Rf = /* @__PURE__ */ new Map();
function ey(e) {
  if (Intl.Locale) {
    let t = Rf.get(e);
    return t || (t = new Intl.Locale(e).maximize().region, t && Rf.set(e, t)), t;
  }
  let r = e.split("-")[1];
  return r === "u" ? void 0 : r;
}
function ry(e) {
  let r = ey(e);
  return r && G3[r] || 0;
}
function ri(e) {
  e = Rt(e, new ei());
  let r = zl(e.era, e.year);
  return Ex(r, e.month, e.day, e.hour, e.minute, e.second, e.millisecond);
}
function Ex(e, r, t, a, n, i, s) {
  let o = /* @__PURE__ */ new Date();
  return o.setUTCHours(a, n, i, s), o.setUTCFullYear(e, r - 1, t), o.getTime();
}
function Uu(e, r) {
  if (r === "UTC")
    return 0;
  if (e > 0 && r === Dx())
    return new Date(e).getTimezoneOffset() * -6e4;
  let { year: t, month: a, day: n, hour: i, minute: s, second: o } = kx(e, r);
  return Ex(t, a, n, i, s, o, 0) - Math.floor(e / 1e3) * 1e3;
}
const If = /* @__PURE__ */ new Map();
function kx(e, r) {
  let t = If.get(r);
  t || (t = new Intl.DateTimeFormat("en-US", {
    timeZone: r,
    hour12: !1,
    era: "short",
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  }), If.set(r, t));
  let a = t.formatToParts(new Date(e)), n = {};
  for (let i of a)
    i.type !== "literal" && (n[i.type] = i.value);
  return {
    // Firefox returns B instead of BC... https://bugzilla.mozilla.org/show_bug.cgi?id=1752253
    year: n.era === "BC" || n.era === "B" ? -n.year + 1 : +n.year,
    month: +n.month,
    day: +n.day,
    hour: n.hour === "24" ? 0 : +n.hour,
    minute: +n.minute,
    second: +n.second
  };
}
const Bf = 864e5;
function ty(e, r, t, a) {
  return (t === a ? [
    t
  ] : [
    t,
    a
  ]).filter((i) => ay(e, r, i));
}
function ay(e, r, t) {
  let a = kx(t, r);
  return e.year === a.year && e.month === a.month && e.day === a.day && e.hour === a.hour && e.minute === a.minute && e.second === a.second;
}
function ra(e, r, t = "compatible") {
  let a = ti(e);
  if (r === "UTC")
    return ri(a);
  if (r === Dx() && t === "compatible") {
    a = Rt(a, new ei());
    let u = /* @__PURE__ */ new Date(), l = zl(a.era, a.year);
    return u.setFullYear(l, a.month - 1, a.day), u.setHours(a.hour, a.minute, a.second, a.millisecond), u.getTime();
  }
  let n = ri(a), i = Uu(n - Bf, r), s = Uu(n + Bf, r), o = ty(a, r, n - i, n - s);
  if (o.length === 1)
    return o[0];
  if (o.length > 1)
    switch (t) {
      case "compatible":
      case "earlier":
        return o[0];
      case "later":
        return o[o.length - 1];
      case "reject":
        throw new RangeError("Multiple possible absolute times found");
    }
  switch (t) {
    case "earlier":
      return Math.min(n - i, n - s);
    case "compatible":
    case "later":
      return Math.max(n - i, n - s);
    case "reject":
      throw new RangeError("No such absolute time found");
  }
}
function Tx(e, r, t = "compatible") {
  return new Date(ra(e, r, t));
}
function na(e, r) {
  let t = Uu(e, r), a = new Date(e + t), n = a.getUTCFullYear(), i = a.getUTCMonth() + 1, s = a.getUTCDate(), o = a.getUTCHours(), u = a.getUTCMinutes(), l = a.getUTCSeconds(), c = a.getUTCMilliseconds();
  return new Mx(n < 1 ? "BC" : "AD", n < 1 ? -n + 1 : n, i, s, r, t, o, u, l, c);
}
function ny(e) {
  return new Px(e.calendar, e.era, e.year, e.month, e.day);
}
function ti(e, r) {
  let t = 0, a = 0, n = 0, i = 0;
  if ("timeZone" in e)
    ({ hour: t, minute: a, second: n, millisecond: i } = e);
  else if ("hour" in e && !r)
    return e;
  return r && ({ hour: t, minute: a, second: n, millisecond: i } = r), new by(e.calendar, e.era, e.year, e.month, e.day, t, a, n, i);
}
function Rt(e, r) {
  if (e.calendar.identifier === r.identifier)
    return e;
  let t = r.fromJulianDay(e.calendar.toJulianDay(e)), a = e.copy();
  return a.calendar = r, a.era = t.era, a.year = t.year, a.month = t.month, a.day = t.day, on(a), a;
}
function iy(e, r, t) {
  if (e instanceof Mx)
    return e.timeZone === r ? e : oy(e, r);
  let a = ra(e, r, t);
  return na(a, r);
}
function sy(e) {
  let r = ri(e) - e.offset;
  return new Date(r);
}
function oy(e, r) {
  let t = ri(e) - e.offset;
  return Rt(na(t, r), e.calendar);
}
const ki = 36e5;
function n0(e, r) {
  let t = e.copy(), a = "hour" in t ? fy(t, r) : 0;
  Vu(t, r.years || 0), t.calendar.balanceYearMonth && t.calendar.balanceYearMonth(t, e), t.month += r.months || 0, Wu(t), Sx(t), t.day += (r.weeks || 0) * 7, t.day += r.days || 0, t.day += a, uy(t), t.calendar.balanceDate && t.calendar.balanceDate(t), t.year < 1 && (t.year = 1, t.month = 1, t.day = 1);
  let n = t.calendar.getYearsInEra(t);
  if (t.year > n) {
    var i, s;
    let u = (i = (s = t.calendar).isInverseEra) === null || i === void 0 ? void 0 : i.call(s, t);
    t.year = n, t.month = u ? 1 : t.calendar.getMonthsInYear(t), t.day = u ? 1 : t.calendar.getDaysInMonth(t);
  }
  t.month < 1 && (t.month = 1, t.day = 1);
  let o = t.calendar.getMonthsInYear(t);
  return t.month > o && (t.month = o, t.day = t.calendar.getDaysInMonth(t)), t.day = Math.max(1, Math.min(t.calendar.getDaysInMonth(t), t.day)), t;
}
function Vu(e, r) {
  var t, a;
  !((t = (a = e.calendar).isInverseEra) === null || t === void 0) && t.call(a, e) && (r = -r), e.year += r;
}
function Wu(e) {
  for (; e.month < 1; )
    Vu(e, -1), e.month += e.calendar.getMonthsInYear(e);
  let r = 0;
  for (; e.month > (r = e.calendar.getMonthsInYear(e)); )
    e.month -= r, Vu(e, 1);
}
function uy(e) {
  for (; e.day < 1; )
    e.month--, Wu(e), e.day += e.calendar.getDaysInMonth(e);
  for (; e.day > e.calendar.getDaysInMonth(e); )
    e.day -= e.calendar.getDaysInMonth(e), e.month++, Wu(e);
}
function Sx(e) {
  e.month = Math.max(1, Math.min(e.calendar.getMonthsInYear(e), e.month)), e.day = Math.max(1, Math.min(e.calendar.getDaysInMonth(e), e.day));
}
function on(e) {
  e.calendar.constrainDate && e.calendar.constrainDate(e), e.year = Math.max(1, Math.min(e.calendar.getYearsInEra(e), e.year)), Sx(e);
}
function Cx(e) {
  let r = {};
  for (let t in e)
    typeof e[t] == "number" && (r[t] = -e[t]);
  return r;
}
function Fx(e, r) {
  return n0(e, Cx(r));
}
function Gl(e, r) {
  let t = e.copy();
  return r.era != null && (t.era = r.era), r.year != null && (t.year = r.year), r.month != null && (t.month = r.month), r.day != null && (t.day = r.day), on(t), t;
}
function ko(e, r) {
  let t = e.copy();
  return r.hour != null && (t.hour = r.hour), r.minute != null && (t.minute = r.minute), r.second != null && (t.second = r.second), r.millisecond != null && (t.millisecond = r.millisecond), cy(t), t;
}
function ly(e) {
  e.second += Math.floor(e.millisecond / 1e3), e.millisecond = Gs(e.millisecond, 1e3), e.minute += Math.floor(e.second / 60), e.second = Gs(e.second, 60), e.hour += Math.floor(e.minute / 60), e.minute = Gs(e.minute, 60);
  let r = Math.floor(e.hour / 24);
  return e.hour = Gs(e.hour, 24), r;
}
function cy(e) {
  e.millisecond = Math.max(0, Math.min(e.millisecond, 1e3)), e.second = Math.max(0, Math.min(e.second, 59)), e.minute = Math.max(0, Math.min(e.minute, 59)), e.hour = Math.max(0, Math.min(e.hour, 23));
}
function Gs(e, r) {
  let t = e % r;
  return t < 0 && (t += r), t;
}
function fy(e, r) {
  return e.hour += r.hours || 0, e.minute += r.minutes || 0, e.second += r.seconds || 0, e.millisecond += r.milliseconds || 0, ly(e);
}
function Kl(e, r, t, a) {
  let n = e.copy();
  switch (r) {
    case "era": {
      let o = e.calendar.getEras(), u = o.indexOf(e.era);
      if (u < 0)
        throw new Error("Invalid era: " + e.era);
      u = ia(u, t, 0, o.length - 1, a == null ? void 0 : a.round), n.era = o[u], on(n);
      break;
    }
    case "year":
      var i, s;
      !((i = (s = n.calendar).isInverseEra) === null || i === void 0) && i.call(s, n) && (t = -t), n.year = ia(e.year, t, -1 / 0, 9999, a == null ? void 0 : a.round), n.year === -1 / 0 && (n.year = 1), n.calendar.balanceYearMonth && n.calendar.balanceYearMonth(n, e);
      break;
    case "month":
      n.month = ia(e.month, t, 1, e.calendar.getMonthsInYear(e), a == null ? void 0 : a.round);
      break;
    case "day":
      n.day = ia(e.day, t, 1, e.calendar.getDaysInMonth(e), a == null ? void 0 : a.round);
      break;
    default:
      throw new Error("Unsupported field " + r);
  }
  return e.calendar.balanceDate && e.calendar.balanceDate(n), on(n), n;
}
function Ax(e, r, t, a) {
  let n = e.copy();
  switch (r) {
    case "hour": {
      let i = e.hour, s = 0, o = 23;
      if ((a == null ? void 0 : a.hourCycle) === 12) {
        let u = i >= 12;
        s = u ? 12 : 0, o = u ? 23 : 11;
      }
      n.hour = ia(i, t, s, o, a == null ? void 0 : a.round);
      break;
    }
    case "minute":
      n.minute = ia(e.minute, t, 0, 59, a == null ? void 0 : a.round);
      break;
    case "second":
      n.second = ia(e.second, t, 0, 59, a == null ? void 0 : a.round);
      break;
    case "millisecond":
      n.millisecond = ia(e.millisecond, t, 0, 999, a == null ? void 0 : a.round);
      break;
    default:
      throw new Error("Unsupported field " + r);
  }
  return n;
}
function ia(e, r, t, a, n = !1) {
  if (n) {
    e += Math.sign(r), e < t && (e = a);
    let i = Math.abs(r);
    r > 0 ? e = Math.ceil(e / i) * i : e = Math.floor(e / i) * i, e > a && (e = t);
  } else
    e += r, e < t ? e = a - (t - e - 1) : e > a && (e = t + (e - a - 1));
  return e;
}
function Rx(e, r) {
  let t;
  if (r.years != null && r.years !== 0 || r.months != null && r.months !== 0 || r.weeks != null && r.weeks !== 0 || r.days != null && r.days !== 0) {
    let n = n0(ti(e), {
      years: r.years,
      months: r.months,
      weeks: r.weeks,
      days: r.days
    });
    t = ra(n, e.timeZone);
  } else
    t = ri(e) - e.offset;
  t += r.milliseconds || 0, t += (r.seconds || 0) * 1e3, t += (r.minutes || 0) * 6e4, t += (r.hours || 0) * 36e5;
  let a = na(t, e.timeZone);
  return Rt(a, e.calendar);
}
function dy(e, r) {
  return Rx(e, Cx(r));
}
function hy(e, r, t, a) {
  switch (r) {
    case "hour": {
      let n = 0, i = 23;
      if ((a == null ? void 0 : a.hourCycle) === 12) {
        let m = e.hour >= 12;
        n = m ? 12 : 0, i = m ? 23 : 11;
      }
      let s = ti(e), o = Rt(ko(s, {
        hour: n
      }), new ei()), u = [
        ra(o, e.timeZone, "earlier"),
        ra(o, e.timeZone, "later")
      ].filter((m) => na(m, e.timeZone).day === o.day)[0], l = Rt(ko(s, {
        hour: i
      }), new ei()), c = [
        ra(l, e.timeZone, "earlier"),
        ra(l, e.timeZone, "later")
      ].filter((m) => na(m, e.timeZone).day === l.day).pop(), f = ri(e) - e.offset, h = Math.floor(f / ki), d = f % ki;
      return f = ia(h, t, Math.floor(u / ki), Math.floor(c / ki), a == null ? void 0 : a.round) * ki + d, Rt(na(f, e.timeZone), e.calendar);
    }
    case "minute":
    case "second":
    case "millisecond":
      return Ax(e, r, t, a);
    case "era":
    case "year":
    case "month":
    case "day": {
      let n = Kl(ti(e), r, t, a), i = ra(n, e.timeZone);
      return Rt(na(i, e.timeZone), e.calendar);
    }
    default:
      throw new Error("Unsupported field " + r);
  }
}
function xy(e, r, t) {
  let a = ti(e), n = ko(Gl(a, r), r);
  if (n.compare(a) === 0)
    return e;
  let i = ra(n, e.timeZone, t);
  return Rt(na(i, e.timeZone), e.calendar);
}
function my(e) {
  return `${String(e.hour).padStart(2, "0")}:${String(e.minute).padStart(2, "0")}:${String(e.second).padStart(2, "0")}${e.millisecond ? String(e.millisecond / 1e3).slice(1) : ""}`;
}
function Ix(e) {
  let r = Rt(e, new ei()), t;
  return r.era === "BC" ? t = r.year === 1 ? "0000" : "-" + String(Math.abs(1 - r.year)).padStart(6, "00") : t = String(r.year).padStart(4, "0"), `${t}-${String(r.month).padStart(2, "0")}-${String(r.day).padStart(2, "0")}`;
}
function Bx(e) {
  return `${Ix(e)}T${my(e)}`;
}
function py(e) {
  let r = Math.sign(e) < 0 ? "-" : "+";
  e = Math.abs(e);
  let t = Math.floor(e / 36e5), a = e % 36e5 / 6e4;
  return `${r}${String(t).padStart(2, "0")}:${String(a).padStart(2, "0")}`;
}
function vy(e) {
  return `${Bx(e)}${py(e.offset)}[${e.timeZone}]`;
}
function Yl(e) {
  let r = typeof e[0] == "object" ? e.shift() : new ei(), t;
  if (typeof e[0] == "string")
    t = e.shift();
  else {
    let s = r.getEras();
    t = s[s.length - 1];
  }
  let a = e.shift(), n = e.shift(), i = e.shift();
  return [
    r,
    t,
    a,
    n,
    i
  ];
}
var gy = /* @__PURE__ */ new WeakMap();
let Px = class Hu {
  /** Returns a copy of this date. */
  copy() {
    return this.era ? new Hu(this.calendar, this.era, this.year, this.month, this.day) : new Hu(this.calendar, this.year, this.month, this.day);
  }
  /** Returns a new `CalendarDate` with the given duration added to it. */
  add(r) {
    return n0(this, r);
  }
  /** Returns a new `CalendarDate` with the given duration subtracted from it. */
  subtract(r) {
    return Fx(this, r);
  }
  /** Returns a new `CalendarDate` with the given fields set to the provided values. Other fields will be constrained accordingly. */
  set(r) {
    return Gl(this, r);
  }
  /**
  * Returns a new `CalendarDate` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(r, t, a) {
    return Kl(this, r, t, a);
  }
  /** Converts the date to a native JavaScript Date object, with the time set to midnight in the given time zone. */
  toDate(r) {
    return Tx(this, r);
  }
  /** Converts the date to an ISO 8601 formatted string. */
  toString() {
    return Ix(this);
  }
  /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */
  compare(r) {
    return $x(this, r);
  }
  constructor(...r) {
    at(this, gy, {
      writable: !0,
      value: void 0
    });
    let [t, a, n, i, s] = Yl(r);
    this.calendar = t, this.era = a, this.year = n, this.month = i, this.day = s, on(this);
  }
};
var yy = /* @__PURE__ */ new WeakMap();
let by = class ju {
  /** Returns a copy of this date. */
  copy() {
    return this.era ? new ju(this.calendar, this.era, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond) : new ju(this.calendar, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond);
  }
  /** Returns a new `CalendarDateTime` with the given duration added to it. */
  add(r) {
    return n0(this, r);
  }
  /** Returns a new `CalendarDateTime` with the given duration subtracted from it. */
  subtract(r) {
    return Fx(this, r);
  }
  /** Returns a new `CalendarDateTime` with the given fields set to the provided values. Other fields will be constrained accordingly. */
  set(r) {
    return Gl(ko(this, r), r);
  }
  /**
  * Returns a new `CalendarDateTime` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(r, t, a) {
    switch (r) {
      case "era":
      case "year":
      case "month":
      case "day":
        return Kl(this, r, t, a);
      default:
        return Ax(this, r, t, a);
    }
  }
  /** Converts the date to a native JavaScript Date object in the given time zone. */
  toDate(r, t) {
    return Tx(this, r, t);
  }
  /** Converts the date to an ISO 8601 formatted string. */
  toString() {
    return Bx(this);
  }
  /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */
  compare(r) {
    let t = $x(this, r);
    return t === 0 ? J3(this, ti(r)) : t;
  }
  constructor(...r) {
    at(this, yy, {
      writable: !0,
      value: void 0
    });
    let [t, a, n, i, s] = Yl(r);
    this.calendar = t, this.era = a, this.year = n, this.month = i, this.day = s, this.hour = r.shift() || 0, this.minute = r.shift() || 0, this.second = r.shift() || 0, this.millisecond = r.shift() || 0, on(this);
  }
};
var wy = /* @__PURE__ */ new WeakMap();
let Mx = class zu {
  /** Returns a copy of this date. */
  copy() {
    return this.era ? new zu(this.calendar, this.era, this.year, this.month, this.day, this.timeZone, this.offset, this.hour, this.minute, this.second, this.millisecond) : new zu(this.calendar, this.year, this.month, this.day, this.timeZone, this.offset, this.hour, this.minute, this.second, this.millisecond);
  }
  /** Returns a new `ZonedDateTime` with the given duration added to it. */
  add(r) {
    return Rx(this, r);
  }
  /** Returns a new `ZonedDateTime` with the given duration subtracted from it. */
  subtract(r) {
    return dy(this, r);
  }
  /** Returns a new `ZonedDateTime` with the given fields set to the provided values. Other fields will be constrained accordingly. */
  set(r, t) {
    return xy(this, r, t);
  }
  /**
  * Returns a new `ZonedDateTime` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(r, t, a) {
    return hy(this, r, t, a);
  }
  /** Converts the date to a native JavaScript Date object. */
  toDate() {
    return sy(this);
  }
  /** Converts the date to an ISO 8601 formatted string, including the UTC offset and time zone identifier. */
  toString() {
    return vy(this);
  }
  /** Converts the date to an ISO 8601 formatted string in UTC. */
  toAbsoluteString() {
    return this.toDate().toISOString();
  }
  /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */
  compare(r) {
    return this.toDate().getTime() - iy(r, this.timeZone).toDate().getTime();
  }
  constructor(...r) {
    at(this, wy, {
      writable: !0,
      value: void 0
    });
    let [t, a, n, i, s] = Yl(r), o = r.shift(), u = r.shift();
    this.calendar = t, this.era = a, this.year = n, this.month = i, this.day = s, this.timeZone = o, this.offset = u, this.hour = r.shift() || 0, this.minute = r.shift() || 0, this.second = r.shift() || 0, this.millisecond = r.shift() || 0, on(this);
  }
};
function Ox(e) {
  return e && e.__esModule ? e.default : e;
}
const Xl = /* @__PURE__ */ new WeakMap();
function Xi(e) {
  return (e == null ? void 0 : e.calendar.identifier) === "gregory" && e.era === "BC" ? "short" : void 0;
}
function _y(e) {
  let r = fi(Ox(gs), "@react-aria/calendar"), t, a;
  var n;
  "highlightedRange" in e ? { start: t, end: a } = e.highlightedRange || {} : t = a = (n = e.value) !== null && n !== void 0 ? n : void 0;
  let i = Qn({
    weekday: "long",
    month: "long",
    year: "numeric",
    day: "numeric",
    era: Xi(t) || Xi(a),
    timeZone: e.timeZone
  }), s = "anchorDate" in e ? e.anchorDate : null;
  return Pe(() => {
    if (!s && t && a)
      if (ct(t, a)) {
        let o = i.format(t.toDate(e.timeZone));
        return r.format("selectedDateDescription", {
          date: o
        });
      } else {
        let o = Ku(i, r, t, a, e.timeZone);
        return r.format("selectedRangeDescription", {
          dateRange: o
        });
      }
    return "";
  }, [
    t,
    a,
    s,
    e.timeZone,
    r,
    i
  ]);
}
function Gu(e, r, t, a) {
  let n = fi(Ox(gs), "@react-aria/calendar"), i = Xi(e) || Xi(r), s = Qn({
    month: "long",
    year: "numeric",
    era: i,
    calendar: e.calendar.identifier,
    timeZone: t
  }), o = Qn({
    month: "long",
    year: "numeric",
    day: "numeric",
    era: i,
    calendar: e.calendar.identifier,
    timeZone: t
  });
  return Pe(() => {
    if (ct(e, q3(e))) {
      if (ct(r, Af(e)))
        return s.format(e.toDate(t));
      if (ct(r, Af(r)))
        return a ? Ku(s, n, e, r, t) : s.formatRange(e.toDate(t), r.toDate(t));
    }
    return a ? Ku(o, n, e, r, t) : o.formatRange(e.toDate(t), r.toDate(t));
  }, [
    e,
    r,
    s,
    o,
    n,
    t,
    a
  ]);
}
function Ku(e, r, t, a, n) {
  let i = e.formatRangeToParts(t.toDate(n), a.toDate(n)), s = -1;
  for (let l = 0; l < i.length; l++) {
    let c = i[l];
    if (c.source === "shared" && c.type === "literal")
      s = l;
    else if (c.source === "endRange")
      break;
  }
  let o = "", u = "";
  for (let l = 0; l < i.length; l++)
    l < s ? o += i[l].value : l > s && (u += i[l].value);
  return r.format("dateRange", {
    startDate: o,
    endDate: u
  });
}
const Lx = 7e3;
let Nt = null;
function To(e, r = "assertive", t = Lx) {
  Nt ? Nt.announce(e, r, t) : (Nt = new $y(), (typeof IS_REACT_ACT_ENVIRONMENT == "boolean" ? IS_REACT_ACT_ENVIRONMENT : typeof jest < "u") ? Nt.announce(e, r, t) : setTimeout(() => {
    Nt != null && Nt.isAttached() && (Nt == null || Nt.announce(e, r, t));
  }, 100));
}
class $y {
  isAttached() {
    var r;
    return (r = this.node) === null || r === void 0 ? void 0 : r.isConnected;
  }
  createLog(r) {
    let t = document.createElement("div");
    return t.setAttribute("role", "log"), t.setAttribute("aria-live", r), t.setAttribute("aria-relevant", "additions"), t;
  }
  destroy() {
    this.node && (document.body.removeChild(this.node), this.node = null);
  }
  announce(r, t = "assertive", a = Lx) {
    var n, i;
    if (!this.node)
      return;
    let s = document.createElement("div");
    typeof r == "object" ? (s.setAttribute("role", "img"), s.setAttribute("aria-labelledby", r["aria-labelledby"])) : s.textContent = r, t === "assertive" ? (n = this.assertiveLog) === null || n === void 0 || n.appendChild(s) : (i = this.politeLog) === null || i === void 0 || i.appendChild(s), r !== "" && setTimeout(() => {
      s.remove();
    }, a);
  }
  clear(r) {
    this.node && ((!r || r === "assertive") && this.assertiveLog && (this.assertiveLog.innerHTML = ""), (!r || r === "polite") && this.politeLog && (this.politeLog.innerHTML = ""));
  }
  constructor() {
    this.node = null, this.assertiveLog = null, this.politeLog = null, typeof document < "u" && (this.node = document.createElement("div"), this.node.dataset.liveAnnouncer = "true", Object.assign(this.node.style, {
      border: 0,
      clip: "rect(0 0 0 0)",
      clipPath: "inset(50%)",
      height: "1px",
      margin: "-1px",
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      width: "1px",
      whiteSpace: "nowrap"
    }), this.assertiveLog = this.createLog("assertive"), this.node.appendChild(this.assertiveLog), this.politeLog = this.createLog("polite"), this.node.appendChild(this.politeLog), document.body.prepend(this.node));
  }
}
function Dy(e) {
  return e && e.__esModule ? e.default : e;
}
function Nx(e, r) {
  let t = fi(Dy(gs), "@react-aria/calendar"), a = lt(e), n = Gu(r.visibleRange.start, r.visibleRange.end, r.timeZone, !1), i = Gu(r.visibleRange.start, r.visibleRange.end, r.timeZone, !0);
  pf(() => {
    r.isFocused || To(i);
  }, [
    i
  ]);
  let s = _y(r);
  pf(() => {
    s && To(s, "polite", 4e3);
  }, [
    s
  ]);
  let o = wo([
    !!e.errorMessage,
    e.isInvalid,
    e.validationState
  ]);
  Xl.set(r, {
    ariaLabel: e["aria-label"],
    ariaLabelledBy: e["aria-labelledby"],
    errorMessageId: o,
    selectedDateDescription: s
  });
  let [u, l] = He(!1), c = e.isDisabled || r.isNextVisibleRangeInvalid();
  c && u && (l(!1), r.setFocused(!0));
  let [f, h] = He(!1), d = e.isDisabled || r.isPreviousVisibleRangeInvalid();
  d && f && (h(!1), r.setFocused(!0));
  let m = Pl({
    id: e.id,
    "aria-label": [
      e["aria-label"],
      i
    ].filter(Boolean).join(", "),
    "aria-labelledby": e["aria-labelledby"]
  });
  return {
    calendarProps: Nr(a, m, {
      role: "application",
      "aria-describedby": e["aria-describedby"] || void 0
    }),
    nextButtonProps: {
      onPress: () => r.focusNextPage(),
      "aria-label": t.format("next"),
      isDisabled: c,
      onFocusChange: l
    },
    prevButtonProps: {
      onPress: () => r.focusPreviousPage(),
      "aria-label": t.format("previous"),
      isDisabled: d,
      onFocusChange: h
    },
    errorMessageProps: {
      id: o
    },
    title: n
  };
}
function Ey(e, r) {
  return Nx(e, r);
}
function ky(e, r, t) {
  let a = Nx(e, r), n = ze(!1), i = ze(typeof window < "u" ? window : null);
  return O0(i, "pointerdown", (o) => {
    n.current = o.width === 0 && o.height === 0;
  }), O0(i, "pointerup", (o) => {
    if (n.current) {
      n.current = !1;
      return;
    }
    if (r.setDragging(!1), !r.anchorDate)
      return;
    let u = o.target;
    t.current && t.current.contains(document.activeElement) && (!t.current.contains(u) || !u.closest('button, [role="button"]')) && r.selectFocusedDate();
  }), a.calendarProps.onBlur = (o) => {
    t.current && (!o.relatedTarget || !t.current.contains(o.relatedTarget)) && r.anchorDate && r.selectFocusedDate();
  }, O0(t, "touchmove", (o) => {
    r.isDragging && o.preventDefault();
  }, {
    passive: !1,
    capture: !0
  }), a;
}
function Ty(e, r) {
  let { startDate: t = r.visibleRange.start, endDate: a = r.visibleRange.end } = e, { direction: n } = Kt(), i = (d) => {
    switch (d.key) {
      case "Enter":
      case " ":
        d.preventDefault(), r.selectFocusedDate();
        break;
      case "PageUp":
        d.preventDefault(), d.stopPropagation(), r.focusPreviousSection(d.shiftKey);
        break;
      case "PageDown":
        d.preventDefault(), d.stopPropagation(), r.focusNextSection(d.shiftKey);
        break;
      case "End":
        d.preventDefault(), d.stopPropagation(), r.focusSectionEnd();
        break;
      case "Home":
        d.preventDefault(), d.stopPropagation(), r.focusSectionStart();
        break;
      case "ArrowLeft":
        d.preventDefault(), d.stopPropagation(), n === "rtl" ? r.focusNextDay() : r.focusPreviousDay();
        break;
      case "ArrowUp":
        d.preventDefault(), d.stopPropagation(), r.focusPreviousRow();
        break;
      case "ArrowRight":
        d.preventDefault(), d.stopPropagation(), n === "rtl" ? r.focusPreviousDay() : r.focusNextDay();
        break;
      case "ArrowDown":
        d.preventDefault(), d.stopPropagation(), r.focusNextRow();
        break;
      case "Escape":
        "setAnchorDate" in r && (d.preventDefault(), r.setAnchorDate(null));
        break;
    }
  }, s = Gu(t, a, r.timeZone, !0), { ariaLabel: o, ariaLabelledBy: u } = Xl.get(r), l = Pl({
    "aria-label": [
      o,
      s
    ].filter(Boolean).join(", "),
    "aria-labelledby": u
  }), c = Qn({
    weekday: e.weekdayStyle || "narrow",
    timeZone: r.timeZone
  }), { locale: f } = Kt(), h = Pe(() => {
    let d = Q3(_x(r.timeZone), f);
    return [
      ...new Array(7).keys()
    ].map((m) => {
      let p = d.add({
        days: m
      }).toDate(r.timeZone);
      return c.format(p);
    });
  }, [
    f,
    r.timeZone,
    c
  ]);
  return {
    gridProps: Nr(l, {
      role: "grid",
      "aria-readonly": r.isReadOnly || void 0,
      "aria-disabled": r.isDisabled || void 0,
      "aria-multiselectable": "highlightedRange" in r || void 0,
      onKeyDown: i,
      onFocus: () => r.setFocused(!0),
      onBlur: () => r.setFocused(!1)
    }),
    headerProps: {
      // Column headers are hidden to screen readers to make navigating with a touch screen reader easier.
      // The day names are already included in the label of each cell, so there's no need to announce them twice.
      "aria-hidden": !0
    },
    weekDays: h
  };
}
function Sy(e) {
  return e && e.__esModule ? e.default : e;
}
function Cy(e, r, t) {
  let { date: a, isDisabled: n } = e, { errorMessageId: i, selectedDateDescription: s } = Xl.get(r), o = fi(Sy(gs), "@react-aria/calendar"), u = Qn({
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
    era: Xi(a),
    timeZone: r.timeZone
  }), l = r.isSelected(a), c = r.isCellFocused(a);
  n = n || r.isCellDisabled(a);
  let f = r.isCellUnavailable(a), h = !n && !f, d = r.isValueInvalid && !!("highlightedRange" in r ? !r.anchorDate && r.highlightedRange && a.compare(r.highlightedRange.start) >= 0 && a.compare(r.highlightedRange.end) <= 0 : r.value && ct(r.value, a));
  d && (l = !0), a = p1(a, K3);
  let m = Pe(() => a.toDate(r.timeZone), [
    a,
    r.timeZone
  ]), x = Y3(a, r.timeZone), p = Pe(() => {
    let T = "";
    return "highlightedRange" in r && r.value && !r.anchorDate && (ct(a, r.value.start) || ct(a, r.value.end)) && (T = s + ", "), T += u.format(m), x ? T = o.format(l ? "todayDateSelected" : "todayDate", {
      date: T
    }) : l && (T = o.format("dateSelected", {
      date: T
    })), r.minValue && ct(a, r.minValue) ? T += ", " + o.format("minimumDate") : r.maxValue && ct(a, r.maxValue) && (T += ", " + o.format("maximumDate")), T;
  }, [
    u,
    m,
    o,
    l,
    x,
    a,
    r,
    s
  ]), w = "";
  "anchorDate" in r && c && !r.isReadOnly && h && (r.anchorDate ? w = o.format("finishRangeSelectionPrompt") : w = o.format("startRangeSelectionPrompt"));
  let D = Ml(w), y = ze(!1), B = ze(!1), L = ze(void 0), { pressProps: U, isPressed: k } = Ll({
    // When dragging to select a range, we don't want dragging over the original anchor
    // again to trigger onPressStart. Cancel presses immediately when the pointer exits.
    shouldCancelOnPointerExit: "anchorDate" in r && !!r.anchorDate,
    preventFocusOnPress: !0,
    isDisabled: !h || r.isReadOnly,
    onPressStart(T) {
      if (r.isReadOnly) {
        r.setFocusedDate(a);
        return;
      }
      if ("highlightedRange" in r && !r.anchorDate && (T.pointerType === "mouse" || T.pointerType === "touch")) {
        if (r.highlightedRange && !d) {
          if (ct(a, r.highlightedRange.start)) {
            r.setAnchorDate(r.highlightedRange.end), r.setFocusedDate(a), r.setDragging(!0), B.current = !0;
            return;
          } else if (ct(a, r.highlightedRange.end)) {
            r.setAnchorDate(r.highlightedRange.start), r.setFocusedDate(a), r.setDragging(!0), B.current = !0;
            return;
          }
        }
        let C = () => {
          r.setDragging(!0), L.current = void 0, r.selectDate(a), r.setFocusedDate(a), y.current = !0;
        };
        T.pointerType === "touch" ? L.current = setTimeout(C, 200) : C();
      }
    },
    onPressEnd() {
      B.current = !1, y.current = !1, clearTimeout(L.current), L.current = void 0;
    },
    onPress() {
      !("anchorDate" in r) && !r.isReadOnly && (r.selectDate(a), r.setFocusedDate(a));
    },
    onPressUp(T) {
      if (!r.isReadOnly && ("anchorDate" in r && L.current && (r.selectDate(a), r.setFocusedDate(a)), "anchorDate" in r))
        if (B.current)
          r.setAnchorDate(a);
        else if (r.anchorDate && !y.current)
          r.selectDate(a), r.setFocusedDate(a);
        else if (T.pointerType === "keyboard" && !r.anchorDate) {
          r.selectDate(a);
          let C = a.add({
            days: 1
          });
          r.isInvalid(C) && (C = a.subtract({
            days: 1
          })), r.isInvalid(C) || r.setFocusedDate(C);
        } else
          T.pointerType === "virtual" && (r.selectDate(a), r.setFocusedDate(a));
    }
  }), v;
  n || (v = ct(a, r.focusedDate) ? 0 : -1), Hr(() => {
    c && t.current && (ka(t.current), F1() !== "pointer" && document.activeElement === t.current && r3(t.current, {
      containingElement: Jg(t.current)
    }));
  }, [
    c,
    t
  ]);
  let b = Qn({
    day: "numeric",
    timeZone: r.timeZone,
    calendar: a.calendar.identifier
  }), A = Pe(() => b.formatToParts(m).find((T) => T.type === "day").value, [
    b,
    m
  ]);
  return {
    cellProps: {
      role: "gridcell",
      "aria-disabled": !h || void 0,
      "aria-selected": l || void 0,
      "aria-invalid": d || void 0
    },
    buttonProps: Nr(U, {
      onFocus() {
        n || r.setFocusedDate(a);
      },
      tabIndex: v,
      role: "button",
      "aria-disabled": !h || void 0,
      "aria-label": p,
      "aria-invalid": d || void 0,
      "aria-describedby": [
        d ? i : void 0,
        D["aria-describedby"]
      ].filter(Boolean).join(" ") || void 0,
      onPointerEnter(T) {
        "highlightDate" in r && (T.pointerType !== "touch" || r.isDragging) && h && r.highlightDate(a);
      },
      onPointerDown(T) {
        "releasePointerCapture" in T.target && T.target.releasePointerCapture(T.pointerId);
      },
      onContextMenu(T) {
        T.preventDefault();
      }
    }),
    isPressed: k,
    isFocused: c,
    isSelected: l,
    isDisabled: n,
    isUnavailable: f,
    isOutsideVisibleRange: a.compare(r.visibleRange.start) < 0 || a.compare(r.visibleRange.end) > 0,
    isInvalid: d,
    formattedDate: A
  };
}
const Zl = {
  badInput: !1,
  customError: !1,
  patternMismatch: !1,
  rangeOverflow: !1,
  rangeUnderflow: !1,
  stepMismatch: !1,
  tooLong: !1,
  tooShort: !1,
  typeMismatch: !1,
  valueMissing: !1,
  valid: !0
};
({
  ...Zl
});
const Pf = {
  isInvalid: !1,
  validationDetails: Zl,
  validationErrors: []
};
Ze({});
const Yu = "__formValidationState" + Date.now();
function Mf(...e) {
  let r = /* @__PURE__ */ new Set(), t = !1, a = {
    ...Zl
  };
  for (let s of e) {
    var n, i;
    for (let o of s.validationErrors)
      r.add(o);
    t || (t = s.isInvalid);
    for (let o in a)
      (n = a)[i = o] || (n[i] = s.validationDetails[o]);
  }
  return a.valid = !t, {
    isInvalid: t,
    validationErrors: [
      ...r
    ],
    validationDetails: a
  };
}
function Fy(e) {
  let { id: r, label: t, "aria-labelledby": a, "aria-label": n, labelElementType: i = "label" } = e;
  r = Pt(r);
  let s = Pt(), o = {};
  t ? (a = a ? `${s} ${a}` : s, o = {
    id: s,
    htmlFor: i === "label" ? r : void 0
  }) : !a && !n && console.warn("If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility");
  let u = Pl({
    id: r,
    "aria-label": n,
    "aria-labelledby": a
  });
  return {
    labelProps: o,
    fieldProps: u
  };
}
function Ux(e) {
  let { description: r, errorMessage: t, isInvalid: a, validationState: n } = e, { labelProps: i, fieldProps: s } = Fy(e), o = wo([
    !!r,
    !!t,
    a,
    n
  ]), u = wo([
    !!r,
    !!t,
    a,
    n
  ]);
  return s = Nr(s, {
    "aria-describedby": [
      o,
      // Use aria-describedby for error message because aria-errormessage is unsupported using VoiceOver or NVDA. See https://github.com/adobe/react-spectrum/issues/1346#issuecomment-740136268
      u,
      e["aria-describedby"]
    ].filter(Boolean).join(" ") || void 0
  }), {
    labelProps: i,
    fieldProps: s,
    descriptionProps: {
      id: o
    },
    errorMessageProps: {
      id: u
    }
  };
}
const Of = {
  border: 0,
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  width: "1px",
  whiteSpace: "nowrap"
};
function Ay(e = {}) {
  let { style: r, isFocusable: t } = e, [a, n] = He(!1), { focusWithinProps: i } = a0({
    isDisabled: !t,
    onFocusWithinChange: (o) => n(o)
  }), s = Pe(() => a ? r : r ? {
    ...Of,
    ...r
  } : Of, [
    a
  ]);
  return {
    visuallyHiddenProps: {
      ...i,
      style: s
    }
  };
}
function So(e) {
  let { children: r, elementType: t = "div", isFocusable: a, style: n, ...i } = e, { visuallyHiddenProps: s } = Ay(e);
  return /* @__PURE__ */ ye.createElement(t, Nr(i, s), r);
}
const Ry = /* @__PURE__ */ ye.createContext(null);
function Iy() {
  let e = Sr(Ry), r = e == null ? void 0 : e.setContain;
  fa(() => {
    r == null || r(!0);
  }, [
    r
  ]);
}
var Vx = {};
Vx = {
  calendar: "التقويم",
  day: "يوم",
  dayPeriod: "ص/م",
  endDate: "تاريخ الانتهاء",
  era: "العصر",
  hour: "الساعات",
  minute: "الدقائق",
  month: "الشهر",
  second: "الثواني",
  selectedDateDescription: (e) => `تاريخ محدد: ${e.date}`,
  selectedRangeDescription: (e) => `المدى الزمني المحدد: ${e.startDate} إلى ${e.endDate}`,
  selectedTimeDescription: (e) => `الوقت المحدد: ${e.time}`,
  startDate: "تاريخ البدء",
  timeZoneName: "التوقيت",
  weekday: "اليوم",
  year: "السنة"
};
var Wx = {};
Wx = {
  calendar: "Календар",
  day: "ден",
  dayPeriod: "пр.об./сл.об.",
  endDate: "Крайна дата",
  era: "ера",
  hour: "час",
  minute: "минута",
  month: "месец",
  second: "секунда",
  selectedDateDescription: (e) => `Избрана дата: ${e.date}`,
  selectedRangeDescription: (e) => `Избран диапазон: ${e.startDate} до ${e.endDate}`,
  selectedTimeDescription: (e) => `Избрано време: ${e.time}`,
  startDate: "Начална дата",
  timeZoneName: "часова зона",
  weekday: "ден от седмицата",
  year: "година"
};
var Hx = {};
Hx = {
  calendar: "Kalendář",
  day: "den",
  dayPeriod: "část dne",
  endDate: "Konečné datum",
  era: "letopočet",
  hour: "hodina",
  minute: "minuta",
  month: "měsíc",
  second: "sekunda",
  selectedDateDescription: (e) => `Vybrané datum: ${e.date}`,
  selectedRangeDescription: (e) => `Vybrané období: ${e.startDate} až ${e.endDate}`,
  selectedTimeDescription: (e) => `Vybraný čas: ${e.time}`,
  startDate: "Počáteční datum",
  timeZoneName: "časové pásmo",
  weekday: "den v týdnu",
  year: "rok"
};
var jx = {};
jx = {
  calendar: "Kalender",
  day: "dag",
  dayPeriod: "AM/PM",
  endDate: "Slutdato",
  era: "æra",
  hour: "time",
  minute: "minut",
  month: "måned",
  second: "sekund",
  selectedDateDescription: (e) => `Valgt dato: ${e.date}`,
  selectedRangeDescription: (e) => `Valgt interval: ${e.startDate} til ${e.endDate}`,
  selectedTimeDescription: (e) => `Valgt tidspunkt: ${e.time}`,
  startDate: "Startdato",
  timeZoneName: "tidszone",
  weekday: "ugedag",
  year: "år"
};
var zx = {};
zx = {
  calendar: "Kalender",
  day: "Tag",
  dayPeriod: "Tageshälfte",
  endDate: "Enddatum",
  era: "Epoche",
  hour: "Stunde",
  minute: "Minute",
  month: "Monat",
  second: "Sekunde",
  selectedDateDescription: (e) => `Ausgewähltes Datum: ${e.date}`,
  selectedRangeDescription: (e) => `Ausgewählter Bereich: ${e.startDate} bis ${e.endDate}`,
  selectedTimeDescription: (e) => `Ausgewählte Zeit: ${e.time}`,
  startDate: "Anfangsdatum",
  timeZoneName: "Zeitzone",
  weekday: "Wochentag",
  year: "Jahr"
};
var Gx = {};
Gx = {
  calendar: "Ημερολόγιο",
  day: "ημέρα",
  dayPeriod: "π.μ./μ.μ.",
  endDate: "Ημερομηνία λήξης",
  era: "περίοδος",
  hour: "ώρα",
  minute: "λεπτό",
  month: "μήνας",
  second: "δευτερόλεπτο",
  selectedDateDescription: (e) => `Επιλεγμένη ημερομηνία: ${e.date}`,
  selectedRangeDescription: (e) => `Επιλεγμένο εύρος: ${e.startDate} έως ${e.endDate}`,
  selectedTimeDescription: (e) => `Επιλεγμένη ώρα: ${e.time}`,
  startDate: "Ημερομηνία έναρξης",
  timeZoneName: "ζώνη ώρας",
  weekday: "καθημερινή",
  year: "έτος"
};
var Kx = {};
Kx = {
  era: "era",
  year: "year",
  month: "month",
  day: "day",
  hour: "hour",
  minute: "minute",
  second: "second",
  dayPeriod: "AM/PM",
  calendar: "Calendar",
  startDate: "Start Date",
  endDate: "End Date",
  weekday: "day of the week",
  timeZoneName: "time zone",
  selectedDateDescription: (e) => `Selected Date: ${e.date}`,
  selectedRangeDescription: (e) => `Selected Range: ${e.startDate} to ${e.endDate}`,
  selectedTimeDescription: (e) => `Selected Time: ${e.time}`
};
var Yx = {};
Yx = {
  calendar: "Calendario",
  day: "día",
  dayPeriod: "a. m./p. m.",
  endDate: "Fecha final",
  era: "era",
  hour: "hora",
  minute: "minuto",
  month: "mes",
  second: "segundo",
  selectedDateDescription: (e) => `Fecha seleccionada: ${e.date}`,
  selectedRangeDescription: (e) => `Rango seleccionado: ${e.startDate} a ${e.endDate}`,
  selectedTimeDescription: (e) => `Hora seleccionada: ${e.time}`,
  startDate: "Fecha de inicio",
  timeZoneName: "zona horaria",
  weekday: "día de la semana",
  year: "año"
};
var Xx = {};
Xx = {
  calendar: "Kalender",
  day: "päev",
  dayPeriod: "enne/pärast lõunat",
  endDate: "Lõppkuupäev",
  era: "ajastu",
  hour: "tund",
  minute: "minut",
  month: "kuu",
  second: "sekund",
  selectedDateDescription: (e) => `Valitud kuupäev: ${e.date}`,
  selectedRangeDescription: (e) => `Valitud vahemik: ${e.startDate} kuni ${e.endDate}`,
  selectedTimeDescription: (e) => `Valitud aeg: ${e.time}`,
  startDate: "Alguskuupäev",
  timeZoneName: "ajavöönd",
  weekday: "nädalapäev",
  year: "aasta"
};
var Zx = {};
Zx = {
  calendar: "Kalenteri",
  day: "päivä",
  dayPeriod: "vuorokaudenaika",
  endDate: "Päättymispäivä",
  era: "aikakausi",
  hour: "tunti",
  minute: "minuutti",
  month: "kuukausi",
  second: "sekunti",
  selectedDateDescription: (e) => `Valittu päivämäärä: ${e.date}`,
  selectedRangeDescription: (e) => `Valittu aikaväli: ${e.startDate} – ${e.endDate}`,
  selectedTimeDescription: (e) => `Valittu aika: ${e.time}`,
  startDate: "Alkamispäivä",
  timeZoneName: "aikavyöhyke",
  weekday: "viikonpäivä",
  year: "vuosi"
};
var Jx = {};
Jx = {
  calendar: "Calendrier",
  day: "jour",
  dayPeriod: "cadran",
  endDate: "Date de fin",
  era: "ère",
  hour: "heure",
  minute: "minute",
  month: "mois",
  second: "seconde",
  selectedDateDescription: (e) => `Date sélectionnée : ${e.date}`,
  selectedRangeDescription: (e) => `Plage sélectionnée : ${e.startDate} au ${e.endDate}`,
  selectedTimeDescription: (e) => `Heure choisie : ${e.time}`,
  startDate: "Date de début",
  timeZoneName: "fuseau horaire",
  weekday: "jour de la semaine",
  year: "année"
};
var qx = {};
qx = {
  calendar: "לוח שנה",
  day: "יום",
  dayPeriod: "לפנה״צ/אחה״צ",
  endDate: "תאריך סיום",
  era: "תקופה",
  hour: "שעה",
  minute: "דקה",
  month: "חודש",
  second: "שנייה",
  selectedDateDescription: (e) => `תאריך נבחר: ${e.date}`,
  selectedRangeDescription: (e) => `טווח נבחר: ${e.startDate} עד ${e.endDate}`,
  selectedTimeDescription: (e) => `זמן נבחר: ${e.time}`,
  startDate: "תאריך התחלה",
  timeZoneName: "אזור זמן",
  weekday: "יום בשבוע",
  year: "שנה"
};
var Qx = {};
Qx = {
  calendar: "Kalendar",
  day: "dan",
  dayPeriod: "AM/PM",
  endDate: "Datum završetka",
  era: "era",
  hour: "sat",
  minute: "minuta",
  month: "mjesec",
  second: "sekunda",
  selectedDateDescription: (e) => `Odabrani datum: ${e.date}`,
  selectedRangeDescription: (e) => `Odabrani raspon: ${e.startDate} do ${e.endDate}`,
  selectedTimeDescription: (e) => `Odabrano vrijeme: ${e.time}`,
  startDate: "Datum početka",
  timeZoneName: "vremenska zona",
  weekday: "dan u tjednu",
  year: "godina"
};
var e4 = {};
e4 = {
  calendar: "Naptár",
  day: "nap",
  dayPeriod: "napszak",
  endDate: "Befejező dátum",
  era: "éra",
  hour: "óra",
  minute: "perc",
  month: "hónap",
  second: "másodperc",
  selectedDateDescription: (e) => `Kijelölt dátum: ${e.date}`,
  selectedRangeDescription: (e) => `Kijelölt tartomány: ${e.startDate}–${e.endDate}`,
  selectedTimeDescription: (e) => `Kijelölt idő: ${e.time}`,
  startDate: "Kezdő dátum",
  timeZoneName: "időzóna",
  weekday: "hét napja",
  year: "év"
};
var r4 = {};
r4 = {
  calendar: "Calendario",
  day: "giorno",
  dayPeriod: "AM/PM",
  endDate: "Data finale",
  era: "era",
  hour: "ora",
  minute: "minuto",
  month: "mese",
  second: "secondo",
  selectedDateDescription: (e) => `Data selezionata: ${e.date}`,
  selectedRangeDescription: (e) => `Intervallo selezionato: da ${e.startDate} a ${e.endDate}`,
  selectedTimeDescription: (e) => `Ora selezionata: ${e.time}`,
  startDate: "Data iniziale",
  timeZoneName: "fuso orario",
  weekday: "giorno della settimana",
  year: "anno"
};
var t4 = {};
t4 = {
  calendar: "カレンダー",
  day: "日",
  dayPeriod: "午前/午後",
  endDate: "終了日",
  era: "時代",
  hour: "時",
  minute: "分",
  month: "月",
  second: "秒",
  selectedDateDescription: (e) => `選択した日付 : ${e.date}`,
  selectedRangeDescription: (e) => `選択範囲 : ${e.startDate} から ${e.endDate}`,
  selectedTimeDescription: (e) => `選択した時間 : ${e.time}`,
  startDate: "開始日",
  timeZoneName: "タイムゾーン",
  weekday: "曜日",
  year: "年"
};
var a4 = {};
a4 = {
  calendar: "달력",
  day: "일",
  dayPeriod: "오전/오후",
  endDate: "종료일",
  era: "연호",
  hour: "시",
  minute: "분",
  month: "월",
  second: "초",
  selectedDateDescription: (e) => `선택 일자: ${e.date}`,
  selectedRangeDescription: (e) => `선택 범위: ${e.startDate} ~ ${e.endDate}`,
  selectedTimeDescription: (e) => `선택 시간: ${e.time}`,
  startDate: "시작일",
  timeZoneName: "시간대",
  weekday: "요일",
  year: "년"
};
var n4 = {};
n4 = {
  calendar: "Kalendorius",
  day: "diena",
  dayPeriod: "iki pietų / po pietų",
  endDate: "Pabaigos data",
  era: "era",
  hour: "valanda",
  minute: "minutė",
  month: "mėnuo",
  second: "sekundė",
  selectedDateDescription: (e) => `Pasirinkta data: ${e.date}`,
  selectedRangeDescription: (e) => `Pasirinktas intervalas: nuo ${e.startDate} iki ${e.endDate}`,
  selectedTimeDescription: (e) => `Pasirinktas laikas: ${e.time}`,
  startDate: "Pradžios data",
  timeZoneName: "laiko juosta",
  weekday: "savaitės diena",
  year: "metai"
};
var i4 = {};
i4 = {
  calendar: "Kalendārs",
  day: "diena",
  dayPeriod: "priekšpusdienā/pēcpusdienā",
  endDate: "Beigu datums",
  era: "ēra",
  hour: "stundas",
  minute: "minūtes",
  month: "mēnesis",
  second: "sekundes",
  selectedDateDescription: (e) => `Atlasītais datums: ${e.date}`,
  selectedRangeDescription: (e) => `Atlasītais diapazons: no ${e.startDate} līdz ${e.endDate}`,
  selectedTimeDescription: (e) => `Atlasītais laiks: ${e.time}`,
  startDate: "Sākuma datums",
  timeZoneName: "laika josla",
  weekday: "nedēļas diena",
  year: "gads"
};
var s4 = {};
s4 = {
  calendar: "Kalender",
  day: "dag",
  dayPeriod: "a.m./p.m.",
  endDate: "Sluttdato",
  era: "tidsalder",
  hour: "time",
  minute: "minutt",
  month: "måned",
  second: "sekund",
  selectedDateDescription: (e) => `Valgt dato: ${e.date}`,
  selectedRangeDescription: (e) => `Valgt område: ${e.startDate} til ${e.endDate}`,
  selectedTimeDescription: (e) => `Valgt tid: ${e.time}`,
  startDate: "Startdato",
  timeZoneName: "tidssone",
  weekday: "ukedag",
  year: "år"
};
var o4 = {};
o4 = {
  calendar: "Kalender",
  day: "dag",
  dayPeriod: "a.m./p.m.",
  endDate: "Einddatum",
  era: "tijdperk",
  hour: "uur",
  minute: "minuut",
  month: "maand",
  second: "seconde",
  selectedDateDescription: (e) => `Geselecteerde datum: ${e.date}`,
  selectedRangeDescription: (e) => `Geselecteerd bereik: ${e.startDate} tot ${e.endDate}`,
  selectedTimeDescription: (e) => `Geselecteerde tijd: ${e.time}`,
  startDate: "Startdatum",
  timeZoneName: "tijdzone",
  weekday: "dag van de week",
  year: "jaar"
};
var u4 = {};
u4 = {
  calendar: "Kalendarz",
  day: "dzień",
  dayPeriod: "rano / po południu / wieczorem",
  endDate: "Data końcowa",
  era: "era",
  hour: "godzina",
  minute: "minuta",
  month: "miesiąc",
  second: "sekunda",
  selectedDateDescription: (e) => `Wybrana data: ${e.date}`,
  selectedRangeDescription: (e) => `Wybrany zakres: ${e.startDate} do ${e.endDate}`,
  selectedTimeDescription: (e) => `Wybrany czas: ${e.time}`,
  startDate: "Data początkowa",
  timeZoneName: "strefa czasowa",
  weekday: "dzień tygodnia",
  year: "rok"
};
var l4 = {};
l4 = {
  calendar: "Calendário",
  day: "dia",
  dayPeriod: "AM/PM",
  endDate: "Data final",
  era: "era",
  hour: "hora",
  minute: "minuto",
  month: "mês",
  second: "segundo",
  selectedDateDescription: (e) => `Data selecionada: ${e.date}`,
  selectedRangeDescription: (e) => `Intervalo selecionado: ${e.startDate} a ${e.endDate}`,
  selectedTimeDescription: (e) => `Hora selecionada: ${e.time}`,
  startDate: "Data inicial",
  timeZoneName: "fuso horário",
  weekday: "dia da semana",
  year: "ano"
};
var c4 = {};
c4 = {
  calendar: "Calendário",
  day: "dia",
  dayPeriod: "am/pm",
  endDate: "Data de Término",
  era: "era",
  hour: "hora",
  minute: "minuto",
  month: "mês",
  second: "segundo",
  selectedDateDescription: (e) => `Data selecionada: ${e.date}`,
  selectedRangeDescription: (e) => `Intervalo selecionado: ${e.startDate} a ${e.endDate}`,
  selectedTimeDescription: (e) => `Hora selecionada: ${e.time}`,
  startDate: "Data de Início",
  timeZoneName: "fuso horário",
  weekday: "dia da semana",
  year: "ano"
};
var f4 = {};
f4 = {
  calendar: "Calendar",
  day: "zi",
  dayPeriod: "a.m/p.m.",
  endDate: "Dată final",
  era: "eră",
  hour: "oră",
  minute: "minut",
  month: "lună",
  second: "secundă",
  selectedDateDescription: (e) => `Dată selectată: ${e.date}`,
  selectedRangeDescription: (e) => `Interval selectat: de la ${e.startDate} până la ${e.endDate}`,
  selectedTimeDescription: (e) => `Ora selectată: ${e.time}`,
  startDate: "Dată început",
  timeZoneName: "fus orar",
  weekday: "ziua din săptămână",
  year: "an"
};
var d4 = {};
d4 = {
  calendar: "Календарь",
  day: "день",
  dayPeriod: "AM/PM",
  endDate: "Дата окончания",
  era: "эра",
  hour: "час",
  minute: "минута",
  month: "месяц",
  second: "секунда",
  selectedDateDescription: (e) => `Выбранная дата: ${e.date}`,
  selectedRangeDescription: (e) => `Выбранный диапазон: с ${e.startDate} по ${e.endDate}`,
  selectedTimeDescription: (e) => `Выбранное время: ${e.time}`,
  startDate: "Дата начала",
  timeZoneName: "часовой пояс",
  weekday: "день недели",
  year: "год"
};
var h4 = {};
h4 = {
  calendar: "Kalendár",
  day: "deň",
  dayPeriod: "AM/PM",
  endDate: "Dátum ukončenia",
  era: "letopočet",
  hour: "hodina",
  minute: "minúta",
  month: "mesiac",
  second: "sekunda",
  selectedDateDescription: (e) => `Vybratý dátum: ${e.date}`,
  selectedRangeDescription: (e) => `Vybratý rozsah: od ${e.startDate} do ${e.endDate}`,
  selectedTimeDescription: (e) => `Vybratý čas: ${e.time}`,
  startDate: "Dátum začatia",
  timeZoneName: "časové pásmo",
  weekday: "deň týždňa",
  year: "rok"
};
var x4 = {};
x4 = {
  calendar: "Koledar",
  day: "dan",
  dayPeriod: "dop/pop",
  endDate: "Datum konca",
  era: "doba",
  hour: "ura",
  minute: "minuta",
  month: "mesec",
  second: "sekunda",
  selectedDateDescription: (e) => `Izbrani datum: ${e.date}`,
  selectedRangeDescription: (e) => `Izbrano območje: ${e.startDate} do ${e.endDate}`,
  selectedTimeDescription: (e) => `Izbrani čas: ${e.time}`,
  startDate: "Datum začetka",
  timeZoneName: "časovni pas",
  weekday: "dan v tednu",
  year: "leto"
};
var m4 = {};
m4 = {
  calendar: "Kalendar",
  day: "дан",
  dayPeriod: "пре подне/по подне",
  endDate: "Datum završetka",
  era: "ера",
  hour: "сат",
  minute: "минут",
  month: "месец",
  second: "секунд",
  selectedDateDescription: (e) => `Izabrani datum: ${e.date}`,
  selectedRangeDescription: (e) => `Izabrani opseg: od ${e.startDate} do ${e.endDate}`,
  selectedTimeDescription: (e) => `Izabrano vreme: ${e.time}`,
  startDate: "Datum početka",
  timeZoneName: "временска зона",
  weekday: "дан у недељи",
  year: "година"
};
var p4 = {};
p4 = {
  calendar: "Kalender",
  day: "dag",
  dayPeriod: "fm/em",
  endDate: "Slutdatum",
  era: "era",
  hour: "timme",
  minute: "minut",
  month: "månad",
  second: "sekund",
  selectedDateDescription: (e) => `Valt datum: ${e.date}`,
  selectedRangeDescription: (e) => `Valt intervall: ${e.startDate} till ${e.endDate}`,
  selectedTimeDescription: (e) => `Vald tid: ${e.time}`,
  startDate: "Startdatum",
  timeZoneName: "tidszon",
  weekday: "veckodag",
  year: "år"
};
var v4 = {};
v4 = {
  calendar: "Takvim",
  day: "gün",
  dayPeriod: "ÖÖ/ÖS",
  endDate: "Bitiş Tarihi",
  era: "çağ",
  hour: "saat",
  minute: "dakika",
  month: "ay",
  second: "saniye",
  selectedDateDescription: (e) => `Seçilen Tarih: ${e.date}`,
  selectedRangeDescription: (e) => `Seçilen Aralık: ${e.startDate} - ${e.endDate}`,
  selectedTimeDescription: (e) => `Seçilen Zaman: ${e.time}`,
  startDate: "Başlangıç Tarihi",
  timeZoneName: "saat dilimi",
  weekday: "haftanın günü",
  year: "yıl"
};
var g4 = {};
g4 = {
  calendar: "Календар",
  day: "день",
  dayPeriod: "дп/пп",
  endDate: "Дата завершення",
  era: "ера",
  hour: "година",
  minute: "хвилина",
  month: "місяць",
  second: "секунда",
  selectedDateDescription: (e) => `Вибрана дата: ${e.date}`,
  selectedRangeDescription: (e) => `Вибраний діапазон: ${e.startDate} — ${e.endDate}`,
  selectedTimeDescription: (e) => `Вибраний час: ${e.time}`,
  startDate: "Дата початку",
  timeZoneName: "часовий пояс",
  weekday: "день тижня",
  year: "рік"
};
var y4 = {};
y4 = {
  calendar: "日历",
  day: "日",
  dayPeriod: "上午/下午",
  endDate: "结束日期",
  era: "纪元",
  hour: "小时",
  minute: "分钟",
  month: "月",
  second: "秒",
  selectedDateDescription: (e) => `选定的日期：${e.date}`,
  selectedRangeDescription: (e) => `选定的范围：${e.startDate} 至 ${e.endDate}`,
  selectedTimeDescription: (e) => `选定的时间：${e.time}`,
  startDate: "开始日期",
  timeZoneName: "时区",
  weekday: "工作日",
  year: "年"
};
var b4 = {};
b4 = {
  calendar: "日曆",
  day: "日",
  dayPeriod: "上午/下午",
  endDate: "結束日期",
  era: "纪元",
  hour: "小时",
  minute: "分钟",
  month: "月",
  second: "秒",
  selectedDateDescription: (e) => `選定的日期：${e.date}`,
  selectedRangeDescription: (e) => `選定的範圍：${e.startDate} 至 ${e.endDate}`,
  selectedTimeDescription: (e) => `選定的時間：${e.time}`,
  startDate: "開始日期",
  timeZoneName: "时区",
  weekday: "工作日",
  year: "年"
};
var Jl = {};
Jl = {
  "ar-AE": Vx,
  "bg-BG": Wx,
  "cs-CZ": Hx,
  "da-DK": jx,
  "de-DE": zx,
  "el-GR": Gx,
  "en-US": Kx,
  "es-ES": Yx,
  "et-EE": Xx,
  "fi-FI": Zx,
  "fr-FR": Jx,
  "he-IL": qx,
  "hr-HR": Qx,
  "hu-HU": e4,
  "it-IT": r4,
  "ja-JP": t4,
  "ko-KR": a4,
  "lt-LT": n4,
  "lv-LV": i4,
  "nb-NO": s4,
  "nl-NL": o4,
  "pl-PL": u4,
  "pt-BR": l4,
  "pt-PT": c4,
  "ro-RO": f4,
  "ru-RU": d4,
  "sk-SK": h4,
  "sl-SI": x4,
  "sr-SP": m4,
  "sv-SE": p4,
  "tr-TR": v4,
  "uk-UA": g4,
  "zh-CN": y4,
  "zh-TW": b4
};
function w4(e, r, t) {
  let { direction: a } = Kt(), n = Pe(() => Hl(r), [
    r
  ]), i = (u) => {
    if (u.currentTarget.contains(u.target) && (u.altKey && (u.key === "ArrowDown" || u.key === "ArrowUp") && "setOpen" in e && (u.preventDefault(), u.stopPropagation(), e.setOpen(!0)), !t))
      switch (u.key) {
        case "ArrowLeft":
          u.preventDefault(), u.stopPropagation(), a === "rtl" ? n.focusNext() : n.focusPrevious();
          break;
        case "ArrowRight":
          u.preventDefault(), u.stopPropagation(), a === "rtl" ? n.focusPrevious() : n.focusNext();
          break;
      }
  }, s = () => {
    var u;
    if (!r.current)
      return;
    let l = (u = window.event) === null || u === void 0 ? void 0 : u.target, c = Ai(r.current, {
      tabbable: !0
    });
    if (l && (c.currentNode = l, l = c.previousNode()), !l) {
      let f;
      do
        f = c.lastChild(), f && (l = f);
      while (f);
    }
    for (; l != null && l.hasAttribute("data-placeholder"); ) {
      let f = c.previousNode();
      if (f && f.hasAttribute("data-placeholder"))
        l = f;
      else
        break;
    }
    l && l.focus();
  }, { pressProps: o } = Ll({
    preventFocusOnPress: !0,
    allowTextSelectionOnPress: !0,
    onPressStart(u) {
      u.pointerType === "mouse" && s();
    },
    onPress(u) {
      u.pointerType !== "mouse" && s();
    }
  });
  return Nr(o, {
    onKeyDown: i
  });
}
const _4 = "__role_" + Date.now(), By = "__focusManager_" + Date.now();
function Py(e) {
  return e && e.__esModule ? e.default : e;
}
function My(e, r, t) {
  let a = Pt(), n = Pt(), i = Pt(), s = fi(Py(Jl), "@react-aria/datepicker"), { isInvalid: o, validationErrors: u, validationDetails: l } = r.displayValidation, { labelProps: c, fieldProps: f, descriptionProps: h, errorMessageProps: d } = Ux({
    ...e,
    labelElementType: "span",
    isInvalid: o,
    errorMessage: e.errorMessage || u
  }), m = w4(r, t), x = f["aria-labelledby"] || f.id, { locale: p } = Kt(), w = r.formatValue(p, {
    month: "long"
  }), D = w ? s.format("selectedDateDescription", {
    date: w
  }) : "", y = Ml(D), B = [
    y["aria-describedby"],
    f["aria-describedby"]
  ].filter(Boolean).join(" ") || void 0, L = lt(e), U = Pe(() => Hl(t), [
    t
  ]), { focusWithinProps: k } = a0({
    ...e,
    isDisabled: r.isOpen,
    onBlurWithin: e.onBlur,
    onFocusWithin: e.onFocus,
    onFocusWithinChange: e.onFocusChange
  });
  return {
    groupProps: Nr(L, m, f, y, k, {
      role: "group",
      "aria-disabled": e.isDisabled || null,
      "aria-labelledby": x,
      "aria-describedby": B,
      onKeyDown(v) {
        r.isOpen || e.onKeyDown && e.onKeyDown(v);
      },
      onKeyUp(v) {
        r.isOpen || e.onKeyUp && e.onKeyUp(v);
      }
    }),
    labelProps: {
      ...c,
      onClick: () => {
        U.focusFirst();
      }
    },
    fieldProps: {
      ...f,
      id: i,
      [_4]: "presentation",
      "aria-describedby": B,
      value: r.value,
      onChange: r.setValue,
      placeholderValue: e.placeholderValue,
      hideTimeZone: e.hideTimeZone,
      hourCycle: e.hourCycle,
      shouldForceLeadingZeros: e.shouldForceLeadingZeros,
      granularity: e.granularity,
      isDisabled: e.isDisabled,
      isReadOnly: e.isReadOnly,
      isRequired: e.isRequired,
      validationBehavior: e.validationBehavior,
      // DatePicker owns the validation state for the date field.
      [Yu]: r,
      autoFocus: e.autoFocus,
      name: e.name
    },
    descriptionProps: h,
    errorMessageProps: d,
    buttonProps: {
      ...y,
      id: a,
      "aria-haspopup": "dialog",
      "aria-label": s.format("calendar"),
      "aria-labelledby": `${a} ${x}`,
      "aria-describedby": B,
      "aria-expanded": r.isOpen,
      isDisabled: e.isDisabled || e.isReadOnly,
      onPress: () => r.setOpen(!0)
    },
    dialogProps: {
      id: n,
      "aria-labelledby": `${a} ${x}`
    },
    calendarProps: {
      autoFocus: !0,
      value: r.dateValue,
      onChange: r.setDateValue,
      minValue: e.minValue,
      maxValue: e.maxValue,
      isDisabled: e.isDisabled,
      isReadOnly: e.isReadOnly,
      isDateUnavailable: e.isDateUnavailable,
      defaultFocusedValue: r.dateValue ? void 0 : e.placeholderValue,
      isInvalid: r.isInvalid,
      errorMessage: typeof e.errorMessage == "function" ? e.errorMessage(r.displayValidation) : e.errorMessage || r.displayValidation.validationErrors.join(" ")
    },
    isInvalid: o,
    validationErrors: u,
    validationDetails: l
  };
}
function Oy(e) {
  return e && e.__esModule ? e.default : e;
}
function Ly(e, r, t) {
  var a, n, i;
  let s = fi(Oy(Jl), "@react-aria/datepicker"), { isInvalid: o, validationErrors: u, validationDetails: l } = r.displayValidation, { labelProps: c, fieldProps: f, descriptionProps: h, errorMessageProps: d } = Ux({
    ...e,
    labelElementType: "span",
    isInvalid: o,
    errorMessage: e.errorMessage || u
  }), m = f["aria-labelledby"] || f.id, { locale: x } = Kt(), p = r.formatValue(x, {
    month: "long"
  }), w = p ? s.format("selectedRangeDescription", {
    startDate: p.start,
    endDate: p.end
  }) : "", D = Ml(w), y = {
    "aria-label": s.format("startDate"),
    "aria-labelledby": m
  }, B = {
    "aria-label": s.format("endDate"),
    "aria-labelledby": m
  }, L = Pt(), U = Pt(), k = w4(r, t), v = [
    D["aria-describedby"],
    f["aria-describedby"]
  ].filter(Boolean).join(" ") || void 0, b = Pe(() => Hl(t, {
    // Exclude the button from the focus manager.
    accept: (W) => W.id !== L
  }), [
    t,
    L
  ]), A = {
    [By]: b,
    [_4]: "presentation",
    "aria-describedby": v,
    placeholderValue: e.placeholderValue,
    hideTimeZone: e.hideTimeZone,
    hourCycle: e.hourCycle,
    granularity: e.granularity,
    shouldForceLeadingZeros: e.shouldForceLeadingZeros,
    isDisabled: e.isDisabled,
    isReadOnly: e.isReadOnly,
    isRequired: e.isRequired,
    validationBehavior: e.validationBehavior
  }, T = lt(e), { focusWithinProps: C } = a0({
    ...e,
    isDisabled: r.isOpen,
    onBlurWithin: e.onBlur,
    onFocusWithin: e.onFocus,
    onFocusWithinChange: e.onFocusChange
  }), I = ze(Pf), Y = ze(Pf);
  var j, J;
  return {
    groupProps: Nr(T, k, f, D, C, {
      role: "group",
      "aria-disabled": e.isDisabled || null,
      "aria-describedby": v,
      onKeyDown(W) {
        r.isOpen || e.onKeyDown && e.onKeyDown(W);
      },
      onKeyUp(W) {
        r.isOpen || e.onKeyUp && e.onKeyUp(W);
      }
    }),
    labelProps: {
      ...c,
      onClick: () => {
        b.focusFirst();
      }
    },
    buttonProps: {
      ...D,
      id: L,
      "aria-haspopup": "dialog",
      "aria-label": s.format("calendar"),
      "aria-labelledby": `${L} ${m}`,
      "aria-describedby": v,
      "aria-expanded": r.isOpen,
      isDisabled: e.isDisabled || e.isReadOnly,
      onPress: () => r.setOpen(!0)
    },
    dialogProps: {
      id: U,
      "aria-labelledby": `${L} ${m}`
    },
    startFieldProps: {
      ...y,
      ...A,
      value: (j = (a = r.value) === null || a === void 0 ? void 0 : a.start) !== null && j !== void 0 ? j : null,
      onChange: (W) => r.setDateTime("start", W),
      autoFocus: e.autoFocus,
      name: e.startName,
      [Yu]: {
        realtimeValidation: r.realtimeValidation,
        displayValidation: r.displayValidation,
        updateValidation(W) {
          I.current = W, r.updateValidation(Mf(W, Y.current));
        },
        resetValidation: r.resetValidation,
        commitValidation: r.commitValidation
      }
    },
    endFieldProps: {
      ...B,
      ...A,
      value: (J = (n = r.value) === null || n === void 0 ? void 0 : n.end) !== null && J !== void 0 ? J : null,
      onChange: (W) => r.setDateTime("end", W),
      name: e.endName,
      [Yu]: {
        realtimeValidation: r.realtimeValidation,
        displayValidation: r.displayValidation,
        updateValidation(W) {
          Y.current = W, r.updateValidation(Mf(I.current, W));
        },
        resetValidation: r.resetValidation,
        commitValidation: r.commitValidation
      }
    },
    descriptionProps: h,
    errorMessageProps: d,
    calendarProps: {
      autoFocus: !0,
      value: !((i = r.dateRange) === null || i === void 0) && i.start && r.dateRange.end ? r.dateRange : null,
      onChange: r.setDateRange,
      minValue: e.minValue,
      maxValue: e.maxValue,
      isDisabled: e.isDisabled,
      isReadOnly: e.isReadOnly,
      isDateUnavailable: e.isDateUnavailable,
      allowsNonContiguousRanges: e.allowsNonContiguousRanges,
      defaultFocusedValue: r.dateRange ? void 0 : e.placeholderValue,
      isInvalid: r.isInvalid,
      errorMessage: typeof e.errorMessage == "function" ? e.errorMessage(r.displayValidation) : e.errorMessage || r.displayValidation.validationErrors.join(" ")
    },
    isInvalid: o,
    validationErrors: u,
    validationDetails: l
  };
}
function Ny(e, r) {
  let { role: t = "dialog" } = e, a = wo();
  a = e["aria-label"] ? void 0 : a;
  let n = ze(!1);
  return Hr(() => {
    if (r.current && !r.current.contains(document.activeElement)) {
      Eo(r.current);
      let i = setTimeout(() => {
        document.activeElement === r.current && (n.current = !0, r.current && (r.current.blur(), Eo(r.current)), n.current = !1);
      }, 500);
      return () => {
        clearTimeout(i);
      };
    }
  }, [
    r
  ]), Iy(), {
    dialogProps: {
      ...lt(e, {
        labelable: !0
      }),
      role: t,
      tabIndex: -1,
      "aria-labelledby": e["aria-labelledby"] || a,
      // Prevent blur events from reaching useOverlay, which may cause
      // popovers to close. Since focus is contained within the dialog,
      // we don't want this to occur due to the above useEffect.
      onBlur: (i) => {
        n.current && i.stopPropagation();
      }
    },
    titleProps: {
      id: a
    }
  };
}
const ql = /* @__PURE__ */ Ze({});
function Uy(e, r) {
  [e, r] = da(e, r, ql);
  let { elementType: t = "label", ...a } = e;
  return /* @__PURE__ */ ye.createElement(t, {
    className: "react-aria-Label",
    ...a,
    ref: r
  });
}
const $4 = /* @__PURE__ */ u1(Uy), Vy = /* @__PURE__ */ Ze(null), Wy = /* @__PURE__ */ new Set([
  "form",
  "formAction",
  "formEncType",
  "formMethod",
  "formNoValidate",
  "formTarget",
  "name",
  "value"
]), di = /* @__PURE__ */ Ze({});
function Hy(e, r) {
  [e, r] = da(e, r, di), e = jy(e);
  let t = e, { isPending: a } = t, { buttonProps: n, isPressed: i } = H3(e, r), { focusProps: s, isFocused: o, isFocusVisible: u } = vs(e), { hoverProps: l, isHovered: c } = Vl({
    ...e,
    isDisabled: e.isDisabled || a
  }), f = {
    isHovered: c,
    isPressed: (t.isPressed || i) && !a,
    isFocused: o,
    isFocusVisible: u,
    isDisabled: e.isDisabled || !1,
    isPending: a ?? !1
  }, h = Ua({
    ...e,
    values: f,
    defaultClassName: "react-aria-Button"
  }), d = Pt(n.id), m = Pt(), x = n["aria-labelledby"];
  a && (x ? x = `${x} ${m}` : n["aria-label"] && (x = `${d} ${m}`));
  let p = ze(a);
  return Hr(() => {
    let w = {
      "aria-labelledby": x || d
    };
    (!p.current && o && a || p.current && o && !a) && To(w, "assertive"), p.current = a;
  }, [
    a,
    o,
    x,
    d
  ]), /* @__PURE__ */ ye.createElement("button", {
    ...lt(e, {
      propNames: Wy
    }),
    ...Nr(n, s, l),
    ...h,
    id: d,
    ref: r,
    "aria-labelledby": x,
    slot: e.slot || void 0,
    "aria-disabled": a ? "true" : n["aria-disabled"],
    "data-disabled": e.isDisabled || void 0,
    "data-pressed": f.isPressed || void 0,
    "data-hovered": c || void 0,
    "data-focused": o || void 0,
    "data-pending": a || void 0,
    "data-focus-visible": u || void 0
  }, /* @__PURE__ */ ye.createElement(Vy.Provider, {
    value: {
      id: m
    }
  }, h.children));
}
function jy(e) {
  return e.isPending && (e.onPress = void 0, e.onPressStart = void 0, e.onPressEnd = void 0, e.onPressChange = void 0, e.onPressUp = void 0, e.onKeyDown = void 0, e.onKeyUp = void 0, e.onClick = void 0, e.href = void 0), e;
}
const Ln = /* @__PURE__ */ u1(Hy), i0 = /* @__PURE__ */ Ze({});
function Nn(e, r) {
  return e - r * Math.floor(e / r);
}
const D4 = 1721426;
function Ja(e, r, t, a) {
  r = ys(e, r);
  let n = r - 1, i = -2;
  return t <= 2 ? i = 0 : Ta(r) && (i = -1), D4 - 1 + 365 * n + Math.floor(n / 4) - Math.floor(n / 100) + Math.floor(n / 400) + Math.floor((367 * t - 362) / 12 + i + a);
}
function Ta(e) {
  return e % 4 === 0 && (e % 100 !== 0 || e % 400 === 0);
}
function ys(e, r) {
  return e === "BC" ? 1 - r : r;
}
function s0(e) {
  let r = "AD";
  return e <= 0 && (r = "BC", e = 1 - e), [
    r,
    e
  ];
}
const zy = {
  standard: [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
  ],
  leapyear: [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
  ]
};
let ha = class {
  fromJulianDay(r) {
    let t = r, a = t - D4, n = Math.floor(a / 146097), i = Nn(a, 146097), s = Math.floor(i / 36524), o = Nn(i, 36524), u = Math.floor(o / 1461), l = Nn(o, 1461), c = Math.floor(l / 365), f = n * 400 + s * 100 + u * 4 + c + (s !== 4 && c !== 4 ? 1 : 0), [h, d] = s0(f), m = t - Ja(h, d, 1, 1), x = 2;
    t < Ja(h, d, 3, 1) ? x = 0 : Ta(d) && (x = 1);
    let p = Math.floor(((m + x) * 12 + 373) / 367), w = t - Ja(h, d, p, 1) + 1;
    return new nt(h, d, p, w);
  }
  toJulianDay(r) {
    return Ja(r.era, r.year, r.month, r.day);
  }
  getDaysInMonth(r) {
    return zy[Ta(r.year) ? "leapyear" : "standard"][r.month - 1];
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getMonthsInYear(r) {
    return 12;
  }
  getDaysInYear(r) {
    return Ta(r.year) ? 366 : 365;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getYearsInEra(r) {
    return 9999;
  }
  getEras() {
    return [
      "BC",
      "AD"
    ];
  }
  isInverseEra(r) {
    return r.era === "BC";
  }
  balanceDate(r) {
    r.year <= 0 && (r.era = r.era === "BC" ? "AD" : "BC", r.year = 1 - r.year);
  }
  constructor() {
    this.identifier = "gregory";
  }
};
const Gy = {
  "001": 1,
  AD: 1,
  AE: 6,
  AF: 6,
  AI: 1,
  AL: 1,
  AM: 1,
  AN: 1,
  AR: 1,
  AT: 1,
  AU: 1,
  AX: 1,
  AZ: 1,
  BA: 1,
  BE: 1,
  BG: 1,
  BH: 6,
  BM: 1,
  BN: 1,
  BY: 1,
  CH: 1,
  CL: 1,
  CM: 1,
  CN: 1,
  CR: 1,
  CY: 1,
  CZ: 1,
  DE: 1,
  DJ: 6,
  DK: 1,
  DZ: 6,
  EC: 1,
  EE: 1,
  EG: 6,
  ES: 1,
  FI: 1,
  FJ: 1,
  FO: 1,
  FR: 1,
  GB: 1,
  GE: 1,
  GF: 1,
  GP: 1,
  GR: 1,
  HR: 1,
  HU: 1,
  IE: 1,
  IQ: 6,
  IR: 6,
  IS: 1,
  IT: 1,
  JO: 6,
  KG: 1,
  KW: 6,
  KZ: 1,
  LB: 1,
  LI: 1,
  LK: 1,
  LT: 1,
  LU: 1,
  LV: 1,
  LY: 6,
  MC: 1,
  MD: 1,
  ME: 1,
  MK: 1,
  MN: 1,
  MQ: 1,
  MV: 5,
  MY: 1,
  NL: 1,
  NO: 1,
  NZ: 1,
  OM: 6,
  PL: 1,
  QA: 6,
  RE: 1,
  RO: 1,
  RS: 1,
  RU: 1,
  SD: 6,
  SE: 1,
  SI: 1,
  SK: 1,
  SM: 1,
  SY: 6,
  TJ: 1,
  TM: 1,
  TR: 1,
  UA: 1,
  UY: 1,
  UZ: 1,
  VA: 1,
  VN: 1,
  XK: 1
};
function Lf(e, r) {
  return r = bs(r, e.calendar), e.era === r.era && e.year === r.year && e.month === r.month && e.day === r.day;
}
function Ky(e, r) {
  return r = bs(r, e.calendar), e = Xu(e), r = Xu(r), e.era === r.era && e.year === r.year && e.month === r.month;
}
function Yy(e, r) {
  let t = e.calendar.toJulianDay(e), a = Math.ceil(t + 1 - qy(r)) % 7;
  return a < 0 && (a += 7), a;
}
function E4(e, r) {
  return e.calendar.toJulianDay(e) - r.calendar.toJulianDay(r);
}
function Xy(e, r) {
  return Nf(e) - Nf(r);
}
function Nf(e) {
  return e.hour * 36e5 + e.minute * 6e4 + e.second * 1e3 + e.millisecond;
}
let K0 = null;
function k4() {
  return K0 == null && (K0 = new Intl.DateTimeFormat().resolvedOptions().timeZone), K0;
}
function Xu(e) {
  return e.subtract({
    days: e.day - 1
  });
}
function Zy(e) {
  return e.add({
    days: e.calendar.getDaysInMonth(e) - e.day
  });
}
const Uf = /* @__PURE__ */ new Map();
function Jy(e) {
  if (Intl.Locale) {
    let t = Uf.get(e);
    return t || (t = new Intl.Locale(e).maximize().region, t && Uf.set(e, t)), t;
  }
  let r = e.split("-")[1];
  return r === "u" ? void 0 : r;
}
function qy(e) {
  let r = Jy(e);
  return r && Gy[r] || 0;
}
function Qy(e, r) {
  let t = e.calendar.getDaysInMonth(e);
  return Math.ceil((Yy(Xu(e), r) + t) / 7);
}
function Vf(e) {
  e = bs(e, new ha());
  let r = ys(e.era, e.year);
  return T4(r, e.month, e.day, e.hour, e.minute, e.second, e.millisecond);
}
function T4(e, r, t, a, n, i, s) {
  let o = /* @__PURE__ */ new Date();
  return o.setUTCHours(a, n, i, s), o.setUTCFullYear(e, r - 1, t), o.getTime();
}
function Wf(e, r) {
  if (r === "UTC")
    return 0;
  if (e > 0 && r === k4())
    return new Date(e).getTimezoneOffset() * -6e4;
  let { year: t, month: a, day: n, hour: i, minute: s, second: o } = S4(e, r);
  return T4(t, a, n, i, s, o, 0) - Math.floor(e / 1e3) * 1e3;
}
const Hf = /* @__PURE__ */ new Map();
function S4(e, r) {
  let t = Hf.get(r);
  t || (t = new Intl.DateTimeFormat("en-US", {
    timeZone: r,
    hour12: !1,
    era: "short",
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  }), Hf.set(r, t));
  let a = t.formatToParts(new Date(e)), n = {};
  for (let i of a)
    i.type !== "literal" && (n[i.type] = i.value);
  return {
    // Firefox returns B instead of BC... https://bugzilla.mozilla.org/show_bug.cgi?id=1752253
    year: n.era === "BC" || n.era === "B" ? -n.year + 1 : +n.year,
    month: +n.month,
    day: +n.day,
    hour: n.hour === "24" ? 0 : +n.hour,
    minute: +n.minute,
    second: +n.second
  };
}
const jf = 864e5;
function eb(e, r, t, a) {
  return (t === a ? [
    t
  ] : [
    t,
    a
  ]).filter((i) => rb(e, r, i));
}
function rb(e, r, t) {
  let a = S4(t, r);
  return e.year === a.year && e.month === a.month && e.day === a.day && e.hour === a.hour && e.minute === a.minute && e.second === a.second;
}
function tb(e, r, t = "compatible") {
  let a = F4(e);
  if (r === "UTC")
    return Vf(a);
  if (r === k4() && t === "compatible") {
    a = bs(a, new ha());
    let u = /* @__PURE__ */ new Date(), l = ys(a.era, a.year);
    return u.setFullYear(l, a.month - 1, a.day), u.setHours(a.hour, a.minute, a.second, a.millisecond), u.getTime();
  }
  let n = Vf(a), i = Wf(n - jf, r), s = Wf(n + jf, r), o = eb(a, r, n - i, n - s);
  if (o.length === 1)
    return o[0];
  if (o.length > 1)
    switch (t) {
      case "compatible":
      case "earlier":
        return o[0];
      case "later":
        return o[o.length - 1];
      case "reject":
        throw new RangeError("Multiple possible absolute times found");
    }
  switch (t) {
    case "earlier":
      return Math.min(n - i, n - s);
    case "compatible":
    case "later":
      return Math.max(n - i, n - s);
    case "reject":
      throw new RangeError("No such absolute time found");
  }
}
function C4(e, r, t = "compatible") {
  return new Date(tb(e, r, t));
}
function F4(e, r) {
  let t = 0, a = 0, n = 0, i = 0;
  if ("timeZone" in e)
    ({ hour: t, minute: a, second: n, millisecond: i } = e);
  else if ("hour" in e && !r)
    return e;
  return r && ({ hour: t, minute: a, second: n, millisecond: i } = r), new xb(e.calendar, e.era, e.year, e.month, e.day, t, a, n, i);
}
function bs(e, r) {
  if (e.calendar.identifier === r.identifier)
    return e;
  let t = r.fromJulianDay(e.calendar.toJulianDay(e)), a = e.copy();
  return a.calendar = r, a.era = t.era, a.year = t.year, a.month = t.month, a.day = t.day, ai(a), a;
}
function Ql(e, r) {
  let t = e.copy(), a = "hour" in t ? ub(t, r) : 0;
  Zu(t, r.years || 0), t.calendar.balanceYearMonth && t.calendar.balanceYearMonth(t, e), t.month += r.months || 0, Ju(t), A4(t), t.day += (r.weeks || 0) * 7, t.day += r.days || 0, t.day += a, ab(t), t.calendar.balanceDate && t.calendar.balanceDate(t), t.year < 1 && (t.year = 1, t.month = 1, t.day = 1);
  let n = t.calendar.getYearsInEra(t);
  if (t.year > n) {
    var i, s;
    let u = (i = (s = t.calendar).isInverseEra) === null || i === void 0 ? void 0 : i.call(s, t);
    t.year = n, t.month = u ? 1 : t.calendar.getMonthsInYear(t), t.day = u ? 1 : t.calendar.getDaysInMonth(t);
  }
  t.month < 1 && (t.month = 1, t.day = 1);
  let o = t.calendar.getMonthsInYear(t);
  return t.month > o && (t.month = o, t.day = t.calendar.getDaysInMonth(t)), t.day = Math.max(1, Math.min(t.calendar.getDaysInMonth(t), t.day)), t;
}
function Zu(e, r) {
  var t, a;
  !((t = (a = e.calendar).isInverseEra) === null || t === void 0) && t.call(a, e) && (r = -r), e.year += r;
}
function Ju(e) {
  for (; e.month < 1; )
    Zu(e, -1), e.month += e.calendar.getMonthsInYear(e);
  let r = 0;
  for (; e.month > (r = e.calendar.getMonthsInYear(e)); )
    e.month -= r, Zu(e, 1);
}
function ab(e) {
  for (; e.day < 1; )
    e.month--, Ju(e), e.day += e.calendar.getDaysInMonth(e);
  for (; e.day > e.calendar.getDaysInMonth(e); )
    e.day -= e.calendar.getDaysInMonth(e), e.month++, Ju(e);
}
function A4(e) {
  e.month = Math.max(1, Math.min(e.calendar.getMonthsInYear(e), e.month)), e.day = Math.max(1, Math.min(e.calendar.getDaysInMonth(e), e.day));
}
function ai(e) {
  e.calendar.constrainDate && e.calendar.constrainDate(e), e.year = Math.max(1, Math.min(e.calendar.getYearsInEra(e), e.year)), A4(e);
}
function nb(e) {
  let r = {};
  for (let t in e)
    typeof e[t] == "number" && (r[t] = -e[t]);
  return r;
}
function R4(e, r) {
  return Ql(e, nb(r));
}
function I4(e, r) {
  let t = e.copy();
  return r.era != null && (t.era = r.era), r.year != null && (t.year = r.year), r.month != null && (t.month = r.month), r.day != null && (t.day = r.day), ai(t), t;
}
function ib(e, r) {
  let t = e.copy();
  return r.hour != null && (t.hour = r.hour), r.minute != null && (t.minute = r.minute), r.second != null && (t.second = r.second), r.millisecond != null && (t.millisecond = r.millisecond), ob(t), t;
}
function sb(e) {
  e.second += Math.floor(e.millisecond / 1e3), e.millisecond = Ks(e.millisecond, 1e3), e.minute += Math.floor(e.second / 60), e.second = Ks(e.second, 60), e.hour += Math.floor(e.minute / 60), e.minute = Ks(e.minute, 60);
  let r = Math.floor(e.hour / 24);
  return e.hour = Ks(e.hour, 24), r;
}
function ob(e) {
  e.millisecond = Math.max(0, Math.min(e.millisecond, 1e3)), e.second = Math.max(0, Math.min(e.second, 59)), e.minute = Math.max(0, Math.min(e.minute, 59)), e.hour = Math.max(0, Math.min(e.hour, 23));
}
function Ks(e, r) {
  let t = e % r;
  return t < 0 && (t += r), t;
}
function ub(e, r) {
  return e.hour += r.hours || 0, e.minute += r.minutes || 0, e.second += r.seconds || 0, e.millisecond += r.milliseconds || 0, sb(e);
}
function B4(e, r, t, a) {
  let n = e.copy();
  switch (r) {
    case "era": {
      let o = e.calendar.getEras(), u = o.indexOf(e.era);
      if (u < 0)
        throw new Error("Invalid era: " + e.era);
      u = Sa(u, t, 0, o.length - 1, a == null ? void 0 : a.round), n.era = o[u], ai(n);
      break;
    }
    case "year":
      var i, s;
      !((i = (s = n.calendar).isInverseEra) === null || i === void 0) && i.call(s, n) && (t = -t), n.year = Sa(e.year, t, -1 / 0, 9999, a == null ? void 0 : a.round), n.year === -1 / 0 && (n.year = 1), n.calendar.balanceYearMonth && n.calendar.balanceYearMonth(n, e);
      break;
    case "month":
      n.month = Sa(e.month, t, 1, e.calendar.getMonthsInYear(e), a == null ? void 0 : a.round);
      break;
    case "day":
      n.day = Sa(e.day, t, 1, e.calendar.getDaysInMonth(e), a == null ? void 0 : a.round);
      break;
    default:
      throw new Error("Unsupported field " + r);
  }
  return e.calendar.balanceDate && e.calendar.balanceDate(n), ai(n), n;
}
function lb(e, r, t, a) {
  let n = e.copy();
  switch (r) {
    case "hour": {
      let i = e.hour, s = 0, o = 23;
      if ((a == null ? void 0 : a.hourCycle) === 12) {
        let u = i >= 12;
        s = u ? 12 : 0, o = u ? 23 : 11;
      }
      n.hour = Sa(i, t, s, o, a == null ? void 0 : a.round);
      break;
    }
    case "minute":
      n.minute = Sa(e.minute, t, 0, 59, a == null ? void 0 : a.round);
      break;
    case "second":
      n.second = Sa(e.second, t, 0, 59, a == null ? void 0 : a.round);
      break;
    case "millisecond":
      n.millisecond = Sa(e.millisecond, t, 0, 999, a == null ? void 0 : a.round);
      break;
    default:
      throw new Error("Unsupported field " + r);
  }
  return n;
}
function Sa(e, r, t, a, n = !1) {
  if (n) {
    e += Math.sign(r), e < t && (e = a);
    let i = Math.abs(r);
    r > 0 ? e = Math.ceil(e / i) * i : e = Math.floor(e / i) * i, e > a && (e = t);
  } else
    e += r, e < t ? e = a - (t - e - 1) : e > a && (e = t + (e - a - 1));
  return e;
}
function cb(e) {
  return `${String(e.hour).padStart(2, "0")}:${String(e.minute).padStart(2, "0")}:${String(e.second).padStart(2, "0")}${e.millisecond ? String(e.millisecond / 1e3).slice(1) : ""}`;
}
function P4(e) {
  let r = bs(e, new ha()), t;
  return r.era === "BC" ? t = r.year === 1 ? "0000" : "-" + String(Math.abs(1 - r.year)).padStart(6, "00") : t = String(r.year).padStart(4, "0"), `${t}-${String(r.month).padStart(2, "0")}-${String(r.day).padStart(2, "0")}`;
}
function fb(e) {
  return `${P4(e)}T${cb(e)}`;
}
function M4(e) {
  let r = typeof e[0] == "object" ? e.shift() : new ha(), t;
  if (typeof e[0] == "string")
    t = e.shift();
  else {
    let s = r.getEras();
    t = s[s.length - 1];
  }
  let a = e.shift(), n = e.shift(), i = e.shift();
  return [
    r,
    t,
    a,
    n,
    i
  ];
}
var db = /* @__PURE__ */ new WeakMap();
let nt = class qu {
  /** Returns a copy of this date. */
  copy() {
    return this.era ? new qu(this.calendar, this.era, this.year, this.month, this.day) : new qu(this.calendar, this.year, this.month, this.day);
  }
  /** Returns a new `CalendarDate` with the given duration added to it. */
  add(r) {
    return Ql(this, r);
  }
  /** Returns a new `CalendarDate` with the given duration subtracted from it. */
  subtract(r) {
    return R4(this, r);
  }
  /** Returns a new `CalendarDate` with the given fields set to the provided values. Other fields will be constrained accordingly. */
  set(r) {
    return I4(this, r);
  }
  /**
  * Returns a new `CalendarDate` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(r, t, a) {
    return B4(this, r, t, a);
  }
  /** Converts the date to a native JavaScript Date object, with the time set to midnight in the given time zone. */
  toDate(r) {
    return C4(this, r);
  }
  /** Converts the date to an ISO 8601 formatted string. */
  toString() {
    return P4(this);
  }
  /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */
  compare(r) {
    return E4(this, r);
  }
  constructor(...r) {
    at(this, db, {
      writable: !0,
      value: void 0
    });
    let [t, a, n, i, s] = M4(r);
    this.calendar = t, this.era = a, this.year = n, this.month = i, this.day = s, ai(this);
  }
};
var hb = /* @__PURE__ */ new WeakMap();
let xb = class Qu {
  /** Returns a copy of this date. */
  copy() {
    return this.era ? new Qu(this.calendar, this.era, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond) : new Qu(this.calendar, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond);
  }
  /** Returns a new `CalendarDateTime` with the given duration added to it. */
  add(r) {
    return Ql(this, r);
  }
  /** Returns a new `CalendarDateTime` with the given duration subtracted from it. */
  subtract(r) {
    return R4(this, r);
  }
  /** Returns a new `CalendarDateTime` with the given fields set to the provided values. Other fields will be constrained accordingly. */
  set(r) {
    return I4(ib(this, r), r);
  }
  /**
  * Returns a new `CalendarDateTime` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(r, t, a) {
    switch (r) {
      case "era":
      case "year":
      case "month":
      case "day":
        return B4(this, r, t, a);
      default:
        return lb(this, r, t, a);
    }
  }
  /** Converts the date to a native JavaScript Date object in the given time zone. */
  toDate(r, t) {
    return C4(this, r, t);
  }
  /** Converts the date to an ISO 8601 formatted string. */
  toString() {
    return fb(this);
  }
  /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */
  compare(r) {
    let t = E4(this, r);
    return t === 0 ? Xy(this, F4(r)) : t;
  }
  constructor(...r) {
    at(this, hb, {
      writable: !0,
      value: void 0
    });
    let [t, a, n, i, s] = M4(r);
    this.calendar = t, this.era = a, this.year = n, this.month = i, this.day = s, this.hour = r.shift() || 0, this.minute = r.shift() || 0, this.second = r.shift() || 0, this.millisecond = r.shift() || 0, ai(this);
  }
};
const Un = [
  [
    1868,
    9,
    8
  ],
  [
    1912,
    7,
    30
  ],
  [
    1926,
    12,
    25
  ],
  [
    1989,
    1,
    8
  ],
  [
    2019,
    5,
    1
  ]
], mb = [
  [
    1912,
    7,
    29
  ],
  [
    1926,
    12,
    24
  ],
  [
    1989,
    1,
    7
  ],
  [
    2019,
    4,
    30
  ]
], ho = [
  1867,
  1911,
  1925,
  1988,
  2018
], $a = [
  "meiji",
  "taisho",
  "showa",
  "heisei",
  "reiwa"
];
function zf(e) {
  const r = Un.findIndex(([t, a, n]) => e.year < t || e.year === t && e.month < a || e.year === t && e.month === a && e.day < n);
  return r === -1 ? Un.length - 1 : r === 0 ? 0 : r - 1;
}
function Y0(e) {
  let r = ho[$a.indexOf(e.era)];
  if (!r)
    throw new Error("Unknown era: " + e.era);
  return new nt(e.year + r, e.month, e.day);
}
class pb extends ha {
  fromJulianDay(r) {
    let t = super.fromJulianDay(r), a = zf(t);
    return new nt(this, $a[a], t.year - ho[a], t.month, t.day);
  }
  toJulianDay(r) {
    return super.toJulianDay(Y0(r));
  }
  balanceDate(r) {
    let t = Y0(r), a = zf(t);
    $a[a] !== r.era && (r.era = $a[a], r.year = t.year - ho[a]), this.constrainDate(r);
  }
  constrainDate(r) {
    let t = $a.indexOf(r.era), a = mb[t];
    if (a != null) {
      let [n, i, s] = a, o = n - ho[t];
      r.year = Math.max(1, Math.min(o, r.year)), r.year === o && (r.month = Math.min(i, r.month), r.month === i && (r.day = Math.min(s, r.day)));
    }
    if (r.year === 1 && t >= 0) {
      let [, n, i] = Un[t];
      r.month = Math.max(n, r.month), r.month === n && (r.day = Math.max(i, r.day));
    }
  }
  getEras() {
    return $a;
  }
  getYearsInEra(r) {
    let t = $a.indexOf(r.era), a = Un[t], n = Un[t + 1];
    if (n == null)
      return 9999 - a[0] + 1;
    let i = n[0] - a[0];
    return (r.month < n[1] || r.month === n[1] && r.day < n[2]) && i++, i;
  }
  getDaysInMonth(r) {
    return super.getDaysInMonth(Y0(r));
  }
  getMinimumMonthInYear(r) {
    let t = Gf(r);
    return t ? t[1] : 1;
  }
  getMinimumDayInMonth(r) {
    let t = Gf(r);
    return t && r.month === t[1] ? t[2] : 1;
  }
  constructor(...r) {
    super(...r), this.identifier = "japanese";
  }
}
function Gf(e) {
  if (e.year === 1) {
    let r = $a.indexOf(e.era);
    return Un[r];
  }
}
const O4 = -543;
class vb extends ha {
  fromJulianDay(r) {
    let t = super.fromJulianDay(r), a = ys(t.era, t.year);
    return new nt(this, a - O4, t.month, t.day);
  }
  toJulianDay(r) {
    return super.toJulianDay(Kf(r));
  }
  getEras() {
    return [
      "BE"
    ];
  }
  getDaysInMonth(r) {
    return super.getDaysInMonth(Kf(r));
  }
  balanceDate() {
  }
  constructor(...r) {
    super(...r), this.identifier = "buddhist";
  }
}
function Kf(e) {
  let [r, t] = s0(e.year + O4);
  return new nt(r, t, e.month, e.day);
}
const Co = 1911;
function L4(e) {
  return e.era === "minguo" ? e.year + Co : 1 - e.year + Co;
}
function Yf(e) {
  let r = e - Co;
  return r > 0 ? [
    "minguo",
    r
  ] : [
    "before_minguo",
    1 - r
  ];
}
class gb extends ha {
  fromJulianDay(r) {
    let t = super.fromJulianDay(r), a = ys(t.era, t.year), [n, i] = Yf(a);
    return new nt(this, n, i, t.month, t.day);
  }
  toJulianDay(r) {
    return super.toJulianDay(Xf(r));
  }
  getEras() {
    return [
      "before_minguo",
      "minguo"
    ];
  }
  balanceDate(r) {
    let [t, a] = Yf(L4(r));
    r.era = t, r.year = a;
  }
  isInverseEra(r) {
    return r.era === "before_minguo";
  }
  getDaysInMonth(r) {
    return super.getDaysInMonth(Xf(r));
  }
  getYearsInEra(r) {
    return r.era === "before_minguo" ? 9999 : 9999 - Co;
  }
  constructor(...r) {
    super(...r), this.identifier = "roc";
  }
}
function Xf(e) {
  let [r, t] = s0(L4(e));
  return new nt(r, t, e.month, e.day);
}
const Zf = 1948320, Jf = [
  0,
  31,
  62,
  93,
  124,
  155,
  186,
  216,
  246,
  276,
  306,
  336
  // Esfand
];
class yb {
  fromJulianDay(r) {
    let t = r - Zf, a = 1 + Math.floor((33 * t + 3) / 12053), n = 365 * (a - 1) + Math.floor((8 * a + 21) / 33), i = t - n, s = i < 216 ? Math.floor(i / 31) : Math.floor((i - 6) / 30), o = i - Jf[s] + 1;
    return new nt(this, a, s + 1, o);
  }
  toJulianDay(r) {
    let t = Zf - 1 + 365 * (r.year - 1) + Math.floor((8 * r.year + 21) / 33);
    return t += Jf[r.month - 1], t += r.day, t;
  }
  getMonthsInYear() {
    return 12;
  }
  getDaysInMonth(r) {
    return r.month <= 6 ? 31 : r.month <= 11 || Nn(25 * r.year + 11, 33) < 8 ? 30 : 29;
  }
  getEras() {
    return [
      "AP"
    ];
  }
  getYearsInEra() {
    return 9377;
  }
  constructor() {
    this.identifier = "persian";
  }
}
const X0 = 78, qf = 80;
class bb extends ha {
  fromJulianDay(r) {
    let t = super.fromJulianDay(r), a = t.year - X0, n = r - Ja(t.era, t.year, 1, 1), i;
    n < qf ? (a--, i = Ta(t.year - 1) ? 31 : 30, n += i + 155 + 90 + 10) : (i = Ta(t.year) ? 31 : 30, n -= qf);
    let s, o;
    if (n < i)
      s = 1, o = n + 1;
    else {
      let u = n - i;
      u < 155 ? (s = Math.floor(u / 31) + 2, o = u % 31 + 1) : (u -= 155, s = Math.floor(u / 30) + 7, o = u % 30 + 1);
    }
    return new nt(this, a, s, o);
  }
  toJulianDay(r) {
    let t = r.year + X0, [a, n] = s0(t), i, s;
    return Ta(n) ? (i = 31, s = Ja(a, n, 3, 21)) : (i = 30, s = Ja(a, n, 3, 22)), r.month === 1 ? s + r.day - 1 : (s += i + Math.min(r.month - 2, 5) * 31, r.month >= 8 && (s += (r.month - 7) * 30), s += r.day - 1, s);
  }
  getDaysInMonth(r) {
    return r.month === 1 && Ta(r.year + X0) || r.month >= 2 && r.month <= 6 ? 31 : 30;
  }
  getYearsInEra() {
    return 9919;
  }
  getEras() {
    return [
      "saka"
    ];
  }
  balanceDate() {
  }
  constructor(...r) {
    super(...r), this.identifier = "indian";
  }
}
const Fo = 1948440, Qf = 1948439, $t = 1300, Tn = 1600, wb = 460322;
function Ao(e, r, t, a) {
  return a + Math.ceil(29.5 * (t - 1)) + (r - 1) * 354 + Math.floor((3 + 11 * r) / 30) + e - 1;
}
function N4(e, r, t) {
  let a = Math.floor((30 * (t - r) + 10646) / 10631), n = Math.min(12, Math.ceil((t - (29 + Ao(r, a, 1, 1))) / 29.5) + 1), i = t - Ao(r, a, n, 1) + 1;
  return new nt(e, a, n, i);
}
function ed(e) {
  return (14 + 11 * e) % 30 < 11;
}
class ec {
  fromJulianDay(r) {
    return N4(this, Fo, r);
  }
  toJulianDay(r) {
    return Ao(Fo, r.year, r.month, r.day);
  }
  getDaysInMonth(r) {
    let t = 29 + r.month % 2;
    return r.month === 12 && ed(r.year) && t++, t;
  }
  getMonthsInYear() {
    return 12;
  }
  getDaysInYear(r) {
    return ed(r.year) ? 355 : 354;
  }
  getYearsInEra() {
    return 9665;
  }
  getEras() {
    return [
      "AH"
    ];
  }
  constructor() {
    this.identifier = "islamic-civil";
  }
}
class _b extends ec {
  fromJulianDay(r) {
    return N4(this, Qf, r);
  }
  toJulianDay(r) {
    return Ao(Qf, r.year, r.month, r.day);
  }
  constructor(...r) {
    super(...r), this.identifier = "islamic-tbla";
  }
}
const $b = "qgpUDckO1AbqBmwDrQpVBakGkgepC9QF2gpcBS0NlQZKB1QLagutBa4ETwoXBYsGpQbVCtYCWwmdBE0KJg2VDawFtgm6AlsKKwWVCsoG6Qr0AnYJtgJWCcoKpAvSC9kF3AJtCU0FpQpSC6ULtAW2CVcFlwJLBaMGUgdlC2oFqworBZUMSg2lDcoF1gpXCasESwmlClILagt1BXYCtwhbBFUFqQW0BdoJ3QRuAjYJqgpUDbIN1QXaAlsJqwRVCkkLZAtxC7QFtQpVCiUNkg7JDtQG6QprCasEkwpJDaQNsg25CroEWworBZUKKgtVC1wFvQQ9Ah0JlQpKC1oLbQW2AjsJmwRVBqkGVAdqC2wFrQpVBSkLkgupC9QF2gpaBasKlQVJB2QHqgu1BbYCVgpNDiULUgtqC60FrgIvCZcESwalBqwG1gpdBZ0ETQoWDZUNqgW1BdoCWwmtBJUFygbkBuoK9QS2AlYJqgpUC9IL2QXqAm0JrQSVCkoLpQuyBbUJ1gSXCkcFkwZJB1ULagVrCisFiwpGDaMNygXWCtsEawJLCaUKUgtpC3UFdgG3CFsCKwVlBbQF2gntBG0BtgimClINqQ3UBdoKWwmrBFMGKQdiB6kLsgW1ClUFJQuSDckO0gbpCmsFqwRVCikNVA2qDbUJugQ7CpsETQqqCtUK2gJdCV4ELgqaDFUNsga5BroEXQotBZUKUguoC7QLuQXaAloJSgukDdEO6AZqC20FNQWVBkoNqA3UDdoGWwWdAisGFQtKC5ULqgWuCi4JjwwnBZUGqgbWCl0FnQI=";
let el, Vn;
function xo(e) {
  return wb + Vn[e - $t];
}
function Ii(e, r) {
  let t = e - $t, a = 1 << 11 - (r - 1);
  return el[t] & a ? 30 : 29;
}
function rd(e, r) {
  let t = xo(e);
  for (let a = 1; a < r; a++)
    t += Ii(e, a);
  return t;
}
function td(e) {
  return Vn[e + 1 - $t] - Vn[e - $t];
}
class Db extends ec {
  fromJulianDay(r) {
    let t = r - Fo, a = xo($t), n = xo(Tn);
    if (t < a || t > n)
      return super.fromJulianDay(r);
    {
      let i = $t - 1, s = 1, o = 1;
      for (; o > 0; ) {
        i++, o = t - xo(i) + 1;
        let u = td(i);
        if (o === u) {
          s = 12;
          break;
        } else if (o < u) {
          let l = Ii(i, s);
          for (s = 1; o > l; )
            o -= l, s++, l = Ii(i, s);
          break;
        }
      }
      return new nt(this, i, s, t - rd(i, s) + 1);
    }
  }
  toJulianDay(r) {
    return r.year < $t || r.year > Tn ? super.toJulianDay(r) : Fo + rd(r.year, r.month) + (r.day - 1);
  }
  getDaysInMonth(r) {
    return r.year < $t || r.year > Tn ? super.getDaysInMonth(r) : Ii(r.year, r.month);
  }
  getDaysInYear(r) {
    return r.year < $t || r.year > Tn ? super.getDaysInYear(r) : td(r.year);
  }
  constructor() {
    if (super(), this.identifier = "islamic-umalqura", el || (el = new Uint16Array(Uint8Array.from(atob($b), (r) => r.charCodeAt(0)).buffer)), !Vn) {
      Vn = new Uint32Array(Tn - $t + 1);
      let r = 0;
      for (let t = $t; t <= Tn; t++) {
        Vn[t - $t] = r;
        for (let a = 1; a <= 12; a++)
          r += Ii(t, a);
      }
    }
  }
}
const ad = 347997, U4 = 1080, V4 = 24 * U4, Eb = 29, kb = 12 * U4 + 793, Tb = Eb * V4 + kb;
function Ya(e) {
  return Nn(e * 7 + 1, 19) < 7;
}
function mo(e) {
  let r = Math.floor((235 * e - 234) / 19), t = 12084 + 13753 * r, a = r * 29 + Math.floor(t / 25920);
  return Nn(3 * (a + 1), 7) < 3 && (a += 1), a;
}
function Sb(e) {
  let r = mo(e - 1), t = mo(e);
  return mo(e + 1) - t === 356 ? 2 : t - r === 382 ? 1 : 0;
}
function Li(e) {
  return mo(e) + Sb(e);
}
function W4(e) {
  return Li(e + 1) - Li(e);
}
function Cb(e) {
  let r = W4(e);
  switch (r > 380 && (r -= 30), r) {
    case 353:
      return 0;
    case 354:
      return 1;
    case 355:
      return 2;
  }
}
function Ys(e, r) {
  if (r >= 6 && !Ya(e) && r++, r === 4 || r === 7 || r === 9 || r === 11 || r === 13)
    return 29;
  let t = Cb(e);
  return r === 2 ? t === 2 ? 30 : 29 : r === 3 ? t === 0 ? 29 : 30 : r === 6 ? Ya(e) ? 30 : 0 : 30;
}
class Fb {
  fromJulianDay(r) {
    let t = r - ad, a = t * V4 / Tb, n = Math.floor((19 * a + 234) / 235) + 1, i = Li(n), s = Math.floor(t - i);
    for (; s < 1; )
      n--, i = Li(n), s = Math.floor(t - i);
    let o = 1, u = 0;
    for (; u < s; )
      u += Ys(n, o), o++;
    o--, u -= Ys(n, o);
    let l = s - u;
    return new nt(this, n, o, l);
  }
  toJulianDay(r) {
    let t = Li(r.year);
    for (let a = 1; a < r.month; a++)
      t += Ys(r.year, a);
    return t + r.day + ad;
  }
  getDaysInMonth(r) {
    return Ys(r.year, r.month);
  }
  getMonthsInYear(r) {
    return Ya(r.year) ? 13 : 12;
  }
  getDaysInYear(r) {
    return W4(r.year);
  }
  getYearsInEra() {
    return 9999;
  }
  getEras() {
    return [
      "AM"
    ];
  }
  balanceYearMonth(r, t) {
    t.year !== r.year && (Ya(t.year) && !Ya(r.year) && t.month > 6 ? r.month-- : !Ya(t.year) && Ya(r.year) && t.month > 6 && r.month++);
  }
  constructor() {
    this.identifier = "hebrew";
  }
}
const rl = 1723856, nd = 1824665, tl = 5500;
function Ro(e, r, t, a) {
  return e + 365 * r + Math.floor(r / 4) + 30 * (t - 1) + a - 1;
}
function rc(e, r) {
  let t = Math.floor(4 * (r - e) / 1461), a = 1 + Math.floor((r - Ro(e, t, 1, 1)) / 30), n = r + 1 - Ro(e, t, a, 1);
  return [
    t,
    a,
    n
  ];
}
function H4(e) {
  return Math.floor(e % 4 / 3);
}
function j4(e, r) {
  return r % 13 !== 0 ? 30 : H4(e) + 5;
}
class tc {
  fromJulianDay(r) {
    let [t, a, n] = rc(rl, r), i = "AM";
    return t <= 0 && (i = "AA", t += tl), new nt(this, i, t, a, n);
  }
  toJulianDay(r) {
    let t = r.year;
    return r.era === "AA" && (t -= tl), Ro(rl, t, r.month, r.day);
  }
  getDaysInMonth(r) {
    return j4(r.year, r.month);
  }
  getMonthsInYear() {
    return 13;
  }
  getDaysInYear(r) {
    return 365 + H4(r.year);
  }
  getYearsInEra(r) {
    return r.era === "AA" ? 9999 : 9991;
  }
  getEras() {
    return [
      "AA",
      "AM"
    ];
  }
  constructor() {
    this.identifier = "ethiopic";
  }
}
class Ab extends tc {
  fromJulianDay(r) {
    let [t, a, n] = rc(rl, r);
    return t += tl, new nt(this, "AA", t, a, n);
  }
  getEras() {
    return [
      "AA"
    ];
  }
  getYearsInEra() {
    return 9999;
  }
  constructor(...r) {
    super(...r), this.identifier = "ethioaa";
  }
}
class Rb extends tc {
  fromJulianDay(r) {
    let [t, a, n] = rc(nd, r), i = "CE";
    return t <= 0 && (i = "BCE", t = 1 - t), new nt(this, i, t, a, n);
  }
  toJulianDay(r) {
    let t = r.year;
    return r.era === "BCE" && (t = 1 - t), Ro(nd, t, r.month, r.day);
  }
  getDaysInMonth(r) {
    let t = r.year;
    return r.era === "BCE" && (t = 1 - t), j4(t, r.month);
  }
  isInverseEra(r) {
    return r.era === "BCE";
  }
  balanceDate(r) {
    r.year <= 0 && (r.era = r.era === "BCE" ? "CE" : "BCE", r.year = 1 - r.year);
  }
  getEras() {
    return [
      "BCE",
      "CE"
    ];
  }
  getYearsInEra(r) {
    return r.era === "BCE" ? 9999 : 9715;
  }
  constructor(...r) {
    super(...r), this.identifier = "coptic";
  }
}
function z4(e) {
  switch (e) {
    case "buddhist":
      return new vb();
    case "ethiopic":
      return new tc();
    case "ethioaa":
      return new Ab();
    case "coptic":
      return new Rb();
    case "hebrew":
      return new Fb();
    case "indian":
      return new bb();
    case "islamic-civil":
      return new ec();
    case "islamic-tbla":
      return new _b();
    case "islamic-umalqura":
      return new Db();
    case "japanese":
      return new pb();
    case "persian":
      return new yb();
    case "roc":
      return new gb();
    case "gregory":
    default:
      return new ha();
  }
}
function Z0(e, r) {
  return e - r * Math.floor(e / r);
}
const G4 = 1721426;
function Xs(e, r, t, a) {
  r = ac(e, r);
  let n = r - 1, i = -2;
  return t <= 2 ? i = 0 : po(r) && (i = -1), G4 - 1 + 365 * n + Math.floor(n / 4) - Math.floor(n / 100) + Math.floor(n / 400) + Math.floor((367 * t - 362) / 12 + i + a);
}
function po(e) {
  return e % 4 === 0 && (e % 100 !== 0 || e % 400 === 0);
}
function ac(e, r) {
  return e === "BC" ? 1 - r : r;
}
function Ib(e) {
  let r = "AD";
  return e <= 0 && (r = "BC", e = 1 - e), [
    r,
    e
  ];
}
const Bb = {
  standard: [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
  ],
  leapyear: [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
  ]
};
let Ba = class {
  fromJulianDay(r) {
    let t = r, a = t - G4, n = Math.floor(a / 146097), i = Z0(a, 146097), s = Math.floor(i / 36524), o = Z0(i, 36524), u = Math.floor(o / 1461), l = Z0(o, 1461), c = Math.floor(l / 365), f = n * 400 + s * 100 + u * 4 + c + (s !== 4 && c !== 4 ? 1 : 0), [h, d] = Ib(f), m = t - Xs(h, d, 1, 1), x = 2;
    t < Xs(h, d, 3, 1) ? x = 0 : po(d) && (x = 1);
    let p = Math.floor(((m + x) * 12 + 373) / 367), w = t - Xs(h, d, p, 1) + 1;
    return new sm(h, d, p, w);
  }
  toJulianDay(r) {
    return Xs(r.era, r.year, r.month, r.day);
  }
  getDaysInMonth(r) {
    return Bb[po(r.year) ? "leapyear" : "standard"][r.month - 1];
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getMonthsInYear(r) {
    return 12;
  }
  getDaysInYear(r) {
    return po(r.year) ? 366 : 365;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getYearsInEra(r) {
    return 9999;
  }
  getEras() {
    return [
      "BC",
      "AD"
    ];
  }
  isInverseEra(r) {
    return r.era === "BC";
  }
  balanceDate(r) {
    r.year <= 0 && (r.era = r.era === "BC" ? "AD" : "BC", r.year = 1 - r.year);
  }
  constructor() {
    this.identifier = "gregory";
  }
};
const Pb = {
  "001": 1,
  AD: 1,
  AE: 6,
  AF: 6,
  AI: 1,
  AL: 1,
  AM: 1,
  AN: 1,
  AR: 1,
  AT: 1,
  AU: 1,
  AX: 1,
  AZ: 1,
  BA: 1,
  BE: 1,
  BG: 1,
  BH: 6,
  BM: 1,
  BN: 1,
  BY: 1,
  CH: 1,
  CL: 1,
  CM: 1,
  CN: 1,
  CR: 1,
  CY: 1,
  CZ: 1,
  DE: 1,
  DJ: 6,
  DK: 1,
  DZ: 6,
  EC: 1,
  EE: 1,
  EG: 6,
  ES: 1,
  FI: 1,
  FJ: 1,
  FO: 1,
  FR: 1,
  GB: 1,
  GE: 1,
  GF: 1,
  GP: 1,
  GR: 1,
  HR: 1,
  HU: 1,
  IE: 1,
  IQ: 6,
  IR: 6,
  IS: 1,
  IT: 1,
  JO: 6,
  KG: 1,
  KW: 6,
  KZ: 1,
  LB: 1,
  LI: 1,
  LK: 1,
  LT: 1,
  LU: 1,
  LV: 1,
  LY: 6,
  MC: 1,
  MD: 1,
  ME: 1,
  MK: 1,
  MN: 1,
  MQ: 1,
  MV: 5,
  MY: 1,
  NL: 1,
  NO: 1,
  NZ: 1,
  OM: 6,
  PL: 1,
  QA: 6,
  RE: 1,
  RO: 1,
  RS: 1,
  RU: 1,
  SD: 6,
  SE: 1,
  SI: 1,
  SK: 1,
  SM: 1,
  SY: 6,
  TJ: 1,
  TM: 1,
  TR: 1,
  UA: 1,
  UY: 1,
  UZ: 1,
  VA: 1,
  VN: 1,
  XK: 1
};
function Ti(e, r) {
  return r = Pr(r, e.calendar), e.era === r.era && e.year === r.year && e.month === r.month && e.day === r.day;
}
function id(e, r) {
  return e.calendar.identifier === r.calendar.identifier && e.era === r.era && e.year === r.year && e.month === r.month && e.day === r.day;
}
function K4(e, r) {
  let t = e.calendar.toJulianDay(e), a = Math.ceil(t + 1 - Hb(r)) % 7;
  return a < 0 && (a += 7), a;
}
function Mb(e) {
  return sa(Date.now(), e);
}
function Ob(e) {
  return Mt(Mb(e));
}
function Y4(e, r) {
  return e.calendar.toJulianDay(e) - r.calendar.toJulianDay(r);
}
function Lb(e, r) {
  return sd(e) - sd(r);
}
function sd(e) {
  return e.hour * 36e5 + e.minute * 6e4 + e.second * 1e3 + e.millisecond;
}
let J0 = null;
function X4() {
  return J0 == null && (J0 = new Intl.DateTimeFormat().resolvedOptions().timeZone), J0;
}
function nc(e) {
  return e.subtract({
    days: e.day - 1
  });
}
function Nb(e) {
  return e.add({
    days: e.calendar.getDaysInMonth(e) - e.day
  });
}
function Ub(e) {
  return nc(e.subtract({
    months: e.month - 1
  }));
}
function Io(e, r) {
  let t = K4(e, r);
  return e.subtract({
    days: t
  });
}
function Vb(e, r) {
  return Io(e, r).add({
    days: 6
  });
}
const od = /* @__PURE__ */ new Map();
function Wb(e) {
  if (Intl.Locale) {
    let t = od.get(e);
    return t || (t = new Intl.Locale(e).maximize().region, t && od.set(e, t)), t;
  }
  let r = e.split("-")[1];
  return r === "u" ? void 0 : r;
}
function Hb(e) {
  let r = Wb(e);
  return r && Pb[r] || 0;
}
function ic(e, r) {
  return e && r ? e.compare(r) <= 0 ? e : r : e || r;
}
function sc(e, r) {
  return e && r ? e.compare(r) >= 0 ? e : r : e || r;
}
function ni(e) {
  e = Pr(e, new Ba());
  let r = ac(e.era, e.year);
  return Z4(r, e.month, e.day, e.hour, e.minute, e.second, e.millisecond);
}
function Z4(e, r, t, a, n, i, s) {
  let o = /* @__PURE__ */ new Date();
  return o.setUTCHours(a, n, i, s), o.setUTCFullYear(e, r - 1, t), o.getTime();
}
function al(e, r) {
  if (r === "UTC")
    return 0;
  if (e > 0 && r === X4())
    return new Date(e).getTimezoneOffset() * -6e4;
  let { year: t, month: a, day: n, hour: i, minute: s, second: o } = J4(e, r);
  return Z4(t, a, n, i, s, o, 0) - Math.floor(e / 1e3) * 1e3;
}
const ud = /* @__PURE__ */ new Map();
function J4(e, r) {
  let t = ud.get(r);
  t || (t = new Intl.DateTimeFormat("en-US", {
    timeZone: r,
    hour12: !1,
    era: "short",
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  }), ud.set(r, t));
  let a = t.formatToParts(new Date(e)), n = {};
  for (let i of a)
    i.type !== "literal" && (n[i.type] = i.value);
  return {
    // Firefox returns B instead of BC... https://bugzilla.mozilla.org/show_bug.cgi?id=1752253
    year: n.era === "BC" || n.era === "B" ? -n.year + 1 : +n.year,
    month: +n.month,
    day: +n.day,
    hour: n.hour === "24" ? 0 : +n.hour,
    minute: +n.minute,
    second: +n.second
  };
}
const ld = 864e5;
function jb(e, r, t, a) {
  return (t === a ? [
    t
  ] : [
    t,
    a
  ]).filter((i) => zb(e, r, i));
}
function zb(e, r, t) {
  let a = J4(t, r);
  return e.year === a.year && e.month === a.month && e.day === a.day && e.hour === a.hour && e.minute === a.minute && e.second === a.second;
}
function ta(e, r, t = "compatible") {
  let a = ii(e);
  if (r === "UTC")
    return ni(a);
  if (r === X4() && t === "compatible") {
    a = Pr(a, new Ba());
    let u = /* @__PURE__ */ new Date(), l = ac(a.era, a.year);
    return u.setFullYear(l, a.month - 1, a.day), u.setHours(a.hour, a.minute, a.second, a.millisecond), u.getTime();
  }
  let n = ni(a), i = al(n - ld, r), s = al(n + ld, r), o = jb(a, r, n - i, n - s);
  if (o.length === 1)
    return o[0];
  if (o.length > 1)
    switch (t) {
      case "compatible":
      case "earlier":
        return o[0];
      case "later":
        return o[o.length - 1];
      case "reject":
        throw new RangeError("Multiple possible absolute times found");
    }
  switch (t) {
    case "earlier":
      return Math.min(n - i, n - s);
    case "compatible":
    case "later":
      return Math.max(n - i, n - s);
    case "reject":
      throw new RangeError("No such absolute time found");
  }
}
function q4(e, r, t = "compatible") {
  return new Date(ta(e, r, t));
}
function sa(e, r) {
  let t = al(e, r), a = new Date(e + t), n = a.getUTCFullYear(), i = a.getUTCMonth() + 1, s = a.getUTCDate(), o = a.getUTCHours(), u = a.getUTCMinutes(), l = a.getUTCSeconds(), c = a.getUTCMilliseconds();
  return new Zi(n < 1 ? "BC" : "AD", n < 1 ? -n + 1 : n, i, s, r, t, o, u, l, c);
}
function Mt(e) {
  return new sm(e.calendar, e.era, e.year, e.month, e.day);
}
function ii(e, r) {
  let t = 0, a = 0, n = 0, i = 0;
  if ("timeZone" in e)
    ({ hour: t, minute: a, second: n, millisecond: i } = e);
  else if ("hour" in e && !r)
    return e;
  return r && ({ hour: t, minute: a, second: n, millisecond: i } = r), new ow(e.calendar, e.era, e.year, e.month, e.day, t, a, n, i);
}
function Pr(e, r) {
  if (e.calendar.identifier === r.identifier)
    return e;
  let t = r.fromJulianDay(e.calendar.toJulianDay(e)), a = e.copy();
  return a.calendar = r, a.era = t.era, a.year = t.year, a.month = t.month, a.day = t.day, un(a), a;
}
function Gb(e, r, t) {
  if (e instanceof Zi)
    return e.timeZone === r ? e : Yb(e, r);
  let a = ta(e, r, t);
  return sa(a, r);
}
function Kb(e) {
  let r = ni(e) - e.offset;
  return new Date(r);
}
function Yb(e, r) {
  let t = ni(e) - e.offset;
  return Pr(sa(t, r), e.calendar);
}
const Si = 36e5;
function o0(e, r) {
  let t = e.copy(), a = "hour" in t ? qb(t, r) : 0;
  nl(t, r.years || 0), t.calendar.balanceYearMonth && t.calendar.balanceYearMonth(t, e), t.month += r.months || 0, il(t), Q4(t), t.day += (r.weeks || 0) * 7, t.day += r.days || 0, t.day += a, Xb(t), t.calendar.balanceDate && t.calendar.balanceDate(t), t.year < 1 && (t.year = 1, t.month = 1, t.day = 1);
  let n = t.calendar.getYearsInEra(t);
  if (t.year > n) {
    var i, s;
    let u = (i = (s = t.calendar).isInverseEra) === null || i === void 0 ? void 0 : i.call(s, t);
    t.year = n, t.month = u ? 1 : t.calendar.getMonthsInYear(t), t.day = u ? 1 : t.calendar.getDaysInMonth(t);
  }
  t.month < 1 && (t.month = 1, t.day = 1);
  let o = t.calendar.getMonthsInYear(t);
  return t.month > o && (t.month = o, t.day = t.calendar.getDaysInMonth(t)), t.day = Math.max(1, Math.min(t.calendar.getDaysInMonth(t), t.day)), t;
}
function nl(e, r) {
  var t, a;
  !((t = (a = e.calendar).isInverseEra) === null || t === void 0) && t.call(a, e) && (r = -r), e.year += r;
}
function il(e) {
  for (; e.month < 1; )
    nl(e, -1), e.month += e.calendar.getMonthsInYear(e);
  let r = 0;
  for (; e.month > (r = e.calendar.getMonthsInYear(e)); )
    e.month -= r, nl(e, 1);
}
function Xb(e) {
  for (; e.day < 1; )
    e.month--, il(e), e.day += e.calendar.getDaysInMonth(e);
  for (; e.day > e.calendar.getDaysInMonth(e); )
    e.day -= e.calendar.getDaysInMonth(e), e.month++, il(e);
}
function Q4(e) {
  e.month = Math.max(1, Math.min(e.calendar.getMonthsInYear(e), e.month)), e.day = Math.max(1, Math.min(e.calendar.getDaysInMonth(e), e.day));
}
function un(e) {
  e.calendar.constrainDate && e.calendar.constrainDate(e), e.year = Math.max(1, Math.min(e.calendar.getYearsInEra(e), e.year)), Q4(e);
}
function em(e) {
  let r = {};
  for (let t in e)
    typeof e[t] == "number" && (r[t] = -e[t]);
  return r;
}
function rm(e, r) {
  return o0(e, em(r));
}
function oc(e, r) {
  let t = e.copy();
  return r.era != null && (t.era = r.era), r.year != null && (t.year = r.year), r.month != null && (t.month = r.month), r.day != null && (t.day = r.day), un(t), t;
}
function Bo(e, r) {
  let t = e.copy();
  return r.hour != null && (t.hour = r.hour), r.minute != null && (t.minute = r.minute), r.second != null && (t.second = r.second), r.millisecond != null && (t.millisecond = r.millisecond), Jb(t), t;
}
function Zb(e) {
  e.second += Math.floor(e.millisecond / 1e3), e.millisecond = Zs(e.millisecond, 1e3), e.minute += Math.floor(e.second / 60), e.second = Zs(e.second, 60), e.hour += Math.floor(e.minute / 60), e.minute = Zs(e.minute, 60);
  let r = Math.floor(e.hour / 24);
  return e.hour = Zs(e.hour, 24), r;
}
function Jb(e) {
  e.millisecond = Math.max(0, Math.min(e.millisecond, 1e3)), e.second = Math.max(0, Math.min(e.second, 59)), e.minute = Math.max(0, Math.min(e.minute, 59)), e.hour = Math.max(0, Math.min(e.hour, 23));
}
function Zs(e, r) {
  let t = e % r;
  return t < 0 && (t += r), t;
}
function qb(e, r) {
  return e.hour += r.hours || 0, e.minute += r.minutes || 0, e.second += r.seconds || 0, e.millisecond += r.milliseconds || 0, Zb(e);
}
function uc(e, r, t, a) {
  let n = e.copy();
  switch (r) {
    case "era": {
      let o = e.calendar.getEras(), u = o.indexOf(e.era);
      if (u < 0)
        throw new Error("Invalid era: " + e.era);
      u = oa(u, t, 0, o.length - 1, a == null ? void 0 : a.round), n.era = o[u], un(n);
      break;
    }
    case "year":
      var i, s;
      !((i = (s = n.calendar).isInverseEra) === null || i === void 0) && i.call(s, n) && (t = -t), n.year = oa(e.year, t, -1 / 0, 9999, a == null ? void 0 : a.round), n.year === -1 / 0 && (n.year = 1), n.calendar.balanceYearMonth && n.calendar.balanceYearMonth(n, e);
      break;
    case "month":
      n.month = oa(e.month, t, 1, e.calendar.getMonthsInYear(e), a == null ? void 0 : a.round);
      break;
    case "day":
      n.day = oa(e.day, t, 1, e.calendar.getDaysInMonth(e), a == null ? void 0 : a.round);
      break;
    default:
      throw new Error("Unsupported field " + r);
  }
  return e.calendar.balanceDate && e.calendar.balanceDate(n), un(n), n;
}
function tm(e, r, t, a) {
  let n = e.copy();
  switch (r) {
    case "hour": {
      let i = e.hour, s = 0, o = 23;
      if ((a == null ? void 0 : a.hourCycle) === 12) {
        let u = i >= 12;
        s = u ? 12 : 0, o = u ? 23 : 11;
      }
      n.hour = oa(i, t, s, o, a == null ? void 0 : a.round);
      break;
    }
    case "minute":
      n.minute = oa(e.minute, t, 0, 59, a == null ? void 0 : a.round);
      break;
    case "second":
      n.second = oa(e.second, t, 0, 59, a == null ? void 0 : a.round);
      break;
    case "millisecond":
      n.millisecond = oa(e.millisecond, t, 0, 999, a == null ? void 0 : a.round);
      break;
    default:
      throw new Error("Unsupported field " + r);
  }
  return n;
}
function oa(e, r, t, a, n = !1) {
  if (n) {
    e += Math.sign(r), e < t && (e = a);
    let i = Math.abs(r);
    r > 0 ? e = Math.ceil(e / i) * i : e = Math.floor(e / i) * i, e > a && (e = t);
  } else
    e += r, e < t ? e = a - (t - e - 1) : e > a && (e = t + (e - a - 1));
  return e;
}
function am(e, r) {
  let t;
  if (r.years != null && r.years !== 0 || r.months != null && r.months !== 0 || r.weeks != null && r.weeks !== 0 || r.days != null && r.days !== 0) {
    let n = o0(ii(e), {
      years: r.years,
      months: r.months,
      weeks: r.weeks,
      days: r.days
    });
    t = ta(n, e.timeZone);
  } else
    t = ni(e) - e.offset;
  t += r.milliseconds || 0, t += (r.seconds || 0) * 1e3, t += (r.minutes || 0) * 6e4, t += (r.hours || 0) * 36e5;
  let a = sa(t, e.timeZone);
  return Pr(a, e.calendar);
}
function Qb(e, r) {
  return am(e, em(r));
}
function ew(e, r, t, a) {
  switch (r) {
    case "hour": {
      let n = 0, i = 23;
      if ((a == null ? void 0 : a.hourCycle) === 12) {
        let m = e.hour >= 12;
        n = m ? 12 : 0, i = m ? 23 : 11;
      }
      let s = ii(e), o = Pr(Bo(s, {
        hour: n
      }), new Ba()), u = [
        ta(o, e.timeZone, "earlier"),
        ta(o, e.timeZone, "later")
      ].filter((m) => sa(m, e.timeZone).day === o.day)[0], l = Pr(Bo(s, {
        hour: i
      }), new Ba()), c = [
        ta(l, e.timeZone, "earlier"),
        ta(l, e.timeZone, "later")
      ].filter((m) => sa(m, e.timeZone).day === l.day).pop(), f = ni(e) - e.offset, h = Math.floor(f / Si), d = f % Si;
      return f = oa(h, t, Math.floor(u / Si), Math.floor(c / Si), a == null ? void 0 : a.round) * Si + d, Pr(sa(f, e.timeZone), e.calendar);
    }
    case "minute":
    case "second":
    case "millisecond":
      return tm(e, r, t, a);
    case "era":
    case "year":
    case "month":
    case "day": {
      let n = uc(ii(e), r, t, a), i = ta(n, e.timeZone);
      return Pr(sa(i, e.timeZone), e.calendar);
    }
    default:
      throw new Error("Unsupported field " + r);
  }
}
function rw(e, r, t) {
  let a = ii(e), n = Bo(oc(a, r), r);
  if (n.compare(a) === 0)
    return e;
  let i = ta(n, e.timeZone, t);
  return Pr(sa(i, e.timeZone), e.calendar);
}
function tw(e) {
  return `${String(e.hour).padStart(2, "0")}:${String(e.minute).padStart(2, "0")}:${String(e.second).padStart(2, "0")}${e.millisecond ? String(e.millisecond / 1e3).slice(1) : ""}`;
}
function nm(e) {
  let r = Pr(e, new Ba()), t;
  return r.era === "BC" ? t = r.year === 1 ? "0000" : "-" + String(Math.abs(1 - r.year)).padStart(6, "00") : t = String(r.year).padStart(4, "0"), `${t}-${String(r.month).padStart(2, "0")}-${String(r.day).padStart(2, "0")}`;
}
function im(e) {
  return `${nm(e)}T${tw(e)}`;
}
function aw(e) {
  let r = Math.sign(e) < 0 ? "-" : "+";
  e = Math.abs(e);
  let t = Math.floor(e / 36e5), a = e % 36e5 / 6e4;
  return `${r}${String(t).padStart(2, "0")}:${String(a).padStart(2, "0")}`;
}
function nw(e) {
  return `${im(e)}${aw(e.offset)}[${e.timeZone}]`;
}
function lc(e) {
  let r = typeof e[0] == "object" ? e.shift() : new Ba(), t;
  if (typeof e[0] == "string")
    t = e.shift();
  else {
    let s = r.getEras();
    t = s[s.length - 1];
  }
  let a = e.shift(), n = e.shift(), i = e.shift();
  return [
    r,
    t,
    a,
    n,
    i
  ];
}
var iw = /* @__PURE__ */ new WeakMap();
let sm = class sl {
  /** Returns a copy of this date. */
  copy() {
    return this.era ? new sl(this.calendar, this.era, this.year, this.month, this.day) : new sl(this.calendar, this.year, this.month, this.day);
  }
  /** Returns a new `CalendarDate` with the given duration added to it. */
  add(r) {
    return o0(this, r);
  }
  /** Returns a new `CalendarDate` with the given duration subtracted from it. */
  subtract(r) {
    return rm(this, r);
  }
  /** Returns a new `CalendarDate` with the given fields set to the provided values. Other fields will be constrained accordingly. */
  set(r) {
    return oc(this, r);
  }
  /**
  * Returns a new `CalendarDate` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(r, t, a) {
    return uc(this, r, t, a);
  }
  /** Converts the date to a native JavaScript Date object, with the time set to midnight in the given time zone. */
  toDate(r) {
    return q4(this, r);
  }
  /** Converts the date to an ISO 8601 formatted string. */
  toString() {
    return nm(this);
  }
  /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */
  compare(r) {
    return Y4(this, r);
  }
  constructor(...r) {
    at(this, iw, {
      writable: !0,
      value: void 0
    });
    let [t, a, n, i, s] = lc(r);
    this.calendar = t, this.era = a, this.year = n, this.month = i, this.day = s, un(this);
  }
};
var sw = /* @__PURE__ */ new WeakMap();
let ow = class ol {
  /** Returns a copy of this date. */
  copy() {
    return this.era ? new ol(this.calendar, this.era, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond) : new ol(this.calendar, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond);
  }
  /** Returns a new `CalendarDateTime` with the given duration added to it. */
  add(r) {
    return o0(this, r);
  }
  /** Returns a new `CalendarDateTime` with the given duration subtracted from it. */
  subtract(r) {
    return rm(this, r);
  }
  /** Returns a new `CalendarDateTime` with the given fields set to the provided values. Other fields will be constrained accordingly. */
  set(r) {
    return oc(Bo(this, r), r);
  }
  /**
  * Returns a new `CalendarDateTime` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(r, t, a) {
    switch (r) {
      case "era":
      case "year":
      case "month":
      case "day":
        return uc(this, r, t, a);
      default:
        return tm(this, r, t, a);
    }
  }
  /** Converts the date to a native JavaScript Date object in the given time zone. */
  toDate(r, t) {
    return q4(this, r, t);
  }
  /** Converts the date to an ISO 8601 formatted string. */
  toString() {
    return im(this);
  }
  /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */
  compare(r) {
    let t = Y4(this, r);
    return t === 0 ? Lb(this, ii(r)) : t;
  }
  constructor(...r) {
    at(this, sw, {
      writable: !0,
      value: void 0
    });
    let [t, a, n, i, s] = lc(r);
    this.calendar = t, this.era = a, this.year = n, this.month = i, this.day = s, this.hour = r.shift() || 0, this.minute = r.shift() || 0, this.second = r.shift() || 0, this.millisecond = r.shift() || 0, un(this);
  }
};
var uw = /* @__PURE__ */ new WeakMap();
class Zi {
  /** Returns a copy of this date. */
  copy() {
    return this.era ? new Zi(this.calendar, this.era, this.year, this.month, this.day, this.timeZone, this.offset, this.hour, this.minute, this.second, this.millisecond) : new Zi(this.calendar, this.year, this.month, this.day, this.timeZone, this.offset, this.hour, this.minute, this.second, this.millisecond);
  }
  /** Returns a new `ZonedDateTime` with the given duration added to it. */
  add(r) {
    return am(this, r);
  }
  /** Returns a new `ZonedDateTime` with the given duration subtracted from it. */
  subtract(r) {
    return Qb(this, r);
  }
  /** Returns a new `ZonedDateTime` with the given fields set to the provided values. Other fields will be constrained accordingly. */
  set(r, t) {
    return rw(this, r, t);
  }
  /**
  * Returns a new `ZonedDateTime` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(r, t, a) {
    return ew(this, r, t, a);
  }
  /** Converts the date to a native JavaScript Date object. */
  toDate() {
    return Kb(this);
  }
  /** Converts the date to an ISO 8601 formatted string, including the UTC offset and time zone identifier. */
  toString() {
    return nw(this);
  }
  /** Converts the date to an ISO 8601 formatted string in UTC. */
  toAbsoluteString() {
    return this.toDate().toISOString();
  }
  /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */
  compare(r) {
    return this.toDate().getTime() - Gb(r, this.timeZone).toDate().getTime();
  }
  constructor(...r) {
    at(this, uw, {
      writable: !0,
      value: void 0
    });
    let [t, a, n, i, s] = lc(r), o = r.shift(), u = r.shift();
    this.calendar = t, this.era = a, this.year = n, this.month = i, this.day = s, this.timeZone = o, this.offset = u, this.hour = r.shift() || 0, this.minute = r.shift() || 0, this.second = r.shift() || 0, this.millisecond = r.shift() || 0, un(this);
  }
}
let q0 = /* @__PURE__ */ new Map(), lw = class {
  /** Formats a date as a string according to the locale and format options passed to the constructor. */
  format(r) {
    return this.formatter.format(r);
  }
  /** Formats a date to an array of parts such as separators, numbers, punctuation, and more. */
  formatToParts(r) {
    return this.formatter.formatToParts(r);
  }
  /** Formats a date range as a string. */
  formatRange(r, t) {
    if (typeof this.formatter.formatRange == "function")
      return this.formatter.formatRange(r, t);
    if (t < r)
      throw new RangeError("End date must be >= start date");
    return `${this.formatter.format(r)} – ${this.formatter.format(t)}`;
  }
  /** Formats a date range as an array of parts. */
  formatRangeToParts(r, t) {
    if (typeof this.formatter.formatRangeToParts == "function")
      return this.formatter.formatRangeToParts(r, t);
    if (t < r)
      throw new RangeError("End date must be >= start date");
    let a = this.formatter.formatToParts(r), n = this.formatter.formatToParts(t);
    return [
      ...a.map((i) => ({
        ...i,
        source: "startRange"
      })),
      {
        type: "literal",
        value: " – ",
        source: "shared"
      },
      ...n.map((i) => ({
        ...i,
        source: "endRange"
      }))
    ];
  }
  /** Returns the resolved formatting options based on the values passed to the constructor. */
  resolvedOptions() {
    let r = this.formatter.resolvedOptions();
    return dw() && (this.resolvedHourCycle || (this.resolvedHourCycle = hw(r.locale, this.options)), r.hourCycle = this.resolvedHourCycle, r.hour12 = this.resolvedHourCycle === "h11" || this.resolvedHourCycle === "h12"), r.calendar === "ethiopic-amete-alem" && (r.calendar = "ethioaa"), r;
  }
  constructor(r, t = {}) {
    this.formatter = om(r, t), this.options = t;
  }
};
const cw = {
  true: {
    // Only Japanese uses the h11 style for 12 hour time. All others use h12.
    ja: "h11"
  },
  false: {}
};
function om(e, r = {}) {
  if (typeof r.hour12 == "boolean" && fw()) {
    r = {
      ...r
    };
    let n = cw[String(r.hour12)][e.split("-")[0]], i = r.hour12 ? "h12" : "h23";
    r.hourCycle = n ?? i, delete r.hour12;
  }
  let t = e + (r ? Object.entries(r).sort((n, i) => n[0] < i[0] ? -1 : 1).join() : "");
  if (q0.has(t))
    return q0.get(t);
  let a = new Intl.DateTimeFormat(e, r);
  return q0.set(t, a), a;
}
let Q0 = null;
function fw() {
  return Q0 == null && (Q0 = new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    hour12: !1
  }).format(new Date(2020, 2, 3, 0)) === "24"), Q0;
}
let eu = null;
function dw() {
  return eu == null && (eu = new Intl.DateTimeFormat("fr", {
    hour: "numeric",
    hour12: !1
  }).resolvedOptions().hourCycle === "h12"), eu;
}
function hw(e, r) {
  if (!r.timeStyle && !r.hour)
    return;
  e = e.replace(/(-u-)?-nu-[a-zA-Z0-9]+/, ""), e += (e.includes("-u-") ? "" : "-u") + "-nu-latn";
  let t = om(e, {
    ...r,
    timeZone: void 0
    // use local timezone
  }), a = parseInt(t.formatToParts(new Date(2020, 2, 3, 0)).find((i) => i.type === "hour").value, 10), n = parseInt(t.formatToParts(new Date(2020, 2, 3, 23)).find((i) => i.type === "hour").value, 10);
  if (a === 0 && n === 23)
    return "h23";
  if (a === 24 && n === 23)
    return "h24";
  if (a === 0 && n === 11)
    return "h11";
  if (a === 12 && n === 11)
    return "h12";
  throw new Error("Unexpected hour cycle result");
}
function Wn(e, r, t) {
  return r != null && e.compare(r) < 0 || t != null && e.compare(t) > 0;
}
function ul(e, r, t, a, n) {
  let i = {};
  for (let o in r)
    i[o] = Math.floor(r[o] / 2), i[o] > 0 && r[o] % 2 === 0 && i[o]--;
  let s = qa(e, r, t).subtract(i);
  return Ji(e, s, r, t, a, n);
}
function qa(e, r, t, a, n) {
  let i = e;
  return r.years ? i = Ub(e) : r.months ? i = nc(e) : r.weeks && (i = Io(e, t)), Ji(e, i, r, t, a, n);
}
function ll(e, r, t, a, n) {
  let i = {
    ...r
  };
  i.days ? i.days-- : i.weeks ? i.weeks-- : i.months ? i.months-- : i.years && i.years--;
  let s = qa(e, r, t).subtract(i);
  return Ji(e, s, r, t, a, n);
}
function Ji(e, r, t, a, n, i) {
  if (n && e.compare(n) >= 0) {
    let s = sc(r, qa(Mt(n), t, a));
    s && (r = s);
  }
  if (i && e.compare(i) <= 0) {
    let s = ic(r, ll(Mt(i), t, a));
    s && (r = s);
  }
  return r;
}
function wa(e, r, t) {
  if (r) {
    let a = sc(e, Mt(r));
    a && (e = a);
  }
  if (t) {
    let a = ic(e, Mt(t));
    a && (e = a);
  }
  return e;
}
function um(e, r, t) {
  if (!t)
    return e;
  for (; e.compare(r) >= 0 && t(e); )
    e = e.subtract({
      days: 1
    });
  return e.compare(r) >= 0 ? e : null;
}
function lm(e) {
  let r = Pe(() => new lw(e.locale), [
    e.locale
  ]), t = Pe(() => r.resolvedOptions(), [
    r
  ]), { locale: a, createCalendar: n, visibleDuration: i = {
    months: 1
  }, minValue: s, maxValue: o, selectionAlignment: u, isDateUnavailable: l, pageBehavior: c = "visible" } = e, f = Pe(() => n(t.calendar), [
    n,
    t.calendar
  ]);
  var h;
  let [d, m] = qn(e.value, (h = e.defaultValue) !== null && h !== void 0 ? h : null, e.onChange), x = Pe(() => d ? Pr(Mt(d), f) : null, [
    d,
    f
  ]), p = Pe(() => d && "timeZone" in d ? d.timeZone : t.timeZone, [
    d,
    t.timeZone
  ]), w = Pe(() => e.focusedValue ? wa(Pr(Mt(e.focusedValue), f), s, o) : void 0, [
    e.focusedValue,
    f,
    s,
    o
  ]), D = Pe(() => wa(e.defaultFocusedValue ? Pr(Mt(e.defaultFocusedValue), f) : x || Pr(Ob(p), f), s, o), [
    e.defaultFocusedValue,
    x,
    p,
    f,
    s,
    o
  ]), [y, B] = qn(w, D, e.onFocusChange), [L, U] = He(() => {
    switch (u) {
      case "start":
        return qa(y, i, a, s, o);
      case "end":
        return ll(y, i, a, s, o);
      case "center":
      default:
        return ul(y, i, a, s, o);
    }
  }), [k, v] = He(e.autoFocus || !1), b = Pe(() => {
    let ee = {
      ...i
    };
    return ee.days ? ee.days-- : ee.days = -1, L.add(ee);
  }, [
    L,
    i
  ]), [A, T] = He(f.identifier);
  if (f.identifier !== A) {
    let ee = Pr(y, f);
    U(ul(ee, i, a, s, o)), B(ee), T(f.identifier);
  }
  Wn(y, s, o) ? B(wa(y, s, o)) : y.compare(L) < 0 ? U(ll(y, i, a, s, o)) : y.compare(b) > 0 && U(qa(y, i, a, s, o));
  function C(ee) {
    ee = wa(ee, s, o), B(ee);
  }
  function I(ee) {
    if (!e.isDisabled && !e.isReadOnly) {
      let de = ee;
      if (de === null) {
        m(null);
        return;
      }
      if (de = wa(de, s, o), de = um(de, L, l), !de)
        return;
      de = Pr(de, (d == null ? void 0 : d.calendar) || new Ba()), d && "hour" in d ? m(d.set(de)) : m(de);
    }
  }
  let Y = Pe(() => x ? l && l(x) ? !0 : Wn(x, s, o) : !1, [
    x,
    l,
    s,
    o
  ]), j = e.isInvalid || e.validationState === "invalid" || Y, J = j ? "invalid" : null, W = Pe(() => c === "visible" ? i : ru(i), [
    c,
    i
  ]);
  var ce, V;
  return {
    isDisabled: (ce = e.isDisabled) !== null && ce !== void 0 ? ce : !1,
    isReadOnly: (V = e.isReadOnly) !== null && V !== void 0 ? V : !1,
    value: x,
    setValue: I,
    visibleRange: {
      start: L,
      end: b
    },
    minValue: s,
    maxValue: o,
    focusedDate: y,
    timeZone: p,
    validationState: J,
    isValueInvalid: j,
    setFocusedDate(ee) {
      C(ee), v(!0);
    },
    focusNextDay() {
      C(y.add({
        days: 1
      }));
    },
    focusPreviousDay() {
      C(y.subtract({
        days: 1
      }));
    },
    focusNextRow() {
      i.days ? this.focusNextPage() : (i.weeks || i.months || i.years) && C(y.add({
        weeks: 1
      }));
    },
    focusPreviousRow() {
      i.days ? this.focusPreviousPage() : (i.weeks || i.months || i.years) && C(y.subtract({
        weeks: 1
      }));
    },
    focusNextPage() {
      let ee = L.add(W);
      B(wa(y.add(W), s, o)), U(qa(Ji(y, ee, W, a, s, o), W, a));
    },
    focusPreviousPage() {
      let ee = L.subtract(W);
      B(wa(y.subtract(W), s, o)), U(qa(Ji(y, ee, W, a, s, o), W, a));
    },
    focusSectionStart() {
      i.days ? C(L) : i.weeks ? C(Io(y, a)) : (i.months || i.years) && C(nc(y));
    },
    focusSectionEnd() {
      i.days ? C(b) : i.weeks ? C(Vb(y, a)) : (i.months || i.years) && C(Nb(y));
    },
    focusNextSection(ee) {
      if (!ee && !i.days) {
        C(y.add(ru(i)));
        return;
      }
      i.days ? this.focusNextPage() : i.weeks ? C(y.add({
        months: 1
      })) : (i.months || i.years) && C(y.add({
        years: 1
      }));
    },
    focusPreviousSection(ee) {
      if (!ee && !i.days) {
        C(y.subtract(ru(i)));
        return;
      }
      i.days ? this.focusPreviousPage() : i.weeks ? C(y.subtract({
        months: 1
      })) : (i.months || i.years) && C(y.subtract({
        years: 1
      }));
    },
    selectFocusedDate() {
      I(y);
    },
    selectDate(ee) {
      I(ee);
    },
    isFocused: k,
    setFocused: v,
    isInvalid(ee) {
      return Wn(ee, s, o);
    },
    isSelected(ee) {
      return x != null && Ti(ee, x) && !this.isCellDisabled(ee) && !this.isCellUnavailable(ee);
    },
    isCellFocused(ee) {
      return k && y && Ti(ee, y);
    },
    isCellDisabled(ee) {
      return e.isDisabled || ee.compare(L) < 0 || ee.compare(b) > 0 || this.isInvalid(ee);
    },
    isCellUnavailable(ee) {
      return e.isDateUnavailable ? e.isDateUnavailable(ee) : !1;
    },
    isPreviousVisibleRangeInvalid() {
      let ee = L.subtract({
        days: 1
      });
      return Ti(ee, L) || this.isInvalid(ee);
    },
    isNextVisibleRangeInvalid() {
      let ee = b.add({
        days: 1
      });
      return Ti(ee, b) || this.isInvalid(ee);
    },
    getDatesInWeek(ee, de = L) {
      let F = de.add({
        weeks: ee
      }), H = [];
      F = Io(F, a);
      let P = K4(F, a);
      for (let N = 0; N < P; N++)
        H.push(null);
      for (; H.length < 7; ) {
        H.push(F);
        let N = F.add({
          days: 1
        });
        if (Ti(F, N))
          break;
        F = N;
      }
      for (; H.length < 7; )
        H.push(null);
      return H;
    }
  };
}
function ru(e) {
  let r = {
    ...e
  };
  for (let t in e)
    r[t] = 1;
  return r;
}
function xw(e) {
  let { value: r, defaultValue: t, onChange: a, createCalendar: n, locale: i, visibleDuration: s = {
    months: 1
  }, minValue: o, maxValue: u, ...l } = e, [c, f] = qn(r, t || null, a), [h, d] = He(null), m = "center";
  if (c && c.start && c.end) {
    let ce = ul(Mt(c.start), s, i, o, u).add(s).subtract({
      days: 1
    });
    c.end.compare(ce) > 0 && (m = "start");
  }
  let x = ze(null), [p, w] = He(null), D = Pe(() => sc(o, p == null ? void 0 : p.start), [
    o,
    p
  ]), y = Pe(() => ic(u, p == null ? void 0 : p.end), [
    u,
    p
  ]), B = lm({
    ...l,
    value: c && c.start,
    createCalendar: n,
    locale: i,
    visibleDuration: s,
    minValue: D,
    maxValue: y,
    selectionAlignment: m
  }), L = (W) => {
    if (W && e.isDateUnavailable && !e.allowsNonContiguousRanges) {
      const ce = fd(W, B, -1), V = fd(W, B, 1);
      x.current = {
        start: ce,
        end: V
      }, w(x.current);
    } else
      x.current = null, w(null);
  }, [U, k] = He(B.visibleRange);
  (!id(B.visibleRange.start, U.start) || !id(B.visibleRange.end, U.end)) && (L(h), k(B.visibleRange));
  let v = (W) => {
    W ? (d(W), L(W)) : (d(null), L(null));
  }, b = h ? tu(h, B.focusedDate) : c && tu(c.start, c.end), A = (W) => {
    if (e.isReadOnly)
      return;
    const ce = wa(W, D, y), V = um(ce, B.visibleRange.start, e.isDateUnavailable);
    if (V)
      if (!h)
        v(V);
      else {
        let ee = tu(h, V);
        ee && f({
          start: cd(ee.start, c == null ? void 0 : c.start),
          end: cd(ee.end, c == null ? void 0 : c.end)
        }), v(null);
      }
  }, [T, C] = He(!1), { isDateUnavailable: I } = e, Y = Pe(() => !c || h ? !1 : I && (I(c.start) || I(c.end)) ? !0 : Wn(c.start, o, u) || Wn(c.end, o, u), [
    I,
    c,
    h,
    o,
    u
  ]), j = e.isInvalid || e.validationState === "invalid" || Y;
  return {
    ...B,
    value: c,
    setValue: f,
    anchorDate: h,
    setAnchorDate: v,
    highlightedRange: b,
    validationState: j ? "invalid" : null,
    isValueInvalid: j,
    selectFocusedDate() {
      A(B.focusedDate);
    },
    selectDate: A,
    highlightDate(W) {
      h && B.setFocusedDate(W);
    },
    isSelected(W) {
      return !!(b && W.compare(b.start) >= 0 && W.compare(b.end) <= 0 && !B.isCellDisabled(W) && !B.isCellUnavailable(W));
    },
    isInvalid(W) {
      var ce, V;
      return B.isInvalid(W) || Wn(W, (ce = x.current) === null || ce === void 0 ? void 0 : ce.start, (V = x.current) === null || V === void 0 ? void 0 : V.end);
    },
    isDragging: T,
    setDragging: C
  };
}
function tu(e, r) {
  return !e || !r ? null : (r.compare(e) < 0 && ([e, r] = [
    r,
    e
  ]), {
    start: Mt(e),
    end: Mt(r)
  });
}
function cd(e, r) {
  return e = Pr(e, (r == null ? void 0 : r.calendar) || new Ba()), r && "hour" in r ? r.set(e) : e;
}
function fd(e, r, t) {
  let a = e.add({
    days: t
  });
  for (; (t < 0 ? a.compare(r.visibleRange.start) >= 0 : a.compare(r.visibleRange.end) <= 0) && !r.isCellUnavailable(a); )
    a = a.add({
      days: t
    });
  if (r.isCellUnavailable(a))
    return a.add({
      days: -t
    });
}
function cm(e) {
  let [r, t] = qn(e.isOpen, e.defaultOpen || !1, e.onOpenChange);
  const a = Cr(() => {
    t(!0);
  }, [
    t
  ]), n = Cr(() => {
    t(!1);
  }, [
    t
  ]), i = Cr(() => {
    t(!r);
  }, [
    t,
    r
  ]);
  return {
    isOpen: r,
    setOpen: t,
    open: a,
    close: n,
    toggle: i
  };
}
var fm = {};
fm = {
  rangeOverflow: (e) => `يجب أن تكون القيمة ${e.maxValue} أو قبل ذلك.`,
  rangeReversed: "تاريخ البدء يجب أن يكون قبل تاريخ الانتهاء.",
  rangeUnderflow: (e) => `يجب أن تكون القيمة ${e.minValue} أو بعد ذلك.`,
  unavailableDate: "البيانات المحددة غير متاحة."
};
var dm = {};
dm = {
  rangeOverflow: (e) => `Стойността трябва да е ${e.maxValue} или по-ранна.`,
  rangeReversed: "Началната дата трябва да е преди крайната.",
  rangeUnderflow: (e) => `Стойността трябва да е ${e.minValue} или по-късно.`,
  unavailableDate: "Избраната дата не е налична."
};
var hm = {};
hm = {
  rangeOverflow: (e) => `Hodnota musí být ${e.maxValue} nebo dřívější.`,
  rangeReversed: "Datum zahájení musí předcházet datu ukončení.",
  rangeUnderflow: (e) => `Hodnota musí být ${e.minValue} nebo pozdější.`,
  unavailableDate: "Vybrané datum není k dispozici."
};
var xm = {};
xm = {
  rangeOverflow: (e) => `Værdien skal være ${e.maxValue} eller tidligere.`,
  rangeReversed: "Startdatoen skal være før slutdatoen.",
  rangeUnderflow: (e) => `Værdien skal være ${e.minValue} eller nyere.`,
  unavailableDate: "Den valgte dato er ikke tilgængelig."
};
var mm = {};
mm = {
  rangeOverflow: (e) => `Der Wert muss ${e.maxValue} oder früher sein.`,
  rangeReversed: "Das Anfangsdatum muss vor dem Enddatum liegen.",
  rangeUnderflow: (e) => `Der Wert muss ${e.minValue} oder später sein.`,
  unavailableDate: "Das ausgewählte Datum ist nicht verfügbar."
};
var pm = {};
pm = {
  rangeOverflow: (e) => `Η τιμή πρέπει να είναι ${e.maxValue} ή παλαιότερη.`,
  rangeReversed: "Η ημερομηνία έναρξης πρέπει να είναι πριν από την ημερομηνία λήξης.",
  rangeUnderflow: (e) => `Η τιμή πρέπει να είναι ${e.minValue} ή μεταγενέστερη.`,
  unavailableDate: "Η επιλεγμένη ημερομηνία δεν είναι διαθέσιμη."
};
var vm = {};
vm = {
  rangeUnderflow: (e) => `Value must be ${e.minValue} or later.`,
  rangeOverflow: (e) => `Value must be ${e.maxValue} or earlier.`,
  rangeReversed: "Start date must be before end date.",
  unavailableDate: "Selected date unavailable."
};
var gm = {};
gm = {
  rangeOverflow: (e) => `El valor debe ser ${e.maxValue} o anterior.`,
  rangeReversed: "La fecha de inicio debe ser anterior a la fecha de finalización.",
  rangeUnderflow: (e) => `El valor debe ser ${e.minValue} o posterior.`,
  unavailableDate: "Fecha seleccionada no disponible."
};
var ym = {};
ym = {
  rangeOverflow: (e) => `Väärtus peab olema ${e.maxValue} või varasem.`,
  rangeReversed: "Alguskuupäev peab olema enne lõppkuupäeva.",
  rangeUnderflow: (e) => `Väärtus peab olema ${e.minValue} või hilisem.`,
  unavailableDate: "Valitud kuupäev pole saadaval."
};
var bm = {};
bm = {
  rangeOverflow: (e) => `Arvon on oltava ${e.maxValue} tai sitä aikaisempi.`,
  rangeReversed: "Aloituspäivän on oltava ennen lopetuspäivää.",
  rangeUnderflow: (e) => `Arvon on oltava ${e.minValue} tai sitä myöhäisempi.`,
  unavailableDate: "Valittu päivämäärä ei ole käytettävissä."
};
var wm = {};
wm = {
  rangeOverflow: (e) => `La valeur doit être ${e.maxValue} ou antérieure.`,
  rangeReversed: "La date de début doit être antérieure à la date de fin.",
  rangeUnderflow: (e) => `La valeur doit être ${e.minValue} ou ultérieure.`,
  unavailableDate: "La date sélectionnée n’est pas disponible."
};
var _m = {};
_m = {
  rangeOverflow: (e) => `הערך חייב להיות ${e.maxValue} או מוקדם יותר.`,
  rangeReversed: "תאריך ההתחלה חייב להיות לפני תאריך הסיום.",
  rangeUnderflow: (e) => `הערך חייב להיות ${e.minValue} או מאוחר יותר.`,
  unavailableDate: "התאריך הנבחר אינו זמין."
};
var $m = {};
$m = {
  rangeOverflow: (e) => `Vrijednost mora biti ${e.maxValue} ili ranije.`,
  rangeReversed: "Datum početka mora biti prije datuma završetka.",
  rangeUnderflow: (e) => `Vrijednost mora biti ${e.minValue} ili kasnije.`,
  unavailableDate: "Odabrani datum nije dostupan."
};
var Dm = {};
Dm = {
  rangeOverflow: (e) => `Az értéknek ${e.maxValue} vagy korábbinak kell lennie.`,
  rangeReversed: "A kezdő dátumnak a befejező dátumnál korábbinak kell lennie.",
  rangeUnderflow: (e) => `Az értéknek ${e.minValue} vagy későbbinek kell lennie.`,
  unavailableDate: "A kiválasztott dátum nem érhető el."
};
var Em = {};
Em = {
  rangeOverflow: (e) => `Il valore deve essere ${e.maxValue} o precedente.`,
  rangeReversed: "La data di inizio deve essere antecedente alla data di fine.",
  rangeUnderflow: (e) => `Il valore deve essere ${e.minValue} o successivo.`,
  unavailableDate: "Data selezionata non disponibile."
};
var km = {};
km = {
  rangeOverflow: (e) => `値は ${e.maxValue} 以下にする必要があります。`,
  rangeReversed: "開始日は終了日より前にする必要があります。",
  rangeUnderflow: (e) => `値は ${e.minValue} 以上にする必要があります。`,
  unavailableDate: "選択した日付は使用できません。"
};
var Tm = {};
Tm = {
  rangeOverflow: (e) => `값은 ${e.maxValue} 이전이어야 합니다.`,
  rangeReversed: "시작일은 종료일 이전이어야 합니다.",
  rangeUnderflow: (e) => `값은 ${e.minValue} 이상이어야 합니다.`,
  unavailableDate: "선택한 날짜를 사용할 수 없습니다."
};
var Sm = {};
Sm = {
  rangeOverflow: (e) => `Reikšmė turi būti ${e.maxValue} arba ankstesnė.`,
  rangeReversed: "Pradžios data turi būti ankstesnė nei pabaigos data.",
  rangeUnderflow: (e) => `Reikšmė turi būti ${e.minValue} arba naujesnė.`,
  unavailableDate: "Pasirinkta data nepasiekiama."
};
var Cm = {};
Cm = {
  rangeOverflow: (e) => `Vērtībai ir jābūt ${e.maxValue} vai agrākai.`,
  rangeReversed: "Sākuma datumam ir jābūt pirms beigu datuma.",
  rangeUnderflow: (e) => `Vērtībai ir jābūt ${e.minValue} vai vēlākai.`,
  unavailableDate: "Atlasītais datums nav pieejams."
};
var Fm = {};
Fm = {
  rangeOverflow: (e) => `Verdien må være ${e.maxValue} eller tidligere.`,
  rangeReversed: "Startdatoen må være før sluttdatoen.",
  rangeUnderflow: (e) => `Verdien må være ${e.minValue} eller senere.`,
  unavailableDate: "Valgt dato utilgjengelig."
};
var Am = {};
Am = {
  rangeOverflow: (e) => `Waarde moet ${e.maxValue} of eerder zijn.`,
  rangeReversed: "De startdatum moet voor de einddatum liggen.",
  rangeUnderflow: (e) => `Waarde moet ${e.minValue} of later zijn.`,
  unavailableDate: "Geselecteerde datum niet beschikbaar."
};
var Rm = {};
Rm = {
  rangeOverflow: (e) => `Wartość musi mieć wartość ${e.maxValue} lub wcześniejszą.`,
  rangeReversed: "Data rozpoczęcia musi być wcześniejsza niż data zakończenia.",
  rangeUnderflow: (e) => `Wartość musi mieć wartość ${e.minValue} lub późniejszą.`,
  unavailableDate: "Wybrana data jest niedostępna."
};
var Im = {};
Im = {
  rangeOverflow: (e) => `O valor deve ser ${e.maxValue} ou anterior.`,
  rangeReversed: "A data inicial deve ser anterior à data final.",
  rangeUnderflow: (e) => `O valor deve ser ${e.minValue} ou posterior.`,
  unavailableDate: "Data selecionada indisponível."
};
var Bm = {};
Bm = {
  rangeOverflow: (e) => `O valor tem de ser ${e.maxValue} ou anterior.`,
  rangeReversed: "A data de início deve ser anterior à data de fim.",
  rangeUnderflow: (e) => `O valor tem de ser ${e.minValue} ou posterior.`,
  unavailableDate: "Data selecionada indisponível."
};
var Pm = {};
Pm = {
  rangeOverflow: (e) => `Valoarea trebuie să fie ${e.maxValue} sau anterioară.`,
  rangeReversed: "Data de început trebuie să fie anterioară datei de sfârșit.",
  rangeUnderflow: (e) => `Valoarea trebuie să fie ${e.minValue} sau ulterioară.`,
  unavailableDate: "Data selectată nu este disponibilă."
};
var Mm = {};
Mm = {
  rangeOverflow: (e) => `Значение должно быть не позже ${e.maxValue}.`,
  rangeReversed: "Дата начала должна предшествовать дате окончания.",
  rangeUnderflow: (e) => `Значение должно быть не раньше ${e.minValue}.`,
  unavailableDate: "Выбранная дата недоступна."
};
var Om = {};
Om = {
  rangeOverflow: (e) => `Hodnota musí byť ${e.maxValue} alebo skoršia.`,
  rangeReversed: "Dátum začiatku musí byť skorší ako dátum konca.",
  rangeUnderflow: (e) => `Hodnota musí byť ${e.minValue} alebo neskoršia.`,
  unavailableDate: "Vybratý dátum je nedostupný."
};
var Lm = {};
Lm = {
  rangeOverflow: (e) => `Vrednost mora biti ${e.maxValue} ali starejša.`,
  rangeReversed: "Začetni datum mora biti pred končnim datumom.",
  rangeUnderflow: (e) => `Vrednost mora biti ${e.minValue} ali novejša.`,
  unavailableDate: "Izbrani datum ni na voljo."
};
var Nm = {};
Nm = {
  rangeOverflow: (e) => `Vrednost mora da bude ${e.maxValue} ili starija.`,
  rangeReversed: "Datum početka mora biti pre datuma završetka.",
  rangeUnderflow: (e) => `Vrednost mora da bude ${e.minValue} ili novija.`,
  unavailableDate: "Izabrani datum nije dostupan."
};
var Um = {};
Um = {
  rangeOverflow: (e) => `Värdet måste vara ${e.maxValue} eller tidigare.`,
  rangeReversed: "Startdatumet måste vara före slutdatumet.",
  rangeUnderflow: (e) => `Värdet måste vara ${e.minValue} eller senare.`,
  unavailableDate: "Det valda datumet är inte tillgängligt."
};
var Vm = {};
Vm = {
  rangeOverflow: (e) => `Değer, ${e.maxValue} veya öncesi olmalıdır.`,
  rangeReversed: "Başlangıç tarihi bitiş tarihinden önce olmalıdır.",
  rangeUnderflow: (e) => `Değer, ${e.minValue} veya sonrası olmalıdır.`,
  unavailableDate: "Seçilen tarih kullanılamıyor."
};
var Wm = {};
Wm = {
  rangeOverflow: (e) => `Значення має бути не пізніше ${e.maxValue}.`,
  rangeReversed: "Дата початку має передувати даті завершення.",
  rangeUnderflow: (e) => `Значення має бути не раніше ${e.minValue}.`,
  unavailableDate: "Вибрана дата недоступна."
};
var Hm = {};
Hm = {
  rangeOverflow: (e) => `值必须是 ${e.maxValue} 或更早日期。`,
  rangeReversed: "开始日期必须早于结束日期。",
  rangeUnderflow: (e) => `值必须是 ${e.minValue} 或更晚日期。`,
  unavailableDate: "所选日期不可用。"
};
var jm = {};
jm = {
  rangeOverflow: (e) => `值必須是 ${e.maxValue} 或更早。`,
  rangeReversed: "開始日期必須在結束日期之前。",
  rangeUnderflow: (e) => `值必須是 ${e.minValue} 或更晚。`,
  unavailableDate: "所選日期無法使用。"
};
var zm = {};
zm = {
  "ar-AE": fm,
  "bg-BG": dm,
  "cs-CZ": hm,
  "da-DK": xm,
  "de-DE": mm,
  "el-GR": pm,
  "en-US": vm,
  "es-ES": gm,
  "et-EE": ym,
  "fi-FI": bm,
  "fr-FR": wm,
  "he-IL": _m,
  "hr-HR": $m,
  "hu-HU": Dm,
  "it-IT": Em,
  "ja-JP": km,
  "ko-KR": Tm,
  "lt-LT": Sm,
  "lv-LV": Cm,
  "nb-NO": Fm,
  "nl-NL": Am,
  "pl-PL": Rm,
  "pt-BR": Im,
  "pt-PT": Bm,
  "ro-RO": Pm,
  "ru-RU": Mm,
  "sk-SK": Om,
  "sl-SI": Lm,
  "sr-SP": Nm,
  "sv-SE": Um,
  "tr-TR": Vm,
  "uk-UA": Wm,
  "zh-CN": Hm,
  "zh-TW": jm
};
function au(e, r) {
  return e - r * Math.floor(e / r);
}
const Gm = 1721426;
function Js(e, r, t, a) {
  r = cc(e, r);
  let n = r - 1, i = -2;
  return t <= 2 ? i = 0 : vo(r) && (i = -1), Gm - 1 + 365 * n + Math.floor(n / 4) - Math.floor(n / 100) + Math.floor(n / 400) + Math.floor((367 * t - 362) / 12 + i + a);
}
function vo(e) {
  return e % 4 === 0 && (e % 100 !== 0 || e % 400 === 0);
}
function cc(e, r) {
  return e === "BC" ? 1 - r : r;
}
function mw(e) {
  let r = "AD";
  return e <= 0 && (r = "BC", e = 1 - e), [
    r,
    e
  ];
}
const pw = {
  standard: [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
  ],
  leapyear: [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
  ]
};
class u0 {
  fromJulianDay(r) {
    let t = r, a = t - Gm, n = Math.floor(a / 146097), i = au(a, 146097), s = Math.floor(i / 36524), o = au(i, 36524), u = Math.floor(o / 1461), l = au(o, 1461), c = Math.floor(l / 365), f = n * 400 + s * 100 + u * 4 + c + (s !== 4 && c !== 4 ? 1 : 0), [h, d] = mw(f), m = t - Js(h, d, 1, 1), x = 2;
    t < Js(h, d, 3, 1) ? x = 0 : vo(d) && (x = 1);
    let p = Math.floor(((m + x) * 12 + 373) / 367), w = t - Js(h, d, p, 1) + 1;
    return new Qi(h, d, p, w);
  }
  toJulianDay(r) {
    return Js(r.era, r.year, r.month, r.day);
  }
  getDaysInMonth(r) {
    return pw[vo(r.year) ? "leapyear" : "standard"][r.month - 1];
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getMonthsInYear(r) {
    return 12;
  }
  getDaysInYear(r) {
    return vo(r.year) ? 366 : 365;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getYearsInEra(r) {
    return 9999;
  }
  getEras() {
    return [
      "BC",
      "AD"
    ];
  }
  isInverseEra(r) {
    return r.era === "BC";
  }
  balanceDate(r) {
    r.year <= 0 && (r.era = r.era === "BC" ? "AD" : "BC", r.year = 1 - r.year);
  }
  constructor() {
    this.identifier = "gregory";
  }
}
function Km(e, r) {
  return e.calendar.toJulianDay(e) - r.calendar.toJulianDay(r);
}
function Ym(e, r) {
  return dd(e) - dd(r);
}
function dd(e) {
  return e.hour * 36e5 + e.minute * 6e4 + e.second * 1e3 + e.millisecond;
}
let nu = null;
function Xm() {
  return nu == null && (nu = new Intl.DateTimeFormat().resolvedOptions().timeZone), nu;
}
function hd(e) {
  e = fc(e, new u0());
  let r = cc(e.era, e.year);
  return Zm(r, e.month, e.day, e.hour, e.minute, e.second, e.millisecond);
}
function Zm(e, r, t, a, n, i, s) {
  let o = /* @__PURE__ */ new Date();
  return o.setUTCHours(a, n, i, s), o.setUTCFullYear(e, r - 1, t), o.getTime();
}
function xd(e, r) {
  if (r === "UTC")
    return 0;
  if (e > 0 && r === Xm())
    return new Date(e).getTimezoneOffset() * -6e4;
  let { year: t, month: a, day: n, hour: i, minute: s, second: o } = Jm(e, r);
  return Zm(t, a, n, i, s, o, 0) - Math.floor(e / 1e3) * 1e3;
}
const md = /* @__PURE__ */ new Map();
function Jm(e, r) {
  let t = md.get(r);
  t || (t = new Intl.DateTimeFormat("en-US", {
    timeZone: r,
    hour12: !1,
    era: "short",
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  }), md.set(r, t));
  let a = t.formatToParts(new Date(e)), n = {};
  for (let i of a)
    i.type !== "literal" && (n[i.type] = i.value);
  return {
    // Firefox returns B instead of BC... https://bugzilla.mozilla.org/show_bug.cgi?id=1752253
    year: n.era === "BC" || n.era === "B" ? -n.year + 1 : +n.year,
    month: +n.month,
    day: +n.day,
    hour: n.hour === "24" ? 0 : +n.hour,
    minute: +n.minute,
    second: +n.second
  };
}
const pd = 864e5;
function vw(e, r, t, a) {
  return (t === a ? [
    t
  ] : [
    t,
    a
  ]).filter((i) => gw(e, r, i));
}
function gw(e, r, t) {
  let a = Jm(t, r);
  return e.year === a.year && e.month === a.month && e.day === a.day && e.hour === a.hour && e.minute === a.minute && e.second === a.second;
}
function yw(e, r, t = "compatible") {
  let a = qi(e);
  if (r === "UTC")
    return hd(a);
  if (r === Xm() && t === "compatible") {
    a = fc(a, new u0());
    let u = /* @__PURE__ */ new Date(), l = cc(a.era, a.year);
    return u.setFullYear(l, a.month - 1, a.day), u.setHours(a.hour, a.minute, a.second, a.millisecond), u.getTime();
  }
  let n = hd(a), i = xd(n - pd, r), s = xd(n + pd, r), o = vw(a, r, n - i, n - s);
  if (o.length === 1)
    return o[0];
  if (o.length > 1)
    switch (t) {
      case "compatible":
      case "earlier":
        return o[0];
      case "later":
        return o[o.length - 1];
      case "reject":
        throw new RangeError("Multiple possible absolute times found");
    }
  switch (t) {
    case "earlier":
      return Math.min(n - i, n - s);
    case "compatible":
    case "later":
      return Math.max(n - i, n - s);
    case "reject":
      throw new RangeError("No such absolute time found");
  }
}
function qm(e, r, t = "compatible") {
  return new Date(yw(e, r, t));
}
function cl(e) {
  return new Qi(e.calendar, e.era, e.year, e.month, e.day);
}
function qi(e, r) {
  let t = 0, a = 0, n = 0, i = 0;
  if ("timeZone" in e)
    ({ hour: t, minute: a, second: n, millisecond: i } = e);
  else if ("hour" in e && !r)
    return e;
  return r && ({ hour: t, minute: a, second: n, millisecond: i } = r), new Po(e.calendar, e.era, e.year, e.month, e.day, t, a, n, i);
}
function fc(e, r) {
  if (e.calendar.identifier === r.identifier)
    return e;
  let t = r.fromJulianDay(e.calendar.toJulianDay(e)), a = e.copy();
  return a.calendar = r, a.era = t.era, a.year = t.year, a.month = t.month, a.day = t.day, si(a), a;
}
function dc(e, r) {
  let t = e.copy(), a = "hour" in t ? ip(t, r) : 0;
  fl(t, r.years || 0), t.calendar.balanceYearMonth && t.calendar.balanceYearMonth(t, e), t.month += r.months || 0, dl(t), Qm(t), t.day += (r.weeks || 0) * 7, t.day += r.days || 0, t.day += a, bw(t), t.calendar.balanceDate && t.calendar.balanceDate(t), t.year < 1 && (t.year = 1, t.month = 1, t.day = 1);
  let n = t.calendar.getYearsInEra(t);
  if (t.year > n) {
    var i, s;
    let u = (i = (s = t.calendar).isInverseEra) === null || i === void 0 ? void 0 : i.call(s, t);
    t.year = n, t.month = u ? 1 : t.calendar.getMonthsInYear(t), t.day = u ? 1 : t.calendar.getDaysInMonth(t);
  }
  t.month < 1 && (t.month = 1, t.day = 1);
  let o = t.calendar.getMonthsInYear(t);
  return t.month > o && (t.month = o, t.day = t.calendar.getDaysInMonth(t)), t.day = Math.max(1, Math.min(t.calendar.getDaysInMonth(t), t.day)), t;
}
function fl(e, r) {
  var t, a;
  !((t = (a = e.calendar).isInverseEra) === null || t === void 0) && t.call(a, e) && (r = -r), e.year += r;
}
function dl(e) {
  for (; e.month < 1; )
    fl(e, -1), e.month += e.calendar.getMonthsInYear(e);
  let r = 0;
  for (; e.month > (r = e.calendar.getMonthsInYear(e)); )
    e.month -= r, fl(e, 1);
}
function bw(e) {
  for (; e.day < 1; )
    e.month--, dl(e), e.day += e.calendar.getDaysInMonth(e);
  for (; e.day > e.calendar.getDaysInMonth(e); )
    e.day -= e.calendar.getDaysInMonth(e), e.month++, dl(e);
}
function Qm(e) {
  e.month = Math.max(1, Math.min(e.calendar.getMonthsInYear(e), e.month)), e.day = Math.max(1, Math.min(e.calendar.getDaysInMonth(e), e.day));
}
function si(e) {
  e.calendar.constrainDate && e.calendar.constrainDate(e), e.year = Math.max(1, Math.min(e.calendar.getYearsInEra(e), e.year)), Qm(e);
}
function ep(e) {
  let r = {};
  for (let t in e)
    typeof e[t] == "number" && (r[t] = -e[t]);
  return r;
}
function rp(e, r) {
  return dc(e, ep(r));
}
function tp(e, r) {
  let t = e.copy();
  return r.era != null && (t.era = r.era), r.year != null && (t.year = r.year), r.month != null && (t.month = r.month), r.day != null && (t.day = r.day), si(t), t;
}
function ap(e, r) {
  let t = e.copy();
  return r.hour != null && (t.hour = r.hour), r.minute != null && (t.minute = r.minute), r.second != null && (t.second = r.second), r.millisecond != null && (t.millisecond = r.millisecond), np(t), t;
}
function ww(e) {
  e.second += Math.floor(e.millisecond / 1e3), e.millisecond = qs(e.millisecond, 1e3), e.minute += Math.floor(e.second / 60), e.second = qs(e.second, 60), e.hour += Math.floor(e.minute / 60), e.minute = qs(e.minute, 60);
  let r = Math.floor(e.hour / 24);
  return e.hour = qs(e.hour, 24), r;
}
function np(e) {
  e.millisecond = Math.max(0, Math.min(e.millisecond, 1e3)), e.second = Math.max(0, Math.min(e.second, 59)), e.minute = Math.max(0, Math.min(e.minute, 59)), e.hour = Math.max(0, Math.min(e.hour, 23));
}
function qs(e, r) {
  let t = e % r;
  return t < 0 && (t += r), t;
}
function ip(e, r) {
  return e.hour += r.hours || 0, e.minute += r.minutes || 0, e.second += r.seconds || 0, e.millisecond += r.milliseconds || 0, ww(e);
}
function sp(e, r) {
  let t = e.copy();
  return ip(t, r), t;
}
function _w(e, r) {
  return sp(e, ep(r));
}
function op(e, r, t, a) {
  let n = e.copy();
  switch (r) {
    case "era": {
      let o = e.calendar.getEras(), u = o.indexOf(e.era);
      if (u < 0)
        throw new Error("Invalid era: " + e.era);
      u = Ca(u, t, 0, o.length - 1, a == null ? void 0 : a.round), n.era = o[u], si(n);
      break;
    }
    case "year":
      var i, s;
      !((i = (s = n.calendar).isInverseEra) === null || i === void 0) && i.call(s, n) && (t = -t), n.year = Ca(e.year, t, -1 / 0, 9999, a == null ? void 0 : a.round), n.year === -1 / 0 && (n.year = 1), n.calendar.balanceYearMonth && n.calendar.balanceYearMonth(n, e);
      break;
    case "month":
      n.month = Ca(e.month, t, 1, e.calendar.getMonthsInYear(e), a == null ? void 0 : a.round);
      break;
    case "day":
      n.day = Ca(e.day, t, 1, e.calendar.getDaysInMonth(e), a == null ? void 0 : a.round);
      break;
    default:
      throw new Error("Unsupported field " + r);
  }
  return e.calendar.balanceDate && e.calendar.balanceDate(n), si(n), n;
}
function up(e, r, t, a) {
  let n = e.copy();
  switch (r) {
    case "hour": {
      let i = e.hour, s = 0, o = 23;
      if ((a == null ? void 0 : a.hourCycle) === 12) {
        let u = i >= 12;
        s = u ? 12 : 0, o = u ? 23 : 11;
      }
      n.hour = Ca(i, t, s, o, a == null ? void 0 : a.round);
      break;
    }
    case "minute":
      n.minute = Ca(e.minute, t, 0, 59, a == null ? void 0 : a.round);
      break;
    case "second":
      n.second = Ca(e.second, t, 0, 59, a == null ? void 0 : a.round);
      break;
    case "millisecond":
      n.millisecond = Ca(e.millisecond, t, 0, 999, a == null ? void 0 : a.round);
      break;
    default:
      throw new Error("Unsupported field " + r);
  }
  return n;
}
function Ca(e, r, t, a, n = !1) {
  if (n) {
    e += Math.sign(r), e < t && (e = a);
    let i = Math.abs(r);
    r > 0 ? e = Math.ceil(e / i) * i : e = Math.floor(e / i) * i, e > a && (e = t);
  } else
    e += r, e < t ? e = a - (t - e - 1) : e > a && (e = t + (e - a - 1));
  return e;
}
function lp(e) {
  return `${String(e.hour).padStart(2, "0")}:${String(e.minute).padStart(2, "0")}:${String(e.second).padStart(2, "0")}${e.millisecond ? String(e.millisecond / 1e3).slice(1) : ""}`;
}
function cp(e) {
  let r = fc(e, new u0()), t;
  return r.era === "BC" ? t = r.year === 1 ? "0000" : "-" + String(Math.abs(1 - r.year)).padStart(6, "00") : t = String(r.year).padStart(4, "0"), `${t}-${String(r.month).padStart(2, "0")}-${String(r.day).padStart(2, "0")}`;
}
function $w(e) {
  return `${cp(e)}T${lp(e)}`;
}
function fp(e) {
  let r = typeof e[0] == "object" ? e.shift() : new u0(), t;
  if (typeof e[0] == "string")
    t = e.shift();
  else {
    let s = r.getEras();
    t = s[s.length - 1];
  }
  let a = e.shift(), n = e.shift(), i = e.shift();
  return [
    r,
    t,
    a,
    n,
    i
  ];
}
var Dw = /* @__PURE__ */ new WeakMap();
class Qi {
  /** Returns a copy of this date. */
  copy() {
    return this.era ? new Qi(this.calendar, this.era, this.year, this.month, this.day) : new Qi(this.calendar, this.year, this.month, this.day);
  }
  /** Returns a new `CalendarDate` with the given duration added to it. */
  add(r) {
    return dc(this, r);
  }
  /** Returns a new `CalendarDate` with the given duration subtracted from it. */
  subtract(r) {
    return rp(this, r);
  }
  /** Returns a new `CalendarDate` with the given fields set to the provided values. Other fields will be constrained accordingly. */
  set(r) {
    return tp(this, r);
  }
  /**
  * Returns a new `CalendarDate` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(r, t, a) {
    return op(this, r, t, a);
  }
  /** Converts the date to a native JavaScript Date object, with the time set to midnight in the given time zone. */
  toDate(r) {
    return qm(this, r);
  }
  /** Converts the date to an ISO 8601 formatted string. */
  toString() {
    return cp(this);
  }
  /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */
  compare(r) {
    return Km(this, r);
  }
  constructor(...r) {
    at(this, Dw, {
      writable: !0,
      value: void 0
    });
    let [t, a, n, i, s] = fp(r);
    this.calendar = t, this.era = a, this.year = n, this.month = i, this.day = s, si(this);
  }
}
var Ew = /* @__PURE__ */ new WeakMap();
class hc {
  /** Returns a copy of this time. */
  copy() {
    return new hc(this.hour, this.minute, this.second, this.millisecond);
  }
  /** Returns a new `Time` with the given duration added to it. */
  add(r) {
    return sp(this, r);
  }
  /** Returns a new `Time` with the given duration subtracted from it. */
  subtract(r) {
    return _w(this, r);
  }
  /** Returns a new `Time` with the given fields set to the provided values. Other fields will be constrained accordingly. */
  set(r) {
    return ap(this, r);
  }
  /**
  * Returns a new `Time` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(r, t, a) {
    return up(this, r, t, a);
  }
  /** Converts the time to an ISO 8601 formatted string. */
  toString() {
    return lp(this);
  }
  /** Compares this time with another. A negative result indicates that this time is before the given one, and a positive time indicates that it is after. */
  compare(r) {
    return Ym(this, r);
  }
  constructor(r = 0, t = 0, a = 0, n = 0) {
    at(this, Ew, {
      writable: !0,
      value: void 0
    }), this.hour = r, this.minute = t, this.second = a, this.millisecond = n, np(this);
  }
}
var kw = /* @__PURE__ */ new WeakMap();
class Po {
  /** Returns a copy of this date. */
  copy() {
    return this.era ? new Po(this.calendar, this.era, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond) : new Po(this.calendar, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond);
  }
  /** Returns a new `CalendarDateTime` with the given duration added to it. */
  add(r) {
    return dc(this, r);
  }
  /** Returns a new `CalendarDateTime` with the given duration subtracted from it. */
  subtract(r) {
    return rp(this, r);
  }
  /** Returns a new `CalendarDateTime` with the given fields set to the provided values. Other fields will be constrained accordingly. */
  set(r) {
    return tp(ap(this, r), r);
  }
  /**
  * Returns a new `CalendarDateTime` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(r, t, a) {
    switch (r) {
      case "era":
      case "year":
      case "month":
      case "day":
        return op(this, r, t, a);
      default:
        return up(this, r, t, a);
    }
  }
  /** Converts the date to a native JavaScript Date object in the given time zone. */
  toDate(r, t) {
    return qm(this, r, t);
  }
  /** Converts the date to an ISO 8601 formatted string. */
  toString() {
    return $w(this);
  }
  /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */
  compare(r) {
    let t = Km(this, r);
    return t === 0 ? Ym(this, qi(r)) : t;
  }
  constructor(...r) {
    at(this, kw, {
      writable: !0,
      value: void 0
    });
    let [t, a, n, i, s] = fp(r);
    this.calendar = t, this.era = a, this.year = n, this.month = i, this.day = s, this.hour = r.shift() || 0, this.minute = r.shift() || 0, this.second = r.shift() || 0, this.millisecond = r.shift() || 0, si(this);
  }
}
let iu = /* @__PURE__ */ new Map();
class Hn {
  /** Formats a date as a string according to the locale and format options passed to the constructor. */
  format(r) {
    return this.formatter.format(r);
  }
  /** Formats a date to an array of parts such as separators, numbers, punctuation, and more. */
  formatToParts(r) {
    return this.formatter.formatToParts(r);
  }
  /** Formats a date range as a string. */
  formatRange(r, t) {
    if (typeof this.formatter.formatRange == "function")
      return this.formatter.formatRange(r, t);
    if (t < r)
      throw new RangeError("End date must be >= start date");
    return `${this.formatter.format(r)} – ${this.formatter.format(t)}`;
  }
  /** Formats a date range as an array of parts. */
  formatRangeToParts(r, t) {
    if (typeof this.formatter.formatRangeToParts == "function")
      return this.formatter.formatRangeToParts(r, t);
    if (t < r)
      throw new RangeError("End date must be >= start date");
    let a = this.formatter.formatToParts(r), n = this.formatter.formatToParts(t);
    return [
      ...a.map((i) => ({
        ...i,
        source: "startRange"
      })),
      {
        type: "literal",
        value: " – ",
        source: "shared"
      },
      ...n.map((i) => ({
        ...i,
        source: "endRange"
      }))
    ];
  }
  /** Returns the resolved formatting options based on the values passed to the constructor. */
  resolvedOptions() {
    let r = this.formatter.resolvedOptions();
    return Cw() && (this.resolvedHourCycle || (this.resolvedHourCycle = Fw(r.locale, this.options)), r.hourCycle = this.resolvedHourCycle, r.hour12 = this.resolvedHourCycle === "h11" || this.resolvedHourCycle === "h12"), r.calendar === "ethiopic-amete-alem" && (r.calendar = "ethioaa"), r;
  }
  constructor(r, t = {}) {
    this.formatter = dp(r, t), this.options = t;
  }
}
const Tw = {
  true: {
    // Only Japanese uses the h11 style for 12 hour time. All others use h12.
    ja: "h11"
  },
  false: {}
};
function dp(e, r = {}) {
  if (typeof r.hour12 == "boolean" && Sw()) {
    r = {
      ...r
    };
    let n = Tw[String(r.hour12)][e.split("-")[0]], i = r.hour12 ? "h12" : "h23";
    r.hourCycle = n ?? i, delete r.hour12;
  }
  let t = e + (r ? Object.entries(r).sort((n, i) => n[0] < i[0] ? -1 : 1).join() : "");
  if (iu.has(t))
    return iu.get(t);
  let a = new Intl.DateTimeFormat(e, r);
  return iu.set(t, a), a;
}
let su = null;
function Sw() {
  return su == null && (su = new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    hour12: !1
  }).format(new Date(2020, 2, 3, 0)) === "24"), su;
}
let ou = null;
function Cw() {
  return ou == null && (ou = new Intl.DateTimeFormat("fr", {
    hour: "numeric",
    hour12: !1
  }).resolvedOptions().hourCycle === "h12"), ou;
}
function Fw(e, r) {
  if (!r.timeStyle && !r.hour)
    return;
  e = e.replace(/(-u-)?-nu-[a-zA-Z0-9]+/, ""), e += (e.includes("-u-") ? "" : "-u") + "-nu-latn";
  let t = dp(e, {
    ...r,
    timeZone: void 0
    // use local timezone
  }), a = parseInt(t.formatToParts(new Date(2020, 2, 3, 0)).find((i) => i.type === "hour").value, 10), n = parseInt(t.formatToParts(new Date(2020, 2, 3, 23)).find((i) => i.type === "hour").value, 10);
  if (a === 0 && n === 23)
    return "h23";
  if (a === 24 && n === 23)
    return "h24";
  if (a === 0 && n === 11)
    return "h11";
  if (a === 12 && n === 11)
    return "h12";
  throw new Error("Unexpected hour cycle result");
}
const Aw = Symbol.for("react-aria.i18n.locale"), Rw = Symbol.for("react-aria.i18n.strings");
let Sn;
class ws {
  /** Returns a localized string for the given key and locale. */
  getStringForLocale(r, t) {
    let n = this.getStringsForLocale(t)[r];
    if (!n)
      throw new Error(`Could not find intl message ${r} in ${t} locale`);
    return n;
  }
  /** Returns all localized strings for the given locale. */
  getStringsForLocale(r) {
    let t = this.strings[r];
    return t || (t = Iw(r, this.strings, this.defaultLocale), this.strings[r] = t), t;
  }
  static getGlobalDictionaryForPackage(r) {
    if (typeof window > "u")
      return null;
    let t = window[Aw];
    if (Sn === void 0) {
      let n = window[Rw];
      if (!n)
        return null;
      Sn = {};
      for (let i in n)
        Sn[i] = new ws({
          [t]: n[i]
        }, t);
    }
    let a = Sn == null ? void 0 : Sn[r];
    if (!a)
      throw new Error(`Strings for package "${r}" were not included by LocalizedStringProvider. Please add it to the list passed to createLocalizedStringDictionary.`);
    return a;
  }
  constructor(r, t = "en-US") {
    this.strings = Object.fromEntries(Object.entries(r).filter(([, a]) => a)), this.defaultLocale = t;
  }
}
function Iw(e, r, t = "en-US") {
  if (r[e])
    return r[e];
  let a = Bw(e);
  if (r[a])
    return r[a];
  for (let n in r)
    if (n.startsWith(a + "-"))
      return r[n];
  return r[t];
}
function Bw(e) {
  return Intl.Locale ? new Intl.Locale(e).language : e.split("-")[0];
}
const vd = /* @__PURE__ */ new Map(), gd = /* @__PURE__ */ new Map();
class Pw {
  /** Formats a localized string for the given key with the provided variables. */
  format(r, t) {
    let a = this.strings.getStringForLocale(r, this.locale);
    return typeof a == "function" ? a(t, this) : a;
  }
  plural(r, t, a = "cardinal") {
    let n = t["=" + r];
    if (n)
      return typeof n == "function" ? n() : n;
    let i = this.locale + ":" + a, s = vd.get(i);
    s || (s = new Intl.PluralRules(this.locale, {
      type: a
    }), vd.set(i, s));
    let o = s.select(r);
    return n = t[o] || t.other, typeof n == "function" ? n() : n;
  }
  number(r) {
    let t = gd.get(this.locale);
    return t || (t = new Intl.NumberFormat(this.locale), gd.set(this.locale, t)), t.format(r);
  }
  select(r, t) {
    let a = r[t] || r.other;
    return typeof a == "function" ? a() : a;
  }
  constructor(r, t) {
    this.locale = r, this.strings = t;
  }
}
const l0 = {
  badInput: !1,
  customError: !1,
  patternMismatch: !1,
  rangeOverflow: !1,
  rangeUnderflow: !1,
  stepMismatch: !1,
  tooLong: !1,
  tooShort: !1,
  typeMismatch: !1,
  valueMissing: !1,
  valid: !0
}, hp = {
  ...l0,
  customError: !0,
  valid: !1
}, Ci = {
  isInvalid: !1,
  validationDetails: l0,
  validationErrors: []
}, Mw = Ze({}), yd = "__formValidationState" + Date.now();
function xp(e) {
  if (e[yd]) {
    let { realtimeValidation: r, displayValidation: t, updateValidation: a, resetValidation: n, commitValidation: i } = e[yd];
    return {
      realtimeValidation: r,
      displayValidation: t,
      updateValidation: a,
      resetValidation: n,
      commitValidation: i
    };
  }
  return Ow(e);
}
function Ow(e) {
  let { isInvalid: r, validationState: t, name: a, value: n, builtinValidation: i, validate: s, validationBehavior: o = "aria" } = e;
  t && (r || (r = t === "invalid"));
  let u = r !== void 0 ? {
    isInvalid: r,
    validationErrors: [],
    validationDetails: hp
  } : null, l = Pe(() => {
    if (!s || n == null)
      return null;
    let A = Lw(s, n);
    return bd(A);
  }, [
    s,
    n
  ]);
  i != null && i.validationDetails.valid && (i = void 0);
  let c = Sr(Mw), f = Pe(() => a ? Array.isArray(a) ? a.flatMap((A) => hl(c[A])) : hl(c[a]) : [], [
    c,
    a
  ]), [h, d] = He(c), [m, x] = He(!1);
  c !== h && (d(c), x(!1));
  let p = Pe(() => bd(m ? [] : f), [
    m,
    f
  ]), w = ze(Ci), [D, y] = He(Ci), B = ze(Ci), L = () => {
    if (!U)
      return;
    k(!1);
    let A = l || i || w.current;
    uu(A, B.current) || (B.current = A, y(A));
  }, [U, k] = He(!1);
  return Hr(L), {
    realtimeValidation: u || p || l || i || Ci,
    displayValidation: o === "native" ? u || p || D : u || p || l || i || D,
    updateValidation(A) {
      o === "aria" && !uu(D, A) ? y(A) : w.current = A;
    },
    resetValidation() {
      let A = Ci;
      uu(A, B.current) || (B.current = A, y(A)), o === "native" && k(!1), x(!0);
    },
    commitValidation() {
      o === "native" && k(!0), x(!0);
    }
  };
}
function hl(e) {
  return e ? Array.isArray(e) ? e : [
    e
  ] : [];
}
function Lw(e, r) {
  if (typeof e == "function") {
    let t = e(r);
    if (t && typeof t != "boolean")
      return hl(t);
  }
  return [];
}
function bd(e) {
  return e.length ? {
    isInvalid: !0,
    validationErrors: e,
    validationDetails: hp
  } : null;
}
function uu(e, r) {
  return e === r ? !0 : !!e && !!r && e.isInvalid === r.isInvalid && e.validationErrors.length === r.validationErrors.length && e.validationErrors.every((t, a) => t === r.validationErrors[a]) && Object.entries(e.validationDetails).every(([t, a]) => r.validationDetails[t] === a);
}
function wd(...e) {
  let r = /* @__PURE__ */ new Set(), t = !1, a = {
    ...l0
  };
  for (let s of e) {
    var n, i;
    for (let o of s.validationErrors)
      r.add(o);
    t || (t = s.isInvalid);
    for (let o in a)
      (n = a)[i = o] || (n[i] = s.validationDetails[o]);
  }
  return a.valid = !t, {
    isInvalid: t,
    validationErrors: [
      ...r
    ],
    validationDetails: a
  };
}
function Nw(e) {
  return e && e.__esModule ? e.default : e;
}
const mp = new ws(Nw(zm));
function pp() {
  return typeof navigator < "u" && (navigator.language || navigator.userLanguage) || "en-US";
}
function xl(e, r, t, a, n) {
  let i = e != null && t != null && e.compare(t) > 0, s = e != null && r != null && e.compare(r) < 0, o = e != null && (a == null ? void 0 : a(e)) || !1, u = i || s || o, l = [];
  if (u) {
    let c = pp(), f = ws.getGlobalDictionaryForPackage("@react-stately/datepicker") || mp, h = new Pw(c, f), d = new Hn(c, jn({}, n)), m = d.resolvedOptions().timeZone;
    s && r != null && l.push(h.format("rangeUnderflow", {
      minValue: d.format(r.toDate(m))
    })), i && t != null && l.push(h.format("rangeOverflow", {
      maxValue: d.format(t.toDate(m))
    })), o && l.push(h.format("unavailableDate"));
  }
  return {
    isInvalid: u,
    validationErrors: l,
    validationDetails: {
      badInput: o,
      customError: !1,
      patternMismatch: !1,
      rangeOverflow: i,
      rangeUnderflow: s,
      stepMismatch: !1,
      tooLong: !1,
      tooShort: !1,
      typeMismatch: !1,
      valueMissing: !1,
      valid: !u
    }
  };
}
function Uw(e, r, t, a, n) {
  var i;
  let s = xl((i = e == null ? void 0 : e.start) !== null && i !== void 0 ? i : null, r, t, a, n);
  var o;
  let u = xl((o = e == null ? void 0 : e.end) !== null && o !== void 0 ? o : null, r, t, a, n), l = wd(s, u);
  if ((e == null ? void 0 : e.end) != null && e.start != null && e.end.compare(e.start) < 0) {
    let c = ws.getGlobalDictionaryForPackage("@react-stately/datepicker") || mp;
    l = wd(l, {
      isInvalid: !0,
      validationErrors: [
        c.getStringForLocale("rangeReversed", pp())
      ],
      validationDetails: {
        ...l0,
        rangeUnderflow: !0,
        rangeOverflow: !0,
        valid: !1
      }
    });
  }
  return l;
}
const Vw = {
  year: "numeric",
  month: "numeric",
  day: "numeric",
  hour: "numeric",
  minute: "2-digit",
  second: "2-digit"
}, Ww = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit"
};
function jn(e, r) {
  e = {
    ...r.shouldForceLeadingZeros ? Ww : Vw,
    ...e
  };
  let a = r.granularity || "minute", n = Object.keys(e);
  var i;
  let s = n.indexOf((i = r.maxGranularity) !== null && i !== void 0 ? i : "year");
  s < 0 && (s = 0);
  let o = n.indexOf(a);
  if (o < 0 && (o = 2), s > o)
    throw new Error("maxGranularity must be greater than granularity");
  let u = n.slice(s, o + 1).reduce((c, f) => (c[f] = e[f], c), {});
  return r.hourCycle != null && (u.hour12 = r.hourCycle === 12), u.timeZone = r.timeZone || "UTC", (a === "hour" || a === "minute" || a === "second") && r.timeZone && !r.hideTimeZone && (u.timeZoneName = "short"), r.showEra && s === 0 && (u.era = "short"), u;
}
function Pn(e) {
  return e && "hour" in e ? e : new hc();
}
function vp(e, r) {
  let t = e && "timeZone" in e ? e.timeZone : void 0, a = e && "minute" in e ? "minute" : "day";
  if (e && r && !(r in e))
    throw new Error("Invalid granularity " + r + " for value " + e.toString());
  let [n, i] = He([
    a,
    t
  ]);
  e && (n[0] !== a || n[1] !== t) && i([
    a,
    t
  ]), r || (r = e ? a : n[0]);
  let s = e ? t : n[1];
  return [
    r,
    s
  ];
}
function Hw(e) {
  let r = cm(e), [t, a] = qn(e.value, e.defaultValue || null, e.onChange), n = t || e.placeholderValue || null, [i, s] = vp(n, e.granularity), o = t != null ? t.toDate(s ?? "UTC") : null, u = i === "hour" || i === "minute" || i === "second";
  var l;
  let c = (l = e.shouldCloseOnSelect) !== null && l !== void 0 ? l : !0, [f, h] = He(null), [d, m] = He(null);
  if (t && (f = t, "hour" in t && (d = t)), n && !(i in n))
    throw new Error("Invalid granularity " + i + " for value " + n.toString());
  let x = (t == null ? void 0 : t.calendar.identifier) === "gregory" && t.era === "BC", p = Pe(() => ({
    granularity: i,
    timeZone: s,
    hideTimeZone: e.hideTimeZone,
    hourCycle: e.hourCycle,
    shouldForceLeadingZeros: e.shouldForceLeadingZeros,
    showEra: x
  }), [
    i,
    e.hourCycle,
    e.shouldForceLeadingZeros,
    s,
    e.hideTimeZone,
    x
  ]), { minValue: w, maxValue: D, isDateUnavailable: y } = e, B = Pe(() => xl(t, w, D, y, p), [
    t,
    w,
    D,
    y,
    p
  ]), L = xp({
    ...e,
    value: t,
    builtinValidation: B
  }), U = L.displayValidation.isInvalid, k = e.validationState || (U ? "invalid" : null), v = (T, C) => {
    a("timeZone" in C ? C.set(cl(T)) : qi(T, C)), h(null), m(null), L.commitValidation();
  };
  return {
    ...L,
    value: t,
    setValue: a,
    dateValue: f,
    timeValue: d,
    setDateValue: (T) => {
      let C = typeof c == "function" ? c() : c;
      u ? d || C ? v(T, d || Pn(e.defaultValue || e.placeholderValue)) : h(T) : (a(T), L.commitValidation()), C && r.setOpen(!1);
    },
    setTimeValue: (T) => {
      f && T ? v(f, T) : m(T);
    },
    granularity: i,
    hasTime: u,
    ...r,
    setOpen(T) {
      !T && !t && f && u && v(f, d || Pn(e.defaultValue || e.placeholderValue)), r.setOpen(T);
    },
    validationState: k,
    isInvalid: U,
    formatValue(T, C) {
      if (!o)
        return "";
      let I = jn(C, p);
      return new Hn(T, I).format(o);
    },
    getDateFormatter(T, C) {
      let I = {
        ...p,
        ...C
      }, Y = jn({}, I);
      return new Hn(T, Y);
    }
  };
}
function jw(e) {
  var r, t;
  let a = cm(e), [n, i] = qn(e.value, e.defaultValue || null, e.onChange), [s, o] = He(() => n || {
    start: null,
    end: null
  });
  n == null && s.start && s.end && (s = {
    start: null,
    end: null
  }, o(s));
  let u = n || s, l = (J) => {
    o(J || {
      start: null,
      end: null
    }), Ka(J) ? i(J) : i(null);
  }, c = (u == null ? void 0 : u.start) || (u == null ? void 0 : u.end) || e.placeholderValue || null, [f, h] = vp(c, e.granularity), d = f === "hour" || f === "minute" || f === "second";
  var m;
  let x = (m = e.shouldCloseOnSelect) !== null && m !== void 0 ? m : !0, [p, w] = He(null), [D, y] = He(null);
  u && Ka(u) && (p = u, "hour" in u.start && (D = u));
  let B = (J, W) => {
    l({
      start: "timeZone" in W.start ? W.start.set(cl(J.start)) : qi(J.start, W.start),
      end: "timeZone" in W.end ? W.end.set(cl(J.end)) : qi(J.end, W.end)
    }), w(null), y(null), I.commitValidation();
  }, L = (J) => {
    let W = typeof x == "function" ? x() : x;
    d ? Ka(J) && (D != null && D.start) && (D != null && D.end) ? B(J, {
      start: (D == null ? void 0 : D.start) || Pn(e.placeholderValue),
      end: (D == null ? void 0 : D.end) || Pn(e.placeholderValue)
    }) : w(J) : Ka(J) ? (l(J), I.commitValidation()) : w(J), W && a.setOpen(!1);
  }, U = (J) => {
    Ka(p) && Ka(J) ? B(p, J) : y(J);
  }, k = (u == null || (r = u.start) === null || r === void 0 ? void 0 : r.calendar.identifier) === "gregory" && u.start.era === "BC" || (u == null || (t = u.end) === null || t === void 0 ? void 0 : t.calendar.identifier) === "gregory" && u.end.era === "BC", v = Pe(() => ({
    granularity: f,
    timeZone: h,
    hideTimeZone: e.hideTimeZone,
    hourCycle: e.hourCycle,
    shouldForceLeadingZeros: e.shouldForceLeadingZeros,
    showEra: k
  }), [
    f,
    e.hourCycle,
    e.shouldForceLeadingZeros,
    h,
    e.hideTimeZone,
    k
  ]), { minValue: b, maxValue: A, isDateUnavailable: T } = e, C = Pe(() => Uw(u, b, A, T, v), [
    u,
    b,
    A,
    T,
    v
  ]), I = xp({
    ...e,
    value: n,
    name: Pe(() => [
      e.startName,
      e.endName
    ].filter((J) => J != null), [
      e.startName,
      e.endName
    ]),
    builtinValidation: C
  }), Y = I.displayValidation.isInvalid, j = e.validationState || (Y ? "invalid" : null);
  return {
    ...I,
    value: u,
    setValue: l,
    dateRange: p,
    timeRange: D,
    granularity: f,
    hasTime: d,
    setDate(J, W) {
      var ce, V;
      L(J === "start" ? {
        start: W,
        end: (ce = p == null ? void 0 : p.end) !== null && ce !== void 0 ? ce : null
      } : {
        start: (V = p == null ? void 0 : p.start) !== null && V !== void 0 ? V : null,
        end: W
      });
    },
    setTime(J, W) {
      var ce, V;
      U(J === "start" ? {
        start: W,
        end: (ce = D == null ? void 0 : D.end) !== null && ce !== void 0 ? ce : null
      } : {
        start: (V = D == null ? void 0 : D.start) !== null && V !== void 0 ? V : null,
        end: W
      });
    },
    setDateTime(J, W) {
      var ce, V;
      l(J === "start" ? {
        start: W,
        end: (ce = u == null ? void 0 : u.end) !== null && ce !== void 0 ? ce : null
      } : {
        start: (V = u == null ? void 0 : u.start) !== null && V !== void 0 ? V : null,
        end: W
      });
    },
    setDateRange: L,
    setTimeRange: U,
    ...a,
    setOpen(J) {
      !J && !(u != null && u.start && (u != null && u.end)) && Ka(p) && d && B(p, {
        start: (D == null ? void 0 : D.start) || Pn(e.placeholderValue),
        end: (D == null ? void 0 : D.end) || Pn(e.placeholderValue)
      }), a.setOpen(J);
    },
    validationState: j,
    isInvalid: Y,
    formatValue(J, W) {
      if (!u || !u.start || !u.end)
        return null;
      let ce = "timeZone" in u.start ? u.start.timeZone : void 0, V = e.granularity || (u.start && "minute" in u.start ? "minute" : "day"), ee = "timeZone" in u.end ? u.end.timeZone : void 0, de = e.granularity || (u.end && "minute" in u.end ? "minute" : "day"), F = jn(W, {
        granularity: V,
        timeZone: ce,
        hideTimeZone: e.hideTimeZone,
        hourCycle: e.hourCycle,
        showEra: u.start.calendar.identifier === "gregory" && u.start.era === "BC" || u.end.calendar.identifier === "gregory" && u.end.era === "BC"
      }), H = u.start.toDate(ce || "UTC"), P = u.end.toDate(ee || "UTC"), N = new Hn(J, F), X;
      if (ce === ee && V === de && u.start.compare(u.end) !== 0) {
        try {
          let ae = N.formatRangeToParts(H, P), ie = -1;
          for (let ve = 0; ve < ae.length; ve++) {
            let M = ae[ve];
            if (M.source === "shared" && M.type === "literal")
              ie = ve;
            else if (M.source === "endRange")
              break;
          }
          let q = "", re = "";
          for (let ve = 0; ve < ae.length; ve++)
            ve < ie ? q += ae[ve].value : ve > ie && (re += ae[ve].value);
          return {
            start: q,
            end: re
          };
        } catch {
        }
        X = N;
      } else {
        let ae = jn(W, {
          granularity: de,
          timeZone: ee,
          hideTimeZone: e.hideTimeZone,
          hourCycle: e.hourCycle
        });
        X = new Hn(J, ae);
      }
      return {
        start: N.format(H),
        end: X.format(P)
      };
    },
    getDateFormatter(J, W) {
      let ce = {
        ...v,
        ...W
      }, V = jn({}, ce);
      return new Hn(J, V);
    }
  };
}
function Ka(e) {
  return (e == null ? void 0 : e.start) != null && e.end != null;
}
const gp = /* @__PURE__ */ Ze({}), yp = /* @__PURE__ */ Ze({}), c0 = /* @__PURE__ */ Ze(null), f0 = /* @__PURE__ */ Ze(null);
function zw(e, r) {
  [e, r] = da(e, r, gp);
  let { locale: t } = Kt(), a = lm({
    ...e,
    locale: t,
    createCalendar: z4
  }), { calendarProps: n, prevButtonProps: i, nextButtonProps: s, errorMessageProps: o, title: u } = Ey(e, a), l = Ua({
    ...e,
    values: {
      state: a,
      isDisabled: e.isDisabled || !1,
      isInvalid: a.isValueInvalid
    },
    defaultClassName: "react-aria-Calendar"
  });
  return /* @__PURE__ */ ye.createElement("div", {
    ...l,
    ...n,
    ref: r,
    slot: e.slot || void 0,
    "data-disabled": e.isDisabled || void 0,
    "data-invalid": a.isValueInvalid || void 0
  }, /* @__PURE__ */ ye.createElement(ps, {
    values: [
      [
        di,
        {
          slots: {
            previous: i,
            next: s
          }
        }
      ],
      [
        r0,
        {
          "aria-hidden": !0,
          level: 2,
          children: u
        }
      ],
      [
        c0,
        a
      ],
      [
        i0,
        {
          slots: {
            errorMessage: o
          }
        }
      ]
    ]
  }, /* @__PURE__ */ ye.createElement(So, null, /* @__PURE__ */ ye.createElement("h2", null, n["aria-label"])), l.children, /* @__PURE__ */ ye.createElement(So, null, /* @__PURE__ */ ye.createElement("button", {
    "aria-label": s["aria-label"],
    disabled: s.isDisabled,
    onClick: () => a.focusNextPage(),
    tabIndex: -1
  }))));
}
const Gw = /* @__PURE__ */ vt(zw);
function Kw(e, r) {
  [e, r] = da(e, r, yp);
  let { locale: t } = Kt(), a = xw({
    ...e,
    locale: t,
    createCalendar: z4
  }), { calendarProps: n, prevButtonProps: i, nextButtonProps: s, errorMessageProps: o, title: u } = ky(e, a, r), l = Ua({
    ...e,
    values: {
      state: a,
      isDisabled: e.isDisabled || !1,
      isInvalid: a.isValueInvalid
    },
    defaultClassName: "react-aria-RangeCalendar"
  });
  return /* @__PURE__ */ ye.createElement("div", {
    ...l,
    ...n,
    ref: r,
    slot: e.slot || void 0,
    "data-disabled": e.isDisabled || void 0,
    "data-invalid": a.isValueInvalid || void 0
  }, /* @__PURE__ */ ye.createElement(ps, {
    values: [
      [
        di,
        {
          slots: {
            previous: i,
            next: s
          }
        }
      ],
      [
        r0,
        {
          "aria-hidden": !0,
          level: 2,
          children: u
        }
      ],
      [
        f0,
        a
      ],
      [
        i0,
        {
          slots: {
            errorMessage: o
          }
        }
      ]
    ]
  }, /* @__PURE__ */ ye.createElement(So, null, /* @__PURE__ */ ye.createElement("h2", null, n["aria-label"])), l.children, /* @__PURE__ */ ye.createElement(So, null, /* @__PURE__ */ ye.createElement("button", {
    "aria-label": s["aria-label"],
    disabled: s.isDisabled,
    onClick: () => a.focusNextPage(),
    tabIndex: -1
  }))));
}
const Yw = /* @__PURE__ */ vt(Kw), d0 = /* @__PURE__ */ Ze(null);
function Xw(e, r) {
  let t = Sr(c0), a = Sr(f0), n = t ?? a, i = n.visibleRange.start;
  e.offset && (i = i.add(e.offset));
  let { gridProps: s, headerProps: o, weekDays: u } = Ty({
    startDate: i,
    endDate: Zy(i),
    weekdayStyle: e.weekdayStyle
  }, n);
  var l;
  return /* @__PURE__ */ ye.createElement(d0.Provider, {
    value: {
      headerProps: o,
      weekDays: u,
      startDate: i
    }
  }, /* @__PURE__ */ ye.createElement("table", {
    ...lt(e),
    ...s,
    ref: r,
    style: e.style,
    className: (l = e.className) !== null && l !== void 0 ? l : "react-aria-CalendarGrid"
  }, typeof e.children != "function" ? e.children : /* @__PURE__ */ ye.createElement(ye.Fragment, null, /* @__PURE__ */ ye.createElement(Mo, null, (c) => /* @__PURE__ */ ye.createElement(Oo, null, c)), /* @__PURE__ */ ye.createElement(Lo, null, e.children))));
}
const ml = /* @__PURE__ */ vt(Xw);
function Zw(e, r) {
  let { children: t, style: a, className: n } = e, { headerProps: i, weekDays: s } = Sr(d0);
  return /* @__PURE__ */ ye.createElement("thead", {
    ...lt(e),
    ...i,
    ref: r,
    style: a,
    className: n || "react-aria-CalendarGridHeader"
  }, /* @__PURE__ */ ye.createElement("tr", null, s.map((o, u) => /* @__PURE__ */ ye.cloneElement(t(o), {
    key: u
  }))));
}
const Mo = /* @__PURE__ */ vt(Zw);
function Jw(e, r) {
  let { children: t, style: a, className: n } = e;
  return /* @__PURE__ */ ye.createElement("th", {
    ...lt(e),
    ref: r,
    style: a,
    className: n || "react-aria-CalendarHeaderCell"
  }, t);
}
const Oo = /* @__PURE__ */ vt(Jw);
function qw(e, r) {
  let { children: t, style: a, className: n } = e, i = Sr(c0), s = Sr(f0), o = i ?? s, { startDate: u } = Sr(d0), { locale: l } = Kt(), c = Qy(u, l);
  return /* @__PURE__ */ ye.createElement("tbody", {
    ...lt(e),
    ref: r,
    style: a,
    className: n || "react-aria-CalendarGridBody"
  }, [
    ...new Array(c).keys()
  ].map((f) => /* @__PURE__ */ ye.createElement("tr", {
    key: f
  }, o.getDatesInWeek(f, u).map((h, d) => h ? /* @__PURE__ */ ye.cloneElement(t(h), {
    key: d
  }) : /* @__PURE__ */ ye.createElement("td", {
    key: d
  })))));
}
const Lo = /* @__PURE__ */ vt(qw);
function Qw({ date: e, ...r }, t) {
  let a = Sr(c0), n = Sr(f0), i = a ?? n;
  var s;
  let { startDate: o } = (s = Sr(d0)) !== null && s !== void 0 ? s : {
    startDate: i.visibleRange.start
  }, u = ze(null), { cellProps: l, buttonProps: c, ...f } = Cy({
    date: e
  }, i, u), { hoverProps: h, isHovered: d } = Vl({
    ...r,
    isDisabled: f.isDisabled
  }), { focusProps: m, isFocusVisible: x } = vs();
  x && (x = f.isFocused);
  let p = !Ky(o, e), w = !1, D = !1;
  "highlightedRange" in i && i.highlightedRange && (w = Lf(e, i.highlightedRange.start), D = Lf(e, i.highlightedRange.end));
  let y = Ua({
    ...r,
    defaultChildren: f.formattedDate,
    defaultClassName: "react-aria-CalendarCell",
    values: {
      date: e,
      isHovered: d,
      isOutsideMonth: p,
      isFocusVisible: x,
      isSelectionStart: w,
      isSelectionEnd: D,
      ...f
    }
  }), B = {
    "data-focused": f.isFocused || void 0,
    "data-hovered": d || void 0,
    "data-pressed": f.isPressed || void 0,
    "data-unavailable": f.isUnavailable || void 0,
    "data-disabled": f.isDisabled || void 0,
    "data-focus-visible": x || void 0,
    "data-outside-visible-range": f.isOutsideVisibleRange || void 0,
    "data-outside-month": p || void 0,
    "data-selected": f.isSelected || void 0,
    "data-selection-start": w || void 0,
    "data-selection-end": D || void 0,
    "data-invalid": f.isInvalid || void 0
  };
  return /* @__PURE__ */ ye.createElement("td", {
    ...l,
    ref: t
  }, /* @__PURE__ */ ye.createElement("div", {
    ...Nr(lt(r), c, m, h, B, y),
    ref: u
  }));
}
const pl = /* @__PURE__ */ vt(Qw), bp = /* @__PURE__ */ Ze(null), wp = /* @__PURE__ */ Ze(null), xc = /* @__PURE__ */ Ze({});
function e5(e, r) {
  [e, r] = da(e, r, xc);
  let { isDisabled: t, isInvalid: a, onHoverStart: n, onHoverChange: i, onHoverEnd: s, ...o } = e, { hoverProps: u, isHovered: l } = Vl({
    onHoverStart: n,
    onHoverChange: i,
    onHoverEnd: s,
    isDisabled: t
  }), { isFocused: c, isFocusVisible: f, focusProps: h } = vs({
    within: !0
  });
  t ?? (t = !!e["aria-disabled"] && e["aria-disabled"] !== "false"), a ?? (a = !!e["aria-invalid"] && e["aria-invalid"] !== "false");
  let d = Ua({
    ...e,
    values: {
      isHovered: l,
      isFocusWithin: c,
      isFocusVisible: f,
      isDisabled: t,
      isInvalid: a
    },
    defaultClassName: "react-aria-Group"
  });
  var m, x;
  return /* @__PURE__ */ ye.createElement("div", {
    ...Nr(o, h, u),
    ...d,
    ref: r,
    role: (m = e.role) !== null && m !== void 0 ? m : "group",
    slot: (x = e.slot) !== null && x !== void 0 ? x : void 0,
    "data-focus-within": c || void 0,
    "data-hovered": l || void 0,
    "data-focus-visible": f || void 0,
    "data-disabled": t || void 0,
    "data-invalid": a || void 0
  }, d.children);
}
const _p = /* @__PURE__ */ vt(e5), $p = /* @__PURE__ */ Ze(null), mc = /* @__PURE__ */ Ze(null), pc = /* @__PURE__ */ Ze(null);
function r5(e, r) {
  let t = e["aria-labelledby"];
  [e, r] = da(e, r, mc);
  let { dialogProps: a, titleProps: n } = Ny({
    ...e,
    // Only pass aria-labelledby from props, not context.
    // Context is used as a fallback below.
    "aria-labelledby": t
  }, r), i = Sr(pc);
  !a["aria-label"] && !a["aria-labelledby"] && (e["aria-labelledby"] ? a["aria-labelledby"] = e["aria-labelledby"] : console.warn('If a Dialog does not contain a <Heading slot="title">, it must have an aria-label or aria-labelledby attribute for accessibility.'));
  let s = Ua({
    defaultClassName: "react-aria-Dialog",
    className: e.className,
    style: e.style,
    children: e.children,
    values: {
      close: (i == null ? void 0 : i.close) || (() => {
      })
    }
  });
  return /* @__PURE__ */ ye.createElement("section", {
    ...lt(e),
    ...a,
    ...s,
    ref: r,
    slot: e.slot || void 0
  }, /* @__PURE__ */ ye.createElement(ps, {
    values: [
      [
        r0,
        {
          slots: {
            [_o]: {},
            title: {
              ...n,
              level: 2
            }
          }
        }
      ],
      [
        di,
        {
          slots: {
            [_o]: {},
            close: {
              onPress: () => i == null ? void 0 : i.close()
            }
          }
        }
      ]
    ]
  }, s.children));
}
const Dp = /* @__PURE__ */ vt(r5), Ep = /* @__PURE__ */ Ze(null), t5 = /* @__PURE__ */ Ze(null), a5 = /* @__PURE__ */ Ze(null), n5 = /* @__PURE__ */ Ze(null), i5 = /* @__PURE__ */ Ze(null);
function s5(e, r) {
  [e, r] = da(e, r, t5);
  let { validationBehavior: t } = Ol(wp) || {};
  var a, n;
  let i = (n = (a = e.validationBehavior) !== null && a !== void 0 ? a : t) !== null && n !== void 0 ? n : "native", s = Hw({
    ...e,
    validationBehavior: i
  }), o = ze(null), [u, l] = v1(), { groupProps: c, labelProps: f, fieldProps: h, buttonProps: d, dialogProps: m, calendarProps: x, descriptionProps: p, errorMessageProps: w, ...D } = My({
    ...g1(e),
    label: l,
    validationBehavior: i
  }, s, o), [y, B] = He(null), L = Cr(() => {
    o.current && B(o.current.offsetWidth + "px");
  }, []);
  x1({
    ref: o,
    onResize: L
  });
  let { focusProps: U, isFocused: k, isFocusVisible: v } = vs({
    within: !0
  }), b = Ua({
    ...e,
    values: {
      state: s,
      isFocusWithin: k,
      isFocusVisible: v,
      isDisabled: e.isDisabled || !1,
      isInvalid: s.isInvalid,
      isOpen: s.isOpen
    },
    defaultClassName: "react-aria-DatePicker"
  }), A = lt(e);
  return delete A.id, /* @__PURE__ */ ye.createElement(ps, {
    values: [
      [
        n5,
        s
      ],
      [
        xc,
        {
          ...c,
          ref: o,
          isInvalid: s.isInvalid
        }
      ],
      [
        Ep,
        h
      ],
      [
        di,
        {
          ...d,
          isPressed: s.isOpen
        }
      ],
      [
        ql,
        {
          ...f,
          ref: u,
          elementType: "span"
        }
      ],
      [
        gp,
        x
      ],
      [
        pc,
        s
      ],
      [
        $p,
        {
          trigger: "DatePicker",
          triggerRef: o,
          placement: "bottom start",
          style: {
            "--trigger-width": y
          }
        }
      ],
      [
        mc,
        m
      ],
      [
        i0,
        {
          slots: {
            description: p,
            errorMessage: w
          }
        }
      ],
      [
        bp,
        D
      ]
    ]
  }, /* @__PURE__ */ ye.createElement("div", {
    ...U,
    ...A,
    ...b,
    ref: r,
    slot: e.slot || void 0,
    "data-focus-within": k || void 0,
    "data-invalid": s.isInvalid || void 0,
    "data-focus-visible": v || void 0,
    "data-disabled": e.isDisabled || void 0,
    "data-open": s.isOpen || void 0
  }));
}
const o5 = /* @__PURE__ */ vt(s5);
function u5(e, r) {
  [e, r] = da(e, r, a5);
  let { validationBehavior: t } = Ol(wp) || {};
  var a, n;
  let i = (n = (a = e.validationBehavior) !== null && a !== void 0 ? a : t) !== null && n !== void 0 ? n : "native", s = jw({
    ...e,
    validationBehavior: i
  }), o = ze(null), [u, l] = v1(), { groupProps: c, labelProps: f, startFieldProps: h, endFieldProps: d, buttonProps: m, dialogProps: x, calendarProps: p, descriptionProps: w, errorMessageProps: D, ...y } = Ly({
    ...g1(e),
    label: l,
    validationBehavior: i
  }, s, o), [B, L] = He(null), U = Cr(() => {
    o.current && L(o.current.offsetWidth + "px");
  }, []);
  x1({
    ref: o,
    onResize: U
  });
  let { focusProps: k, isFocused: v, isFocusVisible: b } = vs({
    within: !0
  }), A = Ua({
    ...e,
    values: {
      state: s,
      isFocusWithin: v,
      isFocusVisible: b,
      isDisabled: e.isDisabled || !1,
      isInvalid: s.isInvalid,
      isOpen: s.isOpen
    },
    defaultClassName: "react-aria-DateRangePicker"
  }), T = lt(e);
  return delete T.id, /* @__PURE__ */ ye.createElement(ps, {
    values: [
      [
        i5,
        s
      ],
      [
        xc,
        {
          ...c,
          ref: o,
          isInvalid: s.isInvalid
        }
      ],
      [
        di,
        {
          ...m,
          isPressed: s.isOpen
        }
      ],
      [
        ql,
        {
          ...f,
          ref: u,
          elementType: "span"
        }
      ],
      [
        yp,
        p
      ],
      [
        pc,
        s
      ],
      [
        $p,
        {
          trigger: "DateRangePicker",
          triggerRef: o,
          placement: "bottom start",
          style: {
            "--trigger-width": B
          }
        }
      ],
      [
        mc,
        x
      ],
      [
        Ep,
        {
          slots: {
            start: h,
            end: d
          }
        }
      ],
      [
        i0,
        {
          slots: {
            description: w,
            errorMessage: D
          }
        }
      ],
      [
        bp,
        y
      ]
    ]
  }, /* @__PURE__ */ ye.createElement("div", {
    ...k,
    ...T,
    ...A,
    ref: r,
    slot: e.slot || void 0,
    "data-focus-within": v || void 0,
    "data-invalid": s.isInvalid || void 0,
    "data-focus-visible": b || void 0,
    "data-disabled": e.isDisabled || void 0,
    "data-open": s.isOpen || void 0
  }));
}
const l5 = /* @__PURE__ */ vt(u5);
function c5(e, r) {
  [e, r] = da(e, r, r0);
  let { children: t, level: a = 3, className: n, ...i } = e, s = `h${a}`;
  return /* @__PURE__ */ ye.createElement(s, {
    ...i,
    ref: r,
    className: n ?? "react-aria-Heading"
  }, t);
}
const kp = /* @__PURE__ */ vt(c5);
function vl(e, r) {
  if (!e || typeof e != "number")
    throw new Error("Invalid epoch timestamp provided.");
  return new Intl.DateTimeFormat("en-US", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    timeZone: r
  }).format(new Date(e));
}
function _d(e, r, t, a) {
  try {
    const n = new Ft(e, r, t);
    return Jh(n, a);
  } catch {
    throw new Error("Error converting date");
  }
}
const B9 = (e, r, t, a, n, i, s) => {
  var y, B, L;
  const o = ((y = a[0]) == null ? void 0 : y.name) ?? "UTC", u = ((B = e == null ? void 0 : e[0]) == null ? void 0 : B.name) ?? "UTC", { startDate: l, endDate: c } = n, f = pr(l ?? 0, o), h = pr(c ?? 0, o), d = _d(
    f.year,
    f.month,
    f.day,
    u
  ).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toDate().valueOf(), m = _d(
    h.year,
    h.month,
    h.day,
    u
  ).set({ hour: 23, minute: 59, second: 59, millisecond: 0 }).toDate().valueOf(), x = new Ft(
    Ne(u).year,
    Ne(u).month,
    Ne(u).day,
    0,
    0,
    0,
    0
  ).subtract({
    [t.param]: t.subtractor
  }).toDate(((L = e == null ? void 0 : e[0]) == null ? void 0 : L.name) ?? "").valueOf(), p = new Ft(
    Ne(u).year,
    Ne(u).month,
    Ne(u).day,
    23,
    59,
    59,
    0
  ).subtract({ [r.param]: r.subtractor }).toDate(u).valueOf();
  let w = d, D = m;
  d < x ? w = x : d > p ? w = p : w = d, m > p || m < x ? D = p : D = m, i({ startDate: w, endDate: D }), s(e);
};
var Tp = { exports: {} };
/* @license
Papa Parse
v5.4.1
https://github.com/mholt/PapaParse
License: MIT
*/
(function(e, r) {
  (function(t, a) {
    e.exports = a();
  })(X2, function t() {
    var a = typeof self < "u" ? self : typeof window < "u" ? window : a !== void 0 ? a : {}, n = !a.document && !!a.postMessage, i = a.IS_PAPA_WORKER || !1, s = {}, o = 0, u = { parse: function(v, b) {
      var A = (b = b || {}).dynamicTyping || !1;
      if (k(A) && (b.dynamicTypingFunction = A, A = {}), b.dynamicTyping = A, b.transform = !!k(b.transform) && b.transform, b.worker && u.WORKERS_SUPPORTED) {
        var T = function() {
          if (!u.WORKERS_SUPPORTED)
            return !1;
          var I = (j = a.URL || a.webkitURL || null, J = t.toString(), u.BLOB_URL || (u.BLOB_URL = j.createObjectURL(new Blob(["var global = (function() { if (typeof self !== 'undefined') { return self; } if (typeof window !== 'undefined') { return window; } if (typeof global !== 'undefined') { return global; } return {}; })(); global.IS_PAPA_WORKER=true; ", "(", J, ")();"], { type: "text/javascript" })))), Y = new a.Worker(I), j, J;
          return Y.onmessage = D, Y.id = o++, s[Y.id] = Y;
        }();
        return T.userStep = b.step, T.userChunk = b.chunk, T.userComplete = b.complete, T.userError = b.error, b.step = k(b.step), b.chunk = k(b.chunk), b.complete = k(b.complete), b.error = k(b.error), delete b.worker, void T.postMessage({ input: v, config: b, workerId: T.id });
      }
      var C = null;
      return u.NODE_STREAM_INPUT, typeof v == "string" ? (v = function(I) {
        return I.charCodeAt(0) === 65279 ? I.slice(1) : I;
      }(v), C = b.download ? new f(b) : new d(b)) : v.readable === !0 && k(v.read) && k(v.on) ? C = new m(b) : (a.File && v instanceof File || v instanceof Object) && (C = new h(b)), C.stream(v);
    }, unparse: function(v, b) {
      var A = !1, T = !0, C = ",", I = `\r
`, Y = '"', j = Y + Y, J = !1, W = null, ce = !1;
      (function() {
        if (typeof b == "object") {
          if (typeof b.delimiter != "string" || u.BAD_DELIMITERS.filter(function(F) {
            return b.delimiter.indexOf(F) !== -1;
          }).length || (C = b.delimiter), (typeof b.quotes == "boolean" || typeof b.quotes == "function" || Array.isArray(b.quotes)) && (A = b.quotes), typeof b.skipEmptyLines != "boolean" && typeof b.skipEmptyLines != "string" || (J = b.skipEmptyLines), typeof b.newline == "string" && (I = b.newline), typeof b.quoteChar == "string" && (Y = b.quoteChar), typeof b.header == "boolean" && (T = b.header), Array.isArray(b.columns)) {
            if (b.columns.length === 0)
              throw new Error("Option columns is empty");
            W = b.columns;
          }
          b.escapeChar !== void 0 && (j = b.escapeChar + Y), (typeof b.escapeFormulae == "boolean" || b.escapeFormulae instanceof RegExp) && (ce = b.escapeFormulae instanceof RegExp ? b.escapeFormulae : /^[=+\-@\t\r].*$/);
        }
      })();
      var V = new RegExp(p(Y), "g");
      if (typeof v == "string" && (v = JSON.parse(v)), Array.isArray(v)) {
        if (!v.length || Array.isArray(v[0]))
          return ee(null, v, J);
        if (typeof v[0] == "object")
          return ee(W || Object.keys(v[0]), v, J);
      } else if (typeof v == "object")
        return typeof v.data == "string" && (v.data = JSON.parse(v.data)), Array.isArray(v.data) && (v.fields || (v.fields = v.meta && v.meta.fields || W), v.fields || (v.fields = Array.isArray(v.data[0]) ? v.fields : typeof v.data[0] == "object" ? Object.keys(v.data[0]) : []), Array.isArray(v.data[0]) || typeof v.data[0] == "object" || (v.data = [v.data])), ee(v.fields || [], v.data || [], J);
      throw new Error("Unable to serialize unrecognized input");
      function ee(F, H, P) {
        var N = "";
        typeof F == "string" && (F = JSON.parse(F)), typeof H == "string" && (H = JSON.parse(H));
        var X = Array.isArray(F) && 0 < F.length, ae = !Array.isArray(H[0]);
        if (X && T) {
          for (var ie = 0; ie < F.length; ie++)
            0 < ie && (N += C), N += de(F[ie], ie);
          0 < H.length && (N += I);
        }
        for (var q = 0; q < H.length; q++) {
          var re = X ? F.length : H[q].length, ve = !1, M = X ? Object.keys(H[q]).length === 0 : H[q].length === 0;
          if (P && !X && (ve = P === "greedy" ? H[q].join("").trim() === "" : H[q].length === 1 && H[q][0].length === 0), P === "greedy" && X) {
            for (var _e = [], De = 0; De < re; De++) {
              var $e = ae ? F[De] : De;
              _e.push(H[q][$e]);
            }
            ve = _e.join("").trim() === "";
          }
          if (!ve) {
            for (var ge = 0; ge < re; ge++) {
              0 < ge && !M && (N += C);
              var fe = X && ae ? F[ge] : ge;
              N += de(H[q][fe], ge);
            }
            q < H.length - 1 && (!P || 0 < re && !M) && (N += I);
          }
        }
        return N;
      }
      function de(F, H) {
        if (F == null)
          return "";
        if (F.constructor === Date)
          return JSON.stringify(F).slice(1, 25);
        var P = !1;
        ce && typeof F == "string" && ce.test(F) && (F = "'" + F, P = !0);
        var N = F.toString().replace(V, j);
        return (P = P || A === !0 || typeof A == "function" && A(F, H) || Array.isArray(A) && A[H] || function(X, ae) {
          for (var ie = 0; ie < ae.length; ie++)
            if (-1 < X.indexOf(ae[ie]))
              return !0;
          return !1;
        }(N, u.BAD_DELIMITERS) || -1 < N.indexOf(C) || N.charAt(0) === " " || N.charAt(N.length - 1) === " ") ? Y + N + Y : N;
      }
    } };
    if (u.RECORD_SEP = "", u.UNIT_SEP = "", u.BYTE_ORDER_MARK = "\uFEFF", u.BAD_DELIMITERS = ["\r", `
`, '"', u.BYTE_ORDER_MARK], u.WORKERS_SUPPORTED = !n && !!a.Worker, u.NODE_STREAM_INPUT = 1, u.LocalChunkSize = 10485760, u.RemoteChunkSize = 5242880, u.DefaultDelimiter = ",", u.Parser = w, u.ParserHandle = x, u.NetworkStreamer = f, u.FileStreamer = h, u.StringStreamer = d, u.ReadableStreamStreamer = m, a.jQuery) {
      var l = a.jQuery;
      l.fn.parse = function(v) {
        var b = v.config || {}, A = [];
        return this.each(function(I) {
          if (!(l(this).prop("tagName").toUpperCase() === "INPUT" && l(this).attr("type").toLowerCase() === "file" && a.FileReader) || !this.files || this.files.length === 0)
            return !0;
          for (var Y = 0; Y < this.files.length; Y++)
            A.push({ file: this.files[Y], inputElem: this, instanceConfig: l.extend({}, b) });
        }), T(), this;
        function T() {
          if (A.length !== 0) {
            var I, Y, j, J, W = A[0];
            if (k(v.before)) {
              var ce = v.before(W.file, W.inputElem);
              if (typeof ce == "object") {
                if (ce.action === "abort")
                  return I = "AbortError", Y = W.file, j = W.inputElem, J = ce.reason, void (k(v.error) && v.error({ name: I }, Y, j, J));
                if (ce.action === "skip")
                  return void C();
                typeof ce.config == "object" && (W.instanceConfig = l.extend(W.instanceConfig, ce.config));
              } else if (ce === "skip")
                return void C();
            }
            var V = W.instanceConfig.complete;
            W.instanceConfig.complete = function(ee) {
              k(V) && V(ee, W.file, W.inputElem), C();
            }, u.parse(W.file, W.instanceConfig);
          } else
            k(v.complete) && v.complete();
        }
        function C() {
          A.splice(0, 1), T();
        }
      };
    }
    function c(v) {
      this._handle = null, this._finished = !1, this._completed = !1, this._halted = !1, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = !0, this._completeResults = { data: [], errors: [], meta: {} }, (function(b) {
        var A = L(b);
        A.chunkSize = parseInt(A.chunkSize), b.step || b.chunk || (A.chunkSize = null), this._handle = new x(A), (this._handle.streamer = this)._config = A;
      }).call(this, v), this.parseChunk = function(b, A) {
        if (this.isFirstChunk && k(this._config.beforeFirstChunk)) {
          var T = this._config.beforeFirstChunk(b);
          T !== void 0 && (b = T);
        }
        this.isFirstChunk = !1, this._halted = !1;
        var C = this._partialLine + b;
        this._partialLine = "";
        var I = this._handle.parse(C, this._baseIndex, !this._finished);
        if (!this._handle.paused() && !this._handle.aborted()) {
          var Y = I.meta.cursor;
          this._finished || (this._partialLine = C.substring(Y - this._baseIndex), this._baseIndex = Y), I && I.data && (this._rowCount += I.data.length);
          var j = this._finished || this._config.preview && this._rowCount >= this._config.preview;
          if (i)
            a.postMessage({ results: I, workerId: u.WORKER_ID, finished: j });
          else if (k(this._config.chunk) && !A) {
            if (this._config.chunk(I, this._handle), this._handle.paused() || this._handle.aborted())
              return void (this._halted = !0);
            I = void 0, this._completeResults = void 0;
          }
          return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(I.data), this._completeResults.errors = this._completeResults.errors.concat(I.errors), this._completeResults.meta = I.meta), this._completed || !j || !k(this._config.complete) || I && I.meta.aborted || (this._config.complete(this._completeResults, this._input), this._completed = !0), j || I && I.meta.paused || this._nextChunk(), I;
        }
        this._halted = !0;
      }, this._sendError = function(b) {
        k(this._config.error) ? this._config.error(b) : i && this._config.error && a.postMessage({ workerId: u.WORKER_ID, error: b, finished: !1 });
      };
    }
    function f(v) {
      var b;
      (v = v || {}).chunkSize || (v.chunkSize = u.RemoteChunkSize), c.call(this, v), this._nextChunk = n ? function() {
        this._readChunk(), this._chunkLoaded();
      } : function() {
        this._readChunk();
      }, this.stream = function(A) {
        this._input = A, this._nextChunk();
      }, this._readChunk = function() {
        if (this._finished)
          this._chunkLoaded();
        else {
          if (b = new XMLHttpRequest(), this._config.withCredentials && (b.withCredentials = this._config.withCredentials), n || (b.onload = U(this._chunkLoaded, this), b.onerror = U(this._chunkError, this)), b.open(this._config.downloadRequestBody ? "POST" : "GET", this._input, !n), this._config.downloadRequestHeaders) {
            var A = this._config.downloadRequestHeaders;
            for (var T in A)
              b.setRequestHeader(T, A[T]);
          }
          if (this._config.chunkSize) {
            var C = this._start + this._config.chunkSize - 1;
            b.setRequestHeader("Range", "bytes=" + this._start + "-" + C);
          }
          try {
            b.send(this._config.downloadRequestBody);
          } catch (I) {
            this._chunkError(I.message);
          }
          n && b.status === 0 && this._chunkError();
        }
      }, this._chunkLoaded = function() {
        b.readyState === 4 && (b.status < 200 || 400 <= b.status ? this._chunkError() : (this._start += this._config.chunkSize ? this._config.chunkSize : b.responseText.length, this._finished = !this._config.chunkSize || this._start >= function(A) {
          var T = A.getResponseHeader("Content-Range");
          return T === null ? -1 : parseInt(T.substring(T.lastIndexOf("/") + 1));
        }(b), this.parseChunk(b.responseText)));
      }, this._chunkError = function(A) {
        var T = b.statusText || A;
        this._sendError(new Error(T));
      };
    }
    function h(v) {
      var b, A;
      (v = v || {}).chunkSize || (v.chunkSize = u.LocalChunkSize), c.call(this, v);
      var T = typeof FileReader < "u";
      this.stream = function(C) {
        this._input = C, A = C.slice || C.webkitSlice || C.mozSlice, T ? ((b = new FileReader()).onload = U(this._chunkLoaded, this), b.onerror = U(this._chunkError, this)) : b = new FileReaderSync(), this._nextChunk();
      }, this._nextChunk = function() {
        this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk();
      }, this._readChunk = function() {
        var C = this._input;
        if (this._config.chunkSize) {
          var I = Math.min(this._start + this._config.chunkSize, this._input.size);
          C = A.call(C, this._start, I);
        }
        var Y = b.readAsText(C, this._config.encoding);
        T || this._chunkLoaded({ target: { result: Y } });
      }, this._chunkLoaded = function(C) {
        this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(C.target.result);
      }, this._chunkError = function() {
        this._sendError(b.error);
      };
    }
    function d(v) {
      var b;
      c.call(this, v = v || {}), this.stream = function(A) {
        return b = A, this._nextChunk();
      }, this._nextChunk = function() {
        if (!this._finished) {
          var A, T = this._config.chunkSize;
          return T ? (A = b.substring(0, T), b = b.substring(T)) : (A = b, b = ""), this._finished = !b, this.parseChunk(A);
        }
      };
    }
    function m(v) {
      c.call(this, v = v || {});
      var b = [], A = !0, T = !1;
      this.pause = function() {
        c.prototype.pause.apply(this, arguments), this._input.pause();
      }, this.resume = function() {
        c.prototype.resume.apply(this, arguments), this._input.resume();
      }, this.stream = function(C) {
        this._input = C, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
      }, this._checkIsFinished = function() {
        T && b.length === 1 && (this._finished = !0);
      }, this._nextChunk = function() {
        this._checkIsFinished(), b.length ? this.parseChunk(b.shift()) : A = !0;
      }, this._streamData = U(function(C) {
        try {
          b.push(typeof C == "string" ? C : C.toString(this._config.encoding)), A && (A = !1, this._checkIsFinished(), this.parseChunk(b.shift()));
        } catch (I) {
          this._streamError(I);
        }
      }, this), this._streamError = U(function(C) {
        this._streamCleanUp(), this._sendError(C);
      }, this), this._streamEnd = U(function() {
        this._streamCleanUp(), T = !0, this._streamData("");
      }, this), this._streamCleanUp = U(function() {
        this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
      }, this);
    }
    function x(v) {
      var b, A, T, C = Math.pow(2, 53), I = -C, Y = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/, j = /^((\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)))$/, J = this, W = 0, ce = 0, V = !1, ee = !1, de = [], F = { data: [], errors: [], meta: {} };
      if (k(v.step)) {
        var H = v.step;
        v.step = function(q) {
          if (F = q, X())
            N();
          else {
            if (N(), F.data.length === 0)
              return;
            W += q.data.length, v.preview && W > v.preview ? A.abort() : (F.data = F.data[0], H(F, J));
          }
        };
      }
      function P(q) {
        return v.skipEmptyLines === "greedy" ? q.join("").trim() === "" : q.length === 1 && q[0].length === 0;
      }
      function N() {
        return F && T && (ie("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + u.DefaultDelimiter + "'"), T = !1), v.skipEmptyLines && (F.data = F.data.filter(function(q) {
          return !P(q);
        })), X() && function() {
          if (!F)
            return;
          function q(ve, M) {
            k(v.transformHeader) && (ve = v.transformHeader(ve, M)), de.push(ve);
          }
          if (Array.isArray(F.data[0])) {
            for (var re = 0; X() && re < F.data.length; re++)
              F.data[re].forEach(q);
            F.data.splice(0, 1);
          } else
            F.data.forEach(q);
        }(), function() {
          if (!F || !v.header && !v.dynamicTyping && !v.transform)
            return F;
          function q(ve, M) {
            var _e, De = v.header ? {} : [];
            for (_e = 0; _e < ve.length; _e++) {
              var $e = _e, ge = ve[_e];
              v.header && ($e = _e >= de.length ? "__parsed_extra" : de[_e]), v.transform && (ge = v.transform(ge, $e)), ge = ae($e, ge), $e === "__parsed_extra" ? (De[$e] = De[$e] || [], De[$e].push(ge)) : De[$e] = ge;
            }
            return v.header && (_e > de.length ? ie("FieldMismatch", "TooManyFields", "Too many fields: expected " + de.length + " fields but parsed " + _e, ce + M) : _e < de.length && ie("FieldMismatch", "TooFewFields", "Too few fields: expected " + de.length + " fields but parsed " + _e, ce + M)), De;
          }
          var re = 1;
          return !F.data.length || Array.isArray(F.data[0]) ? (F.data = F.data.map(q), re = F.data.length) : F.data = q(F.data, 0), v.header && F.meta && (F.meta.fields = de), ce += re, F;
        }();
      }
      function X() {
        return v.header && de.length === 0;
      }
      function ae(q, re) {
        return ve = q, v.dynamicTypingFunction && v.dynamicTyping[ve] === void 0 && (v.dynamicTyping[ve] = v.dynamicTypingFunction(ve)), (v.dynamicTyping[ve] || v.dynamicTyping) === !0 ? re === "true" || re === "TRUE" || re !== "false" && re !== "FALSE" && (function(M) {
          if (Y.test(M)) {
            var _e = parseFloat(M);
            if (I < _e && _e < C)
              return !0;
          }
          return !1;
        }(re) ? parseFloat(re) : j.test(re) ? new Date(re) : re === "" ? null : re) : re;
        var ve;
      }
      function ie(q, re, ve, M) {
        var _e = { type: q, code: re, message: ve };
        M !== void 0 && (_e.row = M), F.errors.push(_e);
      }
      this.parse = function(q, re, ve) {
        var M = v.quoteChar || '"';
        if (v.newline || (v.newline = function($e, ge) {
          $e = $e.substring(0, 1048576);
          var fe = new RegExp(p(ge) + "([^]*?)" + p(ge), "gm"), Me = ($e = $e.replace(fe, "")).split("\r"), Je = $e.split(`
`), dr = 1 < Je.length && Je[0].length < Me[0].length;
          if (Me.length === 1 || dr)
            return `
`;
          for (var lr = 0, Ve = 0; Ve < Me.length; Ve++)
            Me[Ve][0] === `
` && lr++;
          return lr >= Me.length / 2 ? `\r
` : "\r";
        }(q, M)), T = !1, v.delimiter)
          k(v.delimiter) && (v.delimiter = v.delimiter(q), F.meta.delimiter = v.delimiter);
        else {
          var _e = function($e, ge, fe, Me, Je) {
            var dr, lr, Ve, Ge;
            Je = Je || [",", "	", "|", ";", u.RECORD_SEP, u.UNIT_SEP];
            for (var cr = 0; cr < Je.length; cr++) {
              var Ae = Je[cr], Rr = 0, wr = 0, nr = 0;
              Ve = void 0;
              for (var hr = new w({ comments: Me, delimiter: Ae, newline: ge, preview: 10 }).parse($e), ke = 0; ke < hr.data.length; ke++)
                if (fe && P(hr.data[ke]))
                  nr++;
                else {
                  var Le = hr.data[ke].length;
                  wr += Le, Ve !== void 0 ? 0 < Le && (Rr += Math.abs(Le - Ve), Ve = Le) : Ve = Le;
                }
              0 < hr.data.length && (wr /= hr.data.length - nr), (lr === void 0 || Rr <= lr) && (Ge === void 0 || Ge < wr) && 1.99 < wr && (lr = Rr, dr = Ae, Ge = wr);
            }
            return { successful: !!(v.delimiter = dr), bestDelimiter: dr };
          }(q, v.newline, v.skipEmptyLines, v.comments, v.delimitersToGuess);
          _e.successful ? v.delimiter = _e.bestDelimiter : (T = !0, v.delimiter = u.DefaultDelimiter), F.meta.delimiter = v.delimiter;
        }
        var De = L(v);
        return v.preview && v.header && De.preview++, b = q, A = new w(De), F = A.parse(b, re, ve), N(), V ? { meta: { paused: !0 } } : F || { meta: { paused: !1 } };
      }, this.paused = function() {
        return V;
      }, this.pause = function() {
        V = !0, A.abort(), b = k(v.chunk) ? "" : b.substring(A.getCharIndex());
      }, this.resume = function() {
        J.streamer._halted ? (V = !1, J.streamer.parseChunk(b, !0)) : setTimeout(J.resume, 3);
      }, this.aborted = function() {
        return ee;
      }, this.abort = function() {
        ee = !0, A.abort(), F.meta.aborted = !0, k(v.complete) && v.complete(F), b = "";
      };
    }
    function p(v) {
      return v.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }
    function w(v) {
      var b, A = (v = v || {}).delimiter, T = v.newline, C = v.comments, I = v.step, Y = v.preview, j = v.fastMode, J = b = v.quoteChar === void 0 || v.quoteChar === null ? '"' : v.quoteChar;
      if (v.escapeChar !== void 0 && (J = v.escapeChar), (typeof A != "string" || -1 < u.BAD_DELIMITERS.indexOf(A)) && (A = ","), C === A)
        throw new Error("Comment character same as delimiter");
      C === !0 ? C = "#" : (typeof C != "string" || -1 < u.BAD_DELIMITERS.indexOf(C)) && (C = !1), T !== `
` && T !== "\r" && T !== `\r
` && (T = `
`);
      var W = 0, ce = !1;
      this.parse = function(V, ee, de) {
        if (typeof V != "string")
          throw new Error("Input must be a string");
        var F = V.length, H = A.length, P = T.length, N = C.length, X = k(I), ae = [], ie = [], q = [], re = W = 0;
        if (!V)
          return er();
        if (v.header && !ee) {
          var ve = V.split(T)[0].split(A), M = [], _e = {}, De = !1;
          for (var $e in ve) {
            var ge = ve[$e];
            k(v.transformHeader) && (ge = v.transformHeader(ge, $e));
            var fe = ge, Me = _e[ge] || 0;
            for (0 < Me && (De = !0, fe = ge + "_" + Me), _e[ge] = Me + 1; M.includes(fe); )
              fe = fe + "_" + Me;
            M.push(fe);
          }
          if (De) {
            var Je = V.split(T);
            Je[0] = M.join(A), V = Je.join(T);
          }
        }
        if (j || j !== !1 && V.indexOf(b) === -1) {
          for (var dr = V.split(T), lr = 0; lr < dr.length; lr++) {
            if (q = dr[lr], W += q.length, lr !== dr.length - 1)
              W += T.length;
            else if (de)
              return er();
            if (!C || q.substring(0, N) !== C) {
              if (X) {
                if (ae = [], nr(q.split(A)), ar(), ce)
                  return er();
              } else
                nr(q.split(A));
              if (Y && Y <= lr)
                return ae = ae.slice(0, Y), er(!0);
            }
          }
          return er();
        }
        for (var Ve = V.indexOf(A, W), Ge = V.indexOf(T, W), cr = new RegExp(p(J) + p(b), "g"), Ae = V.indexOf(b, W); ; )
          if (V[W] !== b)
            if (C && q.length === 0 && V.substring(W, W + N) === C) {
              if (Ge === -1)
                return er();
              W = Ge + P, Ge = V.indexOf(T, W), Ve = V.indexOf(A, W);
            } else if (Ve !== -1 && (Ve < Ge || Ge === -1))
              q.push(V.substring(W, Ve)), W = Ve + H, Ve = V.indexOf(A, W);
            else {
              if (Ge === -1)
                break;
              if (q.push(V.substring(W, Ge)), Le(Ge + P), X && (ar(), ce))
                return er();
              if (Y && ae.length >= Y)
                return er(!0);
            }
          else
            for (Ae = W, W++; ; ) {
              if ((Ae = V.indexOf(b, Ae + 1)) === -1)
                return de || ie.push({ type: "Quotes", code: "MissingQuotes", message: "Quoted field unterminated", row: ae.length, index: W }), ke();
              if (Ae === F - 1)
                return ke(V.substring(W, Ae).replace(cr, b));
              if (b !== J || V[Ae + 1] !== J) {
                if (b === J || Ae === 0 || V[Ae - 1] !== J) {
                  Ve !== -1 && Ve < Ae + 1 && (Ve = V.indexOf(A, Ae + 1)), Ge !== -1 && Ge < Ae + 1 && (Ge = V.indexOf(T, Ae + 1));
                  var Rr = hr(Ge === -1 ? Ve : Math.min(Ve, Ge));
                  if (V.substr(Ae + 1 + Rr, H) === A) {
                    q.push(V.substring(W, Ae).replace(cr, b)), V[W = Ae + 1 + Rr + H] !== b && (Ae = V.indexOf(b, W)), Ve = V.indexOf(A, W), Ge = V.indexOf(T, W);
                    break;
                  }
                  var wr = hr(Ge);
                  if (V.substring(Ae + 1 + wr, Ae + 1 + wr + P) === T) {
                    if (q.push(V.substring(W, Ae).replace(cr, b)), Le(Ae + 1 + wr + P), Ve = V.indexOf(A, W), Ae = V.indexOf(b, W), X && (ar(), ce))
                      return er();
                    if (Y && ae.length >= Y)
                      return er(!0);
                    break;
                  }
                  ie.push({ type: "Quotes", code: "InvalidQuotes", message: "Trailing quote on quoted field is malformed", row: ae.length, index: W }), Ae++;
                }
              } else
                Ae++;
            }
        return ke();
        function nr(xr) {
          ae.push(xr), re = W;
        }
        function hr(xr) {
          var ja = 0;
          if (xr !== -1) {
            var za = V.substring(Ae + 1, xr);
            za && za.trim() === "" && (ja = za.length);
          }
          return ja;
        }
        function ke(xr) {
          return de || (xr === void 0 && (xr = V.substring(W)), q.push(xr), W = F, nr(q), X && ar()), er();
        }
        function Le(xr) {
          W = xr, nr(q), q = [], Ge = V.indexOf(T, W);
        }
        function er(xr) {
          return { data: ae, errors: ie, meta: { delimiter: A, linebreak: T, aborted: ce, truncated: !!xr, cursor: re + (ee || 0) } };
        }
        function ar() {
          I(er()), ae = [], ie = [];
        }
      }, this.abort = function() {
        ce = !0;
      }, this.getCharIndex = function() {
        return W;
      };
    }
    function D(v) {
      var b = v.data, A = s[b.workerId], T = !1;
      if (b.error)
        A.userError(b.error, b.file);
      else if (b.results && b.results.data) {
        var C = { abort: function() {
          T = !0, y(b.workerId, { data: [], errors: [], meta: { aborted: !0 } });
        }, pause: B, resume: B };
        if (k(A.userStep)) {
          for (var I = 0; I < b.results.data.length && (A.userStep({ data: b.results.data[I], errors: b.results.errors, meta: b.results.meta }, C), !T); I++)
            ;
          delete b.results;
        } else
          k(A.userChunk) && (A.userChunk(b.results, C, b.file), delete b.results);
      }
      b.finished && !T && y(b.workerId, b.results);
    }
    function y(v, b) {
      var A = s[v];
      k(A.userComplete) && A.userComplete(b), A.terminate(), delete s[v];
    }
    function B() {
      throw new Error("Not implemented.");
    }
    function L(v) {
      if (typeof v != "object" || v === null)
        return v;
      var b = Array.isArray(v) ? [] : {};
      for (var A in v)
        b[A] = L(v[A]);
      return b;
    }
    function U(v, b) {
      return function() {
        v.apply(b, arguments);
      };
    }
    function k(v) {
      return typeof v == "function";
    }
    return i && (a.onmessage = function(v) {
      var b = v.data;
      if (u.WORKER_ID === void 0 && b && (u.WORKER_ID = b.workerId), typeof b.input == "string")
        a.postMessage({ workerId: u.WORKER_ID, results: u.parse(b.input, b.config), finished: !0 });
      else if (a.File && b.input instanceof File || b.input instanceof Object) {
        var A = u.parse(b.input, b.config);
        A && a.postMessage({ workerId: u.WORKER_ID, results: A, finished: !0 });
      }
    }), (f.prototype = Object.create(c.prototype)).constructor = f, (h.prototype = Object.create(c.prototype)).constructor = h, (d.prototype = Object.create(d.prototype)).constructor = d, (m.prototype = Object.create(c.prototype)).constructor = m, u;
  });
})(Tp);
var f5 = Tp.exports;
const d5 = /* @__PURE__ */ Z2(f5);
/*! xlsx.js (C) 2013-present SheetJS -- http://sheetjs.com */
var es = {};
es.version = "0.18.5";
var xt = 1200, ln = 1252, h5 = [874, 932, 936, 949, 950, 1250, 1251, 1252, 1253, 1254, 1255, 1256, 1257, 1258, 1e4], vc = {
  /*::[*/
  0: 1252,
  /* ANSI */
  /*::[*/
  1: 65001,
  /* DEFAULT */
  /*::[*/
  2: 65001,
  /* SYMBOL */
  /*::[*/
  77: 1e4,
  /* MAC */
  /*::[*/
  128: 932,
  /* SHIFTJIS */
  /*::[*/
  129: 949,
  /* HANGUL */
  /*::[*/
  130: 1361,
  /* JOHAB */
  /*::[*/
  134: 936,
  /* GB2312 */
  /*::[*/
  136: 950,
  /* CHINESEBIG5 */
  /*::[*/
  161: 1253,
  /* GREEK */
  /*::[*/
  162: 1254,
  /* TURKISH */
  /*::[*/
  163: 1258,
  /* VIETNAMESE */
  /*::[*/
  177: 1255,
  /* HEBREW */
  /*::[*/
  178: 1256,
  /* ARABIC */
  /*::[*/
  186: 1257,
  /* BALTIC */
  /*::[*/
  204: 1251,
  /* RUSSIAN */
  /*::[*/
  222: 874,
  /* THAI */
  /*::[*/
  238: 1250,
  /* EASTEUROPE */
  /*::[*/
  255: 1252,
  /* OEM */
  /*::[*/
  69: 6969
  /* MISC */
}, h0 = function(e) {
  h5.indexOf(e) != -1 && (ln = vc[0] = e);
};
function x5() {
  h0(1252);
}
var kt = function(e) {
  xt = e, h0(e);
};
function x0() {
  kt(1200), x5();
}
function No(e) {
  for (var r = [], t = 0, a = e.length; t < a; ++t)
    r[t] = e.charCodeAt(t);
  return r;
}
function m5(e) {
  for (var r = [], t = 0; t < e.length >> 1; ++t)
    r[t] = String.fromCharCode(e.charCodeAt(2 * t) + (e.charCodeAt(2 * t + 1) << 8));
  return r.join("");
}
function Sp(e) {
  for (var r = [], t = 0; t < e.length >> 1; ++t)
    r[t] = String.fromCharCode(e.charCodeAt(2 * t + 1) + (e.charCodeAt(2 * t) << 8));
  return r.join("");
}
var Mn = function(e) {
  var r = e.charCodeAt(0), t = e.charCodeAt(1);
  return r == 255 && t == 254 ? m5(e.slice(2)) : r == 254 && t == 255 ? Sp(e.slice(2)) : r == 65279 ? e.slice(1) : e;
}, Bi = function(r) {
  return String.fromCharCode(r);
}, gl = function(r) {
  return String.fromCharCode(r);
}, Ue;
function p5(e) {
  Ue = e, kt = function(r) {
    xt = r, h0(r);
  }, Mn = function(r) {
    return r.charCodeAt(0) === 255 && r.charCodeAt(1) === 254 ? Ue.utils.decode(1200, No(r.slice(2))) : r;
  }, Bi = function(t) {
    return xt === 1200 ? String.fromCharCode(t) : Ue.utils.decode(xt, [t & 255, t >> 8])[0];
  }, gl = function(t) {
    return Ue.utils.decode(ln, [t])[0];
  }, av();
}
var Fa = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
function rs(e) {
  for (var r = "", t = 0, a = 0, n = 0, i = 0, s = 0, o = 0, u = 0, l = 0; l < e.length; )
    t = e.charCodeAt(l++), i = t >> 2, a = e.charCodeAt(l++), s = (t & 3) << 4 | a >> 4, n = e.charCodeAt(l++), o = (a & 15) << 2 | n >> 6, u = n & 63, isNaN(a) ? o = u = 64 : isNaN(n) && (u = 64), r += Fa.charAt(i) + Fa.charAt(s) + Fa.charAt(o) + Fa.charAt(u);
  return r;
}
function mt(e) {
  var r = "", t = 0, a = 0, n = 0, i = 0, s = 0, o = 0, u = 0;
  e = e.replace(/[^\w\+\/\=]/g, "");
  for (var l = 0; l < e.length; )
    i = Fa.indexOf(e.charAt(l++)), s = Fa.indexOf(e.charAt(l++)), t = i << 2 | s >> 4, r += String.fromCharCode(t), o = Fa.indexOf(e.charAt(l++)), a = (s & 15) << 4 | o >> 2, o !== 64 && (r += String.fromCharCode(a)), u = Fa.indexOf(e.charAt(l++)), n = (o & 3) << 6 | u, u !== 64 && (r += String.fromCharCode(n));
  return r;
}
var Ie = /* @__PURE__ */ function() {
  return typeof Buffer < "u" && typeof process < "u" && typeof process.versions < "u" && !!process.versions.node;
}(), xa = /* @__PURE__ */ function() {
  if (typeof Buffer < "u") {
    var e = !Buffer.from;
    if (!e)
      try {
        Buffer.from("foo", "utf8");
      } catch {
        e = !0;
      }
    return e ? function(r, t) {
      return t ? new Buffer(r, t) : new Buffer(r);
    } : Buffer.from.bind(Buffer);
  }
  return function() {
  };
}();
function Pa(e) {
  return Ie ? Buffer.alloc ? Buffer.alloc(e) : new Buffer(e) : typeof Uint8Array < "u" ? new Uint8Array(e) : new Array(e);
}
function $d(e) {
  return Ie ? Buffer.allocUnsafe ? Buffer.allocUnsafe(e) : new Buffer(e) : typeof Uint8Array < "u" ? new Uint8Array(e) : new Array(e);
}
var dt = function(r) {
  return Ie ? xa(r, "binary") : r.split("").map(function(t) {
    return t.charCodeAt(0) & 255;
  });
};
function _s(e) {
  if (typeof ArrayBuffer > "u")
    return dt(e);
  for (var r = new ArrayBuffer(e.length), t = new Uint8Array(r), a = 0; a != e.length; ++a)
    t[a] = e.charCodeAt(a) & 255;
  return r;
}
function Va(e) {
  if (Array.isArray(e))
    return e.map(function(a) {
      return String.fromCharCode(a);
    }).join("");
  for (var r = [], t = 0; t < e.length; ++t)
    r[t] = String.fromCharCode(e[t]);
  return r.join("");
}
function v5(e) {
  if (typeof Uint8Array > "u")
    throw new Error("Unsupported");
  return new Uint8Array(e);
}
function gc(e) {
  if (typeof ArrayBuffer > "u")
    throw new Error("Unsupported");
  if (e instanceof ArrayBuffer)
    return gc(new Uint8Array(e));
  for (var r = new Array(e.length), t = 0; t < e.length; ++t)
    r[t] = e[t];
  return r;
}
var Or = Ie ? function(e) {
  return Buffer.concat(e.map(function(r) {
    return Buffer.isBuffer(r) ? r : xa(r);
  }));
} : function(e) {
  if (typeof Uint8Array < "u") {
    var r = 0, t = 0;
    for (r = 0; r < e.length; ++r)
      t += e[r].length;
    var a = new Uint8Array(t), n = 0;
    for (r = 0, t = 0; r < e.length; t += n, ++r)
      if (n = e[r].length, e[r] instanceof Uint8Array)
        a.set(e[r], t);
      else {
        if (typeof e[r] == "string")
          throw "wtf";
        a.set(new Uint8Array(e[r]), t);
      }
    return a;
  }
  return [].concat.apply([], e.map(function(i) {
    return Array.isArray(i) ? i : [].slice.call(i);
  }));
};
function g5(e) {
  for (var r = [], t = 0, a = e.length + 250, n = Pa(e.length + 255), i = 0; i < e.length; ++i) {
    var s = e.charCodeAt(i);
    if (s < 128)
      n[t++] = s;
    else if (s < 2048)
      n[t++] = 192 | s >> 6 & 31, n[t++] = 128 | s & 63;
    else if (s >= 55296 && s < 57344) {
      s = (s & 1023) + 64;
      var o = e.charCodeAt(++i) & 1023;
      n[t++] = 240 | s >> 8 & 7, n[t++] = 128 | s >> 2 & 63, n[t++] = 128 | o >> 6 & 15 | (s & 3) << 4, n[t++] = 128 | o & 63;
    } else
      n[t++] = 224 | s >> 12 & 15, n[t++] = 128 | s >> 6 & 63, n[t++] = 128 | s & 63;
    t > a && (r.push(n.slice(0, t)), t = 0, n = Pa(65535), a = 65530);
  }
  return r.push(n.slice(0, t)), Or(r);
}
var Zr = /\u0000/g, Pi = /[\u0001-\u0006]/g;
function zn(e) {
  for (var r = "", t = e.length - 1; t >= 0; )
    r += e.charAt(t--);
  return r;
}
function It(e, r) {
  var t = "" + e;
  return t.length >= r ? t : vr("0", r - t.length) + t;
}
function yc(e, r) {
  var t = "" + e;
  return t.length >= r ? t : vr(" ", r - t.length) + t;
}
function Uo(e, r) {
  var t = "" + e;
  return t.length >= r ? t : t + vr(" ", r - t.length);
}
function y5(e, r) {
  var t = "" + Math.round(e);
  return t.length >= r ? t : vr("0", r - t.length) + t;
}
function b5(e, r) {
  var t = "" + e;
  return t.length >= r ? t : vr("0", r - t.length) + t;
}
var Dd = /* @__PURE__ */ Math.pow(2, 32);
function Cn(e, r) {
  if (e > Dd || e < -Dd)
    return y5(e, r);
  var t = Math.round(e);
  return b5(t, r);
}
function Vo(e, r) {
  return r = r || 0, e.length >= 7 + r && (e.charCodeAt(r) | 32) === 103 && (e.charCodeAt(r + 1) | 32) === 101 && (e.charCodeAt(r + 2) | 32) === 110 && (e.charCodeAt(r + 3) | 32) === 101 && (e.charCodeAt(r + 4) | 32) === 114 && (e.charCodeAt(r + 5) | 32) === 97 && (e.charCodeAt(r + 6) | 32) === 108;
}
var Ed = [
  ["Sun", "Sunday"],
  ["Mon", "Monday"],
  ["Tue", "Tuesday"],
  ["Wed", "Wednesday"],
  ["Thu", "Thursday"],
  ["Fri", "Friday"],
  ["Sat", "Saturday"]
], lu = [
  ["J", "Jan", "January"],
  ["F", "Feb", "February"],
  ["M", "Mar", "March"],
  ["A", "Apr", "April"],
  ["M", "May", "May"],
  ["J", "Jun", "June"],
  ["J", "Jul", "July"],
  ["A", "Aug", "August"],
  ["S", "Sep", "September"],
  ["O", "Oct", "October"],
  ["N", "Nov", "November"],
  ["D", "Dec", "December"]
];
function w5(e) {
  return e || (e = {}), e[0] = "General", e[1] = "0", e[2] = "0.00", e[3] = "#,##0", e[4] = "#,##0.00", e[9] = "0%", e[10] = "0.00%", e[11] = "0.00E+00", e[12] = "# ?/?", e[13] = "# ??/??", e[14] = "m/d/yy", e[15] = "d-mmm-yy", e[16] = "d-mmm", e[17] = "mmm-yy", e[18] = "h:mm AM/PM", e[19] = "h:mm:ss AM/PM", e[20] = "h:mm", e[21] = "h:mm:ss", e[22] = "m/d/yy h:mm", e[37] = "#,##0 ;(#,##0)", e[38] = "#,##0 ;[Red](#,##0)", e[39] = "#,##0.00;(#,##0.00)", e[40] = "#,##0.00;[Red](#,##0.00)", e[45] = "mm:ss", e[46] = "[h]:mm:ss", e[47] = "mmss.0", e[48] = "##0.0E+0", e[49] = "@", e[56] = '"上午/下午 "hh"時"mm"分"ss"秒 "', e;
}
var Ee = {
  0: "General",
  1: "0",
  2: "0.00",
  3: "#,##0",
  4: "#,##0.00",
  9: "0%",
  10: "0.00%",
  11: "0.00E+00",
  12: "# ?/?",
  13: "# ??/??",
  14: "m/d/yy",
  15: "d-mmm-yy",
  16: "d-mmm",
  17: "mmm-yy",
  18: "h:mm AM/PM",
  19: "h:mm:ss AM/PM",
  20: "h:mm",
  21: "h:mm:ss",
  22: "m/d/yy h:mm",
  37: "#,##0 ;(#,##0)",
  38: "#,##0 ;[Red](#,##0)",
  39: "#,##0.00;(#,##0.00)",
  40: "#,##0.00;[Red](#,##0.00)",
  45: "mm:ss",
  46: "[h]:mm:ss",
  47: "mmss.0",
  48: "##0.0E+0",
  49: "@",
  56: '"上午/下午 "hh"時"mm"分"ss"秒 "'
}, kd = {
  5: 37,
  6: 38,
  7: 39,
  8: 40,
  //  5 -> 37 ...  8 -> 40
  23: 0,
  24: 0,
  25: 0,
  26: 0,
  // 23 ->  0 ... 26 ->  0
  27: 14,
  28: 14,
  29: 14,
  30: 14,
  31: 14,
  // 27 -> 14 ... 31 -> 14
  50: 14,
  51: 14,
  52: 14,
  53: 14,
  54: 14,
  // 50 -> 14 ... 58 -> 14
  55: 14,
  56: 14,
  57: 14,
  58: 14,
  59: 1,
  60: 2,
  61: 3,
  62: 4,
  // 59 ->  1 ... 62 ->  4
  67: 9,
  68: 10,
  // 67 ->  9 ... 68 -> 10
  69: 12,
  70: 13,
  71: 14,
  // 69 -> 12 ... 71 -> 14
  72: 14,
  73: 15,
  74: 16,
  75: 17,
  // 72 -> 14 ... 75 -> 17
  76: 20,
  77: 21,
  78: 22,
  // 76 -> 20 ... 78 -> 22
  79: 45,
  80: 46,
  81: 47,
  // 79 -> 45 ... 81 -> 47
  82: 0
  // 82 ->  0 ... 65536 -> 0 (omitted)
}, _5 = {
  //  5 -- Currency,   0 decimal, black negative
  5: '"$"#,##0_);\\("$"#,##0\\)',
  63: '"$"#,##0_);\\("$"#,##0\\)',
  //  6 -- Currency,   0 decimal, red   negative
  6: '"$"#,##0_);[Red]\\("$"#,##0\\)',
  64: '"$"#,##0_);[Red]\\("$"#,##0\\)',
  //  7 -- Currency,   2 decimal, black negative
  7: '"$"#,##0.00_);\\("$"#,##0.00\\)',
  65: '"$"#,##0.00_);\\("$"#,##0.00\\)',
  //  8 -- Currency,   2 decimal, red   negative
  8: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
  66: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
  // 41 -- Accounting, 0 decimal, No Symbol
  41: '_(* #,##0_);_(* \\(#,##0\\);_(* "-"_);_(@_)',
  // 42 -- Accounting, 0 decimal, $  Symbol
  42: '_("$"* #,##0_);_("$"* \\(#,##0\\);_("$"* "-"_);_(@_)',
  // 43 -- Accounting, 2 decimal, No Symbol
  43: '_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)',
  // 44 -- Accounting, 2 decimal, $  Symbol
  44: '_("$"* #,##0.00_);_("$"* \\(#,##0.00\\);_("$"* "-"??_);_(@_)'
};
function Wo(e, r, t) {
  for (var a = e < 0 ? -1 : 1, n = e * a, i = 0, s = 1, o = 0, u = 1, l = 0, c = 0, f = Math.floor(n); l < r && (f = Math.floor(n), o = f * s + i, c = f * l + u, !(n - f < 5e-8)); )
    n = 1 / (n - f), i = s, s = o, u = l, l = c;
  if (c > r && (l > r ? (c = u, o = i) : (c = l, o = s)), !t)
    return [0, a * o, c];
  var h = Math.floor(a * o / c);
  return [h, a * o - h * c, c];
}
function Aa(e, r, t) {
  if (e > 2958465 || e < 0)
    return null;
  var a = e | 0, n = Math.floor(86400 * (e - a)), i = 0, s = [], o = { D: a, T: n, u: 86400 * (e - a) - n, y: 0, m: 0, d: 0, H: 0, M: 0, S: 0, q: 0 };
  if (Math.abs(o.u) < 1e-6 && (o.u = 0), r && r.date1904 && (a += 1462), o.u > 0.9999 && (o.u = 0, ++n == 86400 && (o.T = n = 0, ++a, ++o.D)), a === 60)
    s = t ? [1317, 10, 29] : [1900, 2, 29], i = 3;
  else if (a === 0)
    s = t ? [1317, 8, 29] : [1900, 1, 0], i = 6;
  else {
    a > 60 && --a;
    var u = new Date(1900, 0, 1);
    u.setDate(u.getDate() + a - 1), s = [u.getFullYear(), u.getMonth() + 1, u.getDate()], i = u.getDay(), a < 60 && (i = (i + 6) % 7), t && (i = S5(u, s));
  }
  return o.y = s[0], o.m = s[1], o.d = s[2], o.S = n % 60, n = Math.floor(n / 60), o.M = n % 60, n = Math.floor(n / 60), o.H = n, o.q = i, o;
}
var Cp = /* @__PURE__ */ new Date(1899, 11, 31, 0, 0, 0), $5 = /* @__PURE__ */ Cp.getTime(), D5 = /* @__PURE__ */ new Date(1900, 2, 1, 0, 0, 0);
function Fp(e, r) {
  var t = /* @__PURE__ */ e.getTime();
  return r ? t -= 1461 * 24 * 60 * 60 * 1e3 : e >= D5 && (t += 24 * 60 * 60 * 1e3), (t - ($5 + (/* @__PURE__ */ e.getTimezoneOffset() - /* @__PURE__ */ Cp.getTimezoneOffset()) * 6e4)) / (24 * 60 * 60 * 1e3);
}
function bc(e) {
  return e.indexOf(".") == -1 ? e : e.replace(/(?:\.0*|(\.\d*[1-9])0+)$/, "$1");
}
function E5(e) {
  return e.indexOf("E") == -1 ? e : e.replace(/(?:\.0*|(\.\d*[1-9])0+)[Ee]/, "$1E").replace(/(E[+-])(\d)$/, "$10$2");
}
function k5(e) {
  var r = e < 0 ? 12 : 11, t = bc(e.toFixed(12));
  return t.length <= r || (t = e.toPrecision(10), t.length <= r) ? t : e.toExponential(5);
}
function T5(e) {
  var r = bc(e.toFixed(11));
  return r.length > (e < 0 ? 12 : 11) || r === "0" || r === "-0" ? e.toPrecision(6) : r;
}
function ts(e) {
  var r = Math.floor(Math.log(Math.abs(e)) * Math.LOG10E), t;
  return r >= -4 && r <= -1 ? t = e.toPrecision(10 + r) : Math.abs(r) <= 9 ? t = k5(e) : r === 10 ? t = e.toFixed(10).substr(0, 12) : t = T5(e), bc(E5(t.toUpperCase()));
}
function cn(e, r) {
  switch (typeof e) {
    case "string":
      return e;
    case "boolean":
      return e ? "TRUE" : "FALSE";
    case "number":
      return (e | 0) === e ? e.toString(10) : ts(e);
    case "undefined":
      return "";
    case "object":
      if (e == null)
        return "";
      if (e instanceof Date)
        return pt(14, Fp(e, r && r.date1904), r);
  }
  throw new Error("unsupported value in General format: " + e);
}
function S5(e, r) {
  r[0] -= 581;
  var t = e.getDay();
  return e < 60 && (t = (t + 6) % 7), t;
}
function C5(e, r, t, a) {
  var n = "", i = 0, s = 0, o = t.y, u, l = 0;
  switch (e) {
    case 98:
      o = t.y + 543;
    case 121:
      switch (r.length) {
        case 1:
        case 2:
          u = o % 100, l = 2;
          break;
        default:
          u = o % 1e4, l = 4;
          break;
      }
      break;
    case 109:
      switch (r.length) {
        case 1:
        case 2:
          u = t.m, l = r.length;
          break;
        case 3:
          return lu[t.m - 1][1];
        case 5:
          return lu[t.m - 1][0];
        default:
          return lu[t.m - 1][2];
      }
      break;
    case 100:
      switch (r.length) {
        case 1:
        case 2:
          u = t.d, l = r.length;
          break;
        case 3:
          return Ed[t.q][0];
        default:
          return Ed[t.q][1];
      }
      break;
    case 104:
      switch (r.length) {
        case 1:
        case 2:
          u = 1 + (t.H + 11) % 12, l = r.length;
          break;
        default:
          throw "bad hour format: " + r;
      }
      break;
    case 72:
      switch (r.length) {
        case 1:
        case 2:
          u = t.H, l = r.length;
          break;
        default:
          throw "bad hour format: " + r;
      }
      break;
    case 77:
      switch (r.length) {
        case 1:
        case 2:
          u = t.M, l = r.length;
          break;
        default:
          throw "bad minute format: " + r;
      }
      break;
    case 115:
      if (r != "s" && r != "ss" && r != ".0" && r != ".00" && r != ".000")
        throw "bad second format: " + r;
      return t.u === 0 && (r == "s" || r == "ss") ? It(t.S, r.length) : (a >= 2 ? s = a === 3 ? 1e3 : 100 : s = a === 1 ? 10 : 1, i = Math.round(s * (t.S + t.u)), i >= 60 * s && (i = 0), r === "s" ? i === 0 ? "0" : "" + i / s : (n = It(i, 2 + a), r === "ss" ? n.substr(0, 2) : "." + n.substr(2, r.length - 1)));
    case 90:
      switch (r) {
        case "[h]":
        case "[hh]":
          u = t.D * 24 + t.H;
          break;
        case "[m]":
        case "[mm]":
          u = (t.D * 24 + t.H) * 60 + t.M;
          break;
        case "[s]":
        case "[ss]":
          u = ((t.D * 24 + t.H) * 60 + t.M) * 60 + Math.round(t.S + t.u);
          break;
        default:
          throw "bad abstime format: " + r;
      }
      l = r.length === 3 ? 1 : 2;
      break;
    case 101:
      u = o, l = 1;
      break;
  }
  var c = l > 0 ? It(u, l) : "";
  return c;
}
function Ra(e) {
  var r = 3;
  if (e.length <= r)
    return e;
  for (var t = e.length % r, a = e.substr(0, t); t != e.length; t += r)
    a += (a.length > 0 ? "," : "") + e.substr(t, r);
  return a;
}
var Ap = /%/g;
function F5(e, r, t) {
  var a = r.replace(Ap, ""), n = r.length - a.length;
  return la(e, a, t * Math.pow(10, 2 * n)) + vr("%", n);
}
function A5(e, r, t) {
  for (var a = r.length - 1; r.charCodeAt(a - 1) === 44; )
    --a;
  return la(e, r.substr(0, a), t / Math.pow(10, 3 * (r.length - a)));
}
function Rp(e, r) {
  var t, a = e.indexOf("E") - e.indexOf(".") - 1;
  if (e.match(/^#+0.0E\+0$/)) {
    if (r == 0)
      return "0.0E+0";
    if (r < 0)
      return "-" + Rp(e, -r);
    var n = e.indexOf(".");
    n === -1 && (n = e.indexOf("E"));
    var i = Math.floor(Math.log(r) * Math.LOG10E) % n;
    if (i < 0 && (i += n), t = (r / Math.pow(10, i)).toPrecision(a + 1 + (n + i) % n), t.indexOf("e") === -1) {
      var s = Math.floor(Math.log(r) * Math.LOG10E);
      for (t.indexOf(".") === -1 ? t = t.charAt(0) + "." + t.substr(1) + "E+" + (s - t.length + i) : t += "E+" + (s - i); t.substr(0, 2) === "0."; )
        t = t.charAt(0) + t.substr(2, n) + "." + t.substr(2 + n), t = t.replace(/^0+([1-9])/, "$1").replace(/^0+\./, "0.");
      t = t.replace(/\+-/, "-");
    }
    t = t.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function(o, u, l, c) {
      return u + l + c.substr(0, (n + i) % n) + "." + c.substr(i) + "E";
    });
  } else
    t = r.toExponential(a);
  return e.match(/E\+00$/) && t.match(/e[+-]\d$/) && (t = t.substr(0, t.length - 1) + "0" + t.charAt(t.length - 1)), e.match(/E\-/) && t.match(/e\+/) && (t = t.replace(/e\+/, "e")), t.replace("e", "E");
}
var Ip = /# (\?+)( ?)\/( ?)(\d+)/;
function R5(e, r, t) {
  var a = parseInt(e[4], 10), n = Math.round(r * a), i = Math.floor(n / a), s = n - i * a, o = a;
  return t + (i === 0 ? "" : "" + i) + " " + (s === 0 ? vr(" ", e[1].length + 1 + e[4].length) : yc(s, e[1].length) + e[2] + "/" + e[3] + It(o, e[4].length));
}
function I5(e, r, t) {
  return t + (r === 0 ? "" : "" + r) + vr(" ", e[1].length + 2 + e[4].length);
}
var Bp = /^#*0*\.([0#]+)/, Pp = /\).*[0#]/, Mp = /\(###\) ###\\?-####/;
function et(e) {
  for (var r = "", t, a = 0; a != e.length; ++a)
    switch (t = e.charCodeAt(a)) {
      case 35:
        break;
      case 63:
        r += " ";
        break;
      case 48:
        r += "0";
        break;
      default:
        r += String.fromCharCode(t);
    }
  return r;
}
function Td(e, r) {
  var t = Math.pow(10, r);
  return "" + Math.round(e * t) / t;
}
function Sd(e, r) {
  var t = e - Math.floor(e), a = Math.pow(10, r);
  return r < ("" + Math.round(t * a)).length ? 0 : Math.round(t * a);
}
function B5(e, r) {
  return r < ("" + Math.round((e - Math.floor(e)) * Math.pow(10, r))).length ? 1 : 0;
}
function P5(e) {
  return e < 2147483647 && e > -2147483648 ? "" + (e >= 0 ? e | 0 : e - 1 | 0) : "" + Math.floor(e);
}
function yt(e, r, t) {
  if (e.charCodeAt(0) === 40 && !r.match(Pp)) {
    var a = r.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
    return t >= 0 ? yt("n", a, t) : "(" + yt("n", a, -t) + ")";
  }
  if (r.charCodeAt(r.length - 1) === 44)
    return A5(e, r, t);
  if (r.indexOf("%") !== -1)
    return F5(e, r, t);
  if (r.indexOf("E") !== -1)
    return Rp(r, t);
  if (r.charCodeAt(0) === 36)
    return "$" + yt(e, r.substr(r.charAt(1) == " " ? 2 : 1), t);
  var n, i, s, o, u = Math.abs(t), l = t < 0 ? "-" : "";
  if (r.match(/^00+$/))
    return l + Cn(u, r.length);
  if (r.match(/^[#?]+$/))
    return n = Cn(t, 0), n === "0" && (n = ""), n.length > r.length ? n : et(r.substr(0, r.length - n.length)) + n;
  if (i = r.match(Ip))
    return R5(i, u, l);
  if (r.match(/^#+0+$/))
    return l + Cn(u, r.length - r.indexOf("0"));
  if (i = r.match(Bp))
    return n = Td(t, i[1].length).replace(/^([^\.]+)$/, "$1." + et(i[1])).replace(/\.$/, "." + et(i[1])).replace(/\.(\d*)$/, function(m, x) {
      return "." + x + vr("0", et(
        /*::(*/
        i[1]
      ).length - x.length);
    }), r.indexOf("0.") !== -1 ? n : n.replace(/^0\./, ".");
  if (r = r.replace(/^#+([0.])/, "$1"), i = r.match(/^(0*)\.(#*)$/))
    return l + Td(u, i[2].length).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, i[1].length ? "0." : ".");
  if (i = r.match(/^#{1,3},##0(\.?)$/))
    return l + Ra(Cn(u, 0));
  if (i = r.match(/^#,##0\.([#0]*0)$/))
    return t < 0 ? "-" + yt(e, r, -t) : Ra("" + (Math.floor(t) + B5(t, i[1].length))) + "." + It(Sd(t, i[1].length), i[1].length);
  if (i = r.match(/^#,#*,#0/))
    return yt(e, r.replace(/^#,#*,/, ""), t);
  if (i = r.match(/^([0#]+)(\\?-([0#]+))+$/))
    return n = zn(yt(e, r.replace(/[\\-]/g, ""), t)), s = 0, zn(zn(r.replace(/\\/g, "")).replace(/[0#]/g, function(m) {
      return s < n.length ? n.charAt(s++) : m === "0" ? "0" : "";
    }));
  if (r.match(Mp))
    return n = yt(e, "##########", t), "(" + n.substr(0, 3) + ") " + n.substr(3, 3) + "-" + n.substr(6);
  var c = "";
  if (i = r.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))
    return s = Math.min(
      /*::String(*/
      i[4].length,
      7
    ), o = Wo(u, Math.pow(10, s) - 1, !1), n = "" + l, c = la(
      "n",
      /*::String(*/
      i[1],
      o[1]
    ), c.charAt(c.length - 1) == " " && (c = c.substr(0, c.length - 1) + "0"), n += c + /*::String(*/
    i[2] + "/" + /*::String(*/
    i[3], c = Uo(o[2], s), c.length < i[4].length && (c = et(i[4].substr(i[4].length - c.length)) + c), n += c, n;
  if (i = r.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))
    return s = Math.min(Math.max(i[1].length, i[4].length), 7), o = Wo(u, Math.pow(10, s) - 1, !0), l + (o[0] || (o[1] ? "" : "0")) + " " + (o[1] ? yc(o[1], s) + i[2] + "/" + i[3] + Uo(o[2], s) : vr(" ", 2 * s + 1 + i[2].length + i[3].length));
  if (i = r.match(/^[#0?]+$/))
    return n = Cn(t, 0), r.length <= n.length ? n : et(r.substr(0, r.length - n.length)) + n;
  if (i = r.match(/^([#0?]+)\.([#0]+)$/)) {
    n = "" + t.toFixed(Math.min(i[2].length, 10)).replace(/([^0])0+$/, "$1"), s = n.indexOf(".");
    var f = r.indexOf(".") - s, h = r.length - n.length - f;
    return et(r.substr(0, f) + n + r.substr(r.length - h));
  }
  if (i = r.match(/^00,000\.([#0]*0)$/))
    return s = Sd(t, i[1].length), t < 0 ? "-" + yt(e, r, -t) : Ra(P5(t)).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function(m) {
      return "00," + (m.length < 3 ? It(0, 3 - m.length) : "") + m;
    }) + "." + It(s, i[1].length);
  switch (r) {
    case "###,##0.00":
      return yt(e, "#,##0.00", t);
    case "###,###":
    case "##,###":
    case "#,###":
      var d = Ra(Cn(u, 0));
      return d !== "0" ? l + d : "";
    case "###,###.00":
      return yt(e, "###,##0.00", t).replace(/^0\./, ".");
    case "#,###.00":
      return yt(e, "#,##0.00", t).replace(/^0\./, ".");
  }
  throw new Error("unsupported format |" + r + "|");
}
function M5(e, r, t) {
  for (var a = r.length - 1; r.charCodeAt(a - 1) === 44; )
    --a;
  return la(e, r.substr(0, a), t / Math.pow(10, 3 * (r.length - a)));
}
function O5(e, r, t) {
  var a = r.replace(Ap, ""), n = r.length - a.length;
  return la(e, a, t * Math.pow(10, 2 * n)) + vr("%", n);
}
function Op(e, r) {
  var t, a = e.indexOf("E") - e.indexOf(".") - 1;
  if (e.match(/^#+0.0E\+0$/)) {
    if (r == 0)
      return "0.0E+0";
    if (r < 0)
      return "-" + Op(e, -r);
    var n = e.indexOf(".");
    n === -1 && (n = e.indexOf("E"));
    var i = Math.floor(Math.log(r) * Math.LOG10E) % n;
    if (i < 0 && (i += n), t = (r / Math.pow(10, i)).toPrecision(a + 1 + (n + i) % n), !t.match(/[Ee]/)) {
      var s = Math.floor(Math.log(r) * Math.LOG10E);
      t.indexOf(".") === -1 ? t = t.charAt(0) + "." + t.substr(1) + "E+" + (s - t.length + i) : t += "E+" + (s - i), t = t.replace(/\+-/, "-");
    }
    t = t.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function(o, u, l, c) {
      return u + l + c.substr(0, (n + i) % n) + "." + c.substr(i) + "E";
    });
  } else
    t = r.toExponential(a);
  return e.match(/E\+00$/) && t.match(/e[+-]\d$/) && (t = t.substr(0, t.length - 1) + "0" + t.charAt(t.length - 1)), e.match(/E\-/) && t.match(/e\+/) && (t = t.replace(/e\+/, "e")), t.replace("e", "E");
}
function Vt(e, r, t) {
  if (e.charCodeAt(0) === 40 && !r.match(Pp)) {
    var a = r.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
    return t >= 0 ? Vt("n", a, t) : "(" + Vt("n", a, -t) + ")";
  }
  if (r.charCodeAt(r.length - 1) === 44)
    return M5(e, r, t);
  if (r.indexOf("%") !== -1)
    return O5(e, r, t);
  if (r.indexOf("E") !== -1)
    return Op(r, t);
  if (r.charCodeAt(0) === 36)
    return "$" + Vt(e, r.substr(r.charAt(1) == " " ? 2 : 1), t);
  var n, i, s, o, u = Math.abs(t), l = t < 0 ? "-" : "";
  if (r.match(/^00+$/))
    return l + It(u, r.length);
  if (r.match(/^[#?]+$/))
    return n = "" + t, t === 0 && (n = ""), n.length > r.length ? n : et(r.substr(0, r.length - n.length)) + n;
  if (i = r.match(Ip))
    return I5(i, u, l);
  if (r.match(/^#+0+$/))
    return l + It(u, r.length - r.indexOf("0"));
  if (i = r.match(Bp))
    return n = ("" + t).replace(/^([^\.]+)$/, "$1." + et(i[1])).replace(/\.$/, "." + et(i[1])), n = n.replace(/\.(\d*)$/, function(m, x) {
      return "." + x + vr("0", et(i[1]).length - x.length);
    }), r.indexOf("0.") !== -1 ? n : n.replace(/^0\./, ".");
  if (r = r.replace(/^#+([0.])/, "$1"), i = r.match(/^(0*)\.(#*)$/))
    return l + ("" + u).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, i[1].length ? "0." : ".");
  if (i = r.match(/^#{1,3},##0(\.?)$/))
    return l + Ra("" + u);
  if (i = r.match(/^#,##0\.([#0]*0)$/))
    return t < 0 ? "-" + Vt(e, r, -t) : Ra("" + t) + "." + vr("0", i[1].length);
  if (i = r.match(/^#,#*,#0/))
    return Vt(e, r.replace(/^#,#*,/, ""), t);
  if (i = r.match(/^([0#]+)(\\?-([0#]+))+$/))
    return n = zn(Vt(e, r.replace(/[\\-]/g, ""), t)), s = 0, zn(zn(r.replace(/\\/g, "")).replace(/[0#]/g, function(m) {
      return s < n.length ? n.charAt(s++) : m === "0" ? "0" : "";
    }));
  if (r.match(Mp))
    return n = Vt(e, "##########", t), "(" + n.substr(0, 3) + ") " + n.substr(3, 3) + "-" + n.substr(6);
  var c = "";
  if (i = r.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))
    return s = Math.min(
      /*::String(*/
      i[4].length,
      7
    ), o = Wo(u, Math.pow(10, s) - 1, !1), n = "" + l, c = la(
      "n",
      /*::String(*/
      i[1],
      o[1]
    ), c.charAt(c.length - 1) == " " && (c = c.substr(0, c.length - 1) + "0"), n += c + /*::String(*/
    i[2] + "/" + /*::String(*/
    i[3], c = Uo(o[2], s), c.length < i[4].length && (c = et(i[4].substr(i[4].length - c.length)) + c), n += c, n;
  if (i = r.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))
    return s = Math.min(Math.max(i[1].length, i[4].length), 7), o = Wo(u, Math.pow(10, s) - 1, !0), l + (o[0] || (o[1] ? "" : "0")) + " " + (o[1] ? yc(o[1], s) + i[2] + "/" + i[3] + Uo(o[2], s) : vr(" ", 2 * s + 1 + i[2].length + i[3].length));
  if (i = r.match(/^[#0?]+$/))
    return n = "" + t, r.length <= n.length ? n : et(r.substr(0, r.length - n.length)) + n;
  if (i = r.match(/^([#0]+)\.([#0]+)$/)) {
    n = "" + t.toFixed(Math.min(i[2].length, 10)).replace(/([^0])0+$/, "$1"), s = n.indexOf(".");
    var f = r.indexOf(".") - s, h = r.length - n.length - f;
    return et(r.substr(0, f) + n + r.substr(r.length - h));
  }
  if (i = r.match(/^00,000\.([#0]*0)$/))
    return t < 0 ? "-" + Vt(e, r, -t) : Ra("" + t).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function(m) {
      return "00," + (m.length < 3 ? It(0, 3 - m.length) : "") + m;
    }) + "." + It(0, i[1].length);
  switch (r) {
    case "###,###":
    case "##,###":
    case "#,###":
      var d = Ra("" + u);
      return d !== "0" ? l + d : "";
    default:
      if (r.match(/\.[0#?]*$/))
        return Vt(e, r.slice(0, r.lastIndexOf(".")), t) + et(r.slice(r.lastIndexOf(".")));
  }
  throw new Error("unsupported format |" + r + "|");
}
function la(e, r, t) {
  return (t | 0) === t ? Vt(e, r, t) : yt(e, r, t);
}
function L5(e) {
  for (var r = [], t = !1, a = 0, n = 0; a < e.length; ++a)
    switch (
      /*cc=*/
      e.charCodeAt(a)
    ) {
      case 34:
        t = !t;
        break;
      case 95:
      case 42:
      case 92:
        ++a;
        break;
      case 59:
        r[r.length] = e.substr(n, a - n), n = a + 1;
    }
  if (r[r.length] = e.substr(n), t === !0)
    throw new Error("Format |" + e + "| unterminated string ");
  return r;
}
var Lp = /\[[HhMmSs\u0E0A\u0E19\u0E17]*\]/;
function pn(e) {
  for (var r = 0, t = "", a = ""; r < e.length; )
    switch (t = e.charAt(r)) {
      case "G":
        Vo(e, r) && (r += 6), r++;
        break;
      case '"':
        for (
          ;
          /*cc=*/
          e.charCodeAt(++r) !== 34 && r < e.length;
        )
          ;
        ++r;
        break;
      case "\\":
        r += 2;
        break;
      case "_":
        r += 2;
        break;
      case "@":
        ++r;
        break;
      case "B":
      case "b":
        if (e.charAt(r + 1) === "1" || e.charAt(r + 1) === "2")
          return !0;
      case "M":
      case "D":
      case "Y":
      case "H":
      case "S":
      case "E":
      case "m":
      case "d":
      case "y":
      case "h":
      case "s":
      case "e":
      case "g":
        return !0;
      case "A":
      case "a":
      case "上":
        if (e.substr(r, 3).toUpperCase() === "A/P" || e.substr(r, 5).toUpperCase() === "AM/PM" || e.substr(r, 5).toUpperCase() === "上午/下午")
          return !0;
        ++r;
        break;
      case "[":
        for (a = t; e.charAt(r++) !== "]" && r < e.length; )
          a += e.charAt(r);
        if (a.match(Lp))
          return !0;
        break;
      case ".":
      case "0":
      case "#":
        for (; r < e.length && ("0#?.,E+-%".indexOf(t = e.charAt(++r)) > -1 || t == "\\" && e.charAt(r + 1) == "-" && "0#".indexOf(e.charAt(r + 2)) > -1); )
          ;
        break;
      case "?":
        for (; e.charAt(++r) === t; )
          ;
        break;
      case "*":
        ++r, (e.charAt(r) == " " || e.charAt(r) == "*") && ++r;
        break;
      case "(":
      case ")":
        ++r;
        break;
      case "1":
      case "2":
      case "3":
      case "4":
      case "5":
      case "6":
      case "7":
      case "8":
      case "9":
        for (; r < e.length && "0123456789".indexOf(e.charAt(++r)) > -1; )
          ;
        break;
      case " ":
        ++r;
        break;
      default:
        ++r;
        break;
    }
  return !1;
}
function N5(e, r, t, a) {
  for (var n = [], i = "", s = 0, o = "", u = "t", l, c, f, h = "H"; s < e.length; )
    switch (o = e.charAt(s)) {
      case "G":
        if (!Vo(e, s))
          throw new Error("unrecognized character " + o + " in " + e);
        n[n.length] = { t: "G", v: "General" }, s += 7;
        break;
      case '"':
        for (i = ""; (f = e.charCodeAt(++s)) !== 34 && s < e.length; )
          i += String.fromCharCode(f);
        n[n.length] = { t: "t", v: i }, ++s;
        break;
      case "\\":
        var d = e.charAt(++s), m = d === "(" || d === ")" ? d : "t";
        n[n.length] = { t: m, v: d }, ++s;
        break;
      case "_":
        n[n.length] = { t: "t", v: " " }, s += 2;
        break;
      case "@":
        n[n.length] = { t: "T", v: r }, ++s;
        break;
      case "B":
      case "b":
        if (e.charAt(s + 1) === "1" || e.charAt(s + 1) === "2") {
          if (l == null && (l = Aa(r, t, e.charAt(s + 1) === "2"), l == null))
            return "";
          n[n.length] = { t: "X", v: e.substr(s, 2) }, u = o, s += 2;
          break;
        }
      case "M":
      case "D":
      case "Y":
      case "H":
      case "S":
      case "E":
        o = o.toLowerCase();
      case "m":
      case "d":
      case "y":
      case "h":
      case "s":
      case "e":
      case "g":
        if (r < 0 || l == null && (l = Aa(r, t), l == null))
          return "";
        for (i = o; ++s < e.length && e.charAt(s).toLowerCase() === o; )
          i += o;
        o === "m" && u.toLowerCase() === "h" && (o = "M"), o === "h" && (o = h), n[n.length] = { t: o, v: i }, u = o;
        break;
      case "A":
      case "a":
      case "上":
        var x = { t: o, v: o };
        if (l == null && (l = Aa(r, t)), e.substr(s, 3).toUpperCase() === "A/P" ? (l != null && (x.v = l.H >= 12 ? "P" : "A"), x.t = "T", h = "h", s += 3) : e.substr(s, 5).toUpperCase() === "AM/PM" ? (l != null && (x.v = l.H >= 12 ? "PM" : "AM"), x.t = "T", s += 5, h = "h") : e.substr(s, 5).toUpperCase() === "上午/下午" ? (l != null && (x.v = l.H >= 12 ? "下午" : "上午"), x.t = "T", s += 5, h = "h") : (x.t = "t", ++s), l == null && x.t === "T")
          return "";
        n[n.length] = x, u = o;
        break;
      case "[":
        for (i = o; e.charAt(s++) !== "]" && s < e.length; )
          i += e.charAt(s);
        if (i.slice(-1) !== "]")
          throw 'unterminated "[" block: |' + i + "|";
        if (i.match(Lp)) {
          if (l == null && (l = Aa(r, t), l == null))
            return "";
          n[n.length] = { t: "Z", v: i.toLowerCase() }, u = i.charAt(1);
        } else
          i.indexOf("$") > -1 && (i = (i.match(/\$([^-\[\]]*)/) || [])[1] || "$", pn(e) || (n[n.length] = { t: "t", v: i }));
        break;
      case ".":
        if (l != null) {
          for (i = o; ++s < e.length && (o = e.charAt(s)) === "0"; )
            i += o;
          n[n.length] = { t: "s", v: i };
          break;
        }
      case "0":
      case "#":
        for (i = o; ++s < e.length && "0#?.,E+-%".indexOf(o = e.charAt(s)) > -1; )
          i += o;
        n[n.length] = { t: "n", v: i };
        break;
      case "?":
        for (i = o; e.charAt(++s) === o; )
          i += o;
        n[n.length] = { t: o, v: i }, u = o;
        break;
      case "*":
        ++s, (e.charAt(s) == " " || e.charAt(s) == "*") && ++s;
        break;
      case "(":
      case ")":
        n[n.length] = { t: a === 1 ? "t" : o, v: o }, ++s;
        break;
      case "1":
      case "2":
      case "3":
      case "4":
      case "5":
      case "6":
      case "7":
      case "8":
      case "9":
        for (i = o; s < e.length && "0123456789".indexOf(e.charAt(++s)) > -1; )
          i += e.charAt(s);
        n[n.length] = { t: "D", v: i };
        break;
      case " ":
        n[n.length] = { t: o, v: o }, ++s;
        break;
      case "$":
        n[n.length] = { t: "t", v: "$" }, ++s;
        break;
      default:
        if (",$-+/():!^&'~{}<>=€acfijklopqrtuvwxzP".indexOf(o) === -1)
          throw new Error("unrecognized character " + o + " in " + e);
        n[n.length] = { t: "t", v: o }, ++s;
        break;
    }
  var p = 0, w = 0, D;
  for (s = n.length - 1, u = "t"; s >= 0; --s)
    switch (n[s].t) {
      case "h":
      case "H":
        n[s].t = h, u = "h", p < 1 && (p = 1);
        break;
      case "s":
        (D = n[s].v.match(/\.0+$/)) && (w = Math.max(w, D[0].length - 1)), p < 3 && (p = 3);
      case "d":
      case "y":
      case "M":
      case "e":
        u = n[s].t;
        break;
      case "m":
        u === "s" && (n[s].t = "M", p < 2 && (p = 2));
        break;
      case "X":
        break;
      case "Z":
        p < 1 && n[s].v.match(/[Hh]/) && (p = 1), p < 2 && n[s].v.match(/[Mm]/) && (p = 2), p < 3 && n[s].v.match(/[Ss]/) && (p = 3);
    }
  switch (p) {
    case 0:
      break;
    case 1:
      l.u >= 0.5 && (l.u = 0, ++l.S), l.S >= 60 && (l.S = 0, ++l.M), l.M >= 60 && (l.M = 0, ++l.H);
      break;
    case 2:
      l.u >= 0.5 && (l.u = 0, ++l.S), l.S >= 60 && (l.S = 0, ++l.M);
      break;
  }
  var y = "", B;
  for (s = 0; s < n.length; ++s)
    switch (n[s].t) {
      case "t":
      case "T":
      case " ":
      case "D":
        break;
      case "X":
        n[s].v = "", n[s].t = ";";
        break;
      case "d":
      case "m":
      case "y":
      case "h":
      case "H":
      case "M":
      case "s":
      case "e":
      case "b":
      case "Z":
        n[s].v = C5(n[s].t.charCodeAt(0), n[s].v, l, w), n[s].t = "t";
        break;
      case "n":
      case "?":
        for (B = s + 1; n[B] != null && ((o = n[B].t) === "?" || o === "D" || (o === " " || o === "t") && n[B + 1] != null && (n[B + 1].t === "?" || n[B + 1].t === "t" && n[B + 1].v === "/") || n[s].t === "(" && (o === " " || o === "n" || o === ")") || o === "t" && (n[B].v === "/" || n[B].v === " " && n[B + 1] != null && n[B + 1].t == "?")); )
          n[s].v += n[B].v, n[B] = { v: "", t: ";" }, ++B;
        y += n[s].v, s = B - 1;
        break;
      case "G":
        n[s].t = "t", n[s].v = cn(r, t);
        break;
    }
  var L = "", U, k;
  if (y.length > 0) {
    y.charCodeAt(0) == 40 ? (U = r < 0 && y.charCodeAt(0) === 45 ? -r : r, k = la("n", y, U)) : (U = r < 0 && a > 1 ? -r : r, k = la("n", y, U), U < 0 && n[0] && n[0].t == "t" && (k = k.substr(1), n[0].v = "-" + n[0].v)), B = k.length - 1;
    var v = n.length;
    for (s = 0; s < n.length; ++s)
      if (n[s] != null && n[s].t != "t" && n[s].v.indexOf(".") > -1) {
        v = s;
        break;
      }
    var b = n.length;
    if (v === n.length && k.indexOf("E") === -1) {
      for (s = n.length - 1; s >= 0; --s)
        n[s] == null || "n?".indexOf(n[s].t) === -1 || (B >= n[s].v.length - 1 ? (B -= n[s].v.length, n[s].v = k.substr(B + 1, n[s].v.length)) : B < 0 ? n[s].v = "" : (n[s].v = k.substr(0, B + 1), B = -1), n[s].t = "t", b = s);
      B >= 0 && b < n.length && (n[b].v = k.substr(0, B + 1) + n[b].v);
    } else if (v !== n.length && k.indexOf("E") === -1) {
      for (B = k.indexOf(".") - 1, s = v; s >= 0; --s)
        if (!(n[s] == null || "n?".indexOf(n[s].t) === -1)) {
          for (c = n[s].v.indexOf(".") > -1 && s === v ? n[s].v.indexOf(".") - 1 : n[s].v.length - 1, L = n[s].v.substr(c + 1); c >= 0; --c)
            B >= 0 && (n[s].v.charAt(c) === "0" || n[s].v.charAt(c) === "#") && (L = k.charAt(B--) + L);
          n[s].v = L, n[s].t = "t", b = s;
        }
      for (B >= 0 && b < n.length && (n[b].v = k.substr(0, B + 1) + n[b].v), B = k.indexOf(".") + 1, s = v; s < n.length; ++s)
        if (!(n[s] == null || "n?(".indexOf(n[s].t) === -1 && s !== v)) {
          for (c = n[s].v.indexOf(".") > -1 && s === v ? n[s].v.indexOf(".") + 1 : 0, L = n[s].v.substr(0, c); c < n[s].v.length; ++c)
            B < k.length && (L += k.charAt(B++));
          n[s].v = L, n[s].t = "t", b = s;
        }
    }
  }
  for (s = 0; s < n.length; ++s)
    n[s] != null && "n?".indexOf(n[s].t) > -1 && (U = a > 1 && r < 0 && s > 0 && n[s - 1].v === "-" ? -r : r, n[s].v = la(n[s].t, n[s].v, U), n[s].t = "t");
  var A = "";
  for (s = 0; s !== n.length; ++s)
    n[s] != null && (A += n[s].v);
  return A;
}
var Cd = /\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;
function Fd(e, r) {
  if (r == null)
    return !1;
  var t = parseFloat(r[2]);
  switch (r[1]) {
    case "=":
      if (e == t)
        return !0;
      break;
    case ">":
      if (e > t)
        return !0;
      break;
    case "<":
      if (e < t)
        return !0;
      break;
    case "<>":
      if (e != t)
        return !0;
      break;
    case ">=":
      if (e >= t)
        return !0;
      break;
    case "<=":
      if (e <= t)
        return !0;
      break;
  }
  return !1;
}
function U5(e, r) {
  var t = L5(e), a = t.length, n = t[a - 1].indexOf("@");
  if (a < 4 && n > -1 && --a, t.length > 4)
    throw new Error("cannot find right format for |" + t.join("|") + "|");
  if (typeof r != "number")
    return [4, t.length === 4 || n > -1 ? t[t.length - 1] : "@"];
  switch (t.length) {
    case 1:
      t = n > -1 ? ["General", "General", "General", t[0]] : [t[0], t[0], t[0], "@"];
      break;
    case 2:
      t = n > -1 ? [t[0], t[0], t[0], t[1]] : [t[0], t[1], t[0], "@"];
      break;
    case 3:
      t = n > -1 ? [t[0], t[1], t[0], t[2]] : [t[0], t[1], t[2], "@"];
      break;
  }
  var i = r > 0 ? t[0] : r < 0 ? t[1] : t[2];
  if (t[0].indexOf("[") === -1 && t[1].indexOf("[") === -1)
    return [a, i];
  if (t[0].match(/\[[=<>]/) != null || t[1].match(/\[[=<>]/) != null) {
    var s = t[0].match(Cd), o = t[1].match(Cd);
    return Fd(r, s) ? [a, t[0]] : Fd(r, o) ? [a, t[1]] : [a, t[s != null && o != null ? 2 : 1]];
  }
  return [a, i];
}
function pt(e, r, t) {
  t == null && (t = {});
  var a = "";
  switch (typeof e) {
    case "string":
      e == "m/d/yy" && t.dateNF ? a = t.dateNF : a = e;
      break;
    case "number":
      e == 14 && t.dateNF ? a = t.dateNF : a = (t.table != null ? t.table : Ee)[e], a == null && (a = t.table && t.table[kd[e]] || Ee[kd[e]]), a == null && (a = _5[e] || "General");
      break;
  }
  if (Vo(a, 0))
    return cn(r, t);
  r instanceof Date && (r = Fp(r, t.date1904));
  var n = U5(a, r);
  if (Vo(n[1]))
    return cn(r, t);
  if (r === !0)
    r = "TRUE";
  else if (r === !1)
    r = "FALSE";
  else if (r === "" || r == null)
    return "";
  return N5(n[1], r, t, n[0]);
}
function Gt(e, r) {
  if (typeof r != "number") {
    r = +r || -1;
    for (var t = 0; t < 392; ++t) {
      if (Ee[t] == null) {
        r < 0 && (r = t);
        continue;
      }
      if (Ee[t] == e) {
        r = t;
        break;
      }
    }
    r < 0 && (r = 391);
  }
  return Ee[r] = e, r;
}
function $s(e) {
  for (var r = 0; r != 392; ++r)
    e[r] !== void 0 && Gt(e[r], r);
}
function hi() {
  Ee = w5();
}
var Np = {
  format: pt,
  load: Gt,
  _table: Ee,
  load_table: $s,
  parse_date_code: Aa,
  is_date: pn,
  get_table: function() {
    return Np._table = Ee;
  }
}, V5 = {
  5: '"$"#,##0_);\\("$"#,##0\\)',
  6: '"$"#,##0_);[Red]\\("$"#,##0\\)',
  7: '"$"#,##0.00_);\\("$"#,##0.00\\)',
  8: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
  23: "General",
  24: "General",
  25: "General",
  26: "General",
  27: "m/d/yy",
  28: "m/d/yy",
  29: "m/d/yy",
  30: "m/d/yy",
  31: "m/d/yy",
  32: "h:mm:ss",
  33: "h:mm:ss",
  34: "h:mm:ss",
  35: "h:mm:ss",
  36: "m/d/yy",
  41: '_(* #,##0_);_(* (#,##0);_(* "-"_);_(@_)',
  42: '_("$"* #,##0_);_("$"* (#,##0);_("$"* "-"_);_(@_)',
  43: '_(* #,##0.00_);_(* (#,##0.00);_(* "-"??_);_(@_)',
  44: '_("$"* #,##0.00_);_("$"* (#,##0.00);_("$"* "-"??_);_(@_)',
  50: "m/d/yy",
  51: "m/d/yy",
  52: "m/d/yy",
  53: "m/d/yy",
  54: "m/d/yy",
  55: "m/d/yy",
  56: "m/d/yy",
  57: "m/d/yy",
  58: "m/d/yy",
  59: "0",
  60: "0.00",
  61: "#,##0",
  62: "#,##0.00",
  63: '"$"#,##0_);\\("$"#,##0\\)',
  64: '"$"#,##0_);[Red]\\("$"#,##0\\)',
  65: '"$"#,##0.00_);\\("$"#,##0.00\\)',
  66: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
  67: "0%",
  68: "0.00%",
  69: "# ?/?",
  70: "# ??/??",
  71: "m/d/yy",
  72: "m/d/yy",
  73: "d-mmm-yy",
  74: "d-mmm",
  75: "mmm-yy",
  76: "h:mm",
  77: "h:mm:ss",
  78: "m/d/yy h:mm",
  79: "mm:ss",
  80: "[h]:mm:ss",
  81: "mmss.0"
}, Up = /[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;
function W5(e) {
  var r = typeof e == "number" ? Ee[e] : e;
  return r = r.replace(Up, "(\\d+)"), new RegExp("^" + r + "$");
}
function H5(e, r, t) {
  var a = -1, n = -1, i = -1, s = -1, o = -1, u = -1;
  (r.match(Up) || []).forEach(function(f, h) {
    var d = parseInt(t[h + 1], 10);
    switch (f.toLowerCase().charAt(0)) {
      case "y":
        a = d;
        break;
      case "d":
        i = d;
        break;
      case "h":
        s = d;
        break;
      case "s":
        u = d;
        break;
      case "m":
        s >= 0 ? o = d : n = d;
        break;
    }
  }), u >= 0 && o == -1 && n >= 0 && (o = n, n = -1);
  var l = ("" + (a >= 0 ? a : (/* @__PURE__ */ new Date()).getFullYear())).slice(-4) + "-" + ("00" + (n >= 1 ? n : 1)).slice(-2) + "-" + ("00" + (i >= 1 ? i : 1)).slice(-2);
  l.length == 7 && (l = "0" + l), l.length == 8 && (l = "20" + l);
  var c = ("00" + (s >= 0 ? s : 0)).slice(-2) + ":" + ("00" + (o >= 0 ? o : 0)).slice(-2) + ":" + ("00" + (u >= 0 ? u : 0)).slice(-2);
  return s == -1 && o == -1 && u == -1 ? l : a == -1 && n == -1 && i == -1 ? c : l + "T" + c;
}
var j5 = /* @__PURE__ */ function() {
  var e = {};
  e.version = "1.2.0";
  function r() {
    for (var k = 0, v = new Array(256), b = 0; b != 256; ++b)
      k = b, k = k & 1 ? -306674912 ^ k >>> 1 : k >>> 1, k = k & 1 ? -306674912 ^ k >>> 1 : k >>> 1, k = k & 1 ? -306674912 ^ k >>> 1 : k >>> 1, k = k & 1 ? -306674912 ^ k >>> 1 : k >>> 1, k = k & 1 ? -306674912 ^ k >>> 1 : k >>> 1, k = k & 1 ? -306674912 ^ k >>> 1 : k >>> 1, k = k & 1 ? -306674912 ^ k >>> 1 : k >>> 1, k = k & 1 ? -306674912 ^ k >>> 1 : k >>> 1, v[b] = k;
    return typeof Int32Array < "u" ? new Int32Array(v) : v;
  }
  var t = r();
  function a(k) {
    var v = 0, b = 0, A = 0, T = typeof Int32Array < "u" ? new Int32Array(4096) : new Array(4096);
    for (A = 0; A != 256; ++A)
      T[A] = k[A];
    for (A = 0; A != 256; ++A)
      for (b = k[A], v = 256 + A; v < 4096; v += 256)
        b = T[v] = b >>> 8 ^ k[b & 255];
    var C = [];
    for (A = 1; A != 16; ++A)
      C[A - 1] = typeof Int32Array < "u" ? T.subarray(A * 256, A * 256 + 256) : T.slice(A * 256, A * 256 + 256);
    return C;
  }
  var n = a(t), i = n[0], s = n[1], o = n[2], u = n[3], l = n[4], c = n[5], f = n[6], h = n[7], d = n[8], m = n[9], x = n[10], p = n[11], w = n[12], D = n[13], y = n[14];
  function B(k, v) {
    for (var b = v ^ -1, A = 0, T = k.length; A < T; )
      b = b >>> 8 ^ t[(b ^ k.charCodeAt(A++)) & 255];
    return ~b;
  }
  function L(k, v) {
    for (var b = v ^ -1, A = k.length - 15, T = 0; T < A; )
      b = y[k[T++] ^ b & 255] ^ D[k[T++] ^ b >> 8 & 255] ^ w[k[T++] ^ b >> 16 & 255] ^ p[k[T++] ^ b >>> 24] ^ x[k[T++]] ^ m[k[T++]] ^ d[k[T++]] ^ h[k[T++]] ^ f[k[T++]] ^ c[k[T++]] ^ l[k[T++]] ^ u[k[T++]] ^ o[k[T++]] ^ s[k[T++]] ^ i[k[T++]] ^ t[k[T++]];
    for (A += 15; T < A; )
      b = b >>> 8 ^ t[(b ^ k[T++]) & 255];
    return ~b;
  }
  function U(k, v) {
    for (var b = v ^ -1, A = 0, T = k.length, C = 0, I = 0; A < T; )
      C = k.charCodeAt(A++), C < 128 ? b = b >>> 8 ^ t[(b ^ C) & 255] : C < 2048 ? (b = b >>> 8 ^ t[(b ^ (192 | C >> 6 & 31)) & 255], b = b >>> 8 ^ t[(b ^ (128 | C & 63)) & 255]) : C >= 55296 && C < 57344 ? (C = (C & 1023) + 64, I = k.charCodeAt(A++) & 1023, b = b >>> 8 ^ t[(b ^ (240 | C >> 8 & 7)) & 255], b = b >>> 8 ^ t[(b ^ (128 | C >> 2 & 63)) & 255], b = b >>> 8 ^ t[(b ^ (128 | I >> 6 & 15 | (C & 3) << 4)) & 255], b = b >>> 8 ^ t[(b ^ (128 | I & 63)) & 255]) : (b = b >>> 8 ^ t[(b ^ (224 | C >> 12 & 15)) & 255], b = b >>> 8 ^ t[(b ^ (128 | C >> 6 & 63)) & 255], b = b >>> 8 ^ t[(b ^ (128 | C & 63)) & 255]);
    return ~b;
  }
  return e.table = t, e.bstr = B, e.buf = L, e.str = U, e;
}(), we = /* @__PURE__ */ function() {
  var r = {};
  r.version = "1.2.1";
  function t(E, O) {
    for (var g = E.split("/"), _ = O.split("/"), S = 0, R = 0, K = Math.min(g.length, _.length); S < K; ++S) {
      if (R = g[S].length - _[S].length)
        return R;
      if (g[S] != _[S])
        return g[S] < _[S] ? -1 : 1;
    }
    return g.length - _.length;
  }
  function a(E) {
    if (E.charAt(E.length - 1) == "/")
      return E.slice(0, -1).indexOf("/") === -1 ? E : a(E.slice(0, -1));
    var O = E.lastIndexOf("/");
    return O === -1 ? E : E.slice(0, O + 1);
  }
  function n(E) {
    if (E.charAt(E.length - 1) == "/")
      return n(E.slice(0, -1));
    var O = E.lastIndexOf("/");
    return O === -1 ? E : E.slice(O + 1);
  }
  function i(E, O) {
    typeof O == "string" && (O = new Date(O));
    var g = O.getHours();
    g = g << 6 | O.getMinutes(), g = g << 5 | O.getSeconds() >>> 1, E.write_shift(2, g);
    var _ = O.getFullYear() - 1980;
    _ = _ << 4 | O.getMonth() + 1, _ = _ << 5 | O.getDate(), E.write_shift(2, _);
  }
  function s(E) {
    var O = E.read_shift(2) & 65535, g = E.read_shift(2) & 65535, _ = /* @__PURE__ */ new Date(), S = g & 31;
    g >>>= 5;
    var R = g & 15;
    g >>>= 4, _.setMilliseconds(0), _.setFullYear(g + 1980), _.setMonth(R - 1), _.setDate(S);
    var K = O & 31;
    O >>>= 5;
    var Q = O & 63;
    return O >>>= 6, _.setHours(O), _.setMinutes(Q), _.setSeconds(K << 1), _;
  }
  function o(E) {
    Vr(E, 0);
    for (var O = (
      /*::(*/
      {}
    ), g = 0; E.l <= E.length - 4; ) {
      var _ = E.read_shift(2), S = E.read_shift(2), R = E.l + S, K = {};
      switch (_) {
        case 21589:
          g = E.read_shift(1), g & 1 && (K.mtime = E.read_shift(4)), S > 5 && (g & 2 && (K.atime = E.read_shift(4)), g & 4 && (K.ctime = E.read_shift(4))), K.mtime && (K.mt = new Date(K.mtime * 1e3));
          break;
      }
      E.l = R, O[_] = K;
    }
    return O;
  }
  var u;
  function l() {
    return u || (u = {});
  }
  function c(E, O) {
    if (E[0] == 80 && E[1] == 75)
      return vi(E, O);
    if ((E[0] | 32) == 109 && (E[1] | 32) == 105)
      return Os(E, O);
    if (E.length < 512)
      throw new Error("CFB file size " + E.length + " < 512");
    var g = 3, _ = 512, S = 0, R = 0, K = 0, Q = 0, z = 0, G = [], Z = (
      /*::(*/
      E.slice(0, 512)
    );
    Vr(Z, 0);
    var ne = f(Z);
    switch (g = ne[0], g) {
      case 3:
        _ = 512;
        break;
      case 4:
        _ = 4096;
        break;
      case 0:
        if (ne[1] == 0)
          return vi(E, O);
      default:
        throw new Error("Major Version: Expected 3 or 4 saw " + g);
    }
    _ !== 512 && (Z = /*::(*/
    E.slice(0, _), Vr(
      Z,
      28
      /* blob.l */
    ));
    var oe = E.slice(0, _);
    h(Z, g);
    var me = Z.read_shift(4, "i");
    if (g === 3 && me !== 0)
      throw new Error("# Directory Sectors: Expected 0 saw " + me);
    Z.l += 4, K = Z.read_shift(4, "i"), Z.l += 4, Z.chk("00100000", "Mini Stream Cutoff Size: "), Q = Z.read_shift(4, "i"), S = Z.read_shift(4, "i"), z = Z.read_shift(4, "i"), R = Z.read_shift(4, "i");
    for (var ue = -1, pe = 0; pe < 109 && (ue = Z.read_shift(4, "i"), !(ue < 0)); ++pe)
      G[pe] = ue;
    var be = d(E, _);
    p(z, R, be, _, G);
    var rr = D(be, K, G, _);
    rr[K].name = "!Directory", S > 0 && Q !== I && (rr[Q].name = "!MiniFAT"), rr[G[0]].name = "!FAT", rr.fat_addrs = G, rr.ssz = _;
    var ir = {}, Ir = [], yi = [], bi = [];
    y(K, rr, be, Ir, S, ir, yi, Q), m(yi, bi, Ir), Ir.shift();
    var wi = {
      FileIndex: yi,
      FullPaths: bi
    };
    return O && O.raw && (wi.raw = { header: oe, sectors: be }), wi;
  }
  function f(E) {
    if (E[E.l] == 80 && E[E.l + 1] == 75)
      return [0, 0];
    E.chk(Y, "Header Signature: "), E.l += 16;
    var O = E.read_shift(2, "u");
    return [E.read_shift(2, "u"), O];
  }
  function h(E, O) {
    var g = 9;
    switch (E.l += 2, g = E.read_shift(2)) {
      case 9:
        if (O != 3)
          throw new Error("Sector Shift: Expected 9 saw " + g);
        break;
      case 12:
        if (O != 4)
          throw new Error("Sector Shift: Expected 12 saw " + g);
        break;
      default:
        throw new Error("Sector Shift: Expected 9 or 12 saw " + g);
    }
    E.chk("0600", "Mini Sector Shift: "), E.chk("000000000000", "Reserved: ");
  }
  function d(E, O) {
    for (var g = Math.ceil(E.length / O) - 1, _ = [], S = 1; S < g; ++S)
      _[S - 1] = E.slice(S * O, (S + 1) * O);
    return _[g - 1] = E.slice(g * O), _;
  }
  function m(E, O, g) {
    for (var _ = 0, S = 0, R = 0, K = 0, Q = 0, z = g.length, G = [], Z = []; _ < z; ++_)
      G[_] = Z[_] = _, O[_] = g[_];
    for (; Q < Z.length; ++Q)
      _ = Z[Q], S = E[_].L, R = E[_].R, K = E[_].C, G[_] === _ && (S !== -1 && G[S] !== S && (G[_] = G[S]), R !== -1 && G[R] !== R && (G[_] = G[R])), K !== -1 && (G[K] = _), S !== -1 && _ != G[_] && (G[S] = G[_], Z.lastIndexOf(S) < Q && Z.push(S)), R !== -1 && _ != G[_] && (G[R] = G[_], Z.lastIndexOf(R) < Q && Z.push(R));
    for (_ = 1; _ < z; ++_)
      G[_] === _ && (R !== -1 && G[R] !== R ? G[_] = G[R] : S !== -1 && G[S] !== S && (G[_] = G[S]));
    for (_ = 1; _ < z; ++_)
      if (E[_].type !== 0) {
        if (Q = _, Q != G[Q])
          do
            Q = G[Q], O[_] = O[Q] + "/" + O[_];
          while (Q !== 0 && G[Q] !== -1 && Q != G[Q]);
        G[_] = -1;
      }
    for (O[0] += "/", _ = 1; _ < z; ++_)
      E[_].type !== 2 && (O[_] += "/");
  }
  function x(E, O, g) {
    for (var _ = E.start, S = E.size, R = [], K = _; g && S > 0 && K >= 0; )
      R.push(O.slice(K * C, K * C + C)), S -= C, K = Xa(g, K * 4);
    return R.length === 0 ? te(0) : Or(R).slice(0, E.size);
  }
  function p(E, O, g, _, S) {
    var R = I;
    if (E === I) {
      if (O !== 0)
        throw new Error("DIFAT chain shorter than expected");
    } else if (E !== -1) {
      var K = g[E], Q = (_ >>> 2) - 1;
      if (!K)
        return;
      for (var z = 0; z < Q && (R = Xa(K, z * 4)) !== I; ++z)
        S.push(R);
      p(Xa(K, _ - 4), O - 1, g, _, S);
    }
  }
  function w(E, O, g, _, S) {
    var R = [], K = [];
    S || (S = []);
    var Q = _ - 1, z = 0, G = 0;
    for (z = O; z >= 0; ) {
      S[z] = !0, R[R.length] = z, K.push(E[z]);
      var Z = g[Math.floor(z * 4 / _)];
      if (G = z * 4 & Q, _ < 4 + G)
        throw new Error("FAT boundary crossed: " + z + " 4 " + _);
      if (!E[Z])
        break;
      z = Xa(E[Z], G);
    }
    return { nodes: R, data: Wd([K]) };
  }
  function D(E, O, g, _) {
    var S = E.length, R = [], K = [], Q = [], z = [], G = _ - 1, Z = 0, ne = 0, oe = 0, me = 0;
    for (Z = 0; Z < S; ++Z)
      if (Q = [], oe = Z + O, oe >= S && (oe -= S), !K[oe]) {
        z = [];
        var ue = [];
        for (ne = oe; ne >= 0; ) {
          ue[ne] = !0, K[ne] = !0, Q[Q.length] = ne, z.push(E[ne]);
          var pe = g[Math.floor(ne * 4 / _)];
          if (me = ne * 4 & G, _ < 4 + me)
            throw new Error("FAT boundary crossed: " + ne + " 4 " + _);
          if (!E[pe] || (ne = Xa(E[pe], me), ue[ne]))
            break;
        }
        R[oe] = { nodes: Q, data: Wd([z]) };
      }
    return R;
  }
  function y(E, O, g, _, S, R, K, Q) {
    for (var z = 0, G = _.length ? 2 : 0, Z = O[E].data, ne = 0, oe = 0, me; ne < Z.length; ne += 128) {
      var ue = (
        /*::(*/
        Z.slice(ne, ne + 128)
      );
      Vr(ue, 64), oe = ue.read_shift(2), me = g0(ue, 0, oe - G), _.push(me);
      var pe = {
        name: me,
        type: ue.read_shift(1),
        color: ue.read_shift(1),
        L: ue.read_shift(4, "i"),
        R: ue.read_shift(4, "i"),
        C: ue.read_shift(4, "i"),
        clsid: ue.read_shift(16),
        state: ue.read_shift(4, "i"),
        start: 0,
        size: 0
      }, be = ue.read_shift(2) + ue.read_shift(2) + ue.read_shift(2) + ue.read_shift(2);
      be !== 0 && (pe.ct = B(ue, ue.l - 8));
      var rr = ue.read_shift(2) + ue.read_shift(2) + ue.read_shift(2) + ue.read_shift(2);
      rr !== 0 && (pe.mt = B(ue, ue.l - 8)), pe.start = ue.read_shift(4, "i"), pe.size = ue.read_shift(4, "i"), pe.size < 0 && pe.start < 0 && (pe.size = pe.type = 0, pe.start = I, pe.name = ""), pe.type === 5 ? (z = pe.start, S > 0 && z !== I && (O[z].name = "!StreamData")) : pe.size >= 4096 ? (pe.storage = "fat", O[pe.start] === void 0 && (O[pe.start] = w(g, pe.start, O.fat_addrs, O.ssz)), O[pe.start].name = pe.name, pe.content = O[pe.start].data.slice(0, pe.size)) : (pe.storage = "minifat", pe.size < 0 ? pe.size = 0 : z !== I && pe.start !== I && O[z] && (pe.content = x(pe, O[z].data, (O[Q] || {}).data))), pe.content && Vr(pe.content, 0), R[me] = pe, K.push(pe);
    }
  }
  function B(E, O) {
    return new Date((Mr(E, O + 4) / 1e7 * Math.pow(2, 32) + Mr(E, O) / 1e7 - 11644473600) * 1e3);
  }
  function L(E, O) {
    return l(), c(u.readFileSync(E), O);
  }
  function U(E, O) {
    var g = O && O.type;
    switch (g || Ie && Buffer.isBuffer(E) && (g = "buffer"), g || "base64") {
      case "file":
        return L(E, O);
      case "base64":
        return c(dt(mt(E)), O);
      case "binary":
        return c(dt(E), O);
    }
    return c(
      /*::typeof blob == 'string' ? new Buffer(blob, 'utf-8') : */
      E,
      O
    );
  }
  function k(E, O) {
    var g = O || {}, _ = g.root || "Root Entry";
    if (E.FullPaths || (E.FullPaths = []), E.FileIndex || (E.FileIndex = []), E.FullPaths.length !== E.FileIndex.length)
      throw new Error("inconsistent CFB structure");
    E.FullPaths.length === 0 && (E.FullPaths[0] = _ + "/", E.FileIndex[0] = { name: _, type: 5 }), g.CLSID && (E.FileIndex[0].clsid = g.CLSID), v(E);
  }
  function v(E) {
    var O = "Sh33tJ5";
    if (!we.find(E, "/" + O)) {
      var g = te(4);
      g[0] = 55, g[1] = g[3] = 50, g[2] = 54, E.FileIndex.push({ name: O, type: 2, content: g, size: 4, L: 69, R: 69, C: 69 }), E.FullPaths.push(E.FullPaths[0] + O), b(E);
    }
  }
  function b(E, O) {
    k(E);
    for (var g = !1, _ = !1, S = E.FullPaths.length - 1; S >= 0; --S) {
      var R = E.FileIndex[S];
      switch (R.type) {
        case 0:
          _ ? g = !0 : (E.FileIndex.pop(), E.FullPaths.pop());
          break;
        case 1:
        case 2:
        case 5:
          _ = !0, isNaN(R.R * R.L * R.C) && (g = !0), R.R > -1 && R.L > -1 && R.R == R.L && (g = !0);
          break;
        default:
          g = !0;
          break;
      }
    }
    if (!(!g && !O)) {
      var K = new Date(1987, 1, 19), Q = 0, z = Object.create ? /* @__PURE__ */ Object.create(null) : {}, G = [];
      for (S = 0; S < E.FullPaths.length; ++S)
        z[E.FullPaths[S]] = !0, E.FileIndex[S].type !== 0 && G.push([E.FullPaths[S], E.FileIndex[S]]);
      for (S = 0; S < G.length; ++S) {
        var Z = a(G[S][0]);
        _ = z[Z], _ || (G.push([Z, {
          name: n(Z).replace("/", ""),
          type: 1,
          clsid: J,
          ct: K,
          mt: K,
          content: null
        }]), z[Z] = !0);
      }
      for (G.sort(function(me, ue) {
        return t(me[0], ue[0]);
      }), E.FullPaths = [], E.FileIndex = [], S = 0; S < G.length; ++S)
        E.FullPaths[S] = G[S][0], E.FileIndex[S] = G[S][1];
      for (S = 0; S < G.length; ++S) {
        var ne = E.FileIndex[S], oe = E.FullPaths[S];
        if (ne.name = n(oe).replace("/", ""), ne.L = ne.R = ne.C = -(ne.color = 1), ne.size = ne.content ? ne.content.length : 0, ne.start = 0, ne.clsid = ne.clsid || J, S === 0)
          ne.C = G.length > 1 ? 1 : -1, ne.size = 0, ne.type = 5;
        else if (oe.slice(-1) == "/") {
          for (Q = S + 1; Q < G.length && a(E.FullPaths[Q]) != oe; ++Q)
            ;
          for (ne.C = Q >= G.length ? -1 : Q, Q = S + 1; Q < G.length && a(E.FullPaths[Q]) != a(oe); ++Q)
            ;
          ne.R = Q >= G.length ? -1 : Q, ne.type = 1;
        } else
          a(E.FullPaths[S + 1] || "") == a(oe) && (ne.R = S + 1), ne.type = 2;
      }
    }
  }
  function A(E, O) {
    var g = O || {};
    if (g.fileType == "mad")
      return S0(E, g);
    switch (b(E), g.fileType) {
      case "zip":
        return gi(E, g);
    }
    var _ = function(me) {
      for (var ue = 0, pe = 0, be = 0; be < me.FileIndex.length; ++be) {
        var rr = me.FileIndex[be];
        if (rr.content) {
          var ir = rr.content.length;
          ir > 0 && (ir < 4096 ? ue += ir + 63 >> 6 : pe += ir + 511 >> 9);
        }
      }
      for (var Ir = me.FullPaths.length + 3 >> 2, yi = ue + 7 >> 3, bi = ue + 127 >> 7, wi = yi + pe + Ir + bi, Ga = wi + 127 >> 7, R0 = Ga <= 109 ? 0 : Math.ceil((Ga - 109) / 127); wi + Ga + R0 + 127 >> 7 > Ga; )
        R0 = ++Ga <= 109 ? 0 : Math.ceil((Ga - 109) / 127);
      var Jt = [1, R0, Ga, bi, Ir, pe, ue, 0];
      return me.FileIndex[0].size = ue << 6, Jt[7] = (me.FileIndex[0].start = Jt[0] + Jt[1] + Jt[2] + Jt[3] + Jt[4] + Jt[5]) + (Jt[6] + 7 >> 3), Jt;
    }(E), S = te(_[7] << 9), R = 0, K = 0;
    {
      for (R = 0; R < 8; ++R)
        S.write_shift(1, j[R]);
      for (R = 0; R < 8; ++R)
        S.write_shift(2, 0);
      for (S.write_shift(2, 62), S.write_shift(2, 3), S.write_shift(2, 65534), S.write_shift(2, 9), S.write_shift(2, 6), R = 0; R < 3; ++R)
        S.write_shift(2, 0);
      for (S.write_shift(4, 0), S.write_shift(4, _[2]), S.write_shift(4, _[0] + _[1] + _[2] + _[3] - 1), S.write_shift(4, 0), S.write_shift(4, 4096), S.write_shift(4, _[3] ? _[0] + _[1] + _[2] - 1 : I), S.write_shift(4, _[3]), S.write_shift(-4, _[1] ? _[0] - 1 : I), S.write_shift(4, _[1]), R = 0; R < 109; ++R)
        S.write_shift(-4, R < _[2] ? _[1] + R : -1);
    }
    if (_[1])
      for (K = 0; K < _[1]; ++K) {
        for (; R < 236 + K * 127; ++R)
          S.write_shift(-4, R < _[2] ? _[1] + R : -1);
        S.write_shift(-4, K === _[1] - 1 ? I : K + 1);
      }
    var Q = function(me) {
      for (K += me; R < K - 1; ++R)
        S.write_shift(-4, R + 1);
      me && (++R, S.write_shift(-4, I));
    };
    for (K = R = 0, K += _[1]; R < K; ++R)
      S.write_shift(-4, W.DIFSECT);
    for (K += _[2]; R < K; ++R)
      S.write_shift(-4, W.FATSECT);
    Q(_[3]), Q(_[4]);
    for (var z = 0, G = 0, Z = E.FileIndex[0]; z < E.FileIndex.length; ++z)
      Z = E.FileIndex[z], Z.content && (G = Z.content.length, !(G < 4096) && (Z.start = K, Q(G + 511 >> 9)));
    for (Q(_[6] + 7 >> 3); S.l & 511; )
      S.write_shift(-4, W.ENDOFCHAIN);
    for (K = R = 0, z = 0; z < E.FileIndex.length; ++z)
      Z = E.FileIndex[z], Z.content && (G = Z.content.length, !(!G || G >= 4096) && (Z.start = K, Q(G + 63 >> 6)));
    for (; S.l & 511; )
      S.write_shift(-4, W.ENDOFCHAIN);
    for (R = 0; R < _[4] << 2; ++R) {
      var ne = E.FullPaths[R];
      if (!ne || ne.length === 0) {
        for (z = 0; z < 17; ++z)
          S.write_shift(4, 0);
        for (z = 0; z < 3; ++z)
          S.write_shift(4, -1);
        for (z = 0; z < 12; ++z)
          S.write_shift(4, 0);
        continue;
      }
      Z = E.FileIndex[R], R === 0 && (Z.start = Z.size ? Z.start - 1 : I);
      var oe = R === 0 && g.root || Z.name;
      if (G = 2 * (oe.length + 1), S.write_shift(64, oe, "utf16le"), S.write_shift(2, G), S.write_shift(1, Z.type), S.write_shift(1, Z.color), S.write_shift(-4, Z.L), S.write_shift(-4, Z.R), S.write_shift(-4, Z.C), Z.clsid)
        S.write_shift(16, Z.clsid, "hex");
      else
        for (z = 0; z < 4; ++z)
          S.write_shift(4, 0);
      S.write_shift(4, Z.state || 0), S.write_shift(4, 0), S.write_shift(4, 0), S.write_shift(4, 0), S.write_shift(4, 0), S.write_shift(4, Z.start), S.write_shift(4, Z.size), S.write_shift(4, 0);
    }
    for (R = 1; R < E.FileIndex.length; ++R)
      if (Z = E.FileIndex[R], Z.size >= 4096)
        if (S.l = Z.start + 1 << 9, Ie && Buffer.isBuffer(Z.content))
          Z.content.copy(S, S.l, 0, Z.size), S.l += Z.size + 511 & -512;
        else {
          for (z = 0; z < Z.size; ++z)
            S.write_shift(1, Z.content[z]);
          for (; z & 511; ++z)
            S.write_shift(1, 0);
        }
    for (R = 1; R < E.FileIndex.length; ++R)
      if (Z = E.FileIndex[R], Z.size > 0 && Z.size < 4096)
        if (Ie && Buffer.isBuffer(Z.content))
          Z.content.copy(S, S.l, 0, Z.size), S.l += Z.size + 63 & -64;
        else {
          for (z = 0; z < Z.size; ++z)
            S.write_shift(1, Z.content[z]);
          for (; z & 63; ++z)
            S.write_shift(1, 0);
        }
    if (Ie)
      S.l = S.length;
    else
      for (; S.l < S.length; )
        S.write_shift(1, 0);
    return S;
  }
  function T(E, O) {
    var g = E.FullPaths.map(function(z) {
      return z.toUpperCase();
    }), _ = g.map(function(z) {
      var G = z.split("/");
      return G[G.length - (z.slice(-1) == "/" ? 2 : 1)];
    }), S = !1;
    O.charCodeAt(0) === 47 ? (S = !0, O = g[0].slice(0, -1) + O) : S = O.indexOf("/") !== -1;
    var R = O.toUpperCase(), K = S === !0 ? g.indexOf(R) : _.indexOf(R);
    if (K !== -1)
      return E.FileIndex[K];
    var Q = !R.match(Pi);
    for (R = R.replace(Zr, ""), Q && (R = R.replace(Pi, "!")), K = 0; K < g.length; ++K)
      if ((Q ? g[K].replace(Pi, "!") : g[K]).replace(Zr, "") == R || (Q ? _[K].replace(Pi, "!") : _[K]).replace(Zr, "") == R)
        return E.FileIndex[K];
    return null;
  }
  var C = 64, I = -2, Y = "d0cf11e0a1b11ae1", j = [208, 207, 17, 224, 161, 177, 26, 225], J = "00000000000000000000000000000000", W = {
    /* 2.1 Compund File Sector Numbers and Types */
    MAXREGSECT: -6,
    DIFSECT: -4,
    FATSECT: -3,
    ENDOFCHAIN: I,
    FREESECT: -1,
    /* 2.2 Compound File Header */
    HEADER_SIGNATURE: Y,
    HEADER_MINOR_VERSION: "3e00",
    MAXREGSID: -6,
    NOSTREAM: -1,
    HEADER_CLSID: J,
    /* 2.6.1 Compound File Directory Entry */
    EntryTypes: ["unknown", "storage", "stream", "lockbytes", "property", "root"]
  };
  function ce(E, O, g) {
    l();
    var _ = A(E, g);
    u.writeFileSync(O, _);
  }
  function V(E) {
    for (var O = new Array(E.length), g = 0; g < E.length; ++g)
      O[g] = String.fromCharCode(E[g]);
    return O.join("");
  }
  function ee(E, O) {
    var g = A(E, O);
    switch (O && O.type || "buffer") {
      case "file":
        return l(), u.writeFileSync(O.filename, g), g;
      case "binary":
        return typeof g == "string" ? g : V(g);
      case "base64":
        return rs(typeof g == "string" ? g : V(g));
      case "buffer":
        if (Ie)
          return Buffer.isBuffer(g) ? g : xa(g);
      case "array":
        return typeof g == "string" ? dt(g) : g;
    }
    return g;
  }
  var de;
  function F(E) {
    try {
      var O = E.InflateRaw, g = new O();
      if (g._processChunk(new Uint8Array([3, 0]), g._finishFlushFlag), g.bytesRead)
        de = E;
      else
        throw new Error("zlib does not expose bytesRead");
    } catch (_) {
      console.error("cannot use native zlib: " + (_.message || _));
    }
  }
  function H(E, O) {
    if (!de)
      return Is(E, O);
    var g = de.InflateRaw, _ = new g(), S = _._processChunk(E.slice(E.l), _._finishFlushFlag);
    return E.l += _.bytesRead, S;
  }
  function P(E) {
    return de ? de.deflateRawSync(E) : ke(E);
  }
  var N = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], X = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258], ae = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577];
  function ie(E) {
    var O = (E << 1 | E << 11) & 139536 | (E << 5 | E << 15) & 558144;
    return (O >> 16 | O >> 8 | O) & 255;
  }
  for (var q = typeof Uint8Array < "u", re = q ? new Uint8Array(256) : [], ve = 0; ve < 256; ++ve)
    re[ve] = ie(ve);
  function M(E, O) {
    var g = re[E & 255];
    return O <= 8 ? g >>> 8 - O : (g = g << 8 | re[E >> 8 & 255], O <= 16 ? g >>> 16 - O : (g = g << 8 | re[E >> 16 & 255], g >>> 24 - O));
  }
  function _e(E, O) {
    var g = O & 7, _ = O >>> 3;
    return (E[_] | (g <= 6 ? 0 : E[_ + 1] << 8)) >>> g & 3;
  }
  function De(E, O) {
    var g = O & 7, _ = O >>> 3;
    return (E[_] | (g <= 5 ? 0 : E[_ + 1] << 8)) >>> g & 7;
  }
  function $e(E, O) {
    var g = O & 7, _ = O >>> 3;
    return (E[_] | (g <= 4 ? 0 : E[_ + 1] << 8)) >>> g & 15;
  }
  function ge(E, O) {
    var g = O & 7, _ = O >>> 3;
    return (E[_] | (g <= 3 ? 0 : E[_ + 1] << 8)) >>> g & 31;
  }
  function fe(E, O) {
    var g = O & 7, _ = O >>> 3;
    return (E[_] | (g <= 1 ? 0 : E[_ + 1] << 8)) >>> g & 127;
  }
  function Me(E, O, g) {
    var _ = O & 7, S = O >>> 3, R = (1 << g) - 1, K = E[S] >>> _;
    return g < 8 - _ || (K |= E[S + 1] << 8 - _, g < 16 - _) || (K |= E[S + 2] << 16 - _, g < 24 - _) || (K |= E[S + 3] << 24 - _), K & R;
  }
  function Je(E, O, g) {
    var _ = O & 7, S = O >>> 3;
    return _ <= 5 ? E[S] |= (g & 7) << _ : (E[S] |= g << _ & 255, E[S + 1] = (g & 7) >> 8 - _), O + 3;
  }
  function dr(E, O, g) {
    var _ = O & 7, S = O >>> 3;
    return g = (g & 1) << _, E[S] |= g, O + 1;
  }
  function lr(E, O, g) {
    var _ = O & 7, S = O >>> 3;
    return g <<= _, E[S] |= g & 255, g >>>= 8, E[S + 1] = g, O + 8;
  }
  function Ve(E, O, g) {
    var _ = O & 7, S = O >>> 3;
    return g <<= _, E[S] |= g & 255, g >>>= 8, E[S + 1] = g & 255, E[S + 2] = g >>> 8, O + 16;
  }
  function Ge(E, O) {
    var g = E.length, _ = 2 * g > O ? 2 * g : O + 5, S = 0;
    if (g >= O)
      return E;
    if (Ie) {
      var R = $d(_);
      if (E.copy)
        E.copy(R);
      else
        for (; S < E.length; ++S)
          R[S] = E[S];
      return R;
    } else if (q) {
      var K = new Uint8Array(_);
      if (K.set)
        K.set(E);
      else
        for (; S < g; ++S)
          K[S] = E[S];
      return K;
    }
    return E.length = _, E;
  }
  function cr(E) {
    for (var O = new Array(E), g = 0; g < E; ++g)
      O[g] = 0;
    return O;
  }
  function Ae(E, O, g) {
    var _ = 1, S = 0, R = 0, K = 0, Q = 0, z = E.length, G = q ? new Uint16Array(32) : cr(32);
    for (R = 0; R < 32; ++R)
      G[R] = 0;
    for (R = z; R < g; ++R)
      E[R] = 0;
    z = E.length;
    var Z = q ? new Uint16Array(z) : cr(z);
    for (R = 0; R < z; ++R)
      G[S = E[R]]++, _ < S && (_ = S), Z[R] = 0;
    for (G[0] = 0, R = 1; R <= _; ++R)
      G[R + 16] = Q = Q + G[R - 1] << 1;
    for (R = 0; R < z; ++R)
      Q = E[R], Q != 0 && (Z[R] = G[Q + 16]++);
    var ne = 0;
    for (R = 0; R < z; ++R)
      if (ne = E[R], ne != 0)
        for (Q = M(Z[R], _) >> _ - ne, K = (1 << _ + 4 - ne) - 1; K >= 0; --K)
          O[Q | K << ne] = ne & 15 | R << 4;
    return _;
  }
  var Rr = q ? new Uint16Array(512) : cr(512), wr = q ? new Uint16Array(32) : cr(32);
  if (!q) {
    for (var nr = 0; nr < 512; ++nr)
      Rr[nr] = 0;
    for (nr = 0; nr < 32; ++nr)
      wr[nr] = 0;
  }
  (function() {
    for (var E = [], O = 0; O < 32; O++)
      E.push(5);
    Ae(E, wr, 32);
    var g = [];
    for (O = 0; O <= 143; O++)
      g.push(8);
    for (; O <= 255; O++)
      g.push(9);
    for (; O <= 279; O++)
      g.push(7);
    for (; O <= 287; O++)
      g.push(8);
    Ae(g, Rr, 288);
  })();
  var hr = /* @__PURE__ */ function() {
    for (var O = q ? new Uint8Array(32768) : [], g = 0, _ = 0; g < ae.length - 1; ++g)
      for (; _ < ae[g + 1]; ++_)
        O[_] = g;
    for (; _ < 32768; ++_)
      O[_] = 29;
    var S = q ? new Uint8Array(259) : [];
    for (g = 0, _ = 0; g < X.length - 1; ++g)
      for (; _ < X[g + 1]; ++_)
        S[_] = g;
    function R(Q, z) {
      for (var G = 0; G < Q.length; ) {
        var Z = Math.min(65535, Q.length - G), ne = G + Z == Q.length;
        for (z.write_shift(1, +ne), z.write_shift(2, Z), z.write_shift(2, ~Z & 65535); Z-- > 0; )
          z[z.l++] = Q[G++];
      }
      return z.l;
    }
    function K(Q, z) {
      for (var G = 0, Z = 0, ne = q ? new Uint16Array(32768) : []; Z < Q.length; ) {
        var oe = (
          /* data.length - boff; */
          Math.min(65535, Q.length - Z)
        );
        if (oe < 10) {
          for (G = Je(z, G, +(Z + oe == Q.length)), G & 7 && (G += 8 - (G & 7)), z.l = G / 8 | 0, z.write_shift(2, oe), z.write_shift(2, ~oe & 65535); oe-- > 0; )
            z[z.l++] = Q[Z++];
          G = z.l * 8;
          continue;
        }
        G = Je(z, G, +(Z + oe == Q.length) + 2);
        for (var me = 0; oe-- > 0; ) {
          var ue = Q[Z];
          me = (me << 5 ^ ue) & 32767;
          var pe = -1, be = 0;
          if ((pe = ne[me]) && (pe |= Z & -32768, pe > Z && (pe -= 32768), pe < Z))
            for (; Q[pe + be] == Q[Z + be] && be < 250; )
              ++be;
          if (be > 2) {
            ue = S[be], ue <= 22 ? G = lr(z, G, re[ue + 1] >> 1) - 1 : (lr(z, G, 3), G += 5, lr(z, G, re[ue - 23] >> 5), G += 3);
            var rr = ue < 8 ? 0 : ue - 4 >> 2;
            rr > 0 && (Ve(z, G, be - X[ue]), G += rr), ue = O[Z - pe], G = lr(z, G, re[ue] >> 3), G -= 3;
            var ir = ue < 4 ? 0 : ue - 2 >> 1;
            ir > 0 && (Ve(z, G, Z - pe - ae[ue]), G += ir);
            for (var Ir = 0; Ir < be; ++Ir)
              ne[me] = Z & 32767, me = (me << 5 ^ Q[Z]) & 32767, ++Z;
            oe -= be - 1;
          } else
            ue <= 143 ? ue = ue + 48 : G = dr(z, G, 1), G = lr(z, G, re[ue]), ne[me] = Z & 32767, ++Z;
        }
        G = lr(z, G, 0) - 1;
      }
      return z.l = (G + 7) / 8 | 0, z.l;
    }
    return function(z, G) {
      return z.length < 8 ? R(z, G) : K(z, G);
    };
  }();
  function ke(E) {
    var O = te(50 + Math.floor(E.length * 1.1)), g = hr(E, O);
    return O.slice(0, g);
  }
  var Le = q ? new Uint16Array(32768) : cr(32768), er = q ? new Uint16Array(32768) : cr(32768), ar = q ? new Uint16Array(128) : cr(128), xr = 1, ja = 1;
  function za(E, O) {
    var g = ge(E, O) + 257;
    O += 5;
    var _ = ge(E, O) + 1;
    O += 5;
    var S = $e(E, O) + 4;
    O += 4;
    for (var R = 0, K = q ? new Uint8Array(19) : cr(19), Q = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], z = 1, G = q ? new Uint8Array(8) : cr(8), Z = q ? new Uint8Array(8) : cr(8), ne = K.length, oe = 0; oe < S; ++oe)
      K[N[oe]] = R = De(E, O), z < R && (z = R), G[R]++, O += 3;
    var me = 0;
    for (G[0] = 0, oe = 1; oe <= z; ++oe)
      Z[oe] = me = me + G[oe - 1] << 1;
    for (oe = 0; oe < ne; ++oe)
      (me = K[oe]) != 0 && (Q[oe] = Z[me]++);
    var ue = 0;
    for (oe = 0; oe < ne; ++oe)
      if (ue = K[oe], ue != 0) {
        me = re[Q[oe]] >> 8 - ue;
        for (var pe = (1 << 7 - ue) - 1; pe >= 0; --pe)
          ar[me | pe << ue] = ue & 7 | oe << 3;
      }
    var be = [];
    for (z = 1; be.length < g + _; )
      switch (me = ar[fe(E, O)], O += me & 7, me >>>= 3) {
        case 16:
          for (R = 3 + _e(E, O), O += 2, me = be[be.length - 1]; R-- > 0; )
            be.push(me);
          break;
        case 17:
          for (R = 3 + De(E, O), O += 3; R-- > 0; )
            be.push(0);
          break;
        case 18:
          for (R = 11 + fe(E, O), O += 7; R-- > 0; )
            be.push(0);
          break;
        default:
          be.push(me), z < me && (z = me);
          break;
      }
    var rr = be.slice(0, g), ir = be.slice(g);
    for (oe = g; oe < 286; ++oe)
      rr[oe] = 0;
    for (oe = _; oe < 30; ++oe)
      ir[oe] = 0;
    return xr = Ae(rr, Le, 286), ja = Ae(ir, er, 30), O;
  }
  function E0(E, O) {
    if (E[0] == 3 && !(E[1] & 3))
      return [Pa(O), 2];
    for (var g = 0, _ = 0, S = $d(O || 1 << 18), R = 0, K = S.length >>> 0, Q = 0, z = 0; !(_ & 1); ) {
      if (_ = De(E, g), g += 3, _ >>> 1)
        _ >> 1 == 1 ? (Q = 9, z = 5) : (g = za(E, g), Q = xr, z = ja);
      else {
        g & 7 && (g += 8 - (g & 7));
        var G = E[g >>> 3] | E[(g >>> 3) + 1] << 8;
        if (g += 32, G > 0)
          for (!O && K < R + G && (S = Ge(S, R + G), K = S.length); G-- > 0; )
            S[R++] = E[g >>> 3], g += 8;
        continue;
      }
      for (; ; ) {
        !O && K < R + 32767 && (S = Ge(S, R + 32767), K = S.length);
        var Z = Me(E, g, Q), ne = _ >>> 1 == 1 ? Rr[Z] : Le[Z];
        if (g += ne & 15, ne >>>= 4, !(ne >>> 8 & 255))
          S[R++] = ne;
        else {
          if (ne == 256)
            break;
          ne -= 257;
          var oe = ne < 8 ? 0 : ne - 4 >> 2;
          oe > 5 && (oe = 0);
          var me = R + X[ne];
          oe > 0 && (me += Me(E, g, oe), g += oe), Z = Me(E, g, z), ne = _ >>> 1 == 1 ? wr[Z] : er[Z], g += ne & 15, ne >>>= 4;
          var ue = ne < 4 ? 0 : ne - 2 >> 1, pe = ae[ne];
          for (ue > 0 && (pe += Me(E, g, ue), g += ue), !O && K < me && (S = Ge(S, me + 100), K = S.length); R < me; )
            S[R] = S[R - pe], ++R;
        }
      }
    }
    return O ? [S, g + 7 >>> 3] : [S.slice(0, R), g + 7 >>> 3];
  }
  function Is(E, O) {
    var g = E.slice(E.l || 0), _ = E0(g, O);
    return E.l += _[1], _[0];
  }
  function $n(E, O) {
    if (E)
      typeof console < "u" && console.error(O);
    else
      throw new Error(O);
  }
  function vi(E, O) {
    var g = (
      /*::(*/
      E
    );
    Vr(g, 0);
    var _ = [], S = [], R = {
      FileIndex: _,
      FullPaths: S
    };
    k(R, { root: O.root });
    for (var K = g.length - 4; (g[K] != 80 || g[K + 1] != 75 || g[K + 2] != 5 || g[K + 3] != 6) && K >= 0; )
      --K;
    g.l = K + 4, g.l += 4;
    var Q = g.read_shift(2);
    g.l += 6;
    var z = g.read_shift(4);
    for (g.l = z, K = 0; K < Q; ++K) {
      g.l += 20;
      var G = g.read_shift(4), Z = g.read_shift(4), ne = g.read_shift(2), oe = g.read_shift(2), me = g.read_shift(2);
      g.l += 8;
      var ue = g.read_shift(4), pe = o(
        /*::(*/
        g.slice(g.l + ne, g.l + ne + oe)
        /*:: :any)*/
      );
      g.l += ne + oe + me;
      var be = g.l;
      g.l = ue + 4, va(g, G, Z, R, pe), g.l = be;
    }
    return R;
  }
  function va(E, O, g, _, S) {
    E.l += 2;
    var R = E.read_shift(2), K = E.read_shift(2), Q = s(E);
    if (R & 8257)
      throw new Error("Unsupported ZIP encryption");
    for (var z = E.read_shift(4), G = E.read_shift(4), Z = E.read_shift(4), ne = E.read_shift(2), oe = E.read_shift(2), me = "", ue = 0; ue < ne; ++ue)
      me += String.fromCharCode(E[E.l++]);
    if (oe) {
      var pe = o(
        /*::(*/
        E.slice(E.l, E.l + oe)
        /*:: :any)*/
      );
      (pe[21589] || {}).mt && (Q = pe[21589].mt), ((S || {})[21589] || {}).mt && (Q = S[21589].mt);
    }
    E.l += oe;
    var be = E.slice(E.l, E.l + G);
    switch (K) {
      case 8:
        be = H(E, Z);
        break;
      case 0:
        break;
      default:
        throw new Error("Unsupported ZIP Compression method " + K);
    }
    var rr = !1;
    R & 8 && (z = E.read_shift(4), z == 134695760 && (z = E.read_shift(4), rr = !0), G = E.read_shift(4), Z = E.read_shift(4)), G != O && $n(rr, "Bad compressed size: " + O + " != " + G), Z != g && $n(rr, "Bad uncompressed size: " + g + " != " + Z), Dn(_, me, be, { unsafe: !0, mt: Q });
  }
  function gi(E, O) {
    var g = O || {}, _ = [], S = [], R = te(1), K = g.compression ? 8 : 0, Q = 0, z = 0, G = 0, Z = 0, ne = 0, oe = E.FullPaths[0], me = oe, ue = E.FileIndex[0], pe = [], be = 0;
    for (z = 1; z < E.FullPaths.length; ++z)
      if (me = E.FullPaths[z].slice(oe.length), ue = E.FileIndex[z], !(!ue.size || !ue.content || me == "Sh33tJ5")) {
        var rr = Z, ir = te(me.length);
        for (G = 0; G < me.length; ++G)
          ir.write_shift(1, me.charCodeAt(G) & 127);
        ir = ir.slice(0, ir.l), pe[ne] = j5.buf(
          /*::((*/
          ue.content,
          0
        );
        var Ir = ue.content;
        K == 8 && (Ir = P(Ir)), R = te(30), R.write_shift(4, 67324752), R.write_shift(2, 20), R.write_shift(2, Q), R.write_shift(2, K), ue.mt ? i(R, ue.mt) : R.write_shift(4, 0), R.write_shift(-4, pe[ne]), R.write_shift(4, Ir.length), R.write_shift(
          4,
          /*::(*/
          ue.content.length
        ), R.write_shift(2, ir.length), R.write_shift(2, 0), Z += R.length, _.push(R), Z += ir.length, _.push(ir), Z += Ir.length, _.push(Ir), R = te(46), R.write_shift(4, 33639248), R.write_shift(2, 0), R.write_shift(2, 20), R.write_shift(2, Q), R.write_shift(2, K), R.write_shift(4, 0), R.write_shift(-4, pe[ne]), R.write_shift(4, Ir.length), R.write_shift(
          4,
          /*::(*/
          ue.content.length
        ), R.write_shift(2, ir.length), R.write_shift(2, 0), R.write_shift(2, 0), R.write_shift(2, 0), R.write_shift(2, 0), R.write_shift(4, 0), R.write_shift(4, rr), be += R.l, S.push(R), be += ir.length, S.push(ir), ++ne;
      }
    return R = te(22), R.write_shift(4, 101010256), R.write_shift(2, 0), R.write_shift(2, 0), R.write_shift(2, ne), R.write_shift(2, ne), R.write_shift(4, be), R.write_shift(4, Z), R.write_shift(2, 0), Or([Or(_), Or(S), R]);
  }
  var ga = {
    htm: "text/html",
    xml: "text/xml",
    gif: "image/gif",
    jpg: "image/jpeg",
    png: "image/png",
    mso: "application/x-mso",
    thmx: "application/vnd.ms-officetheme",
    sh33tj5: "application/octet-stream"
  };
  function Bs(E, O) {
    if (E.ctype)
      return E.ctype;
    var g = E.name || "", _ = g.match(/\.([^\.]+)$/);
    return _ && ga[_[1]] || O && (_ = (g = O).match(/[\.\\]([^\.\\])+$/), _ && ga[_[1]]) ? ga[_[1]] : "application/octet-stream";
  }
  function k0(E) {
    for (var O = rs(E), g = [], _ = 0; _ < O.length; _ += 76)
      g.push(O.slice(_, _ + 76));
    return g.join(`\r
`) + `\r
`;
  }
  function Ps(E) {
    var O = E.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF=]/g, function(G) {
      var Z = G.charCodeAt(0).toString(16).toUpperCase();
      return "=" + (Z.length == 1 ? "0" + Z : Z);
    });
    O = O.replace(/ $/mg, "=20").replace(/\t$/mg, "=09"), O.charAt(0) == `
` && (O = "=0D" + O.slice(1)), O = O.replace(/\r(?!\n)/mg, "=0D").replace(/\n\n/mg, `
=0A`).replace(/([^\r\n])\n/mg, "$1=0A");
    for (var g = [], _ = O.split(`\r
`), S = 0; S < _.length; ++S) {
      var R = _[S];
      if (R.length == 0) {
        g.push("");
        continue;
      }
      for (var K = 0; K < R.length; ) {
        var Q = 76, z = R.slice(K, K + Q);
        z.charAt(Q - 1) == "=" ? Q-- : z.charAt(Q - 2) == "=" ? Q -= 2 : z.charAt(Q - 3) == "=" && (Q -= 3), z = R.slice(K, K + Q), K += Q, K < R.length && (z += "="), g.push(z);
      }
    }
    return g.join(`\r
`);
  }
  function T0(E) {
    for (var O = [], g = 0; g < E.length; ++g) {
      for (var _ = E[g]; g <= E.length && _.charAt(_.length - 1) == "="; )
        _ = _.slice(0, _.length - 1) + E[++g];
      O.push(_);
    }
    for (var S = 0; S < O.length; ++S)
      O[S] = O[S].replace(/[=][0-9A-Fa-f]{2}/g, function(R) {
        return String.fromCharCode(parseInt(R.slice(1), 16));
      });
    return dt(O.join(`\r
`));
  }
  function Ms(E, O, g) {
    for (var _ = "", S = "", R = "", K, Q = 0; Q < 10; ++Q) {
      var z = O[Q];
      if (!z || z.match(/^\s*$/))
        break;
      var G = z.match(/^(.*?):\s*([^\s].*)$/);
      if (G)
        switch (G[1].toLowerCase()) {
          case "content-location":
            _ = G[2].trim();
            break;
          case "content-type":
            R = G[2].trim();
            break;
          case "content-transfer-encoding":
            S = G[2].trim();
            break;
        }
    }
    switch (++Q, S.toLowerCase()) {
      case "base64":
        K = dt(mt(O.slice(Q).join("")));
        break;
      case "quoted-printable":
        K = T0(O.slice(Q));
        break;
      default:
        throw new Error("Unsupported Content-Transfer-Encoding " + S);
    }
    var Z = Dn(E, _.slice(g.length), K, { unsafe: !0 });
    R && (Z.ctype = R);
  }
  function Os(E, O) {
    if (V(E.slice(0, 13)).toLowerCase() != "mime-version:")
      throw new Error("Unsupported MAD header");
    var g = O && O.root || "", _ = (Ie && Buffer.isBuffer(E) ? E.toString("binary") : V(E)).split(`\r
`), S = 0, R = "";
    for (S = 0; S < _.length; ++S)
      if (R = _[S], !!/^Content-Location:/i.test(R) && (R = R.slice(R.indexOf("file")), g || (g = R.slice(0, R.lastIndexOf("/") + 1)), R.slice(0, g.length) != g))
        for (; g.length > 0 && (g = g.slice(0, g.length - 1), g = g.slice(0, g.lastIndexOf("/") + 1), R.slice(0, g.length) != g); )
          ;
    var K = (_[1] || "").match(/boundary="(.*?)"/);
    if (!K)
      throw new Error("MAD cannot find boundary");
    var Q = "--" + (K[1] || ""), z = [], G = [], Z = {
      FileIndex: z,
      FullPaths: G
    };
    k(Z);
    var ne, oe = 0;
    for (S = 0; S < _.length; ++S) {
      var me = _[S];
      me !== Q && me !== Q + "--" || (oe++ && Ms(Z, _.slice(ne, S), g), ne = S);
    }
    return Z;
  }
  function S0(E, O) {
    var g = O || {}, _ = g.boundary || "SheetJS";
    _ = "------=" + _;
    for (var S = [
      "MIME-Version: 1.0",
      'Content-Type: multipart/related; boundary="' + _.slice(2) + '"',
      "",
      "",
      ""
    ], R = E.FullPaths[0], K = R, Q = E.FileIndex[0], z = 1; z < E.FullPaths.length; ++z)
      if (K = E.FullPaths[z].slice(R.length), Q = E.FileIndex[z], !(!Q.size || !Q.content || K == "Sh33tJ5")) {
        K = K.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF]/g, function(be) {
          return "_x" + be.charCodeAt(0).toString(16) + "_";
        }).replace(/[\u0080-\uFFFF]/g, function(be) {
          return "_u" + be.charCodeAt(0).toString(16) + "_";
        });
        for (var G = Q.content, Z = Ie && Buffer.isBuffer(G) ? G.toString("binary") : V(G), ne = 0, oe = Math.min(1024, Z.length), me = 0, ue = 0; ue <= oe; ++ue)
          (me = Z.charCodeAt(ue)) >= 32 && me < 128 && ++ne;
        var pe = ne >= oe * 4 / 5;
        S.push(_), S.push("Content-Location: " + (g.root || "file:///C:/SheetJS/") + K), S.push("Content-Transfer-Encoding: " + (pe ? "quoted-printable" : "base64")), S.push("Content-Type: " + Bs(Q, K)), S.push(""), S.push(pe ? Ps(Z) : k0(Z));
      }
    return S.push(_ + `--\r
`), S.join(`\r
`);
  }
  function C0(E) {
    var O = {};
    return k(O, E), O;
  }
  function Dn(E, O, g, _) {
    var S = _ && _.unsafe;
    S || k(E);
    var R = !S && we.find(E, O);
    if (!R) {
      var K = E.FullPaths[0];
      O.slice(0, K.length) == K ? K = O : (K.slice(-1) != "/" && (K += "/"), K = (K + O).replace("//", "/")), R = { name: n(O), type: 2 }, E.FileIndex.push(R), E.FullPaths.push(K), S || we.utils.cfb_gc(E);
    }
    return R.content = g, R.size = g ? g.length : 0, _ && (_.CLSID && (R.clsid = _.CLSID), _.mt && (R.mt = _.mt), _.ct && (R.ct = _.ct)), R;
  }
  function Ls(E, O) {
    k(E);
    var g = we.find(E, O);
    if (g) {
      for (var _ = 0; _ < E.FileIndex.length; ++_)
        if (E.FileIndex[_] == g)
          return E.FileIndex.splice(_, 1), E.FullPaths.splice(_, 1), !0;
    }
    return !1;
  }
  function F0(E, O, g) {
    k(E);
    var _ = we.find(E, O);
    if (_) {
      for (var S = 0; S < E.FileIndex.length; ++S)
        if (E.FileIndex[S] == _)
          return E.FileIndex[S].name = n(g), E.FullPaths[S] = g, !0;
    }
    return !1;
  }
  function A0(E) {
    b(E, !0);
  }
  return r.find = T, r.read = U, r.parse = c, r.write = ee, r.writeFile = ce, r.utils = {
    cfb_new: C0,
    cfb_add: Dn,
    cfb_del: Ls,
    cfb_mov: F0,
    cfb_gc: A0,
    ReadShift: Ni,
    CheckField: nv,
    prep_blob: Vr,
    bconcat: Or,
    use_zlib: F,
    _deflateRaw: ke,
    _inflateRaw: Is,
    consts: W
  }, r;
}();
let Ia;
function z5(e) {
  Ia = e;
}
function G5(e) {
  return typeof e == "string" ? _s(e) : Array.isArray(e) ? v5(e) : e;
}
function Ds(e, r, t) {
  if (typeof Ia < "u" && Ia.writeFileSync)
    return t ? Ia.writeFileSync(e, r, t) : Ia.writeFileSync(e, r);
  if (typeof Deno < "u") {
    if (t && typeof r == "string")
      switch (t) {
        case "utf8":
          r = new TextEncoder(t).encode(r);
          break;
        case "binary":
          r = _s(r);
          break;
        default:
          throw new Error("Unsupported encoding " + t);
      }
    return Deno.writeFileSync(e, r);
  }
  var a = t == "utf8" ? zt(r) : r;
  if (typeof IE_SaveFile < "u")
    return IE_SaveFile(a, e);
  if (typeof Blob < "u") {
    var n = new Blob([G5(a)], { type: "application/octet-stream" });
    if (typeof navigator < "u" && navigator.msSaveBlob)
      return navigator.msSaveBlob(n, e);
    if (typeof saveAs < "u")
      return saveAs(n, e);
    if (typeof URL < "u" && typeof document < "u" && document.createElement && URL.createObjectURL) {
      var i = URL.createObjectURL(n);
      if (typeof chrome == "object" && typeof (chrome.downloads || {}).download == "function")
        return URL.revokeObjectURL && typeof setTimeout < "u" && setTimeout(function() {
          URL.revokeObjectURL(i);
        }, 6e4), chrome.downloads.download({ url: i, filename: e, saveAs: !0 });
      var s = document.createElement("a");
      if (s.download != null)
        return s.download = e, s.href = i, document.body.appendChild(s), s.click(), document.body.removeChild(s), URL.revokeObjectURL && typeof setTimeout < "u" && setTimeout(function() {
          URL.revokeObjectURL(i);
        }, 6e4), i;
    }
  }
  if (typeof $ < "u" && typeof File < "u" && typeof Folder < "u")
    try {
      var o = File(e);
      return o.open("w"), o.encoding = "binary", Array.isArray(r) && (r = Va(r)), o.write(r), o.close(), r;
    } catch (u) {
      if (!u.message || !u.message.match(/onstruct/))
        throw u;
    }
  throw new Error("cannot save file " + e);
}
function K5(e) {
  if (typeof Ia < "u")
    return Ia.readFileSync(e);
  if (typeof Deno < "u")
    return Deno.readFileSync(e);
  if (typeof $ < "u" && typeof File < "u" && typeof Folder < "u")
    try {
      var r = File(e);
      r.open("r"), r.encoding = "binary";
      var t = r.read();
      return r.close(), t;
    } catch (a) {
      if (!a.message || !a.message.match(/onstruct/))
        throw a;
    }
  throw new Error("Cannot access file " + e);
}
function br(e) {
  for (var r = Object.keys(e), t = [], a = 0; a < r.length; ++a)
    Object.prototype.hasOwnProperty.call(e, r[a]) && t.push(r[a]);
  return t;
}
function Ad(e, r) {
  for (var t = [], a = br(e), n = 0; n !== a.length; ++n)
    t[e[a[n]][r]] == null && (t[e[a[n]][r]] = a[n]);
  return t;
}
function m0(e) {
  for (var r = [], t = br(e), a = 0; a !== t.length; ++a)
    r[e[t[a]]] = t[a];
  return r;
}
function p0(e) {
  for (var r = [], t = br(e), a = 0; a !== t.length; ++a)
    r[e[t[a]]] = parseInt(t[a], 10);
  return r;
}
function Y5(e) {
  for (var r = [], t = br(e), a = 0; a !== t.length; ++a)
    r[e[t[a]]] == null && (r[e[t[a]]] = []), r[e[t[a]]].push(t[a]);
  return r;
}
var Ho = /* @__PURE__ */ new Date(1899, 11, 30, 0, 0, 0);
function Ar(e, r) {
  var t = /* @__PURE__ */ e.getTime(), a = /* @__PURE__ */ Ho.getTime() + (/* @__PURE__ */ e.getTimezoneOffset() - /* @__PURE__ */ Ho.getTimezoneOffset()) * 6e4;
  return (t - a) / (24 * 60 * 60 * 1e3);
}
var Vp = /* @__PURE__ */ new Date(), X5 = /* @__PURE__ */ Ho.getTime() + (/* @__PURE__ */ Vp.getTimezoneOffset() - /* @__PURE__ */ Ho.getTimezoneOffset()) * 6e4, Rd = /* @__PURE__ */ Vp.getTimezoneOffset();
function v0(e) {
  var r = /* @__PURE__ */ new Date();
  return r.setTime(e * 24 * 60 * 60 * 1e3 + X5), r.getTimezoneOffset() !== Rd && r.setTime(r.getTime() + (r.getTimezoneOffset() - Rd) * 6e4), r;
}
function Z5(e) {
  var r = 0, t = 0, a = !1, n = e.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);
  if (!n)
    throw new Error("|" + e + "| is not an ISO8601 Duration");
  for (var i = 1; i != n.length; ++i)
    if (n[i]) {
      switch (t = 1, i > 3 && (a = !0), n[i].slice(n[i].length - 1)) {
        case "Y":
          throw new Error("Unsupported ISO Duration Field: " + n[i].slice(n[i].length - 1));
        case "D":
          t *= 24;
        case "H":
          t *= 60;
        case "M":
          if (a)
            t *= 60;
          else
            throw new Error("Unsupported ISO Duration Field: M");
      }
      r += t * parseInt(n[i], 10);
    }
  return r;
}
var Id = /* @__PURE__ */ new Date("2017-02-19T19:06:09.000Z"), Wp = /* @__PURE__ */ isNaN(/* @__PURE__ */ Id.getFullYear()) ? /* @__PURE__ */ new Date("2/19/17") : Id, J5 = /* @__PURE__ */ Wp.getFullYear() == 2017;
function ur(e, r) {
  var t = new Date(e);
  if (J5)
    return r > 0 ? t.setTime(t.getTime() + t.getTimezoneOffset() * 60 * 1e3) : r < 0 && t.setTime(t.getTime() - t.getTimezoneOffset() * 60 * 1e3), t;
  if (e instanceof Date)
    return e;
  if (Wp.getFullYear() == 1917 && !isNaN(t.getFullYear())) {
    var a = t.getFullYear();
    return e.indexOf("" + a) > -1 || t.setFullYear(t.getFullYear() + 100), t;
  }
  var n = e.match(/\d+/g) || ["2017", "2", "19", "0", "0", "0"], i = new Date(+n[0], +n[1] - 1, +n[2], +n[3] || 0, +n[4] || 0, +n[5] || 0);
  return e.indexOf("Z") > -1 && (i = new Date(i.getTime() - i.getTimezoneOffset() * 60 * 1e3)), i;
}
function fn(e, r) {
  if (Ie && Buffer.isBuffer(e)) {
    if (r) {
      if (e[0] == 255 && e[1] == 254)
        return zt(e.slice(2).toString("utf16le"));
      if (e[1] == 254 && e[2] == 255)
        return zt(Sp(e.slice(2).toString("binary")));
    }
    return e.toString("binary");
  }
  if (typeof TextDecoder < "u")
    try {
      if (r) {
        if (e[0] == 255 && e[1] == 254)
          return zt(new TextDecoder("utf-16le").decode(e.slice(2)));
        if (e[0] == 254 && e[1] == 255)
          return zt(new TextDecoder("utf-16be").decode(e.slice(2)));
      }
      var t = {
        "€": "",
        "‚": "",
        ƒ: "",
        "„": "",
        "…": "",
        "†": "",
        "‡": "",
        "ˆ": "",
        "‰": "",
        Š: "",
        "‹": "",
        Œ: "",
        Ž: "",
        "‘": "",
        "’": "",
        "“": "",
        "”": "",
        "•": "",
        "–": "",
        "—": "",
        "˜": "",
        "™": "",
        š: "",
        "›": "",
        œ: "",
        ž: "",
        Ÿ: ""
      };
      return Array.isArray(e) && (e = new Uint8Array(e)), new TextDecoder("latin1").decode(e).replace(/[€‚ƒ„…†‡ˆ‰Š‹ŒŽ‘’“”•–—˜™š›œžŸ]/g, function(i) {
        return t[i] || i;
      });
    } catch {
    }
  for (var a = [], n = 0; n != e.length; ++n)
    a.push(String.fromCharCode(e[n]));
  return a.join("");
}
function tr(e) {
  if (typeof JSON < "u" && !Array.isArray(e))
    return JSON.parse(JSON.stringify(e));
  if (typeof e != "object" || e == null)
    return e;
  if (e instanceof Date)
    return new Date(e.getTime());
  var r = {};
  for (var t in e)
    Object.prototype.hasOwnProperty.call(e, t) && (r[t] = tr(e[t]));
  return r;
}
function vr(e, r) {
  for (var t = ""; t.length < r; )
    t += e;
  return t;
}
function Ot(e) {
  var r = Number(e);
  if (!isNaN(r))
    return isFinite(r) ? r : NaN;
  if (!/\d/.test(e))
    return r;
  var t = 1, a = e.replace(/([\d]),([\d])/g, "$1$2").replace(/[$]/g, "").replace(/[%]/g, function() {
    return t *= 100, "";
  });
  return !isNaN(r = Number(a)) || (a = a.replace(/[(](.*)[)]/, function(n, i) {
    return t = -t, i;
  }), !isNaN(r = Number(a))) ? r / t : r;
}
var q5 = ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"];
function oi(e) {
  var r = new Date(e), t = /* @__PURE__ */ new Date(NaN), a = r.getYear(), n = r.getMonth(), i = r.getDate();
  if (isNaN(i))
    return t;
  var s = e.toLowerCase();
  if (s.match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/)) {
    if (s = s.replace(/[^a-z]/g, "").replace(/([^a-z]|^)[ap]m?([^a-z]|$)/, ""), s.length > 3 && q5.indexOf(s) == -1)
      return t;
  } else if (s.match(/[a-z]/))
    return t;
  return a < 0 || a > 8099 ? t : (n > 0 || i > 1) && a != 101 ? r : e.match(/[^-0-9:,\/\\]/) ? t : r;
}
var Q5 = /* @__PURE__ */ function() {
  var e = "abacaba".split(/(:?b)/i).length == 5;
  return function(t, a, n) {
    if (e || typeof a == "string")
      return t.split(a);
    for (var i = t.split(a), s = [i[0]], o = 1; o < i.length; ++o)
      s.push(n), s.push(i[o]);
    return s;
  };
}();
function Hp(e) {
  return e ? e.content && e.type ? fn(e.content, !0) : e.data ? Mn(e.data) : e.asNodeBuffer && Ie ? Mn(e.asNodeBuffer().toString("binary")) : e.asBinary ? Mn(e.asBinary()) : e._data && e._data.getContent ? Mn(fn(Array.prototype.slice.call(e._data.getContent(), 0))) : null : null;
}
function jp(e) {
  if (!e)
    return null;
  if (e.data)
    return No(e.data);
  if (e.asNodeBuffer && Ie)
    return e.asNodeBuffer();
  if (e._data && e._data.getContent) {
    var r = e._data.getContent();
    return typeof r == "string" ? No(r) : Array.prototype.slice.call(r);
  }
  return e.content && e.type ? e.content : null;
}
function e_(e) {
  return e && e.name.slice(-4) === ".bin" ? jp(e) : Hp(e);
}
function _t(e, r) {
  for (var t = e.FullPaths || br(e.files), a = r.toLowerCase().replace(/[\/]/g, "\\"), n = a.replace(/\\/g, "/"), i = 0; i < t.length; ++i) {
    var s = t[i].replace(/^Root Entry[\/]/, "").toLowerCase();
    if (a == s || n == s)
      return e.files ? e.files[t[i]] : e.FileIndex[i];
  }
  return null;
}
function wc(e, r) {
  var t = _t(e, r);
  if (t == null)
    throw new Error("Cannot find file " + r + " in zip");
  return t;
}
function kr(e, r, t) {
  if (!t)
    return e_(wc(e, r));
  if (!r)
    return null;
  try {
    return kr(e, r);
  } catch {
    return null;
  }
}
function ht(e, r, t) {
  if (!t)
    return Hp(wc(e, r));
  if (!r)
    return null;
  try {
    return ht(e, r);
  } catch {
    return null;
  }
}
function r_(e, r, t) {
  return jp(wc(e, r));
}
function Bd(e) {
  for (var r = e.FullPaths || br(e.files), t = [], a = 0; a < r.length; ++a)
    r[a].slice(-1) != "/" && t.push(r[a].replace(/^Root Entry[\/]/, ""));
  return t.sort();
}
function Fe(e, r, t) {
  if (e.FullPaths) {
    if (typeof t == "string") {
      var a;
      return Ie ? a = xa(t) : a = g5(t), we.utils.cfb_add(e, r, a);
    }
    we.utils.cfb_add(e, r, t);
  } else
    e.file(r, t);
}
function _c() {
  return we.utils.cfb_new();
}
function zp(e, r) {
  switch (r.type) {
    case "base64":
      return we.read(e, { type: "base64" });
    case "binary":
      return we.read(e, { type: "binary" });
    case "buffer":
    case "array":
      return we.read(e, { type: "buffer" });
  }
  throw new Error("Unrecognized type " + r.type);
}
function Mi(e, r) {
  if (e.charAt(0) == "/")
    return e.slice(1);
  var t = r.split("/");
  r.slice(-1) != "/" && t.pop();
  for (var a = e.split("/"); a.length !== 0; ) {
    var n = a.shift();
    n === ".." ? t.pop() : n !== "." && t.push(n);
  }
  return t.join("/");
}
var $r = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r
`, t_ = /([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g, Pd = /<[\/\?]?[a-zA-Z0-9:_-]+(?:\s+[^"\s?>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'">\s=]+))*\s*[\/\?]?>/mg, a_ = /<[^>]*>/g, Qr = /* @__PURE__ */ $r.match(Pd) ? Pd : a_, n_ = /<\w*:/, i_ = /<(\/?)\w+:/;
function Se(e, r, t) {
  for (var a = {}, n = 0, i = 0; n !== e.length && !((i = e.charCodeAt(n)) === 32 || i === 10 || i === 13); ++n)
    ;
  if (r || (a[0] = e.slice(0, n)), n === e.length)
    return a;
  var s = e.match(t_), o = 0, u = "", l = 0, c = "", f = "", h = 1;
  if (s)
    for (l = 0; l != s.length; ++l) {
      for (f = s[l], i = 0; i != f.length && f.charCodeAt(i) !== 61; ++i)
        ;
      for (c = f.slice(0, i).trim(); f.charCodeAt(i + 1) == 32; )
        ++i;
      for (h = (n = f.charCodeAt(i + 1)) == 34 || n == 39 ? 1 : 0, u = f.slice(i + 1 + h, f.length - h), o = 0; o != c.length && c.charCodeAt(o) !== 58; ++o)
        ;
      if (o === c.length)
        c.indexOf("_") > 0 && (c = c.slice(0, c.indexOf("_"))), a[c] = u, a[c.toLowerCase()] = u;
      else {
        var d = (o === 5 && c.slice(0, 5) === "xmlns" ? "xmlns" : "") + c.slice(o + 1);
        if (a[d] && c.slice(o - 3, o) == "ext")
          continue;
        a[d] = u, a[d.toLowerCase()] = u;
      }
    }
  return a;
}
function Xt(e) {
  return e.replace(i_, "<$1");
}
var Gp = {
  "&quot;": '"',
  "&apos;": "'",
  "&gt;": ">",
  "&lt;": "<",
  "&amp;": "&"
}, $c = /* @__PURE__ */ m0(Gp), We = /* @__PURE__ */ function() {
  var e = /&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/ig, r = /_x([\da-fA-F]{4})_/ig;
  return function t(a) {
    var n = a + "", i = n.indexOf("<![CDATA[");
    if (i == -1)
      return n.replace(e, function(o, u) {
        return Gp[o] || String.fromCharCode(parseInt(u, o.indexOf("x") > -1 ? 16 : 10)) || o;
      }).replace(r, function(o, u) {
        return String.fromCharCode(parseInt(u, 16));
      });
    var s = n.indexOf("]]>");
    return t(n.slice(0, i)) + n.slice(i + 9, s) + t(n.slice(s + 3));
  };
}(), Dc = /[&<>'"]/g, s_ = /[\u0000-\u0008\u000b-\u001f]/g;
function Xe(e) {
  var r = e + "";
  return r.replace(Dc, function(t) {
    return $c[t];
  }).replace(s_, function(t) {
    return "_x" + ("000" + t.charCodeAt(0).toString(16)).slice(-4) + "_";
  });
}
function Md(e) {
  return Xe(e).replace(/ /g, "_x0020_");
}
var Kp = /[\u0000-\u001f]/g;
function Ec(e) {
  var r = e + "";
  return r.replace(Dc, function(t) {
    return $c[t];
  }).replace(/\n/g, "<br/>").replace(Kp, function(t) {
    return "&#x" + ("000" + t.charCodeAt(0).toString(16)).slice(-4) + ";";
  });
}
function o_(e) {
  var r = e + "";
  return r.replace(Dc, function(t) {
    return $c[t];
  }).replace(Kp, function(t) {
    return "&#x" + t.charCodeAt(0).toString(16).toUpperCase() + ";";
  });
}
var Od = /* @__PURE__ */ function() {
  var e = /&#(\d+);/g;
  function r(t, a) {
    return String.fromCharCode(parseInt(a, 10));
  }
  return function(a) {
    return a.replace(e, r);
  };
}();
function u_(e) {
  return e.replace(/(\r\n|[\r\n])/g, "&#10;");
}
function sr(e) {
  switch (e) {
    case 1:
    case !0:
    case "1":
    case "true":
    case "TRUE":
      return !0;
    default:
      return !1;
  }
}
function cu(e) {
  for (var r = "", t = 0, a = 0, n = 0, i = 0, s = 0, o = 0; t < e.length; ) {
    if (a = e.charCodeAt(t++), a < 128) {
      r += String.fromCharCode(a);
      continue;
    }
    if (n = e.charCodeAt(t++), a > 191 && a < 224) {
      s = (a & 31) << 6, s |= n & 63, r += String.fromCharCode(s);
      continue;
    }
    if (i = e.charCodeAt(t++), a < 240) {
      r += String.fromCharCode((a & 15) << 12 | (n & 63) << 6 | i & 63);
      continue;
    }
    s = e.charCodeAt(t++), o = ((a & 7) << 18 | (n & 63) << 12 | (i & 63) << 6 | s & 63) - 65536, r += String.fromCharCode(55296 + (o >>> 10 & 1023)), r += String.fromCharCode(56320 + (o & 1023));
  }
  return r;
}
function Ld(e) {
  var r = Pa(2 * e.length), t, a, n = 1, i = 0, s = 0, o;
  for (a = 0; a < e.length; a += n)
    n = 1, (o = e.charCodeAt(a)) < 128 ? t = o : o < 224 ? (t = (o & 31) * 64 + (e.charCodeAt(a + 1) & 63), n = 2) : o < 240 ? (t = (o & 15) * 4096 + (e.charCodeAt(a + 1) & 63) * 64 + (e.charCodeAt(a + 2) & 63), n = 3) : (n = 4, t = (o & 7) * 262144 + (e.charCodeAt(a + 1) & 63) * 4096 + (e.charCodeAt(a + 2) & 63) * 64 + (e.charCodeAt(a + 3) & 63), t -= 65536, s = 55296 + (t >>> 10 & 1023), t = 56320 + (t & 1023)), s !== 0 && (r[i++] = s & 255, r[i++] = s >>> 8, s = 0), r[i++] = t % 256, r[i++] = t >>> 8;
  return r.slice(0, i).toString("ucs2");
}
function Nd(e) {
  return xa(e, "binary").toString("utf8");
}
var Qs = "foo bar bazâð£", Qe = Ie && (/* @__PURE__ */ Nd(Qs) == /* @__PURE__ */ cu(Qs) && Nd || /* @__PURE__ */ Ld(Qs) == /* @__PURE__ */ cu(Qs) && Ld) || cu, zt = Ie ? function(e) {
  return xa(e, "utf8").toString("binary");
} : function(e) {
  for (var r = [], t = 0, a = 0, n = 0; t < e.length; )
    switch (a = e.charCodeAt(t++), !0) {
      case a < 128:
        r.push(String.fromCharCode(a));
        break;
      case a < 2048:
        r.push(String.fromCharCode(192 + (a >> 6))), r.push(String.fromCharCode(128 + (a & 63)));
        break;
      case (a >= 55296 && a < 57344):
        a -= 55296, n = e.charCodeAt(t++) - 56320 + (a << 10), r.push(String.fromCharCode(240 + (n >> 18 & 7))), r.push(String.fromCharCode(144 + (n >> 12 & 63))), r.push(String.fromCharCode(128 + (n >> 6 & 63))), r.push(String.fromCharCode(128 + (n & 63)));
        break;
      default:
        r.push(String.fromCharCode(224 + (a >> 12))), r.push(String.fromCharCode(128 + (a >> 6 & 63))), r.push(String.fromCharCode(128 + (a & 63)));
    }
  return r.join("");
}, as = /* @__PURE__ */ function() {
  var e = {};
  return function(t, a) {
    var n = t + "|" + (a || "");
    return e[n] ? e[n] : e[n] = new RegExp("<(?:\\w+:)?" + t + '(?: xml:space="preserve")?(?:[^>]*)>([\\s\\S]*?)</(?:\\w+:)?' + t + ">", a || "");
  };
}(), Yp = /* @__PURE__ */ function() {
  var e = [
    ["nbsp", " "],
    ["middot", "·"],
    ["quot", '"'],
    ["apos", "'"],
    ["gt", ">"],
    ["lt", "<"],
    ["amp", "&"]
  ].map(function(r) {
    return [new RegExp("&" + r[0] + ";", "ig"), r[1]];
  });
  return function(t) {
    for (var a = t.replace(/^[\t\n\r ]+/, "").replace(/[\t\n\r ]+$/, "").replace(/>\s+/g, ">").replace(/\s+</g, "<").replace(/[\t\n\r ]+/g, " ").replace(/<\s*[bB][rR]\s*\/?>/g, `
`).replace(/<[^>]*>/g, ""), n = 0; n < e.length; ++n)
      a = a.replace(e[n][0], e[n][1]);
    return a;
  };
}(), l_ = /* @__PURE__ */ function() {
  var e = {};
  return function(t) {
    return e[t] !== void 0 ? e[t] : e[t] = new RegExp("<(?:vt:)?" + t + ">([\\s\\S]*?)</(?:vt:)?" + t + ">", "g");
  };
}(), c_ = /<\/?(?:vt:)?variant>/g, f_ = /<(?:vt:)([^>]*)>([\s\S]*)</;
function Ud(e, r) {
  var t = Se(e), a = e.match(l_(t.baseType)) || [], n = [];
  if (a.length != t.size) {
    if (r.WTF)
      throw new Error("unexpected vector length " + a.length + " != " + t.size);
    return n;
  }
  return a.forEach(function(i) {
    var s = i.replace(c_, "").match(f_);
    s && n.push({ v: Qe(s[2]), t: s[1] });
  }), n;
}
var Xp = /(^\s|\s$|\n)/;
function Wr(e, r) {
  return "<" + e + (r.match(Xp) ? ' xml:space="preserve"' : "") + ">" + r + "</" + e + ">";
}
function ns(e) {
  return br(e).map(function(r) {
    return " " + r + '="' + e[r] + '"';
  }).join("");
}
function he(e, r, t) {
  return "<" + e + (t != null ? ns(t) : "") + (r != null ? (r.match(Xp) ? ' xml:space="preserve"' : "") + ">" + r + "</" + e : "/") + ">";
}
function yl(e, r) {
  try {
    return e.toISOString().replace(/\.\d*/, "");
  } catch (t) {
    if (r)
      throw t;
  }
  return "";
}
function d_(e, r) {
  switch (typeof e) {
    case "string":
      var t = he("vt:lpwstr", Xe(e));
      return t = t.replace(/&quot;/g, "_x0022_"), t;
    case "number":
      return he((e | 0) == e ? "vt:i4" : "vt:r8", Xe(String(e)));
    case "boolean":
      return he("vt:bool", e ? "true" : "false");
  }
  if (e instanceof Date)
    return he("vt:filetime", yl(e));
  throw new Error("Unable to serialize " + e);
}
function kc(e) {
  if (Ie && /*::typeof Buffer !== "undefined" && d != null && d instanceof Buffer &&*/
  Buffer.isBuffer(e))
    return e.toString("utf8");
  if (typeof e == "string")
    return e;
  if (typeof Uint8Array < "u" && e instanceof Uint8Array)
    return Qe(Va(gc(e)));
  throw new Error("Bad input format: expected Buffer or string");
}
var is = /<(\/?)([^\s?><!\/:]*:|)([^\s?<>:\/]+)(?:[\s?:\/][^>]*)?>/mg, Fr = {
  CORE_PROPS: "http://schemas.openxmlformats.org/package/2006/metadata/core-properties",
  CUST_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/custom-properties",
  EXT_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties",
  CT: "http://schemas.openxmlformats.org/package/2006/content-types",
  RELS: "http://schemas.openxmlformats.org/package/2006/relationships",
  TCMNT: "http://schemas.microsoft.com/office/spreadsheetml/2018/threadedcomments",
  dc: "http://purl.org/dc/elements/1.1/",
  dcterms: "http://purl.org/dc/terms/",
  dcmitype: "http://purl.org/dc/dcmitype/",
  mx: "http://schemas.microsoft.com/office/mac/excel/2008/main",
  r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
  sjs: "http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties",
  vt: "http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes",
  xsi: "http://www.w3.org/2001/XMLSchema-instance",
  xsd: "http://www.w3.org/2001/XMLSchema"
}, vn = [
  "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
  "http://purl.oclc.org/ooxml/spreadsheetml/main",
  "http://schemas.microsoft.com/office/excel/2006/main",
  "http://schemas.microsoft.com/office/excel/2006/2"
], ft = {
  o: "urn:schemas-microsoft-com:office:office",
  x: "urn:schemas-microsoft-com:office:excel",
  ss: "urn:schemas-microsoft-com:office:spreadsheet",
  dt: "uuid:C2F41010-65B3-11d1-A29F-00AA00C14882",
  mv: "http://macVmlSchemaUri",
  v: "urn:schemas-microsoft-com:vml",
  html: "http://www.w3.org/TR/REC-html40"
};
function h_(e, r) {
  for (var t = 1 - 2 * (e[r + 7] >>> 7), a = ((e[r + 7] & 127) << 4) + (e[r + 6] >>> 4 & 15), n = e[r + 6] & 15, i = 5; i >= 0; --i)
    n = n * 256 + e[r + i];
  return a == 2047 ? n == 0 ? t * (1 / 0) : NaN : (a == 0 ? a = -1022 : (a -= 1023, n += Math.pow(2, 52)), t * Math.pow(2, a - 52) * n);
}
function x_(e, r, t) {
  var a = (r < 0 || 1 / r == -1 / 0 ? 1 : 0) << 7, n = 0, i = 0, s = a ? -r : r;
  isFinite(s) ? s == 0 ? n = i = 0 : (n = Math.floor(Math.log(s) / Math.LN2), i = s * Math.pow(2, 52 - n), n <= -1023 && (!isFinite(i) || i < Math.pow(2, 52)) ? n = -1022 : (i -= Math.pow(2, 52), n += 1023)) : (n = 2047, i = isNaN(r) ? 26985 : 0);
  for (var o = 0; o <= 5; ++o, i /= 256)
    e[t + o] = i & 255;
  e[t + 6] = (n & 15) << 4 | i & 15, e[t + 7] = n >> 4 | a;
}
var Vd = function(e) {
  for (var r = [], t = 10240, a = 0; a < e[0].length; ++a)
    if (e[0][a])
      for (var n = 0, i = e[0][a].length; n < i; n += t)
        r.push.apply(r, e[0][a].slice(n, n + t));
  return r;
}, Wd = Ie ? function(e) {
  return e[0].length > 0 && Buffer.isBuffer(e[0][0]) ? Buffer.concat(e[0].map(function(r) {
    return Buffer.isBuffer(r) ? r : xa(r);
  })) : Vd(e);
} : Vd, Hd = function(e, r, t) {
  for (var a = [], n = r; n < t; n += 2)
    a.push(String.fromCharCode(ua(e, n)));
  return a.join("").replace(Zr, "");
}, g0 = Ie ? function(e, r, t) {
  return Buffer.isBuffer(e) ? e.toString("utf16le", r, t).replace(Zr, "") : Hd(e, r, t);
} : Hd, jd = function(e, r, t) {
  for (var a = [], n = r; n < r + t; ++n)
    a.push(("0" + e[n].toString(16)).slice(-2));
  return a.join("");
}, Zp = Ie ? function(e, r, t) {
  return Buffer.isBuffer(e) ? e.toString("hex", r, r + t) : jd(e, r, t);
} : jd, zd = function(e, r, t) {
  for (var a = [], n = r; n < t; n++)
    a.push(String.fromCharCode(In(e, n)));
  return a.join("");
}, xi = Ie ? function(r, t, a) {
  return Buffer.isBuffer(r) ? r.toString("utf8", t, a) : zd(r, t, a);
} : zd, Jp = function(e, r) {
  var t = Mr(e, r);
  return t > 0 ? xi(e, r + 4, r + 4 + t - 1) : "";
}, Tc = Jp, qp = function(e, r) {
  var t = Mr(e, r);
  return t > 0 ? xi(e, r + 4, r + 4 + t - 1) : "";
}, Sc = qp, Qp = function(e, r) {
  var t = 2 * Mr(e, r);
  return t > 0 ? xi(e, r + 4, r + 4 + t - 1) : "";
}, Cc = Qp, ev = function(r, t) {
  var a = Mr(r, t);
  return a > 0 ? g0(r, t + 4, t + 4 + a) : "";
}, Fc = ev, rv = function(e, r) {
  var t = Mr(e, r);
  return t > 0 ? xi(e, r + 4, r + 4 + t) : "";
}, Ac = rv, tv = function(e, r) {
  return h_(e, r);
}, jo = tv, Rc = function(r) {
  return Array.isArray(r) || typeof Uint8Array < "u" && r instanceof Uint8Array;
};
Ie && (Tc = function(r, t) {
  if (!Buffer.isBuffer(r))
    return Jp(r, t);
  var a = r.readUInt32LE(t);
  return a > 0 ? r.toString("utf8", t + 4, t + 4 + a - 1) : "";
}, Sc = function(r, t) {
  if (!Buffer.isBuffer(r))
    return qp(r, t);
  var a = r.readUInt32LE(t);
  return a > 0 ? r.toString("utf8", t + 4, t + 4 + a - 1) : "";
}, Cc = function(r, t) {
  if (!Buffer.isBuffer(r))
    return Qp(r, t);
  var a = 2 * r.readUInt32LE(t);
  return r.toString("utf16le", t + 4, t + 4 + a - 1);
}, Fc = function(r, t) {
  if (!Buffer.isBuffer(r))
    return ev(r, t);
  var a = r.readUInt32LE(t);
  return r.toString("utf16le", t + 4, t + 4 + a);
}, Ac = function(r, t) {
  if (!Buffer.isBuffer(r))
    return rv(r, t);
  var a = r.readUInt32LE(t);
  return r.toString("utf8", t + 4, t + 4 + a);
}, jo = function(r, t) {
  return Buffer.isBuffer(r) ? r.readDoubleLE(t) : tv(r, t);
}, Rc = function(r) {
  return Buffer.isBuffer(r) || Array.isArray(r) || typeof Uint8Array < "u" && r instanceof Uint8Array;
});
function av() {
  g0 = function(e, r, t) {
    return Ue.utils.decode(1200, e.slice(r, t)).replace(Zr, "");
  }, xi = function(e, r, t) {
    return Ue.utils.decode(65001, e.slice(r, t));
  }, Tc = function(e, r) {
    var t = Mr(e, r);
    return t > 0 ? Ue.utils.decode(ln, e.slice(r + 4, r + 4 + t - 1)) : "";
  }, Sc = function(e, r) {
    var t = Mr(e, r);
    return t > 0 ? Ue.utils.decode(xt, e.slice(r + 4, r + 4 + t - 1)) : "";
  }, Cc = function(e, r) {
    var t = 2 * Mr(e, r);
    return t > 0 ? Ue.utils.decode(1200, e.slice(r + 4, r + 4 + t - 1)) : "";
  }, Fc = function(e, r) {
    var t = Mr(e, r);
    return t > 0 ? Ue.utils.decode(1200, e.slice(r + 4, r + 4 + t)) : "";
  }, Ac = function(e, r) {
    var t = Mr(e, r);
    return t > 0 ? Ue.utils.decode(65001, e.slice(r + 4, r + 4 + t)) : "";
  };
}
typeof Ue < "u" && av();
var In = function(e, r) {
  return e[r];
}, ua = function(e, r) {
  return e[r + 1] * 256 + e[r];
}, m_ = function(e, r) {
  var t = e[r + 1] * 256 + e[r];
  return t < 32768 ? t : (65535 - t + 1) * -1;
}, Mr = function(e, r) {
  return e[r + 3] * (1 << 24) + (e[r + 2] << 16) + (e[r + 1] << 8) + e[r];
}, Xa = function(e, r) {
  return e[r + 3] << 24 | e[r + 2] << 16 | e[r + 1] << 8 | e[r];
}, p_ = function(e, r) {
  return e[r] << 24 | e[r + 1] << 16 | e[r + 2] << 8 | e[r + 3];
};
function Ni(e, r) {
  var t = "", a, n, i = [], s, o, u, l;
  switch (r) {
    case "dbcs":
      if (l = this.l, Ie && Buffer.isBuffer(this))
        t = this.slice(this.l, this.l + 2 * e).toString("utf16le");
      else
        for (u = 0; u < e; ++u)
          t += String.fromCharCode(ua(this, l)), l += 2;
      e *= 2;
      break;
    case "utf8":
      t = xi(this, this.l, this.l + e);
      break;
    case "utf16le":
      e *= 2, t = g0(this, this.l, this.l + e);
      break;
    case "wstr":
      if (typeof Ue < "u")
        t = Ue.utils.decode(xt, this.slice(this.l, this.l + 2 * e));
      else
        return Ni.call(this, e, "dbcs");
      e = 2 * e;
      break;
    case "lpstr-ansi":
      t = Tc(this, this.l), e = 4 + Mr(this, this.l);
      break;
    case "lpstr-cp":
      t = Sc(this, this.l), e = 4 + Mr(this, this.l);
      break;
    case "lpwstr":
      t = Cc(this, this.l), e = 4 + 2 * Mr(this, this.l);
      break;
    case "lpp4":
      e = 4 + Mr(this, this.l), t = Fc(this, this.l), e & 2 && (e += 2);
      break;
    case "8lpp4":
      e = 4 + Mr(this, this.l), t = Ac(this, this.l), e & 3 && (e += 4 - (e & 3));
      break;
    case "cstr":
      for (e = 0, t = ""; (s = In(this, this.l + e++)) !== 0; )
        i.push(Bi(s));
      t = i.join("");
      break;
    case "_wstr":
      for (e = 0, t = ""; (s = ua(this, this.l + e)) !== 0; )
        i.push(Bi(s)), e += 2;
      e += 2, t = i.join("");
      break;
    case "dbcs-cont":
      for (t = "", l = this.l, u = 0; u < e; ++u) {
        if (this.lens && this.lens.indexOf(l) !== -1)
          return s = In(this, l), this.l = l + 1, o = Ni.call(this, e - u, s ? "dbcs-cont" : "sbcs-cont"), i.join("") + o;
        i.push(Bi(ua(this, l))), l += 2;
      }
      t = i.join(""), e *= 2;
      break;
    case "cpstr":
      if (typeof Ue < "u") {
        t = Ue.utils.decode(xt, this.slice(this.l, this.l + e));
        break;
      }
    case "sbcs-cont":
      for (t = "", l = this.l, u = 0; u != e; ++u) {
        if (this.lens && this.lens.indexOf(l) !== -1)
          return s = In(this, l), this.l = l + 1, o = Ni.call(this, e - u, s ? "dbcs-cont" : "sbcs-cont"), i.join("") + o;
        i.push(Bi(In(this, l))), l += 1;
      }
      t = i.join("");
      break;
    default:
      switch (e) {
        case 1:
          return a = In(this, this.l), this.l++, a;
        case 2:
          return a = (r === "i" ? m_ : ua)(this, this.l), this.l += 2, a;
        case 4:
        case -4:
          return r === "i" || !(this[this.l + 3] & 128) ? (a = (e > 0 ? Xa : p_)(this, this.l), this.l += 4, a) : (n = Mr(this, this.l), this.l += 4, n);
        case 8:
        case -8:
          if (r === "f")
            return e == 8 ? n = jo(this, this.l) : n = jo([this[this.l + 7], this[this.l + 6], this[this.l + 5], this[this.l + 4], this[this.l + 3], this[this.l + 2], this[this.l + 1], this[this.l + 0]], 0), this.l += 8, n;
          e = 8;
        case 16:
          t = Zp(this, this.l, e);
          break;
      }
  }
  return this.l += e, t;
}
var v_ = function(e, r, t) {
  e[t] = r & 255, e[t + 1] = r >>> 8 & 255, e[t + 2] = r >>> 16 & 255, e[t + 3] = r >>> 24 & 255;
}, g_ = function(e, r, t) {
  e[t] = r & 255, e[t + 1] = r >> 8 & 255, e[t + 2] = r >> 16 & 255, e[t + 3] = r >> 24 & 255;
}, y_ = function(e, r, t) {
  e[t] = r & 255, e[t + 1] = r >>> 8 & 255;
};
function b_(e, r, t) {
  var a = 0, n = 0;
  if (t === "dbcs") {
    for (n = 0; n != r.length; ++n)
      y_(this, r.charCodeAt(n), this.l + 2 * n);
    a = 2 * r.length;
  } else if (t === "sbcs") {
    if (typeof Ue < "u" && ln == 874)
      for (n = 0; n != r.length; ++n) {
        var i = Ue.utils.encode(ln, r.charAt(n));
        this[this.l + n] = i[0];
      }
    else
      for (r = r.replace(/[^\x00-\x7F]/g, "_"), n = 0; n != r.length; ++n)
        this[this.l + n] = r.charCodeAt(n) & 255;
    a = r.length;
  } else if (t === "hex") {
    for (; n < e; ++n)
      this[this.l++] = parseInt(r.slice(2 * n, 2 * n + 2), 16) || 0;
    return this;
  } else if (t === "utf16le") {
    var s = Math.min(this.l + e, this.length);
    for (n = 0; n < Math.min(r.length, e); ++n) {
      var o = r.charCodeAt(n);
      this[this.l++] = o & 255, this[this.l++] = o >> 8;
    }
    for (; this.l < s; )
      this[this.l++] = 0;
    return this;
  } else
    switch (e) {
      case 1:
        a = 1, this[this.l] = r & 255;
        break;
      case 2:
        a = 2, this[this.l] = r & 255, r >>>= 8, this[this.l + 1] = r & 255;
        break;
      case 3:
        a = 3, this[this.l] = r & 255, r >>>= 8, this[this.l + 1] = r & 255, r >>>= 8, this[this.l + 2] = r & 255;
        break;
      case 4:
        a = 4, v_(this, r, this.l);
        break;
      case 8:
        if (a = 8, t === "f") {
          x_(this, r, this.l);
          break;
        }
      case 16:
        break;
      case -4:
        a = 4, g_(this, r, this.l);
        break;
    }
  return this.l += a, this;
}
function nv(e, r) {
  var t = Zp(this, this.l, e.length >> 1);
  if (t !== e)
    throw new Error(r + "Expected " + e + " saw " + t);
  this.l += e.length >> 1;
}
function Vr(e, r) {
  e.l = r, e.read_shift = /*::(*/
  Ni, e.chk = nv, e.write_shift = b_;
}
function qr(e, r) {
  e.l += r;
}
function te(e) {
  var r = Pa(e);
  return Vr(r, 0), r;
}
function ma(e, r, t) {
  if (e) {
    var a, n, i;
    Vr(e, e.l || 0);
    for (var s = e.length, o = 0, u = 0; e.l < s; ) {
      o = e.read_shift(1), o & 128 && (o = (o & 127) + ((e.read_shift(1) & 127) << 7));
      var l = fs[o] || fs[65535];
      for (a = e.read_shift(1), i = a & 127, n = 1; n < 4 && a & 128; ++n)
        i += ((a = e.read_shift(1)) & 127) << 7 * n;
      u = e.l + i;
      var c = l.f && l.f(e, i, t);
      if (e.l = u, r(c, l, o))
        return;
    }
  }
}
function ut() {
  var e = [], r = Ie ? 256 : 2048, t = function(l) {
    var c = te(l);
    return Vr(c, 0), c;
  }, a = t(r), n = function() {
    a && (a.length > a.l && (a = a.slice(0, a.l), a.l = a.length), a.length > 0 && e.push(a), a = null);
  }, i = function(l) {
    return a && l < a.length - a.l ? a : (n(), a = t(Math.max(l + 1, r)));
  }, s = function() {
    return n(), Or(e);
  }, o = function(l) {
    n(), a = l, a.l == null && (a.l = a.length), i(r);
  };
  return { next: i, push: o, end: s, _bufs: e };
}
function se(e, r, t, a) {
  var n = +r, i;
  if (!isNaN(n)) {
    a || (a = fs[n].p || (t || []).length || 0), i = 1 + (n >= 128 ? 1 : 0) + 1, a >= 128 && ++i, a >= 16384 && ++i, a >= 2097152 && ++i;
    var s = e.next(i);
    n <= 127 ? s.write_shift(1, n) : (s.write_shift(1, (n & 127) + 128), s.write_shift(1, n >> 7));
    for (var o = 0; o != 4; ++o)
      if (a >= 128)
        s.write_shift(1, (a & 127) + 128), a >>= 7;
      else {
        s.write_shift(1, a);
        break;
      }
    /*:: length != null &&*/
    a > 0 && Rc(t) && e.push(t);
  }
}
function Ui(e, r, t) {
  var a = tr(e);
  if (r.s ? (a.cRel && (a.c += r.s.c), a.rRel && (a.r += r.s.r)) : (a.cRel && (a.c += r.c), a.rRel && (a.r += r.r)), !t || t.biff < 12) {
    for (; a.c >= 256; )
      a.c -= 256;
    for (; a.r >= 65536; )
      a.r -= 65536;
  }
  return a;
}
function Gd(e, r, t) {
  var a = tr(e);
  return a.s = Ui(a.s, r.s, t), a.e = Ui(a.e, r.s, t), a;
}
function Vi(e, r) {
  if (e.cRel && e.c < 0)
    for (e = tr(e); e.c < 0; )
      e.c += r > 8 ? 16384 : 256;
  if (e.rRel && e.r < 0)
    for (e = tr(e); e.r < 0; )
      e.r += r > 8 ? 1048576 : r > 5 ? 65536 : 16384;
  var t = Te(e);
  return !e.cRel && e.cRel != null && (t = $_(t)), !e.rRel && e.rRel != null && (t = w_(t)), t;
}
function fu(e, r) {
  return e.s.r == 0 && !e.s.rRel && e.e.r == (r.biff >= 12 ? 1048575 : r.biff >= 8 ? 65536 : 16384) && !e.e.rRel ? (e.s.cRel ? "" : "$") + or(e.s.c) + ":" + (e.e.cRel ? "" : "$") + or(e.e.c) : e.s.c == 0 && !e.s.cRel && e.e.c == (r.biff >= 12 ? 16383 : 255) && !e.e.cRel ? (e.s.rRel ? "" : "$") + gr(e.s.r) + ":" + (e.e.rRel ? "" : "$") + gr(e.e.r) : Vi(e.s, r.biff) + ":" + Vi(e.e, r.biff);
}
function Ic(e) {
  return parseInt(__(e), 10) - 1;
}
function gr(e) {
  return "" + (e + 1);
}
function w_(e) {
  return e.replace(/([A-Z]|^)(\d+)$/, "$1$$$2");
}
function __(e) {
  return e.replace(/\$(\d+)$/, "$1");
}
function Bc(e) {
  for (var r = D_(e), t = 0, a = 0; a !== r.length; ++a)
    t = 26 * t + r.charCodeAt(a) - 64;
  return t - 1;
}
function or(e) {
  if (e < 0)
    throw new Error("invalid column " + e);
  var r = "";
  for (++e; e; e = Math.floor((e - 1) / 26))
    r = String.fromCharCode((e - 1) % 26 + 65) + r;
  return r;
}
function $_(e) {
  return e.replace(/^([A-Z])/, "$$$1");
}
function D_(e) {
  return e.replace(/^\$([A-Z])/, "$1");
}
function E_(e) {
  return e.replace(/(\$?[A-Z]*)(\$?\d*)/, "$1,$2").split(",");
}
function fr(e) {
  for (var r = 0, t = 0, a = 0; a < e.length; ++a) {
    var n = e.charCodeAt(a);
    n >= 48 && n <= 57 ? r = 10 * r + (n - 48) : n >= 65 && n <= 90 && (t = 26 * t + (n - 64));
  }
  return { c: t - 1, r: r - 1 };
}
function Te(e) {
  for (var r = e.c + 1, t = ""; r; r = (r - 1) / 26 | 0)
    t = String.fromCharCode((r - 1) % 26 + 65) + t;
  return t + (e.r + 1);
}
function tt(e) {
  var r = e.indexOf(":");
  return r == -1 ? { s: fr(e), e: fr(e) } : { s: fr(e.slice(0, r)), e: fr(e.slice(r + 1)) };
}
function Ce(e, r) {
  return typeof r > "u" || typeof r == "number" ? Ce(e.s, e.e) : (typeof e != "string" && (e = Te(e)), typeof r != "string" && (r = Te(r)), e == r ? e : e + ":" + r);
}
function Oe(e) {
  var r = { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } }, t = 0, a = 0, n = 0, i = e.length;
  for (t = 0; a < i && !((n = e.charCodeAt(a) - 64) < 1 || n > 26); ++a)
    t = 26 * t + n;
  for (r.s.c = --t, t = 0; a < i && !((n = e.charCodeAt(a) - 48) < 0 || n > 9); ++a)
    t = 10 * t + n;
  if (r.s.r = --t, a === i || n != 10)
    return r.e.c = r.s.c, r.e.r = r.s.r, r;
  for (++a, t = 0; a != i && !((n = e.charCodeAt(a) - 64) < 1 || n > 26); ++a)
    t = 26 * t + n;
  for (r.e.c = --t, t = 0; a != i && !((n = e.charCodeAt(a) - 48) < 0 || n > 9); ++a)
    t = 10 * t + n;
  return r.e.r = --t, r;
}
function Kd(e, r) {
  var t = e.t == "d" && r instanceof Date;
  if (e.z != null)
    try {
      return e.w = pt(e.z, t ? Ar(r) : r);
    } catch {
    }
  try {
    return e.w = pt((e.XF || {}).numFmtId || (t ? 14 : 0), t ? Ar(r) : r);
  } catch {
    return "" + r;
  }
}
function Yt(e, r, t) {
  return e == null || e.t == null || e.t == "z" ? "" : e.w !== void 0 ? e.w : (e.t == "d" && !e.z && t && t.dateNF && (e.z = t.dateNF), e.t == "e" ? pa[e.v] || e.v : r == null ? Kd(e, e.v) : Kd(e, r));
}
function Wa(e, r) {
  var t = r && r.sheet ? r.sheet : "Sheet1", a = {};
  return a[t] = e, { SheetNames: [t], Sheets: a };
}
function iv(e, r, t) {
  var a = t || {}, n = e ? Array.isArray(e) : a.dense, i = e || (n ? [] : {}), s = 0, o = 0;
  if (i && a.origin != null) {
    if (typeof a.origin == "number")
      s = a.origin;
    else {
      var u = typeof a.origin == "string" ? fr(a.origin) : a.origin;
      s = u.r, o = u.c;
    }
    i["!ref"] || (i["!ref"] = "A1:A1");
  }
  var l = { s: { c: 1e7, r: 1e7 }, e: { c: 0, r: 0 } };
  if (i["!ref"]) {
    var c = Oe(i["!ref"]);
    l.s.c = c.s.c, l.s.r = c.s.r, l.e.c = Math.max(l.e.c, c.e.c), l.e.r = Math.max(l.e.r, c.e.r), s == -1 && (l.e.r = s = c.e.r + 1);
  }
  for (var f = 0; f != r.length; ++f)
    if (r[f]) {
      if (!Array.isArray(r[f]))
        throw new Error("aoa_to_sheet expects an array of arrays");
      for (var h = 0; h != r[f].length; ++h)
        if (!(typeof r[f][h] > "u")) {
          var d = { v: r[f][h] }, m = s + f, x = o + h;
          if (l.s.r > m && (l.s.r = m), l.s.c > x && (l.s.c = x), l.e.r < m && (l.e.r = m), l.e.c < x && (l.e.c = x), r[f][h] && typeof r[f][h] == "object" && !Array.isArray(r[f][h]) && !(r[f][h] instanceof Date))
            d = r[f][h];
          else if (Array.isArray(d.v) && (d.f = r[f][h][1], d.v = d.v[0]), d.v === null)
            if (d.f)
              d.t = "n";
            else if (a.nullError)
              d.t = "e", d.v = 0;
            else if (a.sheetStubs)
              d.t = "z";
            else
              continue;
          else
            typeof d.v == "number" ? d.t = "n" : typeof d.v == "boolean" ? d.t = "b" : d.v instanceof Date ? (d.z = a.dateNF || Ee[14], a.cellDates ? (d.t = "d", d.w = pt(d.z, Ar(d.v))) : (d.t = "n", d.v = Ar(d.v), d.w = pt(d.z, d.v))) : d.t = "s";
          if (n)
            i[m] || (i[m] = []), i[m][x] && i[m][x].z && (d.z = i[m][x].z), i[m][x] = d;
          else {
            var p = Te({ c: x, r: m });
            i[p] && i[p].z && (d.z = i[p].z), i[p] = d;
          }
        }
    }
  return l.s.c < 1e7 && (i["!ref"] = Ce(l)), i;
}
function mi(e, r) {
  return iv(null, e, r);
}
function k_(e) {
  return e.read_shift(4, "i");
}
function Lt(e, r) {
  return r || (r = te(4)), r.write_shift(4, e), r;
}
function Jr(e) {
  var r = e.read_shift(4);
  return r === 0 ? "" : e.read_shift(r, "dbcs");
}
function Lr(e, r) {
  var t = !1;
  return r == null && (t = !0, r = te(4 + 2 * e.length)), r.write_shift(4, e.length), e.length > 0 && r.write_shift(0, e, "dbcs"), t ? r.slice(0, r.l) : r;
}
function T_(e) {
  return { ich: e.read_shift(2), ifnt: e.read_shift(2) };
}
function S_(e, r) {
  return r || (r = te(4)), r.write_shift(2, 0), r.write_shift(2, 0), r;
}
function Pc(e, r) {
  var t = e.l, a = e.read_shift(1), n = Jr(e), i = [], s = { t: n, h: n };
  if (a & 1) {
    for (var o = e.read_shift(4), u = 0; u != o; ++u)
      i.push(T_(e));
    s.r = i;
  } else
    s.r = [{ ich: 0, ifnt: 0 }];
  return e.l = t + r, s;
}
function C_(e, r) {
  var t = !1;
  return r == null && (t = !0, r = te(15 + 4 * e.t.length)), r.write_shift(1, 0), Lr(e.t, r), t ? r.slice(0, r.l) : r;
}
var F_ = Pc;
function A_(e, r) {
  var t = !1;
  return r == null && (t = !0, r = te(23 + 4 * e.t.length)), r.write_shift(1, 1), Lr(e.t, r), r.write_shift(4, 1), S_({ ich: 0, ifnt: 0 }, r), t ? r.slice(0, r.l) : r;
}
function St(e) {
  var r = e.read_shift(4), t = e.read_shift(2);
  return t += e.read_shift(1) << 16, e.l++, { c: r, iStyleRef: t };
}
function gn(e, r) {
  return r == null && (r = te(8)), r.write_shift(-4, e.c), r.write_shift(3, e.iStyleRef || e.s), r.write_shift(1, 0), r;
}
function yn(e) {
  var r = e.read_shift(2);
  return r += e.read_shift(1) << 16, e.l++, { c: -1, iStyleRef: r };
}
function bn(e, r) {
  return r == null && (r = te(4)), r.write_shift(3, e.iStyleRef || e.s), r.write_shift(1, 0), r;
}
var R_ = Jr, sv = Lr;
function Mc(e) {
  var r = e.read_shift(4);
  return r === 0 || r === 4294967295 ? "" : e.read_shift(r, "dbcs");
}
function zo(e, r) {
  var t = !1;
  return r == null && (t = !0, r = te(127)), r.write_shift(4, e.length > 0 ? e.length : 4294967295), e.length > 0 && r.write_shift(0, e, "dbcs"), t ? r.slice(0, r.l) : r;
}
var I_ = Jr, bl = Mc, Oc = zo;
function Lc(e) {
  var r = e.slice(e.l, e.l + 4), t = r[0] & 1, a = r[0] & 2;
  e.l += 4;
  var n = a === 0 ? jo([0, 0, 0, 0, r[0] & 252, r[1], r[2], r[3]], 0) : Xa(r, 0) >> 2;
  return t ? n / 100 : n;
}
function ov(e, r) {
  r == null && (r = te(4));
  var t = 0, a = 0, n = e * 100;
  if (e == (e | 0) && e >= -(1 << 29) && e < 1 << 29 ? a = 1 : n == (n | 0) && n >= -(1 << 29) && n < 1 << 29 && (a = 1, t = 1), a)
    r.write_shift(-4, ((t ? n : e) << 2) + (t + 2));
  else
    throw new Error("unsupported RkNumber " + e);
}
function uv(e) {
  var r = { s: {}, e: {} };
  return r.s.r = e.read_shift(4), r.e.r = e.read_shift(4), r.s.c = e.read_shift(4), r.e.c = e.read_shift(4), r;
}
function B_(e, r) {
  return r || (r = te(16)), r.write_shift(4, e.s.r), r.write_shift(4, e.e.r), r.write_shift(4, e.s.c), r.write_shift(4, e.e.c), r;
}
var wn = uv, pi = B_;
function Xr(e) {
  if (e.length - e.l < 8)
    throw "XLS Xnum Buffer underflow";
  return e.read_shift(8, "f");
}
function dn(e, r) {
  return (r || te(8)).write_shift(8, e, "f");
}
function P_(e) {
  var r = {}, t = e.read_shift(1), a = t >>> 1, n = e.read_shift(1), i = e.read_shift(2, "i"), s = e.read_shift(1), o = e.read_shift(1), u = e.read_shift(1);
  switch (e.l++, a) {
    case 0:
      r.auto = 1;
      break;
    case 1:
      r.index = n;
      var l = Qa[n];
      l && (r.rgb = os(l));
      break;
    case 2:
      r.rgb = os([s, o, u]);
      break;
    case 3:
      r.theme = n;
      break;
  }
  return i != 0 && (r.tint = i > 0 ? i / 32767 : i / 32768), r;
}
function Go(e, r) {
  if (r || (r = te(8)), !e || e.auto)
    return r.write_shift(4, 0), r.write_shift(4, 0), r;
  e.index != null ? (r.write_shift(1, 2), r.write_shift(1, e.index)) : e.theme != null ? (r.write_shift(1, 6), r.write_shift(1, e.theme)) : (r.write_shift(1, 5), r.write_shift(1, 0));
  var t = e.tint || 0;
  if (t > 0 ? t *= 32767 : t < 0 && (t *= 32768), r.write_shift(2, t), !e.rgb || e.theme != null)
    r.write_shift(2, 0), r.write_shift(1, 0), r.write_shift(1, 0);
  else {
    var a = e.rgb || "FFFFFF";
    typeof a == "number" && (a = ("000000" + a.toString(16)).slice(-6)), r.write_shift(1, parseInt(a.slice(0, 2), 16)), r.write_shift(1, parseInt(a.slice(2, 4), 16)), r.write_shift(1, parseInt(a.slice(4, 6), 16)), r.write_shift(1, 255);
  }
  return r;
}
function M_(e) {
  var r = e.read_shift(1);
  e.l++;
  var t = {
    fBold: r & 1,
    fItalic: r & 2,
    fUnderline: r & 4,
    fStrikeout: r & 8,
    fOutline: r & 16,
    fShadow: r & 32,
    fCondense: r & 64,
    fExtend: r & 128
  };
  return t;
}
function O_(e, r) {
  r || (r = te(2));
  var t = (e.italic ? 2 : 0) | (e.strike ? 8 : 0) | (e.outline ? 16 : 0) | (e.shadow ? 32 : 0) | (e.condense ? 64 : 0) | (e.extend ? 128 : 0);
  return r.write_shift(1, t), r.write_shift(1, 0), r;
}
function lv(e, r) {
  var t = { 2: "BITMAP", 3: "METAFILEPICT", 8: "DIB", 14: "ENHMETAFILE" }, a = e.read_shift(4);
  switch (a) {
    case 0:
      return "";
    case 4294967295:
    case 4294967294:
      return t[e.read_shift(4)] || "";
  }
  if (a > 400)
    throw new Error("Unsupported Clipboard: " + a.toString(16));
  return e.l -= 4, e.read_shift(0, r == 1 ? "lpstr" : "lpwstr");
}
function L_(e) {
  return lv(e, 1);
}
function N_(e) {
  return lv(e, 2);
}
var Nc = 2, it = 3, eo = 11, Yd = 12, Ko = 19, ro = 64, U_ = 65, V_ = 71, W_ = 4108, H_ = 4126, Br = 80, cv = 81, j_ = [Br, cv], wl = {
  /*::[*/
  1: { n: "CodePage", t: Nc },
  /*::[*/
  2: { n: "Category", t: Br },
  /*::[*/
  3: { n: "PresentationFormat", t: Br },
  /*::[*/
  4: { n: "ByteCount", t: it },
  /*::[*/
  5: { n: "LineCount", t: it },
  /*::[*/
  6: { n: "ParagraphCount", t: it },
  /*::[*/
  7: { n: "SlideCount", t: it },
  /*::[*/
  8: { n: "NoteCount", t: it },
  /*::[*/
  9: { n: "HiddenCount", t: it },
  /*::[*/
  10: { n: "MultimediaClipCount", t: it },
  /*::[*/
  11: { n: "ScaleCrop", t: eo },
  /*::[*/
  12: {
    n: "HeadingPairs",
    t: W_
    /* VT_VECTOR | VT_VARIANT */
  },
  /*::[*/
  13: {
    n: "TitlesOfParts",
    t: H_
    /* VT_VECTOR | VT_LPSTR */
  },
  /*::[*/
  14: { n: "Manager", t: Br },
  /*::[*/
  15: { n: "Company", t: Br },
  /*::[*/
  16: { n: "LinksUpToDate", t: eo },
  /*::[*/
  17: { n: "CharacterCount", t: it },
  /*::[*/
  19: { n: "SharedDoc", t: eo },
  /*::[*/
  22: { n: "HyperlinksChanged", t: eo },
  /*::[*/
  23: { n: "AppVersion", t: it, p: "version" },
  /*::[*/
  24: { n: "DigSig", t: U_ },
  /*::[*/
  26: { n: "ContentType", t: Br },
  /*::[*/
  27: { n: "ContentStatus", t: Br },
  /*::[*/
  28: { n: "Language", t: Br },
  /*::[*/
  29: { n: "Version", t: Br },
  /*::[*/
  255: {},
  /* [MS-OLEPS] 2.18 */
  /*::[*/
  2147483648: { n: "Locale", t: Ko },
  /*::[*/
  2147483651: { n: "Behavior", t: Ko },
  /*::[*/
  1919054434: {}
}, _l = {
  /*::[*/
  1: { n: "CodePage", t: Nc },
  /*::[*/
  2: { n: "Title", t: Br },
  /*::[*/
  3: { n: "Subject", t: Br },
  /*::[*/
  4: { n: "Author", t: Br },
  /*::[*/
  5: { n: "Keywords", t: Br },
  /*::[*/
  6: { n: "Comments", t: Br },
  /*::[*/
  7: { n: "Template", t: Br },
  /*::[*/
  8: { n: "LastAuthor", t: Br },
  /*::[*/
  9: { n: "RevNumber", t: Br },
  /*::[*/
  10: { n: "EditTime", t: ro },
  /*::[*/
  11: { n: "LastPrinted", t: ro },
  /*::[*/
  12: { n: "CreatedDate", t: ro },
  /*::[*/
  13: { n: "ModifiedDate", t: ro },
  /*::[*/
  14: { n: "PageCount", t: it },
  /*::[*/
  15: { n: "WordCount", t: it },
  /*::[*/
  16: { n: "CharCount", t: it },
  /*::[*/
  17: { n: "Thumbnail", t: V_ },
  /*::[*/
  18: { n: "Application", t: Br },
  /*::[*/
  19: { n: "DocSecurity", t: it },
  /*::[*/
  255: {},
  /* [MS-OLEPS] 2.18 */
  /*::[*/
  2147483648: { n: "Locale", t: Ko },
  /*::[*/
  2147483651: { n: "Behavior", t: Ko },
  /*::[*/
  1919054434: {}
}, Xd = {
  /*::[*/
  1: "US",
  // United States
  /*::[*/
  2: "CA",
  // Canada
  /*::[*/
  3: "",
  // Latin America (except Brazil)
  /*::[*/
  7: "RU",
  // Russia
  /*::[*/
  20: "EG",
  // Egypt
  /*::[*/
  30: "GR",
  // Greece
  /*::[*/
  31: "NL",
  // Netherlands
  /*::[*/
  32: "BE",
  // Belgium
  /*::[*/
  33: "FR",
  // France
  /*::[*/
  34: "ES",
  // Spain
  /*::[*/
  36: "HU",
  // Hungary
  /*::[*/
  39: "IT",
  // Italy
  /*::[*/
  41: "CH",
  // Switzerland
  /*::[*/
  43: "AT",
  // Austria
  /*::[*/
  44: "GB",
  // United Kingdom
  /*::[*/
  45: "DK",
  // Denmark
  /*::[*/
  46: "SE",
  // Sweden
  /*::[*/
  47: "NO",
  // Norway
  /*::[*/
  48: "PL",
  // Poland
  /*::[*/
  49: "DE",
  // Germany
  /*::[*/
  52: "MX",
  // Mexico
  /*::[*/
  55: "BR",
  // Brazil
  /*::[*/
  61: "AU",
  // Australia
  /*::[*/
  64: "NZ",
  // New Zealand
  /*::[*/
  66: "TH",
  // Thailand
  /*::[*/
  81: "JP",
  // Japan
  /*::[*/
  82: "KR",
  // Korea
  /*::[*/
  84: "VN",
  // Viet Nam
  /*::[*/
  86: "CN",
  // China
  /*::[*/
  90: "TR",
  // Turkey
  /*::[*/
  105: "JS",
  // Ramastan
  /*::[*/
  213: "DZ",
  // Algeria
  /*::[*/
  216: "MA",
  // Morocco
  /*::[*/
  218: "LY",
  // Libya
  /*::[*/
  351: "PT",
  // Portugal
  /*::[*/
  354: "IS",
  // Iceland
  /*::[*/
  358: "FI",
  // Finland
  /*::[*/
  420: "CZ",
  // Czech Republic
  /*::[*/
  886: "TW",
  // Taiwan
  /*::[*/
  961: "LB",
  // Lebanon
  /*::[*/
  962: "JO",
  // Jordan
  /*::[*/
  963: "SY",
  // Syria
  /*::[*/
  964: "IQ",
  // Iraq
  /*::[*/
  965: "KW",
  // Kuwait
  /*::[*/
  966: "SA",
  // Saudi Arabia
  /*::[*/
  971: "AE",
  // United Arab Emirates
  /*::[*/
  972: "IL",
  // Israel
  /*::[*/
  974: "QA",
  // Qatar
  /*::[*/
  981: "IR",
  // Iran
  /*::[*/
  65535: "US"
  // United States
}, z_ = [
  null,
  "solid",
  "mediumGray",
  "darkGray",
  "lightGray",
  "darkHorizontal",
  "darkVertical",
  "darkDown",
  "darkUp",
  "darkGrid",
  "darkTrellis",
  "lightHorizontal",
  "lightVertical",
  "lightDown",
  "lightUp",
  "lightGrid",
  "lightTrellis",
  "gray125",
  "gray0625"
];
function G_(e) {
  return e.map(function(r) {
    return [r >> 16 & 255, r >> 8 & 255, r & 255];
  });
}
var K_ = /* @__PURE__ */ G_([
  /* Color Constants */
  0,
  16777215,
  16711680,
  65280,
  255,
  16776960,
  16711935,
  65535,
  /* Overridable Defaults */
  0,
  16777215,
  16711680,
  65280,
  255,
  16776960,
  16711935,
  65535,
  8388608,
  32768,
  128,
  8421376,
  8388736,
  32896,
  12632256,
  8421504,
  10066431,
  10040166,
  16777164,
  13434879,
  6684774,
  16744576,
  26316,
  13421823,
  128,
  16711935,
  16776960,
  65535,
  8388736,
  8388608,
  32896,
  255,
  52479,
  13434879,
  13434828,
  16777113,
  10079487,
  16751052,
  13408767,
  16764057,
  3368703,
  3394764,
  10079232,
  16763904,
  16750848,
  16737792,
  6710937,
  9868950,
  13158,
  3381606,
  13056,
  3355392,
  10040064,
  10040166,
  3355545,
  3355443,
  /* Other entries to appease BIFF8/12 */
  16777215,
  /* 0x40 icvForeground ?? */
  0,
  /* 0x41 icvBackground ?? */
  0,
  /* 0x42 icvFrame ?? */
  0,
  /* 0x43 icv3D ?? */
  0,
  /* 0x44 icv3DText ?? */
  0,
  /* 0x45 icv3DHilite ?? */
  0,
  /* 0x46 icv3DShadow ?? */
  0,
  /* 0x47 icvHilite ?? */
  0,
  /* 0x48 icvCtlText ?? */
  0,
  /* 0x49 icvCtlScrl ?? */
  0,
  /* 0x4A icvCtlInv ?? */
  0,
  /* 0x4B icvCtlBody ?? */
  0,
  /* 0x4C icvCtlFrame ?? */
  0,
  /* 0x4D icvCtlFore ?? */
  0,
  /* 0x4E icvCtlBack ?? */
  0,
  /* 0x4F icvCtlNeutral */
  0,
  /* 0x50 icvInfoBk ?? */
  0
  /* 0x51 icvInfoText ?? */
]), Qa = /* @__PURE__ */ tr(K_), pa = {
  /*::[*/
  0: "#NULL!",
  /*::[*/
  7: "#DIV/0!",
  /*::[*/
  15: "#VALUE!",
  /*::[*/
  23: "#REF!",
  /*::[*/
  29: "#NAME?",
  /*::[*/
  36: "#NUM!",
  /*::[*/
  42: "#N/A",
  /*::[*/
  43: "#GETTING_DATA",
  /*::[*/
  255: "#WTF?"
}, fv = {
  "#NULL!": 0,
  "#DIV/0!": 7,
  "#VALUE!": 15,
  "#REF!": 23,
  "#NAME?": 29,
  "#NUM!": 36,
  "#N/A": 42,
  "#GETTING_DATA": 43,
  "#WTF?": 255
}, $l = {
  /* Workbook */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": "workbooks",
  "application/vnd.ms-excel.sheet.macroEnabled.main+xml": "workbooks",
  "application/vnd.ms-excel.sheet.binary.macroEnabled.main": "workbooks",
  "application/vnd.ms-excel.addin.macroEnabled.main+xml": "workbooks",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml": "workbooks",
  /* Worksheet */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml": "sheets",
  "application/vnd.ms-excel.worksheet": "sheets",
  "application/vnd.ms-excel.binIndexWs": "TODO",
  /* Binary Index */
  /* Chartsheet */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml": "charts",
  "application/vnd.ms-excel.chartsheet": "charts",
  /* Macrosheet */
  "application/vnd.ms-excel.macrosheet+xml": "macros",
  "application/vnd.ms-excel.macrosheet": "macros",
  "application/vnd.ms-excel.intlmacrosheet": "TODO",
  "application/vnd.ms-excel.binIndexMs": "TODO",
  /* Binary Index */
  /* Dialogsheet */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml": "dialogs",
  "application/vnd.ms-excel.dialogsheet": "dialogs",
  /* Shared Strings */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml": "strs",
  "application/vnd.ms-excel.sharedStrings": "strs",
  /* Styles */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml": "styles",
  "application/vnd.ms-excel.styles": "styles",
  /* File Properties */
  "application/vnd.openxmlformats-package.core-properties+xml": "coreprops",
  "application/vnd.openxmlformats-officedocument.custom-properties+xml": "custprops",
  "application/vnd.openxmlformats-officedocument.extended-properties+xml": "extprops",
  /* Custom Data Properties */
  "application/vnd.openxmlformats-officedocument.customXmlProperties+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty": "TODO",
  /* Comments */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml": "comments",
  "application/vnd.ms-excel.comments": "comments",
  "application/vnd.ms-excel.threadedcomments+xml": "threadedcomments",
  "application/vnd.ms-excel.person+xml": "people",
  /* Metadata (Stock/Geography and Dynamic Array) */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml": "metadata",
  "application/vnd.ms-excel.sheetMetadata": "metadata",
  /* PivotTable */
  "application/vnd.ms-excel.pivotTable": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml": "TODO",
  /* Chart Objects */
  "application/vnd.openxmlformats-officedocument.drawingml.chart+xml": "TODO",
  /* Chart Colors */
  "application/vnd.ms-office.chartcolorstyle+xml": "TODO",
  /* Chart Style */
  "application/vnd.ms-office.chartstyle+xml": "TODO",
  /* Chart Advanced */
  "application/vnd.ms-office.chartex+xml": "TODO",
  /* Calculation Chain */
  "application/vnd.ms-excel.calcChain": "calcchains",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml": "calcchains",
  /* Printer Settings */
  "application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings": "TODO",
  /* ActiveX */
  "application/vnd.ms-office.activeX": "TODO",
  "application/vnd.ms-office.activeX+xml": "TODO",
  /* Custom Toolbars */
  "application/vnd.ms-excel.attachedToolbars": "TODO",
  /* External Data Connections */
  "application/vnd.ms-excel.connections": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": "TODO",
  /* External Links */
  "application/vnd.ms-excel.externalLink": "links",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml": "links",
  /* PivotCache */
  "application/vnd.ms-excel.pivotCacheDefinition": "TODO",
  "application/vnd.ms-excel.pivotCacheRecords": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml": "TODO",
  /* Query Table */
  "application/vnd.ms-excel.queryTable": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml": "TODO",
  /* Shared Workbook */
  "application/vnd.ms-excel.userNames": "TODO",
  "application/vnd.ms-excel.revisionHeaders": "TODO",
  "application/vnd.ms-excel.revisionLog": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml": "TODO",
  /* Single Cell Table */
  "application/vnd.ms-excel.tableSingleCells": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml": "TODO",
  /* Slicer */
  "application/vnd.ms-excel.slicer": "TODO",
  "application/vnd.ms-excel.slicerCache": "TODO",
  "application/vnd.ms-excel.slicer+xml": "TODO",
  "application/vnd.ms-excel.slicerCache+xml": "TODO",
  /* Sort Map */
  "application/vnd.ms-excel.wsSortMap": "TODO",
  /* Table */
  "application/vnd.ms-excel.table": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": "TODO",
  /* Themes */
  "application/vnd.openxmlformats-officedocument.theme+xml": "themes",
  /* Theme Override */
  "application/vnd.openxmlformats-officedocument.themeOverride+xml": "TODO",
  /* Timeline */
  "application/vnd.ms-excel.Timeline+xml": "TODO",
  /* verify */
  "application/vnd.ms-excel.TimelineCache+xml": "TODO",
  /* verify */
  /* VBA */
  "application/vnd.ms-office.vbaProject": "vba",
  "application/vnd.ms-office.vbaProjectSignature": "TODO",
  /* Volatile Dependencies */
  "application/vnd.ms-office.volatileDependencies": "TODO",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml": "TODO",
  /* Control Properties */
  "application/vnd.ms-excel.controlproperties+xml": "TODO",
  /* Data Model */
  "application/vnd.openxmlformats-officedocument.model+data": "TODO",
  /* Survey */
  "application/vnd.ms-excel.Survey+xml": "TODO",
  /* Drawing */
  "application/vnd.openxmlformats-officedocument.drawing+xml": "drawings",
  "application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml": "TODO",
  "application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml": "TODO",
  /* VML */
  "application/vnd.openxmlformats-officedocument.vmlDrawing": "TODO",
  "application/vnd.openxmlformats-package.relationships+xml": "rels",
  "application/vnd.openxmlformats-officedocument.oleObject": "TODO",
  /* Image */
  "image/png": "TODO",
  sheet: "js"
}, to = {
  workbooks: {
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",
    xlsm: "application/vnd.ms-excel.sheet.macroEnabled.main+xml",
    xlsb: "application/vnd.ms-excel.sheet.binary.macroEnabled.main",
    xlam: "application/vnd.ms-excel.addin.macroEnabled.main+xml",
    xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml"
  },
  strs: {
    /* Shared Strings */
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",
    xlsb: "application/vnd.ms-excel.sharedStrings"
  },
  comments: {
    /* Comments */
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml",
    xlsb: "application/vnd.ms-excel.comments"
  },
  sheets: {
    /* Worksheet */
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",
    xlsb: "application/vnd.ms-excel.worksheet"
  },
  charts: {
    /* Chartsheet */
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml",
    xlsb: "application/vnd.ms-excel.chartsheet"
  },
  dialogs: {
    /* Dialogsheet */
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml",
    xlsb: "application/vnd.ms-excel.dialogsheet"
  },
  macros: {
    /* Macrosheet (Excel 4.0 Macros) */
    xlsx: "application/vnd.ms-excel.macrosheet+xml",
    xlsb: "application/vnd.ms-excel.macrosheet"
  },
  metadata: {
    /* Metadata (Stock/Geography and Dynamic Array) */
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml",
    xlsb: "application/vnd.ms-excel.sheetMetadata"
  },
  styles: {
    /* Styles */
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",
    xlsb: "application/vnd.ms-excel.styles"
  }
};
function Uc() {
  return {
    workbooks: [],
    sheets: [],
    charts: [],
    dialogs: [],
    macros: [],
    rels: [],
    strs: [],
    comments: [],
    threadedcomments: [],
    links: [],
    coreprops: [],
    extprops: [],
    custprops: [],
    themes: [],
    styles: [],
    calcchains: [],
    vba: [],
    drawings: [],
    metadata: [],
    people: [],
    TODO: [],
    xmlns: ""
  };
}
function Y_(e) {
  var r = Uc();
  if (!e || !e.match)
    return r;
  var t = {};
  if ((e.match(Qr) || []).forEach(function(a) {
    var n = Se(a);
    switch (n[0].replace(n_, "<")) {
      case "<?xml":
        break;
      case "<Types":
        r.xmlns = n["xmlns" + (n[0].match(/<(\w+):/) || ["", ""])[1]];
        break;
      case "<Default":
        t[n.Extension] = n.ContentType;
        break;
      case "<Override":
        r[$l[n.ContentType]] !== void 0 && r[$l[n.ContentType]].push(n.PartName);
        break;
    }
  }), r.xmlns !== Fr.CT)
    throw new Error("Unknown Namespace: " + r.xmlns);
  return r.calcchain = r.calcchains.length > 0 ? r.calcchains[0] : "", r.sst = r.strs.length > 0 ? r.strs[0] : "", r.style = r.styles.length > 0 ? r.styles[0] : "", r.defaults = t, delete r.calcchains, r;
}
function dv(e, r) {
  var t = Y5($l), a = [], n;
  a[a.length] = $r, a[a.length] = he("Types", null, {
    xmlns: Fr.CT,
    "xmlns:xsd": Fr.xsd,
    "xmlns:xsi": Fr.xsi
  }), a = a.concat([
    ["xml", "application/xml"],
    ["bin", "application/vnd.ms-excel.sheet.binary.macroEnabled.main"],
    ["vml", "application/vnd.openxmlformats-officedocument.vmlDrawing"],
    ["data", "application/vnd.openxmlformats-officedocument.model+data"],
    /* from test files */
    ["bmp", "image/bmp"],
    ["png", "image/png"],
    ["gif", "image/gif"],
    ["emf", "image/x-emf"],
    ["wmf", "image/x-wmf"],
    ["jpg", "image/jpeg"],
    ["jpeg", "image/jpeg"],
    ["tif", "image/tiff"],
    ["tiff", "image/tiff"],
    ["pdf", "application/pdf"],
    ["rels", "application/vnd.openxmlformats-package.relationships+xml"]
  ].map(function(u) {
    return he("Default", null, { Extension: u[0], ContentType: u[1] });
  }));
  var i = function(u) {
    e[u] && e[u].length > 0 && (n = e[u][0], a[a.length] = he("Override", null, {
      PartName: (n[0] == "/" ? "" : "/") + n,
      ContentType: to[u][r.bookType] || to[u].xlsx
    }));
  }, s = function(u) {
    (e[u] || []).forEach(function(l) {
      a[a.length] = he("Override", null, {
        PartName: (l[0] == "/" ? "" : "/") + l,
        ContentType: to[u][r.bookType] || to[u].xlsx
      });
    });
  }, o = function(u) {
    (e[u] || []).forEach(function(l) {
      a[a.length] = he("Override", null, {
        PartName: (l[0] == "/" ? "" : "/") + l,
        ContentType: t[u][0]
      });
    });
  };
  return i("workbooks"), s("sheets"), s("charts"), o("themes"), ["strs", "styles"].forEach(i), ["coreprops", "extprops", "custprops"].forEach(o), o("vba"), o("comments"), o("threadedcomments"), o("drawings"), s("metadata"), o("people"), a.length > 2 && (a[a.length] = "</Types>", a[1] = a[1].replace("/>", ">")), a.join("");
}
var Be = {
  WB: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
  SHEET: "http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
  HLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
  VML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
  XPATH: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLinkPath",
  XMISS: "http://schemas.microsoft.com/office/2006/relationships/xlExternalLinkPath/xlPathMissing",
  XLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLink",
  CXML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml",
  CXMLP: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXmlProps",
  CMNT: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments",
  CORE_PROPS: "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties",
  EXT_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties",
  CUST_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties",
  SST: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings",
  STY: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",
  THEME: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",
  CHART: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chart",
  CHARTEX: "http://schemas.microsoft.com/office/2014/relationships/chartEx",
  CS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet",
  WS: [
    "http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
    "http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"
  ],
  DS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet",
  MS: "http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet",
  IMG: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
  DRAW: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing",
  XLMETA: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sheetMetadata",
  TCMNT: "http://schemas.microsoft.com/office/2017/10/relationships/threadedComment",
  PEOPLE: "http://schemas.microsoft.com/office/2017/10/relationships/person",
  VBA: "http://schemas.microsoft.com/office/2006/relationships/vbaProject"
};
function ss(e) {
  var r = e.lastIndexOf("/");
  return e.slice(0, r + 1) + "_rels/" + e.slice(r + 1) + ".rels";
}
function Wi(e, r) {
  var t = { "!id": {} };
  if (!e)
    return t;
  r.charAt(0) !== "/" && (r = "/" + r);
  var a = {};
  return (e.match(Qr) || []).forEach(function(n) {
    var i = Se(n);
    if (i[0] === "<Relationship") {
      var s = {};
      s.Type = i.Type, s.Target = i.Target, s.Id = i.Id, i.TargetMode && (s.TargetMode = i.TargetMode);
      var o = i.TargetMode === "External" ? i.Target : Mi(i.Target, r);
      t[o] = s, a[i.Id] = s;
    }
  }), t["!id"] = a, t;
}
function Gn(e) {
  var r = [$r, he("Relationships", null, {
    //'xmlns:ns0': XMLNS.RELS,
    xmlns: Fr.RELS
  })];
  return br(e["!id"]).forEach(function(t) {
    r[r.length] = he("Relationship", null, e["!id"][t]);
  }), r.length > 2 && (r[r.length] = "</Relationships>", r[1] = r[1].replace("/>", ">")), r.join("");
}
function Ye(e, r, t, a, n, i) {
  if (n || (n = {}), e["!id"] || (e["!id"] = {}), e["!idx"] || (e["!idx"] = 1), r < 0)
    for (r = e["!idx"]; e["!id"]["rId" + r]; ++r)
      ;
  if (e["!idx"] = r + 1, n.Id = "rId" + r, n.Type = a, n.Target = t, [Be.HLINK, Be.XPATH, Be.XMISS].indexOf(n.Type) > -1 && (n.TargetMode = "External"), e["!id"][n.Id])
    throw new Error("Cannot rewrite rId " + r);
  return e["!id"][n.Id] = n, e[("/" + n.Target).replace("//", "/")] = n, r;
}
var X_ = "application/vnd.oasis.opendocument.spreadsheet";
function Z_(e, r) {
  for (var t = kc(e), a, n; a = is.exec(t); )
    switch (a[3]) {
      case "manifest":
        break;
      case "file-entry":
        if (n = Se(a[0], !1), n.path == "/" && n.type !== X_)
          throw new Error("This OpenDocument is not a spreadsheet");
        break;
      case "encryption-data":
      case "algorithm":
      case "start-key-generation":
      case "key-derivation":
        throw new Error("Unsupported ODS Encryption");
      default:
        if (r && r.WTF)
          throw a;
    }
}
function J_(e) {
  var r = [$r];
  r.push(`<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0" manifest:version="1.2">
`), r.push(`  <manifest:file-entry manifest:full-path="/" manifest:version="1.2" manifest:media-type="application/vnd.oasis.opendocument.spreadsheet"/>
`);
  for (var t = 0; t < e.length; ++t)
    r.push('  <manifest:file-entry manifest:full-path="' + e[t][0] + '" manifest:media-type="' + e[t][1] + `"/>
`);
  return r.push("</manifest:manifest>"), r.join("");
}
function Zd(e, r, t) {
  return [
    '  <rdf:Description rdf:about="' + e + `">
`,
    '    <rdf:type rdf:resource="http://docs.oasis-open.org/ns/office/1.2/meta/' + (t || "odf") + "#" + r + `"/>
`,
    `  </rdf:Description>
`
  ].join("");
}
function q_(e, r) {
  return [
    '  <rdf:Description rdf:about="' + e + `">
`,
    '    <ns0:hasPart xmlns:ns0="http://docs.oasis-open.org/ns/office/1.2/meta/pkg#" rdf:resource="' + r + `"/>
`,
    `  </rdf:Description>
`
  ].join("");
}
function Q_(e) {
  var r = [$r];
  r.push(`<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">
`);
  for (var t = 0; t != e.length; ++t)
    r.push(Zd(e[t][0], e[t][1])), r.push(q_("", e[t][0]));
  return r.push(Zd("", "Document", "pkg")), r.push("</rdf:RDF>"), r.join("");
}
function hv() {
  return '<office:document-meta xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:meta="urn:oasis:names:tc:opendocument:xmlns:meta:1.0" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xlink="http://www.w3.org/1999/xlink" office:version="1.2"><office:meta><meta:generator>SheetJS ' + es.version + "</meta:generator></office:meta></office:document-meta>";
}
var Tt = [
  ["cp:category", "Category"],
  ["cp:contentStatus", "ContentStatus"],
  ["cp:keywords", "Keywords"],
  ["cp:lastModifiedBy", "LastAuthor"],
  ["cp:lastPrinted", "LastPrinted"],
  ["cp:revision", "RevNumber"],
  ["cp:version", "Version"],
  ["dc:creator", "Author"],
  ["dc:description", "Comments"],
  ["dc:identifier", "Identifier"],
  ["dc:language", "Language"],
  ["dc:subject", "Subject"],
  ["dc:title", "Title"],
  ["dcterms:created", "CreatedDate", "date"],
  ["dcterms:modified", "ModifiedDate", "date"]
], e6 = /* @__PURE__ */ function() {
  for (var e = new Array(Tt.length), r = 0; r < Tt.length; ++r) {
    var t = Tt[r], a = "(?:" + t[0].slice(0, t[0].indexOf(":")) + ":)" + t[0].slice(t[0].indexOf(":") + 1);
    e[r] = new RegExp("<" + a + "[^>]*>([\\s\\S]*?)</" + a + ">");
  }
  return e;
}();
function xv(e) {
  var r = {};
  e = Qe(e);
  for (var t = 0; t < Tt.length; ++t) {
    var a = Tt[t], n = e.match(e6[t]);
    n != null && n.length > 0 && (r[a[1]] = We(n[1])), a[2] === "date" && r[a[1]] && (r[a[1]] = ur(r[a[1]]));
  }
  return r;
}
function du(e, r, t, a, n) {
  n[e] != null || r == null || r === "" || (n[e] = r, r = Xe(r), a[a.length] = t ? he(e, r, t) : Wr(e, r));
}
function mv(e, r) {
  var t = r || {}, a = [$r, he("cp:coreProperties", null, {
    //'xmlns': XMLNS.CORE_PROPS,
    "xmlns:cp": Fr.CORE_PROPS,
    "xmlns:dc": Fr.dc,
    "xmlns:dcterms": Fr.dcterms,
    "xmlns:dcmitype": Fr.dcmitype,
    "xmlns:xsi": Fr.xsi
  })], n = {};
  if (!e && !t.Props)
    return a.join("");
  e && (e.CreatedDate != null && du("dcterms:created", typeof e.CreatedDate == "string" ? e.CreatedDate : yl(e.CreatedDate, t.WTF), { "xsi:type": "dcterms:W3CDTF" }, a, n), e.ModifiedDate != null && du("dcterms:modified", typeof e.ModifiedDate == "string" ? e.ModifiedDate : yl(e.ModifiedDate, t.WTF), { "xsi:type": "dcterms:W3CDTF" }, a, n));
  for (var i = 0; i != Tt.length; ++i) {
    var s = Tt[i], o = t.Props && t.Props[s[1]] != null ? t.Props[s[1]] : e ? e[s[1]] : null;
    o === !0 ? o = "1" : o === !1 ? o = "0" : typeof o == "number" && (o = String(o)), o != null && du(s[0], o, null, a, n);
  }
  return a.length > 2 && (a[a.length] = "</cp:coreProperties>", a[1] = a[1].replace("/>", ">")), a.join("");
}
var en = [
  ["Application", "Application", "string"],
  ["AppVersion", "AppVersion", "string"],
  ["Company", "Company", "string"],
  ["DocSecurity", "DocSecurity", "string"],
  ["Manager", "Manager", "string"],
  ["HyperlinksChanged", "HyperlinksChanged", "bool"],
  ["SharedDoc", "SharedDoc", "bool"],
  ["LinksUpToDate", "LinksUpToDate", "bool"],
  ["ScaleCrop", "ScaleCrop", "bool"],
  ["HeadingPairs", "HeadingPairs", "raw"],
  ["TitlesOfParts", "TitlesOfParts", "raw"]
], pv = [
  "Worksheets",
  "SheetNames",
  "NamedRanges",
  "DefinedNames",
  "Chartsheets",
  "ChartNames"
];
function vv(e, r, t, a) {
  var n = [];
  if (typeof e == "string")
    n = Ud(e, a);
  else
    for (var i = 0; i < e.length; ++i)
      n = n.concat(e[i].map(function(c) {
        return { v: c };
      }));
  var s = typeof r == "string" ? Ud(r, a).map(function(c) {
    return c.v;
  }) : r, o = 0, u = 0;
  if (s.length > 0)
    for (var l = 0; l !== n.length; l += 2) {
      switch (u = +n[l + 1].v, n[l].v) {
        case "Worksheets":
        case "工作表":
        case "Листы":
        case "أوراق العمل":
        case "ワークシート":
        case "גליונות עבודה":
        case "Arbeitsblätter":
        case "Çalışma Sayfaları":
        case "Feuilles de calcul":
        case "Fogli di lavoro":
        case "Folhas de cálculo":
        case "Planilhas":
        case "Regneark":
        case "Hojas de cálculo":
        case "Werkbladen":
          t.Worksheets = u, t.SheetNames = s.slice(o, o + u);
          break;
        case "Named Ranges":
        case "Rangos con nombre":
        case "名前付き一覧":
        case "Benannte Bereiche":
        case "Navngivne områder":
          t.NamedRanges = u, t.DefinedNames = s.slice(o, o + u);
          break;
        case "Charts":
        case "Diagramme":
          t.Chartsheets = u, t.ChartNames = s.slice(o, o + u);
          break;
      }
      o += u;
    }
}
function r6(e, r, t) {
  var a = {};
  return r || (r = {}), e = Qe(e), en.forEach(function(n) {
    var i = (e.match(as(n[0])) || [])[1];
    switch (n[2]) {
      case "string":
        i && (r[n[1]] = We(i));
        break;
      case "bool":
        r[n[1]] = i === "true";
        break;
      case "raw":
        var s = e.match(new RegExp("<" + n[0] + "[^>]*>([\\s\\S]*?)</" + n[0] + ">"));
        s && s.length > 0 && (a[n[1]] = s[1]);
        break;
    }
  }), a.HeadingPairs && a.TitlesOfParts && vv(a.HeadingPairs, a.TitlesOfParts, r, t), r;
}
function gv(e) {
  var r = [], t = he;
  return e || (e = {}), e.Application = "SheetJS", r[r.length] = $r, r[r.length] = he("Properties", null, {
    xmlns: Fr.EXT_PROPS,
    "xmlns:vt": Fr.vt
  }), en.forEach(function(a) {
    if (e[a[1]] !== void 0) {
      var n;
      switch (a[2]) {
        case "string":
          n = Xe(String(e[a[1]]));
          break;
        case "bool":
          n = e[a[1]] ? "true" : "false";
          break;
      }
      n !== void 0 && (r[r.length] = t(a[0], n));
    }
  }), r[r.length] = t("HeadingPairs", t("vt:vector", t("vt:variant", "<vt:lpstr>Worksheets</vt:lpstr>") + t("vt:variant", t("vt:i4", String(e.Worksheets))), { size: 2, baseType: "variant" })), r[r.length] = t("TitlesOfParts", t("vt:vector", e.SheetNames.map(function(a) {
    return "<vt:lpstr>" + Xe(a) + "</vt:lpstr>";
  }).join(""), { size: e.Worksheets, baseType: "lpstr" })), r.length > 2 && (r[r.length] = "</Properties>", r[1] = r[1].replace("/>", ">")), r.join("");
}
var t6 = /<[^>]+>[^<]*/g;
function a6(e, r) {
  var t = {}, a = "", n = e.match(t6);
  if (n)
    for (var i = 0; i != n.length; ++i) {
      var s = n[i], o = Se(s);
      switch (o[0]) {
        case "<?xml":
          break;
        case "<Properties":
          break;
        case "<property":
          a = We(o.name);
          break;
        case "</property>":
          a = null;
          break;
        default:
          if (s.indexOf("<vt:") === 0) {
            var u = s.split(">"), l = u[0].slice(4), c = u[1];
            switch (l) {
              case "lpstr":
              case "bstr":
              case "lpwstr":
                t[a] = We(c);
                break;
              case "bool":
                t[a] = sr(c);
                break;
              case "i1":
              case "i2":
              case "i4":
              case "i8":
              case "int":
              case "uint":
                t[a] = parseInt(c, 10);
                break;
              case "r4":
              case "r8":
              case "decimal":
                t[a] = parseFloat(c);
                break;
              case "filetime":
              case "date":
                t[a] = ur(c);
                break;
              case "cy":
              case "error":
                t[a] = We(c);
                break;
              default:
                if (l.slice(-1) == "/")
                  break;
                r.WTF && typeof console < "u" && console.warn("Unexpected", s, l, u);
            }
          } else if (s.slice(0, 2) !== "</") {
            if (r.WTF)
              throw new Error(s);
          }
      }
    }
  return t;
}
function yv(e) {
  var r = [$r, he("Properties", null, {
    xmlns: Fr.CUST_PROPS,
    "xmlns:vt": Fr.vt
  })];
  if (!e)
    return r.join("");
  var t = 1;
  return br(e).forEach(function(n) {
    ++t, r[r.length] = he("property", d_(e[n]), {
      fmtid: "{D5CDD505-2E9C-101B-9397-08002B2CF9AE}",
      pid: t,
      name: Xe(n)
    });
  }), r.length > 2 && (r[r.length] = "</Properties>", r[1] = r[1].replace("/>", ">")), r.join("");
}
var Dl = {
  Title: "Title",
  Subject: "Subject",
  Author: "Author",
  Keywords: "Keywords",
  Comments: "Description",
  LastAuthor: "LastAuthor",
  RevNumber: "Revision",
  Application: "AppName",
  /* TotalTime: 'TotalTime', */
  LastPrinted: "LastPrinted",
  CreatedDate: "Created",
  ModifiedDate: "LastSaved",
  /* Pages */
  /* Words */
  /* Characters */
  Category: "Category",
  /* PresentationFormat */
  Manager: "Manager",
  Company: "Company",
  /* Guid */
  /* HyperlinkBase */
  /* Bytes */
  /* Lines */
  /* Paragraphs */
  /* CharactersWithSpaces */
  AppVersion: "Version",
  ContentStatus: "ContentStatus",
  /* NOTE: missing from schema */
  Identifier: "Identifier",
  /* NOTE: missing from schema */
  Language: "Language"
  /* NOTE: missing from schema */
}, hu;
function n6(e, r, t) {
  hu || (hu = m0(Dl)), r = hu[r] || r, e[r] = t;
}
function i6(e, r) {
  var t = [];
  return br(Dl).map(function(a) {
    for (var n = 0; n < Tt.length; ++n)
      if (Tt[n][1] == a)
        return Tt[n];
    for (n = 0; n < en.length; ++n)
      if (en[n][1] == a)
        return en[n];
    throw a;
  }).forEach(function(a) {
    if (e[a[1]] != null) {
      var n = r && r.Props && r.Props[a[1]] != null ? r.Props[a[1]] : e[a[1]];
      switch (a[2]) {
        case "date":
          n = new Date(n).toISOString().replace(/\.\d*Z/, "Z");
          break;
      }
      typeof n == "number" ? n = String(n) : n === !0 || n === !1 ? n = n ? "1" : "0" : n instanceof Date && (n = new Date(n).toISOString().replace(/\.\d*Z/, "")), t.push(Wr(Dl[a[1]] || a[1], n));
    }
  }), he("DocumentProperties", t.join(""), { xmlns: ft.o });
}
function s6(e, r) {
  var t = ["Worksheets", "SheetNames"], a = "CustomDocumentProperties", n = [];
  return e && br(e).forEach(function(i) {
    if (Object.prototype.hasOwnProperty.call(e, i)) {
      for (var s = 0; s < Tt.length; ++s)
        if (i == Tt[s][1])
          return;
      for (s = 0; s < en.length; ++s)
        if (i == en[s][1])
          return;
      for (s = 0; s < t.length; ++s)
        if (i == t[s])
          return;
      var o = e[i], u = "string";
      typeof o == "number" ? (u = "float", o = String(o)) : o === !0 || o === !1 ? (u = "boolean", o = o ? "1" : "0") : o = String(o), n.push(he(Md(i), o, { "dt:dt": u }));
    }
  }), r && br(r).forEach(function(i) {
    if (Object.prototype.hasOwnProperty.call(r, i) && !(e && Object.prototype.hasOwnProperty.call(e, i))) {
      var s = r[i], o = "string";
      typeof s == "number" ? (o = "float", s = String(s)) : s === !0 || s === !1 ? (o = "boolean", s = s ? "1" : "0") : s instanceof Date ? (o = "dateTime.tz", s = s.toISOString()) : s = String(s), n.push(he(Md(i), s, { "dt:dt": o }));
    }
  }), "<" + a + ' xmlns="' + ft.o + '">' + n.join("") + "</" + a + ">";
}
function Vc(e) {
  var r = e.read_shift(4), t = e.read_shift(4);
  return new Date((t / 1e7 * Math.pow(2, 32) + r / 1e7 - 11644473600) * 1e3).toISOString().replace(/\.000/, "");
}
function o6(e) {
  var r = typeof e == "string" ? new Date(Date.parse(e)) : e, t = r.getTime() / 1e3 + 11644473600, a = t % Math.pow(2, 32), n = (t - a) / Math.pow(2, 32);
  a *= 1e7, n *= 1e7;
  var i = a / Math.pow(2, 32) | 0;
  i > 0 && (a = a % Math.pow(2, 32), n += i);
  var s = te(8);
  return s.write_shift(4, a), s.write_shift(4, n), s;
}
function bv(e, r, t) {
  var a = e.l, n = e.read_shift(0, "lpstr-cp");
  if (t)
    for (; e.l - a & 3; )
      ++e.l;
  return n;
}
function wv(e, r, t) {
  var a = e.read_shift(0, "lpwstr");
  return a;
}
function _v(e, r, t) {
  return r === 31 ? wv(e) : bv(e, r, t);
}
function El(e, r, t) {
  return _v(e, r, t === !1 ? 0 : 4);
}
function u6(e, r) {
  if (!r)
    throw new Error("VtUnalignedString must have positive length");
  return _v(e, r, 0);
}
function l6(e) {
  for (var r = e.read_shift(4), t = [], a = 0; a != r; ++a) {
    var n = e.l;
    t[a] = e.read_shift(0, "lpwstr").replace(Zr, ""), e.l - n & 2 && (e.l += 2);
  }
  return t;
}
function c6(e) {
  for (var r = e.read_shift(4), t = [], a = 0; a != r; ++a)
    t[a] = e.read_shift(0, "lpstr-cp").replace(Zr, "");
  return t;
}
function f6(e) {
  var r = e.l, t = Yo(e, cv);
  e[e.l] == 0 && e[e.l + 1] == 0 && e.l - r & 2 && (e.l += 2);
  var a = Yo(e, it);
  return [t, a];
}
function d6(e) {
  for (var r = e.read_shift(4), t = [], a = 0; a < r / 2; ++a)
    t.push(f6(e));
  return t;
}
function Jd(e, r) {
  for (var t = e.read_shift(4), a = {}, n = 0; n != t; ++n) {
    var i = e.read_shift(4), s = e.read_shift(4);
    a[i] = e.read_shift(s, r === 1200 ? "utf16le" : "utf8").replace(Zr, "").replace(Pi, "!"), r === 1200 && s % 2 && (e.l += 2);
  }
  return e.l & 3 && (e.l = e.l >> 3 << 2), a;
}
function $v(e) {
  var r = e.read_shift(4), t = e.slice(e.l, e.l + r);
  return e.l += r, (r & 3) > 0 && (e.l += 4 - (r & 3) & 3), t;
}
function h6(e) {
  var r = {};
  return r.Size = e.read_shift(4), e.l += r.Size + 3 - (r.Size - 1) % 4, r;
}
function Yo(e, r, t) {
  var a = e.read_shift(2), n, i = t || {};
  if (e.l += 2, r !== Yd && a !== r && j_.indexOf(r) === -1 && !((r & 65534) == 4126 && (a & 65534) == 4126))
    throw new Error("Expected type " + r + " saw " + a);
  switch (r === Yd ? a : r) {
    case 2:
      return n = e.read_shift(2, "i"), i.raw || (e.l += 2), n;
    case 3:
      return n = e.read_shift(4, "i"), n;
    case 11:
      return e.read_shift(4) !== 0;
    case 19:
      return n = e.read_shift(4), n;
    case 30:
      return bv(e, a, 4).replace(Zr, "");
    case 31:
      return wv(e);
    case 64:
      return Vc(e);
    case 65:
      return $v(e);
    case 71:
      return h6(e);
    case 80:
      return El(e, a, !i.raw).replace(Zr, "");
    case 81:
      return u6(
        e,
        a
        /*, 4*/
      ).replace(Zr, "");
    case 4108:
      return d6(e);
    case 4126:
    case 4127:
      return a == 4127 ? l6(e) : c6(e);
    default:
      throw new Error("TypedPropertyValue unrecognized type " + r + " " + a);
  }
}
function qd(e, r) {
  var t = te(4), a = te(4);
  switch (t.write_shift(4, e == 80 ? 31 : e), e) {
    case 3:
      a.write_shift(-4, r);
      break;
    case 5:
      a = te(8), a.write_shift(8, r, "f");
      break;
    case 11:
      a.write_shift(4, r ? 1 : 0);
      break;
    case 64:
      a = o6(r);
      break;
    case 31:
    case 80:
      for (a = te(4 + 2 * (r.length + 1) + (r.length % 2 ? 0 : 2)), a.write_shift(4, r.length + 1), a.write_shift(0, r, "dbcs"); a.l != a.length; )
        a.write_shift(1, 0);
      break;
    default:
      throw new Error("TypedPropertyValue unrecognized type " + e + " " + r);
  }
  return Or([t, a]);
}
function Qd(e, r) {
  var t = e.l, a = e.read_shift(4), n = e.read_shift(4), i = [], s = 0, o = 0, u = -1, l = {};
  for (s = 0; s != n; ++s) {
    var c = e.read_shift(4), f = e.read_shift(4);
    i[s] = [c, f + t];
  }
  i.sort(function(D, y) {
    return D[1] - y[1];
  });
  var h = {};
  for (s = 0; s != n; ++s) {
    if (e.l !== i[s][1]) {
      var d = !0;
      if (s > 0 && r)
        switch (r[i[s - 1][0]].t) {
          case 2:
            e.l + 2 === i[s][1] && (e.l += 2, d = !1);
            break;
          case 80:
            e.l <= i[s][1] && (e.l = i[s][1], d = !1);
            break;
          case 4108:
            e.l <= i[s][1] && (e.l = i[s][1], d = !1);
            break;
        }
      if ((!r || s == 0) && e.l <= i[s][1] && (d = !1, e.l = i[s][1]), d)
        throw new Error("Read Error: Expected address " + i[s][1] + " at " + e.l + " :" + s);
    }
    if (r) {
      var m = r[i[s][0]];
      if (h[m.n] = Yo(e, m.t, { raw: !0 }), m.p === "version" && (h[m.n] = String(h[m.n] >> 16) + "." + ("0000" + String(h[m.n] & 65535)).slice(-4)), m.n == "CodePage")
        switch (h[m.n]) {
          case 0:
            h[m.n] = 1252;
          case 874:
          case 932:
          case 936:
          case 949:
          case 950:
          case 1250:
          case 1251:
          case 1253:
          case 1254:
          case 1255:
          case 1256:
          case 1257:
          case 1258:
          case 1e4:
          case 1200:
          case 1201:
          case 1252:
          case 65e3:
          case -536:
          case 65001:
          case -535:
            kt(o = h[m.n] >>> 0 & 65535);
            break;
          default:
            throw new Error("Unsupported CodePage: " + h[m.n]);
        }
    } else if (i[s][0] === 1) {
      if (o = h.CodePage = Yo(e, Nc), kt(o), u !== -1) {
        var x = e.l;
        e.l = i[u][1], l = Jd(e, o), e.l = x;
      }
    } else if (i[s][0] === 0) {
      if (o === 0) {
        u = s, e.l = i[s + 1][1];
        continue;
      }
      l = Jd(e, o);
    } else {
      var p = l[i[s][0]], w;
      switch (e[e.l]) {
        case 65:
          e.l += 4, w = $v(e);
          break;
        case 30:
          e.l += 4, w = El(e, e[e.l - 4]).replace(/\u0000+$/, "");
          break;
        case 31:
          e.l += 4, w = El(e, e[e.l - 4]).replace(/\u0000+$/, "");
          break;
        case 3:
          e.l += 4, w = e.read_shift(4, "i");
          break;
        case 19:
          e.l += 4, w = e.read_shift(4);
          break;
        case 5:
          e.l += 4, w = e.read_shift(8, "f");
          break;
        case 11:
          e.l += 4, w = _r(e, 4);
          break;
        case 64:
          e.l += 4, w = ur(Vc(e));
          break;
        default:
          throw new Error("unparsed value: " + e[e.l]);
      }
      h[p] = w;
    }
  }
  return e.l = t + a, h;
}
var Dv = ["CodePage", "Thumbnail", "_PID_LINKBASE", "_PID_HLINKS", "SystemIdentifier", "FMTID"];
function x6(e) {
  switch (typeof e) {
    case "boolean":
      return 11;
    case "number":
      return (e | 0) == e ? 3 : 5;
    case "string":
      return 31;
    case "object":
      if (e instanceof Date)
        return 64;
      break;
  }
  return -1;
}
function eh(e, r, t) {
  var a = te(8), n = [], i = [], s = 8, o = 0, u = te(8), l = te(8);
  if (u.write_shift(4, 2), u.write_shift(4, 1200), l.write_shift(4, 1), i.push(u), n.push(l), s += 8 + u.length, !r) {
    l = te(8), l.write_shift(4, 0), n.unshift(l);
    var c = [te(4)];
    for (c[0].write_shift(4, e.length), o = 0; o < e.length; ++o) {
      var f = e[o][0];
      for (u = te(8 + 2 * (f.length + 1) + (f.length % 2 ? 0 : 2)), u.write_shift(4, o + 2), u.write_shift(4, f.length + 1), u.write_shift(0, f, "dbcs"); u.l != u.length; )
        u.write_shift(1, 0);
      c.push(u);
    }
    u = Or(c), i.unshift(u), s += 8 + u.length;
  }
  for (o = 0; o < e.length; ++o)
    if (!(r && !r[e[o][0]]) && !(Dv.indexOf(e[o][0]) > -1 || pv.indexOf(e[o][0]) > -1) && e[o][1] != null) {
      var h = e[o][1], d = 0;
      if (r) {
        d = +r[e[o][0]];
        var m = t[d];
        if (m.p == "version" && typeof h == "string") {
          var x = h.split(".");
          h = (+x[0] << 16) + (+x[1] || 0);
        }
        u = qd(m.t, h);
      } else {
        var p = x6(h);
        p == -1 && (p = 31, h = String(h)), u = qd(p, h);
      }
      i.push(u), l = te(8), l.write_shift(4, r ? d : 2 + o), n.push(l), s += 8 + u.length;
    }
  var w = 8 * (i.length + 1);
  for (o = 0; o < i.length; ++o)
    n[o].write_shift(4, w), w += i[o].length;
  return a.write_shift(4, s), a.write_shift(4, i.length), Or([a].concat(n).concat(i));
}
function rh(e, r, t) {
  var a = e.content;
  if (!a)
    return {};
  Vr(a, 0);
  var n, i, s, o, u = 0;
  a.chk("feff", "Byte Order: "), a.read_shift(2);
  var l = a.read_shift(4), c = a.read_shift(16);
  if (c !== we.utils.consts.HEADER_CLSID && c !== t)
    throw new Error("Bad PropertySet CLSID " + c);
  if (n = a.read_shift(4), n !== 1 && n !== 2)
    throw new Error("Unrecognized #Sets: " + n);
  if (i = a.read_shift(16), o = a.read_shift(4), n === 1 && o !== a.l)
    throw new Error("Length mismatch: " + o + " !== " + a.l);
  n === 2 && (s = a.read_shift(16), u = a.read_shift(4));
  var f = Qd(a, r), h = { SystemIdentifier: l };
  for (var d in f)
    h[d] = f[d];
  if (h.FMTID = i, n === 1)
    return h;
  if (u - a.l == 2 && (a.l += 2), a.l !== u)
    throw new Error("Length mismatch 2: " + a.l + " !== " + u);
  var m;
  try {
    m = Qd(a, null);
  } catch {
  }
  for (d in m)
    h[d] = m[d];
  return h.FMTID = [i, s], h;
}
function th(e, r, t, a, n, i) {
  var s = te(n ? 68 : 48), o = [s];
  s.write_shift(2, 65534), s.write_shift(2, 0), s.write_shift(4, 842412599), s.write_shift(16, we.utils.consts.HEADER_CLSID, "hex"), s.write_shift(4, n ? 2 : 1), s.write_shift(16, r, "hex"), s.write_shift(4, n ? 68 : 48);
  var u = eh(e, t, a);
  if (o.push(u), n) {
    var l = eh(n, null, null);
    s.write_shift(16, i, "hex"), s.write_shift(4, 68 + u.length), o.push(l);
  }
  return Or(o);
}
function ba(e, r) {
  return e.read_shift(r), null;
}
function m6(e, r) {
  r || (r = te(e));
  for (var t = 0; t < e; ++t)
    r.write_shift(1, 0);
  return r;
}
function p6(e, r, t) {
  for (var a = [], n = e.l + r; e.l < n; )
    a.push(t(e, n - e.l));
  if (n !== e.l)
    throw new Error("Slurp error");
  return a;
}
function _r(e, r) {
  return e.read_shift(r) === 1;
}
function rt(e, r) {
  return r || (r = te(2)), r.write_shift(2, +!!e), r;
}
function Tr(e) {
  return e.read_shift(2, "u");
}
function Dt(e, r) {
  return r || (r = te(2)), r.write_shift(2, e), r;
}
function Ev(e, r) {
  return p6(e, r, Tr);
}
function v6(e) {
  var r = e.read_shift(1), t = e.read_shift(1);
  return t === 1 ? r : r === 1;
}
function kv(e, r, t) {
  return t || (t = te(2)), t.write_shift(1, r == "e" ? +e : +!!e), t.write_shift(1, r == "e" ? 1 : 0), t;
}
function Es(e, r, t) {
  var a = e.read_shift(t && t.biff >= 12 ? 2 : 1), n = "sbcs-cont", i = xt;
  if (t && t.biff >= 8 && (xt = 1200), !t || t.biff == 8) {
    var s = e.read_shift(1);
    s && (n = "dbcs-cont");
  } else
    t.biff == 12 && (n = "wstr");
  t.biff >= 2 && t.biff <= 5 && (n = "cpstr");
  var o = a ? e.read_shift(a, n) : "";
  return xt = i, o;
}
function g6(e) {
  var r = xt;
  xt = 1200;
  var t = e.read_shift(2), a = e.read_shift(1), n = a & 4, i = a & 8, s = 1 + (a & 1), o = 0, u, l = {};
  i && (o = e.read_shift(2)), n && (u = e.read_shift(4));
  var c = s == 2 ? "dbcs-cont" : "sbcs-cont", f = t === 0 ? "" : e.read_shift(t, c);
  return i && (e.l += 4 * o), n && (e.l += u), l.t = f, i || (l.raw = "<t>" + l.t + "</t>", l.r = l.t), xt = r, l;
}
function y6(e) {
  var r = e.t || "", t = te(3);
  t.write_shift(2, r.length), t.write_shift(1, 1);
  var a = te(2 * r.length);
  a.write_shift(2 * r.length, r, "utf16le");
  var n = [t, a];
  return Or(n);
}
function hn(e, r, t) {
  var a;
  if (t) {
    if (t.biff >= 2 && t.biff <= 5)
      return e.read_shift(r, "cpstr");
    if (t.biff >= 12)
      return e.read_shift(r, "dbcs-cont");
  }
  var n = e.read_shift(1);
  return n === 0 ? a = e.read_shift(r, "sbcs-cont") : a = e.read_shift(r, "dbcs-cont"), a;
}
function ks(e, r, t) {
  var a = e.read_shift(t && t.biff == 2 ? 1 : 2);
  return a === 0 ? (e.l++, "") : hn(e, a, t);
}
function _n(e, r, t) {
  if (t.biff > 5)
    return ks(e, r, t);
  var a = e.read_shift(1);
  return a === 0 ? (e.l++, "") : e.read_shift(a, t.biff <= 4 || !e.lens ? "cpstr" : "sbcs-cont");
}
function Tv(e, r, t) {
  return t || (t = te(3 + 2 * e.length)), t.write_shift(2, e.length), t.write_shift(1, 1), t.write_shift(31, e, "utf16le"), t;
}
function b6(e) {
  var r = e.read_shift(1);
  e.l++;
  var t = e.read_shift(2);
  return e.l += 2, [r, t];
}
function w6(e) {
  var r = e.read_shift(4), t = e.l, a = !1;
  r > 24 && (e.l += r - 24, e.read_shift(16) === "795881f43b1d7f48af2c825dc4852763" && (a = !0), e.l = t);
  var n = e.read_shift((a ? r - 24 : r) >> 1, "utf16le").replace(Zr, "");
  return a && (e.l += 24), n;
}
function _6(e) {
  for (var r = e.read_shift(2), t = ""; r-- > 0; )
    t += "../";
  var a = e.read_shift(0, "lpstr-ansi");
  if (e.l += 2, e.read_shift(2) != 57005)
    throw new Error("Bad FileMoniker");
  var n = e.read_shift(4);
  if (n === 0)
    return t + a.replace(/\\/g, "/");
  var i = e.read_shift(4);
  if (e.read_shift(2) != 3)
    throw new Error("Bad FileMoniker");
  var s = e.read_shift(i >> 1, "utf16le").replace(Zr, "");
  return t + s;
}
function $6(e, r) {
  var t = e.read_shift(16);
  switch (t) {
    case "e0c9ea79f9bace118c8200aa004ba90b":
      return w6(e);
    case "0303000000000000c000000000000046":
      return _6(e);
    default:
      throw new Error("Unsupported Moniker " + t);
  }
}
function ao(e) {
  var r = e.read_shift(4), t = r > 0 ? e.read_shift(r, "utf16le").replace(Zr, "") : "";
  return t;
}
function ah(e, r) {
  r || (r = te(6 + e.length * 2)), r.write_shift(4, 1 + e.length);
  for (var t = 0; t < e.length; ++t)
    r.write_shift(2, e.charCodeAt(t));
  return r.write_shift(2, 0), r;
}
function D6(e, r) {
  var t = e.l + r, a = e.read_shift(4);
  if (a !== 2)
    throw new Error("Unrecognized streamVersion: " + a);
  var n = e.read_shift(2);
  e.l += 2;
  var i, s, o, u, l = "", c, f;
  n & 16 && (i = ao(e, t - e.l)), n & 128 && (s = ao(e, t - e.l)), (n & 257) === 257 && (o = ao(e, t - e.l)), (n & 257) === 1 && (u = $6(e, t - e.l)), n & 8 && (l = ao(e, t - e.l)), n & 32 && (c = e.read_shift(16)), n & 64 && (f = Vc(
    e
    /*, 8*/
  )), e.l = t;
  var h = s || o || u || "";
  h && l && (h += "#" + l), h || (h = "#" + l), n & 2 && h.charAt(0) == "/" && h.charAt(1) != "/" && (h = "file://" + h);
  var d = { Target: h };
  return c && (d.guid = c), f && (d.time = f), i && (d.Tooltip = i), d;
}
function E6(e) {
  var r = te(512), t = 0, a = e.Target;
  a.slice(0, 7) == "file://" && (a = a.slice(7));
  var n = a.indexOf("#"), i = n > -1 ? 31 : 23;
  switch (a.charAt(0)) {
    case "#":
      i = 28;
      break;
    case ".":
      i &= -3;
      break;
  }
  r.write_shift(4, 2), r.write_shift(4, i);
  var s = [8, 6815827, 6619237, 4849780, 83];
  for (t = 0; t < s.length; ++t)
    r.write_shift(4, s[t]);
  if (i == 28)
    a = a.slice(1), ah(a, r);
  else if (i & 2) {
    for (s = "e0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" "), t = 0; t < s.length; ++t)
      r.write_shift(1, parseInt(s[t], 16));
    var o = n > -1 ? a.slice(0, n) : a;
    for (r.write_shift(4, 2 * (o.length + 1)), t = 0; t < o.length; ++t)
      r.write_shift(2, o.charCodeAt(t));
    r.write_shift(2, 0), i & 8 && ah(n > -1 ? a.slice(n + 1) : "", r);
  } else {
    for (s = "03 03 00 00 00 00 00 00 c0 00 00 00 00 00 00 46".split(" "), t = 0; t < s.length; ++t)
      r.write_shift(1, parseInt(s[t], 16));
    for (var u = 0; a.slice(u * 3, u * 3 + 3) == "../" || a.slice(u * 3, u * 3 + 3) == "..\\"; )
      ++u;
    for (r.write_shift(2, u), r.write_shift(4, a.length - 3 * u + 1), t = 0; t < a.length - 3 * u; ++t)
      r.write_shift(1, a.charCodeAt(t + 3 * u) & 255);
    for (r.write_shift(1, 0), r.write_shift(2, 65535), r.write_shift(2, 57005), t = 0; t < 6; ++t)
      r.write_shift(4, 0);
  }
  return r.slice(0, r.l);
}
function Sv(e) {
  var r = e.read_shift(1), t = e.read_shift(1), a = e.read_shift(1), n = e.read_shift(1);
  return [r, t, a, n];
}
function Cv(e, r) {
  var t = Sv(e);
  return t[3] = 0, t;
}
function Zt(e) {
  var r = e.read_shift(2), t = e.read_shift(2), a = e.read_shift(2);
  return { r, c: t, ixfe: a };
}
function xn(e, r, t, a) {
  return a || (a = te(6)), a.write_shift(2, e), a.write_shift(2, r), a.write_shift(2, t || 0), a;
}
function k6(e) {
  var r = e.read_shift(2), t = e.read_shift(2);
  return e.l += 8, { type: r, flags: t };
}
function T6(e, r, t) {
  return r === 0 ? "" : _n(e, r, t);
}
function S6(e, r, t) {
  var a = t.biff > 8 ? 4 : 2, n = e.read_shift(a), i = e.read_shift(a, "i"), s = e.read_shift(a, "i");
  return [n, i, s];
}
function Fv(e) {
  var r = e.read_shift(2), t = Lc(e);
  return [r, t];
}
function C6(e, r, t) {
  e.l += 4, r -= 4;
  var a = e.l + r, n = Es(e, r, t), i = e.read_shift(2);
  if (a -= e.l, i !== a)
    throw new Error("Malformed AddinUdf: padding = " + a + " != " + i);
  return e.l += i, n;
}
function y0(e) {
  var r = e.read_shift(2), t = e.read_shift(2), a = e.read_shift(2), n = e.read_shift(2);
  return { s: { c: a, r }, e: { c: n, r: t } };
}
function Av(e, r) {
  return r || (r = te(8)), r.write_shift(2, e.s.r), r.write_shift(2, e.e.r), r.write_shift(2, e.s.c), r.write_shift(2, e.e.c), r;
}
function Rv(e) {
  var r = e.read_shift(2), t = e.read_shift(2), a = e.read_shift(1), n = e.read_shift(1);
  return { s: { c: a, r }, e: { c: n, r: t } };
}
var F6 = Rv;
function Iv(e) {
  e.l += 4;
  var r = e.read_shift(2), t = e.read_shift(2), a = e.read_shift(2);
  return e.l += 12, [t, r, a];
}
function A6(e) {
  var r = {};
  return e.l += 4, e.l += 16, r.fSharedNote = e.read_shift(2), e.l += 4, r;
}
function R6(e) {
  var r = {};
  return e.l += 4, e.cf = e.read_shift(2), r;
}
function jr(e) {
  e.l += 2, e.l += e.read_shift(2);
}
var I6 = {
  /*::[*/
  0: jr,
  /* FtEnd */
  /*::[*/
  4: jr,
  /* FtMacro */
  /*::[*/
  5: jr,
  /* FtButton */
  /*::[*/
  6: jr,
  /* FtGmo */
  /*::[*/
  7: R6,
  /* FtCf */
  /*::[*/
  8: jr,
  /* FtPioGrbit */
  /*::[*/
  9: jr,
  /* FtPictFmla */
  /*::[*/
  10: jr,
  /* FtCbls */
  /*::[*/
  11: jr,
  /* FtRbo */
  /*::[*/
  12: jr,
  /* FtSbs */
  /*::[*/
  13: A6,
  /* FtNts */
  /*::[*/
  14: jr,
  /* FtSbsFmla */
  /*::[*/
  15: jr,
  /* FtGboData */
  /*::[*/
  16: jr,
  /* FtEdoData */
  /*::[*/
  17: jr,
  /* FtRboData */
  /*::[*/
  18: jr,
  /* FtCblsData */
  /*::[*/
  19: jr,
  /* FtLbsData */
  /*::[*/
  20: jr,
  /* FtCblsFmla */
  /*::[*/
  21: Iv
};
function B6(e, r) {
  for (var t = e.l + r, a = []; e.l < t; ) {
    var n = e.read_shift(2);
    e.l -= 2;
    try {
      a.push(I6[n](e, t - e.l));
    } catch {
      return e.l = t, a;
    }
  }
  return e.l != t && (e.l = t), a;
}
function no(e, r) {
  var t = { BIFFVer: 0, dt: 0 };
  switch (t.BIFFVer = e.read_shift(2), r -= 2, r >= 2 && (t.dt = e.read_shift(2), e.l -= 2), t.BIFFVer) {
    case 1536:
    case 1280:
    case 1024:
    case 768:
    case 512:
    case 2:
    case 7:
      break;
    default:
      if (r > 6)
        throw new Error("Unexpected BIFF Ver " + t.BIFFVer);
  }
  return e.read_shift(r), t;
}
function Wc(e, r, t) {
  var a = 1536, n = 16;
  switch (t.bookType) {
    case "biff8":
      break;
    case "biff5":
      a = 1280, n = 8;
      break;
    case "biff4":
      a = 4, n = 6;
      break;
    case "biff3":
      a = 3, n = 6;
      break;
    case "biff2":
      a = 2, n = 4;
      break;
    case "xla":
      break;
    default:
      throw new Error("unsupported BIFF version");
  }
  var i = te(n);
  return i.write_shift(2, a), i.write_shift(2, r), n > 4 && i.write_shift(2, 29282), n > 6 && i.write_shift(2, 1997), n > 8 && (i.write_shift(2, 49161), i.write_shift(2, 1), i.write_shift(2, 1798), i.write_shift(2, 0)), i;
}
function P6(e, r) {
  return r === 0 || e.read_shift(2), 1200;
}
function M6(e, r, t) {
  if (t.enc)
    return e.l += r, "";
  var a = e.l, n = _n(e, 0, t);
  return e.read_shift(r + a - e.l), n;
}
function O6(e, r) {
  var t = !r || r.biff == 8, a = te(t ? 112 : 54);
  for (a.write_shift(r.biff == 8 ? 2 : 1, 7), t && a.write_shift(1, 0), a.write_shift(4, 859007059), a.write_shift(4, 5458548 | (t ? 0 : 536870912)); a.l < a.length; )
    a.write_shift(1, t ? 0 : 32);
  return a;
}
function L6(e, r, t) {
  var a = t && t.biff == 8 || r == 2 ? e.read_shift(2) : (e.l += r, 0);
  return { fDialog: a & 16, fBelow: a & 64, fRight: a & 128 };
}
function N6(e, r, t) {
  var a = e.read_shift(4), n = e.read_shift(1) & 3, i = e.read_shift(1);
  switch (i) {
    case 0:
      i = "Worksheet";
      break;
    case 1:
      i = "Macrosheet";
      break;
    case 2:
      i = "Chartsheet";
      break;
    case 6:
      i = "VBAModule";
      break;
  }
  var s = Es(e, 0, t);
  return s.length === 0 && (s = "Sheet1"), { pos: a, hs: n, dt: i, name: s };
}
function U6(e, r) {
  var t = !r || r.biff >= 8 ? 2 : 1, a = te(8 + t * e.name.length);
  a.write_shift(4, e.pos), a.write_shift(1, e.hs || 0), a.write_shift(1, e.dt), a.write_shift(1, e.name.length), r.biff >= 8 && a.write_shift(1, 1), a.write_shift(t * e.name.length, e.name, r.biff < 8 ? "sbcs" : "utf16le");
  var n = a.slice(0, a.l);
  return n.l = a.l, n;
}
function V6(e, r) {
  for (var t = e.l + r, a = e.read_shift(4), n = e.read_shift(4), i = [], s = 0; s != n && e.l < t; ++s)
    i.push(g6(e));
  return i.Count = a, i.Unique = n, i;
}
function W6(e, r) {
  var t = te(8);
  t.write_shift(4, e.Count), t.write_shift(4, e.Unique);
  for (var a = [], n = 0; n < e.length; ++n)
    a[n] = y6(e[n]);
  var i = Or([t].concat(a));
  return i.parts = [t.length].concat(a.map(function(s) {
    return s.length;
  })), i;
}
function H6(e, r) {
  var t = {};
  return t.dsst = e.read_shift(2), e.l += r - 2, t;
}
function j6(e) {
  var r = {};
  r.r = e.read_shift(2), r.c = e.read_shift(2), r.cnt = e.read_shift(2) - r.c;
  var t = e.read_shift(2);
  e.l += 4;
  var a = e.read_shift(1);
  return e.l += 3, a & 7 && (r.level = a & 7), a & 32 && (r.hidden = !0), a & 64 && (r.hpt = t / 20), r;
}
function z6(e) {
  var r = k6(e);
  if (r.type != 2211)
    throw new Error("Invalid Future Record " + r.type);
  var t = e.read_shift(4);
  return t !== 0;
}
function G6(e) {
  return e.read_shift(2), e.read_shift(4);
}
function nh(e, r, t) {
  var a = 0;
  t && t.biff == 2 || (a = e.read_shift(2));
  var n = e.read_shift(2);
  t && t.biff == 2 && (a = 1 - (n >> 15), n &= 32767);
  var i = { Unsynced: a & 1, DyZero: (a & 2) >> 1, ExAsc: (a & 4) >> 2, ExDsc: (a & 8) >> 3 };
  return [i, n];
}
function K6(e) {
  var r = e.read_shift(2), t = e.read_shift(2), a = e.read_shift(2), n = e.read_shift(2), i = e.read_shift(2), s = e.read_shift(2), o = e.read_shift(2), u = e.read_shift(2), l = e.read_shift(2);
  return {
    Pos: [r, t],
    Dim: [a, n],
    Flags: i,
    CurTab: s,
    FirstTab: o,
    Selected: u,
    TabRatio: l
  };
}
function Y6() {
  var e = te(18);
  return e.write_shift(2, 0), e.write_shift(2, 0), e.write_shift(2, 29280), e.write_shift(2, 17600), e.write_shift(2, 56), e.write_shift(2, 0), e.write_shift(2, 0), e.write_shift(2, 1), e.write_shift(2, 500), e;
}
function X6(e, r, t) {
  if (t && t.biff >= 2 && t.biff < 5)
    return {};
  var a = e.read_shift(2);
  return { RTL: a & 64 };
}
function Z6(e) {
  var r = te(18), t = 1718;
  return e && e.RTL && (t |= 64), r.write_shift(2, t), r.write_shift(4, 0), r.write_shift(4, 64), r.write_shift(4, 0), r.write_shift(4, 0), r;
}
function J6() {
}
function q6(e, r, t) {
  var a = {
    dyHeight: e.read_shift(2),
    fl: e.read_shift(2)
  };
  switch (t && t.biff || 8) {
    case 2:
      break;
    case 3:
    case 4:
      e.l += 2;
      break;
    default:
      e.l += 10;
      break;
  }
  return a.name = Es(e, 0, t), a;
}
function Q6(e, r) {
  var t = e.name || "Arial", a = r && r.biff == 5, n = a ? 15 + t.length : 16 + 2 * t.length, i = te(n);
  return i.write_shift(2, (e.sz || 12) * 20), i.write_shift(4, 0), i.write_shift(2, 400), i.write_shift(4, 0), i.write_shift(2, 0), i.write_shift(1, t.length), a || i.write_shift(1, 1), i.write_shift((a ? 1 : 2) * t.length, t, a ? "sbcs" : "utf16le"), i;
}
function e$(e) {
  var r = Zt(e);
  return r.isst = e.read_shift(4), r;
}
function r$(e, r, t, a) {
  var n = te(10);
  return xn(e, r, a, n), n.write_shift(4, t), n;
}
function t$(e, r, t) {
  t.biffguess && t.biff == 2 && (t.biff = 5);
  var a = e.l + r, n = Zt(e);
  t.biff == 2 && e.l++;
  var i = ks(e, a - e.l, t);
  return n.val = i, n;
}
function a$(e, r, t, a, n) {
  var i = !n || n.biff == 8, s = te(8 + +i + (1 + i) * t.length);
  return xn(e, r, a, s), s.write_shift(2, t.length), i && s.write_shift(1, 1), s.write_shift((1 + i) * t.length, t, i ? "utf16le" : "sbcs"), s;
}
function n$(e, r, t) {
  var a = e.read_shift(2), n = _n(e, 0, t);
  return [a, n];
}
function i$(e, r, t, a) {
  var n = t && t.biff == 5;
  a || (a = te(n ? 3 + r.length : 5 + 2 * r.length)), a.write_shift(2, e), a.write_shift(n ? 1 : 2, r.length), n || a.write_shift(1, 1), a.write_shift((n ? 1 : 2) * r.length, r, n ? "sbcs" : "utf16le");
  var i = a.length > a.l ? a.slice(0, a.l) : a;
  return i.l == null && (i.l = i.length), i;
}
var s$ = _n;
function ih(e, r, t) {
  var a = e.l + r, n = t.biff == 8 || !t.biff ? 4 : 2, i = e.read_shift(n), s = e.read_shift(n), o = e.read_shift(2), u = e.read_shift(2);
  return e.l = a, { s: { r: i, c: o }, e: { r: s, c: u } };
}
function o$(e, r) {
  var t = r.biff == 8 || !r.biff ? 4 : 2, a = te(2 * t + 6);
  return a.write_shift(t, e.s.r), a.write_shift(t, e.e.r + 1), a.write_shift(2, e.s.c), a.write_shift(2, e.e.c + 1), a.write_shift(2, 0), a;
}
function u$(e) {
  var r = e.read_shift(2), t = e.read_shift(2), a = Fv(e);
  return { r, c: t, ixfe: a[0], rknum: a[1] };
}
function l$(e, r) {
  for (var t = e.l + r - 2, a = e.read_shift(2), n = e.read_shift(2), i = []; e.l < t; )
    i.push(Fv(e));
  if (e.l !== t)
    throw new Error("MulRK read error");
  var s = e.read_shift(2);
  if (i.length != s - n + 1)
    throw new Error("MulRK length mismatch");
  return { r: a, c: n, C: s, rkrec: i };
}
function c$(e, r) {
  for (var t = e.l + r - 2, a = e.read_shift(2), n = e.read_shift(2), i = []; e.l < t; )
    i.push(e.read_shift(2));
  if (e.l !== t)
    throw new Error("MulBlank read error");
  var s = e.read_shift(2);
  if (i.length != s - n + 1)
    throw new Error("MulBlank length mismatch");
  return { r: a, c: n, C: s, ixfe: i };
}
function f$(e, r, t, a) {
  var n = {}, i = e.read_shift(4), s = e.read_shift(4), o = e.read_shift(4), u = e.read_shift(2);
  return n.patternType = z_[o >> 26], a.cellStyles && (n.alc = i & 7, n.fWrap = i >> 3 & 1, n.alcV = i >> 4 & 7, n.fJustLast = i >> 7 & 1, n.trot = i >> 8 & 255, n.cIndent = i >> 16 & 15, n.fShrinkToFit = i >> 20 & 1, n.iReadOrder = i >> 22 & 2, n.fAtrNum = i >> 26 & 1, n.fAtrFnt = i >> 27 & 1, n.fAtrAlc = i >> 28 & 1, n.fAtrBdr = i >> 29 & 1, n.fAtrPat = i >> 30 & 1, n.fAtrProt = i >> 31 & 1, n.dgLeft = s & 15, n.dgRight = s >> 4 & 15, n.dgTop = s >> 8 & 15, n.dgBottom = s >> 12 & 15, n.icvLeft = s >> 16 & 127, n.icvRight = s >> 23 & 127, n.grbitDiag = s >> 30 & 3, n.icvTop = o & 127, n.icvBottom = o >> 7 & 127, n.icvDiag = o >> 14 & 127, n.dgDiag = o >> 21 & 15, n.icvFore = u & 127, n.icvBack = u >> 7 & 127, n.fsxButton = u >> 14 & 1), n;
}
function d$(e, r, t) {
  var a = {};
  return a.ifnt = e.read_shift(2), a.numFmtId = e.read_shift(2), a.flags = e.read_shift(2), a.fStyle = a.flags >> 2 & 1, r -= 6, a.data = f$(e, r, a.fStyle, t), a;
}
function sh(e, r, t, a) {
  var n = t && t.biff == 5;
  a || (a = te(n ? 16 : 20)), a.write_shift(2, 0), e.style ? (a.write_shift(2, e.numFmtId || 0), a.write_shift(2, 65524)) : (a.write_shift(2, e.numFmtId || 0), a.write_shift(2, r << 4));
  var i = 0;
  return e.numFmtId > 0 && n && (i |= 1024), a.write_shift(4, i), a.write_shift(4, 0), n || a.write_shift(4, 0), a.write_shift(2, 0), a;
}
function h$(e) {
  e.l += 4;
  var r = [e.read_shift(2), e.read_shift(2)];
  if (r[0] !== 0 && r[0]--, r[1] !== 0 && r[1]--, r[0] > 7 || r[1] > 7)
    throw new Error("Bad Gutters: " + r.join("|"));
  return r;
}
function x$(e) {
  var r = te(8);
  return r.write_shift(4, 0), r.write_shift(2, 0), r.write_shift(2, 0), r;
}
function oh(e, r, t) {
  var a = Zt(e);
  (t.biff == 2 || r == 9) && ++e.l;
  var n = v6(e);
  return a.val = n, a.t = n === !0 || n === !1 ? "b" : "e", a;
}
function m$(e, r, t, a, n, i) {
  var s = te(8);
  return xn(e, r, a, s), kv(t, i, s), s;
}
function p$(e, r, t) {
  t.biffguess && t.biff == 2 && (t.biff = 5);
  var a = Zt(e), n = Xr(e);
  return a.val = n, a;
}
function v$(e, r, t, a) {
  var n = te(14);
  return xn(e, r, a, n), dn(t, n), n;
}
var uh = T6;
function g$(e, r, t) {
  var a = e.l + r, n = e.read_shift(2), i = e.read_shift(2);
  if (t.sbcch = i, i == 1025 || i == 14849)
    return [i, n];
  if (i < 1 || i > 255)
    throw new Error("Unexpected SupBook type: " + i);
  for (var s = hn(e, i), o = []; a > e.l; )
    o.push(ks(e));
  return [i, n, s, o];
}
function lh(e, r, t) {
  var a = e.read_shift(2), n, i = {
    fBuiltIn: a & 1,
    fWantAdvise: a >>> 1 & 1,
    fWantPict: a >>> 2 & 1,
    fOle: a >>> 3 & 1,
    fOleLink: a >>> 4 & 1,
    cf: a >>> 5 & 1023,
    fIcon: a >>> 15 & 1
  };
  return t.sbcch === 14849 && (n = C6(e, r - 2, t)), i.body = n || e.read_shift(r - 2), typeof n == "string" && (i.Name = n), i;
}
var y$ = [
  "_xlnm.Consolidate_Area",
  "_xlnm.Auto_Open",
  "_xlnm.Auto_Close",
  "_xlnm.Extract",
  "_xlnm.Database",
  "_xlnm.Criteria",
  "_xlnm.Print_Area",
  "_xlnm.Print_Titles",
  "_xlnm.Recorder",
  "_xlnm.Data_Form",
  "_xlnm.Auto_Activate",
  "_xlnm.Auto_Deactivate",
  "_xlnm.Sheet_Title",
  "_xlnm._FilterDatabase"
];
function ch(e, r, t) {
  var a = e.l + r, n = e.read_shift(2), i = e.read_shift(1), s = e.read_shift(1), o = e.read_shift(t && t.biff == 2 ? 1 : 2), u = 0;
  (!t || t.biff >= 5) && (t.biff != 5 && (e.l += 2), u = e.read_shift(2), t.biff == 5 && (e.l += 2), e.l += 4);
  var l = hn(e, s, t);
  n & 32 && (l = y$[l.charCodeAt(0)]);
  var c = a - e.l;
  t && t.biff == 2 && --c;
  var f = a == e.l || o === 0 || !(c > 0) ? [] : B8(e, c, t, o);
  return {
    chKey: i,
    Name: l,
    itab: u,
    rgce: f
  };
}
function Bv(e, r, t) {
  if (t.biff < 8)
    return b$(e, r, t);
  for (var a = [], n = e.l + r, i = e.read_shift(t.biff > 8 ? 4 : 2); i-- !== 0; )
    a.push(S6(e, t.biff > 8 ? 12 : 6, t));
  if (e.l != n)
    throw new Error("Bad ExternSheet: " + e.l + " != " + n);
  return a;
}
function b$(e, r, t) {
  e[e.l + 1] == 3 && e[e.l]++;
  var a = Es(e, r, t);
  return a.charCodeAt(0) == 3 ? a.slice(1) : a;
}
function w$(e, r, t) {
  if (t.biff < 8) {
    e.l += r;
    return;
  }
  var a = e.read_shift(2), n = e.read_shift(2), i = hn(e, a, t), s = hn(e, n, t);
  return [i, s];
}
function _$(e, r, t) {
  var a = Rv(e);
  e.l++;
  var n = e.read_shift(1);
  return r -= 8, [P8(e, r, t), n, a];
}
function fh(e, r, t) {
  var a = F6(e);
  switch (t.biff) {
    case 2:
      e.l++, r -= 7;
      break;
    case 3:
    case 4:
      e.l += 2, r -= 8;
      break;
    default:
      e.l += 6, r -= 12;
  }
  return [a, R8(e, r, t)];
}
function $$(e) {
  var r = e.read_shift(4) !== 0, t = e.read_shift(4) !== 0, a = e.read_shift(4);
  return [r, t, a];
}
function D$(e, r, t) {
  if (!(t.biff < 8)) {
    var a = e.read_shift(2), n = e.read_shift(2), i = e.read_shift(2), s = e.read_shift(2), o = _n(e, 0, t);
    return t.biff < 8 && e.read_shift(1), [{ r: a, c: n }, o, s, i];
  }
}
function E$(e, r, t) {
  return D$(e, r, t);
}
function k$(e, r) {
  for (var t = [], a = e.read_shift(2); a--; )
    t.push(y0(e));
  return t;
}
function T$(e) {
  var r = te(2 + e.length * 8);
  r.write_shift(2, e.length);
  for (var t = 0; t < e.length; ++t)
    Av(e[t], r);
  return r;
}
function S$(e, r, t) {
  if (t && t.biff < 8)
    return F$(e, r, t);
  var a = Iv(e), n = B6(e, r - 22, a[1]);
  return { cmo: a, ft: n };
}
var C$ = {
  8: function(e, r) {
    var t = e.l + r;
    e.l += 10;
    var a = e.read_shift(2);
    e.l += 4, e.l += 2, e.l += 2, e.l += 2, e.l += 4;
    var n = e.read_shift(1);
    return e.l += n, e.l = t, { fmt: a };
  }
};
function F$(e, r, t) {
  e.l += 4;
  var a = e.read_shift(2), n = e.read_shift(2), i = e.read_shift(2);
  e.l += 2, e.l += 2, e.l += 2, e.l += 2, e.l += 2, e.l += 2, e.l += 2, e.l += 2, e.l += 2, e.l += 6, r -= 36;
  var s = [];
  return s.push((C$[a] || qr)(e, r, t)), { cmo: [n, a, i], ft: s };
}
function A$(e, r, t) {
  var a = e.l, n = "";
  try {
    e.l += 4;
    var i = (t.lastobj || { cmo: [0, 0] }).cmo[1], s;
    [0, 5, 7, 11, 12, 14].indexOf(i) == -1 ? e.l += 6 : s = b6(e, 6, t);
    var o = e.read_shift(2);
    e.read_shift(2), Tr(e, 2);
    var u = e.read_shift(2);
    e.l += u;
    for (var l = 1; l < e.lens.length - 1; ++l) {
      if (e.l - a != e.lens[l])
        throw new Error("TxO: bad continue record");
      var c = e[e.l], f = hn(e, e.lens[l + 1] - e.lens[l] - 1);
      if (n += f, n.length >= (c ? o : 2 * o))
        break;
    }
    if (n.length !== o && n.length !== o * 2)
      throw new Error("cchText: " + o + " != " + n.length);
    return e.l = a + r, { t: n };
  } catch {
    return e.l = a + r, { t: n };
  }
}
function R$(e, r) {
  var t = y0(e);
  e.l += 16;
  var a = D6(e, r - 24);
  return [t, a];
}
function I$(e) {
  var r = te(24), t = fr(e[0]);
  r.write_shift(2, t.r), r.write_shift(2, t.r), r.write_shift(2, t.c), r.write_shift(2, t.c);
  for (var a = "d0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" "), n = 0; n < 16; ++n)
    r.write_shift(1, parseInt(a[n], 16));
  return Or([r, E6(e[1])]);
}
function B$(e, r) {
  e.read_shift(2);
  var t = y0(e), a = e.read_shift((r - 10) / 2, "dbcs-cont");
  return a = a.replace(Zr, ""), [t, a];
}
function P$(e) {
  var r = e[1].Tooltip, t = te(10 + 2 * (r.length + 1));
  t.write_shift(2, 2048);
  var a = fr(e[0]);
  t.write_shift(2, a.r), t.write_shift(2, a.r), t.write_shift(2, a.c), t.write_shift(2, a.c);
  for (var n = 0; n < r.length; ++n)
    t.write_shift(2, r.charCodeAt(n));
  return t.write_shift(2, 0), t;
}
function M$(e) {
  var r = [0, 0], t;
  return t = e.read_shift(2), r[0] = Xd[t] || t, t = e.read_shift(2), r[1] = Xd[t] || t, r;
}
function O$(e) {
  return e || (e = te(4)), e.write_shift(2, 1), e.write_shift(2, 1), e;
}
function L$(e) {
  for (var r = e.read_shift(2), t = []; r-- > 0; )
    t.push(Cv(e));
  return t;
}
function N$(e) {
  for (var r = e.read_shift(2), t = []; r-- > 0; )
    t.push(Cv(e));
  return t;
}
function U$(e) {
  e.l += 2;
  var r = { cxfs: 0, crc: 0 };
  return r.cxfs = e.read_shift(2), r.crc = e.read_shift(4), r;
}
function Pv(e, r, t) {
  if (!t.cellStyles)
    return qr(e, r);
  var a = t && t.biff >= 12 ? 4 : 2, n = e.read_shift(a), i = e.read_shift(a), s = e.read_shift(a), o = e.read_shift(a), u = e.read_shift(2);
  a == 2 && (e.l += 2);
  var l = { s: n, e: i, w: s, ixfe: o, flags: u };
  return (t.biff >= 5 || !t.biff) && (l.level = u >> 8 & 7), l;
}
function V$(e, r) {
  var t = te(12);
  t.write_shift(2, r), t.write_shift(2, r), t.write_shift(2, e.width * 256), t.write_shift(2, 0);
  var a = 0;
  return e.hidden && (a |= 1), t.write_shift(1, a), a = e.level || 0, t.write_shift(1, a), t.write_shift(2, 0), t;
}
function W$(e, r) {
  var t = {};
  return r < 32 || (e.l += 16, t.header = Xr(e), t.footer = Xr(e), e.l += 2), t;
}
function H$(e, r, t) {
  var a = { area: !1 };
  if (t.biff != 5)
    return e.l += r, a;
  var n = e.read_shift(1);
  return e.l += 3, n & 16 && (a.area = !0), a;
}
function j$(e) {
  for (var r = te(2 * e), t = 0; t < e; ++t)
    r.write_shift(2, t + 1);
  return r;
}
var z$ = Zt, G$ = Ev, K$ = ks;
function Y$(e) {
  var r = e.read_shift(2), t = e.read_shift(2), a = e.read_shift(4), n = { fmt: r, env: t, len: a, data: e.slice(e.l, e.l + a) };
  return e.l += a, n;
}
function X$(e, r, t) {
  t.biffguess && t.biff == 5 && (t.biff = 2);
  var a = Zt(e);
  ++e.l;
  var n = _n(e, r - 7, t);
  return a.t = "str", a.val = n, a;
}
function Z$(e) {
  var r = Zt(e);
  ++e.l;
  var t = Xr(e);
  return r.t = "n", r.val = t, r;
}
function J$(e, r, t) {
  var a = te(15);
  return Fs(a, e, r), a.write_shift(8, t, "f"), a;
}
function q$(e) {
  var r = Zt(e);
  ++e.l;
  var t = e.read_shift(2);
  return r.t = "n", r.val = t, r;
}
function Q$(e, r, t) {
  var a = te(9);
  return Fs(a, e, r), a.write_shift(2, t), a;
}
function eD(e) {
  var r = e.read_shift(1);
  return r === 0 ? (e.l++, "") : e.read_shift(r, "sbcs-cont");
}
function rD(e, r) {
  e.l += 6, e.l += 2, e.l += 1, e.l += 3, e.l += 1, e.l += r - 13;
}
function tD(e, r, t) {
  var a = e.l + r, n = Zt(e), i = e.read_shift(2), s = hn(e, i, t);
  return e.l = a, n.t = "str", n.val = s, n;
}
var aD = [2, 3, 48, 49, 131, 139, 140, 245], kl = /* @__PURE__ */ function() {
  var e = {
    /* Code Pages Supported by Visual FoxPro */
    /*::[*/
    1: 437,
    /*::[*/
    2: 850,
    /*::[*/
    3: 1252,
    /*::[*/
    4: 1e4,
    /*::[*/
    100: 852,
    /*::[*/
    101: 866,
    /*::[*/
    102: 865,
    /*::[*/
    103: 861,
    /*::[*/
    104: 895,
    /*::[*/
    105: 620,
    /*::[*/
    106: 737,
    /*::[*/
    107: 857,
    /*::[*/
    120: 950,
    /*::[*/
    121: 949,
    /*::[*/
    122: 936,
    /*::[*/
    123: 932,
    /*::[*/
    124: 874,
    /*::[*/
    125: 1255,
    /*::[*/
    126: 1256,
    /*::[*/
    150: 10007,
    /*::[*/
    151: 10029,
    /*::[*/
    152: 10006,
    /*::[*/
    200: 1250,
    /*::[*/
    201: 1251,
    /*::[*/
    202: 1254,
    /*::[*/
    203: 1253,
    /* shapefile DBF extension */
    /*::[*/
    0: 20127,
    /*::[*/
    8: 865,
    /*::[*/
    9: 437,
    /*::[*/
    10: 850,
    /*::[*/
    11: 437,
    /*::[*/
    13: 437,
    /*::[*/
    14: 850,
    /*::[*/
    15: 437,
    /*::[*/
    16: 850,
    /*::[*/
    17: 437,
    /*::[*/
    18: 850,
    /*::[*/
    19: 932,
    /*::[*/
    20: 850,
    /*::[*/
    21: 437,
    /*::[*/
    22: 850,
    /*::[*/
    23: 865,
    /*::[*/
    24: 437,
    /*::[*/
    25: 437,
    /*::[*/
    26: 850,
    /*::[*/
    27: 437,
    /*::[*/
    28: 863,
    /*::[*/
    29: 850,
    /*::[*/
    31: 852,
    /*::[*/
    34: 852,
    /*::[*/
    35: 852,
    /*::[*/
    36: 860,
    /*::[*/
    37: 850,
    /*::[*/
    38: 866,
    /*::[*/
    55: 850,
    /*::[*/
    64: 852,
    /*::[*/
    77: 936,
    /*::[*/
    78: 949,
    /*::[*/
    79: 950,
    /*::[*/
    80: 874,
    /*::[*/
    87: 1252,
    /*::[*/
    88: 1252,
    /*::[*/
    89: 1252,
    /*::[*/
    108: 863,
    /*::[*/
    134: 737,
    /*::[*/
    135: 852,
    /*::[*/
    136: 857,
    /*::[*/
    204: 1257,
    /*::[*/
    255: 16969
  }, r = m0({
    /*::[*/
    1: 437,
    /*::[*/
    2: 850,
    /*::[*/
    3: 1252,
    /*::[*/
    4: 1e4,
    /*::[*/
    100: 852,
    /*::[*/
    101: 866,
    /*::[*/
    102: 865,
    /*::[*/
    103: 861,
    /*::[*/
    104: 895,
    /*::[*/
    105: 620,
    /*::[*/
    106: 737,
    /*::[*/
    107: 857,
    /*::[*/
    120: 950,
    /*::[*/
    121: 949,
    /*::[*/
    122: 936,
    /*::[*/
    123: 932,
    /*::[*/
    124: 874,
    /*::[*/
    125: 1255,
    /*::[*/
    126: 1256,
    /*::[*/
    150: 10007,
    /*::[*/
    151: 10029,
    /*::[*/
    152: 10006,
    /*::[*/
    200: 1250,
    /*::[*/
    201: 1251,
    /*::[*/
    202: 1254,
    /*::[*/
    203: 1253,
    /*::[*/
    0: 20127
  });
  function t(o, u) {
    var l = [], c = Pa(1);
    switch (u.type) {
      case "base64":
        c = dt(mt(o));
        break;
      case "binary":
        c = dt(o);
        break;
      case "buffer":
      case "array":
        c = o;
        break;
    }
    Vr(c, 0);
    var f = c.read_shift(1), h = !!(f & 136), d = !1, m = !1;
    switch (f) {
      case 2:
        break;
      case 3:
        break;
      case 48:
        d = !0, h = !0;
        break;
      case 49:
        d = !0, h = !0;
        break;
      case 131:
        break;
      case 139:
        break;
      case 140:
        m = !0;
        break;
      case 245:
        break;
      default:
        throw new Error("DBF Unsupported Version: " + f.toString(16));
    }
    var x = 0, p = 521;
    f == 2 && (x = c.read_shift(2)), c.l += 3, f != 2 && (x = c.read_shift(4)), x > 1048576 && (x = 1e6), f != 2 && (p = c.read_shift(2));
    var w = c.read_shift(2), D = u.codepage || 1252;
    f != 2 && (c.l += 16, c.read_shift(1), c[c.l] !== 0 && (D = e[c[c.l]]), c.l += 1, c.l += 2), m && (c.l += 36);
    for (var y = [], B = {}, L = Math.min(c.length, f == 2 ? 521 : p - 10 - (d ? 264 : 0)), U = m ? 32 : 11; c.l < L && c[c.l] != 13; )
      switch (B = {}, B.name = Ue.utils.decode(D, c.slice(c.l, c.l + U)).replace(/[\u0000\r\n].*$/g, ""), c.l += U, B.type = String.fromCharCode(c.read_shift(1)), f != 2 && !m && (B.offset = c.read_shift(4)), B.len = c.read_shift(1), f == 2 && (B.offset = c.read_shift(2)), B.dec = c.read_shift(1), B.name.length && y.push(B), f != 2 && (c.l += m ? 13 : 14), B.type) {
        case "B":
          (!d || B.len != 8) && u.WTF && console.log("Skipping " + B.name + ":" + B.type);
          break;
        case "G":
        case "P":
          u.WTF && console.log("Skipping " + B.name + ":" + B.type);
          break;
        case "+":
        case "0":
        case "@":
        case "C":
        case "D":
        case "F":
        case "I":
        case "L":
        case "M":
        case "N":
        case "O":
        case "T":
        case "Y":
          break;
        default:
          throw new Error("Unknown Field Type: " + B.type);
      }
    if (c[c.l] !== 13 && (c.l = p - 1), c.read_shift(1) !== 13)
      throw new Error("DBF Terminator not found " + c.l + " " + c[c.l]);
    c.l = p;
    var k = 0, v = 0;
    for (l[0] = [], v = 0; v != y.length; ++v)
      l[0][v] = y[v].name;
    for (; x-- > 0; ) {
      if (c[c.l] === 42) {
        c.l += w;
        continue;
      }
      for (++c.l, l[++k] = [], v = 0, v = 0; v != y.length; ++v) {
        var b = c.slice(c.l, c.l + y[v].len);
        c.l += y[v].len, Vr(b, 0);
        var A = Ue.utils.decode(D, b);
        switch (y[v].type) {
          case "C":
            A.trim().length && (l[k][v] = A.replace(/\s+$/, ""));
            break;
          case "D":
            A.length === 8 ? l[k][v] = new Date(+A.slice(0, 4), +A.slice(4, 6) - 1, +A.slice(6, 8)) : l[k][v] = A;
            break;
          case "F":
            l[k][v] = parseFloat(A.trim());
            break;
          case "+":
          case "I":
            l[k][v] = m ? b.read_shift(-4, "i") ^ 2147483648 : b.read_shift(4, "i");
            break;
          case "L":
            switch (A.trim().toUpperCase()) {
              case "Y":
              case "T":
                l[k][v] = !0;
                break;
              case "N":
              case "F":
                l[k][v] = !1;
                break;
              case "":
              case "?":
                break;
              default:
                throw new Error("DBF Unrecognized L:|" + A + "|");
            }
            break;
          case "M":
            if (!h)
              throw new Error("DBF Unexpected MEMO for type " + f.toString(16));
            l[k][v] = "##MEMO##" + (m ? parseInt(A.trim(), 10) : b.read_shift(4));
            break;
          case "N":
            A = A.replace(/\u0000/g, "").trim(), A && A != "." && (l[k][v] = +A || 0);
            break;
          case "@":
            l[k][v] = new Date(b.read_shift(-8, "f") - 621356832e5);
            break;
          case "T":
            l[k][v] = new Date((b.read_shift(4) - 2440588) * 864e5 + b.read_shift(4));
            break;
          case "Y":
            l[k][v] = b.read_shift(4, "i") / 1e4 + b.read_shift(4, "i") / 1e4 * Math.pow(2, 32);
            break;
          case "O":
            l[k][v] = -b.read_shift(-8, "f");
            break;
          case "B":
            if (d && y[v].len == 8) {
              l[k][v] = b.read_shift(8, "f");
              break;
            }
          case "G":
          case "P":
            b.l += y[v].len;
            break;
          case "0":
            if (y[v].name === "_NullFlags")
              break;
          default:
            throw new Error("DBF Unsupported data type " + y[v].type);
        }
      }
    }
    if (f != 2 && c.l < c.length && c[c.l++] != 26)
      throw new Error("DBF EOF Marker missing " + (c.l - 1) + " of " + c.length + " " + c[c.l - 1].toString(16));
    return u && u.sheetRows && (l = l.slice(0, u.sheetRows)), u.DBF = y, l;
  }
  function a(o, u) {
    var l = u || {};
    l.dateNF || (l.dateNF = "yyyymmdd");
    var c = mi(t(o, l), l);
    return c["!cols"] = l.DBF.map(function(f) {
      return {
        wch: f.len,
        DBF: f
      };
    }), delete l.DBF, c;
  }
  function n(o, u) {
    try {
      return Wa(a(o, u), u);
    } catch (l) {
      if (u && u.WTF)
        throw l;
    }
    return { SheetNames: [], Sheets: {} };
  }
  var i = { B: 8, C: 250, L: 1, D: 8, "?": 0, "": 0 };
  function s(o, u) {
    var l = u || {};
    if (+l.codepage >= 0 && kt(+l.codepage), l.type == "string")
      throw new Error("Cannot write DBF to JS string");
    var c = ut(), f = qo(o, { header: 1, raw: !0, cellDates: !0 }), h = f[0], d = f.slice(1), m = o["!cols"] || [], x = 0, p = 0, w = 0, D = 1;
    for (x = 0; x < h.length; ++x) {
      if (((m[x] || {}).DBF || {}).name) {
        h[x] = m[x].DBF.name, ++w;
        continue;
      }
      if (h[x] != null) {
        if (++w, typeof h[x] == "number" && (h[x] = h[x].toString(10)), typeof h[x] != "string")
          throw new Error("DBF Invalid column name " + h[x] + " |" + typeof h[x] + "|");
        if (h.indexOf(h[x]) !== x) {
          for (p = 0; p < 1024; ++p)
            if (h.indexOf(h[x] + "_" + p) == -1) {
              h[x] += "_" + p;
              break;
            }
        }
      }
    }
    var y = Oe(o["!ref"]), B = [], L = [], U = [];
    for (x = 0; x <= y.e.c - y.s.c; ++x) {
      var k = "", v = "", b = 0, A = [];
      for (p = 0; p < d.length; ++p)
        d[p][x] != null && A.push(d[p][x]);
      if (A.length == 0 || h[x] == null) {
        B[x] = "?";
        continue;
      }
      for (p = 0; p < A.length; ++p) {
        switch (typeof A[p]) {
          case "number":
            v = "B";
            break;
          case "string":
            v = "C";
            break;
          case "boolean":
            v = "L";
            break;
          case "object":
            v = A[p] instanceof Date ? "D" : "C";
            break;
          default:
            v = "C";
        }
        b = Math.max(b, String(A[p]).length), k = k && k != v ? "C" : v;
      }
      b > 250 && (b = 250), v = ((m[x] || {}).DBF || {}).type, v == "C" && m[x].DBF.len > b && (b = m[x].DBF.len), k == "B" && v == "N" && (k = "N", U[x] = m[x].DBF.dec, b = m[x].DBF.len), L[x] = k == "C" || v == "N" ? b : i[k] || 0, D += L[x], B[x] = k;
    }
    var T = c.next(32);
    for (T.write_shift(4, 318902576), T.write_shift(4, d.length), T.write_shift(2, 296 + 32 * w), T.write_shift(2, D), x = 0; x < 4; ++x)
      T.write_shift(4, 0);
    for (T.write_shift(4, 0 | (+r[
      /*::String(*/
      ln
      /*::)*/
    ] || 3) << 8), x = 0, p = 0; x < h.length; ++x)
      if (h[x] != null) {
        var C = c.next(32), I = (h[x].slice(-10) + "\0\0\0\0\0\0\0\0\0\0\0").slice(0, 11);
        C.write_shift(1, I, "sbcs"), C.write_shift(1, B[x] == "?" ? "C" : B[x], "sbcs"), C.write_shift(4, p), C.write_shift(1, L[x] || i[B[x]] || 0), C.write_shift(1, U[x] || 0), C.write_shift(1, 2), C.write_shift(4, 0), C.write_shift(1, 0), C.write_shift(4, 0), C.write_shift(4, 0), p += L[x] || i[B[x]] || 0;
      }
    var Y = c.next(264);
    for (Y.write_shift(4, 13), x = 0; x < 65; ++x)
      Y.write_shift(4, 0);
    for (x = 0; x < d.length; ++x) {
      var j = c.next(D);
      for (j.write_shift(1, 0), p = 0; p < h.length; ++p)
        if (h[p] != null)
          switch (B[p]) {
            case "L":
              j.write_shift(1, d[x][p] == null ? 63 : d[x][p] ? 84 : 70);
              break;
            case "B":
              j.write_shift(8, d[x][p] || 0, "f");
              break;
            case "N":
              var J = "0";
              for (typeof d[x][p] == "number" && (J = d[x][p].toFixed(U[p] || 0)), w = 0; w < L[p] - J.length; ++w)
                j.write_shift(1, 32);
              j.write_shift(1, J, "sbcs");
              break;
            case "D":
              d[x][p] ? (j.write_shift(4, ("0000" + d[x][p].getFullYear()).slice(-4), "sbcs"), j.write_shift(2, ("00" + (d[x][p].getMonth() + 1)).slice(-2), "sbcs"), j.write_shift(2, ("00" + d[x][p].getDate()).slice(-2), "sbcs")) : j.write_shift(8, "00000000", "sbcs");
              break;
            case "C":
              var W = String(d[x][p] != null ? d[x][p] : "").slice(0, L[p]);
              for (j.write_shift(1, W, "sbcs"), w = 0; w < L[p] - W.length; ++w)
                j.write_shift(1, 32);
              break;
          }
    }
    return c.next(1).write_shift(1, 26), c.end();
  }
  return {
    to_workbook: n,
    to_sheet: a,
    from_sheet: s
  };
}(), Mv = /* @__PURE__ */ function() {
  var e = {
    AA: "À",
    BA: "Á",
    CA: "Â",
    DA: 195,
    HA: "Ä",
    JA: 197,
    AE: "È",
    BE: "É",
    CE: "Ê",
    HE: "Ë",
    AI: "Ì",
    BI: "Í",
    CI: "Î",
    HI: "Ï",
    AO: "Ò",
    BO: "Ó",
    CO: "Ô",
    DO: 213,
    HO: "Ö",
    AU: "Ù",
    BU: "Ú",
    CU: "Û",
    HU: "Ü",
    Aa: "à",
    Ba: "á",
    Ca: "â",
    Da: 227,
    Ha: "ä",
    Ja: 229,
    Ae: "è",
    Be: "é",
    Ce: "ê",
    He: "ë",
    Ai: "ì",
    Bi: "í",
    Ci: "î",
    Hi: "ï",
    Ao: "ò",
    Bo: "ó",
    Co: "ô",
    Do: 245,
    Ho: "ö",
    Au: "ù",
    Bu: "ú",
    Cu: "û",
    Hu: "ü",
    KC: "Ç",
    Kc: "ç",
    q: "æ",
    z: "œ",
    a: "Æ",
    j: "Œ",
    DN: 209,
    Dn: 241,
    Hy: 255,
    S: 169,
    c: 170,
    R: 174,
    "B ": 180,
    /*::[*/
    0: 176,
    /*::[*/
    1: 177,
    /*::[*/
    2: 178,
    /*::[*/
    3: 179,
    /*::[*/
    5: 181,
    /*::[*/
    6: 182,
    /*::[*/
    7: 183,
    Q: 185,
    k: 186,
    b: 208,
    i: 216,
    l: 222,
    s: 240,
    y: 248,
    "!": 161,
    '"': 162,
    "#": 163,
    "(": 164,
    "%": 165,
    "'": 167,
    "H ": 168,
    "+": 171,
    ";": 187,
    "<": 188,
    "=": 189,
    ">": 190,
    "?": 191,
    "{": 223
  }, r = new RegExp("\x1BN(" + br(e).join("|").replace(/\|\|\|/, "|\\||").replace(/([?()+])/g, "\\$1") + "|\\|)", "gm"), t = function(h, d) {
    var m = e[d];
    return typeof m == "number" ? gl(m) : m;
  }, a = function(h, d, m) {
    var x = d.charCodeAt(0) - 32 << 4 | m.charCodeAt(0) - 48;
    return x == 59 ? h : gl(x);
  };
  e["|"] = 254;
  function n(h, d) {
    switch (d.type) {
      case "base64":
        return i(mt(h), d);
      case "binary":
        return i(h, d);
      case "buffer":
        return i(Ie && Buffer.isBuffer(h) ? h.toString("binary") : Va(h), d);
      case "array":
        return i(fn(h), d);
    }
    throw new Error("Unrecognized type " + d.type);
  }
  function i(h, d) {
    var m = h.split(/[\n\r]+/), x = -1, p = -1, w = 0, D = 0, y = [], B = [], L = null, U = {}, k = [], v = [], b = [], A = 0, T;
    for (+d.codepage >= 0 && kt(+d.codepage); w !== m.length; ++w) {
      A = 0;
      var C = m[w].trim().replace(/\x1B([\x20-\x2F])([\x30-\x3F])/g, a).replace(r, t), I = C.replace(/;;/g, "\0").split(";").map(function(N) {
        return N.replace(/\u0000/g, ";");
      }), Y = I[0], j;
      if (C.length > 0)
        switch (Y) {
          case "ID":
            break;
          case "E":
            break;
          case "B":
            break;
          case "O":
            break;
          case "W":
            break;
          case "P":
            I[1].charAt(0) == "P" && B.push(C.slice(3).replace(/;;/g, ";"));
            break;
          case "C":
            var J = !1, W = !1, ce = !1, V = !1, ee = -1, de = -1;
            for (D = 1; D < I.length; ++D)
              switch (I[D].charAt(0)) {
                case "A":
                  break;
                case "X":
                  p = parseInt(I[D].slice(1)) - 1, W = !0;
                  break;
                case "Y":
                  for (x = parseInt(I[D].slice(1)) - 1, W || (p = 0), T = y.length; T <= x; ++T)
                    y[T] = [];
                  break;
                case "K":
                  j = I[D].slice(1), j.charAt(0) === '"' ? j = j.slice(1, j.length - 1) : j === "TRUE" ? j = !0 : j === "FALSE" ? j = !1 : isNaN(Ot(j)) ? isNaN(oi(j).getDate()) || (j = ur(j)) : (j = Ot(j), L !== null && pn(L) && (j = v0(j))), typeof Ue < "u" && typeof j == "string" && (d || {}).type != "string" && (d || {}).codepage && (j = Ue.utils.decode(d.codepage, j)), J = !0;
                  break;
                case "E":
                  V = !0;
                  var F = Kn(I[D].slice(1), { r: x, c: p });
                  y[x][p] = [y[x][p], F];
                  break;
                case "S":
                  ce = !0, y[x][p] = [y[x][p], "S5S"];
                  break;
                case "G":
                  break;
                case "R":
                  ee = parseInt(I[D].slice(1)) - 1;
                  break;
                case "C":
                  de = parseInt(I[D].slice(1)) - 1;
                  break;
                default:
                  if (d && d.WTF)
                    throw new Error("SYLK bad record " + C);
              }
            if (J && (y[x][p] && y[x][p].length == 2 ? y[x][p][0] = j : y[x][p] = j, L = null), ce) {
              if (V)
                throw new Error("SYLK shared formula cannot have own formula");
              var H = ee > -1 && y[ee][de];
              if (!H || !H[1])
                throw new Error("SYLK shared formula cannot find base");
              y[x][p][1] = e2(H[1], { r: x - ee, c: p - de });
            }
            break;
          case "F":
            var P = 0;
            for (D = 1; D < I.length; ++D)
              switch (I[D].charAt(0)) {
                case "X":
                  p = parseInt(I[D].slice(1)) - 1, ++P;
                  break;
                case "Y":
                  for (x = parseInt(I[D].slice(1)) - 1, T = y.length; T <= x; ++T)
                    y[T] = [];
                  break;
                case "M":
                  A = parseInt(I[D].slice(1)) / 20;
                  break;
                case "F":
                  break;
                case "G":
                  break;
                case "P":
                  L = B[parseInt(I[D].slice(1))];
                  break;
                case "S":
                  break;
                case "D":
                  break;
                case "N":
                  break;
                case "W":
                  for (b = I[D].slice(1).split(" "), T = parseInt(b[0], 10); T <= parseInt(b[1], 10); ++T)
                    A = parseInt(b[2], 10), v[T - 1] = A === 0 ? { hidden: !0 } : { wch: A }, Ma(v[T - 1]);
                  break;
                case "C":
                  p = parseInt(I[D].slice(1)) - 1, v[p] || (v[p] = {});
                  break;
                case "R":
                  x = parseInt(I[D].slice(1)) - 1, k[x] || (k[x] = {}), A > 0 ? (k[x].hpt = A, k[x].hpx = li(A)) : A === 0 && (k[x].hidden = !0);
                  break;
                default:
                  if (d && d.WTF)
                    throw new Error("SYLK bad record " + C);
              }
            P < 1 && (L = null);
            break;
          default:
            if (d && d.WTF)
              throw new Error("SYLK bad record " + C);
        }
    }
    return k.length > 0 && (U["!rows"] = k), v.length > 0 && (U["!cols"] = v), d && d.sheetRows && (y = y.slice(0, d.sheetRows)), [y, U];
  }
  function s(h, d) {
    var m = n(h, d), x = m[0], p = m[1], w = mi(x, d);
    return br(p).forEach(function(D) {
      w[D] = p[D];
    }), w;
  }
  function o(h, d) {
    return Wa(s(h, d), d);
  }
  function u(h, d, m, x) {
    var p = "C;Y" + (m + 1) + ";X" + (x + 1) + ";K";
    switch (h.t) {
      case "n":
        p += h.v || 0, h.f && !h.F && (p += ";E" + Yc(h.f, { r: m, c: x }));
        break;
      case "b":
        p += h.v ? "TRUE" : "FALSE";
        break;
      case "e":
        p += h.w || h.v;
        break;
      case "d":
        p += '"' + (h.w || h.v) + '"';
        break;
      case "s":
        p += '"' + h.v.replace(/"/g, "").replace(/;/g, ";;") + '"';
        break;
    }
    return p;
  }
  function l(h, d) {
    d.forEach(function(m, x) {
      var p = "F;W" + (x + 1) + " " + (x + 1) + " ";
      m.hidden ? p += "0" : (typeof m.width == "number" && !m.wpx && (m.wpx = us(m.width)), typeof m.wpx == "number" && !m.wch && (m.wch = ls(m.wpx)), typeof m.wch == "number" && (p += Math.round(m.wch))), p.charAt(p.length - 1) != " " && h.push(p);
    });
  }
  function c(h, d) {
    d.forEach(function(m, x) {
      var p = "F;";
      m.hidden ? p += "M0;" : m.hpt ? p += "M" + 20 * m.hpt + ";" : m.hpx && (p += "M" + 20 * cs(m.hpx) + ";"), p.length > 2 && h.push(p + "R" + (x + 1));
    });
  }
  function f(h, d) {
    var m = ["ID;PWXL;N;E"], x = [], p = Oe(h["!ref"]), w, D = Array.isArray(h), y = `\r
`;
    m.push("P;PGeneral"), m.push("F;P0;DG0G8;M255"), h["!cols"] && l(m, h["!cols"]), h["!rows"] && c(m, h["!rows"]), m.push("B;Y" + (p.e.r - p.s.r + 1) + ";X" + (p.e.c - p.s.c + 1) + ";D" + [p.s.c, p.s.r, p.e.c, p.e.r].join(" "));
    for (var B = p.s.r; B <= p.e.r; ++B)
      for (var L = p.s.c; L <= p.e.c; ++L) {
        var U = Te({ r: B, c: L });
        w = D ? (h[B] || [])[L] : h[U], !(!w || w.v == null && (!w.f || w.F)) && x.push(u(w, h, B, L));
      }
    return m.join(y) + y + x.join(y) + y + "E" + y;
  }
  return {
    to_workbook: o,
    to_sheet: s,
    from_sheet: f
  };
}(), Ov = /* @__PURE__ */ function() {
  function e(i, s) {
    switch (s.type) {
      case "base64":
        return r(mt(i), s);
      case "binary":
        return r(i, s);
      case "buffer":
        return r(Ie && Buffer.isBuffer(i) ? i.toString("binary") : Va(i), s);
      case "array":
        return r(fn(i), s);
    }
    throw new Error("Unrecognized type " + s.type);
  }
  function r(i, s) {
    for (var o = i.split(`
`), u = -1, l = -1, c = 0, f = []; c !== o.length; ++c) {
      if (o[c].trim() === "BOT") {
        f[++u] = [], l = 0;
        continue;
      }
      if (!(u < 0)) {
        var h = o[c].trim().split(","), d = h[0], m = h[1];
        ++c;
        for (var x = o[c] || ""; (x.match(/["]/g) || []).length & 1 && c < o.length - 1; )
          x += `
` + o[++c];
        switch (x = x.trim(), +d) {
          case -1:
            if (x === "BOT") {
              f[++u] = [], l = 0;
              continue;
            } else if (x !== "EOD")
              throw new Error("Unrecognized DIF special command " + x);
            break;
          case 0:
            x === "TRUE" ? f[u][l] = !0 : x === "FALSE" ? f[u][l] = !1 : isNaN(Ot(m)) ? isNaN(oi(m).getDate()) ? f[u][l] = m : f[u][l] = ur(m) : f[u][l] = Ot(m), ++l;
            break;
          case 1:
            x = x.slice(1, x.length - 1), x = x.replace(/""/g, '"'), x && x.match(/^=".*"$/) && (x = x.slice(2, -1)), f[u][l++] = x !== "" ? x : null;
            break;
        }
        if (x === "EOD")
          break;
      }
    }
    return s && s.sheetRows && (f = f.slice(0, s.sheetRows)), f;
  }
  function t(i, s) {
    return mi(e(i, s), s);
  }
  function a(i, s) {
    return Wa(t(i, s), s);
  }
  var n = /* @__PURE__ */ function() {
    var i = function(u, l, c, f, h) {
      u.push(l), u.push(c + "," + f), u.push('"' + h.replace(/"/g, '""') + '"');
    }, s = function(u, l, c, f) {
      u.push(l + "," + c), u.push(l == 1 ? '"' + f.replace(/"/g, '""') + '"' : f);
    };
    return function(u) {
      var l = [], c = Oe(u["!ref"]), f, h = Array.isArray(u);
      i(l, "TABLE", 0, 1, "sheetjs"), i(l, "VECTORS", 0, c.e.r - c.s.r + 1, ""), i(l, "TUPLES", 0, c.e.c - c.s.c + 1, ""), i(l, "DATA", 0, 0, "");
      for (var d = c.s.r; d <= c.e.r; ++d) {
        s(l, -1, 0, "BOT");
        for (var m = c.s.c; m <= c.e.c; ++m) {
          var x = Te({ r: d, c: m });
          if (f = h ? (u[d] || [])[m] : u[x], !f) {
            s(l, 1, 0, "");
            continue;
          }
          switch (f.t) {
            case "n":
              var p = f.w;
              !p && f.v != null && (p = f.v), p == null ? f.f && !f.F ? s(l, 1, 0, "=" + f.f) : s(l, 1, 0, "") : s(l, 0, p, "V");
              break;
            case "b":
              s(l, 0, f.v ? 1 : 0, f.v ? "TRUE" : "FALSE");
              break;
            case "s":
              s(l, 1, 0, isNaN(f.v) ? f.v : '="' + f.v + '"');
              break;
            case "d":
              f.w || (f.w = pt(f.z || Ee[14], Ar(ur(f.v)))), s(l, 0, f.w, "V");
              break;
            default:
              s(l, 1, 0, "");
          }
        }
      }
      s(l, -1, 0, "EOD");
      var w = `\r
`, D = l.join(w);
      return D;
    };
  }();
  return {
    to_workbook: a,
    to_sheet: t,
    from_sheet: n
  };
}(), Lv = /* @__PURE__ */ function() {
  function e(f) {
    return f.replace(/\\b/g, "\\").replace(/\\c/g, ":").replace(/\\n/g, `
`);
  }
  function r(f) {
    return f.replace(/\\/g, "\\b").replace(/:/g, "\\c").replace(/\n/g, "\\n");
  }
  function t(f, h) {
    for (var d = f.split(`
`), m = -1, x = -1, p = 0, w = []; p !== d.length; ++p) {
      var D = d[p].trim().split(":");
      if (D[0] === "cell") {
        var y = fr(D[1]);
        if (w.length <= y.r)
          for (m = w.length; m <= y.r; ++m)
            w[m] || (w[m] = []);
        switch (m = y.r, x = y.c, D[2]) {
          case "t":
            w[m][x] = e(D[3]);
            break;
          case "v":
            w[m][x] = +D[3];
            break;
          case "vtf":
            var B = D[D.length - 1];
          case "vtc":
            switch (D[3]) {
              case "nl":
                w[m][x] = !!+D[4];
                break;
              default:
                w[m][x] = +D[4];
                break;
            }
            D[2] == "vtf" && (w[m][x] = [w[m][x], B]);
        }
      }
    }
    return h && h.sheetRows && (w = w.slice(0, h.sheetRows)), w;
  }
  function a(f, h) {
    return mi(t(f, h), h);
  }
  function n(f, h) {
    return Wa(a(f, h), h);
  }
  var i = [
    "socialcalc:version:1.5",
    "MIME-Version: 1.0",
    "Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"
  ].join(`
`), s = [
    "--SocialCalcSpreadsheetControlSave",
    "Content-type: text/plain; charset=UTF-8"
  ].join(`
`) + `
`, o = [
    "# SocialCalc Spreadsheet Control Save",
    "part:sheet"
  ].join(`
`), u = "--SocialCalcSpreadsheetControlSave--";
  function l(f) {
    if (!f || !f["!ref"])
      return "";
    for (var h = [], d = [], m, x = "", p = tt(f["!ref"]), w = Array.isArray(f), D = p.s.r; D <= p.e.r; ++D)
      for (var y = p.s.c; y <= p.e.c; ++y)
        if (x = Te({ r: D, c: y }), m = w ? (f[D] || [])[y] : f[x], !(!m || m.v == null || m.t === "z")) {
          switch (d = ["cell", x, "t"], m.t) {
            case "s":
            case "str":
              d.push(r(m.v));
              break;
            case "n":
              m.f ? (d[2] = "vtf", d[3] = "n", d[4] = m.v, d[5] = r(m.f)) : (d[2] = "v", d[3] = m.v);
              break;
            case "b":
              d[2] = "vt" + (m.f ? "f" : "c"), d[3] = "nl", d[4] = m.v ? "1" : "0", d[5] = r(m.f || (m.v ? "TRUE" : "FALSE"));
              break;
            case "d":
              var B = Ar(ur(m.v));
              d[2] = "vtc", d[3] = "nd", d[4] = "" + B, d[5] = m.w || pt(m.z || Ee[14], B);
              break;
            case "e":
              continue;
          }
          h.push(d.join(":"));
        }
    return h.push("sheet:c:" + (p.e.c - p.s.c + 1) + ":r:" + (p.e.r - p.s.r + 1) + ":tvf:1"), h.push("valueformat:1:text-wiki"), h.join(`
`);
  }
  function c(f) {
    return [i, s, o, s, l(f), u].join(`
`);
  }
  return {
    to_workbook: n,
    to_sheet: a,
    from_sheet: c
  };
}(), ui = /* @__PURE__ */ function() {
  function e(c, f, h, d, m) {
    m.raw ? f[h][d] = c : c === "" || (c === "TRUE" ? f[h][d] = !0 : c === "FALSE" ? f[h][d] = !1 : isNaN(Ot(c)) ? isNaN(oi(c).getDate()) ? f[h][d] = c : f[h][d] = ur(c) : f[h][d] = Ot(c));
  }
  function r(c, f) {
    var h = f || {}, d = [];
    if (!c || c.length === 0)
      return d;
    for (var m = c.split(/[\r\n]/), x = m.length - 1; x >= 0 && m[x].length === 0; )
      --x;
    for (var p = 10, w = 0, D = 0; D <= x; ++D)
      w = m[D].indexOf(" "), w == -1 ? w = m[D].length : w++, p = Math.max(p, w);
    for (D = 0; D <= x; ++D) {
      d[D] = [];
      var y = 0;
      for (e(m[D].slice(0, p).trim(), d, D, y, h), y = 1; y <= (m[D].length - p) / 10 + 1; ++y)
        e(m[D].slice(p + (y - 1) * 10, p + y * 10).trim(), d, D, y, h);
    }
    return h.sheetRows && (d = d.slice(0, h.sheetRows)), d;
  }
  var t = {
    /*::[*/
    44: ",",
    /*::[*/
    9: "	",
    /*::[*/
    59: ";",
    /*::[*/
    124: "|"
  }, a = {
    /*::[*/
    44: 3,
    /*::[*/
    9: 2,
    /*::[*/
    59: 1,
    /*::[*/
    124: 0
  };
  function n(c) {
    for (var f = {}, h = !1, d = 0, m = 0; d < c.length; ++d)
      (m = c.charCodeAt(d)) == 34 ? h = !h : !h && m in t && (f[m] = (f[m] || 0) + 1);
    m = [];
    for (d in f)
      Object.prototype.hasOwnProperty.call(f, d) && m.push([f[d], d]);
    if (!m.length) {
      f = a;
      for (d in f)
        Object.prototype.hasOwnProperty.call(f, d) && m.push([f[d], d]);
    }
    return m.sort(function(x, p) {
      return x[0] - p[0] || a[x[1]] - a[p[1]];
    }), t[m.pop()[1]] || 44;
  }
  function i(c, f) {
    var h = f || {}, d = "", m = h.dense ? [] : {}, x = { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } };
    c.slice(0, 4) == "sep=" ? c.charCodeAt(5) == 13 && c.charCodeAt(6) == 10 ? (d = c.charAt(4), c = c.slice(7)) : c.charCodeAt(5) == 13 || c.charCodeAt(5) == 10 ? (d = c.charAt(4), c = c.slice(6)) : d = n(c.slice(0, 1024)) : h && h.FS ? d = h.FS : d = n(c.slice(0, 1024));
    var p = 0, w = 0, D = 0, y = 0, B = 0, L = d.charCodeAt(0), U = !1, k = 0, v = c.charCodeAt(0);
    c = c.replace(/\r\n/mg, `
`);
    var b = h.dateNF != null ? W5(h.dateNF) : null;
    function A() {
      var T = c.slice(y, B), C = {};
      if (T.charAt(0) == '"' && T.charAt(T.length - 1) == '"' && (T = T.slice(1, -1).replace(/""/g, '"')), T.length === 0)
        C.t = "z";
      else if (h.raw)
        C.t = "s", C.v = T;
      else if (T.trim().length === 0)
        C.t = "s", C.v = T;
      else if (T.charCodeAt(0) == 61)
        T.charCodeAt(1) == 34 && T.charCodeAt(T.length - 1) == 34 ? (C.t = "s", C.v = T.slice(2, -1).replace(/""/g, '"')) : g7(T) ? (C.t = "n", C.f = T.slice(1)) : (C.t = "s", C.v = T);
      else if (T == "TRUE")
        C.t = "b", C.v = !0;
      else if (T == "FALSE")
        C.t = "b", C.v = !1;
      else if (!isNaN(D = Ot(T)))
        C.t = "n", h.cellText !== !1 && (C.w = T), C.v = D;
      else if (!isNaN(oi(T).getDate()) || b && T.match(b)) {
        C.z = h.dateNF || Ee[14];
        var I = 0;
        b && T.match(b) && (T = H5(T, h.dateNF, T.match(b) || []), I = 1), h.cellDates ? (C.t = "d", C.v = ur(T, I)) : (C.t = "n", C.v = Ar(ur(T, I))), h.cellText !== !1 && (C.w = pt(C.z, C.v instanceof Date ? Ar(C.v) : C.v)), h.cellNF || delete C.z;
      } else
        C.t = "s", C.v = T;
      if (C.t == "z" || (h.dense ? (m[p] || (m[p] = []), m[p][w] = C) : m[Te({ c: w, r: p })] = C), y = B + 1, v = c.charCodeAt(y), x.e.c < w && (x.e.c = w), x.e.r < p && (x.e.r = p), k == L)
        ++w;
      else if (w = 0, ++p, h.sheetRows && h.sheetRows <= p)
        return !0;
    }
    e:
      for (; B < c.length; ++B)
        switch (k = c.charCodeAt(B)) {
          case 34:
            v === 34 && (U = !U);
            break;
          case L:
          case 10:
          case 13:
            if (!U && A())
              break e;
            break;
        }
    return B - y > 0 && A(), m["!ref"] = Ce(x), m;
  }
  function s(c, f) {
    return !(f && f.PRN) || f.FS || c.slice(0, 4) == "sep=" || c.indexOf("	") >= 0 || c.indexOf(",") >= 0 || c.indexOf(";") >= 0 ? i(c, f) : mi(r(c, f), f);
  }
  function o(c, f) {
    var h = "", d = f.type == "string" ? [0, 0, 0, 0] : af(c, f);
    switch (f.type) {
      case "base64":
        h = mt(c);
        break;
      case "binary":
        h = c;
        break;
      case "buffer":
        f.codepage == 65001 ? h = c.toString("utf8") : f.codepage && typeof Ue < "u" ? h = Ue.utils.decode(f.codepage, c) : h = Ie && Buffer.isBuffer(c) ? c.toString("binary") : Va(c);
        break;
      case "array":
        h = fn(c);
        break;
      case "string":
        h = c;
        break;
      default:
        throw new Error("Unrecognized type " + f.type);
    }
    return d[0] == 239 && d[1] == 187 && d[2] == 191 ? h = Qe(h.slice(3)) : f.type != "string" && f.type != "buffer" && f.codepage == 65001 ? h = Qe(h) : f.type == "binary" && typeof Ue < "u" && f.codepage && (h = Ue.utils.decode(f.codepage, Ue.utils.encode(28591, h))), h.slice(0, 19) == "socialcalc:version:" ? Lv.to_sheet(f.type == "string" ? h : Qe(h), f) : s(h, f);
  }
  function u(c, f) {
    return Wa(o(c, f), f);
  }
  function l(c) {
    for (var f = [], h = Oe(c["!ref"]), d, m = Array.isArray(c), x = h.s.r; x <= h.e.r; ++x) {
      for (var p = [], w = h.s.c; w <= h.e.c; ++w) {
        var D = Te({ r: x, c: w });
        if (d = m ? (c[x] || [])[w] : c[D], !d || d.v == null) {
          p.push("          ");
          continue;
        }
        for (var y = (d.w || (Yt(d), d.w) || "").slice(0, 10); y.length < 10; )
          y += " ";
        p.push(y + (w === 0 ? " " : ""));
      }
      f.push(p.join(""));
    }
    return f.join(`
`);
  }
  return {
    to_workbook: u,
    to_sheet: o,
    from_sheet: l
  };
}();
function nD(e, r) {
  var t = r || {}, a = !!t.WTF;
  t.WTF = !0;
  try {
    var n = Mv.to_workbook(e, t);
    return t.WTF = a, n;
  } catch (i) {
    if (t.WTF = a, !i.message.match(/SYLK bad record ID/) && a)
      throw i;
    return ui.to_workbook(e, r);
  }
}
var rn = /* @__PURE__ */ function() {
  function e(F, H, P) {
    if (F) {
      Vr(F, F.l || 0);
      for (var N = P.Enum || ee; F.l < F.length; ) {
        var X = F.read_shift(2), ae = N[X] || N[65535], ie = F.read_shift(2), q = F.l + ie, re = ae.f && ae.f(F, ie, P);
        if (F.l = q, H(re, ae, X))
          return;
      }
    }
  }
  function r(F, H) {
    switch (H.type) {
      case "base64":
        return t(dt(mt(F)), H);
      case "binary":
        return t(dt(F), H);
      case "buffer":
      case "array":
        return t(F, H);
    }
    throw "Unsupported type " + H.type;
  }
  function t(F, H) {
    if (!F)
      return F;
    var P = H || {}, N = P.dense ? [] : {}, X = "Sheet1", ae = "", ie = 0, q = {}, re = [], ve = [], M = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } }, _e = P.sheetRows || 0;
    if (F[2] == 0 && (F[3] == 8 || F[3] == 9) && F.length >= 16 && F[14] == 5 && F[15] === 108)
      throw new Error("Unsupported Works 3 for Mac file");
    if (F[2] == 2)
      P.Enum = ee, e(F, function(fe, Me, Je) {
        switch (Je) {
          case 0:
            P.vers = fe, fe >= 4096 && (P.qpro = !0);
            break;
          case 6:
            M = fe;
            break;
          case 204:
            fe && (ae = fe);
            break;
          case 222:
            ae = fe;
            break;
          case 15:
          case 51:
            P.qpro || (fe[1].v = fe[1].v.slice(1));
          case 13:
          case 14:
          case 16:
            Je == 14 && (fe[2] & 112) == 112 && (fe[2] & 15) > 1 && (fe[2] & 15) < 15 && (fe[1].z = P.dateNF || Ee[14], P.cellDates && (fe[1].t = "d", fe[1].v = v0(fe[1].v))), P.qpro && fe[3] > ie && (N["!ref"] = Ce(M), q[X] = N, re.push(X), N = P.dense ? [] : {}, M = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } }, ie = fe[3], X = ae || "Sheet" + (ie + 1), ae = "");
            var dr = P.dense ? (N[fe[0].r] || [])[fe[0].c] : N[Te(fe[0])];
            if (dr) {
              dr.t = fe[1].t, dr.v = fe[1].v, fe[1].z != null && (dr.z = fe[1].z), fe[1].f != null && (dr.f = fe[1].f);
              break;
            }
            P.dense ? (N[fe[0].r] || (N[fe[0].r] = []), N[fe[0].r][fe[0].c] = fe[1]) : N[Te(fe[0])] = fe[1];
            break;
        }
      }, P);
    else if (F[2] == 26 || F[2] == 14)
      P.Enum = de, F[2] == 14 && (P.qpro = !0, F.l = 0), e(F, function(fe, Me, Je) {
        switch (Je) {
          case 204:
            X = fe;
            break;
          case 22:
            fe[1].v = fe[1].v.slice(1);
          case 23:
          case 24:
          case 25:
          case 37:
          case 39:
          case 40:
            if (fe[3] > ie && (N["!ref"] = Ce(M), q[X] = N, re.push(X), N = P.dense ? [] : {}, M = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } }, ie = fe[3], X = "Sheet" + (ie + 1)), _e > 0 && fe[0].r >= _e)
              break;
            P.dense ? (N[fe[0].r] || (N[fe[0].r] = []), N[fe[0].r][fe[0].c] = fe[1]) : N[Te(fe[0])] = fe[1], M.e.c < fe[0].c && (M.e.c = fe[0].c), M.e.r < fe[0].r && (M.e.r = fe[0].r);
            break;
          case 27:
            fe[14e3] && (ve[fe[14e3][0]] = fe[14e3][1]);
            break;
          case 1537:
            ve[fe[0]] = fe[1], fe[0] == ie && (X = fe[1]);
            break;
        }
      }, P);
    else
      throw new Error("Unrecognized LOTUS BOF " + F[2]);
    if (N["!ref"] = Ce(M), q[ae || X] = N, re.push(ae || X), !ve.length)
      return { SheetNames: re, Sheets: q };
    for (var De = {}, $e = [], ge = 0; ge < ve.length; ++ge)
      q[re[ge]] ? ($e.push(ve[ge] || re[ge]), De[ve[ge]] = q[ve[ge]] || q[re[ge]]) : ($e.push(ve[ge]), De[ve[ge]] = { "!ref": "A1" });
    return { SheetNames: $e, Sheets: De };
  }
  function a(F, H) {
    var P = H || {};
    if (+P.codepage >= 0 && kt(+P.codepage), P.type == "string")
      throw new Error("Cannot write WK1 to JS string");
    var N = ut(), X = Oe(F["!ref"]), ae = Array.isArray(F), ie = [];
    xe(N, 0, i(1030)), xe(N, 6, u(X));
    for (var q = Math.min(X.e.r, 8191), re = X.s.r; re <= q; ++re)
      for (var ve = gr(re), M = X.s.c; M <= X.e.c; ++M) {
        re === X.s.r && (ie[M] = or(M));
        var _e = ie[M] + ve, De = ae ? (F[re] || [])[M] : F[_e];
        if (!(!De || De.t == "z"))
          if (De.t == "n")
            (De.v | 0) == De.v && De.v >= -32768 && De.v <= 32767 ? xe(N, 13, d(re, M, De.v)) : xe(N, 14, x(re, M, De.v));
          else {
            var $e = Yt(De);
            xe(N, 15, f(re, M, $e.slice(0, 239)));
          }
      }
    return xe(N, 1), N.end();
  }
  function n(F, H) {
    var P = H || {};
    if (+P.codepage >= 0 && kt(+P.codepage), P.type == "string")
      throw new Error("Cannot write WK3 to JS string");
    var N = ut();
    xe(N, 0, s(F));
    for (var X = 0, ae = 0; X < F.SheetNames.length; ++X)
      (F.Sheets[F.SheetNames[X]] || {})["!ref"] && xe(N, 27, V(F.SheetNames[X], ae++));
    var ie = 0;
    for (X = 0; X < F.SheetNames.length; ++X) {
      var q = F.Sheets[F.SheetNames[X]];
      if (!(!q || !q["!ref"])) {
        for (var re = Oe(q["!ref"]), ve = Array.isArray(q), M = [], _e = Math.min(re.e.r, 8191), De = re.s.r; De <= _e; ++De)
          for (var $e = gr(De), ge = re.s.c; ge <= re.e.c; ++ge) {
            De === re.s.r && (M[ge] = or(ge));
            var fe = M[ge] + $e, Me = ve ? (q[De] || [])[ge] : q[fe];
            if (!(!Me || Me.t == "z"))
              if (Me.t == "n")
                xe(N, 23, A(De, ge, ie, Me.v));
              else {
                var Je = Yt(Me);
                xe(N, 22, k(De, ge, ie, Je.slice(0, 239)));
              }
          }
        ++ie;
      }
    }
    return xe(N, 1), N.end();
  }
  function i(F) {
    var H = te(2);
    return H.write_shift(2, F), H;
  }
  function s(F) {
    var H = te(26);
    H.write_shift(2, 4096), H.write_shift(2, 4), H.write_shift(4, 0);
    for (var P = 0, N = 0, X = 0, ae = 0; ae < F.SheetNames.length; ++ae) {
      var ie = F.SheetNames[ae], q = F.Sheets[ie];
      if (!(!q || !q["!ref"])) {
        ++X;
        var re = tt(q["!ref"]);
        P < re.e.r && (P = re.e.r), N < re.e.c && (N = re.e.c);
      }
    }
    return P > 8191 && (P = 8191), H.write_shift(2, P), H.write_shift(1, X), H.write_shift(1, N), H.write_shift(2, 0), H.write_shift(2, 0), H.write_shift(1, 1), H.write_shift(1, 2), H.write_shift(4, 0), H.write_shift(4, 0), H;
  }
  function o(F, H, P) {
    var N = { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } };
    return H == 8 && P.qpro ? (N.s.c = F.read_shift(1), F.l++, N.s.r = F.read_shift(2), N.e.c = F.read_shift(1), F.l++, N.e.r = F.read_shift(2), N) : (N.s.c = F.read_shift(2), N.s.r = F.read_shift(2), H == 12 && P.qpro && (F.l += 2), N.e.c = F.read_shift(2), N.e.r = F.read_shift(2), H == 12 && P.qpro && (F.l += 2), N.s.c == 65535 && (N.s.c = N.e.c = N.s.r = N.e.r = 0), N);
  }
  function u(F) {
    var H = te(8);
    return H.write_shift(2, F.s.c), H.write_shift(2, F.s.r), H.write_shift(2, F.e.c), H.write_shift(2, F.e.r), H;
  }
  function l(F, H, P) {
    var N = [{ c: 0, r: 0 }, { t: "n", v: 0 }, 0, 0];
    return P.qpro && P.vers != 20768 ? (N[0].c = F.read_shift(1), N[3] = F.read_shift(1), N[0].r = F.read_shift(2), F.l += 2) : (N[2] = F.read_shift(1), N[0].c = F.read_shift(2), N[0].r = F.read_shift(2)), N;
  }
  function c(F, H, P) {
    var N = F.l + H, X = l(F, H, P);
    if (X[1].t = "s", P.vers == 20768) {
      F.l++;
      var ae = F.read_shift(1);
      return X[1].v = F.read_shift(ae, "utf8"), X;
    }
    return P.qpro && F.l++, X[1].v = F.read_shift(N - F.l, "cstr"), X;
  }
  function f(F, H, P) {
    var N = te(7 + P.length);
    N.write_shift(1, 255), N.write_shift(2, H), N.write_shift(2, F), N.write_shift(1, 39);
    for (var X = 0; X < N.length; ++X) {
      var ae = P.charCodeAt(X);
      N.write_shift(1, ae >= 128 ? 95 : ae);
    }
    return N.write_shift(1, 0), N;
  }
  function h(F, H, P) {
    var N = l(F, H, P);
    return N[1].v = F.read_shift(2, "i"), N;
  }
  function d(F, H, P) {
    var N = te(7);
    return N.write_shift(1, 255), N.write_shift(2, H), N.write_shift(2, F), N.write_shift(2, P, "i"), N;
  }
  function m(F, H, P) {
    var N = l(F, H, P);
    return N[1].v = F.read_shift(8, "f"), N;
  }
  function x(F, H, P) {
    var N = te(13);
    return N.write_shift(1, 255), N.write_shift(2, H), N.write_shift(2, F), N.write_shift(8, P, "f"), N;
  }
  function p(F, H, P) {
    var N = F.l + H, X = l(F, H, P);
    if (X[1].v = F.read_shift(8, "f"), P.qpro)
      F.l = N;
    else {
      var ae = F.read_shift(2);
      B(F.slice(F.l, F.l + ae), X), F.l += ae;
    }
    return X;
  }
  function w(F, H, P) {
    var N = H & 32768;
    return H &= -32769, H = (N ? F : 0) + (H >= 8192 ? H - 16384 : H), (N ? "" : "$") + (P ? or(H) : gr(H));
  }
  var D = {
    51: ["FALSE", 0],
    52: ["TRUE", 0],
    70: ["LEN", 1],
    80: ["SUM", 69],
    81: ["AVERAGEA", 69],
    82: ["COUNTA", 69],
    83: ["MINA", 69],
    84: ["MAXA", 69],
    111: ["T", 1]
  }, y = [
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    // eslint-disable-line no-mixed-spaces-and-tabs
    "",
    "+",
    "-",
    "*",
    "/",
    "^",
    "=",
    "<>",
    // eslint-disable-line no-mixed-spaces-and-tabs
    "<=",
    ">=",
    "<",
    ">",
    "",
    "",
    "",
    "",
    // eslint-disable-line no-mixed-spaces-and-tabs
    "&",
    "",
    "",
    "",
    "",
    "",
    "",
    ""
    // eslint-disable-line no-mixed-spaces-and-tabs
  ];
  function B(F, H) {
    Vr(F, 0);
    for (var P = [], N = 0, X = "", ae = "", ie = "", q = ""; F.l < F.length; ) {
      var re = F[F.l++];
      switch (re) {
        case 0:
          P.push(F.read_shift(8, "f"));
          break;
        case 1:
          ae = w(H[0].c, F.read_shift(2), !0), X = w(H[0].r, F.read_shift(2), !1), P.push(ae + X);
          break;
        case 2:
          {
            var ve = w(H[0].c, F.read_shift(2), !0), M = w(H[0].r, F.read_shift(2), !1);
            ae = w(H[0].c, F.read_shift(2), !0), X = w(H[0].r, F.read_shift(2), !1), P.push(ve + M + ":" + ae + X);
          }
          break;
        case 3:
          if (F.l < F.length) {
            console.error("WK1 premature formula end");
            return;
          }
          break;
        case 4:
          P.push("(" + P.pop() + ")");
          break;
        case 5:
          P.push(F.read_shift(2));
          break;
        case 6:
          {
            for (var _e = ""; re = F[F.l++]; )
              _e += String.fromCharCode(re);
            P.push('"' + _e.replace(/"/g, '""') + '"');
          }
          break;
        case 8:
          P.push("-" + P.pop());
          break;
        case 23:
          P.push("+" + P.pop());
          break;
        case 22:
          P.push("NOT(" + P.pop() + ")");
          break;
        case 20:
        case 21:
          q = P.pop(), ie = P.pop(), P.push(["AND", "OR"][re - 20] + "(" + ie + "," + q + ")");
          break;
        default:
          if (re < 32 && y[re])
            q = P.pop(), ie = P.pop(), P.push(ie + y[re] + q);
          else if (D[re]) {
            if (N = D[re][1], N == 69 && (N = F[F.l++]), N > P.length) {
              console.error("WK1 bad formula parse 0x" + re.toString(16) + ":|" + P.join("|") + "|");
              return;
            }
            var De = P.slice(-N);
            P.length -= N, P.push(D[re][0] + "(" + De.join(",") + ")");
          } else
            return re <= 7 ? console.error("WK1 invalid opcode " + re.toString(16)) : re <= 24 ? console.error("WK1 unsupported op " + re.toString(16)) : re <= 30 ? console.error("WK1 invalid opcode " + re.toString(16)) : re <= 115 ? console.error("WK1 unsupported function opcode " + re.toString(16)) : console.error("WK1 unrecognized opcode " + re.toString(16));
      }
    }
    P.length == 1 ? H[1].f = "" + P[0] : console.error("WK1 bad formula parse |" + P.join("|") + "|");
  }
  function L(F) {
    var H = [{ c: 0, r: 0 }, { t: "n", v: 0 }, 0];
    return H[0].r = F.read_shift(2), H[3] = F[F.l++], H[0].c = F[F.l++], H;
  }
  function U(F, H) {
    var P = L(F);
    return P[1].t = "s", P[1].v = F.read_shift(H - 4, "cstr"), P;
  }
  function k(F, H, P, N) {
    var X = te(6 + N.length);
    X.write_shift(2, F), X.write_shift(1, P), X.write_shift(1, H), X.write_shift(1, 39);
    for (var ae = 0; ae < N.length; ++ae) {
      var ie = N.charCodeAt(ae);
      X.write_shift(1, ie >= 128 ? 95 : ie);
    }
    return X.write_shift(1, 0), X;
  }
  function v(F, H) {
    var P = L(F);
    P[1].v = F.read_shift(2);
    var N = P[1].v >> 1;
    if (P[1].v & 1)
      switch (N & 7) {
        case 0:
          N = (N >> 3) * 5e3;
          break;
        case 1:
          N = (N >> 3) * 500;
          break;
        case 2:
          N = (N >> 3) / 20;
          break;
        case 3:
          N = (N >> 3) / 200;
          break;
        case 4:
          N = (N >> 3) / 2e3;
          break;
        case 5:
          N = (N >> 3) / 2e4;
          break;
        case 6:
          N = (N >> 3) / 16;
          break;
        case 7:
          N = (N >> 3) / 64;
          break;
      }
    return P[1].v = N, P;
  }
  function b(F, H) {
    var P = L(F), N = F.read_shift(4), X = F.read_shift(4), ae = F.read_shift(2);
    if (ae == 65535)
      return N === 0 && X === 3221225472 ? (P[1].t = "e", P[1].v = 15) : N === 0 && X === 3489660928 ? (P[1].t = "e", P[1].v = 42) : P[1].v = 0, P;
    var ie = ae & 32768;
    return ae = (ae & 32767) - 16446, P[1].v = (1 - ie * 2) * (X * Math.pow(2, ae + 32) + N * Math.pow(2, ae)), P;
  }
  function A(F, H, P, N) {
    var X = te(14);
    if (X.write_shift(2, F), X.write_shift(1, P), X.write_shift(1, H), N == 0)
      return X.write_shift(4, 0), X.write_shift(4, 0), X.write_shift(2, 65535), X;
    var ae = 0, ie = 0, q = 0, re = 0;
    return N < 0 && (ae = 1, N = -N), ie = Math.log2(N) | 0, N /= Math.pow(2, ie - 31), re = N >>> 0, re & 2147483648 || (N /= 2, ++ie, re = N >>> 0), N -= re, re |= 2147483648, re >>>= 0, N *= Math.pow(2, 32), q = N >>> 0, X.write_shift(4, q), X.write_shift(4, re), ie += 16383 + (ae ? 32768 : 0), X.write_shift(2, ie), X;
  }
  function T(F, H) {
    var P = b(F);
    return F.l += H - 14, P;
  }
  function C(F, H) {
    var P = L(F), N = F.read_shift(4);
    return P[1].v = N >> 6, P;
  }
  function I(F, H) {
    var P = L(F), N = F.read_shift(8, "f");
    return P[1].v = N, P;
  }
  function Y(F, H) {
    var P = I(F);
    return F.l += H - 10, P;
  }
  function j(F, H) {
    return F[F.l + H - 1] == 0 ? F.read_shift(H, "cstr") : "";
  }
  function J(F, H) {
    var P = F[F.l++];
    P > H - 1 && (P = H - 1);
    for (var N = ""; N.length < P; )
      N += String.fromCharCode(F[F.l++]);
    return N;
  }
  function W(F, H, P) {
    if (!(!P.qpro || H < 21)) {
      var N = F.read_shift(1);
      F.l += 17, F.l += 1, F.l += 2;
      var X = F.read_shift(H - 21, "cstr");
      return [N, X];
    }
  }
  function ce(F, H) {
    for (var P = {}, N = F.l + H; F.l < N; ) {
      var X = F.read_shift(2);
      if (X == 14e3) {
        for (P[X] = [0, ""], P[X][0] = F.read_shift(2); F[F.l]; )
          P[X][1] += String.fromCharCode(F[F.l]), F.l++;
        F.l++;
      }
    }
    return P;
  }
  function V(F, H) {
    var P = te(5 + F.length);
    P.write_shift(2, 14e3), P.write_shift(2, H);
    for (var N = 0; N < F.length; ++N) {
      var X = F.charCodeAt(N);
      P[P.l++] = X > 127 ? 95 : X;
    }
    return P[P.l++] = 0, P;
  }
  var ee = {
    /*::[*/
    0: { n: "BOF", f: Tr },
    /*::[*/
    1: { n: "EOF" },
    /*::[*/
    2: { n: "CALCMODE" },
    /*::[*/
    3: { n: "CALCORDER" },
    /*::[*/
    4: { n: "SPLIT" },
    /*::[*/
    5: { n: "SYNC" },
    /*::[*/
    6: { n: "RANGE", f: o },
    /*::[*/
    7: { n: "WINDOW1" },
    /*::[*/
    8: { n: "COLW1" },
    /*::[*/
    9: { n: "WINTWO" },
    /*::[*/
    10: { n: "COLW2" },
    /*::[*/
    11: { n: "NAME" },
    /*::[*/
    12: { n: "BLANK" },
    /*::[*/
    13: { n: "INTEGER", f: h },
    /*::[*/
    14: { n: "NUMBER", f: m },
    /*::[*/
    15: { n: "LABEL", f: c },
    /*::[*/
    16: { n: "FORMULA", f: p },
    /*::[*/
    24: { n: "TABLE" },
    /*::[*/
    25: { n: "ORANGE" },
    /*::[*/
    26: { n: "PRANGE" },
    /*::[*/
    27: { n: "SRANGE" },
    /*::[*/
    28: { n: "FRANGE" },
    /*::[*/
    29: { n: "KRANGE1" },
    /*::[*/
    32: { n: "HRANGE" },
    /*::[*/
    35: { n: "KRANGE2" },
    /*::[*/
    36: { n: "PROTEC" },
    /*::[*/
    37: { n: "FOOTER" },
    /*::[*/
    38: { n: "HEADER" },
    /*::[*/
    39: { n: "SETUP" },
    /*::[*/
    40: { n: "MARGINS" },
    /*::[*/
    41: { n: "LABELFMT" },
    /*::[*/
    42: { n: "TITLES" },
    /*::[*/
    43: { n: "SHEETJS" },
    /*::[*/
    45: { n: "GRAPH" },
    /*::[*/
    46: { n: "NGRAPH" },
    /*::[*/
    47: { n: "CALCCOUNT" },
    /*::[*/
    48: { n: "UNFORMATTED" },
    /*::[*/
    49: { n: "CURSORW12" },
    /*::[*/
    50: { n: "WINDOW" },
    /*::[*/
    51: { n: "STRING", f: c },
    /*::[*/
    55: { n: "PASSWORD" },
    /*::[*/
    56: { n: "LOCKED" },
    /*::[*/
    60: { n: "QUERY" },
    /*::[*/
    61: { n: "QUERYNAME" },
    /*::[*/
    62: { n: "PRINT" },
    /*::[*/
    63: { n: "PRINTNAME" },
    /*::[*/
    64: { n: "GRAPH2" },
    /*::[*/
    65: { n: "GRAPHNAME" },
    /*::[*/
    66: { n: "ZOOM" },
    /*::[*/
    67: { n: "SYMSPLIT" },
    /*::[*/
    68: { n: "NSROWS" },
    /*::[*/
    69: { n: "NSCOLS" },
    /*::[*/
    70: { n: "RULER" },
    /*::[*/
    71: { n: "NNAME" },
    /*::[*/
    72: { n: "ACOMM" },
    /*::[*/
    73: { n: "AMACRO" },
    /*::[*/
    74: { n: "PARSE" },
    /*::[*/
    102: { n: "PRANGES??" },
    /*::[*/
    103: { n: "RRANGES??" },
    /*::[*/
    104: { n: "FNAME??" },
    /*::[*/
    105: { n: "MRANGES??" },
    /*::[*/
    204: { n: "SHEETNAMECS", f: j },
    /*::[*/
    222: { n: "SHEETNAMELP", f: J },
    /*::[*/
    65535: { n: "" }
  }, de = {
    /*::[*/
    0: { n: "BOF" },
    /*::[*/
    1: { n: "EOF" },
    /*::[*/
    2: { n: "PASSWORD" },
    /*::[*/
    3: { n: "CALCSET" },
    /*::[*/
    4: { n: "WINDOWSET" },
    /*::[*/
    5: { n: "SHEETCELLPTR" },
    /*::[*/
    6: { n: "SHEETLAYOUT" },
    /*::[*/
    7: { n: "COLUMNWIDTH" },
    /*::[*/
    8: { n: "HIDDENCOLUMN" },
    /*::[*/
    9: { n: "USERRANGE" },
    /*::[*/
    10: { n: "SYSTEMRANGE" },
    /*::[*/
    11: { n: "ZEROFORCE" },
    /*::[*/
    12: { n: "SORTKEYDIR" },
    /*::[*/
    13: { n: "FILESEAL" },
    /*::[*/
    14: { n: "DATAFILLNUMS" },
    /*::[*/
    15: { n: "PRINTMAIN" },
    /*::[*/
    16: { n: "PRINTSTRING" },
    /*::[*/
    17: { n: "GRAPHMAIN" },
    /*::[*/
    18: { n: "GRAPHSTRING" },
    /*::[*/
    19: { n: "??" },
    /*::[*/
    20: { n: "ERRCELL" },
    /*::[*/
    21: { n: "NACELL" },
    /*::[*/
    22: { n: "LABEL16", f: U },
    /*::[*/
    23: { n: "NUMBER17", f: b },
    /*::[*/
    24: { n: "NUMBER18", f: v },
    /*::[*/
    25: { n: "FORMULA19", f: T },
    /*::[*/
    26: { n: "FORMULA1A" },
    /*::[*/
    27: { n: "XFORMAT", f: ce },
    /*::[*/
    28: { n: "DTLABELMISC" },
    /*::[*/
    29: { n: "DTLABELCELL" },
    /*::[*/
    30: { n: "GRAPHWINDOW" },
    /*::[*/
    31: { n: "CPA" },
    /*::[*/
    32: { n: "LPLAUTO" },
    /*::[*/
    33: { n: "QUERY" },
    /*::[*/
    34: { n: "HIDDENSHEET" },
    /*::[*/
    35: { n: "??" },
    /*::[*/
    37: { n: "NUMBER25", f: C },
    /*::[*/
    38: { n: "??" },
    /*::[*/
    39: { n: "NUMBER27", f: I },
    /*::[*/
    40: { n: "FORMULA28", f: Y },
    /*::[*/
    142: { n: "??" },
    /*::[*/
    147: { n: "??" },
    /*::[*/
    150: { n: "??" },
    /*::[*/
    151: { n: "??" },
    /*::[*/
    152: { n: "??" },
    /*::[*/
    153: { n: "??" },
    /*::[*/
    154: { n: "??" },
    /*::[*/
    155: { n: "??" },
    /*::[*/
    156: { n: "??" },
    /*::[*/
    163: { n: "??" },
    /*::[*/
    174: { n: "??" },
    /*::[*/
    175: { n: "??" },
    /*::[*/
    176: { n: "??" },
    /*::[*/
    177: { n: "??" },
    /*::[*/
    184: { n: "??" },
    /*::[*/
    185: { n: "??" },
    /*::[*/
    186: { n: "??" },
    /*::[*/
    187: { n: "??" },
    /*::[*/
    188: { n: "??" },
    /*::[*/
    195: { n: "??" },
    /*::[*/
    201: { n: "??" },
    /*::[*/
    204: { n: "SHEETNAMECS", f: j },
    /*::[*/
    205: { n: "??" },
    /*::[*/
    206: { n: "??" },
    /*::[*/
    207: { n: "??" },
    /*::[*/
    208: { n: "??" },
    /*::[*/
    256: { n: "??" },
    /*::[*/
    259: { n: "??" },
    /*::[*/
    260: { n: "??" },
    /*::[*/
    261: { n: "??" },
    /*::[*/
    262: { n: "??" },
    /*::[*/
    263: { n: "??" },
    /*::[*/
    265: { n: "??" },
    /*::[*/
    266: { n: "??" },
    /*::[*/
    267: { n: "??" },
    /*::[*/
    268: { n: "??" },
    /*::[*/
    270: { n: "??" },
    /*::[*/
    271: { n: "??" },
    /*::[*/
    384: { n: "??" },
    /*::[*/
    389: { n: "??" },
    /*::[*/
    390: { n: "??" },
    /*::[*/
    393: { n: "??" },
    /*::[*/
    396: { n: "??" },
    /*::[*/
    512: { n: "??" },
    /*::[*/
    514: { n: "??" },
    /*::[*/
    513: { n: "??" },
    /*::[*/
    516: { n: "??" },
    /*::[*/
    517: { n: "??" },
    /*::[*/
    640: { n: "??" },
    /*::[*/
    641: { n: "??" },
    /*::[*/
    642: { n: "??" },
    /*::[*/
    643: { n: "??" },
    /*::[*/
    644: { n: "??" },
    /*::[*/
    645: { n: "??" },
    /*::[*/
    646: { n: "??" },
    /*::[*/
    647: { n: "??" },
    /*::[*/
    648: { n: "??" },
    /*::[*/
    658: { n: "??" },
    /*::[*/
    659: { n: "??" },
    /*::[*/
    660: { n: "??" },
    /*::[*/
    661: { n: "??" },
    /*::[*/
    662: { n: "??" },
    /*::[*/
    665: { n: "??" },
    /*::[*/
    666: { n: "??" },
    /*::[*/
    768: { n: "??" },
    /*::[*/
    772: { n: "??" },
    /*::[*/
    1537: { n: "SHEETINFOQP", f: W },
    /*::[*/
    1600: { n: "??" },
    /*::[*/
    1602: { n: "??" },
    /*::[*/
    1793: { n: "??" },
    /*::[*/
    1794: { n: "??" },
    /*::[*/
    1795: { n: "??" },
    /*::[*/
    1796: { n: "??" },
    /*::[*/
    1920: { n: "??" },
    /*::[*/
    2048: { n: "??" },
    /*::[*/
    2049: { n: "??" },
    /*::[*/
    2052: { n: "??" },
    /*::[*/
    2688: { n: "??" },
    /*::[*/
    10998: { n: "??" },
    /*::[*/
    12849: { n: "??" },
    /*::[*/
    28233: { n: "??" },
    /*::[*/
    28484: { n: "??" },
    /*::[*/
    65535: { n: "" }
  };
  return {
    sheet_to_wk1: a,
    book_to_wk3: n,
    to_workbook: r
  };
}();
function iD(e) {
  var r = {}, t = e.match(Qr), a = 0, n = !1;
  if (t)
    for (; a != t.length; ++a) {
      var i = Se(t[a]);
      switch (i[0].replace(/\w*:/g, "")) {
        case "<condense":
          break;
        case "<extend":
          break;
        case "<shadow":
          if (!i.val)
            break;
        case "<shadow>":
        case "<shadow/>":
          r.shadow = 1;
          break;
        case "</shadow>":
          break;
        case "<charset":
          if (i.val == "1")
            break;
          r.cp = vc[parseInt(i.val, 10)];
          break;
        case "<outline":
          if (!i.val)
            break;
        case "<outline>":
        case "<outline/>":
          r.outline = 1;
          break;
        case "</outline>":
          break;
        case "<rFont":
          r.name = i.val;
          break;
        case "<sz":
          r.sz = i.val;
          break;
        case "<strike":
          if (!i.val)
            break;
        case "<strike>":
        case "<strike/>":
          r.strike = 1;
          break;
        case "</strike>":
          break;
        case "<u":
          if (!i.val)
            break;
          switch (i.val) {
            case "double":
              r.uval = "double";
              break;
            case "singleAccounting":
              r.uval = "single-accounting";
              break;
            case "doubleAccounting":
              r.uval = "double-accounting";
              break;
          }
        case "<u>":
        case "<u/>":
          r.u = 1;
          break;
        case "</u>":
          break;
        case "<b":
          if (i.val == "0")
            break;
        case "<b>":
        case "<b/>":
          r.b = 1;
          break;
        case "</b>":
          break;
        case "<i":
          if (i.val == "0")
            break;
        case "<i>":
        case "<i/>":
          r.i = 1;
          break;
        case "</i>":
          break;
        case "<color":
          i.rgb && (r.color = i.rgb.slice(2, 8));
          break;
        case "<color>":
        case "<color/>":
        case "</color>":
          break;
        case "<family":
          r.family = i.val;
          break;
        case "<family>":
        case "<family/>":
        case "</family>":
          break;
        case "<vertAlign":
          r.valign = i.val;
          break;
        case "<vertAlign>":
        case "<vertAlign/>":
        case "</vertAlign>":
          break;
        case "<scheme":
          break;
        case "<scheme>":
        case "<scheme/>":
        case "</scheme>":
          break;
        case "<extLst":
        case "<extLst>":
        case "</extLst>":
          break;
        case "<ext":
          n = !0;
          break;
        case "</ext>":
          n = !1;
          break;
        default:
          if (i[0].charCodeAt(1) !== 47 && !n)
            throw new Error("Unrecognized rich format " + i[0]);
      }
    }
  return r;
}
var sD = /* @__PURE__ */ function() {
  var e = as("t"), r = as("rPr");
  function t(i) {
    var s = i.match(e);
    if (!s)
      return { t: "s", v: "" };
    var o = { t: "s", v: We(s[1]) }, u = i.match(r);
    return u && (o.s = iD(u[1])), o;
  }
  var a = /<(?:\w+:)?r>/g, n = /<\/(?:\w+:)?r>/;
  return function(s) {
    return s.replace(a, "").split(n).map(t).filter(function(o) {
      return o.v;
    });
  };
}(), oD = /* @__PURE__ */ function() {
  var r = /(\r\n|\n)/g;
  function t(n, i, s) {
    var o = [];
    n.u && o.push("text-decoration: underline;"), n.uval && o.push("text-underline-style:" + n.uval + ";"), n.sz && o.push("font-size:" + n.sz + "pt;"), n.outline && o.push("text-effect: outline;"), n.shadow && o.push("text-shadow: auto;"), i.push('<span style="' + o.join("") + '">'), n.b && (i.push("<b>"), s.push("</b>")), n.i && (i.push("<i>"), s.push("</i>")), n.strike && (i.push("<s>"), s.push("</s>"));
    var u = n.valign || "";
    return u == "superscript" || u == "super" ? u = "sup" : u == "subscript" && (u = "sub"), u != "" && (i.push("<" + u + ">"), s.push("</" + u + ">")), s.push("</span>"), n;
  }
  function a(n) {
    var i = [[], n.v, []];
    return n.v ? (n.s && t(n.s, i[0], i[2]), i[0].join("") + i[1].replace(r, "<br/>") + i[2].join("")) : "";
  }
  return function(i) {
    return i.map(a).join("");
  };
}(), uD = /<(?:\w+:)?t[^>]*>([^<]*)<\/(?:\w+:)?t>/g, lD = /<(?:\w+:)?r>/, cD = /<(?:\w+:)?rPh.*?>([\s\S]*?)<\/(?:\w+:)?rPh>/g;
function Hc(e, r) {
  var t = r ? r.cellHTML : !0, a = {};
  return e ? (e.match(/^\s*<(?:\w+:)?t[^>]*>/) ? (a.t = We(Qe(e.slice(e.indexOf(">") + 1).split(/<\/(?:\w+:)?t>/)[0] || "")), a.r = Qe(e), t && (a.h = Ec(a.t))) : (
    /*y = */
    e.match(lD) && (a.r = Qe(e), a.t = We(Qe((e.replace(cD, "").match(uD) || []).join("").replace(Qr, ""))), t && (a.h = oD(sD(a.r))))
  ), a) : { t: "" };
}
var fD = /<(?:\w+:)?sst([^>]*)>([\s\S]*)<\/(?:\w+:)?sst>/, dD = /<(?:\w+:)?(?:si|sstItem)>/g, hD = /<\/(?:\w+:)?(?:si|sstItem)>/;
function xD(e, r) {
  var t = [], a = "";
  if (!e)
    return t;
  var n = e.match(fD);
  if (n) {
    a = n[2].replace(dD, "").split(hD);
    for (var i = 0; i != a.length; ++i) {
      var s = Hc(a[i].trim(), r);
      s != null && (t[t.length] = s);
    }
    n = Se(n[1]), t.Count = n.count, t.Unique = n.uniqueCount;
  }
  return t;
}
var mD = /^\s|\s$|[\t\n\r]/;
function Nv(e, r) {
  if (!r.bookSST)
    return "";
  var t = [$r];
  t[t.length] = he("sst", null, {
    xmlns: vn[0],
    count: e.Count,
    uniqueCount: e.Unique
  });
  for (var a = 0; a != e.length; ++a)
    if (e[a] != null) {
      var n = e[a], i = "<si>";
      n.r ? i += n.r : (i += "<t", n.t || (n.t = ""), n.t.match(mD) && (i += ' xml:space="preserve"'), i += ">" + Xe(n.t) + "</t>"), i += "</si>", t[t.length] = i;
    }
  return t.length > 2 && (t[t.length] = "</sst>", t[1] = t[1].replace("/>", ">")), t.join("");
}
function pD(e) {
  return [e.read_shift(4), e.read_shift(4)];
}
function vD(e, r) {
  var t = [], a = !1;
  return ma(e, function(i, s, o) {
    switch (o) {
      case 159:
        t.Count = i[0], t.Unique = i[1];
        break;
      case 19:
        t.push(i);
        break;
      case 160:
        return !0;
      case 35:
        a = !0;
        break;
      case 36:
        a = !1;
        break;
      default:
        if (s.T, !a || r.WTF)
          throw new Error("Unexpected record 0x" + o.toString(16));
    }
  }), t;
}
function gD(e, r) {
  return r || (r = te(8)), r.write_shift(4, e.Count), r.write_shift(4, e.Unique), r;
}
var yD = C_;
function bD(e) {
  var r = ut();
  se(r, 159, gD(e));
  for (var t = 0; t < e.length; ++t)
    se(r, 19, yD(e[t]));
  return se(
    r,
    160
    /* BrtEndSst */
  ), r.end();
}
function Uv(e) {
  if (typeof Ue < "u")
    return Ue.utils.encode(ln, e);
  for (var r = [], t = e.split(""), a = 0; a < t.length; ++a)
    r[a] = t[a].charCodeAt(0);
  return r;
}
function ca(e, r) {
  var t = {};
  return t.Major = e.read_shift(2), t.Minor = e.read_shift(2), r >= 4 && (e.l += r - 4), t;
}
function wD(e) {
  var r = {};
  return r.id = e.read_shift(0, "lpp4"), r.R = ca(e, 4), r.U = ca(e, 4), r.W = ca(e, 4), r;
}
function _D(e) {
  for (var r = e.read_shift(4), t = e.l + r - 4, a = {}, n = e.read_shift(4), i = []; n-- > 0; )
    i.push({ t: e.read_shift(4), v: e.read_shift(0, "lpp4") });
  if (a.name = e.read_shift(0, "lpp4"), a.comps = i, e.l != t)
    throw new Error("Bad DataSpaceMapEntry: " + e.l + " != " + t);
  return a;
}
function $D(e) {
  var r = [];
  e.l += 4;
  for (var t = e.read_shift(4); t-- > 0; )
    r.push(_D(e));
  return r;
}
function DD(e) {
  var r = [];
  e.l += 4;
  for (var t = e.read_shift(4); t-- > 0; )
    r.push(e.read_shift(0, "lpp4"));
  return r;
}
function ED(e) {
  var r = {};
  return e.read_shift(4), e.l += 4, r.id = e.read_shift(0, "lpp4"), r.name = e.read_shift(0, "lpp4"), r.R = ca(e, 4), r.U = ca(e, 4), r.W = ca(e, 4), r;
}
function kD(e) {
  var r = ED(e);
  if (r.ename = e.read_shift(0, "8lpp4"), r.blksz = e.read_shift(4), r.cmode = e.read_shift(4), e.read_shift(4) != 4)
    throw new Error("Bad !Primary record");
  return r;
}
function Vv(e, r) {
  var t = e.l + r, a = {};
  a.Flags = e.read_shift(4) & 63, e.l += 4, a.AlgID = e.read_shift(4);
  var n = !1;
  switch (a.AlgID) {
    case 26126:
    case 26127:
    case 26128:
      n = a.Flags == 36;
      break;
    case 26625:
      n = a.Flags == 4;
      break;
    case 0:
      n = a.Flags == 16 || a.Flags == 4 || a.Flags == 36;
      break;
    default:
      throw "Unrecognized encryption algorithm: " + a.AlgID;
  }
  if (!n)
    throw new Error("Encryption Flags/AlgID mismatch");
  return a.AlgIDHash = e.read_shift(4), a.KeySize = e.read_shift(4), a.ProviderType = e.read_shift(4), e.l += 8, a.CSPName = e.read_shift(t - e.l >> 1, "utf16le"), e.l = t, a;
}
function Wv(e, r) {
  var t = {}, a = e.l + r;
  return e.l += 4, t.Salt = e.slice(e.l, e.l + 16), e.l += 16, t.Verifier = e.slice(e.l, e.l + 16), e.l += 16, e.read_shift(4), t.VerifierHash = e.slice(e.l, a), e.l = a, t;
}
function TD(e) {
  var r = ca(e);
  switch (r.Minor) {
    case 2:
      return [r.Minor, SD(e)];
    case 3:
      return [r.Minor, CD()];
    case 4:
      return [r.Minor, FD(e)];
  }
  throw new Error("ECMA-376 Encrypted file unrecognized Version: " + r.Minor);
}
function SD(e) {
  var r = e.read_shift(4);
  if ((r & 63) != 36)
    throw new Error("EncryptionInfo mismatch");
  var t = e.read_shift(4), a = Vv(e, t), n = Wv(e, e.length - e.l);
  return { t: "Std", h: a, v: n };
}
function CD() {
  throw new Error("File is password-protected: ECMA-376 Extensible");
}
function FD(e) {
  var r = ["saltSize", "blockSize", "keyBits", "hashSize", "cipherAlgorithm", "cipherChaining", "hashAlgorithm", "saltValue"];
  e.l += 4;
  var t = e.read_shift(e.length - e.l, "utf8"), a = {};
  return t.replace(Qr, function(i) {
    var s = Se(i);
    switch (Xt(s[0])) {
      case "<?xml":
        break;
      case "<encryption":
      case "</encryption>":
        break;
      case "<keyData":
        r.forEach(function(o) {
          a[o] = s[o];
        });
        break;
      case "<dataIntegrity":
        a.encryptedHmacKey = s.encryptedHmacKey, a.encryptedHmacValue = s.encryptedHmacValue;
        break;
      case "<keyEncryptors>":
      case "<keyEncryptors":
        a.encs = [];
        break;
      case "</keyEncryptors>":
        break;
      case "<keyEncryptor":
        a.uri = s.uri;
        break;
      case "</keyEncryptor>":
        break;
      case "<encryptedKey":
        a.encs.push(s);
        break;
      default:
        throw s[0];
    }
  }), a;
}
function AD(e, r) {
  var t = {}, a = t.EncryptionVersionInfo = ca(e, 4);
  if (r -= 4, a.Minor != 2)
    throw new Error("unrecognized minor version code: " + a.Minor);
  if (a.Major > 4 || a.Major < 2)
    throw new Error("unrecognized major version code: " + a.Major);
  t.Flags = e.read_shift(4), r -= 4;
  var n = e.read_shift(4);
  return r -= 4, t.EncryptionHeader = Vv(e, n), r -= n, t.EncryptionVerifier = Wv(e, r), t;
}
function RD(e) {
  var r = {}, t = r.EncryptionVersionInfo = ca(e, 4);
  if (t.Major != 1 || t.Minor != 1)
    throw "unrecognized version code " + t.Major + " : " + t.Minor;
  return r.Salt = e.read_shift(16), r.EncryptedVerifier = e.read_shift(16), r.EncryptedVerifierHash = e.read_shift(16), r;
}
function jc(e) {
  var r = 0, t, a = Uv(e), n = a.length + 1, i, s, o, u, l;
  for (t = Pa(n), t[0] = a.length, i = 1; i != n; ++i)
    t[i] = a[i - 1];
  for (i = n - 1; i >= 0; --i)
    s = t[i], o = r & 16384 ? 1 : 0, u = r << 1 & 32767, l = o | u, r = l ^ s;
  return r ^ 52811;
}
var Hv = /* @__PURE__ */ function() {
  var e = [187, 255, 255, 186, 255, 255, 185, 128, 0, 190, 15, 0, 191, 15, 0], r = [57840, 7439, 52380, 33984, 4364, 3600, 61902, 12606, 6258, 57657, 54287, 34041, 10252, 43370, 20163], t = [44796, 19929, 39858, 10053, 20106, 40212, 10761, 31585, 63170, 64933, 60267, 50935, 40399, 11199, 17763, 35526, 1453, 2906, 5812, 11624, 23248, 885, 1770, 3540, 7080, 14160, 28320, 56640, 55369, 41139, 20807, 41614, 21821, 43642, 17621, 28485, 56970, 44341, 19019, 38038, 14605, 29210, 60195, 50791, 40175, 10751, 21502, 43004, 24537, 18387, 36774, 3949, 7898, 15796, 31592, 63184, 47201, 24803, 49606, 37805, 14203, 28406, 56812, 17824, 35648, 1697, 3394, 6788, 13576, 27152, 43601, 17539, 35078, 557, 1114, 2228, 4456, 30388, 60776, 51953, 34243, 7079, 14158, 28316, 14128, 28256, 56512, 43425, 17251, 34502, 7597, 13105, 26210, 52420, 35241, 883, 1766, 3532, 4129, 8258, 16516, 33032, 4657, 9314, 18628], a = function(s) {
    return (s / 2 | s * 128) & 255;
  }, n = function(s, o) {
    return a(s ^ o);
  }, i = function(s) {
    for (var o = r[s.length - 1], u = 104, l = s.length - 1; l >= 0; --l)
      for (var c = s[l], f = 0; f != 7; ++f)
        c & 64 && (o ^= t[u]), c *= 2, --u;
    return o;
  };
  return function(s) {
    for (var o = Uv(s), u = i(o), l = o.length, c = Pa(16), f = 0; f != 16; ++f)
      c[f] = 0;
    var h, d, m;
    for ((l & 1) === 1 && (h = u >> 8, c[l] = n(e[0], h), --l, h = u & 255, d = o[o.length - 1], c[l] = n(d, h)); l > 0; )
      --l, h = u >> 8, c[l] = n(o[l], h), --l, h = u & 255, c[l] = n(o[l], h);
    for (l = 15, m = 15 - o.length; m > 0; )
      h = u >> 8, c[l] = n(e[m], h), --l, --m, h = u & 255, c[l] = n(o[l], h), --l, --m;
    return c;
  };
}(), ID = function(e, r, t, a, n) {
  n || (n = r), a || (a = Hv(e));
  var i, s;
  for (i = 0; i != r.length; ++i)
    s = r[i], s ^= a[t], s = (s >> 5 | s << 3) & 255, n[i] = s, ++t;
  return [n, t, a];
}, BD = function(e) {
  var r = 0, t = Hv(e);
  return function(a) {
    var n = ID("", a, r, t);
    return r = n[1], n[0];
  };
};
function PD(e, r, t, a) {
  var n = { key: Tr(e), verificationBytes: Tr(e) };
  return t.password && (n.verifier = jc(t.password)), a.valid = n.verificationBytes === n.verifier, a.valid && (a.insitu = BD(t.password)), n;
}
function MD(e, r, t) {
  var a = t || {};
  return a.Info = e.read_shift(2), e.l -= 2, a.Info === 1 ? a.Data = RD(e) : a.Data = AD(e, r), a;
}
function OD(e, r, t) {
  var a = { Type: t.biff >= 8 ? e.read_shift(2) : 0 };
  return a.Type ? MD(e, r - 2, a) : PD(e, t.biff >= 8 ? r : r - 2, t, a), a;
}
var jv = /* @__PURE__ */ function() {
  function e(n, i) {
    switch (i.type) {
      case "base64":
        return r(mt(n), i);
      case "binary":
        return r(n, i);
      case "buffer":
        return r(Ie && Buffer.isBuffer(n) ? n.toString("binary") : Va(n), i);
      case "array":
        return r(fn(n), i);
    }
    throw new Error("Unrecognized type " + i.type);
  }
  function r(n, i) {
    var s = i || {}, o = s.dense ? [] : {}, u = n.match(/\\trowd.*?\\row\b/g);
    if (!u.length)
      throw new Error("RTF missing table");
    var l = { s: { c: 0, r: 0 }, e: { c: 0, r: u.length - 1 } };
    return u.forEach(function(c, f) {
      Array.isArray(o) && (o[f] = []);
      for (var h = /\\\w+\b/g, d = 0, m, x = -1; m = h.exec(c); ) {
        switch (m[0]) {
          case "\\cell":
            var p = c.slice(d, h.lastIndex - m[0].length);
            if (p[0] == " " && (p = p.slice(1)), ++x, p.length) {
              var w = { v: p, t: "s" };
              Array.isArray(o) ? o[f][x] = w : o[Te({ r: f, c: x })] = w;
            }
            break;
        }
        d = h.lastIndex;
      }
      x > l.e.c && (l.e.c = x);
    }), o["!ref"] = Ce(l), o;
  }
  function t(n, i) {
    return Wa(e(n, i), i);
  }
  function a(n) {
    for (var i = ["{\\rtf1\\ansi"], s = Oe(n["!ref"]), o, u = Array.isArray(n), l = s.s.r; l <= s.e.r; ++l) {
      i.push("\\trowd\\trautofit1");
      for (var c = s.s.c; c <= s.e.c; ++c)
        i.push("\\cellx" + (c + 1));
      for (i.push("\\pard\\intbl"), c = s.s.c; c <= s.e.c; ++c) {
        var f = Te({ r: l, c });
        o = u ? (n[l] || [])[c] : n[f], !(!o || o.v == null && (!o.f || o.F)) && (i.push(" " + (o.w || (Yt(o), o.w))), i.push("\\cell"));
      }
      i.push("\\pard\\intbl\\row");
    }
    return i.join("") + "}";
  }
  return {
    to_workbook: t,
    to_sheet: e,
    from_sheet: a
  };
}();
function LD(e) {
  var r = e.slice(e[0] === "#" ? 1 : 0).slice(0, 6);
  return [parseInt(r.slice(0, 2), 16), parseInt(r.slice(2, 4), 16), parseInt(r.slice(4, 6), 16)];
}
function os(e) {
  for (var r = 0, t = 1; r != 3; ++r)
    t = t * 256 + (e[r] > 255 ? 255 : e[r] < 0 ? 0 : e[r]);
  return t.toString(16).toUpperCase().slice(1);
}
function ND(e) {
  var r = e[0] / 255, t = e[1] / 255, a = e[2] / 255, n = Math.max(r, t, a), i = Math.min(r, t, a), s = n - i;
  if (s === 0)
    return [0, 0, r];
  var o = 0, u = 0, l = n + i;
  switch (u = s / (l > 1 ? 2 - l : l), n) {
    case r:
      o = ((t - a) / s + 6) % 6;
      break;
    case t:
      o = (a - r) / s + 2;
      break;
    case a:
      o = (r - t) / s + 4;
      break;
  }
  return [o / 6, u, l / 2];
}
function UD(e) {
  var r = e[0], t = e[1], a = e[2], n = t * 2 * (a < 0.5 ? a : 1 - a), i = a - n / 2, s = [i, i, i], o = 6 * r, u;
  if (t !== 0)
    switch (o | 0) {
      case 0:
      case 6:
        u = n * o, s[0] += n, s[1] += u;
        break;
      case 1:
        u = n * (2 - o), s[0] += u, s[1] += n;
        break;
      case 2:
        u = n * (o - 2), s[1] += n, s[2] += u;
        break;
      case 3:
        u = n * (4 - o), s[1] += u, s[2] += n;
        break;
      case 4:
        u = n * (o - 4), s[2] += n, s[0] += u;
        break;
      case 5:
        u = n * (6 - o), s[2] += u, s[0] += n;
        break;
    }
  for (var l = 0; l != 3; ++l)
    s[l] = Math.round(s[l] * 255);
  return s;
}
function Xo(e, r) {
  if (r === 0)
    return e;
  var t = ND(LD(e));
  return r < 0 ? t[2] = t[2] * (1 + r) : t[2] = 1 - (1 - t[2]) * (1 - r), os(UD(t));
}
var zv = 6, VD = 15, WD = 1, Kr = zv;
function us(e) {
  return Math.floor((e + Math.round(128 / Kr) / 256) * Kr);
}
function ls(e) {
  return Math.floor((e - 5) / Kr * 100 + 0.5) / 100;
}
function Zo(e) {
  return Math.round((e * Kr + 5) / Kr * 256) / 256;
}
function xu(e) {
  return Zo(ls(us(e)));
}
function zc(e) {
  var r = Math.abs(e - xu(e)), t = Kr;
  if (r > 5e-3)
    for (Kr = WD; Kr < VD; ++Kr)
      Math.abs(e - xu(e)) <= r && (r = Math.abs(e - xu(e)), t = Kr);
  Kr = t;
}
function Ma(e) {
  e.width ? (e.wpx = us(e.width), e.wch = ls(e.wpx), e.MDW = Kr) : e.wpx ? (e.wch = ls(e.wpx), e.width = Zo(e.wch), e.MDW = Kr) : typeof e.wch == "number" && (e.width = Zo(e.wch), e.wpx = us(e.width), e.MDW = Kr), e.customWidth && delete e.customWidth;
}
var HD = 96, Gv = HD;
function cs(e) {
  return e * 96 / Gv;
}
function li(e) {
  return e * Gv / 96;
}
var jD = {
  None: "none",
  Solid: "solid",
  Gray50: "mediumGray",
  Gray75: "darkGray",
  Gray25: "lightGray",
  HorzStripe: "darkHorizontal",
  VertStripe: "darkVertical",
  ReverseDiagStripe: "darkDown",
  DiagStripe: "darkUp",
  DiagCross: "darkGrid",
  ThickDiagCross: "darkTrellis",
  ThinHorzStripe: "lightHorizontal",
  ThinVertStripe: "lightVertical",
  ThinReverseDiagStripe: "lightDown",
  ThinHorzCross: "lightGrid"
};
function zD(e, r, t, a) {
  r.Borders = [];
  var n = {}, i = !1;
  (e[0].match(Qr) || []).forEach(function(s) {
    var o = Se(s);
    switch (Xt(o[0])) {
      case "<borders":
      case "<borders>":
      case "</borders>":
        break;
      case "<border":
      case "<border>":
      case "<border/>":
        n = /*::(*/
        {}, o.diagonalUp && (n.diagonalUp = sr(o.diagonalUp)), o.diagonalDown && (n.diagonalDown = sr(o.diagonalDown)), r.Borders.push(n);
        break;
      case "</border>":
        break;
      case "<left/>":
        break;
      case "<left":
      case "<left>":
        break;
      case "</left>":
        break;
      case "<right/>":
        break;
      case "<right":
      case "<right>":
        break;
      case "</right>":
        break;
      case "<top/>":
        break;
      case "<top":
      case "<top>":
        break;
      case "</top>":
        break;
      case "<bottom/>":
        break;
      case "<bottom":
      case "<bottom>":
        break;
      case "</bottom>":
        break;
      case "<diagonal":
      case "<diagonal>":
      case "<diagonal/>":
        break;
      case "</diagonal>":
        break;
      case "<horizontal":
      case "<horizontal>":
      case "<horizontal/>":
        break;
      case "</horizontal>":
        break;
      case "<vertical":
      case "<vertical>":
      case "<vertical/>":
        break;
      case "</vertical>":
        break;
      case "<start":
      case "<start>":
      case "<start/>":
        break;
      case "</start>":
        break;
      case "<end":
      case "<end>":
      case "<end/>":
        break;
      case "</end>":
        break;
      case "<color":
      case "<color>":
        break;
      case "<color/>":
      case "</color>":
        break;
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
        break;
      case "<ext":
        i = !0;
        break;
      case "</ext>":
        i = !1;
        break;
      default:
        if (a && a.WTF && !i)
          throw new Error("unrecognized " + o[0] + " in borders");
    }
  });
}
function GD(e, r, t, a) {
  r.Fills = [];
  var n = {}, i = !1;
  (e[0].match(Qr) || []).forEach(function(s) {
    var o = Se(s);
    switch (Xt(o[0])) {
      case "<fills":
      case "<fills>":
      case "</fills>":
        break;
      case "<fill>":
      case "<fill":
      case "<fill/>":
        n = {}, r.Fills.push(n);
        break;
      case "</fill>":
        break;
      case "<gradientFill>":
        break;
      case "<gradientFill":
      case "</gradientFill>":
        r.Fills.push(n), n = {};
        break;
      case "<patternFill":
      case "<patternFill>":
        o.patternType && (n.patternType = o.patternType);
        break;
      case "<patternFill/>":
      case "</patternFill>":
        break;
      case "<bgColor":
        n.bgColor || (n.bgColor = {}), o.indexed && (n.bgColor.indexed = parseInt(o.indexed, 10)), o.theme && (n.bgColor.theme = parseInt(o.theme, 10)), o.tint && (n.bgColor.tint = parseFloat(o.tint)), o.rgb && (n.bgColor.rgb = o.rgb.slice(-6));
        break;
      case "<bgColor/>":
      case "</bgColor>":
        break;
      case "<fgColor":
        n.fgColor || (n.fgColor = {}), o.theme && (n.fgColor.theme = parseInt(o.theme, 10)), o.tint && (n.fgColor.tint = parseFloat(o.tint)), o.rgb != null && (n.fgColor.rgb = o.rgb.slice(-6));
        break;
      case "<fgColor/>":
      case "</fgColor>":
        break;
      case "<stop":
      case "<stop/>":
        break;
      case "</stop>":
        break;
      case "<color":
      case "<color/>":
        break;
      case "</color>":
        break;
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
        break;
      case "<ext":
        i = !0;
        break;
      case "</ext>":
        i = !1;
        break;
      default:
        if (a && a.WTF && !i)
          throw new Error("unrecognized " + o[0] + " in fills");
    }
  });
}
function KD(e, r, t, a) {
  r.Fonts = [];
  var n = {}, i = !1;
  (e[0].match(Qr) || []).forEach(function(s) {
    var o = Se(s);
    switch (Xt(o[0])) {
      case "<fonts":
      case "<fonts>":
      case "</fonts>":
        break;
      case "<font":
      case "<font>":
        break;
      case "</font>":
      case "<font/>":
        r.Fonts.push(n), n = {};
        break;
      case "<name":
        o.val && (n.name = Qe(o.val));
        break;
      case "<name/>":
      case "</name>":
        break;
      case "<b":
        n.bold = o.val ? sr(o.val) : 1;
        break;
      case "<b/>":
        n.bold = 1;
        break;
      case "<i":
        n.italic = o.val ? sr(o.val) : 1;
        break;
      case "<i/>":
        n.italic = 1;
        break;
      case "<u":
        switch (o.val) {
          case "none":
            n.underline = 0;
            break;
          case "single":
            n.underline = 1;
            break;
          case "double":
            n.underline = 2;
            break;
          case "singleAccounting":
            n.underline = 33;
            break;
          case "doubleAccounting":
            n.underline = 34;
            break;
        }
        break;
      case "<u/>":
        n.underline = 1;
        break;
      case "<strike":
        n.strike = o.val ? sr(o.val) : 1;
        break;
      case "<strike/>":
        n.strike = 1;
        break;
      case "<outline":
        n.outline = o.val ? sr(o.val) : 1;
        break;
      case "<outline/>":
        n.outline = 1;
        break;
      case "<shadow":
        n.shadow = o.val ? sr(o.val) : 1;
        break;
      case "<shadow/>":
        n.shadow = 1;
        break;
      case "<condense":
        n.condense = o.val ? sr(o.val) : 1;
        break;
      case "<condense/>":
        n.condense = 1;
        break;
      case "<extend":
        n.extend = o.val ? sr(o.val) : 1;
        break;
      case "<extend/>":
        n.extend = 1;
        break;
      case "<sz":
        o.val && (n.sz = +o.val);
        break;
      case "<sz/>":
      case "</sz>":
        break;
      case "<vertAlign":
        o.val && (n.vertAlign = o.val);
        break;
      case "<vertAlign/>":
      case "</vertAlign>":
        break;
      case "<family":
        o.val && (n.family = parseInt(o.val, 10));
        break;
      case "<family/>":
      case "</family>":
        break;
      case "<scheme":
        o.val && (n.scheme = o.val);
        break;
      case "<scheme/>":
      case "</scheme>":
        break;
      case "<charset":
        if (o.val == "1")
          break;
        o.codepage = vc[parseInt(o.val, 10)];
        break;
      case "<color":
        if (n.color || (n.color = {}), o.auto && (n.color.auto = sr(o.auto)), o.rgb)
          n.color.rgb = o.rgb.slice(-6);
        else if (o.indexed) {
          n.color.index = parseInt(o.indexed, 10);
          var u = Qa[n.color.index];
          n.color.index == 81 && (u = Qa[1]), u || (u = Qa[1]), n.color.rgb = u[0].toString(16) + u[1].toString(16) + u[2].toString(16);
        } else
          o.theme && (n.color.theme = parseInt(o.theme, 10), o.tint && (n.color.tint = parseFloat(o.tint)), o.theme && t.themeElements && t.themeElements.clrScheme && (n.color.rgb = Xo(t.themeElements.clrScheme[n.color.theme].rgb, n.color.tint || 0)));
        break;
      case "<color/>":
      case "</color>":
        break;
      case "<AlternateContent":
        i = !0;
        break;
      case "</AlternateContent>":
        i = !1;
        break;
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
        break;
      case "<ext":
        i = !0;
        break;
      case "</ext>":
        i = !1;
        break;
      default:
        if (a && a.WTF && !i)
          throw new Error("unrecognized " + o[0] + " in fonts");
    }
  });
}
function YD(e, r, t) {
  r.NumberFmt = [];
  for (var a = br(Ee), n = 0; n < a.length; ++n)
    r.NumberFmt[a[n]] = Ee[a[n]];
  var i = e[0].match(Qr);
  if (i)
    for (n = 0; n < i.length; ++n) {
      var s = Se(i[n]);
      switch (Xt(s[0])) {
        case "<numFmts":
        case "</numFmts>":
        case "<numFmts/>":
        case "<numFmts>":
          break;
        case "<numFmt":
          {
            var o = We(Qe(s.formatCode)), u = parseInt(s.numFmtId, 10);
            if (r.NumberFmt[u] = o, u > 0) {
              if (u > 392) {
                for (u = 392; u > 60 && r.NumberFmt[u] != null; --u)
                  ;
                r.NumberFmt[u] = o;
              }
              Gt(o, u);
            }
          }
          break;
        case "</numFmt>":
          break;
        default:
          if (t.WTF)
            throw new Error("unrecognized " + s[0] + " in numFmts");
      }
    }
}
function XD(e) {
  var r = ["<numFmts>"];
  return [[5, 8], [23, 26], [41, 44], [
    /*63*/
    50,
    /*66],[164,*/
    392
  ]].forEach(function(t) {
    for (var a = t[0]; a <= t[1]; ++a)
      e[a] != null && (r[r.length] = he("numFmt", null, { numFmtId: a, formatCode: Xe(e[a]) }));
  }), r.length === 1 ? "" : (r[r.length] = "</numFmts>", r[0] = he("numFmts", null, { count: r.length - 2 }).replace("/>", ">"), r.join(""));
}
var io = ["numFmtId", "fillId", "fontId", "borderId", "xfId"], so = ["applyAlignment", "applyBorder", "applyFill", "applyFont", "applyNumberFormat", "applyProtection", "pivotButton", "quotePrefix"];
function ZD(e, r, t) {
  r.CellXf = [];
  var a, n = !1;
  (e[0].match(Qr) || []).forEach(function(i) {
    var s = Se(i), o = 0;
    switch (Xt(s[0])) {
      case "<cellXfs":
      case "<cellXfs>":
      case "<cellXfs/>":
      case "</cellXfs>":
        break;
      case "<xf":
      case "<xf/>":
        for (a = s, delete a[0], o = 0; o < io.length; ++o)
          a[io[o]] && (a[io[o]] = parseInt(a[io[o]], 10));
        for (o = 0; o < so.length; ++o)
          a[so[o]] && (a[so[o]] = sr(a[so[o]]));
        if (r.NumberFmt && a.numFmtId > 392) {
          for (o = 392; o > 60; --o)
            if (r.NumberFmt[a.numFmtId] == r.NumberFmt[o]) {
              a.numFmtId = o;
              break;
            }
        }
        r.CellXf.push(a);
        break;
      case "</xf>":
        break;
      case "<alignment":
      case "<alignment/>":
        var u = {};
        s.vertical && (u.vertical = s.vertical), s.horizontal && (u.horizontal = s.horizontal), s.textRotation != null && (u.textRotation = s.textRotation), s.indent && (u.indent = s.indent), s.wrapText && (u.wrapText = sr(s.wrapText)), a.alignment = u;
        break;
      case "</alignment>":
        break;
      case "<protection":
        break;
      case "</protection>":
      case "<protection/>":
        break;
      case "<AlternateContent":
        n = !0;
        break;
      case "</AlternateContent>":
        n = !1;
        break;
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
        break;
      case "<ext":
        n = !0;
        break;
      case "</ext>":
        n = !1;
        break;
      default:
        if (t && t.WTF && !n)
          throw new Error("unrecognized " + s[0] + " in cellXfs");
    }
  });
}
function JD(e) {
  var r = [];
  return r[r.length] = he("cellXfs", null), e.forEach(function(t) {
    r[r.length] = he("xf", null, t);
  }), r[r.length] = "</cellXfs>", r.length === 2 ? "" : (r[0] = he("cellXfs", null, { count: r.length - 2 }).replace("/>", ">"), r.join(""));
}
var qD = /* @__PURE__ */ function() {
  var r = /<(?:\w+:)?numFmts([^>]*)>[\S\s]*?<\/(?:\w+:)?numFmts>/, t = /<(?:\w+:)?cellXfs([^>]*)>[\S\s]*?<\/(?:\w+:)?cellXfs>/, a = /<(?:\w+:)?fills([^>]*)>[\S\s]*?<\/(?:\w+:)?fills>/, n = /<(?:\w+:)?fonts([^>]*)>[\S\s]*?<\/(?:\w+:)?fonts>/, i = /<(?:\w+:)?borders([^>]*)>[\S\s]*?<\/(?:\w+:)?borders>/;
  return function(o, u, l) {
    var c = {};
    if (!o)
      return c;
    o = o.replace(/<!--([\s\S]*?)-->/mg, "").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm, "");
    var f;
    return (f = o.match(r)) && YD(f, c, l), (f = o.match(n)) && KD(f, c, u, l), (f = o.match(a)) && GD(f, c, u, l), (f = o.match(i)) && zD(f, c, u, l), (f = o.match(t)) && ZD(f, c, l), c;
  };
}();
function Kv(e, r) {
  var t = [$r, he("styleSheet", null, {
    xmlns: vn[0],
    "xmlns:vt": Fr.vt
  })], a;
  return e.SSF && (a = XD(e.SSF)) != null && (t[t.length] = a), t[t.length] = '<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>', t[t.length] = '<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>', t[t.length] = '<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>', t[t.length] = '<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>', (a = JD(r.cellXfs)) && (t[t.length] = a), t[t.length] = '<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>', t[t.length] = '<dxfs count="0"/>', t[t.length] = '<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>', t.length > 2 && (t[t.length] = "</styleSheet>", t[1] = t[1].replace("/>", ">")), t.join("");
}
function QD(e, r) {
  var t = e.read_shift(2), a = Jr(e);
  return [t, a];
}
function eE(e, r, t) {
  t || (t = te(6 + 4 * r.length)), t.write_shift(2, e), Lr(r, t);
  var a = t.length > t.l ? t.slice(0, t.l) : t;
  return t.l == null && (t.l = t.length), a;
}
function rE(e, r, t) {
  var a = {};
  a.sz = e.read_shift(2) / 20;
  var n = M_(e);
  n.fItalic && (a.italic = 1), n.fCondense && (a.condense = 1), n.fExtend && (a.extend = 1), n.fShadow && (a.shadow = 1), n.fOutline && (a.outline = 1), n.fStrikeout && (a.strike = 1);
  var i = e.read_shift(2);
  switch (i === 700 && (a.bold = 1), e.read_shift(2)) {
    case 1:
      a.vertAlign = "superscript";
      break;
    case 2:
      a.vertAlign = "subscript";
      break;
  }
  var s = e.read_shift(1);
  s != 0 && (a.underline = s);
  var o = e.read_shift(1);
  o > 0 && (a.family = o);
  var u = e.read_shift(1);
  switch (u > 0 && (a.charset = u), e.l++, a.color = P_(e), e.read_shift(1)) {
    case 1:
      a.scheme = "major";
      break;
    case 2:
      a.scheme = "minor";
      break;
  }
  return a.name = Jr(e), a;
}
function tE(e, r) {
  r || (r = te(25 + 4 * 32)), r.write_shift(2, e.sz * 20), O_(e, r), r.write_shift(2, e.bold ? 700 : 400);
  var t = 0;
  e.vertAlign == "superscript" ? t = 1 : e.vertAlign == "subscript" && (t = 2), r.write_shift(2, t), r.write_shift(1, e.underline || 0), r.write_shift(1, e.family || 0), r.write_shift(1, e.charset || 0), r.write_shift(1, 0), Go(e.color, r);
  var a = 0;
  return e.scheme == "major" && (a = 1), e.scheme == "minor" && (a = 2), r.write_shift(1, a), Lr(e.name, r), r.length > r.l ? r.slice(0, r.l) : r;
}
var aE = [
  "none",
  "solid",
  "mediumGray",
  "darkGray",
  "lightGray",
  "darkHorizontal",
  "darkVertical",
  "darkDown",
  "darkUp",
  "darkGrid",
  "darkTrellis",
  "lightHorizontal",
  "lightVertical",
  "lightDown",
  "lightUp",
  "lightGrid",
  "lightTrellis",
  "gray125",
  "gray0625"
], mu, nE = qr;
function dh(e, r) {
  r || (r = te(4 * 3 + 8 * 7 + 16 * 1)), mu || (mu = m0(aE));
  var t = mu[e.patternType];
  t == null && (t = 40), r.write_shift(4, t);
  var a = 0;
  if (t != 40)
    for (Go({ auto: 1 }, r), Go({ auto: 1 }, r); a < 12; ++a)
      r.write_shift(4, 0);
  else {
    for (; a < 4; ++a)
      r.write_shift(4, 0);
    for (; a < 12; ++a)
      r.write_shift(4, 0);
  }
  return r.length > r.l ? r.slice(0, r.l) : r;
}
function iE(e, r) {
  var t = e.l + r, a = e.read_shift(2), n = e.read_shift(2);
  return e.l = t, { ixfe: a, numFmtId: n };
}
function Yv(e, r, t) {
  t || (t = te(16)), t.write_shift(2, r || 0), t.write_shift(2, e.numFmtId || 0), t.write_shift(2, 0), t.write_shift(2, 0), t.write_shift(2, 0), t.write_shift(1, 0), t.write_shift(1, 0);
  var a = 0;
  return t.write_shift(1, a), t.write_shift(1, 0), t.write_shift(1, 0), t.write_shift(1, 0), t;
}
function Fi(e, r) {
  return r || (r = te(10)), r.write_shift(1, 0), r.write_shift(1, 0), r.write_shift(4, 0), r.write_shift(4, 0), r;
}
var sE = qr;
function oE(e, r) {
  return r || (r = te(51)), r.write_shift(1, 0), Fi(null, r), Fi(null, r), Fi(null, r), Fi(null, r), Fi(null, r), r.length > r.l ? r.slice(0, r.l) : r;
}
function uE(e, r) {
  return r || (r = te(12 + 4 * 10)), r.write_shift(4, e.xfId), r.write_shift(2, 1), r.write_shift(1, +e.builtinId), r.write_shift(1, 0), zo(e.name || "", r), r.length > r.l ? r.slice(0, r.l) : r;
}
function lE(e, r, t) {
  var a = te(2052);
  return a.write_shift(4, e), zo(r, a), zo(t, a), a.length > a.l ? a.slice(0, a.l) : a;
}
function cE(e, r, t) {
  var a = {};
  a.NumberFmt = [];
  for (var n in Ee)
    a.NumberFmt[n] = Ee[n];
  a.CellXf = [], a.Fonts = [];
  var i = [], s = !1;
  return ma(e, function(u, l, c) {
    switch (c) {
      case 44:
        a.NumberFmt[u[0]] = u[1], Gt(u[1], u[0]);
        break;
      case 43:
        a.Fonts.push(u), u.color.theme != null && r && r.themeElements && r.themeElements.clrScheme && (u.color.rgb = Xo(r.themeElements.clrScheme[u.color.theme].rgb, u.color.tint || 0));
        break;
      case 1025:
        break;
      case 45:
        break;
      case 46:
        break;
      case 47:
        i[i.length - 1] == 617 && a.CellXf.push(u);
        break;
      case 48:
      case 507:
      case 572:
      case 475:
        break;
      case 1171:
      case 2102:
      case 1130:
      case 512:
      case 2095:
      case 3072:
        break;
      case 35:
        s = !0;
        break;
      case 36:
        s = !1;
        break;
      case 37:
        i.push(c), s = !0;
        break;
      case 38:
        i.pop(), s = !1;
        break;
      default:
        if (l.T > 0)
          i.push(c);
        else if (l.T < 0)
          i.pop();
        else if (!s || t.WTF && i[i.length - 1] != 37)
          throw new Error("Unexpected record 0x" + c.toString(16));
    }
  }), a;
}
function fE(e, r) {
  if (r) {
    var t = 0;
    [[5, 8], [23, 26], [41, 44], [
      /*63*/
      50,
      /*66],[164,*/
      392
    ]].forEach(function(a) {
      for (var n = a[0]; n <= a[1]; ++n)
        r[n] != null && ++t;
    }), t != 0 && (se(e, 615, Lt(t)), [[5, 8], [23, 26], [41, 44], [
      /*63*/
      50,
      /*66],[164,*/
      392
    ]].forEach(function(a) {
      for (var n = a[0]; n <= a[1]; ++n)
        r[n] != null && se(e, 44, eE(n, r[n]));
    }), se(
      e,
      616
      /* BrtEndFmts */
    ));
  }
}
function dE(e) {
  var r = 1;
  se(e, 611, Lt(r)), se(e, 43, tE({
    sz: 12,
    color: { theme: 1 },
    name: "Calibri",
    family: 2,
    scheme: "minor"
  })), se(
    e,
    612
    /* BrtEndFonts */
  );
}
function hE(e) {
  var r = 2;
  se(e, 603, Lt(r)), se(e, 45, dh({ patternType: "none" })), se(e, 45, dh({ patternType: "gray125" })), se(
    e,
    604
    /* BrtEndFills */
  );
}
function xE(e) {
  var r = 1;
  se(e, 613, Lt(r)), se(e, 46, oE()), se(
    e,
    614
    /* BrtEndBorders */
  );
}
function mE(e) {
  var r = 1;
  se(e, 626, Lt(r)), se(e, 47, Yv({
    numFmtId: 0,
    fontId: 0,
    fillId: 0,
    borderId: 0
  }, 65535)), se(
    e,
    627
    /* BrtEndCellStyleXFs */
  );
}
function pE(e, r) {
  se(e, 617, Lt(r.length)), r.forEach(function(t) {
    se(e, 47, Yv(t, 0));
  }), se(
    e,
    618
    /* BrtEndCellXFs */
  );
}
function vE(e) {
  var r = 1;
  se(e, 619, Lt(r)), se(e, 48, uE({
    xfId: 0,
    builtinId: 0,
    name: "Normal"
  })), se(
    e,
    620
    /* BrtEndStyles */
  );
}
function gE(e) {
  var r = 0;
  se(e, 505, Lt(r)), se(
    e,
    506
    /* BrtEndDXFs */
  );
}
function yE(e) {
  var r = 0;
  se(e, 508, lE(r, "TableStyleMedium9", "PivotStyleMedium4")), se(
    e,
    509
    /* BrtEndTableStyles */
  );
}
function bE(e, r) {
  var t = ut();
  return se(
    t,
    278
    /* BrtBeginStyleSheet */
  ), fE(t, e.SSF), dE(t), hE(t), xE(t), mE(t), pE(t, r.cellXfs), vE(t), gE(t), yE(t), se(
    t,
    279
    /* BrtEndStyleSheet */
  ), t.end();
}
var wE = [
  "</a:lt1>",
  "</a:dk1>",
  "</a:lt2>",
  "</a:dk2>",
  "</a:accent1>",
  "</a:accent2>",
  "</a:accent3>",
  "</a:accent4>",
  "</a:accent5>",
  "</a:accent6>",
  "</a:hlink>",
  "</a:folHlink>"
];
function _E(e, r, t) {
  r.themeElements.clrScheme = [];
  var a = {};
  (e[0].match(Qr) || []).forEach(function(n) {
    var i = Se(n);
    switch (i[0]) {
      case "<a:clrScheme":
      case "</a:clrScheme>":
        break;
      case "<a:srgbClr":
        a.rgb = i.val;
        break;
      case "<a:sysClr":
        a.rgb = i.lastClr;
        break;
      case "<a:dk1>":
      case "</a:dk1>":
      case "<a:lt1>":
      case "</a:lt1>":
      case "<a:dk2>":
      case "</a:dk2>":
      case "<a:lt2>":
      case "</a:lt2>":
      case "<a:accent1>":
      case "</a:accent1>":
      case "<a:accent2>":
      case "</a:accent2>":
      case "<a:accent3>":
      case "</a:accent3>":
      case "<a:accent4>":
      case "</a:accent4>":
      case "<a:accent5>":
      case "</a:accent5>":
      case "<a:accent6>":
      case "</a:accent6>":
      case "<a:hlink>":
      case "</a:hlink>":
      case "<a:folHlink>":
      case "</a:folHlink>":
        i[0].charAt(1) === "/" ? (r.themeElements.clrScheme[wE.indexOf(i[0])] = a, a = {}) : a.name = i[0].slice(3, i[0].length - 1);
        break;
      default:
        if (t && t.WTF)
          throw new Error("Unrecognized " + i[0] + " in clrScheme");
    }
  });
}
function $E() {
}
function DE() {
}
var EE = /<a:clrScheme([^>]*)>[\s\S]*<\/a:clrScheme>/, kE = /<a:fontScheme([^>]*)>[\s\S]*<\/a:fontScheme>/, TE = /<a:fmtScheme([^>]*)>[\s\S]*<\/a:fmtScheme>/;
function SE(e, r, t) {
  r.themeElements = {};
  var a;
  [
    /* clrScheme CT_ColorScheme */
    ["clrScheme", EE, _E],
    /* fontScheme CT_FontScheme */
    ["fontScheme", kE, $E],
    /* fmtScheme CT_StyleMatrix */
    ["fmtScheme", TE, DE]
  ].forEach(function(n) {
    if (!(a = e.match(n[1])))
      throw new Error(n[0] + " not found in themeElements");
    n[2](a, r, t);
  });
}
var CE = /<a:themeElements([^>]*)>[\s\S]*<\/a:themeElements>/;
function Xv(e, r) {
  (!e || e.length === 0) && (e = Gc());
  var t, a = {};
  if (!(t = e.match(CE)))
    throw new Error("themeElements not found in theme");
  return SE(t[0], a, r), a.raw = e, a;
}
function Gc(e, r) {
  if (r && r.themeXLSX)
    return r.themeXLSX;
  if (e && typeof e.raw == "string")
    return e.raw;
  var t = [$r];
  return t[t.length] = '<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">', t[t.length] = "<a:themeElements>", t[t.length] = '<a:clrScheme name="Office">', t[t.length] = '<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>', t[t.length] = '<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>', t[t.length] = '<a:dk2><a:srgbClr val="1F497D"/></a:dk2>', t[t.length] = '<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>', t[t.length] = '<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>', t[t.length] = '<a:accent2><a:srgbClr val="C0504D"/></a:accent2>', t[t.length] = '<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>', t[t.length] = '<a:accent4><a:srgbClr val="8064A2"/></a:accent4>', t[t.length] = '<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>', t[t.length] = '<a:accent6><a:srgbClr val="F79646"/></a:accent6>', t[t.length] = '<a:hlink><a:srgbClr val="0000FF"/></a:hlink>', t[t.length] = '<a:folHlink><a:srgbClr val="800080"/></a:folHlink>', t[t.length] = "</a:clrScheme>", t[t.length] = '<a:fontScheme name="Office">', t[t.length] = "<a:majorFont>", t[t.length] = '<a:latin typeface="Cambria"/>', t[t.length] = '<a:ea typeface=""/>', t[t.length] = '<a:cs typeface=""/>', t[t.length] = '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>', t[t.length] = '<a:font script="Hang" typeface="맑은 고딕"/>', t[t.length] = '<a:font script="Hans" typeface="宋体"/>', t[t.length] = '<a:font script="Hant" typeface="新細明體"/>', t[t.length] = '<a:font script="Arab" typeface="Times New Roman"/>', t[t.length] = '<a:font script="Hebr" typeface="Times New Roman"/>', t[t.length] = '<a:font script="Thai" typeface="Tahoma"/>', t[t.length] = '<a:font script="Ethi" typeface="Nyala"/>', t[t.length] = '<a:font script="Beng" typeface="Vrinda"/>', t[t.length] = '<a:font script="Gujr" typeface="Shruti"/>', t[t.length] = '<a:font script="Khmr" typeface="MoolBoran"/>', t[t.length] = '<a:font script="Knda" typeface="Tunga"/>', t[t.length] = '<a:font script="Guru" typeface="Raavi"/>', t[t.length] = '<a:font script="Cans" typeface="Euphemia"/>', t[t.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>', t[t.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>', t[t.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>', t[t.length] = '<a:font script="Thaa" typeface="MV Boli"/>', t[t.length] = '<a:font script="Deva" typeface="Mangal"/>', t[t.length] = '<a:font script="Telu" typeface="Gautami"/>', t[t.length] = '<a:font script="Taml" typeface="Latha"/>', t[t.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>', t[t.length] = '<a:font script="Orya" typeface="Kalinga"/>', t[t.length] = '<a:font script="Mlym" typeface="Kartika"/>', t[t.length] = '<a:font script="Laoo" typeface="DokChampa"/>', t[t.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>', t[t.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>', t[t.length] = '<a:font script="Viet" typeface="Times New Roman"/>', t[t.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>', t[t.length] = '<a:font script="Geor" typeface="Sylfaen"/>', t[t.length] = "</a:majorFont>", t[t.length] = "<a:minorFont>", t[t.length] = '<a:latin typeface="Calibri"/>', t[t.length] = '<a:ea typeface=""/>', t[t.length] = '<a:cs typeface=""/>', t[t.length] = '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>', t[t.length] = '<a:font script="Hang" typeface="맑은 고딕"/>', t[t.length] = '<a:font script="Hans" typeface="宋体"/>', t[t.length] = '<a:font script="Hant" typeface="新細明體"/>', t[t.length] = '<a:font script="Arab" typeface="Arial"/>', t[t.length] = '<a:font script="Hebr" typeface="Arial"/>', t[t.length] = '<a:font script="Thai" typeface="Tahoma"/>', t[t.length] = '<a:font script="Ethi" typeface="Nyala"/>', t[t.length] = '<a:font script="Beng" typeface="Vrinda"/>', t[t.length] = '<a:font script="Gujr" typeface="Shruti"/>', t[t.length] = '<a:font script="Khmr" typeface="DaunPenh"/>', t[t.length] = '<a:font script="Knda" typeface="Tunga"/>', t[t.length] = '<a:font script="Guru" typeface="Raavi"/>', t[t.length] = '<a:font script="Cans" typeface="Euphemia"/>', t[t.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>', t[t.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>', t[t.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>', t[t.length] = '<a:font script="Thaa" typeface="MV Boli"/>', t[t.length] = '<a:font script="Deva" typeface="Mangal"/>', t[t.length] = '<a:font script="Telu" typeface="Gautami"/>', t[t.length] = '<a:font script="Taml" typeface="Latha"/>', t[t.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>', t[t.length] = '<a:font script="Orya" typeface="Kalinga"/>', t[t.length] = '<a:font script="Mlym" typeface="Kartika"/>', t[t.length] = '<a:font script="Laoo" typeface="DokChampa"/>', t[t.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>', t[t.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>', t[t.length] = '<a:font script="Viet" typeface="Arial"/>', t[t.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>', t[t.length] = '<a:font script="Geor" typeface="Sylfaen"/>', t[t.length] = "</a:minorFont>", t[t.length] = "</a:fontScheme>", t[t.length] = '<a:fmtScheme name="Office">', t[t.length] = "<a:fillStyleLst>", t[t.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>', t[t.length] = '<a:gradFill rotWithShape="1">', t[t.length] = "<a:gsLst>", t[t.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>', t[t.length] = '<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>', t[t.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>', t[t.length] = "</a:gsLst>", t[t.length] = '<a:lin ang="16200000" scaled="1"/>', t[t.length] = "</a:gradFill>", t[t.length] = '<a:gradFill rotWithShape="1">', t[t.length] = "<a:gsLst>", t[t.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>', t[t.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>', t[t.length] = "</a:gsLst>", t[t.length] = '<a:lin ang="16200000" scaled="0"/>', t[t.length] = "</a:gradFill>", t[t.length] = "</a:fillStyleLst>", t[t.length] = "<a:lnStyleLst>", t[t.length] = '<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>', t[t.length] = '<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>', t[t.length] = '<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>', t[t.length] = "</a:lnStyleLst>", t[t.length] = "<a:effectStyleLst>", t[t.length] = "<a:effectStyle>", t[t.length] = "<a:effectLst>", t[t.length] = '<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>', t[t.length] = "</a:effectLst>", t[t.length] = "</a:effectStyle>", t[t.length] = "<a:effectStyle>", t[t.length] = "<a:effectLst>", t[t.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>', t[t.length] = "</a:effectLst>", t[t.length] = "</a:effectStyle>", t[t.length] = "<a:effectStyle>", t[t.length] = "<a:effectLst>", t[t.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>', t[t.length] = "</a:effectLst>", t[t.length] = '<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>', t[t.length] = '<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>', t[t.length] = "</a:effectStyle>", t[t.length] = "</a:effectStyleLst>", t[t.length] = "<a:bgFillStyleLst>", t[t.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>', t[t.length] = '<a:gradFill rotWithShape="1">', t[t.length] = "<a:gsLst>", t[t.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>', t[t.length] = '<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>', t[t.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>', t[t.length] = "</a:gsLst>", t[t.length] = '<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>', t[t.length] = "</a:gradFill>", t[t.length] = '<a:gradFill rotWithShape="1">', t[t.length] = "<a:gsLst>", t[t.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>', t[t.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>', t[t.length] = "</a:gsLst>", t[t.length] = '<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>', t[t.length] = "</a:gradFill>", t[t.length] = "</a:bgFillStyleLst>", t[t.length] = "</a:fmtScheme>", t[t.length] = "</a:themeElements>", t[t.length] = "<a:objectDefaults>", t[t.length] = "<a:spDef>", t[t.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>', t[t.length] = "</a:spDef>", t[t.length] = "<a:lnDef>", t[t.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>', t[t.length] = "</a:lnDef>", t[t.length] = "</a:objectDefaults>", t[t.length] = "<a:extraClrSchemeLst/>", t[t.length] = "</a:theme>", t.join("");
}
function FE(e, r, t) {
  var a = e.l + r, n = e.read_shift(4);
  if (n !== 124226) {
    if (!t.cellStyles) {
      e.l = a;
      return;
    }
    var i = e.slice(e.l);
    e.l = a;
    var s;
    try {
      s = zp(i, { type: "array" });
    } catch {
      return;
    }
    var o = ht(s, "theme/theme/theme1.xml", !0);
    if (o)
      return Xv(o, t);
  }
}
function AE(e) {
  return e.read_shift(4);
}
function RE(e) {
  var r = {};
  switch (r.xclrType = e.read_shift(2), r.nTintShade = e.read_shift(2), r.xclrType) {
    case 0:
      e.l += 4;
      break;
    case 1:
      r.xclrValue = IE(e, 4);
      break;
    case 2:
      r.xclrValue = Sv(e);
      break;
    case 3:
      r.xclrValue = AE(e);
      break;
    case 4:
      e.l += 4;
      break;
  }
  return e.l += 8, r;
}
function IE(e, r) {
  return qr(e, r);
}
function BE(e, r) {
  return qr(e, r);
}
function PE(e) {
  var r = e.read_shift(2), t = e.read_shift(2) - 4, a = [r];
  switch (r) {
    case 4:
    case 5:
    case 7:
    case 8:
    case 9:
    case 10:
    case 11:
    case 13:
      a[1] = RE(e);
      break;
    case 6:
      a[1] = BE(e, t);
      break;
    case 14:
    case 15:
      a[1] = e.read_shift(t === 1 ? 1 : 2);
      break;
    default:
      throw new Error("Unrecognized ExtProp type: " + r + " " + t);
  }
  return a;
}
function ME(e, r) {
  var t = e.l + r;
  e.l += 2;
  var a = e.read_shift(2);
  e.l += 2;
  for (var n = e.read_shift(2), i = []; n-- > 0; )
    i.push(PE(e, t - e.l));
  return { ixfe: a, ext: i };
}
function OE(e, r) {
  r.forEach(function(t) {
    switch (t[0]) {
    }
  });
}
function LE(e, r) {
  return {
    flags: e.read_shift(4),
    version: e.read_shift(4),
    name: Jr(e)
  };
}
function NE(e) {
  var r = te(12 + 2 * e.name.length);
  return r.write_shift(4, e.flags), r.write_shift(4, e.version), Lr(e.name, r), r.slice(0, r.l);
}
function UE(e) {
  for (var r = [], t = e.read_shift(4); t-- > 0; )
    r.push([e.read_shift(4), e.read_shift(4)]);
  return r;
}
function VE(e) {
  var r = te(4 + 8 * e.length);
  r.write_shift(4, e.length);
  for (var t = 0; t < e.length; ++t)
    r.write_shift(4, e[t][0]), r.write_shift(4, e[t][1]);
  return r;
}
function WE(e, r) {
  var t = te(8 + 2 * r.length);
  return t.write_shift(4, e), Lr(r, t), t.slice(0, t.l);
}
function HE(e) {
  return e.l += 4, e.read_shift(4) != 0;
}
function jE(e, r) {
  var t = te(8);
  return t.write_shift(4, e), t.write_shift(4, 1), t;
}
function zE(e, r, t) {
  var a = { Types: [], Cell: [], Value: [] }, n = t || {}, i = [], s = !1, o = 2;
  return ma(e, function(u, l, c) {
    switch (c) {
      case 335:
        a.Types.push({ name: u.name });
        break;
      case 51:
        u.forEach(function(f) {
          o == 1 ? a.Cell.push({ type: a.Types[f[0] - 1].name, index: f[1] }) : o == 0 && a.Value.push({ type: a.Types[f[0] - 1].name, index: f[1] });
        });
        break;
      case 337:
        o = u ? 1 : 0;
        break;
      case 338:
        o = 2;
        break;
      case 35:
        i.push(c), s = !0;
        break;
      case 36:
        i.pop(), s = !1;
        break;
      default:
        if (!l.T) {
          if (!s || n.WTF && i[i.length - 1] != 35)
            throw new Error("Unexpected record 0x" + c.toString(16));
        }
    }
  }), a;
}
function GE() {
  var e = ut();
  return se(e, 332), se(e, 334, Lt(1)), se(e, 335, NE({
    name: "XLDAPR",
    version: 12e4,
    flags: 3496657072
  })), se(e, 336), se(e, 339, WE(1, "XLDAPR")), se(e, 52), se(e, 35, Lt(514)), se(e, 4096, Lt(0)), se(e, 4097, Dt(1)), se(e, 36), se(e, 53), se(e, 340), se(e, 337, jE(1)), se(e, 51, VE([[1, 0]])), se(e, 338), se(e, 333), e.end();
}
function KE(e, r, t) {
  var a = { Types: [], Cell: [], Value: [] };
  if (!e)
    return a;
  var n = !1, i = 2, s;
  return e.replace(Qr, function(o) {
    var u = Se(o);
    switch (Xt(u[0])) {
      case "<?xml":
        break;
      case "<metadata":
      case "</metadata>":
        break;
      case "<metadataTypes":
      case "</metadataTypes>":
        break;
      case "<metadataType":
        a.Types.push({ name: u.name });
        break;
      case "</metadataType>":
        break;
      case "<futureMetadata":
        for (var l = 0; l < a.Types.length; ++l)
          a.Types[l].name == u.name && (s = a.Types[l]);
        break;
      case "</futureMetadata>":
        break;
      case "<bk>":
        break;
      case "</bk>":
        break;
      case "<rc":
        i == 1 ? a.Cell.push({ type: a.Types[u.t - 1].name, index: +u.v }) : i == 0 && a.Value.push({ type: a.Types[u.t - 1].name, index: +u.v });
        break;
      case "</rc>":
        break;
      case "<cellMetadata":
        i = 1;
        break;
      case "</cellMetadata>":
        i = 2;
        break;
      case "<valueMetadata":
        i = 0;
        break;
      case "</valueMetadata>":
        i = 2;
        break;
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
      case "<extLst/>":
        break;
      case "<ext":
        n = !0;
        break;
      case "</ext>":
        n = !1;
        break;
      case "<rvb":
        if (!s)
          break;
        s.offsets || (s.offsets = []), s.offsets.push(+u.i);
        break;
      default:
        if (!n && t.WTF)
          throw new Error("unrecognized " + u[0] + " in metadata");
    }
    return o;
  }), a;
}
function Zv() {
  var e = [$r];
  return e.push(`<metadata xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:xlrd="http://schemas.microsoft.com/office/spreadsheetml/2017/richdata" xmlns:xda="http://schemas.microsoft.com/office/spreadsheetml/2017/dynamicarray">
  <metadataTypes count="1">
    <metadataType name="XLDAPR" minSupportedVersion="120000" copy="1" pasteAll="1" pasteValues="1" merge="1" splitFirst="1" rowColShift="1" clearFormats="1" clearComments="1" assign="1" coerce="1" cellMeta="1"/>
  </metadataTypes>
  <futureMetadata name="XLDAPR" count="1">
    <bk>
      <extLst>
        <ext uri="{bdbb8cdc-fa1e-496e-a857-3c3f30c029c3}">
          <xda:dynamicArrayProperties fDynamic="1" fCollapsed="0"/>
        </ext>
      </extLst>
    </bk>
  </futureMetadata>
  <cellMetadata count="1">
    <bk>
      <rc t="1" v="0"/>
    </bk>
  </cellMetadata>
</metadata>`), e.join("");
}
function YE(e) {
  var r = [];
  if (!e)
    return r;
  var t = 1;
  return (e.match(Qr) || []).forEach(function(a) {
    var n = Se(a);
    switch (n[0]) {
      case "<?xml":
        break;
      case "<calcChain":
      case "<calcChain>":
      case "</calcChain>":
        break;
      case "<c":
        delete n[0], n.i ? t = n.i : n.i = t, r.push(n);
        break;
    }
  }), r;
}
function XE(e) {
  var r = {};
  r.i = e.read_shift(4);
  var t = {};
  t.r = e.read_shift(4), t.c = e.read_shift(4), r.r = Te(t);
  var a = e.read_shift(1);
  return a & 2 && (r.l = "1"), a & 8 && (r.a = "1"), r;
}
function ZE(e, r, t) {
  var a = [];
  return ma(e, function(i, s, o) {
    switch (o) {
      case 63:
        a.push(i);
        break;
      default:
        if (!s.T)
          throw new Error("Unexpected record 0x" + o.toString(16));
    }
  }), a;
}
function JE(e, r, t, a) {
  if (!e)
    return e;
  var n = a || {}, i = !1;
  ma(e, function(o, u, l) {
    switch (l) {
      case 359:
      case 363:
      case 364:
      case 366:
      case 367:
      case 368:
      case 369:
      case 370:
      case 371:
      case 472:
      case 577:
      case 578:
      case 579:
      case 580:
      case 581:
      case 582:
      case 583:
      case 584:
      case 585:
      case 586:
      case 587:
        break;
      case 35:
        i = !0;
        break;
      case 36:
        i = !1;
        break;
      default:
        if (!u.T) {
          if (!i || n.WTF)
            throw new Error("Unexpected record 0x" + l.toString(16));
        }
    }
  }, n);
}
function qE(e, r) {
  if (!e)
    return "??";
  var t = (e.match(/<c:chart [^>]*r:id="([^"]*)"/) || ["", ""])[1];
  return r["!id"][t].Target;
}
var On = 1024;
function Jv(e, r) {
  for (var t = [21600, 21600], a = ["m0,0l0", t[1], t[0], t[1], t[0], "0xe"].join(","), n = [
    he("xml", null, { "xmlns:v": ft.v, "xmlns:o": ft.o, "xmlns:x": ft.x, "xmlns:mv": ft.mv }).replace(/\/>/, ">"),
    he("o:shapelayout", he("o:idmap", null, { "v:ext": "edit", data: e }), { "v:ext": "edit" }),
    he("v:shapetype", [
      he("v:stroke", null, { joinstyle: "miter" }),
      he("v:path", null, { gradientshapeok: "t", "o:connecttype": "rect" })
    ].join(""), { id: "_x0000_t202", "o:spt": 202, coordsize: t.join(","), path: a })
  ]; On < e * 1e3; )
    On += 1e3;
  return r.forEach(function(i) {
    var s = fr(i[0]), o = (
      /*::(*/
      { color2: "#BEFF82", type: "gradient" }
    );
    o.type == "gradient" && (o.angle = "-180");
    var u = o.type == "gradient" ? he("o:fill", null, { type: "gradientUnscaled", "v:ext": "view" }) : null, l = he("v:fill", u, o), c = { on: "t", obscured: "t" };
    ++On, n = n.concat([
      "<v:shape" + ns({
        id: "_x0000_s" + On,
        type: "#_x0000_t202",
        style: "position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10" + (i[1].hidden ? ";visibility:hidden" : ""),
        fillcolor: "#ECFAD4",
        strokecolor: "#edeaa1"
      }) + ">",
      l,
      he("v:shadow", null, c),
      he("v:path", null, { "o:connecttype": "none" }),
      '<v:textbox><div style="text-align:left"></div></v:textbox>',
      '<x:ClientData ObjectType="Note">',
      "<x:MoveWithCells/>",
      "<x:SizeWithCells/>",
      /* Part 4 19.4.2.3 Anchor (Anchor) */
      Wr("x:Anchor", [s.c + 1, 0, s.r + 1, 0, s.c + 3, 20, s.r + 5, 20].join(",")),
      Wr("x:AutoFill", "False"),
      Wr("x:Row", String(s.r)),
      Wr("x:Column", String(s.c)),
      i[1].hidden ? "" : "<x:Visible/>",
      "</x:ClientData>",
      "</v:shape>"
    ]);
  }), n.push("</xml>"), n.join("");
}
function hh(e, r, t, a) {
  var n = Array.isArray(e), i;
  r.forEach(function(s) {
    var o = fr(s.ref);
    if (n ? (e[o.r] || (e[o.r] = []), i = e[o.r][o.c]) : i = e[s.ref], !i) {
      i = { t: "z" }, n ? e[o.r][o.c] = i : e[s.ref] = i;
      var u = Oe(e["!ref"] || "BDWGO1000001:A1");
      u.s.r > o.r && (u.s.r = o.r), u.e.r < o.r && (u.e.r = o.r), u.s.c > o.c && (u.s.c = o.c), u.e.c < o.c && (u.e.c = o.c);
      var l = Ce(u);
      l !== e["!ref"] && (e["!ref"] = l);
    }
    i.c || (i.c = []);
    var c = { a: s.author, t: s.t, r: s.r, T: t };
    s.h && (c.h = s.h);
    for (var f = i.c.length - 1; f >= 0; --f) {
      if (!t && i.c[f].T)
        return;
      t && !i.c[f].T && i.c.splice(f, 1);
    }
    if (t && a) {
      for (f = 0; f < a.length; ++f)
        if (c.a == a[f].id) {
          c.a = a[f].name || c.a;
          break;
        }
    }
    i.c.push(c);
  });
}
function QE(e, r) {
  if (e.match(/<(?:\w+:)?comments *\/>/))
    return [];
  var t = [], a = [], n = e.match(/<(?:\w+:)?authors>([\s\S]*)<\/(?:\w+:)?authors>/);
  n && n[1] && n[1].split(/<\/\w*:?author>/).forEach(function(s) {
    if (!(s === "" || s.trim() === "")) {
      var o = s.match(/<(?:\w+:)?author[^>]*>(.*)/);
      o && t.push(o[1]);
    }
  });
  var i = e.match(/<(?:\w+:)?commentList>([\s\S]*)<\/(?:\w+:)?commentList>/);
  return i && i[1] && i[1].split(/<\/\w*:?comment>/).forEach(function(s) {
    if (!(s === "" || s.trim() === "")) {
      var o = s.match(/<(?:\w+:)?comment[^>]*>/);
      if (o) {
        var u = Se(o[0]), l = { author: u.authorId && t[u.authorId] || "sheetjsghost", ref: u.ref, guid: u.guid }, c = fr(u.ref);
        if (!(r.sheetRows && r.sheetRows <= c.r)) {
          var f = s.match(/<(?:\w+:)?text>([\s\S]*)<\/(?:\w+:)?text>/), h = !!f && !!f[1] && Hc(f[1]) || { r: "", t: "", h: "" };
          l.r = h.r, h.r == "<t></t>" && (h.t = h.h = ""), l.t = (h.t || "").replace(/\r\n/g, `
`).replace(/\r/g, `
`), r.cellHTML && (l.h = h.h), a.push(l);
        }
      }
    }
  }), a;
}
function qv(e) {
  var r = [$r, he("comments", null, { xmlns: vn[0] })], t = [];
  return r.push("<authors>"), e.forEach(function(a) {
    a[1].forEach(function(n) {
      var i = Xe(n.a);
      t.indexOf(i) == -1 && (t.push(i), r.push("<author>" + i + "</author>")), n.T && n.ID && t.indexOf("tc=" + n.ID) == -1 && (t.push("tc=" + n.ID), r.push("<author>tc=" + n.ID + "</author>"));
    });
  }), t.length == 0 && (t.push("SheetJ5"), r.push("<author>SheetJ5</author>")), r.push("</authors>"), r.push("<commentList>"), e.forEach(function(a) {
    var n = 0, i = [];
    if (a[1][0] && a[1][0].T && a[1][0].ID ? n = t.indexOf("tc=" + a[1][0].ID) : a[1].forEach(function(u) {
      u.a && (n = t.indexOf(Xe(u.a))), i.push(u.t || "");
    }), r.push('<comment ref="' + a[0] + '" authorId="' + n + '"><text>'), i.length <= 1)
      r.push(Wr("t", Xe(i[0] || "")));
    else {
      for (var s = `Comment:
    ` + i[0] + `
`, o = 1; o < i.length; ++o)
        s += `Reply:
    ` + i[o] + `
`;
      r.push(Wr("t", Xe(s)));
    }
    r.push("</text></comment>");
  }), r.push("</commentList>"), r.length > 2 && (r[r.length] = "</comments>", r[1] = r[1].replace("/>", ">")), r.join("");
}
function e7(e, r) {
  var t = [], a = !1, n = {}, i = 0;
  return e.replace(Qr, function(o, u) {
    var l = Se(o);
    switch (Xt(l[0])) {
      case "<?xml":
        break;
      case "<ThreadedComments":
        break;
      case "</ThreadedComments>":
        break;
      case "<threadedComment":
        n = { author: l.personId, guid: l.id, ref: l.ref, T: 1 };
        break;
      case "</threadedComment>":
        n.t != null && t.push(n);
        break;
      case "<text>":
      case "<text":
        i = u + o.length;
        break;
      case "</text>":
        n.t = e.slice(i, u).replace(/\r\n/g, `
`).replace(/\r/g, `
`);
        break;
      case "<mentions":
      case "<mentions>":
        a = !0;
        break;
      case "</mentions>":
        a = !1;
        break;
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
      case "<extLst/>":
        break;
      case "<ext":
        a = !0;
        break;
      case "</ext>":
        a = !1;
        break;
      default:
        if (!a && r.WTF)
          throw new Error("unrecognized " + l[0] + " in threaded comments");
    }
    return o;
  }), t;
}
function r7(e, r, t) {
  var a = [$r, he("ThreadedComments", null, { xmlns: Fr.TCMNT }).replace(/[\/]>/, ">")];
  return e.forEach(function(n) {
    var i = "";
    (n[1] || []).forEach(function(s, o) {
      if (!s.T) {
        delete s.ID;
        return;
      }
      s.a && r.indexOf(s.a) == -1 && r.push(s.a);
      var u = {
        ref: n[0],
        id: "{54EE7951-7262-4200-6969-" + ("000000000000" + t.tcid++).slice(-12) + "}"
      };
      o == 0 ? i = u.id : u.parentId = i, s.ID = u.id, s.a && (u.personId = "{54EE7950-7262-4200-6969-" + ("000000000000" + r.indexOf(s.a)).slice(-12) + "}"), a.push(he("threadedComment", Wr("text", s.t || ""), u));
    });
  }), a.push("</ThreadedComments>"), a.join("");
}
function t7(e, r) {
  var t = [], a = !1;
  return e.replace(Qr, function(i) {
    var s = Se(i);
    switch (Xt(s[0])) {
      case "<?xml":
        break;
      case "<personList":
        break;
      case "</personList>":
        break;
      case "<person":
        t.push({ name: s.displayname, id: s.id });
        break;
      case "</person>":
        break;
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
      case "<extLst/>":
        break;
      case "<ext":
        a = !0;
        break;
      case "</ext>":
        a = !1;
        break;
      default:
        if (!a && r.WTF)
          throw new Error("unrecognized " + s[0] + " in threaded comments");
    }
    return i;
  }), t;
}
function a7(e) {
  var r = [$r, he("personList", null, {
    xmlns: Fr.TCMNT,
    "xmlns:x": vn[0]
  }).replace(/[\/]>/, ">")];
  return e.forEach(function(t, a) {
    r.push(he("person", null, {
      displayName: t,
      id: "{54EE7950-7262-4200-6969-" + ("000000000000" + a).slice(-12) + "}",
      userId: t,
      providerId: "None"
    }));
  }), r.push("</personList>"), r.join("");
}
function n7(e) {
  var r = {};
  r.iauthor = e.read_shift(4);
  var t = wn(e);
  return r.rfx = t.s, r.ref = Te(t.s), e.l += 16, r;
}
function i7(e, r) {
  return r == null && (r = te(36)), r.write_shift(4, e[1].iauthor), pi(e[0], r), r.write_shift(4, 0), r.write_shift(4, 0), r.write_shift(4, 0), r.write_shift(4, 0), r;
}
var s7 = Jr;
function o7(e) {
  return Lr(e.slice(0, 54));
}
function u7(e, r) {
  var t = [], a = [], n = {}, i = !1;
  return ma(e, function(o, u, l) {
    switch (l) {
      case 632:
        a.push(o);
        break;
      case 635:
        n = o;
        break;
      case 637:
        n.t = o.t, n.h = o.h, n.r = o.r;
        break;
      case 636:
        if (n.author = a[n.iauthor], delete n.iauthor, r.sheetRows && n.rfx && r.sheetRows <= n.rfx.r)
          break;
        n.t || (n.t = ""), delete n.rfx, t.push(n);
        break;
      case 3072:
        break;
      case 35:
        i = !0;
        break;
      case 36:
        i = !1;
        break;
      case 37:
        break;
      case 38:
        break;
      default:
        if (!u.T) {
          if (!i || r.WTF)
            throw new Error("Unexpected record 0x" + l.toString(16));
        }
    }
  }), t;
}
function l7(e) {
  var r = ut(), t = [];
  return se(
    r,
    628
    /* BrtBeginComments */
  ), se(
    r,
    630
    /* BrtBeginCommentAuthors */
  ), e.forEach(function(a) {
    a[1].forEach(function(n) {
      t.indexOf(n.a) > -1 || (t.push(n.a.slice(0, 54)), se(r, 632, o7(n.a)));
    });
  }), se(
    r,
    631
    /* BrtEndCommentAuthors */
  ), se(
    r,
    633
    /* BrtBeginCommentList */
  ), e.forEach(function(a) {
    a[1].forEach(function(n) {
      n.iauthor = t.indexOf(n.a);
      var i = { s: fr(a[0]), e: fr(a[0]) };
      se(r, 635, i7([i, n])), n.t && n.t.length > 0 && se(r, 637, A_(n)), se(
        r,
        636
        /* BrtEndComment */
      ), delete n.iauthor;
    });
  }), se(
    r,
    634
    /* BrtEndCommentList */
  ), se(
    r,
    629
    /* BrtEndComments */
  ), r.end();
}
var c7 = "application/vnd.ms-office.vbaProject";
function f7(e) {
  var r = we.utils.cfb_new({ root: "R" });
  return e.FullPaths.forEach(function(t, a) {
    if (!(t.slice(-1) === "/" || !t.match(/_VBA_PROJECT_CUR/))) {
      var n = t.replace(/^[^\/]*/, "R").replace(/\/_VBA_PROJECT_CUR\u0000*/, "");
      we.utils.cfb_add(r, n, e.FileIndex[a].content);
    }
  }), we.write(r);
}
function d7(e, r) {
  r.FullPaths.forEach(function(t, a) {
    if (a != 0) {
      var n = t.replace(/[^\/]*[\/]/, "/_VBA_PROJECT_CUR/");
      n.slice(-1) !== "/" && we.utils.cfb_add(e, n, r.FileIndex[a].content);
    }
  });
}
var Qv = ["xlsb", "xlsm", "xlam", "biff8", "xla"];
function h7() {
  return { "!type": "dialog" };
}
function x7() {
  return { "!type": "dialog" };
}
function m7() {
  return { "!type": "macro" };
}
function p7() {
  return { "!type": "macro" };
}
var Kn = /* @__PURE__ */ function() {
  var e = /(^|[^A-Za-z_])R(\[?-?\d+\]|[1-9]\d*|)C(\[?-?\d+\]|[1-9]\d*|)(?![A-Za-z0-9_])/g, r = { r: 0, c: 0 };
  function t(a, n, i, s) {
    var o = !1, u = !1;
    i.length == 0 ? u = !0 : i.charAt(0) == "[" && (u = !0, i = i.slice(1, -1)), s.length == 0 ? o = !0 : s.charAt(0) == "[" && (o = !0, s = s.slice(1, -1));
    var l = i.length > 0 ? parseInt(i, 10) | 0 : 0, c = s.length > 0 ? parseInt(s, 10) | 0 : 0;
    return o ? c += r.c : --c, u ? l += r.r : --l, n + (o ? "" : "$") + or(c) + (u ? "" : "$") + gr(l);
  }
  return function(n, i) {
    return r = i, n.replace(e, t);
  };
}(), Kc = /(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})(?![_.\(A-Za-z0-9])/g, Yc = /* @__PURE__ */ function() {
  return function(r, t) {
    return r.replace(Kc, function(a, n, i, s, o, u) {
      var l = Bc(s) - (i ? 0 : t.c), c = Ic(u) - (o ? 0 : t.r), f = c == 0 ? "" : o ? c + 1 : "[" + c + "]", h = l == 0 ? "" : i ? l + 1 : "[" + l + "]";
      return n + "R" + f + "C" + h;
    });
  };
}();
function e2(e, r) {
  return e.replace(Kc, function(t, a, n, i, s, o) {
    return a + (n == "$" ? n + i : or(Bc(i) + r.c)) + (s == "$" ? s + o : gr(Ic(o) + r.r));
  });
}
function v7(e, r, t) {
  var a = tt(r), n = a.s, i = fr(t), s = { r: i.r - n.r, c: i.c - n.c };
  return e2(e, s);
}
function g7(e) {
  return e.length != 1;
}
function xh(e) {
  return e.replace(/_xlfn\./g, "");
}
function Dr(e) {
  e.l += 1;
}
function Oa(e, r) {
  var t = e.read_shift(2);
  return [t & 16383, t >> 14 & 1, t >> 15 & 1];
}
function r2(e, r, t) {
  var a = 2;
  if (t) {
    if (t.biff >= 2 && t.biff <= 5)
      return t2(e);
    t.biff == 12 && (a = 4);
  }
  var n = e.read_shift(a), i = e.read_shift(a), s = Oa(e), o = Oa(e);
  return { s: { r: n, c: s[0], cRel: s[1], rRel: s[2] }, e: { r: i, c: o[0], cRel: o[1], rRel: o[2] } };
}
function t2(e) {
  var r = Oa(e), t = Oa(e), a = e.read_shift(1), n = e.read_shift(1);
  return { s: { r: r[0], c: a, cRel: r[1], rRel: r[2] }, e: { r: t[0], c: n, cRel: t[1], rRel: t[2] } };
}
function y7(e, r, t) {
  if (t.biff < 8)
    return t2(e);
  var a = e.read_shift(t.biff == 12 ? 4 : 2), n = e.read_shift(t.biff == 12 ? 4 : 2), i = Oa(e), s = Oa(e);
  return { s: { r: a, c: i[0], cRel: i[1], rRel: i[2] }, e: { r: n, c: s[0], cRel: s[1], rRel: s[2] } };
}
function a2(e, r, t) {
  if (t && t.biff >= 2 && t.biff <= 5)
    return b7(e);
  var a = e.read_shift(t && t.biff == 12 ? 4 : 2), n = Oa(e);
  return { r: a, c: n[0], cRel: n[1], rRel: n[2] };
}
function b7(e) {
  var r = Oa(e), t = e.read_shift(1);
  return { r: r[0], c: t, cRel: r[1], rRel: r[2] };
}
function w7(e) {
  var r = e.read_shift(2), t = e.read_shift(2);
  return { r, c: t & 255, fQuoted: !!(t & 16384), cRel: t >> 15, rRel: t >> 15 };
}
function _7(e, r, t) {
  var a = t && t.biff ? t.biff : 8;
  if (a >= 2 && a <= 5)
    return $7(e);
  var n = e.read_shift(a >= 12 ? 4 : 2), i = e.read_shift(2), s = (i & 16384) >> 14, o = (i & 32768) >> 15;
  if (i &= 16383, o == 1)
    for (; n > 524287; )
      n -= 1048576;
  if (s == 1)
    for (; i > 8191; )
      i = i - 16384;
  return { r: n, c: i, cRel: s, rRel: o };
}
function $7(e) {
  var r = e.read_shift(2), t = e.read_shift(1), a = (r & 32768) >> 15, n = (r & 16384) >> 14;
  return r &= 16383, a == 1 && r >= 8192 && (r = r - 16384), n == 1 && t >= 128 && (t = t - 256), { r, c: t, cRel: n, rRel: a };
}
function D7(e, r, t) {
  var a = (e[e.l++] & 96) >> 5, n = r2(e, t.biff >= 2 && t.biff <= 5 ? 6 : 8, t);
  return [a, n];
}
function E7(e, r, t) {
  var a = (e[e.l++] & 96) >> 5, n = e.read_shift(2, "i"), i = 8;
  if (t)
    switch (t.biff) {
      case 5:
        e.l += 12, i = 6;
        break;
      case 12:
        i = 12;
        break;
    }
  var s = r2(e, i, t);
  return [a, n, s];
}
function k7(e, r, t) {
  var a = (e[e.l++] & 96) >> 5;
  return e.l += t && t.biff > 8 ? 12 : t.biff < 8 ? 6 : 8, [a];
}
function T7(e, r, t) {
  var a = (e[e.l++] & 96) >> 5, n = e.read_shift(2), i = 8;
  if (t)
    switch (t.biff) {
      case 5:
        e.l += 12, i = 6;
        break;
      case 12:
        i = 12;
        break;
    }
  return e.l += i, [a, n];
}
function S7(e, r, t) {
  var a = (e[e.l++] & 96) >> 5, n = y7(e, r - 1, t);
  return [a, n];
}
function C7(e, r, t) {
  var a = (e[e.l++] & 96) >> 5;
  return e.l += t.biff == 2 ? 6 : t.biff == 12 ? 14 : 7, [a];
}
function mh(e) {
  var r = e[e.l + 1] & 1, t = 1;
  return e.l += 4, [r, t];
}
function F7(e, r, t) {
  e.l += 2;
  for (var a = e.read_shift(t && t.biff == 2 ? 1 : 2), n = [], i = 0; i <= a; ++i)
    n.push(e.read_shift(t && t.biff == 2 ? 1 : 2));
  return n;
}
function A7(e, r, t) {
  var a = e[e.l + 1] & 255 ? 1 : 0;
  return e.l += 2, [a, e.read_shift(t && t.biff == 2 ? 1 : 2)];
}
function R7(e, r, t) {
  var a = e[e.l + 1] & 255 ? 1 : 0;
  return e.l += 2, [a, e.read_shift(t && t.biff == 2 ? 1 : 2)];
}
function I7(e) {
  var r = e[e.l + 1] & 255 ? 1 : 0;
  return e.l += 2, [r, e.read_shift(2)];
}
function B7(e, r, t) {
  var a = e[e.l + 1] & 255 ? 1 : 0;
  return e.l += t && t.biff == 2 ? 3 : 4, [a];
}
function n2(e) {
  var r = e.read_shift(1), t = e.read_shift(1);
  return [r, t];
}
function P7(e) {
  return e.read_shift(2), n2(e);
}
function M7(e) {
  return e.read_shift(2), n2(e);
}
function O7(e, r, t) {
  var a = (e[e.l] & 96) >> 5;
  e.l += 1;
  var n = a2(e, 0, t);
  return [a, n];
}
function L7(e, r, t) {
  var a = (e[e.l] & 96) >> 5;
  e.l += 1;
  var n = _7(e, 0, t);
  return [a, n];
}
function N7(e, r, t) {
  var a = (e[e.l] & 96) >> 5;
  e.l += 1;
  var n = e.read_shift(2);
  t && t.biff == 5 && (e.l += 12);
  var i = a2(e, 0, t);
  return [a, n, i];
}
function U7(e, r, t) {
  var a = (e[e.l] & 96) >> 5;
  e.l += 1;
  var n = e.read_shift(t && t.biff <= 3 ? 1 : 2);
  return [H8[n], o2[n], a];
}
function V7(e, r, t) {
  var a = e[e.l++], n = e.read_shift(1), i = t && t.biff <= 3 ? [a == 88 ? -1 : 0, e.read_shift(1)] : W7(e);
  return [n, (i[0] === 0 ? o2 : W8)[i[1]]];
}
function W7(e) {
  return [e[e.l + 1] >> 7, e.read_shift(2) & 32767];
}
function H7(e, r, t) {
  e.l += t && t.biff == 2 ? 3 : 4;
}
function j7(e, r, t) {
  if (e.l++, t && t.biff == 12)
    return [e.read_shift(4, "i"), 0];
  var a = e.read_shift(2), n = e.read_shift(t && t.biff == 2 ? 1 : 2);
  return [a, n];
}
function z7(e) {
  return e.l++, pa[e.read_shift(1)];
}
function G7(e) {
  return e.l++, e.read_shift(2);
}
function K7(e) {
  return e.l++, e.read_shift(1) !== 0;
}
function Y7(e) {
  return e.l++, Xr(e);
}
function X7(e, r, t) {
  return e.l++, Es(e, r - 1, t);
}
function Z7(e, r) {
  var t = [e.read_shift(1)];
  if (r == 12)
    switch (t[0]) {
      case 2:
        t[0] = 4;
        break;
      case 4:
        t[0] = 16;
        break;
      case 0:
        t[0] = 1;
        break;
      case 1:
        t[0] = 2;
        break;
    }
  switch (t[0]) {
    case 4:
      t[1] = _r(e, 1) ? "TRUE" : "FALSE", r != 12 && (e.l += 7);
      break;
    case 37:
    case 16:
      t[1] = pa[e[e.l]], e.l += r == 12 ? 4 : 8;
      break;
    case 0:
      e.l += 8;
      break;
    case 1:
      t[1] = Xr(e);
      break;
    case 2:
      t[1] = _n(e, 0, { biff: r > 0 && r < 8 ? 2 : r });
      break;
    default:
      throw new Error("Bad SerAr: " + t[0]);
  }
  return t;
}
function J7(e, r, t) {
  for (var a = e.read_shift(t.biff == 12 ? 4 : 2), n = [], i = 0; i != a; ++i)
    n.push((t.biff == 12 ? wn : y0)(e));
  return n;
}
function q7(e, r, t) {
  var a = 0, n = 0;
  t.biff == 12 ? (a = e.read_shift(4), n = e.read_shift(4)) : (n = 1 + e.read_shift(1), a = 1 + e.read_shift(2)), t.biff >= 2 && t.biff < 8 && (--a, --n == 0 && (n = 256));
  for (var i = 0, s = []; i != a && (s[i] = []); ++i)
    for (var o = 0; o != n; ++o)
      s[i][o] = Z7(e, t.biff);
  return s;
}
function Q7(e, r, t) {
  var a = e.read_shift(1) >>> 5 & 3, n = !t || t.biff >= 8 ? 4 : 2, i = e.read_shift(n);
  switch (t.biff) {
    case 2:
      e.l += 5;
      break;
    case 3:
    case 4:
      e.l += 8;
      break;
    case 5:
      e.l += 12;
      break;
  }
  return [a, 0, i];
}
function e8(e, r, t) {
  if (t.biff == 5)
    return r8(e);
  var a = e.read_shift(1) >>> 5 & 3, n = e.read_shift(2), i = e.read_shift(4);
  return [a, n, i];
}
function r8(e) {
  var r = e.read_shift(1) >>> 5 & 3, t = e.read_shift(2, "i");
  e.l += 8;
  var a = e.read_shift(2);
  return e.l += 12, [r, t, a];
}
function t8(e, r, t) {
  var a = e.read_shift(1) >>> 5 & 3;
  e.l += t && t.biff == 2 ? 3 : 4;
  var n = e.read_shift(t && t.biff == 2 ? 1 : 2);
  return [a, n];
}
function a8(e, r, t) {
  var a = e.read_shift(1) >>> 5 & 3, n = e.read_shift(t && t.biff == 2 ? 1 : 2);
  return [a, n];
}
function n8(e, r, t) {
  var a = e.read_shift(1) >>> 5 & 3;
  return e.l += 4, t.biff < 8 && e.l--, t.biff == 12 && (e.l += 2), [a];
}
function i8(e, r, t) {
  var a = (e[e.l++] & 96) >> 5, n = e.read_shift(2), i = 4;
  if (t)
    switch (t.biff) {
      case 5:
        i = 15;
        break;
      case 12:
        i = 6;
        break;
    }
  return e.l += i, [a, n];
}
var s8 = qr, o8 = qr, u8 = qr;
function Ts(e, r, t) {
  return e.l += 2, [w7(e)];
}
function Xc(e) {
  return e.l += 6, [];
}
var l8 = Ts, c8 = Xc, f8 = Xc, d8 = Ts;
function i2(e) {
  return e.l += 2, [Tr(e), e.read_shift(2) & 1];
}
var h8 = Ts, x8 = i2, m8 = Xc, p8 = Ts, v8 = Ts, g8 = [
  "Data",
  "All",
  "Headers",
  "??",
  "?Data2",
  "??",
  "?DataHeaders",
  "??",
  "Totals",
  "??",
  "??",
  "??",
  "?DataTotals",
  "??",
  "??",
  "??",
  "?Current"
];
function y8(e) {
  e.l += 2;
  var r = e.read_shift(2), t = e.read_shift(2), a = e.read_shift(4), n = e.read_shift(2), i = e.read_shift(2), s = g8[t >> 2 & 31];
  return { ixti: r, coltype: t & 3, rt: s, idx: a, c: n, C: i };
}
function b8(e) {
  return e.l += 2, [e.read_shift(4)];
}
function w8(e, r, t) {
  return e.l += 5, e.l += 2, e.l += t.biff == 2 ? 1 : 4, ["PTGSHEET"];
}
function _8(e, r, t) {
  return e.l += t.biff == 2 ? 4 : 5, ["PTGENDSHEET"];
}
function $8(e) {
  var r = e.read_shift(1) >>> 5 & 3, t = e.read_shift(2);
  return [r, t];
}
function D8(e) {
  var r = e.read_shift(1) >>> 5 & 3, t = e.read_shift(2);
  return [r, t];
}
function E8(e) {
  return e.l += 4, [0, 0];
}
var ph = {
  /*::[*/
  1: { n: "PtgExp", f: j7 },
  /*::[*/
  2: { n: "PtgTbl", f: u8 },
  /*::[*/
  3: { n: "PtgAdd", f: Dr },
  /*::[*/
  4: { n: "PtgSub", f: Dr },
  /*::[*/
  5: { n: "PtgMul", f: Dr },
  /*::[*/
  6: { n: "PtgDiv", f: Dr },
  /*::[*/
  7: { n: "PtgPower", f: Dr },
  /*::[*/
  8: { n: "PtgConcat", f: Dr },
  /*::[*/
  9: { n: "PtgLt", f: Dr },
  /*::[*/
  10: { n: "PtgLe", f: Dr },
  /*::[*/
  11: { n: "PtgEq", f: Dr },
  /*::[*/
  12: { n: "PtgGe", f: Dr },
  /*::[*/
  13: { n: "PtgGt", f: Dr },
  /*::[*/
  14: { n: "PtgNe", f: Dr },
  /*::[*/
  15: { n: "PtgIsect", f: Dr },
  /*::[*/
  16: { n: "PtgUnion", f: Dr },
  /*::[*/
  17: { n: "PtgRange", f: Dr },
  /*::[*/
  18: { n: "PtgUplus", f: Dr },
  /*::[*/
  19: { n: "PtgUminus", f: Dr },
  /*::[*/
  20: { n: "PtgPercent", f: Dr },
  /*::[*/
  21: { n: "PtgParen", f: Dr },
  /*::[*/
  22: { n: "PtgMissArg", f: Dr },
  /*::[*/
  23: { n: "PtgStr", f: X7 },
  /*::[*/
  26: { n: "PtgSheet", f: w8 },
  /*::[*/
  27: { n: "PtgEndSheet", f: _8 },
  /*::[*/
  28: { n: "PtgErr", f: z7 },
  /*::[*/
  29: { n: "PtgBool", f: K7 },
  /*::[*/
  30: { n: "PtgInt", f: G7 },
  /*::[*/
  31: { n: "PtgNum", f: Y7 },
  /*::[*/
  32: { n: "PtgArray", f: C7 },
  /*::[*/
  33: { n: "PtgFunc", f: U7 },
  /*::[*/
  34: { n: "PtgFuncVar", f: V7 },
  /*::[*/
  35: { n: "PtgName", f: Q7 },
  /*::[*/
  36: { n: "PtgRef", f: O7 },
  /*::[*/
  37: { n: "PtgArea", f: D7 },
  /*::[*/
  38: { n: "PtgMemArea", f: t8 },
  /*::[*/
  39: { n: "PtgMemErr", f: s8 },
  /*::[*/
  40: { n: "PtgMemNoMem", f: o8 },
  /*::[*/
  41: { n: "PtgMemFunc", f: a8 },
  /*::[*/
  42: { n: "PtgRefErr", f: n8 },
  /*::[*/
  43: { n: "PtgAreaErr", f: k7 },
  /*::[*/
  44: { n: "PtgRefN", f: L7 },
  /*::[*/
  45: { n: "PtgAreaN", f: S7 },
  /*::[*/
  46: { n: "PtgMemAreaN", f: $8 },
  /*::[*/
  47: { n: "PtgMemNoMemN", f: D8 },
  /*::[*/
  57: { n: "PtgNameX", f: e8 },
  /*::[*/
  58: { n: "PtgRef3d", f: N7 },
  /*::[*/
  59: { n: "PtgArea3d", f: E7 },
  /*::[*/
  60: { n: "PtgRefErr3d", f: i8 },
  /*::[*/
  61: { n: "PtgAreaErr3d", f: T7 },
  /*::[*/
  255: {}
}, k8 = {
  /*::[*/
  64: 32,
  /*::[*/
  96: 32,
  /*::[*/
  65: 33,
  /*::[*/
  97: 33,
  /*::[*/
  66: 34,
  /*::[*/
  98: 34,
  /*::[*/
  67: 35,
  /*::[*/
  99: 35,
  /*::[*/
  68: 36,
  /*::[*/
  100: 36,
  /*::[*/
  69: 37,
  /*::[*/
  101: 37,
  /*::[*/
  70: 38,
  /*::[*/
  102: 38,
  /*::[*/
  71: 39,
  /*::[*/
  103: 39,
  /*::[*/
  72: 40,
  /*::[*/
  104: 40,
  /*::[*/
  73: 41,
  /*::[*/
  105: 41,
  /*::[*/
  74: 42,
  /*::[*/
  106: 42,
  /*::[*/
  75: 43,
  /*::[*/
  107: 43,
  /*::[*/
  76: 44,
  /*::[*/
  108: 44,
  /*::[*/
  77: 45,
  /*::[*/
  109: 45,
  /*::[*/
  78: 46,
  /*::[*/
  110: 46,
  /*::[*/
  79: 47,
  /*::[*/
  111: 47,
  /*::[*/
  88: 34,
  /*::[*/
  120: 34,
  /*::[*/
  89: 57,
  /*::[*/
  121: 57,
  /*::[*/
  90: 58,
  /*::[*/
  122: 58,
  /*::[*/
  91: 59,
  /*::[*/
  123: 59,
  /*::[*/
  92: 60,
  /*::[*/
  124: 60,
  /*::[*/
  93: 61,
  /*::[*/
  125: 61
}, T8 = {
  /*::[*/
  1: { n: "PtgElfLel", f: i2 },
  /*::[*/
  2: { n: "PtgElfRw", f: p8 },
  /*::[*/
  3: { n: "PtgElfCol", f: l8 },
  /*::[*/
  6: { n: "PtgElfRwV", f: v8 },
  /*::[*/
  7: { n: "PtgElfColV", f: d8 },
  /*::[*/
  10: { n: "PtgElfRadical", f: h8 },
  /*::[*/
  11: { n: "PtgElfRadicalS", f: m8 },
  /*::[*/
  13: { n: "PtgElfColS", f: c8 },
  /*::[*/
  15: { n: "PtgElfColSV", f: f8 },
  /*::[*/
  16: { n: "PtgElfRadicalLel", f: x8 },
  /*::[*/
  25: { n: "PtgList", f: y8 },
  /*::[*/
  29: { n: "PtgSxName", f: b8 },
  /*::[*/
  255: {}
}, S8 = {
  /*::[*/
  0: { n: "PtgAttrNoop", f: E8 },
  /*::[*/
  1: { n: "PtgAttrSemi", f: B7 },
  /*::[*/
  2: { n: "PtgAttrIf", f: R7 },
  /*::[*/
  4: { n: "PtgAttrChoose", f: F7 },
  /*::[*/
  8: { n: "PtgAttrGoto", f: A7 },
  /*::[*/
  16: { n: "PtgAttrSum", f: H7 },
  /*::[*/
  32: { n: "PtgAttrBaxcel", f: mh },
  /*::[*/
  33: { n: "PtgAttrBaxcel", f: mh },
  /*::[*/
  64: { n: "PtgAttrSpace", f: P7 },
  /*::[*/
  65: { n: "PtgAttrSpaceSemi", f: M7 },
  /*::[*/
  128: { n: "PtgAttrIfError", f: I7 },
  /*::[*/
  255: {}
};
function Ss(e, r, t, a) {
  if (a.biff < 8)
    return qr(e, r);
  for (var n = e.l + r, i = [], s = 0; s !== t.length; ++s)
    switch (t[s][0]) {
      case "PtgArray":
        t[s][1] = q7(e, 0, a), i.push(t[s][1]);
        break;
      case "PtgMemArea":
        t[s][2] = J7(e, t[s][1], a), i.push(t[s][2]);
        break;
      case "PtgExp":
        a && a.biff == 12 && (t[s][1][1] = e.read_shift(4), i.push(t[s][1]));
        break;
      case "PtgList":
      case "PtgElfRadicalS":
      case "PtgElfColS":
      case "PtgElfColSV":
        throw "Unsupported " + t[s][0];
    }
  return r = n - e.l, r !== 0 && i.push(qr(e, r)), i;
}
function Cs(e, r, t) {
  for (var a = e.l + r, n, i, s = []; a != e.l; )
    r = a - e.l, i = e[e.l], n = ph[i] || ph[k8[i]], (i === 24 || i === 25) && (n = (i === 24 ? T8 : S8)[e[e.l + 1]]), !n || !n.f ? qr(e, r) : s.push([n.n, n.f(e, r, t)]);
  return s;
}
function C8(e) {
  for (var r = [], t = 0; t < e.length; ++t) {
    for (var a = e[t], n = [], i = 0; i < a.length; ++i) {
      var s = a[i];
      if (s)
        switch (s[0]) {
          case 2:
            n.push('"' + s[1].replace(/"/g, '""') + '"');
            break;
          default:
            n.push(s[1]);
        }
      else
        n.push("");
    }
    r.push(n.join(","));
  }
  return r.join(";");
}
var F8 = {
  PtgAdd: "+",
  PtgConcat: "&",
  PtgDiv: "/",
  PtgEq: "=",
  PtgGe: ">=",
  PtgGt: ">",
  PtgLe: "<=",
  PtgLt: "<",
  PtgMul: "*",
  PtgNe: "<>",
  PtgPower: "^",
  PtgSub: "-"
};
function A8(e, r) {
  if (!e && !(r && r.biff <= 5 && r.biff >= 2))
    throw new Error("empty sheet name");
  return /[^\w\u4E00-\u9FFF\u3040-\u30FF]/.test(e) ? "'" + e + "'" : e;
}
function s2(e, r, t) {
  if (!e)
    return "SH33TJSERR0";
  if (t.biff > 8 && (!e.XTI || !e.XTI[r]))
    return e.SheetNames[r];
  if (!e.XTI)
    return "SH33TJSERR6";
  var a = e.XTI[r];
  if (t.biff < 8)
    return r > 1e4 && (r -= 65536), r < 0 && (r = -r), r == 0 ? "" : e.XTI[r - 1];
  if (!a)
    return "SH33TJSERR1";
  var n = "";
  if (t.biff > 8)
    switch (e[a[0]][0]) {
      case 357:
        return n = a[1] == -1 ? "#REF" : e.SheetNames[a[1]], a[1] == a[2] ? n : n + ":" + e.SheetNames[a[2]];
      case 358:
        return t.SID != null ? e.SheetNames[t.SID] : "SH33TJSSAME" + e[a[0]][0];
      case 355:
      default:
        return "SH33TJSSRC" + e[a[0]][0];
    }
  switch (e[a[0]][0][0]) {
    case 1025:
      return n = a[1] == -1 ? "#REF" : e.SheetNames[a[1]] || "SH33TJSERR3", a[1] == a[2] ? n : n + ":" + e.SheetNames[a[2]];
    case 14849:
      return e[a[0]].slice(1).map(function(i) {
        return i.Name;
      }).join(";;");
    default:
      return e[a[0]][0][3] ? (n = a[1] == -1 ? "#REF" : e[a[0]][0][3][a[1]] || "SH33TJSERR4", a[1] == a[2] ? n : n + ":" + e[a[0]][0][3][a[2]]) : "SH33TJSERR2";
  }
}
function vh(e, r, t) {
  var a = s2(e, r, t);
  return a == "#REF" ? a : A8(a, t);
}
function Gr(e, r, t, a, n) {
  var i = n && n.biff || 8, s = (
    /*range != null ? range :*/
    { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } }
  ), o = [], u, l, c, f = 0, h = 0, d, m = "";
  if (!e[0] || !e[0][0])
    return "";
  for (var x = -1, p = "", w = 0, D = e[0].length; w < D; ++w) {
    var y = e[0][w];
    switch (y[0]) {
      case "PtgUminus":
        o.push("-" + o.pop());
        break;
      case "PtgUplus":
        o.push("+" + o.pop());
        break;
      case "PtgPercent":
        o.push(o.pop() + "%");
        break;
      case "PtgAdd":
      case "PtgConcat":
      case "PtgDiv":
      case "PtgEq":
      case "PtgGe":
      case "PtgGt":
      case "PtgLe":
      case "PtgLt":
      case "PtgMul":
      case "PtgNe":
      case "PtgPower":
      case "PtgSub":
        if (u = o.pop(), l = o.pop(), x >= 0) {
          switch (e[0][x][1][0]) {
            case 0:
              p = vr(" ", e[0][x][1][1]);
              break;
            case 1:
              p = vr("\r", e[0][x][1][1]);
              break;
            default:
              if (p = "", n.WTF)
                throw new Error("Unexpected PtgAttrSpaceType " + e[0][x][1][0]);
          }
          l = l + p, x = -1;
        }
        o.push(l + F8[y[0]] + u);
        break;
      case "PtgIsect":
        u = o.pop(), l = o.pop(), o.push(l + " " + u);
        break;
      case "PtgUnion":
        u = o.pop(), l = o.pop(), o.push(l + "," + u);
        break;
      case "PtgRange":
        u = o.pop(), l = o.pop(), o.push(l + ":" + u);
        break;
      case "PtgAttrChoose":
        break;
      case "PtgAttrGoto":
        break;
      case "PtgAttrIf":
        break;
      case "PtgAttrIfError":
        break;
      case "PtgRef":
        c = Ui(y[1][1], s, n), o.push(Vi(c, i));
        break;
      case "PtgRefN":
        c = t ? Ui(y[1][1], t, n) : y[1][1], o.push(Vi(c, i));
        break;
      case "PtgRef3d":
        f = /*::Number(*/
        y[1][1], c = Ui(y[1][2], s, n), m = vh(a, f, n), o.push(m + "!" + Vi(c, i));
        break;
      case "PtgFunc":
      case "PtgFuncVar":
        var B = y[1][0], L = y[1][1];
        B || (B = 0), B &= 127;
        var U = B == 0 ? [] : o.slice(-B);
        o.length -= B, L === "User" && (L = U.shift()), o.push(L + "(" + U.join(",") + ")");
        break;
      case "PtgBool":
        o.push(y[1] ? "TRUE" : "FALSE");
        break;
      case "PtgInt":
        o.push(
          /*::String(*/
          y[1]
          /*::)*/
        );
        break;
      case "PtgNum":
        o.push(String(y[1]));
        break;
      case "PtgStr":
        o.push('"' + y[1].replace(/"/g, '""') + '"');
        break;
      case "PtgErr":
        o.push(
          /*::String(*/
          y[1]
          /*::)*/
        );
        break;
      case "PtgAreaN":
        d = Gd(y[1][1], t ? { s: t } : s, n), o.push(fu(d, n));
        break;
      case "PtgArea":
        d = Gd(y[1][1], s, n), o.push(fu(d, n));
        break;
      case "PtgArea3d":
        f = /*::Number(*/
        y[1][1], d = y[1][2], m = vh(a, f, n), o.push(m + "!" + fu(d, n));
        break;
      case "PtgAttrSum":
        o.push("SUM(" + o.pop() + ")");
        break;
      case "PtgAttrBaxcel":
      case "PtgAttrSemi":
        break;
      case "PtgName":
        h = y[1][2];
        var k = (a.names || [])[h - 1] || (a[0] || [])[h], v = k ? k.Name : "SH33TJSNAME" + String(h);
        v && v.slice(0, 6) == "_xlfn." && !n.xlfn && (v = v.slice(6)), o.push(v);
        break;
      case "PtgNameX":
        var b = y[1][1];
        h = y[1][2];
        var A;
        if (n.biff <= 5)
          b < 0 && (b = -b), a[b] && (A = a[b][h]);
        else {
          var T = "";
          if (((a[b] || [])[0] || [])[0] == 14849 || (((a[b] || [])[0] || [])[0] == 1025 ? a[b][h] && a[b][h].itab > 0 && (T = a.SheetNames[a[b][h].itab - 1] + "!") : T = a.SheetNames[h - 1] + "!"), a[b] && a[b][h])
            T += a[b][h].Name;
          else if (a[0] && a[0][h])
            T += a[0][h].Name;
          else {
            var C = (s2(a, b, n) || "").split(";;");
            C[h - 1] ? T = C[h - 1] : T += "SH33TJSERRX";
          }
          o.push(T);
          break;
        }
        A || (A = { Name: "SH33TJSERRY" }), o.push(A.Name);
        break;
      case "PtgParen":
        var I = "(", Y = ")";
        if (x >= 0) {
          switch (p = "", e[0][x][1][0]) {
            case 2:
              I = vr(" ", e[0][x][1][1]) + I;
              break;
            case 3:
              I = vr("\r", e[0][x][1][1]) + I;
              break;
            case 4:
              Y = vr(" ", e[0][x][1][1]) + Y;
              break;
            case 5:
              Y = vr("\r", e[0][x][1][1]) + Y;
              break;
            default:
              if (n.WTF)
                throw new Error("Unexpected PtgAttrSpaceType " + e[0][x][1][0]);
          }
          x = -1;
        }
        o.push(I + o.pop() + Y);
        break;
      case "PtgRefErr":
        o.push("#REF!");
        break;
      case "PtgRefErr3d":
        o.push("#REF!");
        break;
      case "PtgExp":
        c = { c: y[1][1], r: y[1][0] };
        var j = { c: t.c, r: t.r };
        if (a.sharedf[Te(c)]) {
          var J = a.sharedf[Te(c)];
          o.push(Gr(J, s, j, a, n));
        } else {
          var W = !1;
          for (u = 0; u != a.arrayf.length; ++u)
            if (l = a.arrayf[u], !(c.c < l[0].s.c || c.c > l[0].e.c) && !(c.r < l[0].s.r || c.r > l[0].e.r)) {
              o.push(Gr(l[1], s, j, a, n)), W = !0;
              break;
            }
          W || o.push(
            /*::String(*/
            y[1]
            /*::)*/
          );
        }
        break;
      case "PtgArray":
        o.push("{" + C8(
          /*::(*/
          y[1]
          /*:: :any)*/
        ) + "}");
        break;
      case "PtgMemArea":
        break;
      case "PtgAttrSpace":
      case "PtgAttrSpaceSemi":
        x = w;
        break;
      case "PtgTbl":
        break;
      case "PtgMemErr":
        break;
      case "PtgMissArg":
        o.push("");
        break;
      case "PtgAreaErr":
        o.push("#REF!");
        break;
      case "PtgAreaErr3d":
        o.push("#REF!");
        break;
      case "PtgList":
        o.push("Table" + y[1].idx + "[#" + y[1].rt + "]");
        break;
      case "PtgMemAreaN":
      case "PtgMemNoMemN":
      case "PtgAttrNoop":
      case "PtgSheet":
      case "PtgEndSheet":
        break;
      case "PtgMemFunc":
        break;
      case "PtgMemNoMem":
        break;
      case "PtgElfCol":
      case "PtgElfColS":
      case "PtgElfColSV":
      case "PtgElfColV":
      case "PtgElfLel":
      case "PtgElfRadical":
      case "PtgElfRadicalLel":
      case "PtgElfRadicalS":
      case "PtgElfRw":
      case "PtgElfRwV":
        throw new Error("Unsupported ELFs");
      case "PtgSxName":
        throw new Error("Unrecognized Formula Token: " + String(y));
      default:
        throw new Error("Unrecognized Formula Token: " + String(y));
    }
    var ce = ["PtgAttrSpace", "PtgAttrSpaceSemi", "PtgAttrGoto"];
    if (n.biff != 3 && x >= 0 && ce.indexOf(e[0][w][0]) == -1) {
      y = e[0][x];
      var V = !0;
      switch (y[1][0]) {
        case 4:
          V = !1;
        case 0:
          p = vr(" ", y[1][1]);
          break;
        case 5:
          V = !1;
        case 1:
          p = vr("\r", y[1][1]);
          break;
        default:
          if (p = "", n.WTF)
            throw new Error("Unexpected PtgAttrSpaceType " + y[1][0]);
      }
      o.push((V ? p : "") + o.pop() + (V ? "" : p)), x = -1;
    }
  }
  if (o.length > 1 && n.WTF)
    throw new Error("bad formula stack");
  return o[0];
}
function R8(e, r, t) {
  var a = e.l + r, n = t.biff == 2 ? 1 : 2, i, s = e.read_shift(n);
  if (s == 65535)
    return [[], qr(e, r - 2)];
  var o = Cs(e, s, t);
  return r !== s + n && (i = Ss(e, r - s - n, o, t)), e.l = a, [o, i];
}
function I8(e, r, t) {
  var a = e.l + r, n = t.biff == 2 ? 1 : 2, i, s = e.read_shift(n);
  if (s == 65535)
    return [[], qr(e, r - 2)];
  var o = Cs(e, s, t);
  return r !== s + n && (i = Ss(e, r - s - n, o, t)), e.l = a, [o, i];
}
function B8(e, r, t, a) {
  var n = e.l + r, i = Cs(e, a, t), s;
  return n !== e.l && (s = Ss(e, n - e.l, i, t)), [i, s];
}
function P8(e, r, t) {
  var a = e.l + r, n, i = e.read_shift(2), s = Cs(e, i, t);
  return i == 65535 ? [[], qr(e, r - 2)] : (r !== i + 2 && (n = Ss(e, a - i - 2, s, t)), [s, n]);
}
function M8(e) {
  var r;
  if (ua(e, e.l + 6) !== 65535)
    return [Xr(e), "n"];
  switch (e[e.l]) {
    case 0:
      return e.l += 8, ["String", "s"];
    case 1:
      return r = e[e.l + 2] === 1, e.l += 8, [r, "b"];
    case 2:
      return r = e[e.l + 2], e.l += 8, [r, "e"];
    case 3:
      return e.l += 8, ["", "s"];
  }
  return [];
}
function O8(e) {
  if (e == null) {
    var r = te(8);
    return r.write_shift(1, 3), r.write_shift(1, 0), r.write_shift(2, 0), r.write_shift(2, 0), r.write_shift(2, 65535), r;
  } else if (typeof e == "number")
    return dn(e);
  return dn(0);
}
function pu(e, r, t) {
  var a = e.l + r, n = Zt(e);
  t.biff == 2 && ++e.l;
  var i = M8(e), s = e.read_shift(1);
  t.biff != 2 && (e.read_shift(1), t.biff >= 5 && e.read_shift(4));
  var o = I8(e, a - e.l, t);
  return { cell: n, val: i[0], formula: o, shared: s >> 3 & 1, tt: i[1] };
}
function L8(e, r, t, a, n) {
  var i = xn(r, t, n), s = O8(e.v), o = te(6), u = 33;
  o.write_shift(2, u), o.write_shift(4, 0);
  for (var l = te(e.bf.length), c = 0; c < e.bf.length; ++c)
    l[c] = e.bf[c];
  var f = Or([i, s, o, l]);
  return f;
}
function b0(e, r, t) {
  var a = e.read_shift(4), n = Cs(e, a, t), i = e.read_shift(4), s = i > 0 ? Ss(e, i, n, t) : null;
  return [n, s];
}
var N8 = b0, w0 = b0, U8 = b0, V8 = b0, W8 = {
  0: "BEEP",
  1: "OPEN",
  2: "OPEN.LINKS",
  3: "CLOSE.ALL",
  4: "SAVE",
  5: "SAVE.AS",
  6: "FILE.DELETE",
  7: "PAGE.SETUP",
  8: "PRINT",
  9: "PRINTER.SETUP",
  10: "QUIT",
  11: "NEW.WINDOW",
  12: "ARRANGE.ALL",
  13: "WINDOW.SIZE",
  14: "WINDOW.MOVE",
  15: "FULL",
  16: "CLOSE",
  17: "RUN",
  22: "SET.PRINT.AREA",
  23: "SET.PRINT.TITLES",
  24: "SET.PAGE.BREAK",
  25: "REMOVE.PAGE.BREAK",
  26: "FONT",
  27: "DISPLAY",
  28: "PROTECT.DOCUMENT",
  29: "PRECISION",
  30: "A1.R1C1",
  31: "CALCULATE.NOW",
  32: "CALCULATION",
  34: "DATA.FIND",
  35: "EXTRACT",
  36: "DATA.DELETE",
  37: "SET.DATABASE",
  38: "SET.CRITERIA",
  39: "SORT",
  40: "DATA.SERIES",
  41: "TABLE",
  42: "FORMAT.NUMBER",
  43: "ALIGNMENT",
  44: "STYLE",
  45: "BORDER",
  46: "CELL.PROTECTION",
  47: "COLUMN.WIDTH",
  48: "UNDO",
  49: "CUT",
  50: "COPY",
  51: "PASTE",
  52: "CLEAR",
  53: "PASTE.SPECIAL",
  54: "EDIT.DELETE",
  55: "INSERT",
  56: "FILL.RIGHT",
  57: "FILL.DOWN",
  61: "DEFINE.NAME",
  62: "CREATE.NAMES",
  63: "FORMULA.GOTO",
  64: "FORMULA.FIND",
  65: "SELECT.LAST.CELL",
  66: "SHOW.ACTIVE.CELL",
  67: "GALLERY.AREA",
  68: "GALLERY.BAR",
  69: "GALLERY.COLUMN",
  70: "GALLERY.LINE",
  71: "GALLERY.PIE",
  72: "GALLERY.SCATTER",
  73: "COMBINATION",
  74: "PREFERRED",
  75: "ADD.OVERLAY",
  76: "GRIDLINES",
  77: "SET.PREFERRED",
  78: "AXES",
  79: "LEGEND",
  80: "ATTACH.TEXT",
  81: "ADD.ARROW",
  82: "SELECT.CHART",
  83: "SELECT.PLOT.AREA",
  84: "PATTERNS",
  85: "MAIN.CHART",
  86: "OVERLAY",
  87: "SCALE",
  88: "FORMAT.LEGEND",
  89: "FORMAT.TEXT",
  90: "EDIT.REPEAT",
  91: "PARSE",
  92: "JUSTIFY",
  93: "HIDE",
  94: "UNHIDE",
  95: "WORKSPACE",
  96: "FORMULA",
  97: "FORMULA.FILL",
  98: "FORMULA.ARRAY",
  99: "DATA.FIND.NEXT",
  100: "DATA.FIND.PREV",
  101: "FORMULA.FIND.NEXT",
  102: "FORMULA.FIND.PREV",
  103: "ACTIVATE",
  104: "ACTIVATE.NEXT",
  105: "ACTIVATE.PREV",
  106: "UNLOCKED.NEXT",
  107: "UNLOCKED.PREV",
  108: "COPY.PICTURE",
  109: "SELECT",
  110: "DELETE.NAME",
  111: "DELETE.FORMAT",
  112: "VLINE",
  113: "HLINE",
  114: "VPAGE",
  115: "HPAGE",
  116: "VSCROLL",
  117: "HSCROLL",
  118: "ALERT",
  119: "NEW",
  120: "CANCEL.COPY",
  121: "SHOW.CLIPBOARD",
  122: "MESSAGE",
  124: "PASTE.LINK",
  125: "APP.ACTIVATE",
  126: "DELETE.ARROW",
  127: "ROW.HEIGHT",
  128: "FORMAT.MOVE",
  129: "FORMAT.SIZE",
  130: "FORMULA.REPLACE",
  131: "SEND.KEYS",
  132: "SELECT.SPECIAL",
  133: "APPLY.NAMES",
  134: "REPLACE.FONT",
  135: "FREEZE.PANES",
  136: "SHOW.INFO",
  137: "SPLIT",
  138: "ON.WINDOW",
  139: "ON.DATA",
  140: "DISABLE.INPUT",
  142: "OUTLINE",
  143: "LIST.NAMES",
  144: "FILE.CLOSE",
  145: "SAVE.WORKBOOK",
  146: "DATA.FORM",
  147: "COPY.CHART",
  148: "ON.TIME",
  149: "WAIT",
  150: "FORMAT.FONT",
  151: "FILL.UP",
  152: "FILL.LEFT",
  153: "DELETE.OVERLAY",
  155: "SHORT.MENUS",
  159: "SET.UPDATE.STATUS",
  161: "COLOR.PALETTE",
  162: "DELETE.STYLE",
  163: "WINDOW.RESTORE",
  164: "WINDOW.MAXIMIZE",
  166: "CHANGE.LINK",
  167: "CALCULATE.DOCUMENT",
  168: "ON.KEY",
  169: "APP.RESTORE",
  170: "APP.MOVE",
  171: "APP.SIZE",
  172: "APP.MINIMIZE",
  173: "APP.MAXIMIZE",
  174: "BRING.TO.FRONT",
  175: "SEND.TO.BACK",
  185: "MAIN.CHART.TYPE",
  186: "OVERLAY.CHART.TYPE",
  187: "SELECT.END",
  188: "OPEN.MAIL",
  189: "SEND.MAIL",
  190: "STANDARD.FONT",
  191: "CONSOLIDATE",
  192: "SORT.SPECIAL",
  193: "GALLERY.3D.AREA",
  194: "GALLERY.3D.COLUMN",
  195: "GALLERY.3D.LINE",
  196: "GALLERY.3D.PIE",
  197: "VIEW.3D",
  198: "GOAL.SEEK",
  199: "WORKGROUP",
  200: "FILL.GROUP",
  201: "UPDATE.LINK",
  202: "PROMOTE",
  203: "DEMOTE",
  204: "SHOW.DETAIL",
  206: "UNGROUP",
  207: "OBJECT.PROPERTIES",
  208: "SAVE.NEW.OBJECT",
  209: "SHARE",
  210: "SHARE.NAME",
  211: "DUPLICATE",
  212: "APPLY.STYLE",
  213: "ASSIGN.TO.OBJECT",
  214: "OBJECT.PROTECTION",
  215: "HIDE.OBJECT",
  216: "SET.EXTRACT",
  217: "CREATE.PUBLISHER",
  218: "SUBSCRIBE.TO",
  219: "ATTRIBUTES",
  220: "SHOW.TOOLBAR",
  222: "PRINT.PREVIEW",
  223: "EDIT.COLOR",
  224: "SHOW.LEVELS",
  225: "FORMAT.MAIN",
  226: "FORMAT.OVERLAY",
  227: "ON.RECALC",
  228: "EDIT.SERIES",
  229: "DEFINE.STYLE",
  240: "LINE.PRINT",
  243: "ENTER.DATA",
  249: "GALLERY.RADAR",
  250: "MERGE.STYLES",
  251: "EDITION.OPTIONS",
  252: "PASTE.PICTURE",
  253: "PASTE.PICTURE.LINK",
  254: "SPELLING",
  256: "ZOOM",
  259: "INSERT.OBJECT",
  260: "WINDOW.MINIMIZE",
  265: "SOUND.NOTE",
  266: "SOUND.PLAY",
  267: "FORMAT.SHAPE",
  268: "EXTEND.POLYGON",
  269: "FORMAT.AUTO",
  272: "GALLERY.3D.BAR",
  273: "GALLERY.3D.SURFACE",
  274: "FILL.AUTO",
  276: "CUSTOMIZE.TOOLBAR",
  277: "ADD.TOOL",
  278: "EDIT.OBJECT",
  279: "ON.DOUBLECLICK",
  280: "ON.ENTRY",
  281: "WORKBOOK.ADD",
  282: "WORKBOOK.MOVE",
  283: "WORKBOOK.COPY",
  284: "WORKBOOK.OPTIONS",
  285: "SAVE.WORKSPACE",
  288: "CHART.WIZARD",
  289: "DELETE.TOOL",
  290: "MOVE.TOOL",
  291: "WORKBOOK.SELECT",
  292: "WORKBOOK.ACTIVATE",
  293: "ASSIGN.TO.TOOL",
  295: "COPY.TOOL",
  296: "RESET.TOOL",
  297: "CONSTRAIN.NUMERIC",
  298: "PASTE.TOOL",
  302: "WORKBOOK.NEW",
  305: "SCENARIO.CELLS",
  306: "SCENARIO.DELETE",
  307: "SCENARIO.ADD",
  308: "SCENARIO.EDIT",
  309: "SCENARIO.SHOW",
  310: "SCENARIO.SHOW.NEXT",
  311: "SCENARIO.SUMMARY",
  312: "PIVOT.TABLE.WIZARD",
  313: "PIVOT.FIELD.PROPERTIES",
  314: "PIVOT.FIELD",
  315: "PIVOT.ITEM",
  316: "PIVOT.ADD.FIELDS",
  318: "OPTIONS.CALCULATION",
  319: "OPTIONS.EDIT",
  320: "OPTIONS.VIEW",
  321: "ADDIN.MANAGER",
  322: "MENU.EDITOR",
  323: "ATTACH.TOOLBARS",
  324: "VBAActivate",
  325: "OPTIONS.CHART",
  328: "VBA.INSERT.FILE",
  330: "VBA.PROCEDURE.DEFINITION",
  336: "ROUTING.SLIP",
  338: "ROUTE.DOCUMENT",
  339: "MAIL.LOGON",
  342: "INSERT.PICTURE",
  343: "EDIT.TOOL",
  344: "GALLERY.DOUGHNUT",
  350: "CHART.TREND",
  352: "PIVOT.ITEM.PROPERTIES",
  354: "WORKBOOK.INSERT",
  355: "OPTIONS.TRANSITION",
  356: "OPTIONS.GENERAL",
  370: "FILTER.ADVANCED",
  373: "MAIL.ADD.MAILER",
  374: "MAIL.DELETE.MAILER",
  375: "MAIL.REPLY",
  376: "MAIL.REPLY.ALL",
  377: "MAIL.FORWARD",
  378: "MAIL.NEXT.LETTER",
  379: "DATA.LABEL",
  380: "INSERT.TITLE",
  381: "FONT.PROPERTIES",
  382: "MACRO.OPTIONS",
  383: "WORKBOOK.HIDE",
  384: "WORKBOOK.UNHIDE",
  385: "WORKBOOK.DELETE",
  386: "WORKBOOK.NAME",
  388: "GALLERY.CUSTOM",
  390: "ADD.CHART.AUTOFORMAT",
  391: "DELETE.CHART.AUTOFORMAT",
  392: "CHART.ADD.DATA",
  393: "AUTO.OUTLINE",
  394: "TAB.ORDER",
  395: "SHOW.DIALOG",
  396: "SELECT.ALL",
  397: "UNGROUP.SHEETS",
  398: "SUBTOTAL.CREATE",
  399: "SUBTOTAL.REMOVE",
  400: "RENAME.OBJECT",
  412: "WORKBOOK.SCROLL",
  413: "WORKBOOK.NEXT",
  414: "WORKBOOK.PREV",
  415: "WORKBOOK.TAB.SPLIT",
  416: "FULL.SCREEN",
  417: "WORKBOOK.PROTECT",
  420: "SCROLLBAR.PROPERTIES",
  421: "PIVOT.SHOW.PAGES",
  422: "TEXT.TO.COLUMNS",
  423: "FORMAT.CHARTTYPE",
  424: "LINK.FORMAT",
  425: "TRACER.DISPLAY",
  430: "TRACER.NAVIGATE",
  431: "TRACER.CLEAR",
  432: "TRACER.ERROR",
  433: "PIVOT.FIELD.GROUP",
  434: "PIVOT.FIELD.UNGROUP",
  435: "CHECKBOX.PROPERTIES",
  436: "LABEL.PROPERTIES",
  437: "LISTBOX.PROPERTIES",
  438: "EDITBOX.PROPERTIES",
  439: "PIVOT.REFRESH",
  440: "LINK.COMBO",
  441: "OPEN.TEXT",
  442: "HIDE.DIALOG",
  443: "SET.DIALOG.FOCUS",
  444: "ENABLE.OBJECT",
  445: "PUSHBUTTON.PROPERTIES",
  446: "SET.DIALOG.DEFAULT",
  447: "FILTER",
  448: "FILTER.SHOW.ALL",
  449: "CLEAR.OUTLINE",
  450: "FUNCTION.WIZARD",
  451: "ADD.LIST.ITEM",
  452: "SET.LIST.ITEM",
  453: "REMOVE.LIST.ITEM",
  454: "SELECT.LIST.ITEM",
  455: "SET.CONTROL.VALUE",
  456: "SAVE.COPY.AS",
  458: "OPTIONS.LISTS.ADD",
  459: "OPTIONS.LISTS.DELETE",
  460: "SERIES.AXES",
  461: "SERIES.X",
  462: "SERIES.Y",
  463: "ERRORBAR.X",
  464: "ERRORBAR.Y",
  465: "FORMAT.CHART",
  466: "SERIES.ORDER",
  467: "MAIL.LOGOFF",
  468: "CLEAR.ROUTING.SLIP",
  469: "APP.ACTIVATE.MICROSOFT",
  470: "MAIL.EDIT.MAILER",
  471: "ON.SHEET",
  472: "STANDARD.WIDTH",
  473: "SCENARIO.MERGE",
  474: "SUMMARY.INFO",
  475: "FIND.FILE",
  476: "ACTIVE.CELL.FONT",
  477: "ENABLE.TIPWIZARD",
  478: "VBA.MAKE.ADDIN",
  480: "INSERTDATATABLE",
  481: "WORKGROUP.OPTIONS",
  482: "MAIL.SEND.MAILER",
  485: "AUTOCORRECT",
  489: "POST.DOCUMENT",
  491: "PICKLIST",
  493: "VIEW.SHOW",
  494: "VIEW.DEFINE",
  495: "VIEW.DELETE",
  509: "SHEET.BACKGROUND",
  510: "INSERT.MAP.OBJECT",
  511: "OPTIONS.MENONO",
  517: "MSOCHECKS",
  518: "NORMAL",
  519: "LAYOUT",
  520: "RM.PRINT.AREA",
  521: "CLEAR.PRINT.AREA",
  522: "ADD.PRINT.AREA",
  523: "MOVE.BRK",
  545: "HIDECURR.NOTE",
  546: "HIDEALL.NOTES",
  547: "DELETE.NOTE",
  548: "TRAVERSE.NOTES",
  549: "ACTIVATE.NOTES",
  620: "PROTECT.REVISIONS",
  621: "UNPROTECT.REVISIONS",
  647: "OPTIONS.ME",
  653: "WEB.PUBLISH",
  667: "NEWWEBQUERY",
  673: "PIVOT.TABLE.CHART",
  753: "OPTIONS.SAVE",
  755: "OPTIONS.SPELL",
  808: "HIDEALL.INKANNOTS"
}, o2 = {
  0: "COUNT",
  1: "IF",
  2: "ISNA",
  3: "ISERROR",
  4: "SUM",
  5: "AVERAGE",
  6: "MIN",
  7: "MAX",
  8: "ROW",
  9: "COLUMN",
  10: "NA",
  11: "NPV",
  12: "STDEV",
  13: "DOLLAR",
  14: "FIXED",
  15: "SIN",
  16: "COS",
  17: "TAN",
  18: "ATAN",
  19: "PI",
  20: "SQRT",
  21: "EXP",
  22: "LN",
  23: "LOG10",
  24: "ABS",
  25: "INT",
  26: "SIGN",
  27: "ROUND",
  28: "LOOKUP",
  29: "INDEX",
  30: "REPT",
  31: "MID",
  32: "LEN",
  33: "VALUE",
  34: "TRUE",
  35: "FALSE",
  36: "AND",
  37: "OR",
  38: "NOT",
  39: "MOD",
  40: "DCOUNT",
  41: "DSUM",
  42: "DAVERAGE",
  43: "DMIN",
  44: "DMAX",
  45: "DSTDEV",
  46: "VAR",
  47: "DVAR",
  48: "TEXT",
  49: "LINEST",
  50: "TREND",
  51: "LOGEST",
  52: "GROWTH",
  53: "GOTO",
  54: "HALT",
  55: "RETURN",
  56: "PV",
  57: "FV",
  58: "NPER",
  59: "PMT",
  60: "RATE",
  61: "MIRR",
  62: "IRR",
  63: "RAND",
  64: "MATCH",
  65: "DATE",
  66: "TIME",
  67: "DAY",
  68: "MONTH",
  69: "YEAR",
  70: "WEEKDAY",
  71: "HOUR",
  72: "MINUTE",
  73: "SECOND",
  74: "NOW",
  75: "AREAS",
  76: "ROWS",
  77: "COLUMNS",
  78: "OFFSET",
  79: "ABSREF",
  80: "RELREF",
  81: "ARGUMENT",
  82: "SEARCH",
  83: "TRANSPOSE",
  84: "ERROR",
  85: "STEP",
  86: "TYPE",
  87: "ECHO",
  88: "SET.NAME",
  89: "CALLER",
  90: "DEREF",
  91: "WINDOWS",
  92: "SERIES",
  93: "DOCUMENTS",
  94: "ACTIVE.CELL",
  95: "SELECTION",
  96: "RESULT",
  97: "ATAN2",
  98: "ASIN",
  99: "ACOS",
  100: "CHOOSE",
  101: "HLOOKUP",
  102: "VLOOKUP",
  103: "LINKS",
  104: "INPUT",
  105: "ISREF",
  106: "GET.FORMULA",
  107: "GET.NAME",
  108: "SET.VALUE",
  109: "LOG",
  110: "EXEC",
  111: "CHAR",
  112: "LOWER",
  113: "UPPER",
  114: "PROPER",
  115: "LEFT",
  116: "RIGHT",
  117: "EXACT",
  118: "TRIM",
  119: "REPLACE",
  120: "SUBSTITUTE",
  121: "CODE",
  122: "NAMES",
  123: "DIRECTORY",
  124: "FIND",
  125: "CELL",
  126: "ISERR",
  127: "ISTEXT",
  128: "ISNUMBER",
  129: "ISBLANK",
  130: "T",
  131: "N",
  132: "FOPEN",
  133: "FCLOSE",
  134: "FSIZE",
  135: "FREADLN",
  136: "FREAD",
  137: "FWRITELN",
  138: "FWRITE",
  139: "FPOS",
  140: "DATEVALUE",
  141: "TIMEVALUE",
  142: "SLN",
  143: "SYD",
  144: "DDB",
  145: "GET.DEF",
  146: "REFTEXT",
  147: "TEXTREF",
  148: "INDIRECT",
  149: "REGISTER",
  150: "CALL",
  151: "ADD.BAR",
  152: "ADD.MENU",
  153: "ADD.COMMAND",
  154: "ENABLE.COMMAND",
  155: "CHECK.COMMAND",
  156: "RENAME.COMMAND",
  157: "SHOW.BAR",
  158: "DELETE.MENU",
  159: "DELETE.COMMAND",
  160: "GET.CHART.ITEM",
  161: "DIALOG.BOX",
  162: "CLEAN",
  163: "MDETERM",
  164: "MINVERSE",
  165: "MMULT",
  166: "FILES",
  167: "IPMT",
  168: "PPMT",
  169: "COUNTA",
  170: "CANCEL.KEY",
  171: "FOR",
  172: "WHILE",
  173: "BREAK",
  174: "NEXT",
  175: "INITIATE",
  176: "REQUEST",
  177: "POKE",
  178: "EXECUTE",
  179: "TERMINATE",
  180: "RESTART",
  181: "HELP",
  182: "GET.BAR",
  183: "PRODUCT",
  184: "FACT",
  185: "GET.CELL",
  186: "GET.WORKSPACE",
  187: "GET.WINDOW",
  188: "GET.DOCUMENT",
  189: "DPRODUCT",
  190: "ISNONTEXT",
  191: "GET.NOTE",
  192: "NOTE",
  193: "STDEVP",
  194: "VARP",
  195: "DSTDEVP",
  196: "DVARP",
  197: "TRUNC",
  198: "ISLOGICAL",
  199: "DCOUNTA",
  200: "DELETE.BAR",
  201: "UNREGISTER",
  204: "USDOLLAR",
  205: "FINDB",
  206: "SEARCHB",
  207: "REPLACEB",
  208: "LEFTB",
  209: "RIGHTB",
  210: "MIDB",
  211: "LENB",
  212: "ROUNDUP",
  213: "ROUNDDOWN",
  214: "ASC",
  215: "DBCS",
  216: "RANK",
  219: "ADDRESS",
  220: "DAYS360",
  221: "TODAY",
  222: "VDB",
  223: "ELSE",
  224: "ELSE.IF",
  225: "END.IF",
  226: "FOR.CELL",
  227: "MEDIAN",
  228: "SUMPRODUCT",
  229: "SINH",
  230: "COSH",
  231: "TANH",
  232: "ASINH",
  233: "ACOSH",
  234: "ATANH",
  235: "DGET",
  236: "CREATE.OBJECT",
  237: "VOLATILE",
  238: "LAST.ERROR",
  239: "CUSTOM.UNDO",
  240: "CUSTOM.REPEAT",
  241: "FORMULA.CONVERT",
  242: "GET.LINK.INFO",
  243: "TEXT.BOX",
  244: "INFO",
  245: "GROUP",
  246: "GET.OBJECT",
  247: "DB",
  248: "PAUSE",
  251: "RESUME",
  252: "FREQUENCY",
  253: "ADD.TOOLBAR",
  254: "DELETE.TOOLBAR",
  255: "User",
  256: "RESET.TOOLBAR",
  257: "EVALUATE",
  258: "GET.TOOLBAR",
  259: "GET.TOOL",
  260: "SPELLING.CHECK",
  261: "ERROR.TYPE",
  262: "APP.TITLE",
  263: "WINDOW.TITLE",
  264: "SAVE.TOOLBAR",
  265: "ENABLE.TOOL",
  266: "PRESS.TOOL",
  267: "REGISTER.ID",
  268: "GET.WORKBOOK",
  269: "AVEDEV",
  270: "BETADIST",
  271: "GAMMALN",
  272: "BETAINV",
  273: "BINOMDIST",
  274: "CHIDIST",
  275: "CHIINV",
  276: "COMBIN",
  277: "CONFIDENCE",
  278: "CRITBINOM",
  279: "EVEN",
  280: "EXPONDIST",
  281: "FDIST",
  282: "FINV",
  283: "FISHER",
  284: "FISHERINV",
  285: "FLOOR",
  286: "GAMMADIST",
  287: "GAMMAINV",
  288: "CEILING",
  289: "HYPGEOMDIST",
  290: "LOGNORMDIST",
  291: "LOGINV",
  292: "NEGBINOMDIST",
  293: "NORMDIST",
  294: "NORMSDIST",
  295: "NORMINV",
  296: "NORMSINV",
  297: "STANDARDIZE",
  298: "ODD",
  299: "PERMUT",
  300: "POISSON",
  301: "TDIST",
  302: "WEIBULL",
  303: "SUMXMY2",
  304: "SUMX2MY2",
  305: "SUMX2PY2",
  306: "CHITEST",
  307: "CORREL",
  308: "COVAR",
  309: "FORECAST",
  310: "FTEST",
  311: "INTERCEPT",
  312: "PEARSON",
  313: "RSQ",
  314: "STEYX",
  315: "SLOPE",
  316: "TTEST",
  317: "PROB",
  318: "DEVSQ",
  319: "GEOMEAN",
  320: "HARMEAN",
  321: "SUMSQ",
  322: "KURT",
  323: "SKEW",
  324: "ZTEST",
  325: "LARGE",
  326: "SMALL",
  327: "QUARTILE",
  328: "PERCENTILE",
  329: "PERCENTRANK",
  330: "MODE",
  331: "TRIMMEAN",
  332: "TINV",
  334: "MOVIE.COMMAND",
  335: "GET.MOVIE",
  336: "CONCATENATE",
  337: "POWER",
  338: "PIVOT.ADD.DATA",
  339: "GET.PIVOT.TABLE",
  340: "GET.PIVOT.FIELD",
  341: "GET.PIVOT.ITEM",
  342: "RADIANS",
  343: "DEGREES",
  344: "SUBTOTAL",
  345: "SUMIF",
  346: "COUNTIF",
  347: "COUNTBLANK",
  348: "SCENARIO.GET",
  349: "OPTIONS.LISTS.GET",
  350: "ISPMT",
  351: "DATEDIF",
  352: "DATESTRING",
  353: "NUMBERSTRING",
  354: "ROMAN",
  355: "OPEN.DIALOG",
  356: "SAVE.DIALOG",
  357: "VIEW.GET",
  358: "GETPIVOTDATA",
  359: "HYPERLINK",
  360: "PHONETIC",
  361: "AVERAGEA",
  362: "MAXA",
  363: "MINA",
  364: "STDEVPA",
  365: "VARPA",
  366: "STDEVA",
  367: "VARA",
  368: "BAHTTEXT",
  369: "THAIDAYOFWEEK",
  370: "THAIDIGIT",
  371: "THAIMONTHOFYEAR",
  372: "THAINUMSOUND",
  373: "THAINUMSTRING",
  374: "THAISTRINGLENGTH",
  375: "ISTHAIDIGIT",
  376: "ROUNDBAHTDOWN",
  377: "ROUNDBAHTUP",
  378: "THAIYEAR",
  379: "RTD",
  380: "CUBEVALUE",
  381: "CUBEMEMBER",
  382: "CUBEMEMBERPROPERTY",
  383: "CUBERANKEDMEMBER",
  384: "HEX2BIN",
  385: "HEX2DEC",
  386: "HEX2OCT",
  387: "DEC2BIN",
  388: "DEC2HEX",
  389: "DEC2OCT",
  390: "OCT2BIN",
  391: "OCT2HEX",
  392: "OCT2DEC",
  393: "BIN2DEC",
  394: "BIN2OCT",
  395: "BIN2HEX",
  396: "IMSUB",
  397: "IMDIV",
  398: "IMPOWER",
  399: "IMABS",
  400: "IMSQRT",
  401: "IMLN",
  402: "IMLOG2",
  403: "IMLOG10",
  404: "IMSIN",
  405: "IMCOS",
  406: "IMEXP",
  407: "IMARGUMENT",
  408: "IMCONJUGATE",
  409: "IMAGINARY",
  410: "IMREAL",
  411: "COMPLEX",
  412: "IMSUM",
  413: "IMPRODUCT",
  414: "SERIESSUM",
  415: "FACTDOUBLE",
  416: "SQRTPI",
  417: "QUOTIENT",
  418: "DELTA",
  419: "GESTEP",
  420: "ISEVEN",
  421: "ISODD",
  422: "MROUND",
  423: "ERF",
  424: "ERFC",
  425: "BESSELJ",
  426: "BESSELK",
  427: "BESSELY",
  428: "BESSELI",
  429: "XIRR",
  430: "XNPV",
  431: "PRICEMAT",
  432: "YIELDMAT",
  433: "INTRATE",
  434: "RECEIVED",
  435: "DISC",
  436: "PRICEDISC",
  437: "YIELDDISC",
  438: "TBILLEQ",
  439: "TBILLPRICE",
  440: "TBILLYIELD",
  441: "PRICE",
  442: "YIELD",
  443: "DOLLARDE",
  444: "DOLLARFR",
  445: "NOMINAL",
  446: "EFFECT",
  447: "CUMPRINC",
  448: "CUMIPMT",
  449: "EDATE",
  450: "EOMONTH",
  451: "YEARFRAC",
  452: "COUPDAYBS",
  453: "COUPDAYS",
  454: "COUPDAYSNC",
  455: "COUPNCD",
  456: "COUPNUM",
  457: "COUPPCD",
  458: "DURATION",
  459: "MDURATION",
  460: "ODDLPRICE",
  461: "ODDLYIELD",
  462: "ODDFPRICE",
  463: "ODDFYIELD",
  464: "RANDBETWEEN",
  465: "WEEKNUM",
  466: "AMORDEGRC",
  467: "AMORLINC",
  468: "CONVERT",
  724: "SHEETJS",
  469: "ACCRINT",
  470: "ACCRINTM",
  471: "WORKDAY",
  472: "NETWORKDAYS",
  473: "GCD",
  474: "MULTINOMIAL",
  475: "LCM",
  476: "FVSCHEDULE",
  477: "CUBEKPIMEMBER",
  478: "CUBESET",
  479: "CUBESETCOUNT",
  480: "IFERROR",
  481: "COUNTIFS",
  482: "SUMIFS",
  483: "AVERAGEIF",
  484: "AVERAGEIFS"
}, H8 = {
  2: 1,
  3: 1,
  10: 0,
  15: 1,
  16: 1,
  17: 1,
  18: 1,
  19: 0,
  20: 1,
  21: 1,
  22: 1,
  23: 1,
  24: 1,
  25: 1,
  26: 1,
  27: 2,
  30: 2,
  31: 3,
  32: 1,
  33: 1,
  34: 0,
  35: 0,
  38: 1,
  39: 2,
  40: 3,
  41: 3,
  42: 3,
  43: 3,
  44: 3,
  45: 3,
  47: 3,
  48: 2,
  53: 1,
  61: 3,
  63: 0,
  65: 3,
  66: 3,
  67: 1,
  68: 1,
  69: 1,
  70: 1,
  71: 1,
  72: 1,
  73: 1,
  74: 0,
  75: 1,
  76: 1,
  77: 1,
  79: 2,
  80: 2,
  83: 1,
  85: 0,
  86: 1,
  89: 0,
  90: 1,
  94: 0,
  95: 0,
  97: 2,
  98: 1,
  99: 1,
  101: 3,
  102: 3,
  105: 1,
  106: 1,
  108: 2,
  111: 1,
  112: 1,
  113: 1,
  114: 1,
  117: 2,
  118: 1,
  119: 4,
  121: 1,
  126: 1,
  127: 1,
  128: 1,
  129: 1,
  130: 1,
  131: 1,
  133: 1,
  134: 1,
  135: 1,
  136: 2,
  137: 2,
  138: 2,
  140: 1,
  141: 1,
  142: 3,
  143: 4,
  144: 4,
  161: 1,
  162: 1,
  163: 1,
  164: 1,
  165: 2,
  172: 1,
  175: 2,
  176: 2,
  177: 3,
  178: 2,
  179: 1,
  184: 1,
  186: 1,
  189: 3,
  190: 1,
  195: 3,
  196: 3,
  197: 1,
  198: 1,
  199: 3,
  201: 1,
  207: 4,
  210: 3,
  211: 1,
  212: 2,
  213: 2,
  214: 1,
  215: 1,
  225: 0,
  229: 1,
  230: 1,
  231: 1,
  232: 1,
  233: 1,
  234: 1,
  235: 3,
  244: 1,
  247: 4,
  252: 2,
  257: 1,
  261: 1,
  271: 1,
  273: 4,
  274: 2,
  275: 2,
  276: 2,
  277: 3,
  278: 3,
  279: 1,
  280: 3,
  281: 3,
  282: 3,
  283: 1,
  284: 1,
  285: 2,
  286: 4,
  287: 3,
  288: 2,
  289: 4,
  290: 3,
  291: 3,
  292: 3,
  293: 4,
  294: 1,
  295: 3,
  296: 1,
  297: 3,
  298: 1,
  299: 2,
  300: 3,
  301: 3,
  302: 4,
  303: 2,
  304: 2,
  305: 2,
  306: 2,
  307: 2,
  308: 2,
  309: 3,
  310: 2,
  311: 2,
  312: 2,
  313: 2,
  314: 2,
  315: 2,
  316: 4,
  325: 2,
  326: 2,
  327: 2,
  328: 2,
  331: 2,
  332: 2,
  337: 2,
  342: 1,
  343: 1,
  346: 2,
  347: 1,
  350: 4,
  351: 3,
  352: 1,
  353: 2,
  360: 1,
  368: 1,
  369: 1,
  370: 1,
  371: 1,
  372: 1,
  373: 1,
  374: 1,
  375: 1,
  376: 1,
  377: 1,
  378: 1,
  382: 3,
  385: 1,
  392: 1,
  393: 1,
  396: 2,
  397: 2,
  398: 2,
  399: 1,
  400: 1,
  401: 1,
  402: 1,
  403: 1,
  404: 1,
  405: 1,
  406: 1,
  407: 1,
  408: 1,
  409: 1,
  410: 1,
  414: 4,
  415: 1,
  416: 1,
  417: 2,
  420: 1,
  421: 1,
  422: 2,
  424: 1,
  425: 2,
  426: 2,
  427: 2,
  428: 2,
  430: 3,
  438: 3,
  439: 3,
  440: 3,
  443: 2,
  444: 2,
  445: 2,
  446: 2,
  447: 6,
  448: 6,
  449: 2,
  450: 2,
  464: 2,
  468: 3,
  476: 2,
  479: 1,
  480: 2,
  65535: 0
};
function gh(e) {
  return e.slice(0, 3) == "of:" && (e = e.slice(3)), e.charCodeAt(0) == 61 && (e = e.slice(1), e.charCodeAt(0) == 61 && (e = e.slice(1))), e = e.replace(/COM\.MICROSOFT\./g, ""), e = e.replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g, function(r, t) {
    return t.replace(/\./g, "");
  }), e = e.replace(/\[.(#[A-Z]*[?!])\]/g, "$1"), e.replace(/[;~]/g, ",").replace(/\|/g, ";");
}
function j8(e) {
  var r = "of:=" + e.replace(Kc, "$1[.$2$3$4$5]").replace(/\]:\[/g, ":");
  return r.replace(/;/g, "|").replace(/,/g, ";");
}
function vu(e) {
  var r = e.split(":"), t = r[0].split(".")[0];
  return [t, r[0].split(".")[1] + (r.length > 1 ? ":" + (r[1].split(".")[1] || r[1].split(".")[0]) : "")];
}
function z8(e) {
  return e.replace(/\./, "!");
}
var Hi = {}, Yn = {}, ji = typeof Map < "u";
function Zc(e, r, t) {
  var a = 0, n = e.length;
  if (t) {
    if (ji ? t.has(r) : Object.prototype.hasOwnProperty.call(t, r)) {
      for (var i = ji ? t.get(r) : t[r]; a < i.length; ++a)
        if (e[i[a]].t === r)
          return e.Count++, i[a];
    }
  } else
    for (; a < n; ++a)
      if (e[a].t === r)
        return e.Count++, a;
  return e[n] = { t: r }, e.Count++, e.Unique++, t && (ji ? (t.has(r) || t.set(r, []), t.get(r).push(n)) : (Object.prototype.hasOwnProperty.call(t, r) || (t[r] = []), t[r].push(n))), n;
}
function _0(e, r) {
  var t = { min: e + 1, max: e + 1 }, a = -1;
  return r.MDW && (Kr = r.MDW), r.width != null ? t.customWidth = 1 : r.wpx != null ? a = ls(r.wpx) : r.wch != null && (a = r.wch), a > -1 ? (t.width = Zo(a), t.customWidth = 1) : r.width != null && (t.width = r.width), r.hidden && (t.hidden = !0), r.level != null && (t.outlineLevel = t.level = r.level), t;
}
function tn(e, r) {
  if (e) {
    var t = [0.7, 0.7, 0.75, 0.75, 0.3, 0.3];
    r == "xlml" && (t = [1, 1, 1, 1, 0.5, 0.5]), e.left == null && (e.left = t[0]), e.right == null && (e.right = t[1]), e.top == null && (e.top = t[2]), e.bottom == null && (e.bottom = t[3]), e.header == null && (e.header = t[4]), e.footer == null && (e.footer = t[5]);
  }
}
function Ha(e, r, t) {
  var a = t.revssf[r.z != null ? r.z : "General"], n = 60, i = e.length;
  if (a == null && t.ssf) {
    for (; n < 392; ++n)
      if (t.ssf[n] == null) {
        Gt(r.z, n), t.ssf[n] = r.z, t.revssf[r.z] = a = n;
        break;
      }
  }
  for (n = 0; n != i; ++n)
    if (e[n].numFmtId === a)
      return n;
  return e[i] = {
    numFmtId: a,
    fontId: 0,
    fillId: 0,
    borderId: 0,
    xfId: 0,
    applyNumberFormat: 1
  }, i;
}
function u2(e, r, t, a, n, i) {
  try {
    a.cellNF && (e.z = Ee[r]);
  } catch (o) {
    if (a.WTF)
      throw o;
  }
  if (!(e.t === "z" && !a.cellStyles)) {
    if (e.t === "d" && typeof e.v == "string" && (e.v = ur(e.v)), (!a || a.cellText !== !1) && e.t !== "z")
      try {
        if (Ee[r] == null && Gt(V5[r] || "General", r), e.t === "e")
          e.w = e.w || pa[e.v];
        else if (r === 0)
          if (e.t === "n")
            (e.v | 0) === e.v ? e.w = e.v.toString(10) : e.w = ts(e.v);
          else if (e.t === "d") {
            var s = Ar(e.v);
            (s | 0) === s ? e.w = s.toString(10) : e.w = ts(s);
          } else {
            if (e.v === void 0)
              return "";
            e.w = cn(e.v, Yn);
          }
        else
          e.t === "d" ? e.w = pt(r, Ar(e.v), Yn) : e.w = pt(r, e.v, Yn);
      } catch (o) {
        if (a.WTF)
          throw o;
      }
    if (a.cellStyles && t != null)
      try {
        e.s = i.Fills[t], e.s.fgColor && e.s.fgColor.theme && !e.s.fgColor.rgb && (e.s.fgColor.rgb = Xo(n.themeElements.clrScheme[e.s.fgColor.theme].rgb, e.s.fgColor.tint || 0), a.WTF && (e.s.fgColor.raw_rgb = n.themeElements.clrScheme[e.s.fgColor.theme].rgb)), e.s.bgColor && e.s.bgColor.theme && (e.s.bgColor.rgb = Xo(n.themeElements.clrScheme[e.s.bgColor.theme].rgb, e.s.bgColor.tint || 0), a.WTF && (e.s.bgColor.raw_rgb = n.themeElements.clrScheme[e.s.bgColor.theme].rgb));
      } catch (o) {
        if (a.WTF && i.Fills)
          throw o;
      }
  }
}
function G8(e, r, t) {
  if (e && e["!ref"]) {
    var a = Oe(e["!ref"]);
    if (a.e.c < a.s.c || a.e.r < a.s.r)
      throw new Error("Bad range (" + t + "): " + e["!ref"]);
  }
}
function K8(e, r) {
  var t = Oe(r);
  t.s.r <= t.e.r && t.s.c <= t.e.c && t.s.r >= 0 && t.s.c >= 0 && (e["!ref"] = Ce(t));
}
var Y8 = /<(?:\w:)?mergeCell ref="[A-Z0-9:]+"\s*[\/]?>/g, X8 = /<(?:\w+:)?sheetData[^>]*>([\s\S]*)<\/(?:\w+:)?sheetData>/, Z8 = /<(?:\w:)?hyperlink [^>]*>/mg, J8 = /"(\w*:\w*)"/, q8 = /<(?:\w:)?col\b[^>]*[\/]?>/g, Q8 = /<(?:\w:)?autoFilter[^>]*([\/]|>([\s\S]*)<\/(?:\w:)?autoFilter)>/g, ek = /<(?:\w:)?pageMargins[^>]*\/>/g, l2 = /<(?:\w:)?sheetPr\b(?:[^>a-z][^>]*)?\/>/, rk = /<(?:\w:)?sheetPr[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetPr)>/, tk = /<(?:\w:)?sheetViews[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetViews)>/;
function ak(e, r, t, a, n, i, s) {
  if (!e)
    return e;
  a || (a = { "!id": {} });
  var o = r.dense ? [] : {}, u = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } }, l = "", c = "", f = e.match(X8);
  f ? (l = e.slice(0, f.index), c = e.slice(f.index + f[0].length)) : l = c = e;
  var h = l.match(l2);
  h ? Jc(h[0], o, n, t) : (h = l.match(rk)) && ik(h[0], h[1] || "", o, n, t);
  var d = (l.match(/<(?:\w*:)?dimension/) || { index: -1 }).index;
  if (d > 0) {
    var m = l.slice(d, d + 50).match(J8);
    m && K8(o, m[1]);
  }
  var x = l.match(tk);
  x && x[1] && gk(x[1], n);
  var p = [];
  if (r.cellStyles) {
    var w = l.match(q8);
    w && hk(p, w);
  }
  f && wk(f[1], o, r, u, i, s);
  var D = c.match(Q8);
  D && (o["!autofilter"] = mk(D[0]));
  var y = [], B = c.match(Y8);
  if (B)
    for (d = 0; d != B.length; ++d)
      y[d] = Oe(B[d].slice(B[d].indexOf('"') + 1));
  var L = c.match(Z8);
  L && ck(o, L, a);
  var U = c.match(ek);
  if (U && (o["!margins"] = fk(Se(U[0]))), !o["!ref"] && u.e.c >= u.s.c && u.e.r >= u.s.r && (o["!ref"] = Ce(u)), r.sheetRows > 0 && o["!ref"]) {
    var k = Oe(o["!ref"]);
    r.sheetRows <= +k.e.r && (k.e.r = r.sheetRows - 1, k.e.r > u.e.r && (k.e.r = u.e.r), k.e.r < k.s.r && (k.s.r = k.e.r), k.e.c > u.e.c && (k.e.c = u.e.c), k.e.c < k.s.c && (k.s.c = k.e.c), o["!fullref"] = o["!ref"], o["!ref"] = Ce(k));
  }
  return p.length > 0 && (o["!cols"] = p), y.length > 0 && (o["!merges"] = y), o;
}
function nk(e) {
  if (e.length === 0)
    return "";
  for (var r = '<mergeCells count="' + e.length + '">', t = 0; t != e.length; ++t)
    r += '<mergeCell ref="' + Ce(e[t]) + '"/>';
  return r + "</mergeCells>";
}
function Jc(e, r, t, a) {
  var n = Se(e);
  t.Sheets[a] || (t.Sheets[a] = {}), n.codeName && (t.Sheets[a].CodeName = We(Qe(n.codeName)));
}
function ik(e, r, t, a, n) {
  Jc(e.slice(0, e.indexOf(">")), t, a, n);
}
function sk(e, r, t, a, n) {
  var i = !1, s = {}, o = null;
  if (a.bookType !== "xlsx" && r.vbaraw) {
    var u = r.SheetNames[t];
    try {
      r.Workbook && (u = r.Workbook.Sheets[t].CodeName || u);
    } catch {
    }
    i = !0, s.codeName = zt(Xe(u));
  }
  if (e && e["!outline"]) {
    var l = { summaryBelow: 1, summaryRight: 1 };
    e["!outline"].above && (l.summaryBelow = 0), e["!outline"].left && (l.summaryRight = 0), o = (o || "") + he("outlinePr", null, l);
  }
  !i && !o || (n[n.length] = he("sheetPr", o, s));
}
var ok = ["objects", "scenarios", "selectLockedCells", "selectUnlockedCells"], uk = [
  "formatColumns",
  "formatRows",
  "formatCells",
  "insertColumns",
  "insertRows",
  "insertHyperlinks",
  "deleteColumns",
  "deleteRows",
  "sort",
  "autoFilter",
  "pivotTables"
];
function lk(e) {
  var r = { sheet: 1 };
  return ok.forEach(function(t) {
    e[t] != null && e[t] && (r[t] = "1");
  }), uk.forEach(function(t) {
    e[t] != null && !e[t] && (r[t] = "0");
  }), e.password && (r.password = jc(e.password).toString(16).toUpperCase()), he("sheetProtection", null, r);
}
function ck(e, r, t) {
  for (var a = Array.isArray(e), n = 0; n != r.length; ++n) {
    var i = Se(Qe(r[n]), !0);
    if (!i.ref)
      return;
    var s = ((t || {})["!id"] || [])[i.id];
    s ? (i.Target = s.Target, i.location && (i.Target += "#" + We(i.location))) : (i.Target = "#" + We(i.location), s = { Target: i.Target, TargetMode: "Internal" }), i.Rel = s, i.tooltip && (i.Tooltip = i.tooltip, delete i.tooltip);
    for (var o = Oe(i.ref), u = o.s.r; u <= o.e.r; ++u)
      for (var l = o.s.c; l <= o.e.c; ++l) {
        var c = Te({ c: l, r: u });
        a ? (e[u] || (e[u] = []), e[u][l] || (e[u][l] = { t: "z", v: void 0 }), e[u][l].l = i) : (e[c] || (e[c] = { t: "z", v: void 0 }), e[c].l = i);
      }
  }
}
function fk(e) {
  var r = {};
  return ["left", "right", "top", "bottom", "header", "footer"].forEach(function(t) {
    e[t] && (r[t] = parseFloat(e[t]));
  }), r;
}
function dk(e) {
  return tn(e), he("pageMargins", null, e);
}
function hk(e, r) {
  for (var t = !1, a = 0; a != r.length; ++a) {
    var n = Se(r[a], !0);
    n.hidden && (n.hidden = sr(n.hidden));
    var i = parseInt(n.min, 10) - 1, s = parseInt(n.max, 10) - 1;
    for (n.outlineLevel && (n.level = +n.outlineLevel || 0), delete n.min, delete n.max, n.width = +n.width, !t && n.width && (t = !0, zc(n.width)), Ma(n); i <= s; )
      e[i++] = tr(n);
  }
}
function xk(e, r) {
  for (var t = ["<cols>"], a, n = 0; n != r.length; ++n)
    (a = r[n]) && (t[t.length] = he("col", null, _0(n, a)));
  return t[t.length] = "</cols>", t.join("");
}
function mk(e) {
  var r = { ref: (e.match(/ref="([^"]*)"/) || [])[1] };
  return r;
}
function pk(e, r, t, a) {
  var n = typeof e.ref == "string" ? e.ref : Ce(e.ref);
  t.Workbook || (t.Workbook = { Sheets: [] }), t.Workbook.Names || (t.Workbook.Names = []);
  var i = t.Workbook.Names, s = tt(n);
  s.s.r == s.e.r && (s.e.r = tt(r["!ref"]).e.r, n = Ce(s));
  for (var o = 0; o < i.length; ++o) {
    var u = i[o];
    if (u.Name == "_xlnm._FilterDatabase" && u.Sheet == a) {
      u.Ref = "'" + t.SheetNames[a] + "'!" + n;
      break;
    }
  }
  return o == i.length && i.push({ Name: "_xlnm._FilterDatabase", Sheet: a, Ref: "'" + t.SheetNames[a] + "'!" + n }), he("autoFilter", null, { ref: n });
}
var vk = /<(?:\w:)?sheetView(?:[^>a-z][^>]*)?\/?>/;
function gk(e, r) {
  r.Views || (r.Views = [{}]), (e.match(vk) || []).forEach(function(t, a) {
    var n = Se(t);
    r.Views[a] || (r.Views[a] = {}), +n.zoomScale && (r.Views[a].zoom = +n.zoomScale), sr(n.rightToLeft) && (r.Views[a].RTL = !0);
  });
}
function yk(e, r, t, a) {
  var n = { workbookViewId: "0" };
  return (((a || {}).Workbook || {}).Views || [])[0] && (n.rightToLeft = a.Workbook.Views[0].RTL ? "1" : "0"), he("sheetViews", he("sheetView", null, n), {});
}
function bk(e, r, t, a) {
  if (e.c && t["!comments"].push([r, e.c]), e.v === void 0 && typeof e.f != "string" || e.t === "z" && !e.f)
    return "";
  var n = "", i = e.t, s = e.v;
  if (e.t !== "z")
    switch (e.t) {
      case "b":
        n = e.v ? "1" : "0";
        break;
      case "n":
        n = "" + e.v;
        break;
      case "e":
        n = pa[e.v];
        break;
      case "d":
        a && a.cellDates ? n = ur(e.v, -1).toISOString() : (e = tr(e), e.t = "n", n = "" + (e.v = Ar(ur(e.v)))), typeof e.z > "u" && (e.z = Ee[14]);
        break;
      default:
        n = e.v;
        break;
    }
  var o = Wr("v", Xe(n)), u = { r }, l = Ha(a.cellXfs, e, a);
  switch (l !== 0 && (u.s = l), e.t) {
    case "n":
      break;
    case "d":
      u.t = "d";
      break;
    case "b":
      u.t = "b";
      break;
    case "e":
      u.t = "e";
      break;
    case "z":
      break;
    default:
      if (e.v == null) {
        delete e.t;
        break;
      }
      if (e.v.length > 32767)
        throw new Error("Text length must not exceed 32767 characters");
      if (a && a.bookSST) {
        o = Wr("v", "" + Zc(a.Strings, e.v, a.revStrings)), u.t = "s";
        break;
      }
      u.t = "str";
      break;
  }
  if (e.t != i && (e.t = i, e.v = s), typeof e.f == "string" && e.f) {
    var c = e.F && e.F.slice(0, r.length) == r ? { t: "array", ref: e.F } : null;
    o = he("f", Xe(e.f), c) + (e.v != null ? o : "");
  }
  return e.l && t["!links"].push([r, e.l]), e.D && (u.cm = 1), he("c", o, u);
}
var wk = /* @__PURE__ */ function() {
  var e = /<(?:\w+:)?c[ \/>]/, r = /<\/(?:\w+:)?row>/, t = /r=["']([^"']*)["']/, a = /<(?:\w+:)?is>([\S\s]*?)<\/(?:\w+:)?is>/, n = /ref=["']([^"']*)["']/, i = as("v"), s = as("f");
  return function(u, l, c, f, h, d) {
    for (var m = 0, x = "", p = [], w = [], D = 0, y = 0, B = 0, L = "", U, k, v = 0, b = 0, A, T, C = 0, I = 0, Y = Array.isArray(d.CellXf), j, J = [], W = [], ce = Array.isArray(l), V = [], ee = {}, de = !1, F = !!c.sheetStubs, H = u.split(r), P = 0, N = H.length; P != N; ++P) {
      x = H[P].trim();
      var X = x.length;
      if (X !== 0) {
        var ae = 0;
        e:
          for (m = 0; m < X; ++m)
            switch (
              /*x.charCodeAt(ri)*/
              x[m]
            ) {
              case ">":
                if (
                  /*x.charCodeAt(ri-1) != 47*/
                  x[m - 1] != "/"
                ) {
                  ++m;
                  break e;
                }
                if (c && c.cellStyles) {
                  if (k = Se(x.slice(ae, m), !0), v = k.r != null ? parseInt(k.r, 10) : v + 1, b = -1, c.sheetRows && c.sheetRows < v)
                    continue;
                  ee = {}, de = !1, k.ht && (de = !0, ee.hpt = parseFloat(k.ht), ee.hpx = li(ee.hpt)), k.hidden == "1" && (de = !0, ee.hidden = !0), k.outlineLevel != null && (de = !0, ee.level = +k.outlineLevel), de && (V[v - 1] = ee);
                }
                break;
              case "<":
                ae = m;
                break;
            }
        if (ae >= m)
          break;
        if (k = Se(x.slice(ae, m), !0), v = k.r != null ? parseInt(k.r, 10) : v + 1, b = -1, !(c.sheetRows && c.sheetRows < v)) {
          f.s.r > v - 1 && (f.s.r = v - 1), f.e.r < v - 1 && (f.e.r = v - 1), c && c.cellStyles && (ee = {}, de = !1, k.ht && (de = !0, ee.hpt = parseFloat(k.ht), ee.hpx = li(ee.hpt)), k.hidden == "1" && (de = !0, ee.hidden = !0), k.outlineLevel != null && (de = !0, ee.level = +k.outlineLevel), de && (V[v - 1] = ee)), p = x.slice(m).split(e);
          for (var ie = 0; ie != p.length && p[ie].trim().charAt(0) == "<"; ++ie)
            ;
          for (p = p.slice(ie), m = 0; m != p.length; ++m)
            if (x = p[m].trim(), x.length !== 0) {
              if (w = x.match(t), D = m, y = 0, B = 0, x = "<c " + (x.slice(0, 1) == "<" ? ">" : "") + x, w != null && w.length === 2) {
                for (D = 0, L = w[1], y = 0; y != L.length && !((B = L.charCodeAt(y) - 64) < 1 || B > 26); ++y)
                  D = 26 * D + B;
                --D, b = D;
              } else
                ++b;
              for (y = 0; y != x.length && x.charCodeAt(y) !== 62; ++y)
                ;
              if (++y, k = Se(x.slice(0, y), !0), k.r || (k.r = Te({ r: v - 1, c: b })), L = x.slice(y), U = { t: "" }, (w = L.match(i)) != null && /*::cref != null && */
              w[1] !== "" && (U.v = We(w[1])), c.cellFormula) {
                if ((w = L.match(s)) != null && /*::cref != null && */
                w[1] !== "") {
                  if (U.f = We(Qe(w[1])).replace(/\r\n/g, `
`), c.xlfn || (U.f = xh(U.f)), /*::cref != null && cref[0] != null && */
                  w[0].indexOf('t="array"') > -1)
                    U.F = (L.match(n) || [])[1], U.F.indexOf(":") > -1 && J.push([Oe(U.F), U.F]);
                  else if (
                    /*::cref != null && cref[0] != null && */
                    w[0].indexOf('t="shared"') > -1
                  ) {
                    T = Se(w[0]);
                    var q = We(Qe(w[1]));
                    c.xlfn || (q = xh(q)), W[parseInt(T.si, 10)] = [T, q, k.r];
                  }
                } else
                  (w = L.match(/<f[^>]*\/>/)) && (T = Se(w[0]), W[T.si] && (U.f = v7(W[T.si][1], W[T.si][2], k.r)));
                var re = fr(k.r);
                for (y = 0; y < J.length; ++y)
                  re.r >= J[y][0].s.r && re.r <= J[y][0].e.r && re.c >= J[y][0].s.c && re.c <= J[y][0].e.c && (U.F = J[y][1]);
              }
              if (k.t == null && U.v === void 0)
                if (U.f || U.F)
                  U.v = 0, U.t = "n";
                else if (F)
                  U.t = "z";
                else
                  continue;
              else
                U.t = k.t || "n";
              switch (f.s.c > b && (f.s.c = b), f.e.c < b && (f.e.c = b), U.t) {
                case "n":
                  if (U.v == "" || U.v == null) {
                    if (!F)
                      continue;
                    U.t = "z";
                  } else
                    U.v = parseFloat(U.v);
                  break;
                case "s":
                  if (typeof U.v > "u") {
                    if (!F)
                      continue;
                    U.t = "z";
                  } else
                    A = Hi[parseInt(U.v, 10)], U.v = A.t, U.r = A.r, c.cellHTML && (U.h = A.h);
                  break;
                case "str":
                  U.t = "s", U.v = U.v != null ? Qe(U.v) : "", c.cellHTML && (U.h = Ec(U.v));
                  break;
                case "inlineStr":
                  w = L.match(a), U.t = "s", w != null && (A = Hc(w[1])) ? (U.v = A.t, c.cellHTML && (U.h = A.h)) : U.v = "";
                  break;
                case "b":
                  U.v = sr(U.v);
                  break;
                case "d":
                  c.cellDates ? U.v = ur(U.v, 1) : (U.v = Ar(ur(U.v, 1)), U.t = "n");
                  break;
                case "e":
                  (!c || c.cellText !== !1) && (U.w = U.v), U.v = fv[U.v];
                  break;
              }
              if (C = I = 0, j = null, Y && k.s !== void 0 && (j = d.CellXf[k.s], j != null && (j.numFmtId != null && (C = j.numFmtId), c.cellStyles && j.fillId != null && (I = j.fillId))), u2(U, C, I, c, h, d), c.cellDates && Y && U.t == "n" && pn(Ee[C]) && (U.t = "d", U.v = v0(U.v)), k.cm && c.xlmeta) {
                var ve = (c.xlmeta.Cell || [])[+k.cm - 1];
                ve && ve.type == "XLDAPR" && (U.D = !0);
              }
              if (ce) {
                var M = fr(k.r);
                l[M.r] || (l[M.r] = []), l[M.r][M.c] = U;
              } else
                l[k.r] = U;
            }
        }
      }
    }
    V.length > 0 && (l["!rows"] = V);
  };
}();
function _k(e, r, t, a) {
  var n = [], i = [], s = Oe(e["!ref"]), o = "", u, l = "", c = [], f = 0, h = 0, d = e["!rows"], m = Array.isArray(e), x = { r: l }, p, w = -1;
  for (h = s.s.c; h <= s.e.c; ++h)
    c[h] = or(h);
  for (f = s.s.r; f <= s.e.r; ++f) {
    for (i = [], l = gr(f), h = s.s.c; h <= s.e.c; ++h) {
      u = c[h] + l;
      var D = m ? (e[f] || [])[h] : e[u];
      D !== void 0 && (o = bk(D, u, e, r)) != null && i.push(o);
    }
    (i.length > 0 || d && d[f]) && (x = { r: l }, d && d[f] && (p = d[f], p.hidden && (x.hidden = 1), w = -1, p.hpx ? w = cs(p.hpx) : p.hpt && (w = p.hpt), w > -1 && (x.ht = w, x.customHeight = 1), p.level && (x.outlineLevel = p.level)), n[n.length] = he("row", i.join(""), x));
  }
  if (d)
    for (; f < d.length; ++f)
      d && d[f] && (x = { r: f + 1 }, p = d[f], p.hidden && (x.hidden = 1), w = -1, p.hpx ? w = cs(p.hpx) : p.hpt && (w = p.hpt), w > -1 && (x.ht = w, x.customHeight = 1), p.level && (x.outlineLevel = p.level), n[n.length] = he("row", "", x));
  return n.join("");
}
function c2(e, r, t, a) {
  var n = [$r, he("worksheet", null, {
    xmlns: vn[0],
    "xmlns:r": Fr.r
  })], i = t.SheetNames[e], s = 0, o = "", u = t.Sheets[i];
  u == null && (u = {});
  var l = u["!ref"] || "A1", c = Oe(l);
  if (c.e.c > 16383 || c.e.r > 1048575) {
    if (r.WTF)
      throw new Error("Range " + l + " exceeds format limit A1:XFD1048576");
    c.e.c = Math.min(c.e.c, 16383), c.e.r = Math.min(c.e.c, 1048575), l = Ce(c);
  }
  a || (a = {}), u["!comments"] = [];
  var f = [];
  sk(u, t, e, r, n), n[n.length] = he("dimension", null, { ref: l }), n[n.length] = yk(u, r, e, t), r.sheetFormat && (n[n.length] = he("sheetFormatPr", null, {
    defaultRowHeight: r.sheetFormat.defaultRowHeight || "16",
    baseColWidth: r.sheetFormat.baseColWidth || "10",
    outlineLevelRow: r.sheetFormat.outlineLevelRow || "7"
  })), u["!cols"] != null && u["!cols"].length > 0 && (n[n.length] = xk(u, u["!cols"])), n[s = n.length] = "<sheetData/>", u["!links"] = [], u["!ref"] != null && (o = _k(u, r), o.length > 0 && (n[n.length] = o)), n.length > s + 1 && (n[n.length] = "</sheetData>", n[s] = n[s].replace("/>", ">")), u["!protect"] && (n[n.length] = lk(u["!protect"])), u["!autofilter"] != null && (n[n.length] = pk(u["!autofilter"], u, t, e)), u["!merges"] != null && u["!merges"].length > 0 && (n[n.length] = nk(u["!merges"]));
  var h = -1, d, m = -1;
  return (
    /*::(*/
    u["!links"].length > 0 && (n[n.length] = "<hyperlinks>", u["!links"].forEach(function(x) {
      x[1].Target && (d = { ref: x[0] }, x[1].Target.charAt(0) != "#" && (m = Ye(a, -1, Xe(x[1].Target).replace(/#.*$/, ""), Be.HLINK), d["r:id"] = "rId" + m), (h = x[1].Target.indexOf("#")) > -1 && (d.location = Xe(x[1].Target.slice(h + 1))), x[1].Tooltip && (d.tooltip = Xe(x[1].Tooltip)), n[n.length] = he("hyperlink", null, d));
    }), n[n.length] = "</hyperlinks>"), delete u["!links"], u["!margins"] != null && (n[n.length] = dk(u["!margins"])), (!r || r.ignoreEC || r.ignoreEC == null) && (n[n.length] = Wr("ignoredErrors", he("ignoredError", null, { numberStoredAsText: 1, sqref: l }))), f.length > 0 && (m = Ye(a, -1, "../drawings/drawing" + (e + 1) + ".xml", Be.DRAW), n[n.length] = he("drawing", null, { "r:id": "rId" + m }), u["!drawing"] = f), u["!comments"].length > 0 && (m = Ye(a, -1, "../drawings/vmlDrawing" + (e + 1) + ".vml", Be.VML), n[n.length] = he("legacyDrawing", null, { "r:id": "rId" + m }), u["!legacy"] = m), n.length > 1 && (n[n.length] = "</worksheet>", n[1] = n[1].replace("/>", ">")), n.join("")
  );
}
function $k(e, r) {
  var t = {}, a = e.l + r;
  t.r = e.read_shift(4), e.l += 4;
  var n = e.read_shift(2);
  e.l += 1;
  var i = e.read_shift(1);
  return e.l = a, i & 7 && (t.level = i & 7), i & 16 && (t.hidden = !0), i & 32 && (t.hpt = n / 20), t;
}
function Dk(e, r, t) {
  var a = te(145), n = (t["!rows"] || [])[e] || {};
  a.write_shift(4, e), a.write_shift(4, 0);
  var i = 320;
  n.hpx ? i = cs(n.hpx) * 20 : n.hpt && (i = n.hpt * 20), a.write_shift(2, i), a.write_shift(1, 0);
  var s = 0;
  n.level && (s |= n.level), n.hidden && (s |= 16), (n.hpx || n.hpt) && (s |= 32), a.write_shift(1, s), a.write_shift(1, 0);
  var o = 0, u = a.l;
  a.l += 4;
  for (var l = { r: e, c: 0 }, c = 0; c < 16; ++c)
    if (!(r.s.c > c + 1 << 10 || r.e.c < c << 10)) {
      for (var f = -1, h = -1, d = c << 10; d < c + 1 << 10; ++d) {
        l.c = d;
        var m = Array.isArray(t) ? (t[l.r] || [])[l.c] : t[Te(l)];
        m && (f < 0 && (f = d), h = d);
      }
      f < 0 || (++o, a.write_shift(4, f), a.write_shift(4, h));
    }
  var x = a.l;
  return a.l = u, a.write_shift(4, o), a.l = x, a.length > a.l ? a.slice(0, a.l) : a;
}
function Ek(e, r, t, a) {
  var n = Dk(a, t, r);
  (n.length > 17 || (r["!rows"] || [])[a]) && se(e, 0, n);
}
var kk = wn, Tk = pi;
function Sk() {
}
function Ck(e, r) {
  var t = {}, a = e[e.l];
  return ++e.l, t.above = !(a & 64), t.left = !(a & 128), e.l += 18, t.name = R_(e), t;
}
function Fk(e, r, t) {
  t == null && (t = te(84 + 4 * e.length));
  var a = 192;
  r && (r.above && (a &= -65), r.left && (a &= -129)), t.write_shift(1, a);
  for (var n = 1; n < 3; ++n)
    t.write_shift(1, 0);
  return Go({ auto: 1 }, t), t.write_shift(-4, -1), t.write_shift(-4, -1), sv(e, t), t.slice(0, t.l);
}
function Ak(e) {
  var r = St(e);
  return [r];
}
function Rk(e, r, t) {
  return t == null && (t = te(8)), gn(r, t);
}
function Ik(e) {
  var r = yn(e);
  return [r];
}
function Bk(e, r, t) {
  return t == null && (t = te(4)), bn(r, t);
}
function Pk(e) {
  var r = St(e), t = e.read_shift(1);
  return [r, t, "b"];
}
function Mk(e, r, t) {
  return t == null && (t = te(9)), gn(r, t), t.write_shift(1, e.v ? 1 : 0), t;
}
function Ok(e) {
  var r = yn(e), t = e.read_shift(1);
  return [r, t, "b"];
}
function Lk(e, r, t) {
  return t == null && (t = te(5)), bn(r, t), t.write_shift(1, e.v ? 1 : 0), t;
}
function Nk(e) {
  var r = St(e), t = e.read_shift(1);
  return [r, t, "e"];
}
function Uk(e, r, t) {
  return t == null && (t = te(9)), gn(r, t), t.write_shift(1, e.v), t;
}
function Vk(e) {
  var r = yn(e), t = e.read_shift(1);
  return [r, t, "e"];
}
function Wk(e, r, t) {
  return t == null && (t = te(8)), bn(r, t), t.write_shift(1, e.v), t.write_shift(2, 0), t.write_shift(1, 0), t;
}
function Hk(e) {
  var r = St(e), t = e.read_shift(4);
  return [r, t, "s"];
}
function jk(e, r, t) {
  return t == null && (t = te(12)), gn(r, t), t.write_shift(4, r.v), t;
}
function zk(e) {
  var r = yn(e), t = e.read_shift(4);
  return [r, t, "s"];
}
function Gk(e, r, t) {
  return t == null && (t = te(8)), bn(r, t), t.write_shift(4, r.v), t;
}
function Kk(e) {
  var r = St(e), t = Xr(e);
  return [r, t, "n"];
}
function Yk(e, r, t) {
  return t == null && (t = te(16)), gn(r, t), dn(e.v, t), t;
}
function f2(e) {
  var r = yn(e), t = Xr(e);
  return [r, t, "n"];
}
function Xk(e, r, t) {
  return t == null && (t = te(12)), bn(r, t), dn(e.v, t), t;
}
function Zk(e) {
  var r = St(e), t = Lc(e);
  return [r, t, "n"];
}
function Jk(e, r, t) {
  return t == null && (t = te(12)), gn(r, t), ov(e.v, t), t;
}
function qk(e) {
  var r = yn(e), t = Lc(e);
  return [r, t, "n"];
}
function Qk(e, r, t) {
  return t == null && (t = te(8)), bn(r, t), ov(e.v, t), t;
}
function eT(e) {
  var r = St(e), t = Pc(e);
  return [r, t, "is"];
}
function rT(e) {
  var r = St(e), t = Jr(e);
  return [r, t, "str"];
}
function tT(e, r, t) {
  return t == null && (t = te(12 + 4 * e.v.length)), gn(r, t), Lr(e.v, t), t.length > t.l ? t.slice(0, t.l) : t;
}
function aT(e) {
  var r = yn(e), t = Jr(e);
  return [r, t, "str"];
}
function nT(e, r, t) {
  return t == null && (t = te(8 + 4 * e.v.length)), bn(r, t), Lr(e.v, t), t.length > t.l ? t.slice(0, t.l) : t;
}
function iT(e, r, t) {
  var a = e.l + r, n = St(e);
  n.r = t["!row"];
  var i = e.read_shift(1), s = [n, i, "b"];
  if (t.cellFormula) {
    e.l += 2;
    var o = w0(e, a - e.l, t);
    s[3] = Gr(o, null, n, t.supbooks, t);
  } else
    e.l = a;
  return s;
}
function sT(e, r, t) {
  var a = e.l + r, n = St(e);
  n.r = t["!row"];
  var i = e.read_shift(1), s = [n, i, "e"];
  if (t.cellFormula) {
    e.l += 2;
    var o = w0(e, a - e.l, t);
    s[3] = Gr(o, null, n, t.supbooks, t);
  } else
    e.l = a;
  return s;
}
function oT(e, r, t) {
  var a = e.l + r, n = St(e);
  n.r = t["!row"];
  var i = Xr(e), s = [n, i, "n"];
  if (t.cellFormula) {
    e.l += 2;
    var o = w0(e, a - e.l, t);
    s[3] = Gr(o, null, n, t.supbooks, t);
  } else
    e.l = a;
  return s;
}
function uT(e, r, t) {
  var a = e.l + r, n = St(e);
  n.r = t["!row"];
  var i = Jr(e), s = [n, i, "str"];
  if (t.cellFormula) {
    e.l += 2;
    var o = w0(e, a - e.l, t);
    s[3] = Gr(o, null, n, t.supbooks, t);
  } else
    e.l = a;
  return s;
}
var lT = wn, cT = pi;
function fT(e, r) {
  return r == null && (r = te(4)), r.write_shift(4, e), r;
}
function dT(e, r) {
  var t = e.l + r, a = wn(e), n = Mc(e), i = Jr(e), s = Jr(e), o = Jr(e);
  e.l = t;
  var u = { rfx: a, relId: n, loc: i, display: o };
  return s && (u.Tooltip = s), u;
}
function hT(e, r) {
  var t = te(50 + 4 * (e[1].Target.length + (e[1].Tooltip || "").length));
  pi({ s: fr(e[0]), e: fr(e[0]) }, t), Oc("rId" + r, t);
  var a = e[1].Target.indexOf("#"), n = a == -1 ? "" : e[1].Target.slice(a + 1);
  return Lr(n || "", t), Lr(e[1].Tooltip || "", t), Lr("", t), t.slice(0, t.l);
}
function xT() {
}
function mT(e, r, t) {
  var a = e.l + r, n = uv(e), i = e.read_shift(1), s = [n];
  if (s[2] = i, t.cellFormula) {
    var o = N8(e, a - e.l, t);
    s[1] = o;
  } else
    e.l = a;
  return s;
}
function pT(e, r, t) {
  var a = e.l + r, n = wn(e), i = [n];
  if (t.cellFormula) {
    var s = V8(e, a - e.l, t);
    i[1] = s, e.l = a;
  } else
    e.l = a;
  return i;
}
function vT(e, r, t) {
  t == null && (t = te(18));
  var a = _0(e, r);
  t.write_shift(-4, e), t.write_shift(-4, e), t.write_shift(4, (a.width || 10) * 256), t.write_shift(
    4,
    0
    /*ixfe*/
  );
  var n = 0;
  return r.hidden && (n |= 1), typeof a.width == "number" && (n |= 2), r.level && (n |= r.level << 8), t.write_shift(2, n), t;
}
var d2 = ["left", "right", "top", "bottom", "header", "footer"];
function gT(e) {
  var r = {};
  return d2.forEach(function(t) {
    r[t] = Xr(e);
  }), r;
}
function yT(e, r) {
  return r == null && (r = te(6 * 8)), tn(e), d2.forEach(function(t) {
    dn(e[t], r);
  }), r;
}
function bT(e) {
  var r = e.read_shift(2);
  return e.l += 28, { RTL: r & 32 };
}
function wT(e, r, t) {
  t == null && (t = te(30));
  var a = 924;
  return (((r || {}).Views || [])[0] || {}).RTL && (a |= 32), t.write_shift(2, a), t.write_shift(4, 0), t.write_shift(4, 0), t.write_shift(4, 0), t.write_shift(1, 0), t.write_shift(1, 0), t.write_shift(2, 0), t.write_shift(2, 100), t.write_shift(2, 0), t.write_shift(2, 0), t.write_shift(2, 0), t.write_shift(4, 0), t;
}
function _T(e) {
  var r = te(24);
  return r.write_shift(4, 4), r.write_shift(4, 1), pi(e, r), r;
}
function $T(e, r) {
  return r == null && (r = te(16 * 4 + 2)), r.write_shift(2, e.password ? jc(e.password) : 0), r.write_shift(4, 1), [
    ["objects", !1],
    // fObjects
    ["scenarios", !1],
    // fScenarios
    ["formatCells", !0],
    // fFormatCells
    ["formatColumns", !0],
    // fFormatColumns
    ["formatRows", !0],
    // fFormatRows
    ["insertColumns", !0],
    // fInsertColumns
    ["insertRows", !0],
    // fInsertRows
    ["insertHyperlinks", !0],
    // fInsertHyperlinks
    ["deleteColumns", !0],
    // fDeleteColumns
    ["deleteRows", !0],
    // fDeleteRows
    ["selectLockedCells", !1],
    // fSelLockedCells
    ["sort", !0],
    // fSort
    ["autoFilter", !0],
    // fAutoFilter
    ["pivotTables", !0],
    // fPivotTables
    ["selectUnlockedCells", !1]
    // fSelUnlockedCells
  ].forEach(function(t) {
    t[1] ? r.write_shift(4, e[t[0]] != null && !e[t[0]] ? 1 : 0) : r.write_shift(4, e[t[0]] != null && e[t[0]] ? 0 : 1);
  }), r;
}
function DT() {
}
function ET() {
}
function kT(e, r, t, a, n, i, s) {
  if (!e)
    return e;
  var o = r || {};
  a || (a = { "!id": {} });
  var u = o.dense ? [] : {}, l, c = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } }, f = !1, h = !1, d, m, x, p, w, D, y, B, L, U = [];
  o.biff = 12, o["!row"] = 0;
  var k = 0, v = !1, b = [], A = {}, T = o.supbooks || /*::(*/
  n.supbooks || [[]];
  if (T.sharedf = A, T.arrayf = b, T.SheetNames = n.SheetNames || n.Sheets.map(function(ce) {
    return ce.name;
  }), !o.supbooks && (o.supbooks = T, n.Names))
    for (var C = 0; C < n.Names.length; ++C)
      T[0][C + 1] = n.Names[C];
  var I = [], Y = [], j = !1;
  fs[16] = { n: "BrtShortReal", f: f2 };
  var J;
  if (ma(e, function(V, ee, de) {
    if (!h)
      switch (de) {
        case 148:
          l = V;
          break;
        case 0:
          d = V, o.sheetRows && o.sheetRows <= d.r && (h = !0), B = gr(p = d.r), o["!row"] = d.r, (V.hidden || V.hpt || V.level != null) && (V.hpt && (V.hpx = li(V.hpt)), Y[V.r] = V);
          break;
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
        case 8:
        case 9:
        case 10:
        case 11:
        case 13:
        case 14:
        case 15:
        case 16:
        case 17:
        case 18:
        case 62:
          switch (m = { t: V[2] }, V[2]) {
            case "n":
              m.v = V[1];
              break;
            case "s":
              y = Hi[V[1]], m.v = y.t, m.r = y.r;
              break;
            case "b":
              m.v = !!V[1];
              break;
            case "e":
              m.v = V[1], o.cellText !== !1 && (m.w = pa[m.v]);
              break;
            case "str":
              m.t = "s", m.v = V[1];
              break;
            case "is":
              m.t = "s", m.v = V[1].t;
              break;
          }
          if ((x = s.CellXf[V[0].iStyleRef]) && u2(m, x.numFmtId, null, o, i, s), w = V[0].c == -1 ? w + 1 : V[0].c, o.dense ? (u[p] || (u[p] = []), u[p][w] = m) : u[or(w) + B] = m, o.cellFormula) {
            for (v = !1, k = 0; k < b.length; ++k) {
              var F = b[k];
              d.r >= F[0].s.r && d.r <= F[0].e.r && w >= F[0].s.c && w <= F[0].e.c && (m.F = Ce(F[0]), v = !0);
            }
            !v && V.length > 3 && (m.f = V[3]);
          }
          if (c.s.r > d.r && (c.s.r = d.r), c.s.c > w && (c.s.c = w), c.e.r < d.r && (c.e.r = d.r), c.e.c < w && (c.e.c = w), o.cellDates && x && m.t == "n" && pn(Ee[x.numFmtId])) {
            var H = Aa(m.v);
            H && (m.t = "d", m.v = new Date(H.y, H.m - 1, H.d, H.H, H.M, H.S, H.u));
          }
          J && (J.type == "XLDAPR" && (m.D = !0), J = void 0);
          break;
        case 1:
        case 12:
          if (!o.sheetStubs || f)
            break;
          m = { t: "z", v: void 0 }, w = V[0].c == -1 ? w + 1 : V[0].c, o.dense ? (u[p] || (u[p] = []), u[p][w] = m) : u[or(w) + B] = m, c.s.r > d.r && (c.s.r = d.r), c.s.c > w && (c.s.c = w), c.e.r < d.r && (c.e.r = d.r), c.e.c < w && (c.e.c = w), J && (J.type == "XLDAPR" && (m.D = !0), J = void 0);
          break;
        case 176:
          U.push(V);
          break;
        case 49:
          J = ((o.xlmeta || {}).Cell || [])[V - 1];
          break;
        case 494:
          var P = a["!id"][V.relId];
          for (P ? (V.Target = P.Target, V.loc && (V.Target += "#" + V.loc), V.Rel = P) : V.relId == "" && (V.Target = "#" + V.loc), p = V.rfx.s.r; p <= V.rfx.e.r; ++p)
            for (w = V.rfx.s.c; w <= V.rfx.e.c; ++w)
              o.dense ? (u[p] || (u[p] = []), u[p][w] || (u[p][w] = { t: "z", v: void 0 }), u[p][w].l = V) : (D = Te({ c: w, r: p }), u[D] || (u[D] = { t: "z", v: void 0 }), u[D].l = V);
          break;
        case 426:
          if (!o.cellFormula)
            break;
          b.push(V), L = o.dense ? u[p][w] : u[or(w) + B], L.f = Gr(V[1], c, { r: d.r, c: w }, T, o), L.F = Ce(V[0]);
          break;
        case 427:
          if (!o.cellFormula)
            break;
          A[Te(V[0].s)] = V[1], L = o.dense ? u[p][w] : u[or(w) + B], L.f = Gr(V[1], c, { r: d.r, c: w }, T, o);
          break;
        case 60:
          if (!o.cellStyles)
            break;
          for (; V.e >= V.s; )
            I[V.e--] = { width: V.w / 256, hidden: !!(V.flags & 1), level: V.level }, j || (j = !0, zc(V.w / 256)), Ma(I[V.e + 1]);
          break;
        case 161:
          u["!autofilter"] = { ref: Ce(V) };
          break;
        case 476:
          u["!margins"] = V;
          break;
        case 147:
          n.Sheets[t] || (n.Sheets[t] = {}), V.name && (n.Sheets[t].CodeName = V.name), (V.above || V.left) && (u["!outline"] = { above: V.above, left: V.left });
          break;
        case 137:
          n.Views || (n.Views = [{}]), n.Views[0] || (n.Views[0] = {}), V.RTL && (n.Views[0].RTL = !0);
          break;
        case 485:
          break;
        case 64:
        case 1053:
          break;
        case 151:
          break;
        case 152:
        case 175:
        case 644:
        case 625:
        case 562:
        case 396:
        case 1112:
        case 1146:
        case 471:
        case 1050:
        case 649:
        case 1105:
        case 589:
        case 607:
        case 564:
        case 1055:
        case 168:
        case 174:
        case 1180:
        case 499:
        case 507:
        case 550:
        case 171:
        case 167:
        case 1177:
        case 169:
        case 1181:
        case 551:
        case 552:
        case 661:
        case 639:
        case 478:
        case 537:
        case 477:
        case 536:
        case 1103:
        case 680:
        case 1104:
        case 1024:
        case 663:
        case 535:
        case 678:
        case 504:
        case 1043:
        case 428:
        case 170:
        case 3072:
        case 50:
        case 2070:
        case 1045:
          break;
        case 35:
          f = !0;
          break;
        case 36:
          f = !1;
          break;
        case 37:
          f = !0;
          break;
        case 38:
          f = !1;
          break;
        default:
          if (!ee.T) {
            if (!f || o.WTF)
              throw new Error("Unexpected record 0x" + de.toString(16));
          }
      }
  }, o), delete o.supbooks, delete o["!row"], !u["!ref"] && (c.s.r < 2e6 || l && (l.e.r > 0 || l.e.c > 0 || l.s.r > 0 || l.s.c > 0)) && (u["!ref"] = Ce(l || c)), o.sheetRows && u["!ref"]) {
    var W = Oe(u["!ref"]);
    o.sheetRows <= +W.e.r && (W.e.r = o.sheetRows - 1, W.e.r > c.e.r && (W.e.r = c.e.r), W.e.r < W.s.r && (W.s.r = W.e.r), W.e.c > c.e.c && (W.e.c = c.e.c), W.e.c < W.s.c && (W.s.c = W.e.c), u["!fullref"] = u["!ref"], u["!ref"] = Ce(W));
  }
  return U.length > 0 && (u["!merges"] = U), I.length > 0 && (u["!cols"] = I), Y.length > 0 && (u["!rows"] = Y), u;
}
function TT(e, r, t, a, n, i, s) {
  if (r.v === void 0)
    return !1;
  var o = "";
  switch (r.t) {
    case "b":
      o = r.v ? "1" : "0";
      break;
    case "d":
      r = tr(r), r.z = r.z || Ee[14], r.v = Ar(ur(r.v)), r.t = "n";
      break;
    case "n":
    case "e":
      o = "" + r.v;
      break;
    default:
      o = r.v;
      break;
  }
  var u = { r: t, c: a };
  switch (u.s = Ha(n.cellXfs, r, n), r.l && i["!links"].push([Te(u), r.l]), r.c && i["!comments"].push([Te(u), r.c]), r.t) {
    case "s":
    case "str":
      return n.bookSST ? (o = Zc(n.Strings, r.v, n.revStrings), u.t = "s", u.v = o, s ? se(e, 18, Gk(r, u)) : se(e, 7, jk(r, u))) : (u.t = "str", s ? se(e, 17, nT(r, u)) : se(e, 6, tT(r, u))), !0;
    case "n":
      return r.v == (r.v | 0) && r.v > -1e3 && r.v < 1e3 ? s ? se(e, 13, Qk(r, u)) : se(e, 2, Jk(r, u)) : s ? se(e, 16, Xk(r, u)) : se(e, 5, Yk(r, u)), !0;
    case "b":
      return u.t = "b", s ? se(e, 15, Lk(r, u)) : se(e, 4, Mk(r, u)), !0;
    case "e":
      return u.t = "e", s ? se(e, 14, Wk(r, u)) : se(e, 3, Uk(r, u)), !0;
  }
  return s ? se(e, 12, Bk(r, u)) : se(e, 1, Rk(r, u)), !0;
}
function ST(e, r, t, a) {
  var n = Oe(r["!ref"] || "A1"), i, s = "", o = [];
  se(
    e,
    145
    /* BrtBeginSheetData */
  );
  var u = Array.isArray(r), l = n.e.r;
  r["!rows"] && (l = Math.max(n.e.r, r["!rows"].length - 1));
  for (var c = n.s.r; c <= l; ++c) {
    s = gr(c), Ek(e, r, n, c);
    var f = !1;
    if (c <= n.e.r)
      for (var h = n.s.c; h <= n.e.c; ++h) {
        c === n.s.r && (o[h] = or(h)), i = o[h] + s;
        var d = u ? (r[c] || [])[h] : r[i];
        if (!d) {
          f = !1;
          continue;
        }
        f = TT(e, d, c, h, a, r, f);
      }
  }
  se(
    e,
    146
    /* BrtEndSheetData */
  );
}
function CT(e, r) {
  !r || !r["!merges"] || (se(e, 177, fT(r["!merges"].length)), r["!merges"].forEach(function(t) {
    se(e, 176, cT(t));
  }), se(
    e,
    178
    /* BrtEndMergeCells */
  ));
}
function FT(e, r) {
  !r || !r["!cols"] || (se(
    e,
    390
    /* BrtBeginColInfos */
  ), r["!cols"].forEach(function(t, a) {
    t && se(e, 60, vT(a, t));
  }), se(
    e,
    391
    /* BrtEndColInfos */
  ));
}
function AT(e, r) {
  !r || !r["!ref"] || (se(
    e,
    648
    /* BrtBeginCellIgnoreECs */
  ), se(e, 649, _T(Oe(r["!ref"]))), se(
    e,
    650
    /* BrtEndCellIgnoreECs */
  ));
}
function RT(e, r, t) {
  r["!links"].forEach(function(a) {
    if (a[1].Target) {
      var n = Ye(t, -1, a[1].Target.replace(/#.*$/, ""), Be.HLINK);
      se(e, 494, hT(a, n));
    }
  }), delete r["!links"];
}
function IT(e, r, t, a) {
  if (r["!comments"].length > 0) {
    var n = Ye(a, -1, "../drawings/vmlDrawing" + (t + 1) + ".vml", Be.VML);
    se(e, 551, Oc("rId" + n)), r["!legacy"] = n;
  }
}
function BT(e, r, t, a) {
  if (r["!autofilter"]) {
    var n = r["!autofilter"], i = typeof n.ref == "string" ? n.ref : Ce(n.ref);
    t.Workbook || (t.Workbook = { Sheets: [] }), t.Workbook.Names || (t.Workbook.Names = []);
    var s = t.Workbook.Names, o = tt(i);
    o.s.r == o.e.r && (o.e.r = tt(r["!ref"]).e.r, i = Ce(o));
    for (var u = 0; u < s.length; ++u) {
      var l = s[u];
      if (l.Name == "_xlnm._FilterDatabase" && l.Sheet == a) {
        l.Ref = "'" + t.SheetNames[a] + "'!" + i;
        break;
      }
    }
    u == s.length && s.push({ Name: "_xlnm._FilterDatabase", Sheet: a, Ref: "'" + t.SheetNames[a] + "'!" + i }), se(e, 161, pi(Oe(i))), se(
      e,
      162
      /* BrtEndAFilter */
    );
  }
}
function PT(e, r, t) {
  se(
    e,
    133
    /* BrtBeginWsViews */
  ), se(e, 137, wT(r, t)), se(
    e,
    138
    /* BrtEndWsView */
  ), se(
    e,
    134
    /* BrtEndWsViews */
  );
}
function MT(e, r) {
  r["!protect"] && se(e, 535, $T(r["!protect"]));
}
function OT(e, r, t, a) {
  var n = ut(), i = t.SheetNames[e], s = t.Sheets[i] || {}, o = i;
  try {
    t && t.Workbook && (o = t.Workbook.Sheets[e].CodeName || o);
  } catch {
  }
  var u = Oe(s["!ref"] || "A1");
  if (u.e.c > 16383 || u.e.r > 1048575) {
    if (r.WTF)
      throw new Error("Range " + (s["!ref"] || "A1") + " exceeds format limit A1:XFD1048576");
    u.e.c = Math.min(u.e.c, 16383), u.e.r = Math.min(u.e.c, 1048575);
  }
  return s["!links"] = [], s["!comments"] = [], se(
    n,
    129
    /* BrtBeginSheet */
  ), (t.vbaraw || s["!outline"]) && se(n, 147, Fk(o, s["!outline"])), se(n, 148, Tk(u)), PT(n, s, t.Workbook), FT(n, s), ST(n, s, e, r), MT(n, s), BT(n, s, t, e), CT(n, s), RT(n, s, a), s["!margins"] && se(n, 476, yT(s["!margins"])), (!r || r.ignoreEC || r.ignoreEC == null) && AT(n, s), IT(n, s, e, a), se(
    n,
    130
    /* BrtEndSheet */
  ), n.end();
}
function LT(e) {
  var r = [], t = e.match(/^<c:numCache>/), a;
  (e.match(/<c:pt idx="(\d*)">(.*?)<\/c:pt>/mg) || []).forEach(function(i) {
    var s = i.match(/<c:pt idx="(\d*?)"><c:v>(.*)<\/c:v><\/c:pt>/);
    s && (r[+s[1]] = t ? +s[2] : s[2]);
  });
  var n = We((e.match(/<c:formatCode>([\s\S]*?)<\/c:formatCode>/) || ["", "General"])[1]);
  return (e.match(/<c:f>(.*?)<\/c:f>/mg) || []).forEach(function(i) {
    a = i.replace(/<.*?>/g, "");
  }), [r, n, a];
}
function NT(e, r, t, a, n, i) {
  var s = i || { "!type": "chart" };
  if (!e)
    return i;
  var o = 0, u = 0, l = "A", c = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } };
  return (e.match(/<c:numCache>[\s\S]*?<\/c:numCache>/gm) || []).forEach(function(f) {
    var h = LT(f);
    c.s.r = c.s.c = 0, c.e.c = o, l = or(o), h[0].forEach(function(d, m) {
      s[l + gr(m)] = { t: "n", v: d, z: h[1] }, u = m;
    }), c.e.r < u && (c.e.r = u), ++o;
  }), o > 0 && (s["!ref"] = Ce(c)), s;
}
function UT(e, r, t, a, n) {
  if (!e)
    return e;
  a || (a = { "!id": {} });
  var i = { "!type": "chart", "!drawel": null, "!rel": "" }, s, o = e.match(l2);
  return o && Jc(o[0], i, n, t), (s = e.match(/drawing r:id="(.*?)"/)) && (i["!rel"] = s[1]), a["!id"][i["!rel"]] && (i["!drawel"] = a["!id"][i["!rel"]]), i;
}
function VT(e, r) {
  e.l += 10;
  var t = Jr(e);
  return { name: t };
}
function WT(e, r, t, a, n) {
  if (!e)
    return e;
  a || (a = { "!id": {} });
  var i = { "!type": "chart", "!drawel": null, "!rel": "" }, s = !1;
  return ma(e, function(u, l, c) {
    switch (c) {
      case 550:
        i["!rel"] = u;
        break;
      case 651:
        n.Sheets[t] || (n.Sheets[t] = {}), u.name && (n.Sheets[t].CodeName = u.name);
        break;
      case 562:
      case 652:
      case 669:
      case 679:
      case 551:
      case 552:
      case 476:
      case 3072:
        break;
      case 35:
        s = !0;
        break;
      case 36:
        s = !1;
        break;
      case 37:
        break;
      case 38:
        break;
      default:
        if (!(l.T > 0)) {
          if (!(l.T < 0)) {
            if (!s || r.WTF)
              throw new Error("Unexpected record 0x" + c.toString(16));
          }
        }
    }
  }, r), a["!id"][i["!rel"]] && (i["!drawel"] = a["!id"][i["!rel"]]), i;
}
var qc = [
  ["allowRefreshQuery", !1, "bool"],
  ["autoCompressPictures", !0, "bool"],
  ["backupFile", !1, "bool"],
  ["checkCompatibility", !1, "bool"],
  ["CodeName", ""],
  ["date1904", !1, "bool"],
  ["defaultThemeVersion", 0, "int"],
  ["filterPrivacy", !1, "bool"],
  ["hidePivotFieldList", !1, "bool"],
  ["promptedSolutions", !1, "bool"],
  ["publishItems", !1, "bool"],
  ["refreshAllConnections", !1, "bool"],
  ["saveExternalLinkValues", !0, "bool"],
  ["showBorderUnselectedTables", !0, "bool"],
  ["showInkAnnotation", !0, "bool"],
  ["showObjects", "all"],
  ["showPivotChartFilter", !1, "bool"],
  ["updateLinks", "userSet"]
], HT = [
  ["activeTab", 0, "int"],
  ["autoFilterDateGrouping", !0, "bool"],
  ["firstSheet", 0, "int"],
  ["minimized", !1, "bool"],
  ["showHorizontalScroll", !0, "bool"],
  ["showSheetTabs", !0, "bool"],
  ["showVerticalScroll", !0, "bool"],
  ["tabRatio", 600, "int"],
  ["visibility", "visible"]
  //window{Height,Width}, {x,y}Window
], jT = [
  //['state', 'visible']
], zT = [
  ["calcCompleted", "true"],
  ["calcMode", "auto"],
  ["calcOnSave", "true"],
  ["concurrentCalc", "true"],
  ["fullCalcOnLoad", "false"],
  ["fullPrecision", "true"],
  ["iterate", "false"],
  ["iterateCount", "100"],
  ["iterateDelta", "0.001"],
  ["refMode", "A1"]
];
function yh(e, r) {
  for (var t = 0; t != e.length; ++t)
    for (var a = e[t], n = 0; n != r.length; ++n) {
      var i = r[n];
      if (a[i[0]] == null)
        a[i[0]] = i[1];
      else
        switch (i[2]) {
          case "bool":
            typeof a[i[0]] == "string" && (a[i[0]] = sr(a[i[0]]));
            break;
          case "int":
            typeof a[i[0]] == "string" && (a[i[0]] = parseInt(a[i[0]], 10));
            break;
        }
    }
}
function bh(e, r) {
  for (var t = 0; t != r.length; ++t) {
    var a = r[t];
    if (e[a[0]] == null)
      e[a[0]] = a[1];
    else
      switch (a[2]) {
        case "bool":
          typeof e[a[0]] == "string" && (e[a[0]] = sr(e[a[0]]));
          break;
        case "int":
          typeof e[a[0]] == "string" && (e[a[0]] = parseInt(e[a[0]], 10));
          break;
      }
  }
}
function h2(e) {
  bh(e.WBProps, qc), bh(e.CalcPr, zT), yh(e.WBView, HT), yh(e.Sheets, jT), Yn.date1904 = sr(e.WBProps.date1904);
}
function GT(e) {
  return !e.Workbook || !e.Workbook.WBProps ? "false" : sr(e.Workbook.WBProps.date1904) ? "true" : "false";
}
var KT = /* @__PURE__ */ "][*?/\\".split("");
function x2(e, r) {
  if (e.length > 31)
    throw new Error("Sheet names cannot exceed 31 chars");
  var t = !0;
  return KT.forEach(function(a) {
    if (e.indexOf(a) != -1)
      throw new Error("Sheet name cannot contain : \\ / ? * [ ]");
  }), t;
}
function YT(e, r, t) {
  e.forEach(function(a, n) {
    x2(a);
    for (var i = 0; i < n; ++i)
      if (a == e[i])
        throw new Error("Duplicate Sheet Name: " + a);
    if (t) {
      var s = r && r[n] && r[n].CodeName || a;
      if (s.charCodeAt(0) == 95 && s.length > 22)
        throw new Error("Bad Code Name: Worksheet" + s);
    }
  });
}
function m2(e) {
  if (!e || !e.SheetNames || !e.Sheets)
    throw new Error("Invalid Workbook");
  if (!e.SheetNames.length)
    throw new Error("Workbook is empty");
  var r = e.Workbook && e.Workbook.Sheets || [];
  YT(e.SheetNames, r, !!e.vbaraw);
  for (var t = 0; t < e.SheetNames.length; ++t)
    G8(e.Sheets[e.SheetNames[t]], e.SheetNames[t], t);
}
var XT = /<\w+:workbook/;
function ZT(e, r) {
  if (!e)
    throw new Error("Could not find file");
  var t = (
    /*::(*/
    { AppVersion: {}, WBProps: {}, WBView: [], Sheets: [], CalcPr: {}, Names: [], xmlns: "" }
  ), a = !1, n = "xmlns", i = {}, s = 0;
  if (e.replace(Qr, function(u, l) {
    var c = Se(u);
    switch (Xt(c[0])) {
      case "<?xml":
        break;
      case "<workbook":
        u.match(XT) && (n = "xmlns" + u.match(/<(\w+):/)[1]), t.xmlns = c[n];
        break;
      case "</workbook>":
        break;
      case "<fileVersion":
        delete c[0], t.AppVersion = c;
        break;
      case "<fileVersion/>":
      case "</fileVersion>":
        break;
      case "<fileSharing":
        break;
      case "<fileSharing/>":
        break;
      case "<workbookPr":
      case "<workbookPr/>":
        qc.forEach(function(f) {
          if (c[f[0]] != null)
            switch (f[2]) {
              case "bool":
                t.WBProps[f[0]] = sr(c[f[0]]);
                break;
              case "int":
                t.WBProps[f[0]] = parseInt(c[f[0]], 10);
                break;
              default:
                t.WBProps[f[0]] = c[f[0]];
            }
        }), c.codeName && (t.WBProps.CodeName = Qe(c.codeName));
        break;
      case "</workbookPr>":
        break;
      case "<workbookProtection":
        break;
      case "<workbookProtection/>":
        break;
      case "<bookViews":
      case "<bookViews>":
      case "</bookViews>":
        break;
      case "<workbookView":
      case "<workbookView/>":
        delete c[0], t.WBView.push(c);
        break;
      case "</workbookView>":
        break;
      case "<sheets":
      case "<sheets>":
      case "</sheets>":
        break;
      case "<sheet":
        switch (c.state) {
          case "hidden":
            c.Hidden = 1;
            break;
          case "veryHidden":
            c.Hidden = 2;
            break;
          default:
            c.Hidden = 0;
        }
        delete c.state, c.name = We(Qe(c.name)), delete c[0], t.Sheets.push(c);
        break;
      case "</sheet>":
        break;
      case "<functionGroups":
      case "<functionGroups/>":
        break;
      case "<functionGroup":
        break;
      case "<externalReferences":
      case "</externalReferences>":
      case "<externalReferences>":
        break;
      case "<externalReference":
        break;
      case "<definedNames/>":
        break;
      case "<definedNames>":
      case "<definedNames":
        a = !0;
        break;
      case "</definedNames>":
        a = !1;
        break;
      case "<definedName":
        i = {}, i.Name = Qe(c.name), c.comment && (i.Comment = c.comment), c.localSheetId && (i.Sheet = +c.localSheetId), sr(c.hidden || "0") && (i.Hidden = !0), s = l + u.length;
        break;
      case "</definedName>":
        i.Ref = We(Qe(e.slice(s, l))), t.Names.push(i);
        break;
      case "<definedName/>":
        break;
      case "<calcPr":
        delete c[0], t.CalcPr = c;
        break;
      case "<calcPr/>":
        delete c[0], t.CalcPr = c;
        break;
      case "</calcPr>":
        break;
      case "<oleSize":
        break;
      case "<customWorkbookViews>":
      case "</customWorkbookViews>":
      case "<customWorkbookViews":
        break;
      case "<customWorkbookView":
      case "</customWorkbookView>":
        break;
      case "<pivotCaches>":
      case "</pivotCaches>":
      case "<pivotCaches":
        break;
      case "<pivotCache":
        break;
      case "<smartTagPr":
      case "<smartTagPr/>":
        break;
      case "<smartTagTypes":
      case "<smartTagTypes>":
      case "</smartTagTypes>":
        break;
      case "<smartTagType":
        break;
      case "<webPublishing":
      case "<webPublishing/>":
        break;
      case "<fileRecoveryPr":
      case "<fileRecoveryPr/>":
        break;
      case "<webPublishObjects>":
      case "<webPublishObjects":
      case "</webPublishObjects>":
        break;
      case "<webPublishObject":
        break;
      case "<extLst":
      case "<extLst>":
      case "</extLst>":
      case "<extLst/>":
        break;
      case "<ext":
        a = !0;
        break;
      case "</ext>":
        a = !1;
        break;
      case "<ArchID":
        break;
      case "<AlternateContent":
      case "<AlternateContent>":
        a = !0;
        break;
      case "</AlternateContent>":
        a = !1;
        break;
      case "<revisionPtr":
        break;
      default:
        if (!a && r.WTF)
          throw new Error("unrecognized " + c[0] + " in workbook");
    }
    return u;
  }), vn.indexOf(t.xmlns) === -1)
    throw new Error("Unknown Namespace: " + t.xmlns);
  return h2(t), t;
}
function p2(e) {
  var r = [$r];
  r[r.length] = he("workbook", null, {
    xmlns: vn[0],
    //'xmlns:mx': XMLNS.mx,
    //'xmlns:s': XMLNS_main[0],
    "xmlns:r": Fr.r
  });
  var t = e.Workbook && (e.Workbook.Names || []).length > 0, a = { codeName: "ThisWorkbook" };
  e.Workbook && e.Workbook.WBProps && (qc.forEach(function(o) {
    e.Workbook.WBProps[o[0]] != null && e.Workbook.WBProps[o[0]] != o[1] && (a[o[0]] = e.Workbook.WBProps[o[0]]);
  }), e.Workbook.WBProps.CodeName && (a.codeName = e.Workbook.WBProps.CodeName, delete a.CodeName)), r[r.length] = he("workbookPr", null, a);
  var n = e.Workbook && e.Workbook.Sheets || [], i = 0;
  if (n && n[0] && n[0].Hidden) {
    for (r[r.length] = "<bookViews>", i = 0; i != e.SheetNames.length && !(!n[i] || !n[i].Hidden); ++i)
      ;
    i == e.SheetNames.length && (i = 0), r[r.length] = '<workbookView firstSheet="' + i + '" activeTab="' + i + '"/>', r[r.length] = "</bookViews>";
  }
  for (r[r.length] = "<sheets>", i = 0; i != e.SheetNames.length; ++i) {
    var s = { name: Xe(e.SheetNames[i].slice(0, 31)) };
    if (s.sheetId = "" + (i + 1), s["r:id"] = "rId" + (i + 1), n[i])
      switch (n[i].Hidden) {
        case 1:
          s.state = "hidden";
          break;
        case 2:
          s.state = "veryHidden";
          break;
      }
    r[r.length] = he("sheet", null, s);
  }
  return r[r.length] = "</sheets>", t && (r[r.length] = "<definedNames>", e.Workbook && e.Workbook.Names && e.Workbook.Names.forEach(function(o) {
    var u = { name: o.Name };
    o.Comment && (u.comment = o.Comment), o.Sheet != null && (u.localSheetId = "" + o.Sheet), o.Hidden && (u.hidden = "1"), o.Ref && (r[r.length] = he("definedName", Xe(o.Ref), u));
  }), r[r.length] = "</definedNames>"), r.length > 2 && (r[r.length] = "</workbook>", r[1] = r[1].replace("/>", ">")), r.join("");
}
function JT(e, r) {
  var t = {};
  return t.Hidden = e.read_shift(4), t.iTabID = e.read_shift(4), t.strRelID = bl(e), t.name = Jr(e), t;
}
function qT(e, r) {
  return r || (r = te(127)), r.write_shift(4, e.Hidden), r.write_shift(4, e.iTabID), Oc(e.strRelID, r), Lr(e.name.slice(0, 31), r), r.length > r.l ? r.slice(0, r.l) : r;
}
function QT(e, r) {
  var t = {}, a = e.read_shift(4);
  t.defaultThemeVersion = e.read_shift(4);
  var n = r > 8 ? Jr(e) : "";
  return n.length > 0 && (t.CodeName = n), t.autoCompressPictures = !!(a & 65536), t.backupFile = !!(a & 64), t.checkCompatibility = !!(a & 4096), t.date1904 = !!(a & 1), t.filterPrivacy = !!(a & 8), t.hidePivotFieldList = !!(a & 1024), t.promptedSolutions = !!(a & 16), t.publishItems = !!(a & 2048), t.refreshAllConnections = !!(a & 262144), t.saveExternalLinkValues = !!(a & 128), t.showBorderUnselectedTables = !!(a & 4), t.showInkAnnotation = !!(a & 32), t.showObjects = ["all", "placeholders", "none"][a >> 13 & 3], t.showPivotChartFilter = !!(a & 32768), t.updateLinks = ["userSet", "never", "always"][a >> 8 & 3], t;
}
function eS(e, r) {
  r || (r = te(72));
  var t = 0;
  return e && e.filterPrivacy && (t |= 8), r.write_shift(4, t), r.write_shift(4, 0), sv(e && e.CodeName || "ThisWorkbook", r), r.slice(0, r.l);
}
function rS(e, r) {
  var t = {};
  return e.read_shift(4), t.ArchID = e.read_shift(4), e.l += r - 8, t;
}
function tS(e, r, t) {
  var a = e.l + r;
  e.l += 4, e.l += 1;
  var n = e.read_shift(4), i = I_(e), s = U8(e, 0, t), o = Mc(e);
  e.l = a;
  var u = { Name: i, Ptg: s };
  return n < 268435455 && (u.Sheet = n), o && (u.Comment = o), u;
}
function aS(e, r) {
  var t = { AppVersion: {}, WBProps: {}, WBView: [], Sheets: [], CalcPr: {}, xmlns: "" }, a = [], n = !1;
  r || (r = {}), r.biff = 12;
  var i = [], s = [[]];
  return s.SheetNames = [], s.XTI = [], fs[16] = { n: "BrtFRTArchID$", f: rS }, ma(e, function(u, l, c) {
    switch (c) {
      case 156:
        s.SheetNames.push(u.name), t.Sheets.push(u);
        break;
      case 153:
        t.WBProps = u;
        break;
      case 39:
        u.Sheet != null && (r.SID = u.Sheet), u.Ref = Gr(u.Ptg, null, null, s, r), delete r.SID, delete u.Ptg, i.push(u);
        break;
      case 1036:
        break;
      case 357:
      case 358:
      case 355:
      case 667:
        s[0].length ? s.push([c, u]) : s[0] = [c, u], s[s.length - 1].XTI = [];
        break;
      case 362:
        s.length === 0 && (s[0] = [], s[0].XTI = []), s[s.length - 1].XTI = s[s.length - 1].XTI.concat(u), s.XTI = s.XTI.concat(u);
        break;
      case 361:
        break;
      case 2071:
      case 158:
      case 143:
      case 664:
      case 353:
        break;
      case 3072:
      case 3073:
      case 534:
      case 677:
      case 157:
      case 610:
      case 2050:
      case 155:
      case 548:
      case 676:
      case 128:
      case 665:
      case 2128:
      case 2125:
      case 549:
      case 2053:
      case 596:
      case 2076:
      case 2075:
      case 2082:
      case 397:
      case 154:
      case 1117:
      case 553:
      case 2091:
        break;
      case 35:
        a.push(c), n = !0;
        break;
      case 36:
        a.pop(), n = !1;
        break;
      case 37:
        a.push(c), n = !0;
        break;
      case 38:
        a.pop(), n = !1;
        break;
      case 16:
        break;
      default:
        if (!l.T) {
          if (!n || r.WTF && a[a.length - 1] != 37 && a[a.length - 1] != 35)
            throw new Error("Unexpected record 0x" + c.toString(16));
        }
    }
  }, r), h2(t), t.Names = i, t.supbooks = s, t;
}
function nS(e, r) {
  se(
    e,
    143
    /* BrtBeginBundleShs */
  );
  for (var t = 0; t != r.SheetNames.length; ++t) {
    var a = r.Workbook && r.Workbook.Sheets && r.Workbook.Sheets[t] && r.Workbook.Sheets[t].Hidden || 0, n = { Hidden: a, iTabID: t + 1, strRelID: "rId" + (t + 1), name: r.SheetNames[t] };
    se(e, 156, qT(n));
  }
  se(
    e,
    144
    /* BrtEndBundleShs */
  );
}
function iS(e, r) {
  r || (r = te(127));
  for (var t = 0; t != 4; ++t)
    r.write_shift(4, 0);
  return Lr("SheetJS", r), Lr(es.version, r), Lr(es.version, r), Lr("7262", r), r.length > r.l ? r.slice(0, r.l) : r;
}
function sS(e, r) {
  r || (r = te(29)), r.write_shift(-4, 0), r.write_shift(-4, 460), r.write_shift(4, 28800), r.write_shift(4, 17600), r.write_shift(4, 500), r.write_shift(4, e), r.write_shift(4, e);
  var t = 120;
  return r.write_shift(1, t), r.length > r.l ? r.slice(0, r.l) : r;
}
function oS(e, r) {
  if (!(!r.Workbook || !r.Workbook.Sheets)) {
    for (var t = r.Workbook.Sheets, a = 0, n = -1, i = -1; a < t.length; ++a)
      !t[a] || !t[a].Hidden && n == -1 ? n = a : t[a].Hidden == 1 && i == -1 && (i = a);
    i > n || (se(
      e,
      135
      /* BrtBeginBookViews */
    ), se(e, 158, sS(n)), se(
      e,
      136
      /* BrtEndBookViews */
    ));
  }
}
function uS(e, r) {
  var t = ut();
  return se(
    t,
    131
    /* BrtBeginBook */
  ), se(t, 128, iS()), se(t, 153, eS(e.Workbook && e.Workbook.WBProps || null)), oS(t, e), nS(t, e), se(
    t,
    132
    /* BrtEndBook */
  ), t.end();
}
function lS(e, r, t) {
  return r.slice(-4) === ".bin" ? aS(e, t) : ZT(e, t);
}
function cS(e, r, t, a, n, i, s, o) {
  return r.slice(-4) === ".bin" ? kT(e, a, t, n, i, s, o) : ak(e, a, t, n, i, s, o);
}
function fS(e, r, t, a, n, i, s, o) {
  return r.slice(-4) === ".bin" ? WT(e, a, t, n, i) : UT(e, a, t, n, i);
}
function dS(e, r, t, a, n, i, s, o) {
  return r.slice(-4) === ".bin" ? m7() : p7();
}
function hS(e, r, t, a, n, i, s, o) {
  return r.slice(-4) === ".bin" ? h7() : x7();
}
function xS(e, r, t, a) {
  return r.slice(-4) === ".bin" ? cE(e, t, a) : qD(e, t, a);
}
function mS(e, r, t) {
  return Xv(e, t);
}
function pS(e, r, t) {
  return r.slice(-4) === ".bin" ? vD(e, t) : xD(e, t);
}
function vS(e, r, t) {
  return r.slice(-4) === ".bin" ? u7(e, t) : QE(e, t);
}
function gS(e, r, t) {
  return r.slice(-4) === ".bin" ? ZE(e) : YE(e);
}
function yS(e, r, t, a) {
  return t.slice(-4) === ".bin" ? JE(e, r, t, a) : void 0;
}
function bS(e, r, t) {
  return r.slice(-4) === ".bin" ? zE(e, r, t) : KE(e, r, t);
}
function wS(e, r, t) {
  return (r.slice(-4) === ".bin" ? uS : p2)(e);
}
function _S(e, r, t, a, n) {
  return (r.slice(-4) === ".bin" ? OT : c2)(e, t, a, n);
}
function $S(e, r, t) {
  return (r.slice(-4) === ".bin" ? bE : Kv)(e, t);
}
function DS(e, r, t) {
  return (r.slice(-4) === ".bin" ? bD : Nv)(e, t);
}
function ES(e, r, t) {
  return (r.slice(-4) === ".bin" ? l7 : qv)(e);
}
function kS(e) {
  return (e.slice(-4) === ".bin" ? GE : Zv)();
}
var v2 = /([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g, g2 = /([\w:]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;
function Ct(e, r) {
  var t = e.split(/\s+/), a = [];
  if (a[0] = t[0], t.length === 1)
    return a;
  var n = e.match(v2), i, s, o, u;
  if (n)
    for (u = 0; u != n.length; ++u)
      i = n[u].match(g2), (s = i[1].indexOf(":")) === -1 ? a[i[1]] = i[2].slice(1, i[2].length - 1) : (i[1].slice(0, 6) === "xmlns:" ? o = "xmlns" + i[1].slice(6) : o = i[1].slice(s + 1), a[o] = i[2].slice(1, i[2].length - 1));
  return a;
}
function TS(e) {
  var r = e.split(/\s+/), t = {};
  if (r.length === 1)
    return t;
  var a = e.match(v2), n, i, s, o;
  if (a)
    for (o = 0; o != a.length; ++o)
      n = a[o].match(g2), (i = n[1].indexOf(":")) === -1 ? t[n[1]] = n[2].slice(1, n[2].length - 1) : (n[1].slice(0, 6) === "xmlns:" ? s = "xmlns" + n[1].slice(6) : s = n[1].slice(i + 1), t[s] = n[2].slice(1, n[2].length - 1));
  return t;
}
var zi;
function SS(e, r) {
  var t = zi[e] || We(e);
  return t === "General" ? cn(r) : pt(t, r);
}
function CS(e, r, t, a) {
  var n = a;
  switch ((t[0].match(/dt:dt="([\w.]+)"/) || ["", ""])[1]) {
    case "boolean":
      n = sr(a);
      break;
    case "i2":
    case "int":
      n = parseInt(a, 10);
      break;
    case "r4":
    case "float":
      n = parseFloat(a);
      break;
    case "date":
    case "dateTime.tz":
      n = ur(a);
      break;
    case "i8":
    case "string":
    case "fixed":
    case "uuid":
    case "bin.base64":
      break;
    default:
      throw new Error("bad custprop:" + t[0]);
  }
  e[We(r)] = n;
}
function FS(e, r, t) {
  if (e.t !== "z") {
    if (!t || t.cellText !== !1)
      try {
        e.t === "e" ? e.w = e.w || pa[e.v] : r === "General" ? e.t === "n" ? (e.v | 0) === e.v ? e.w = e.v.toString(10) : e.w = ts(e.v) : e.w = cn(e.v) : e.w = SS(r || "General", e.v);
      } catch (i) {
        if (t.WTF)
          throw i;
      }
    try {
      var a = zi[r] || r || "General";
      if (t.cellNF && (e.z = a), t.cellDates && e.t == "n" && pn(a)) {
        var n = Aa(e.v);
        n && (e.t = "d", e.v = new Date(n.y, n.m - 1, n.d, n.H, n.M, n.S, n.u));
      }
    } catch (i) {
      if (t.WTF)
        throw i;
    }
  }
}
function AS(e, r, t) {
  if (t.cellStyles && r.Interior) {
    var a = r.Interior;
    a.Pattern && (a.patternType = jD[a.Pattern] || a.Pattern);
  }
  e[r.ID] = r;
}
function RS(e, r, t, a, n, i, s, o, u, l) {
  var c = "General", f = a.StyleID, h = {};
  l = l || {};
  var d = [], m = 0;
  for (f === void 0 && o && (f = o.StyleID), f === void 0 && s && (f = s.StyleID); i[f] !== void 0 && (i[f].nf && (c = i[f].nf), i[f].Interior && d.push(i[f].Interior), !!i[f].Parent); )
    f = i[f].Parent;
  switch (t.Type) {
    case "Boolean":
      a.t = "b", a.v = sr(e);
      break;
    case "String":
      a.t = "s", a.r = Od(We(e)), a.v = e.indexOf("<") > -1 ? We(r || e).replace(/<.*?>/g, "") : a.r;
      break;
    case "DateTime":
      e.slice(-1) != "Z" && (e += "Z"), a.v = (ur(e) - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1e3), a.v !== a.v ? a.v = We(e) : a.v < 60 && (a.v = a.v - 1), (!c || c == "General") && (c = "yyyy-mm-dd");
    case "Number":
      a.v === void 0 && (a.v = +e), a.t || (a.t = "n");
      break;
    case "Error":
      a.t = "e", a.v = fv[e], l.cellText !== !1 && (a.w = e);
      break;
    default:
      e == "" && r == "" ? a.t = "z" : (a.t = "s", a.v = Od(r || e));
      break;
  }
  if (FS(a, c, l), l.cellFormula !== !1)
    if (a.Formula) {
      var x = We(a.Formula);
      x.charCodeAt(0) == 61 && (x = x.slice(1)), a.f = Kn(x, n), delete a.Formula, a.ArrayRange == "RC" ? a.F = Kn("RC:RC", n) : a.ArrayRange && (a.F = Kn(a.ArrayRange, n), u.push([Oe(a.F), a.F]));
    } else
      for (m = 0; m < u.length; ++m)
        n.r >= u[m][0].s.r && n.r <= u[m][0].e.r && n.c >= u[m][0].s.c && n.c <= u[m][0].e.c && (a.F = u[m][1]);
  l.cellStyles && (d.forEach(function(p) {
    !h.patternType && p.patternType && (h.patternType = p.patternType);
  }), a.s = h), a.StyleID !== void 0 && (a.ixfe = a.StyleID);
}
function IS(e) {
  e.t = e.v || "", e.t = e.t.replace(/\r\n/g, `
`).replace(/\r/g, `
`), e.v = e.w = e.ixfe = void 0;
}
function gu(e, r) {
  var t = r || {};
  hi();
  var a = Mn(kc(e));
  (t.type == "binary" || t.type == "array" || t.type == "base64") && (typeof Ue < "u" ? a = Ue.utils.decode(65001, No(a)) : a = Qe(a));
  var n = a.slice(0, 1024).toLowerCase(), i = !1;
  if (n = n.replace(/".*?"/g, ""), (n.indexOf(">") & 1023) > Math.min(n.indexOf(",") & 1023, n.indexOf(";") & 1023)) {
    var s = tr(t);
    return s.type = "string", ui.to_workbook(a, s);
  }
  if (n.indexOf("<?xml") == -1 && ["html", "table", "head", "meta", "script", "style", "div"].forEach(function(Me) {
    n.indexOf("<" + Me) >= 0 && (i = !0);
  }), i)
    return mC(a, t);
  zi = {
    "General Number": "General",
    "General Date": Ee[22],
    "Long Date": "dddd, mmmm dd, yyyy",
    "Medium Date": Ee[15],
    "Short Date": Ee[14],
    "Long Time": Ee[19],
    "Medium Time": Ee[18],
    "Short Time": Ee[20],
    Currency: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    Fixed: Ee[2],
    Standard: Ee[4],
    Percent: Ee[10],
    Scientific: Ee[11],
    "Yes/No": '"Yes";"Yes";"No";@',
    "True/False": '"True";"True";"False";@',
    "On/Off": '"Yes";"Yes";"No";@'
  };
  var o, u = [], l, c = {}, f = [], h = t.dense ? [] : {}, d = "", m = {}, x = {}, p = Ct('<Data ss:Type="String">'), w = 0, D = 0, y = 0, B = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } }, L = {}, U = {}, k = "", v = 0, b = [], A = {}, T = {}, C = 0, I = [], Y = [], j = {}, J = [], W, ce = !1, V = [], ee = [], de = {}, F = 0, H = 0, P = { Sheets: [], WBProps: { date1904: !1 } }, N = {};
  is.lastIndex = 0, a = a.replace(/<!--([\s\S]*?)-->/mg, "");
  for (var X = ""; o = is.exec(a); )
    switch (o[3] = (X = o[3]).toLowerCase()) {
      case "data":
        if (X == "data") {
          if (o[1] === "/") {
            if ((l = u.pop())[0] !== o[3])
              throw new Error("Bad state: " + l.join("|"));
          } else
            o[0].charAt(o[0].length - 2) !== "/" && u.push([o[3], !0]);
          break;
        }
        if (u[u.length - 1][1])
          break;
        o[1] === "/" ? RS(a.slice(w, o.index), k, p, u[u.length - 1][0] == /*"Comment"*/
        "comment" ? j : m, { c: D, r: y }, L, J[D], x, V, t) : (k = "", p = Ct(o[0]), w = o.index + o[0].length);
        break;
      case "cell":
        if (o[1] === "/")
          if (Y.length > 0 && (m.c = Y), (!t.sheetRows || t.sheetRows > y) && m.v !== void 0 && (t.dense ? (h[y] || (h[y] = []), h[y][D] = m) : h[or(D) + gr(y)] = m), m.HRef && (m.l = { Target: We(m.HRef) }, m.HRefScreenTip && (m.l.Tooltip = m.HRefScreenTip), delete m.HRef, delete m.HRefScreenTip), (m.MergeAcross || m.MergeDown) && (F = D + (parseInt(m.MergeAcross, 10) | 0), H = y + (parseInt(m.MergeDown, 10) | 0), b.push({ s: { c: D, r: y }, e: { c: F, r: H } })), !t.sheetStubs)
            m.MergeAcross ? D = F + 1 : ++D;
          else if (m.MergeAcross || m.MergeDown) {
            for (var ae = D; ae <= F; ++ae)
              for (var ie = y; ie <= H; ++ie)
                (ae > D || ie > y) && (t.dense ? (h[ie] || (h[ie] = []), h[ie][ae] = { t: "z" }) : h[or(ae) + gr(ie)] = { t: "z" });
            D = F + 1;
          } else
            ++D;
        else
          m = TS(o[0]), m.Index && (D = +m.Index - 1), D < B.s.c && (B.s.c = D), D > B.e.c && (B.e.c = D), o[0].slice(-2) === "/>" && ++D, Y = [];
        break;
      case "row":
        o[1] === "/" || o[0].slice(-2) === "/>" ? (y < B.s.r && (B.s.r = y), y > B.e.r && (B.e.r = y), o[0].slice(-2) === "/>" && (x = Ct(o[0]), x.Index && (y = +x.Index - 1)), D = 0, ++y) : (x = Ct(o[0]), x.Index && (y = +x.Index - 1), de = {}, (x.AutoFitHeight == "0" || x.Height) && (de.hpx = parseInt(x.Height, 10), de.hpt = cs(de.hpx), ee[y] = de), x.Hidden == "1" && (de.hidden = !0, ee[y] = de));
        break;
      case "worksheet":
        if (o[1] === "/") {
          if ((l = u.pop())[0] !== o[3])
            throw new Error("Bad state: " + l.join("|"));
          f.push(d), B.s.r <= B.e.r && B.s.c <= B.e.c && (h["!ref"] = Ce(B), t.sheetRows && t.sheetRows <= B.e.r && (h["!fullref"] = h["!ref"], B.e.r = t.sheetRows - 1, h["!ref"] = Ce(B))), b.length && (h["!merges"] = b), J.length > 0 && (h["!cols"] = J), ee.length > 0 && (h["!rows"] = ee), c[d] = h;
        } else
          B = { s: { r: 2e6, c: 2e6 }, e: { r: 0, c: 0 } }, y = D = 0, u.push([o[3], !1]), l = Ct(o[0]), d = We(l.Name), h = t.dense ? [] : {}, b = [], V = [], ee = [], N = { name: d, Hidden: 0 }, P.Sheets.push(N);
        break;
      case "table":
        if (o[1] === "/") {
          if ((l = u.pop())[0] !== o[3])
            throw new Error("Bad state: " + l.join("|"));
        } else {
          if (o[0].slice(-2) == "/>")
            break;
          u.push([o[3], !1]), J = [], ce = !1;
        }
        break;
      case "style":
        o[1] === "/" ? AS(L, U, t) : U = Ct(o[0]);
        break;
      case "numberformat":
        U.nf = We(Ct(o[0]).Format || "General"), zi[U.nf] && (U.nf = zi[U.nf]);
        for (var q = 0; q != 392 && Ee[q] != U.nf; ++q)
          ;
        if (q == 392) {
          for (q = 57; q != 392; ++q)
            if (Ee[q] == null) {
              Gt(U.nf, q);
              break;
            }
        }
        break;
      case "column":
        if (u[u.length - 1][0] !== /*'Table'*/
        "table")
          break;
        if (W = Ct(o[0]), W.Hidden && (W.hidden = !0, delete W.Hidden), W.Width && (W.wpx = parseInt(W.Width, 10)), !ce && W.wpx > 10) {
          ce = !0, Kr = zv;
          for (var re = 0; re < J.length; ++re)
            J[re] && Ma(J[re]);
        }
        ce && Ma(W), J[W.Index - 1 || J.length] = W;
        for (var ve = 0; ve < +W.Span; ++ve)
          J[J.length] = tr(W);
        break;
      case "namedrange":
        if (o[1] === "/")
          break;
        P.Names || (P.Names = []);
        var M = Se(o[0]), _e = {
          Name: M.Name,
          Ref: Kn(M.RefersTo.slice(1), { r: 0, c: 0 })
        };
        P.Sheets.length > 0 && (_e.Sheet = P.Sheets.length - 1), P.Names.push(_e);
        break;
      case "namedcell":
        break;
      case "b":
        break;
      case "i":
        break;
      case "u":
        break;
      case "s":
        break;
      case "em":
        break;
      case "h2":
        break;
      case "h3":
        break;
      case "sub":
        break;
      case "sup":
        break;
      case "span":
        break;
      case "alignment":
        break;
      case "borders":
        break;
      case "border":
        break;
      case "font":
        if (o[0].slice(-2) === "/>")
          break;
        o[1] === "/" ? k += a.slice(v, o.index) : v = o.index + o[0].length;
        break;
      case "interior":
        if (!t.cellStyles)
          break;
        U.Interior = Ct(o[0]);
        break;
      case "protection":
        break;
      case "author":
      case "title":
      case "description":
      case "created":
      case "keywords":
      case "subject":
      case "category":
      case "company":
      case "lastauthor":
      case "lastsaved":
      case "lastprinted":
      case "version":
      case "revision":
      case "totaltime":
      case "hyperlinkbase":
      case "manager":
      case "contentstatus":
      case "identifier":
      case "language":
      case "appname":
        if (o[0].slice(-2) === "/>")
          break;
        o[1] === "/" ? n6(A, X, a.slice(C, o.index)) : C = o.index + o[0].length;
        break;
      case "paragraphs":
        break;
      case "styles":
      case "workbook":
        if (o[1] === "/") {
          if ((l = u.pop())[0] !== o[3])
            throw new Error("Bad state: " + l.join("|"));
        } else
          u.push([o[3], !1]);
        break;
      case "comment":
        if (o[1] === "/") {
          if ((l = u.pop())[0] !== o[3])
            throw new Error("Bad state: " + l.join("|"));
          IS(j), Y.push(j);
        } else
          u.push([o[3], !1]), l = Ct(o[0]), j = { a: l.Author };
        break;
      case "autofilter":
        if (o[1] === "/") {
          if ((l = u.pop())[0] !== o[3])
            throw new Error("Bad state: " + l.join("|"));
        } else if (o[0].charAt(o[0].length - 2) !== "/") {
          var De = Ct(o[0]);
          h["!autofilter"] = { ref: Kn(De.Range).replace(/\$/g, "") }, u.push([o[3], !0]);
        }
        break;
      case "name":
        break;
      case "datavalidation":
        if (o[1] === "/") {
          if ((l = u.pop())[0] !== o[3])
            throw new Error("Bad state: " + l.join("|"));
        } else
          o[0].charAt(o[0].length - 2) !== "/" && u.push([o[3], !0]);
        break;
      case "pixelsperinch":
        break;
      case "componentoptions":
      case "documentproperties":
      case "customdocumentproperties":
      case "officedocumentsettings":
      case "pivottable":
      case "pivotcache":
      case "names":
      case "mapinfo":
      case "pagebreaks":
      case "querytable":
      case "sorting":
      case "schema":
      case "conditionalformatting":
      case "smarttagtype":
      case "smarttags":
      case "excelworkbook":
      case "workbookoptions":
      case "worksheetoptions":
        if (o[1] === "/") {
          if ((l = u.pop())[0] !== o[3])
            throw new Error("Bad state: " + l.join("|"));
        } else
          o[0].charAt(o[0].length - 2) !== "/" && u.push([o[3], !0]);
        break;
      case "null":
        break;
      default:
        if (u.length == 0 && o[3] == "document" || u.length == 0 && o[3] == "uof")
          return Eh(a, t);
        var $e = !0;
        switch (u[u.length - 1][0]) {
          case "officedocumentsettings":
            switch (o[3]) {
              case "allowpng":
                break;
              case "removepersonalinformation":
                break;
              case "downloadcomponents":
                break;
              case "locationofcomponents":
                break;
              case "colors":
                break;
              case "color":
                break;
              case "index":
                break;
              case "rgb":
                break;
              case "targetscreensize":
                break;
              case "readonlyrecommended":
                break;
              default:
                $e = !1;
            }
            break;
          case "componentoptions":
            switch (o[3]) {
              case "toolbar":
                break;
              case "hideofficelogo":
                break;
              case "spreadsheetautofit":
                break;
              case "label":
                break;
              case "caption":
                break;
              case "maxheight":
                break;
              case "maxwidth":
                break;
              case "nextsheetnumber":
                break;
              default:
                $e = !1;
            }
            break;
          case "excelworkbook":
            switch (o[3]) {
              case "date1904":
                P.WBProps.date1904 = !0;
                break;
              case "windowheight":
                break;
              case "windowwidth":
                break;
              case "windowtopx":
                break;
              case "windowtopy":
                break;
              case "tabratio":
                break;
              case "protectstructure":
                break;
              case "protectwindow":
                break;
              case "protectwindows":
                break;
              case "activesheet":
                break;
              case "displayinknotes":
                break;
              case "firstvisiblesheet":
                break;
              case "supbook":
                break;
              case "sheetname":
                break;
              case "sheetindex":
                break;
              case "sheetindexfirst":
                break;
              case "sheetindexlast":
                break;
              case "dll":
                break;
              case "acceptlabelsinformulas":
                break;
              case "donotsavelinkvalues":
                break;
              case "iteration":
                break;
              case "maxiterations":
                break;
              case "maxchange":
                break;
              case "path":
                break;
              case "xct":
                break;
              case "count":
                break;
              case "selectedsheets":
                break;
              case "calculation":
                break;
              case "uncalced":
                break;
              case "startupprompt":
                break;
              case "crn":
                break;
              case "externname":
                break;
              case "formula":
                break;
              case "colfirst":
                break;
              case "collast":
                break;
              case "wantadvise":
                break;
              case "boolean":
                break;
              case "error":
                break;
              case "text":
                break;
              case "ole":
                break;
              case "noautorecover":
                break;
              case "publishobjects":
                break;
              case "donotcalculatebeforesave":
                break;
              case "number":
                break;
              case "refmoder1c1":
                break;
              case "embedsavesmarttags":
                break;
              default:
                $e = !1;
            }
            break;
          case "workbookoptions":
            switch (o[3]) {
              case "owcversion":
                break;
              case "height":
                break;
              case "width":
                break;
              default:
                $e = !1;
            }
            break;
          case "worksheetoptions":
            switch (o[3]) {
              case "visible":
                if (o[0].slice(-2) !== "/>")
                  if (o[1] === "/")
                    switch (a.slice(C, o.index)) {
                      case "SheetHidden":
                        N.Hidden = 1;
                        break;
                      case "SheetVeryHidden":
                        N.Hidden = 2;
                        break;
                    }
                  else
                    C = o.index + o[0].length;
                break;
              case "header":
                h["!margins"] || tn(h["!margins"] = {}, "xlml"), isNaN(+Se(o[0]).Margin) || (h["!margins"].header = +Se(o[0]).Margin);
                break;
              case "footer":
                h["!margins"] || tn(h["!margins"] = {}, "xlml"), isNaN(+Se(o[0]).Margin) || (h["!margins"].footer = +Se(o[0]).Margin);
                break;
              case "pagemargins":
                var ge = Se(o[0]);
                h["!margins"] || tn(h["!margins"] = {}, "xlml"), isNaN(+ge.Top) || (h["!margins"].top = +ge.Top), isNaN(+ge.Left) || (h["!margins"].left = +ge.Left), isNaN(+ge.Right) || (h["!margins"].right = +ge.Right), isNaN(+ge.Bottom) || (h["!margins"].bottom = +ge.Bottom);
                break;
              case "displayrighttoleft":
                P.Views || (P.Views = []), P.Views[0] || (P.Views[0] = {}), P.Views[0].RTL = !0;
                break;
              case "freezepanes":
                break;
              case "frozennosplit":
                break;
              case "splithorizontal":
              case "splitvertical":
                break;
              case "donotdisplaygridlines":
                break;
              case "activerow":
                break;
              case "activecol":
                break;
              case "toprowbottompane":
                break;
              case "leftcolumnrightpane":
                break;
              case "unsynced":
                break;
              case "print":
                break;
              case "printerrors":
                break;
              case "panes":
                break;
              case "scale":
                break;
              case "pane":
                break;
              case "number":
                break;
              case "layout":
                break;
              case "pagesetup":
                break;
              case "selected":
                break;
              case "protectobjects":
                break;
              case "enableselection":
                break;
              case "protectscenarios":
                break;
              case "validprinterinfo":
                break;
              case "horizontalresolution":
                break;
              case "verticalresolution":
                break;
              case "numberofcopies":
                break;
              case "activepane":
                break;
              case "toprowvisible":
                break;
              case "leftcolumnvisible":
                break;
              case "fittopage":
                break;
              case "rangeselection":
                break;
              case "papersizeindex":
                break;
              case "pagelayoutzoom":
                break;
              case "pagebreakzoom":
                break;
              case "filteron":
                break;
              case "fitwidth":
                break;
              case "fitheight":
                break;
              case "commentslayout":
                break;
              case "zoom":
                break;
              case "lefttoright":
                break;
              case "gridlines":
                break;
              case "allowsort":
                break;
              case "allowfilter":
                break;
              case "allowinsertrows":
                break;
              case "allowdeleterows":
                break;
              case "allowinsertcols":
                break;
              case "allowdeletecols":
                break;
              case "allowinserthyperlinks":
                break;
              case "allowformatcells":
                break;
              case "allowsizecols":
                break;
              case "allowsizerows":
                break;
              case "nosummaryrowsbelowdetail":
                h["!outline"] || (h["!outline"] = {}), h["!outline"].above = !0;
                break;
              case "tabcolorindex":
                break;
              case "donotdisplayheadings":
                break;
              case "showpagelayoutzoom":
                break;
              case "nosummarycolumnsrightdetail":
                h["!outline"] || (h["!outline"] = {}), h["!outline"].left = !0;
                break;
              case "blackandwhite":
                break;
              case "donotdisplayzeros":
                break;
              case "displaypagebreak":
                break;
              case "rowcolheadings":
                break;
              case "donotdisplayoutline":
                break;
              case "noorientation":
                break;
              case "allowusepivottables":
                break;
              case "zeroheight":
                break;
              case "viewablerange":
                break;
              case "selection":
                break;
              case "protectcontents":
                break;
              default:
                $e = !1;
            }
            break;
          case "pivottable":
          case "pivotcache":
            switch (o[3]) {
              case "immediateitemsondrop":
                break;
              case "showpagemultipleitemlabel":
                break;
              case "compactrowindent":
                break;
              case "location":
                break;
              case "pivotfield":
                break;
              case "orientation":
                break;
              case "layoutform":
                break;
              case "layoutsubtotallocation":
                break;
              case "layoutcompactrow":
                break;
              case "position":
                break;
              case "pivotitem":
                break;
              case "datatype":
                break;
              case "datafield":
                break;
              case "sourcename":
                break;
              case "parentfield":
                break;
              case "ptlineitems":
                break;
              case "ptlineitem":
                break;
              case "countofsameitems":
                break;
              case "item":
                break;
              case "itemtype":
                break;
              case "ptsource":
                break;
              case "cacheindex":
                break;
              case "consolidationreference":
                break;
              case "filename":
                break;
              case "reference":
                break;
              case "nocolumngrand":
                break;
              case "norowgrand":
                break;
              case "blanklineafteritems":
                break;
              case "hidden":
                break;
              case "subtotal":
                break;
              case "basefield":
                break;
              case "mapchilditems":
                break;
              case "function":
                break;
              case "refreshonfileopen":
                break;
              case "printsettitles":
                break;
              case "mergelabels":
                break;
              case "defaultversion":
                break;
              case "refreshname":
                break;
              case "refreshdate":
                break;
              case "refreshdatecopy":
                break;
              case "versionlastrefresh":
                break;
              case "versionlastupdate":
                break;
              case "versionupdateablemin":
                break;
              case "versionrefreshablemin":
                break;
              case "calculation":
                break;
              default:
                $e = !1;
            }
            break;
          case "pagebreaks":
            switch (o[3]) {
              case "colbreaks":
                break;
              case "colbreak":
                break;
              case "rowbreaks":
                break;
              case "rowbreak":
                break;
              case "colstart":
                break;
              case "colend":
                break;
              case "rowend":
                break;
              default:
                $e = !1;
            }
            break;
          case "autofilter":
            switch (o[3]) {
              case "autofiltercolumn":
                break;
              case "autofiltercondition":
                break;
              case "autofilterand":
                break;
              case "autofilteror":
                break;
              default:
                $e = !1;
            }
            break;
          case "querytable":
            switch (o[3]) {
              case "id":
                break;
              case "autoformatfont":
                break;
              case "autoformatpattern":
                break;
              case "querysource":
                break;
              case "querytype":
                break;
              case "enableredirections":
                break;
              case "refreshedinxl9":
                break;
              case "urlstring":
                break;
              case "htmltables":
                break;
              case "connection":
                break;
              case "commandtext":
                break;
              case "refreshinfo":
                break;
              case "notitles":
                break;
              case "nextid":
                break;
              case "columninfo":
                break;
              case "overwritecells":
                break;
              case "donotpromptforfile":
                break;
              case "textwizardsettings":
                break;
              case "source":
                break;
              case "number":
                break;
              case "decimal":
                break;
              case "thousandseparator":
                break;
              case "trailingminusnumbers":
                break;
              case "formatsettings":
                break;
              case "fieldtype":
                break;
              case "delimiters":
                break;
              case "tab":
                break;
              case "comma":
                break;
              case "autoformatname":
                break;
              case "versionlastedit":
                break;
              case "versionlastrefresh":
                break;
              default:
                $e = !1;
            }
            break;
          case "datavalidation":
            switch (o[3]) {
              case "range":
                break;
              case "type":
                break;
              case "min":
                break;
              case "max":
                break;
              case "sort":
                break;
              case "descending":
                break;
              case "order":
                break;
              case "casesensitive":
                break;
              case "value":
                break;
              case "errorstyle":
                break;
              case "errormessage":
                break;
              case "errortitle":
                break;
              case "inputmessage":
                break;
              case "inputtitle":
                break;
              case "combohide":
                break;
              case "inputhide":
                break;
              case "condition":
                break;
              case "qualifier":
                break;
              case "useblank":
                break;
              case "value1":
                break;
              case "value2":
                break;
              case "format":
                break;
              case "cellrangelist":
                break;
              default:
                $e = !1;
            }
            break;
          case "sorting":
          case "conditionalformatting":
            switch (o[3]) {
              case "range":
                break;
              case "type":
                break;
              case "min":
                break;
              case "max":
                break;
              case "sort":
                break;
              case "descending":
                break;
              case "order":
                break;
              case "casesensitive":
                break;
              case "value":
                break;
              case "errorstyle":
                break;
              case "errormessage":
                break;
              case "errortitle":
                break;
              case "cellrangelist":
                break;
              case "inputmessage":
                break;
              case "inputtitle":
                break;
              case "combohide":
                break;
              case "inputhide":
                break;
              case "condition":
                break;
              case "qualifier":
                break;
              case "useblank":
                break;
              case "value1":
                break;
              case "value2":
                break;
              case "format":
                break;
              default:
                $e = !1;
            }
            break;
          case "mapinfo":
          case "schema":
          case "data":
            switch (o[3]) {
              case "map":
                break;
              case "entry":
                break;
              case "range":
                break;
              case "xpath":
                break;
              case "field":
                break;
              case "xsdtype":
                break;
              case "filteron":
                break;
              case "aggregate":
                break;
              case "elementtype":
                break;
              case "attributetype":
                break;
              case "schema":
              case "element":
              case "complextype":
              case "datatype":
              case "all":
              case "attribute":
              case "extends":
                break;
              case "row":
                break;
              default:
                $e = !1;
            }
            break;
          case "smarttags":
            break;
          default:
            $e = !1;
            break;
        }
        if ($e || o[3].match(/!\[CDATA/))
          break;
        if (!u[u.length - 1][1])
          throw "Unrecognized tag: " + o[3] + "|" + u.join("|");
        if (u[u.length - 1][0] === /*'CustomDocumentProperties'*/
        "customdocumentproperties") {
          if (o[0].slice(-2) === "/>")
            break;
          o[1] === "/" ? CS(T, X, I, a.slice(C, o.index)) : (I = o, C = o.index + o[0].length);
          break;
        }
        if (t.WTF)
          throw "Unrecognized tag: " + o[3] + "|" + u.join("|");
    }
  var fe = {};
  return !t.bookSheets && !t.bookProps && (fe.Sheets = c), fe.SheetNames = f, fe.Workbook = P, fe.SSF = tr(Ee), fe.Props = A, fe.Custprops = T, fe;
}
function Tl(e, r) {
  switch (rf(r = r || {}), r.type || "base64") {
    case "base64":
      return gu(mt(e), r);
    case "binary":
    case "buffer":
    case "file":
      return gu(e, r);
    case "array":
      return gu(Va(e), r);
  }
}
function BS(e, r) {
  var t = [];
  return e.Props && t.push(i6(e.Props, r)), e.Custprops && t.push(s6(e.Props, e.Custprops)), t.join("");
}
function PS() {
  return "";
}
function MS(e, r) {
  var t = ['<Style ss:ID="Default" ss:Name="Normal"><NumberFormat/></Style>'];
  return r.cellXfs.forEach(function(a, n) {
    var i = [];
    i.push(he("NumberFormat", null, { "ss:Format": Xe(Ee[a.numFmtId]) }));
    var s = (
      /*::(*/
      { "ss:ID": "s" + (21 + n) }
    );
    t.push(he("Style", i.join(""), s));
  }), he("Styles", t.join(""));
}
function y2(e) {
  return he("NamedRange", null, { "ss:Name": e.Name, "ss:RefersTo": "=" + Yc(e.Ref, { r: 0, c: 0 }) });
}
function OS(e) {
  if (!((e || {}).Workbook || {}).Names)
    return "";
  for (var r = e.Workbook.Names, t = [], a = 0; a < r.length; ++a) {
    var n = r[a];
    n.Sheet == null && (n.Name.match(/^_xlfn\./) || t.push(y2(n)));
  }
  return he("Names", t.join(""));
}
function LS(e, r, t, a) {
  if (!e || !((a || {}).Workbook || {}).Names)
    return "";
  for (var n = a.Workbook.Names, i = [], s = 0; s < n.length; ++s) {
    var o = n[s];
    o.Sheet == t && (o.Name.match(/^_xlfn\./) || i.push(y2(o)));
  }
  return i.join("");
}
function NS(e, r, t, a) {
  if (!e)
    return "";
  var n = [];
  if (e["!margins"] && (n.push("<PageSetup>"), e["!margins"].header && n.push(he("Header", null, { "x:Margin": e["!margins"].header })), e["!margins"].footer && n.push(he("Footer", null, { "x:Margin": e["!margins"].footer })), n.push(he("PageMargins", null, {
    "x:Bottom": e["!margins"].bottom || "0.75",
    "x:Left": e["!margins"].left || "0.7",
    "x:Right": e["!margins"].right || "0.7",
    "x:Top": e["!margins"].top || "0.75"
  })), n.push("</PageSetup>")), a && a.Workbook && a.Workbook.Sheets && a.Workbook.Sheets[t])
    if (a.Workbook.Sheets[t].Hidden)
      n.push(he("Visible", a.Workbook.Sheets[t].Hidden == 1 ? "SheetHidden" : "SheetVeryHidden", {}));
    else {
      for (var i = 0; i < t && !(a.Workbook.Sheets[i] && !a.Workbook.Sheets[i].Hidden); ++i)
        ;
      i == t && n.push("<Selected/>");
    }
  return ((((a || {}).Workbook || {}).Views || [])[0] || {}).RTL && n.push("<DisplayRightToLeft/>"), e["!protect"] && (n.push(Wr("ProtectContents", "True")), e["!protect"].objects && n.push(Wr("ProtectObjects", "True")), e["!protect"].scenarios && n.push(Wr("ProtectScenarios", "True")), e["!protect"].selectLockedCells != null && !e["!protect"].selectLockedCells ? n.push(Wr("EnableSelection", "NoSelection")) : e["!protect"].selectUnlockedCells != null && !e["!protect"].selectUnlockedCells && n.push(Wr("EnableSelection", "UnlockedCells")), [
    ["formatCells", "AllowFormatCells"],
    ["formatColumns", "AllowSizeCols"],
    ["formatRows", "AllowSizeRows"],
    ["insertColumns", "AllowInsertCols"],
    ["insertRows", "AllowInsertRows"],
    ["insertHyperlinks", "AllowInsertHyperlinks"],
    ["deleteColumns", "AllowDeleteCols"],
    ["deleteRows", "AllowDeleteRows"],
    ["sort", "AllowSort"],
    ["autoFilter", "AllowFilter"],
    ["pivotTables", "AllowUsePivotTables"]
  ].forEach(function(s) {
    e["!protect"][s[0]] && n.push("<" + s[1] + "/>");
  })), n.length == 0 ? "" : he("WorksheetOptions", n.join(""), { xmlns: ft.x });
}
function US(e) {
  return e.map(function(r) {
    var t = u_(r.t || ""), a = he("ss:Data", t, { xmlns: "http://www.w3.org/TR/REC-html40" });
    return he("Comment", a, { "ss:Author": r.a });
  }).join("");
}
function VS(e, r, t, a, n, i, s) {
  if (!e || e.v == null && e.f == null)
    return "";
  var o = {};
  if (e.f && (o["ss:Formula"] = "=" + Xe(Yc(e.f, s))), e.F && e.F.slice(0, r.length) == r) {
    var u = fr(e.F.slice(r.length + 1));
    o["ss:ArrayRange"] = "RC:R" + (u.r == s.r ? "" : "[" + (u.r - s.r) + "]") + "C" + (u.c == s.c ? "" : "[" + (u.c - s.c) + "]");
  }
  if (e.l && e.l.Target && (o["ss:HRef"] = Xe(e.l.Target), e.l.Tooltip && (o["x:HRefScreenTip"] = Xe(e.l.Tooltip))), t["!merges"])
    for (var l = t["!merges"], c = 0; c != l.length; ++c)
      l[c].s.c != s.c || l[c].s.r != s.r || (l[c].e.c > l[c].s.c && (o["ss:MergeAcross"] = l[c].e.c - l[c].s.c), l[c].e.r > l[c].s.r && (o["ss:MergeDown"] = l[c].e.r - l[c].s.r));
  var f = "", h = "";
  switch (e.t) {
    case "z":
      if (!a.sheetStubs)
        return "";
      break;
    case "n":
      f = "Number", h = String(e.v);
      break;
    case "b":
      f = "Boolean", h = e.v ? "1" : "0";
      break;
    case "e":
      f = "Error", h = pa[e.v];
      break;
    case "d":
      f = "DateTime", h = new Date(e.v).toISOString(), e.z == null && (e.z = e.z || Ee[14]);
      break;
    case "s":
      f = "String", h = o_(e.v || "");
      break;
  }
  var d = Ha(a.cellXfs, e, a);
  o["ss:StyleID"] = "s" + (21 + d), o["ss:Index"] = s.c + 1;
  var m = e.v != null ? h : "", x = e.t == "z" ? "" : '<Data ss:Type="' + f + '">' + m + "</Data>";
  return (e.c || []).length > 0 && (x += US(e.c)), he("Cell", x, o);
}
function WS(e, r) {
  var t = '<Row ss:Index="' + (e + 1) + '"';
  return r && (r.hpt && !r.hpx && (r.hpx = li(r.hpt)), r.hpx && (t += ' ss:AutoFitHeight="0" ss:Height="' + r.hpx + '"'), r.hidden && (t += ' ss:Hidden="1"')), t + ">";
}
function HS(e, r, t, a) {
  if (!e["!ref"])
    return "";
  var n = Oe(e["!ref"]), i = e["!merges"] || [], s = 0, o = [];
  e["!cols"] && e["!cols"].forEach(function(p, w) {
    Ma(p);
    var D = !!p.width, y = _0(w, p), B = { "ss:Index": w + 1 };
    D && (B["ss:Width"] = us(y.width)), p.hidden && (B["ss:Hidden"] = "1"), o.push(he("Column", null, B));
  });
  for (var u = Array.isArray(e), l = n.s.r; l <= n.e.r; ++l) {
    for (var c = [WS(l, (e["!rows"] || [])[l])], f = n.s.c; f <= n.e.c; ++f) {
      var h = !1;
      for (s = 0; s != i.length; ++s)
        if (!(i[s].s.c > f) && !(i[s].s.r > l) && !(i[s].e.c < f) && !(i[s].e.r < l)) {
          (i[s].s.c != f || i[s].s.r != l) && (h = !0);
          break;
        }
      if (!h) {
        var d = { r: l, c: f }, m = Te(d), x = u ? (e[l] || [])[f] : e[m];
        c.push(VS(x, m, e, r, t, a, d));
      }
    }
    c.push("</Row>"), c.length > 2 && o.push(c.join(""));
  }
  return o.join("");
}
function jS(e, r, t) {
  var a = [], n = t.SheetNames[e], i = t.Sheets[n], s = i ? LS(i, r, e, t) : "";
  return s.length > 0 && a.push("<Names>" + s + "</Names>"), s = i ? HS(i, r, e, t) : "", s.length > 0 && a.push("<Table>" + s + "</Table>"), a.push(NS(i, r, e, t)), a.join("");
}
function zS(e, r) {
  r || (r = {}), e.SSF || (e.SSF = tr(Ee)), e.SSF && (hi(), $s(e.SSF), r.revssf = p0(e.SSF), r.revssf[e.SSF[65535]] = 0, r.ssf = e.SSF, r.cellXfs = [], Ha(r.cellXfs, {}, { revssf: { General: 0 } }));
  var t = [];
  t.push(BS(e, r)), t.push(PS()), t.push(""), t.push("");
  for (var a = 0; a < e.SheetNames.length; ++a)
    t.push(he("Worksheet", jS(a, r, e), { "ss:Name": Xe(e.SheetNames[a]) }));
  return t[2] = MS(e, r), t[3] = OS(e), $r + he("Workbook", t.join(""), {
    xmlns: ft.ss,
    "xmlns:o": ft.o,
    "xmlns:x": ft.x,
    "xmlns:ss": ft.ss,
    "xmlns:dt": ft.dt,
    "xmlns:html": ft.html
  });
}
function GS(e) {
  var r = {}, t = e.content;
  if (t.l = 28, r.AnsiUserType = t.read_shift(0, "lpstr-ansi"), r.AnsiClipboardFormat = L_(t), t.length - t.l <= 4)
    return r;
  var a = t.read_shift(4);
  if (a == 0 || a > 40 || (t.l -= 4, r.Reserved1 = t.read_shift(0, "lpstr-ansi"), t.length - t.l <= 4) || (a = t.read_shift(4), a !== 1907505652) || (r.UnicodeClipboardFormat = N_(t), a = t.read_shift(4), a == 0 || a > 40))
    return r;
  t.l -= 4, r.Reserved2 = t.read_shift(0, "lpwstr");
}
var KS = [60, 1084, 2066, 2165, 2175];
function YS(e, r, t, a, n) {
  var i = a, s = [], o = t.slice(t.l, t.l + i);
  if (n && n.enc && n.enc.insitu && o.length > 0)
    switch (e) {
      case 9:
      case 521:
      case 1033:
      case 2057:
      case 47:
      case 405:
      case 225:
      case 406:
      case 312:
      case 404:
      case 10:
        break;
      case 133:
        break;
      default:
        n.enc.insitu(o);
    }
  s.push(o), t.l += i;
  for (var u = ua(t, t.l), l = Sl[u], c = 0; l != null && KS.indexOf(u) > -1; )
    i = ua(t, t.l + 2), c = t.l + 4, u == 2066 ? c += 4 : (u == 2165 || u == 2175) && (c += 12), o = t.slice(c, t.l + 4 + i), s.push(o), t.l += 4 + i, l = Sl[u = ua(t, t.l)];
  var f = Or(s);
  Vr(f, 0);
  var h = 0;
  f.lens = [];
  for (var d = 0; d < s.length; ++d)
    f.lens.push(h), h += s[d].length;
  if (f.length < a)
    throw "XLS Record 0x" + e.toString(16) + " Truncated: " + f.length + " < " + a;
  return r.f(f, f.length, n);
}
function Ut(e, r, t) {
  if (e.t !== "z" && e.XF) {
    var a = 0;
    try {
      a = e.z || e.XF.numFmtId || 0, r.cellNF && (e.z = Ee[a]);
    } catch (i) {
      if (r.WTF)
        throw i;
    }
    if (!r || r.cellText !== !1)
      try {
        e.t === "e" ? e.w = e.w || pa[e.v] : a === 0 || a == "General" ? e.t === "n" ? (e.v | 0) === e.v ? e.w = e.v.toString(10) : e.w = ts(e.v) : e.w = cn(e.v) : e.w = pt(a, e.v, { date1904: !!t, dateNF: r && r.dateNF });
      } catch (i) {
        if (r.WTF)
          throw i;
      }
    if (r.cellDates && a && e.t == "n" && pn(Ee[a] || String(a))) {
      var n = Aa(e.v);
      n && (e.t = "d", e.v = new Date(n.y, n.m - 1, n.d, n.H, n.M, n.S, n.u));
    }
  }
}
function oo(e, r, t) {
  return { v: e, ixfe: r, t };
}
function XS(e, r) {
  var t = { opts: {} }, a = {}, n = r.dense ? [] : {}, i = {}, s = {}, o = null, u = [], l = "", c = {}, f, h = "", d, m, x, p, w = {}, D = [], y, B, L = [], U = [], k = { Sheets: [], WBProps: { date1904: !1 }, Views: [{}] }, v = {}, b = function(ke) {
    return ke < 8 ? Qa[ke] : ke < 64 && U[ke - 8] || Qa[ke];
  }, A = function(ke, Le, er) {
    var ar = Le.XF.data;
    if (!(!ar || !ar.patternType || !er || !er.cellStyles)) {
      Le.s = {}, Le.s.patternType = ar.patternType;
      var xr;
      (xr = os(b(ar.icvFore))) && (Le.s.fgColor = { rgb: xr }), (xr = os(b(ar.icvBack))) && (Le.s.bgColor = { rgb: xr });
    }
  }, T = function(ke, Le, er) {
    if (!(de > 1) && !(er.sheetRows && ke.r >= er.sheetRows)) {
      if (er.cellStyles && Le.XF && Le.XF.data && A(ke, Le, er), delete Le.ixfe, delete Le.XF, f = ke, h = Te(ke), (!s || !s.s || !s.e) && (s = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } }), ke.r < s.s.r && (s.s.r = ke.r), ke.c < s.s.c && (s.s.c = ke.c), ke.r + 1 > s.e.r && (s.e.r = ke.r + 1), ke.c + 1 > s.e.c && (s.e.c = ke.c + 1), er.cellFormula && Le.f) {
        for (var ar = 0; ar < D.length; ++ar)
          if (!(D[ar][0].s.c > ke.c || D[ar][0].s.r > ke.r) && !(D[ar][0].e.c < ke.c || D[ar][0].e.r < ke.r)) {
            Le.F = Ce(D[ar][0]), (D[ar][0].s.c != ke.c || D[ar][0].s.r != ke.r) && delete Le.f, Le.f && (Le.f = "" + Gr(D[ar][1], s, ke, V, C));
            break;
          }
      }
      er.dense ? (n[ke.r] || (n[ke.r] = []), n[ke.r][ke.c] = Le) : n[h] = Le;
    }
  }, C = {
    enc: !1,
    // encrypted
    sbcch: 0,
    // cch in the preceding SupBook
    snames: [],
    // sheetnames
    sharedf: w,
    // shared formulae by address
    arrayf: D,
    // array formulae array
    rrtabid: [],
    // RRTabId
    lastuser: "",
    // Last User from WriteAccess
    biff: 8,
    // BIFF version
    codepage: 0,
    // CP from CodePage record
    winlocked: 0,
    // fLockWn from WinProtect
    cellStyles: !!r && !!r.cellStyles,
    WTF: !!r && !!r.wtf
  };
  r.password && (C.password = r.password);
  var I, Y = [], j = [], J = [], W = [], ce = !1, V = [];
  V.SheetNames = C.snames, V.sharedf = C.sharedf, V.arrayf = C.arrayf, V.names = [], V.XTI = [];
  var ee = 0, de = 0, F = 0, H = [], P = [], N;
  C.codepage = 1200, kt(1200);
  for (var X = !1; e.l < e.length - 1; ) {
    var ae = e.l, ie = e.read_shift(2);
    if (ie === 0 && ee === 10)
      break;
    var q = e.l === e.length ? 0 : e.read_shift(2), re = Sl[ie];
    if (re && re.f) {
      if (r.bookSheets && ee === 133 && ie !== 133)
        break;
      if (ee = ie, re.r === 2 || re.r == 12) {
        var ve = e.read_shift(2);
        if (q -= 2, !C.enc && ve !== ie && ((ve & 255) << 8 | ve >> 8) !== ie)
          throw new Error("rt mismatch: " + ve + "!=" + ie);
        re.r == 12 && (e.l += 10, q -= 10);
      }
      var M = {};
      if (ie === 10 ? M = /*::(*/
      re.f(e, q, C) : M = /*::(*/
      YS(ie, re, e, q, C), de == 0 && [9, 521, 1033, 2057].indexOf(ee) === -1)
        continue;
      switch (ie) {
        case 34:
          t.opts.Date1904 = k.WBProps.date1904 = M;
          break;
        case 134:
          t.opts.WriteProtect = !0;
          break;
        case 47:
          if (C.enc || (e.l = 0), C.enc = M, !r.password)
            throw new Error("File is password-protected");
          if (M.valid == null)
            throw new Error("Encryption scheme unsupported");
          if (!M.valid)
            throw new Error("Password is incorrect");
          break;
        case 92:
          C.lastuser = M;
          break;
        case 66:
          var _e = Number(M);
          switch (_e) {
            case 21010:
              _e = 1200;
              break;
            case 32768:
              _e = 1e4;
              break;
            case 32769:
              _e = 1252;
              break;
          }
          kt(C.codepage = _e), X = !0;
          break;
        case 317:
          C.rrtabid = M;
          break;
        case 25:
          C.winlocked = M;
          break;
        case 439:
          t.opts.RefreshAll = M;
          break;
        case 12:
          t.opts.CalcCount = M;
          break;
        case 16:
          t.opts.CalcDelta = M;
          break;
        case 17:
          t.opts.CalcIter = M;
          break;
        case 13:
          t.opts.CalcMode = M;
          break;
        case 14:
          t.opts.CalcPrecision = M;
          break;
        case 95:
          t.opts.CalcSaveRecalc = M;
          break;
        case 15:
          C.CalcRefMode = M;
          break;
        case 2211:
          t.opts.FullCalc = M;
          break;
        case 129:
          M.fDialog && (n["!type"] = "dialog"), M.fBelow || ((n["!outline"] || (n["!outline"] = {})).above = !0), M.fRight || ((n["!outline"] || (n["!outline"] = {})).left = !0);
          break;
        case 224:
          L.push(M);
          break;
        case 430:
          V.push([M]), V[V.length - 1].XTI = [];
          break;
        case 35:
        case 547:
          V[V.length - 1].push(M);
          break;
        case 24:
        case 536:
          N = {
            Name: M.Name,
            Ref: Gr(M.rgce, s, null, V, C)
          }, M.itab > 0 && (N.Sheet = M.itab - 1), V.names.push(N), V[0] || (V[0] = [], V[0].XTI = []), V[V.length - 1].push(M), M.Name == "_xlnm._FilterDatabase" && M.itab > 0 && M.rgce && M.rgce[0] && M.rgce[0][0] && M.rgce[0][0][0] == "PtgArea3d" && (P[M.itab - 1] = { ref: Ce(M.rgce[0][0][1][2]) });
          break;
        case 22:
          C.ExternCount = M;
          break;
        case 23:
          V.length == 0 && (V[0] = [], V[0].XTI = []), V[V.length - 1].XTI = V[V.length - 1].XTI.concat(M), V.XTI = V.XTI.concat(M);
          break;
        case 2196:
          if (C.biff < 8)
            break;
          N != null && (N.Comment = M[1]);
          break;
        case 18:
          n["!protect"] = M;
          break;
        case 19:
          M !== 0 && C.WTF && console.error("Password verifier: " + M);
          break;
        case 133:
          i[M.pos] = M, C.snames.push(M.name);
          break;
        case 10:
          {
            if (--de)
              break;
            if (s.e) {
              if (s.e.r > 0 && s.e.c > 0) {
                if (s.e.r--, s.e.c--, n["!ref"] = Ce(s), r.sheetRows && r.sheetRows <= s.e.r) {
                  var De = s.e.r;
                  s.e.r = r.sheetRows - 1, n["!fullref"] = n["!ref"], n["!ref"] = Ce(s), s.e.r = De;
                }
                s.e.r++, s.e.c++;
              }
              Y.length > 0 && (n["!merges"] = Y), j.length > 0 && (n["!objects"] = j), J.length > 0 && (n["!cols"] = J), W.length > 0 && (n["!rows"] = W), k.Sheets.push(v);
            }
            l === "" ? c = n : a[l] = n, n = r.dense ? [] : {};
          }
          break;
        case 9:
        case 521:
        case 1033:
        case 2057:
          {
            if (C.biff === 8 && (C.biff = {
              /*::[*/
              9: 2,
              /*::[*/
              521: 3,
              /*::[*/
              1033: 4
            }[ie] || {
              /*::[*/
              512: 2,
              /*::[*/
              768: 3,
              /*::[*/
              1024: 4,
              /*::[*/
              1280: 5,
              /*::[*/
              1536: 8,
              /*::[*/
              2: 2,
              /*::[*/
              7: 2
            }[M.BIFFVer] || 8), C.biffguess = M.BIFFVer == 0, M.BIFFVer == 0 && M.dt == 4096 && (C.biff = 5, X = !0, kt(C.codepage = 28591)), C.biff == 8 && M.BIFFVer == 0 && M.dt == 16 && (C.biff = 2), de++)
              break;
            if (n = r.dense ? [] : {}, C.biff < 8 && !X && (X = !0, kt(C.codepage = r.codepage || 1252)), C.biff < 5 || M.BIFFVer == 0 && M.dt == 4096) {
              l === "" && (l = "Sheet1"), s = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } };
              var $e = { pos: e.l - q, name: l };
              i[$e.pos] = $e, C.snames.push(l);
            } else
              l = (i[ae] || { name: "" }).name;
            M.dt == 32 && (n["!type"] = "chart"), M.dt == 64 && (n["!type"] = "macro"), Y = [], j = [], C.arrayf = D = [], J = [], W = [], ce = !1, v = { Hidden: (i[ae] || { hs: 0 }).hs, name: l };
          }
          break;
        case 515:
        case 3:
        case 2:
          n["!type"] == "chart" && (r.dense ? (n[M.r] || [])[M.c] : n[Te({ c: M.c, r: M.r })]) && ++M.c, y = { ixfe: M.ixfe, XF: L[M.ixfe] || {}, v: M.val, t: "n" }, F > 0 && (y.z = H[y.ixfe >> 8 & 63]), Ut(y, r, t.opts.Date1904), T({ c: M.c, r: M.r }, y, r);
          break;
        case 5:
        case 517:
          y = { ixfe: M.ixfe, XF: L[M.ixfe], v: M.val, t: M.t }, F > 0 && (y.z = H[y.ixfe >> 8 & 63]), Ut(y, r, t.opts.Date1904), T({ c: M.c, r: M.r }, y, r);
          break;
        case 638:
          y = { ixfe: M.ixfe, XF: L[M.ixfe], v: M.rknum, t: "n" }, F > 0 && (y.z = H[y.ixfe >> 8 & 63]), Ut(y, r, t.opts.Date1904), T({ c: M.c, r: M.r }, y, r);
          break;
        case 189:
          for (var ge = M.c; ge <= M.C; ++ge) {
            var fe = M.rkrec[ge - M.c][0];
            y = { ixfe: fe, XF: L[fe], v: M.rkrec[ge - M.c][1], t: "n" }, F > 0 && (y.z = H[y.ixfe >> 8 & 63]), Ut(y, r, t.opts.Date1904), T({ c: ge, r: M.r }, y, r);
          }
          break;
        case 6:
        case 518:
        case 1030:
          {
            if (M.val == "String") {
              o = M;
              break;
            }
            if (y = oo(M.val, M.cell.ixfe, M.tt), y.XF = L[y.ixfe], r.cellFormula) {
              var Me = M.formula;
              if (Me && Me[0] && Me[0][0] && Me[0][0][0] == "PtgExp") {
                var Je = Me[0][0][1][0], dr = Me[0][0][1][1], lr = Te({ r: Je, c: dr });
                w[lr] ? y.f = "" + Gr(M.formula, s, M.cell, V, C) : y.F = ((r.dense ? (n[Je] || [])[dr] : n[lr]) || {}).F;
              } else
                y.f = "" + Gr(M.formula, s, M.cell, V, C);
            }
            F > 0 && (y.z = H[y.ixfe >> 8 & 63]), Ut(y, r, t.opts.Date1904), T(M.cell, y, r), o = M;
          }
          break;
        case 7:
        case 519:
          if (o)
            o.val = M, y = oo(M, o.cell.ixfe, "s"), y.XF = L[y.ixfe], r.cellFormula && (y.f = "" + Gr(o.formula, s, o.cell, V, C)), F > 0 && (y.z = H[y.ixfe >> 8 & 63]), Ut(y, r, t.opts.Date1904), T(o.cell, y, r), o = null;
          else
            throw new Error("String record expects Formula");
          break;
        case 33:
        case 545:
          {
            D.push(M);
            var Ve = Te(M[0].s);
            if (d = r.dense ? (n[M[0].s.r] || [])[M[0].s.c] : n[Ve], r.cellFormula && d) {
              if (!o || !Ve || !d)
                break;
              d.f = "" + Gr(M[1], s, M[0], V, C), d.F = Ce(M[0]);
            }
          }
          break;
        case 1212:
          {
            if (!r.cellFormula)
              break;
            if (h) {
              if (!o)
                break;
              w[Te(o.cell)] = M[0], d = r.dense ? (n[o.cell.r] || [])[o.cell.c] : n[Te(o.cell)], (d || {}).f = "" + Gr(M[0], s, f, V, C);
            }
          }
          break;
        case 253:
          y = oo(u[M.isst].t, M.ixfe, "s"), u[M.isst].h && (y.h = u[M.isst].h), y.XF = L[y.ixfe], F > 0 && (y.z = H[y.ixfe >> 8 & 63]), Ut(y, r, t.opts.Date1904), T({ c: M.c, r: M.r }, y, r);
          break;
        case 513:
          r.sheetStubs && (y = { ixfe: M.ixfe, XF: L[M.ixfe], t: "z" }, F > 0 && (y.z = H[y.ixfe >> 8 & 63]), Ut(y, r, t.opts.Date1904), T({ c: M.c, r: M.r }, y, r));
          break;
        case 190:
          if (r.sheetStubs)
            for (var Ge = M.c; Ge <= M.C; ++Ge) {
              var cr = M.ixfe[Ge - M.c];
              y = { ixfe: cr, XF: L[cr], t: "z" }, F > 0 && (y.z = H[y.ixfe >> 8 & 63]), Ut(y, r, t.opts.Date1904), T({ c: Ge, r: M.r }, y, r);
            }
          break;
        case 214:
        case 516:
        case 4:
          y = oo(M.val, M.ixfe, "s"), y.XF = L[y.ixfe], F > 0 && (y.z = H[y.ixfe >> 8 & 63]), Ut(y, r, t.opts.Date1904), T({ c: M.c, r: M.r }, y, r);
          break;
        case 0:
        case 512:
          de === 1 && (s = M);
          break;
        case 252:
          u = M;
          break;
        case 1054:
          if (C.biff == 4) {
            H[F++] = M[1];
            for (var Ae = 0; Ae < F + 163 && Ee[Ae] != M[1]; ++Ae)
              ;
            Ae >= 163 && Gt(M[1], F + 163);
          } else
            Gt(M[1], M[0]);
          break;
        case 30:
          {
            H[F++] = M;
            for (var Rr = 0; Rr < F + 163 && Ee[Rr] != M; ++Rr)
              ;
            Rr >= 163 && Gt(M, F + 163);
          }
          break;
        case 229:
          Y = Y.concat(M);
          break;
        case 93:
          j[M.cmo[0]] = C.lastobj = M;
          break;
        case 438:
          C.lastobj.TxO = M;
          break;
        case 127:
          C.lastobj.ImData = M;
          break;
        case 440:
          for (p = M[0].s.r; p <= M[0].e.r; ++p)
            for (x = M[0].s.c; x <= M[0].e.c; ++x)
              d = r.dense ? (n[p] || [])[x] : n[Te({ c: x, r: p })], d && (d.l = M[1]);
          break;
        case 2048:
          for (p = M[0].s.r; p <= M[0].e.r; ++p)
            for (x = M[0].s.c; x <= M[0].e.c; ++x)
              d = r.dense ? (n[p] || [])[x] : n[Te({ c: x, r: p })], d && d.l && (d.l.Tooltip = M[1]);
          break;
        case 28:
          {
            if (C.biff <= 5 && C.biff >= 2)
              break;
            d = r.dense ? (n[M[0].r] || [])[M[0].c] : n[Te(M[0])];
            var wr = j[M[2]];
            d || (r.dense ? (n[M[0].r] || (n[M[0].r] = []), d = n[M[0].r][M[0].c] = { t: "z" }) : d = n[Te(M[0])] = { t: "z" }, s.e.r = Math.max(s.e.r, M[0].r), s.s.r = Math.min(s.s.r, M[0].r), s.e.c = Math.max(s.e.c, M[0].c), s.s.c = Math.min(s.s.c, M[0].c)), d.c || (d.c = []), m = { a: M[1], t: wr.TxO.t }, d.c.push(m);
          }
          break;
        case 2173:
          OE(L[M.ixfe], M.ext);
          break;
        case 125:
          {
            if (!C.cellStyles)
              break;
            for (; M.e >= M.s; )
              J[M.e--] = { width: M.w / 256, level: M.level || 0, hidden: !!(M.flags & 1) }, ce || (ce = !0, zc(M.w / 256)), Ma(J[M.e + 1]);
          }
          break;
        case 520:
          {
            var nr = {};
            M.level != null && (W[M.r] = nr, nr.level = M.level), M.hidden && (W[M.r] = nr, nr.hidden = !0), M.hpt && (W[M.r] = nr, nr.hpt = M.hpt, nr.hpx = li(M.hpt));
          }
          break;
        case 38:
        case 39:
        case 40:
        case 41:
          n["!margins"] || tn(n["!margins"] = {}), n["!margins"][{ 38: "left", 39: "right", 40: "top", 41: "bottom" }[ie]] = M;
          break;
        case 161:
          n["!margins"] || tn(n["!margins"] = {}), n["!margins"].header = M.header, n["!margins"].footer = M.footer;
          break;
        case 574:
          M.RTL && (k.Views[0].RTL = !0);
          break;
        case 146:
          U = M;
          break;
        case 2198:
          I = M;
          break;
        case 140:
          B = M;
          break;
        case 442:
          l ? v.CodeName = M || v.name : k.WBProps.CodeName = M || "ThisWorkbook";
          break;
      }
    } else
      re || console.error("Missing Info for XLS Record 0x" + ie.toString(16)), e.l += q;
  }
  return t.SheetNames = br(i).sort(function(hr, ke) {
    return Number(hr) - Number(ke);
  }).map(function(hr) {
    return i[hr].name;
  }), r.bookSheets || (t.Sheets = a), !t.SheetNames.length && c["!ref"] ? (t.SheetNames.push("Sheet1"), t.Sheets && (t.Sheets.Sheet1 = c)) : t.Preamble = c, t.Sheets && P.forEach(function(hr, ke) {
    t.Sheets[t.SheetNames[ke]]["!autofilter"] = hr;
  }), t.Strings = u, t.SSF = tr(Ee), C.enc && (t.Encryption = C.enc), I && (t.Themes = I), t.Metadata = {}, B !== void 0 && (t.Metadata.Country = B), V.names.length > 0 && (k.Names = V.names), t.Workbook = k, t;
}
var Gi = {
  SI: "e0859ff2f94f6810ab9108002b27b3d9",
  DSI: "02d5cdd59c2e1b10939708002b2cf9ae",
  UDI: "05d5cdd59c2e1b10939708002b2cf9ae"
};
function ZS(e, r, t) {
  var a = we.find(e, "/!DocumentSummaryInformation");
  if (a && a.size > 0)
    try {
      var n = rh(a, wl, Gi.DSI);
      for (var i in n)
        r[i] = n[i];
    } catch (l) {
      if (t.WTF)
        throw l;
    }
  var s = we.find(e, "/!SummaryInformation");
  if (s && s.size > 0)
    try {
      var o = rh(s, _l, Gi.SI);
      for (var u in o)
        r[u] == null && (r[u] = o[u]);
    } catch (l) {
      if (t.WTF)
        throw l;
    }
  r.HeadingPairs && r.TitlesOfParts && (vv(r.HeadingPairs, r.TitlesOfParts, r, t), delete r.HeadingPairs, delete r.TitlesOfParts);
}
function JS(e, r) {
  var t = [], a = [], n = [], i = 0, s, o = Ad(wl, "n"), u = Ad(_l, "n");
  if (e.Props)
    for (s = br(e.Props), i = 0; i < s.length; ++i)
      (Object.prototype.hasOwnProperty.call(o, s[i]) ? t : Object.prototype.hasOwnProperty.call(u, s[i]) ? a : n).push([s[i], e.Props[s[i]]]);
  if (e.Custprops)
    for (s = br(e.Custprops), i = 0; i < s.length; ++i)
      Object.prototype.hasOwnProperty.call(e.Props || {}, s[i]) || (Object.prototype.hasOwnProperty.call(o, s[i]) ? t : Object.prototype.hasOwnProperty.call(u, s[i]) ? a : n).push([s[i], e.Custprops[s[i]]]);
  var l = [];
  for (i = 0; i < n.length; ++i)
    Dv.indexOf(n[i][0]) > -1 || pv.indexOf(n[i][0]) > -1 || n[i][1] != null && l.push(n[i]);
  a.length && we.utils.cfb_add(r, "/SummaryInformation", th(a, Gi.SI, u, _l)), (t.length || l.length) && we.utils.cfb_add(r, "/DocumentSummaryInformation", th(t, Gi.DSI, o, wl, l.length ? l : null, Gi.UDI));
}
function Qc(e, r) {
  r || (r = {}), rf(r), x0(), r.codepage && h0(r.codepage);
  var t, a;
  if (e.FullPaths) {
    if (we.find(e, "/encryption"))
      throw new Error("File is password-protected");
    t = we.find(e, "!CompObj"), a = we.find(e, "/Workbook") || we.find(e, "/Book");
  } else {
    switch (r.type) {
      case "base64":
        e = dt(mt(e));
        break;
      case "binary":
        e = dt(e);
        break;
      case "buffer":
        break;
      case "array":
        Array.isArray(e) || (e = Array.prototype.slice.call(e));
        break;
    }
    Vr(e, 0), a = { content: e };
  }
  var n, i;
  if (t && GS(t), r.bookProps && !r.bookSheets)
    n = {};
  else {
    var s = Ie ? "buffer" : "array";
    if (a && a.content)
      n = XS(a.content, r);
    else if ((i = we.find(e, "PerfectOffice_MAIN")) && i.content)
      n = rn.to_workbook(i.content, (r.type = s, r));
    else if ((i = we.find(e, "NativeContent_MAIN")) && i.content)
      n = rn.to_workbook(i.content, (r.type = s, r));
    else
      throw (i = we.find(e, "MN0")) && i.content ? new Error("Unsupported Works 4 for Mac file") : new Error("Cannot find Workbook stream");
    r.bookVBA && e.FullPaths && we.find(e, "/_VBA_PROJECT_CUR/VBA/dir") && (n.vbaraw = f7(e));
  }
  var o = {};
  return e.FullPaths && ZS(
    /*::((*/
    e,
    o,
    r
  ), n.Props = n.Custprops = o, r.bookFiles && (n.cfb = e), n;
}
function qS(e, r) {
  var t = r || {}, a = we.utils.cfb_new({ root: "R" }), n = "/Workbook";
  switch (t.bookType || "xls") {
    case "xls":
      t.bookType = "biff8";
    case "xla":
      t.bookType || (t.bookType = "xla");
    case "biff8":
      n = "/Workbook", t.biff = 8;
      break;
    case "biff5":
      n = "/Book", t.biff = 5;
      break;
    default:
      throw new Error("invalid type " + t.bookType + " for XLS CFB");
  }
  return we.utils.cfb_add(a, n, b2(e, t)), t.biff == 8 && (e.Props || e.Custprops) && JS(e, a), t.biff == 8 && e.vbaraw && d7(a, we.read(e.vbaraw, { type: typeof e.vbaraw == "string" ? "binary" : "buffer" })), a;
}
var fs = {
  /*::[*/
  0: {
    /* n:"BrtRowHdr", */
    f: $k
  },
  /*::[*/
  1: {
    /* n:"BrtCellBlank", */
    f: Ak
  },
  /*::[*/
  2: {
    /* n:"BrtCellRk", */
    f: Zk
  },
  /*::[*/
  3: {
    /* n:"BrtCellError", */
    f: Nk
  },
  /*::[*/
  4: {
    /* n:"BrtCellBool", */
    f: Pk
  },
  /*::[*/
  5: {
    /* n:"BrtCellReal", */
    f: Kk
  },
  /*::[*/
  6: {
    /* n:"BrtCellSt", */
    f: rT
  },
  /*::[*/
  7: {
    /* n:"BrtCellIsst", */
    f: Hk
  },
  /*::[*/
  8: {
    /* n:"BrtFmlaString", */
    f: uT
  },
  /*::[*/
  9: {
    /* n:"BrtFmlaNum", */
    f: oT
  },
  /*::[*/
  10: {
    /* n:"BrtFmlaBool", */
    f: iT
  },
  /*::[*/
  11: {
    /* n:"BrtFmlaError", */
    f: sT
  },
  /*::[*/
  12: {
    /* n:"BrtShortBlank", */
    f: Ik
  },
  /*::[*/
  13: {
    /* n:"BrtShortRk", */
    f: qk
  },
  /*::[*/
  14: {
    /* n:"BrtShortError", */
    f: Vk
  },
  /*::[*/
  15: {
    /* n:"BrtShortBool", */
    f: Ok
  },
  /*::[*/
  16: {
    /* n:"BrtShortReal", */
    f: f2
  },
  /*::[*/
  17: {
    /* n:"BrtShortSt", */
    f: aT
  },
  /*::[*/
  18: {
    /* n:"BrtShortIsst", */
    f: zk
  },
  /*::[*/
  19: {
    /* n:"BrtSSTItem", */
    f: Pc
  },
  /*::[*/
  20: {
    /* n:"BrtPCDIMissing" */
  },
  /*::[*/
  21: {
    /* n:"BrtPCDINumber" */
  },
  /*::[*/
  22: {
    /* n:"BrtPCDIBoolean" */
  },
  /*::[*/
  23: {
    /* n:"BrtPCDIError" */
  },
  /*::[*/
  24: {
    /* n:"BrtPCDIString" */
  },
  /*::[*/
  25: {
    /* n:"BrtPCDIDatetime" */
  },
  /*::[*/
  26: {
    /* n:"BrtPCDIIndex" */
  },
  /*::[*/
  27: {
    /* n:"BrtPCDIAMissing" */
  },
  /*::[*/
  28: {
    /* n:"BrtPCDIANumber" */
  },
  /*::[*/
  29: {
    /* n:"BrtPCDIABoolean" */
  },
  /*::[*/
  30: {
    /* n:"BrtPCDIAError" */
  },
  /*::[*/
  31: {
    /* n:"BrtPCDIAString" */
  },
  /*::[*/
  32: {
    /* n:"BrtPCDIADatetime" */
  },
  /*::[*/
  33: {
    /* n:"BrtPCRRecord" */
  },
  /*::[*/
  34: {
    /* n:"BrtPCRRecordDt" */
  },
  /*::[*/
  35: {
    /* n:"BrtFRTBegin", */
    T: 1
  },
  /*::[*/
  36: {
    /* n:"BrtFRTEnd", */
    T: -1
  },
  /*::[*/
  37: {
    /* n:"BrtACBegin", */
    T: 1
  },
  /*::[*/
  38: {
    /* n:"BrtACEnd", */
    T: -1
  },
  /*::[*/
  39: {
    /* n:"BrtName", */
    f: tS
  },
  /*::[*/
  40: {
    /* n:"BrtIndexRowBlock" */
  },
  /*::[*/
  42: {
    /* n:"BrtIndexBlock" */
  },
  /*::[*/
  43: {
    /* n:"BrtFont", */
    f: rE
  },
  /*::[*/
  44: {
    /* n:"BrtFmt", */
    f: QD
  },
  /*::[*/
  45: {
    /* n:"BrtFill", */
    f: nE
  },
  /*::[*/
  46: {
    /* n:"BrtBorder", */
    f: sE
  },
  /*::[*/
  47: {
    /* n:"BrtXF", */
    f: iE
  },
  /*::[*/
  48: {
    /* n:"BrtStyle" */
  },
  /*::[*/
  49: {
    /* n:"BrtCellMeta", */
    f: k_
  },
  /*::[*/
  50: {
    /* n:"BrtValueMeta" */
  },
  /*::[*/
  51: {
    /* n:"BrtMdb" */
    f: UE
  },
  /*::[*/
  52: {
    /* n:"BrtBeginFmd", */
    T: 1
  },
  /*::[*/
  53: {
    /* n:"BrtEndFmd", */
    T: -1
  },
  /*::[*/
  54: {
    /* n:"BrtBeginMdx", */
    T: 1
  },
  /*::[*/
  55: {
    /* n:"BrtEndMdx", */
    T: -1
  },
  /*::[*/
  56: {
    /* n:"BrtBeginMdxTuple", */
    T: 1
  },
  /*::[*/
  57: {
    /* n:"BrtEndMdxTuple", */
    T: -1
  },
  /*::[*/
  58: {
    /* n:"BrtMdxMbrIstr" */
  },
  /*::[*/
  59: {
    /* n:"BrtStr" */
  },
  /*::[*/
  60: {
    /* n:"BrtColInfo", */
    f: Pv
  },
  /*::[*/
  62: {
    /* n:"BrtCellRString", */
    f: eT
  },
  /*::[*/
  63: {
    /* n:"BrtCalcChainItem$", */
    f: XE
  },
  /*::[*/
  64: {
    /* n:"BrtDVal", */
    f: DT
  },
  /*::[*/
  65: {
    /* n:"BrtSxvcellNum" */
  },
  /*::[*/
  66: {
    /* n:"BrtSxvcellStr" */
  },
  /*::[*/
  67: {
    /* n:"BrtSxvcellBool" */
  },
  /*::[*/
  68: {
    /* n:"BrtSxvcellErr" */
  },
  /*::[*/
  69: {
    /* n:"BrtSxvcellDate" */
  },
  /*::[*/
  70: {
    /* n:"BrtSxvcellNil" */
  },
  /*::[*/
  128: {
    /* n:"BrtFileVersion" */
  },
  /*::[*/
  129: {
    /* n:"BrtBeginSheet", */
    T: 1
  },
  /*::[*/
  130: {
    /* n:"BrtEndSheet", */
    T: -1
  },
  /*::[*/
  131: {
    /* n:"BrtBeginBook", */
    T: 1,
    f: qr,
    p: 0
  },
  /*::[*/
  132: {
    /* n:"BrtEndBook", */
    T: -1
  },
  /*::[*/
  133: {
    /* n:"BrtBeginWsViews", */
    T: 1
  },
  /*::[*/
  134: {
    /* n:"BrtEndWsViews", */
    T: -1
  },
  /*::[*/
  135: {
    /* n:"BrtBeginBookViews", */
    T: 1
  },
  /*::[*/
  136: {
    /* n:"BrtEndBookViews", */
    T: -1
  },
  /*::[*/
  137: {
    /* n:"BrtBeginWsView", */
    T: 1,
    f: bT
  },
  /*::[*/
  138: {
    /* n:"BrtEndWsView", */
    T: -1
  },
  /*::[*/
  139: {
    /* n:"BrtBeginCsViews", */
    T: 1
  },
  /*::[*/
  140: {
    /* n:"BrtEndCsViews", */
    T: -1
  },
  /*::[*/
  141: {
    /* n:"BrtBeginCsView", */
    T: 1
  },
  /*::[*/
  142: {
    /* n:"BrtEndCsView", */
    T: -1
  },
  /*::[*/
  143: {
    /* n:"BrtBeginBundleShs", */
    T: 1
  },
  /*::[*/
  144: {
    /* n:"BrtEndBundleShs", */
    T: -1
  },
  /*::[*/
  145: {
    /* n:"BrtBeginSheetData", */
    T: 1
  },
  /*::[*/
  146: {
    /* n:"BrtEndSheetData", */
    T: -1
  },
  /*::[*/
  147: {
    /* n:"BrtWsProp", */
    f: Ck
  },
  /*::[*/
  148: {
    /* n:"BrtWsDim", */
    f: kk,
    p: 16
  },
  /*::[*/
  151: {
    /* n:"BrtPane", */
    f: xT
  },
  /*::[*/
  152: {
    /* n:"BrtSel" */
  },
  /*::[*/
  153: {
    /* n:"BrtWbProp", */
    f: QT
  },
  /*::[*/
  154: {
    /* n:"BrtWbFactoid" */
  },
  /*::[*/
  155: {
    /* n:"BrtFileRecover" */
  },
  /*::[*/
  156: {
    /* n:"BrtBundleSh", */
    f: JT
  },
  /*::[*/
  157: {
    /* n:"BrtCalcProp" */
  },
  /*::[*/
  158: {
    /* n:"BrtBookView" */
  },
  /*::[*/
  159: {
    /* n:"BrtBeginSst", */
    T: 1,
    f: pD
  },
  /*::[*/
  160: {
    /* n:"BrtEndSst", */
    T: -1
  },
  /*::[*/
  161: {
    /* n:"BrtBeginAFilter", */
    T: 1,
    f: wn
  },
  /*::[*/
  162: {
    /* n:"BrtEndAFilter", */
    T: -1
  },
  /*::[*/
  163: {
    /* n:"BrtBeginFilterColumn", */
    T: 1
  },
  /*::[*/
  164: {
    /* n:"BrtEndFilterColumn", */
    T: -1
  },
  /*::[*/
  165: {
    /* n:"BrtBeginFilters", */
    T: 1
  },
  /*::[*/
  166: {
    /* n:"BrtEndFilters", */
    T: -1
  },
  /*::[*/
  167: {
    /* n:"BrtFilter" */
  },
  /*::[*/
  168: {
    /* n:"BrtColorFilter" */
  },
  /*::[*/
  169: {
    /* n:"BrtIconFilter" */
  },
  /*::[*/
  170: {
    /* n:"BrtTop10Filter" */
  },
  /*::[*/
  171: {
    /* n:"BrtDynamicFilter" */
  },
  /*::[*/
  172: {
    /* n:"BrtBeginCustomFilters", */
    T: 1
  },
  /*::[*/
  173: {
    /* n:"BrtEndCustomFilters", */
    T: -1
  },
  /*::[*/
  174: {
    /* n:"BrtCustomFilter" */
  },
  /*::[*/
  175: {
    /* n:"BrtAFilterDateGroupItem" */
  },
  /*::[*/
  176: {
    /* n:"BrtMergeCell", */
    f: lT
  },
  /*::[*/
  177: {
    /* n:"BrtBeginMergeCells", */
    T: 1
  },
  /*::[*/
  178: {
    /* n:"BrtEndMergeCells", */
    T: -1
  },
  /*::[*/
  179: {
    /* n:"BrtBeginPivotCacheDef", */
    T: 1
  },
  /*::[*/
  180: {
    /* n:"BrtEndPivotCacheDef", */
    T: -1
  },
  /*::[*/
  181: {
    /* n:"BrtBeginPCDFields", */
    T: 1
  },
  /*::[*/
  182: {
    /* n:"BrtEndPCDFields", */
    T: -1
  },
  /*::[*/
  183: {
    /* n:"BrtBeginPCDField", */
    T: 1
  },
  /*::[*/
  184: {
    /* n:"BrtEndPCDField", */
    T: -1
  },
  /*::[*/
  185: {
    /* n:"BrtBeginPCDSource", */
    T: 1
  },
  /*::[*/
  186: {
    /* n:"BrtEndPCDSource", */
    T: -1
  },
  /*::[*/
  187: {
    /* n:"BrtBeginPCDSRange", */
    T: 1
  },
  /*::[*/
  188: {
    /* n:"BrtEndPCDSRange", */
    T: -1
  },
  /*::[*/
  189: {
    /* n:"BrtBeginPCDFAtbl", */
    T: 1
  },
  /*::[*/
  190: {
    /* n:"BrtEndPCDFAtbl", */
    T: -1
  },
  /*::[*/
  191: {
    /* n:"BrtBeginPCDIRun", */
    T: 1
  },
  /*::[*/
  192: {
    /* n:"BrtEndPCDIRun", */
    T: -1
  },
  /*::[*/
  193: {
    /* n:"BrtBeginPivotCacheRecords", */
    T: 1
  },
  /*::[*/
  194: {
    /* n:"BrtEndPivotCacheRecords", */
    T: -1
  },
  /*::[*/
  195: {
    /* n:"BrtBeginPCDHierarchies", */
    T: 1
  },
  /*::[*/
  196: {
    /* n:"BrtEndPCDHierarchies", */
    T: -1
  },
  /*::[*/
  197: {
    /* n:"BrtBeginPCDHierarchy", */
    T: 1
  },
  /*::[*/
  198: {
    /* n:"BrtEndPCDHierarchy", */
    T: -1
  },
  /*::[*/
  199: {
    /* n:"BrtBeginPCDHFieldsUsage", */
    T: 1
  },
  /*::[*/
  200: {
    /* n:"BrtEndPCDHFieldsUsage", */
    T: -1
  },
  /*::[*/
  201: {
    /* n:"BrtBeginExtConnection", */
    T: 1
  },
  /*::[*/
  202: {
    /* n:"BrtEndExtConnection", */
    T: -1
  },
  /*::[*/
  203: {
    /* n:"BrtBeginECDbProps", */
    T: 1
  },
  /*::[*/
  204: {
    /* n:"BrtEndECDbProps", */
    T: -1
  },
  /*::[*/
  205: {
    /* n:"BrtBeginECOlapProps", */
    T: 1
  },
  /*::[*/
  206: {
    /* n:"BrtEndECOlapProps", */
    T: -1
  },
  /*::[*/
  207: {
    /* n:"BrtBeginPCDSConsol", */
    T: 1
  },
  /*::[*/
  208: {
    /* n:"BrtEndPCDSConsol", */
    T: -1
  },
  /*::[*/
  209: {
    /* n:"BrtBeginPCDSCPages", */
    T: 1
  },
  /*::[*/
  210: {
    /* n:"BrtEndPCDSCPages", */
    T: -1
  },
  /*::[*/
  211: {
    /* n:"BrtBeginPCDSCPage", */
    T: 1
  },
  /*::[*/
  212: {
    /* n:"BrtEndPCDSCPage", */
    T: -1
  },
  /*::[*/
  213: {
    /* n:"BrtBeginPCDSCPItem", */
    T: 1
  },
  /*::[*/
  214: {
    /* n:"BrtEndPCDSCPItem", */
    T: -1
  },
  /*::[*/
  215: {
    /* n:"BrtBeginPCDSCSets", */
    T: 1
  },
  /*::[*/
  216: {
    /* n:"BrtEndPCDSCSets", */
    T: -1
  },
  /*::[*/
  217: {
    /* n:"BrtBeginPCDSCSet", */
    T: 1
  },
  /*::[*/
  218: {
    /* n:"BrtEndPCDSCSet", */
    T: -1
  },
  /*::[*/
  219: {
    /* n:"BrtBeginPCDFGroup", */
    T: 1
  },
  /*::[*/
  220: {
    /* n:"BrtEndPCDFGroup", */
    T: -1
  },
  /*::[*/
  221: {
    /* n:"BrtBeginPCDFGItems", */
    T: 1
  },
  /*::[*/
  222: {
    /* n:"BrtEndPCDFGItems", */
    T: -1
  },
  /*::[*/
  223: {
    /* n:"BrtBeginPCDFGRange", */
    T: 1
  },
  /*::[*/
  224: {
    /* n:"BrtEndPCDFGRange", */
    T: -1
  },
  /*::[*/
  225: {
    /* n:"BrtBeginPCDFGDiscrete", */
    T: 1
  },
  /*::[*/
  226: {
    /* n:"BrtEndPCDFGDiscrete", */
    T: -1
  },
  /*::[*/
  227: {
    /* n:"BrtBeginPCDSDTupleCache", */
    T: 1
  },
  /*::[*/
  228: {
    /* n:"BrtEndPCDSDTupleCache", */
    T: -1
  },
  /*::[*/
  229: {
    /* n:"BrtBeginPCDSDTCEntries", */
    T: 1
  },
  /*::[*/
  230: {
    /* n:"BrtEndPCDSDTCEntries", */
    T: -1
  },
  /*::[*/
  231: {
    /* n:"BrtBeginPCDSDTCEMembers", */
    T: 1
  },
  /*::[*/
  232: {
    /* n:"BrtEndPCDSDTCEMembers", */
    T: -1
  },
  /*::[*/
  233: {
    /* n:"BrtBeginPCDSDTCEMember", */
    T: 1
  },
  /*::[*/
  234: {
    /* n:"BrtEndPCDSDTCEMember", */
    T: -1
  },
  /*::[*/
  235: {
    /* n:"BrtBeginPCDSDTCQueries", */
    T: 1
  },
  /*::[*/
  236: {
    /* n:"BrtEndPCDSDTCQueries", */
    T: -1
  },
  /*::[*/
  237: {
    /* n:"BrtBeginPCDSDTCQuery", */
    T: 1
  },
  /*::[*/
  238: {
    /* n:"BrtEndPCDSDTCQuery", */
    T: -1
  },
  /*::[*/
  239: {
    /* n:"BrtBeginPCDSDTCSets", */
    T: 1
  },
  /*::[*/
  240: {
    /* n:"BrtEndPCDSDTCSets", */
    T: -1
  },
  /*::[*/
  241: {
    /* n:"BrtBeginPCDSDTCSet", */
    T: 1
  },
  /*::[*/
  242: {
    /* n:"BrtEndPCDSDTCSet", */
    T: -1
  },
  /*::[*/
  243: {
    /* n:"BrtBeginPCDCalcItems", */
    T: 1
  },
  /*::[*/
  244: {
    /* n:"BrtEndPCDCalcItems", */
    T: -1
  },
  /*::[*/
  245: {
    /* n:"BrtBeginPCDCalcItem", */
    T: 1
  },
  /*::[*/
  246: {
    /* n:"BrtEndPCDCalcItem", */
    T: -1
  },
  /*::[*/
  247: {
    /* n:"BrtBeginPRule", */
    T: 1
  },
  /*::[*/
  248: {
    /* n:"BrtEndPRule", */
    T: -1
  },
  /*::[*/
  249: {
    /* n:"BrtBeginPRFilters", */
    T: 1
  },
  /*::[*/
  250: {
    /* n:"BrtEndPRFilters", */
    T: -1
  },
  /*::[*/
  251: {
    /* n:"BrtBeginPRFilter", */
    T: 1
  },
  /*::[*/
  252: {
    /* n:"BrtEndPRFilter", */
    T: -1
  },
  /*::[*/
  253: {
    /* n:"BrtBeginPNames", */
    T: 1
  },
  /*::[*/
  254: {
    /* n:"BrtEndPNames", */
    T: -1
  },
  /*::[*/
  255: {
    /* n:"BrtBeginPName", */
    T: 1
  },
  /*::[*/
  256: {
    /* n:"BrtEndPName", */
    T: -1
  },
  /*::[*/
  257: {
    /* n:"BrtBeginPNPairs", */
    T: 1
  },
  /*::[*/
  258: {
    /* n:"BrtEndPNPairs", */
    T: -1
  },
  /*::[*/
  259: {
    /* n:"BrtBeginPNPair", */
    T: 1
  },
  /*::[*/
  260: {
    /* n:"BrtEndPNPair", */
    T: -1
  },
  /*::[*/
  261: {
    /* n:"BrtBeginECWebProps", */
    T: 1
  },
  /*::[*/
  262: {
    /* n:"BrtEndECWebProps", */
    T: -1
  },
  /*::[*/
  263: {
    /* n:"BrtBeginEcWpTables", */
    T: 1
  },
  /*::[*/
  264: {
    /* n:"BrtEndECWPTables", */
    T: -1
  },
  /*::[*/
  265: {
    /* n:"BrtBeginECParams", */
    T: 1
  },
  /*::[*/
  266: {
    /* n:"BrtEndECParams", */
    T: -1
  },
  /*::[*/
  267: {
    /* n:"BrtBeginECParam", */
    T: 1
  },
  /*::[*/
  268: {
    /* n:"BrtEndECParam", */
    T: -1
  },
  /*::[*/
  269: {
    /* n:"BrtBeginPCDKPIs", */
    T: 1
  },
  /*::[*/
  270: {
    /* n:"BrtEndPCDKPIs", */
    T: -1
  },
  /*::[*/
  271: {
    /* n:"BrtBeginPCDKPI", */
    T: 1
  },
  /*::[*/
  272: {
    /* n:"BrtEndPCDKPI", */
    T: -1
  },
  /*::[*/
  273: {
    /* n:"BrtBeginDims", */
    T: 1
  },
  /*::[*/
  274: {
    /* n:"BrtEndDims", */
    T: -1
  },
  /*::[*/
  275: {
    /* n:"BrtBeginDim", */
    T: 1
  },
  /*::[*/
  276: {
    /* n:"BrtEndDim", */
    T: -1
  },
  /*::[*/
  277: {
    /* n:"BrtIndexPartEnd" */
  },
  /*::[*/
  278: {
    /* n:"BrtBeginStyleSheet", */
    T: 1
  },
  /*::[*/
  279: {
    /* n:"BrtEndStyleSheet", */
    T: -1
  },
  /*::[*/
  280: {
    /* n:"BrtBeginSXView", */
    T: 1
  },
  /*::[*/
  281: {
    /* n:"BrtEndSXVI", */
    T: -1
  },
  /*::[*/
  282: {
    /* n:"BrtBeginSXVI", */
    T: 1
  },
  /*::[*/
  283: {
    /* n:"BrtBeginSXVIs", */
    T: 1
  },
  /*::[*/
  284: {
    /* n:"BrtEndSXVIs", */
    T: -1
  },
  /*::[*/
  285: {
    /* n:"BrtBeginSXVD", */
    T: 1
  },
  /*::[*/
  286: {
    /* n:"BrtEndSXVD", */
    T: -1
  },
  /*::[*/
  287: {
    /* n:"BrtBeginSXVDs", */
    T: 1
  },
  /*::[*/
  288: {
    /* n:"BrtEndSXVDs", */
    T: -1
  },
  /*::[*/
  289: {
    /* n:"BrtBeginSXPI", */
    T: 1
  },
  /*::[*/
  290: {
    /* n:"BrtEndSXPI", */
    T: -1
  },
  /*::[*/
  291: {
    /* n:"BrtBeginSXPIs", */
    T: 1
  },
  /*::[*/
  292: {
    /* n:"BrtEndSXPIs", */
    T: -1
  },
  /*::[*/
  293: {
    /* n:"BrtBeginSXDI", */
    T: 1
  },
  /*::[*/
  294: {
    /* n:"BrtEndSXDI", */
    T: -1
  },
  /*::[*/
  295: {
    /* n:"BrtBeginSXDIs", */
    T: 1
  },
  /*::[*/
  296: {
    /* n:"BrtEndSXDIs", */
    T: -1
  },
  /*::[*/
  297: {
    /* n:"BrtBeginSXLI", */
    T: 1
  },
  /*::[*/
  298: {
    /* n:"BrtEndSXLI", */
    T: -1
  },
  /*::[*/
  299: {
    /* n:"BrtBeginSXLIRws", */
    T: 1
  },
  /*::[*/
  300: {
    /* n:"BrtEndSXLIRws", */
    T: -1
  },
  /*::[*/
  301: {
    /* n:"BrtBeginSXLICols", */
    T: 1
  },
  /*::[*/
  302: {
    /* n:"BrtEndSXLICols", */
    T: -1
  },
  /*::[*/
  303: {
    /* n:"BrtBeginSXFormat", */
    T: 1
  },
  /*::[*/
  304: {
    /* n:"BrtEndSXFormat", */
    T: -1
  },
  /*::[*/
  305: {
    /* n:"BrtBeginSXFormats", */
    T: 1
  },
  /*::[*/
  306: {
    /* n:"BrtEndSxFormats", */
    T: -1
  },
  /*::[*/
  307: {
    /* n:"BrtBeginSxSelect", */
    T: 1
  },
  /*::[*/
  308: {
    /* n:"BrtEndSxSelect", */
    T: -1
  },
  /*::[*/
  309: {
    /* n:"BrtBeginISXVDRws", */
    T: 1
  },
  /*::[*/
  310: {
    /* n:"BrtEndISXVDRws", */
    T: -1
  },
  /*::[*/
  311: {
    /* n:"BrtBeginISXVDCols", */
    T: 1
  },
  /*::[*/
  312: {
    /* n:"BrtEndISXVDCols", */
    T: -1
  },
  /*::[*/
  313: {
    /* n:"BrtEndSXLocation", */
    T: -1
  },
  /*::[*/
  314: {
    /* n:"BrtBeginSXLocation", */
    T: 1
  },
  /*::[*/
  315: {
    /* n:"BrtEndSXView", */
    T: -1
  },
  /*::[*/
  316: {
    /* n:"BrtBeginSXTHs", */
    T: 1
  },
  /*::[*/
  317: {
    /* n:"BrtEndSXTHs", */
    T: -1
  },
  /*::[*/
  318: {
    /* n:"BrtBeginSXTH", */
    T: 1
  },
  /*::[*/
  319: {
    /* n:"BrtEndSXTH", */
    T: -1
  },
  /*::[*/
  320: {
    /* n:"BrtBeginISXTHRws", */
    T: 1
  },
  /*::[*/
  321: {
    /* n:"BrtEndISXTHRws", */
    T: -1
  },
  /*::[*/
  322: {
    /* n:"BrtBeginISXTHCols", */
    T: 1
  },
  /*::[*/
  323: {
    /* n:"BrtEndISXTHCols", */
    T: -1
  },
  /*::[*/
  324: {
    /* n:"BrtBeginSXTDMPS", */
    T: 1
  },
  /*::[*/
  325: {
    /* n:"BrtEndSXTDMPs", */
    T: -1
  },
  /*::[*/
  326: {
    /* n:"BrtBeginSXTDMP", */
    T: 1
  },
  /*::[*/
  327: {
    /* n:"BrtEndSXTDMP", */
    T: -1
  },
  /*::[*/
  328: {
    /* n:"BrtBeginSXTHItems", */
    T: 1
  },
  /*::[*/
  329: {
    /* n:"BrtEndSXTHItems", */
    T: -1
  },
  /*::[*/
  330: {
    /* n:"BrtBeginSXTHItem", */
    T: 1
  },
  /*::[*/
  331: {
    /* n:"BrtEndSXTHItem", */
    T: -1
  },
  /*::[*/
  332: {
    /* n:"BrtBeginMetadata", */
    T: 1
  },
  /*::[*/
  333: {
    /* n:"BrtEndMetadata", */
    T: -1
  },
  /*::[*/
  334: {
    /* n:"BrtBeginEsmdtinfo", */
    T: 1
  },
  /*::[*/
  335: {
    /* n:"BrtMdtinfo", */
    f: LE
  },
  /*::[*/
  336: {
    /* n:"BrtEndEsmdtinfo", */
    T: -1
  },
  /*::[*/
  337: {
    /* n:"BrtBeginEsmdb", */
    f: HE,
    T: 1
  },
  /*::[*/
  338: {
    /* n:"BrtEndEsmdb", */
    T: -1
  },
  /*::[*/
  339: {
    /* n:"BrtBeginEsfmd", */
    T: 1
  },
  /*::[*/
  340: {
    /* n:"BrtEndEsfmd", */
    T: -1
  },
  /*::[*/
  341: {
    /* n:"BrtBeginSingleCells", */
    T: 1
  },
  /*::[*/
  342: {
    /* n:"BrtEndSingleCells", */
    T: -1
  },
  /*::[*/
  343: {
    /* n:"BrtBeginList", */
    T: 1
  },
  /*::[*/
  344: {
    /* n:"BrtEndList", */
    T: -1
  },
  /*::[*/
  345: {
    /* n:"BrtBeginListCols", */
    T: 1
  },
  /*::[*/
  346: {
    /* n:"BrtEndListCols", */
    T: -1
  },
  /*::[*/
  347: {
    /* n:"BrtBeginListCol", */
    T: 1
  },
  /*::[*/
  348: {
    /* n:"BrtEndListCol", */
    T: -1
  },
  /*::[*/
  349: {
    /* n:"BrtBeginListXmlCPr", */
    T: 1
  },
  /*::[*/
  350: {
    /* n:"BrtEndListXmlCPr", */
    T: -1
  },
  /*::[*/
  351: {
    /* n:"BrtListCCFmla" */
  },
  /*::[*/
  352: {
    /* n:"BrtListTrFmla" */
  },
  /*::[*/
  353: {
    /* n:"BrtBeginExternals", */
    T: 1
  },
  /*::[*/
  354: {
    /* n:"BrtEndExternals", */
    T: -1
  },
  /*::[*/
  355: {
    /* n:"BrtSupBookSrc", */
    f: bl
  },
  /*::[*/
  357: {
    /* n:"BrtSupSelf" */
  },
  /*::[*/
  358: {
    /* n:"BrtSupSame" */
  },
  /*::[*/
  359: {
    /* n:"BrtSupTabs" */
  },
  /*::[*/
  360: {
    /* n:"BrtBeginSupBook", */
    T: 1
  },
  /*::[*/
  361: {
    /* n:"BrtPlaceholderName" */
  },
  /*::[*/
  362: {
    /* n:"BrtExternSheet", */
    f: Bv
  },
  /*::[*/
  363: {
    /* n:"BrtExternTableStart" */
  },
  /*::[*/
  364: {
    /* n:"BrtExternTableEnd" */
  },
  /*::[*/
  366: {
    /* n:"BrtExternRowHdr" */
  },
  /*::[*/
  367: {
    /* n:"BrtExternCellBlank" */
  },
  /*::[*/
  368: {
    /* n:"BrtExternCellReal" */
  },
  /*::[*/
  369: {
    /* n:"BrtExternCellBool" */
  },
  /*::[*/
  370: {
    /* n:"BrtExternCellError" */
  },
  /*::[*/
  371: {
    /* n:"BrtExternCellString" */
  },
  /*::[*/
  372: {
    /* n:"BrtBeginEsmdx", */
    T: 1
  },
  /*::[*/
  373: {
    /* n:"BrtEndEsmdx", */
    T: -1
  },
  /*::[*/
  374: {
    /* n:"BrtBeginMdxSet", */
    T: 1
  },
  /*::[*/
  375: {
    /* n:"BrtEndMdxSet", */
    T: -1
  },
  /*::[*/
  376: {
    /* n:"BrtBeginMdxMbrProp", */
    T: 1
  },
  /*::[*/
  377: {
    /* n:"BrtEndMdxMbrProp", */
    T: -1
  },
  /*::[*/
  378: {
    /* n:"BrtBeginMdxKPI", */
    T: 1
  },
  /*::[*/
  379: {
    /* n:"BrtEndMdxKPI", */
    T: -1
  },
  /*::[*/
  380: {
    /* n:"BrtBeginEsstr", */
    T: 1
  },
  /*::[*/
  381: {
    /* n:"BrtEndEsstr", */
    T: -1
  },
  /*::[*/
  382: {
    /* n:"BrtBeginPRFItem", */
    T: 1
  },
  /*::[*/
  383: {
    /* n:"BrtEndPRFItem", */
    T: -1
  },
  /*::[*/
  384: {
    /* n:"BrtBeginPivotCacheIDs", */
    T: 1
  },
  /*::[*/
  385: {
    /* n:"BrtEndPivotCacheIDs", */
    T: -1
  },
  /*::[*/
  386: {
    /* n:"BrtBeginPivotCacheID", */
    T: 1
  },
  /*::[*/
  387: {
    /* n:"BrtEndPivotCacheID", */
    T: -1
  },
  /*::[*/
  388: {
    /* n:"BrtBeginISXVIs", */
    T: 1
  },
  /*::[*/
  389: {
    /* n:"BrtEndISXVIs", */
    T: -1
  },
  /*::[*/
  390: {
    /* n:"BrtBeginColInfos", */
    T: 1
  },
  /*::[*/
  391: {
    /* n:"BrtEndColInfos", */
    T: -1
  },
  /*::[*/
  392: {
    /* n:"BrtBeginRwBrk", */
    T: 1
  },
  /*::[*/
  393: {
    /* n:"BrtEndRwBrk", */
    T: -1
  },
  /*::[*/
  394: {
    /* n:"BrtBeginColBrk", */
    T: 1
  },
  /*::[*/
  395: {
    /* n:"BrtEndColBrk", */
    T: -1
  },
  /*::[*/
  396: {
    /* n:"BrtBrk" */
  },
  /*::[*/
  397: {
    /* n:"BrtUserBookView" */
  },
  /*::[*/
  398: {
    /* n:"BrtInfo" */
  },
  /*::[*/
  399: {
    /* n:"BrtCUsr" */
  },
  /*::[*/
  400: {
    /* n:"BrtUsr" */
  },
  /*::[*/
  401: {
    /* n:"BrtBeginUsers", */
    T: 1
  },
  /*::[*/
  403: {
    /* n:"BrtEOF" */
  },
  /*::[*/
  404: {
    /* n:"BrtUCR" */
  },
  /*::[*/
  405: {
    /* n:"BrtRRInsDel" */
  },
  /*::[*/
  406: {
    /* n:"BrtRREndInsDel" */
  },
  /*::[*/
  407: {
    /* n:"BrtRRMove" */
  },
  /*::[*/
  408: {
    /* n:"BrtRREndMove" */
  },
  /*::[*/
  409: {
    /* n:"BrtRRChgCell" */
  },
  /*::[*/
  410: {
    /* n:"BrtRREndChgCell" */
  },
  /*::[*/
  411: {
    /* n:"BrtRRHeader" */
  },
  /*::[*/
  412: {
    /* n:"BrtRRUserView" */
  },
  /*::[*/
  413: {
    /* n:"BrtRRRenSheet" */
  },
  /*::[*/
  414: {
    /* n:"BrtRRInsertSh" */
  },
  /*::[*/
  415: {
    /* n:"BrtRRDefName" */
  },
  /*::[*/
  416: {
    /* n:"BrtRRNote" */
  },
  /*::[*/
  417: {
    /* n:"BrtRRConflict" */
  },
  /*::[*/
  418: {
    /* n:"BrtRRTQSIF" */
  },
  /*::[*/
  419: {
    /* n:"BrtRRFormat" */
  },
  /*::[*/
  420: {
    /* n:"BrtRREndFormat" */
  },
  /*::[*/
  421: {
    /* n:"BrtRRAutoFmt" */
  },
  /*::[*/
  422: {
    /* n:"BrtBeginUserShViews", */
    T: 1
  },
  /*::[*/
  423: {
    /* n:"BrtBeginUserShView", */
    T: 1
  },
  /*::[*/
  424: {
    /* n:"BrtEndUserShView", */
    T: -1
  },
  /*::[*/
  425: {
    /* n:"BrtEndUserShViews", */
    T: -1
  },
  /*::[*/
  426: {
    /* n:"BrtArrFmla", */
    f: mT
  },
  /*::[*/
  427: {
    /* n:"BrtShrFmla", */
    f: pT
  },
  /*::[*/
  428: {
    /* n:"BrtTable" */
  },
  /*::[*/
  429: {
    /* n:"BrtBeginExtConnections", */
    T: 1
  },
  /*::[*/
  430: {
    /* n:"BrtEndExtConnections", */
    T: -1
  },
  /*::[*/
  431: {
    /* n:"BrtBeginPCDCalcMems", */
    T: 1
  },
  /*::[*/
  432: {
    /* n:"BrtEndPCDCalcMems", */
    T: -1
  },
  /*::[*/
  433: {
    /* n:"BrtBeginPCDCalcMem", */
    T: 1
  },
  /*::[*/
  434: {
    /* n:"BrtEndPCDCalcMem", */
    T: -1
  },
  /*::[*/
  435: {
    /* n:"BrtBeginPCDHGLevels", */
    T: 1
  },
  /*::[*/
  436: {
    /* n:"BrtEndPCDHGLevels", */
    T: -1
  },
  /*::[*/
  437: {
    /* n:"BrtBeginPCDHGLevel", */
    T: 1
  },
  /*::[*/
  438: {
    /* n:"BrtEndPCDHGLevel", */
    T: -1
  },
  /*::[*/
  439: {
    /* n:"BrtBeginPCDHGLGroups", */
    T: 1
  },
  /*::[*/
  440: {
    /* n:"BrtEndPCDHGLGroups", */
    T: -1
  },
  /*::[*/
  441: {
    /* n:"BrtBeginPCDHGLGroup", */
    T: 1
  },
  /*::[*/
  442: {
    /* n:"BrtEndPCDHGLGroup", */
    T: -1
  },
  /*::[*/
  443: {
    /* n:"BrtBeginPCDHGLGMembers", */
    T: 1
  },
  /*::[*/
  444: {
    /* n:"BrtEndPCDHGLGMembers", */
    T: -1
  },
  /*::[*/
  445: {
    /* n:"BrtBeginPCDHGLGMember", */
    T: 1
  },
  /*::[*/
  446: {
    /* n:"BrtEndPCDHGLGMember", */
    T: -1
  },
  /*::[*/
  447: {
    /* n:"BrtBeginQSI", */
    T: 1
  },
  /*::[*/
  448: {
    /* n:"BrtEndQSI", */
    T: -1
  },
  /*::[*/
  449: {
    /* n:"BrtBeginQSIR", */
    T: 1
  },
  /*::[*/
  450: {
    /* n:"BrtEndQSIR", */
    T: -1
  },
  /*::[*/
  451: {
    /* n:"BrtBeginDeletedNames", */
    T: 1
  },
  /*::[*/
  452: {
    /* n:"BrtEndDeletedNames", */
    T: -1
  },
  /*::[*/
  453: {
    /* n:"BrtBeginDeletedName", */
    T: 1
  },
  /*::[*/
  454: {
    /* n:"BrtEndDeletedName", */
    T: -1
  },
  /*::[*/
  455: {
    /* n:"BrtBeginQSIFs", */
    T: 1
  },
  /*::[*/
  456: {
    /* n:"BrtEndQSIFs", */
    T: -1
  },
  /*::[*/
  457: {
    /* n:"BrtBeginQSIF", */
    T: 1
  },
  /*::[*/
  458: {
    /* n:"BrtEndQSIF", */
    T: -1
  },
  /*::[*/
  459: {
    /* n:"BrtBeginAutoSortScope", */
    T: 1
  },
  /*::[*/
  460: {
    /* n:"BrtEndAutoSortScope", */
    T: -1
  },
  /*::[*/
  461: {
    /* n:"BrtBeginConditionalFormatting", */
    T: 1
  },
  /*::[*/
  462: {
    /* n:"BrtEndConditionalFormatting", */
    T: -1
  },
  /*::[*/
  463: {
    /* n:"BrtBeginCFRule", */
    T: 1
  },
  /*::[*/
  464: {
    /* n:"BrtEndCFRule", */
    T: -1
  },
  /*::[*/
  465: {
    /* n:"BrtBeginIconSet", */
    T: 1
  },
  /*::[*/
  466: {
    /* n:"BrtEndIconSet", */
    T: -1
  },
  /*::[*/
  467: {
    /* n:"BrtBeginDatabar", */
    T: 1
  },
  /*::[*/
  468: {
    /* n:"BrtEndDatabar", */
    T: -1
  },
  /*::[*/
  469: {
    /* n:"BrtBeginColorScale", */
    T: 1
  },
  /*::[*/
  470: {
    /* n:"BrtEndColorScale", */
    T: -1
  },
  /*::[*/
  471: {
    /* n:"BrtCFVO" */
  },
  /*::[*/
  472: {
    /* n:"BrtExternValueMeta" */
  },
  /*::[*/
  473: {
    /* n:"BrtBeginColorPalette", */
    T: 1
  },
  /*::[*/
  474: {
    /* n:"BrtEndColorPalette", */
    T: -1
  },
  /*::[*/
  475: {
    /* n:"BrtIndexedColor" */
  },
  /*::[*/
  476: {
    /* n:"BrtMargins", */
    f: gT
  },
  /*::[*/
  477: {
    /* n:"BrtPrintOptions" */
  },
  /*::[*/
  478: {
    /* n:"BrtPageSetup" */
  },
  /*::[*/
  479: {
    /* n:"BrtBeginHeaderFooter", */
    T: 1
  },
  /*::[*/
  480: {
    /* n:"BrtEndHeaderFooter", */
    T: -1
  },
  /*::[*/
  481: {
    /* n:"BrtBeginSXCrtFormat", */
    T: 1
  },
  /*::[*/
  482: {
    /* n:"BrtEndSXCrtFormat", */
    T: -1
  },
  /*::[*/
  483: {
    /* n:"BrtBeginSXCrtFormats", */
    T: 1
  },
  /*::[*/
  484: {
    /* n:"BrtEndSXCrtFormats", */
    T: -1
  },
  /*::[*/
  485: {
    /* n:"BrtWsFmtInfo", */
    f: Sk
  },
  /*::[*/
  486: {
    /* n:"BrtBeginMgs", */
    T: 1
  },
  /*::[*/
  487: {
    /* n:"BrtEndMGs", */
    T: -1
  },
  /*::[*/
  488: {
    /* n:"BrtBeginMGMaps", */
    T: 1
  },
  /*::[*/
  489: {
    /* n:"BrtEndMGMaps", */
    T: -1
  },
  /*::[*/
  490: {
    /* n:"BrtBeginMG", */
    T: 1
  },
  /*::[*/
  491: {
    /* n:"BrtEndMG", */
    T: -1
  },
  /*::[*/
  492: {
    /* n:"BrtBeginMap", */
    T: 1
  },
  /*::[*/
  493: {
    /* n:"BrtEndMap", */
    T: -1
  },
  /*::[*/
  494: {
    /* n:"BrtHLink", */
    f: dT
  },
  /*::[*/
  495: {
    /* n:"BrtBeginDCon", */
    T: 1
  },
  /*::[*/
  496: {
    /* n:"BrtEndDCon", */
    T: -1
  },
  /*::[*/
  497: {
    /* n:"BrtBeginDRefs", */
    T: 1
  },
  /*::[*/
  498: {
    /* n:"BrtEndDRefs", */
    T: -1
  },
  /*::[*/
  499: {
    /* n:"BrtDRef" */
  },
  /*::[*/
  500: {
    /* n:"BrtBeginScenMan", */
    T: 1
  },
  /*::[*/
  501: {
    /* n:"BrtEndScenMan", */
    T: -1
  },
  /*::[*/
  502: {
    /* n:"BrtBeginSct", */
    T: 1
  },
  /*::[*/
  503: {
    /* n:"BrtEndSct", */
    T: -1
  },
  /*::[*/
  504: {
    /* n:"BrtSlc" */
  },
  /*::[*/
  505: {
    /* n:"BrtBeginDXFs", */
    T: 1
  },
  /*::[*/
  506: {
    /* n:"BrtEndDXFs", */
    T: -1
  },
  /*::[*/
  507: {
    /* n:"BrtDXF" */
  },
  /*::[*/
  508: {
    /* n:"BrtBeginTableStyles", */
    T: 1
  },
  /*::[*/
  509: {
    /* n:"BrtEndTableStyles", */
    T: -1
  },
  /*::[*/
  510: {
    /* n:"BrtBeginTableStyle", */
    T: 1
  },
  /*::[*/
  511: {
    /* n:"BrtEndTableStyle", */
    T: -1
  },
  /*::[*/
  512: {
    /* n:"BrtTableStyleElement" */
  },
  /*::[*/
  513: {
    /* n:"BrtTableStyleClient" */
  },
  /*::[*/
  514: {
    /* n:"BrtBeginVolDeps", */
    T: 1
  },
  /*::[*/
  515: {
    /* n:"BrtEndVolDeps", */
    T: -1
  },
  /*::[*/
  516: {
    /* n:"BrtBeginVolType", */
    T: 1
  },
  /*::[*/
  517: {
    /* n:"BrtEndVolType", */
    T: -1
  },
  /*::[*/
  518: {
    /* n:"BrtBeginVolMain", */
    T: 1
  },
  /*::[*/
  519: {
    /* n:"BrtEndVolMain", */
    T: -1
  },
  /*::[*/
  520: {
    /* n:"BrtBeginVolTopic", */
    T: 1
  },
  /*::[*/
  521: {
    /* n:"BrtEndVolTopic", */
    T: -1
  },
  /*::[*/
  522: {
    /* n:"BrtVolSubtopic" */
  },
  /*::[*/
  523: {
    /* n:"BrtVolRef" */
  },
  /*::[*/
  524: {
    /* n:"BrtVolNum" */
  },
  /*::[*/
  525: {
    /* n:"BrtVolErr" */
  },
  /*::[*/
  526: {
    /* n:"BrtVolStr" */
  },
  /*::[*/
  527: {
    /* n:"BrtVolBool" */
  },
  /*::[*/
  528: {
    /* n:"BrtBeginCalcChain$", */
    T: 1
  },
  /*::[*/
  529: {
    /* n:"BrtEndCalcChain$", */
    T: -1
  },
  /*::[*/
  530: {
    /* n:"BrtBeginSortState", */
    T: 1
  },
  /*::[*/
  531: {
    /* n:"BrtEndSortState", */
    T: -1
  },
  /*::[*/
  532: {
    /* n:"BrtBeginSortCond", */
    T: 1
  },
  /*::[*/
  533: {
    /* n:"BrtEndSortCond", */
    T: -1
  },
  /*::[*/
  534: {
    /* n:"BrtBookProtection" */
  },
  /*::[*/
  535: {
    /* n:"BrtSheetProtection" */
  },
  /*::[*/
  536: {
    /* n:"BrtRangeProtection" */
  },
  /*::[*/
  537: {
    /* n:"BrtPhoneticInfo" */
  },
  /*::[*/
  538: {
    /* n:"BrtBeginECTxtWiz", */
    T: 1
  },
  /*::[*/
  539: {
    /* n:"BrtEndECTxtWiz", */
    T: -1
  },
  /*::[*/
  540: {
    /* n:"BrtBeginECTWFldInfoLst", */
    T: 1
  },
  /*::[*/
  541: {
    /* n:"BrtEndECTWFldInfoLst", */
    T: -1
  },
  /*::[*/
  542: {
    /* n:"BrtBeginECTwFldInfo", */
    T: 1
  },
  /*::[*/
  548: {
    /* n:"BrtFileSharing" */
  },
  /*::[*/
  549: {
    /* n:"BrtOleSize" */
  },
  /*::[*/
  550: {
    /* n:"BrtDrawing", */
    f: bl
  },
  /*::[*/
  551: {
    /* n:"BrtLegacyDrawing" */
  },
  /*::[*/
  552: {
    /* n:"BrtLegacyDrawingHF" */
  },
  /*::[*/
  553: {
    /* n:"BrtWebOpt" */
  },
  /*::[*/
  554: {
    /* n:"BrtBeginWebPubItems", */
    T: 1
  },
  /*::[*/
  555: {
    /* n:"BrtEndWebPubItems", */
    T: -1
  },
  /*::[*/
  556: {
    /* n:"BrtBeginWebPubItem", */
    T: 1
  },
  /*::[*/
  557: {
    /* n:"BrtEndWebPubItem", */
    T: -1
  },
  /*::[*/
  558: {
    /* n:"BrtBeginSXCondFmt", */
    T: 1
  },
  /*::[*/
  559: {
    /* n:"BrtEndSXCondFmt", */
    T: -1
  },
  /*::[*/
  560: {
    /* n:"BrtBeginSXCondFmts", */
    T: 1
  },
  /*::[*/
  561: {
    /* n:"BrtEndSXCondFmts", */
    T: -1
  },
  /*::[*/
  562: {
    /* n:"BrtBkHim" */
  },
  /*::[*/
  564: {
    /* n:"BrtColor" */
  },
  /*::[*/
  565: {
    /* n:"BrtBeginIndexedColors", */
    T: 1
  },
  /*::[*/
  566: {
    /* n:"BrtEndIndexedColors", */
    T: -1
  },
  /*::[*/
  569: {
    /* n:"BrtBeginMRUColors", */
    T: 1
  },
  /*::[*/
  570: {
    /* n:"BrtEndMRUColors", */
    T: -1
  },
  /*::[*/
  572: {
    /* n:"BrtMRUColor" */
  },
  /*::[*/
  573: {
    /* n:"BrtBeginDVals", */
    T: 1
  },
  /*::[*/
  574: {
    /* n:"BrtEndDVals", */
    T: -1
  },
  /*::[*/
  577: {
    /* n:"BrtSupNameStart" */
  },
  /*::[*/
  578: {
    /* n:"BrtSupNameValueStart" */
  },
  /*::[*/
  579: {
    /* n:"BrtSupNameValueEnd" */
  },
  /*::[*/
  580: {
    /* n:"BrtSupNameNum" */
  },
  /*::[*/
  581: {
    /* n:"BrtSupNameErr" */
  },
  /*::[*/
  582: {
    /* n:"BrtSupNameSt" */
  },
  /*::[*/
  583: {
    /* n:"BrtSupNameNil" */
  },
  /*::[*/
  584: {
    /* n:"BrtSupNameBool" */
  },
  /*::[*/
  585: {
    /* n:"BrtSupNameFmla" */
  },
  /*::[*/
  586: {
    /* n:"BrtSupNameBits" */
  },
  /*::[*/
  587: {
    /* n:"BrtSupNameEnd" */
  },
  /*::[*/
  588: {
    /* n:"BrtEndSupBook", */
    T: -1
  },
  /*::[*/
  589: {
    /* n:"BrtCellSmartTagProperty" */
  },
  /*::[*/
  590: {
    /* n:"BrtBeginCellSmartTag", */
    T: 1
  },
  /*::[*/
  591: {
    /* n:"BrtEndCellSmartTag", */
    T: -1
  },
  /*::[*/
  592: {
    /* n:"BrtBeginCellSmartTags", */
    T: 1
  },
  /*::[*/
  593: {
    /* n:"BrtEndCellSmartTags", */
    T: -1
  },
  /*::[*/
  594: {
    /* n:"BrtBeginSmartTags", */
    T: 1
  },
  /*::[*/
  595: {
    /* n:"BrtEndSmartTags", */
    T: -1
  },
  /*::[*/
  596: {
    /* n:"BrtSmartTagType" */
  },
  /*::[*/
  597: {
    /* n:"BrtBeginSmartTagTypes", */
    T: 1
  },
  /*::[*/
  598: {
    /* n:"BrtEndSmartTagTypes", */
    T: -1
  },
  /*::[*/
  599: {
    /* n:"BrtBeginSXFilters", */
    T: 1
  },
  /*::[*/
  600: {
    /* n:"BrtEndSXFilters", */
    T: -1
  },
  /*::[*/
  601: {
    /* n:"BrtBeginSXFILTER", */
    T: 1
  },
  /*::[*/
  602: {
    /* n:"BrtEndSXFilter", */
    T: -1
  },
  /*::[*/
  603: {
    /* n:"BrtBeginFills", */
    T: 1
  },
  /*::[*/
  604: {
    /* n:"BrtEndFills", */
    T: -1
  },
  /*::[*/
  605: {
    /* n:"BrtBeginCellWatches", */
    T: 1
  },
  /*::[*/
  606: {
    /* n:"BrtEndCellWatches", */
    T: -1
  },
  /*::[*/
  607: {
    /* n:"BrtCellWatch" */
  },
  /*::[*/
  608: {
    /* n:"BrtBeginCRErrs", */
    T: 1
  },
  /*::[*/
  609: {
    /* n:"BrtEndCRErrs", */
    T: -1
  },
  /*::[*/
  610: {
    /* n:"BrtCrashRecErr" */
  },
  /*::[*/
  611: {
    /* n:"BrtBeginFonts", */
    T: 1
  },
  /*::[*/
  612: {
    /* n:"BrtEndFonts", */
    T: -1
  },
  /*::[*/
  613: {
    /* n:"BrtBeginBorders", */
    T: 1
  },
  /*::[*/
  614: {
    /* n:"BrtEndBorders", */
    T: -1
  },
  /*::[*/
  615: {
    /* n:"BrtBeginFmts", */
    T: 1
  },
  /*::[*/
  616: {
    /* n:"BrtEndFmts", */
    T: -1
  },
  /*::[*/
  617: {
    /* n:"BrtBeginCellXFs", */
    T: 1
  },
  /*::[*/
  618: {
    /* n:"BrtEndCellXFs", */
    T: -1
  },
  /*::[*/
  619: {
    /* n:"BrtBeginStyles", */
    T: 1
  },
  /*::[*/
  620: {
    /* n:"BrtEndStyles", */
    T: -1
  },
  /*::[*/
  625: {
    /* n:"BrtBigName" */
  },
  /*::[*/
  626: {
    /* n:"BrtBeginCellStyleXFs", */
    T: 1
  },
  /*::[*/
  627: {
    /* n:"BrtEndCellStyleXFs", */
    T: -1
  },
  /*::[*/
  628: {
    /* n:"BrtBeginComments", */
    T: 1
  },
  /*::[*/
  629: {
    /* n:"BrtEndComments", */
    T: -1
  },
  /*::[*/
  630: {
    /* n:"BrtBeginCommentAuthors", */
    T: 1
  },
  /*::[*/
  631: {
    /* n:"BrtEndCommentAuthors", */
    T: -1
  },
  /*::[*/
  632: {
    /* n:"BrtCommentAuthor", */
    f: s7
  },
  /*::[*/
  633: {
    /* n:"BrtBeginCommentList", */
    T: 1
  },
  /*::[*/
  634: {
    /* n:"BrtEndCommentList", */
    T: -1
  },
  /*::[*/
  635: {
    /* n:"BrtBeginComment", */
    T: 1,
    f: n7
  },
  /*::[*/
  636: {
    /* n:"BrtEndComment", */
    T: -1
  },
  /*::[*/
  637: {
    /* n:"BrtCommentText", */
    f: F_
  },
  /*::[*/
  638: {
    /* n:"BrtBeginOleObjects", */
    T: 1
  },
  /*::[*/
  639: {
    /* n:"BrtOleObject" */
  },
  /*::[*/
  640: {
    /* n:"BrtEndOleObjects", */
    T: -1
  },
  /*::[*/
  641: {
    /* n:"BrtBeginSxrules", */
    T: 1
  },
  /*::[*/
  642: {
    /* n:"BrtEndSxRules", */
    T: -1
  },
  /*::[*/
  643: {
    /* n:"BrtBeginActiveXControls", */
    T: 1
  },
  /*::[*/
  644: {
    /* n:"BrtActiveX" */
  },
  /*::[*/
  645: {
    /* n:"BrtEndActiveXControls", */
    T: -1
  },
  /*::[*/
  646: {
    /* n:"BrtBeginPCDSDTCEMembersSortBy", */
    T: 1
  },
  /*::[*/
  648: {
    /* n:"BrtBeginCellIgnoreECs", */
    T: 1
  },
  /*::[*/
  649: {
    /* n:"BrtCellIgnoreEC" */
  },
  /*::[*/
  650: {
    /* n:"BrtEndCellIgnoreECs", */
    T: -1
  },
  /*::[*/
  651: {
    /* n:"BrtCsProp", */
    f: VT
  },
  /*::[*/
  652: {
    /* n:"BrtCsPageSetup" */
  },
  /*::[*/
  653: {
    /* n:"BrtBeginUserCsViews", */
    T: 1
  },
  /*::[*/
  654: {
    /* n:"BrtEndUserCsViews", */
    T: -1
  },
  /*::[*/
  655: {
    /* n:"BrtBeginUserCsView", */
    T: 1
  },
  /*::[*/
  656: {
    /* n:"BrtEndUserCsView", */
    T: -1
  },
  /*::[*/
  657: {
    /* n:"BrtBeginPcdSFCIEntries", */
    T: 1
  },
  /*::[*/
  658: {
    /* n:"BrtEndPCDSFCIEntries", */
    T: -1
  },
  /*::[*/
  659: {
    /* n:"BrtPCDSFCIEntry" */
  },
  /*::[*/
  660: {
    /* n:"BrtBeginListParts", */
    T: 1
  },
  /*::[*/
  661: {
    /* n:"BrtListPart" */
  },
  /*::[*/
  662: {
    /* n:"BrtEndListParts", */
    T: -1
  },
  /*::[*/
  663: {
    /* n:"BrtSheetCalcProp" */
  },
  /*::[*/
  664: {
    /* n:"BrtBeginFnGroup", */
    T: 1
  },
  /*::[*/
  665: {
    /* n:"BrtFnGroup" */
  },
  /*::[*/
  666: {
    /* n:"BrtEndFnGroup", */
    T: -1
  },
  /*::[*/
  667: {
    /* n:"BrtSupAddin" */
  },
  /*::[*/
  668: {
    /* n:"BrtSXTDMPOrder" */
  },
  /*::[*/
  669: {
    /* n:"BrtCsProtection" */
  },
  /*::[*/
  671: {
    /* n:"BrtBeginWsSortMap", */
    T: 1
  },
  /*::[*/
  672: {
    /* n:"BrtEndWsSortMap", */
    T: -1
  },
  /*::[*/
  673: {
    /* n:"BrtBeginRRSort", */
    T: 1
  },
  /*::[*/
  674: {
    /* n:"BrtEndRRSort", */
    T: -1
  },
  /*::[*/
  675: {
    /* n:"BrtRRSortItem" */
  },
  /*::[*/
  676: {
    /* n:"BrtFileSharingIso" */
  },
  /*::[*/
  677: {
    /* n:"BrtBookProtectionIso" */
  },
  /*::[*/
  678: {
    /* n:"BrtSheetProtectionIso" */
  },
  /*::[*/
  679: {
    /* n:"BrtCsProtectionIso" */
  },
  /*::[*/
  680: {
    /* n:"BrtRangeProtectionIso" */
  },
  /*::[*/
  681: {
    /* n:"BrtDValList" */
  },
  /*::[*/
  1024: {
    /* n:"BrtRwDescent" */
  },
  /*::[*/
  1025: {
    /* n:"BrtKnownFonts" */
  },
  /*::[*/
  1026: {
    /* n:"BrtBeginSXTupleSet", */
    T: 1
  },
  /*::[*/
  1027: {
    /* n:"BrtEndSXTupleSet", */
    T: -1
  },
  /*::[*/
  1028: {
    /* n:"BrtBeginSXTupleSetHeader", */
    T: 1
  },
  /*::[*/
  1029: {
    /* n:"BrtEndSXTupleSetHeader", */
    T: -1
  },
  /*::[*/
  1030: {
    /* n:"BrtSXTupleSetHeaderItem" */
  },
  /*::[*/
  1031: {
    /* n:"BrtBeginSXTupleSetData", */
    T: 1
  },
  /*::[*/
  1032: {
    /* n:"BrtEndSXTupleSetData", */
    T: -1
  },
  /*::[*/
  1033: {
    /* n:"BrtBeginSXTupleSetRow", */
    T: 1
  },
  /*::[*/
  1034: {
    /* n:"BrtEndSXTupleSetRow", */
    T: -1
  },
  /*::[*/
  1035: {
    /* n:"BrtSXTupleSetRowItem" */
  },
  /*::[*/
  1036: {
    /* n:"BrtNameExt" */
  },
  /*::[*/
  1037: {
    /* n:"BrtPCDH14" */
  },
  /*::[*/
  1038: {
    /* n:"BrtBeginPCDCalcMem14", */
    T: 1
  },
  /*::[*/
  1039: {
    /* n:"BrtEndPCDCalcMem14", */
    T: -1
  },
  /*::[*/
  1040: {
    /* n:"BrtSXTH14" */
  },
  /*::[*/
  1041: {
    /* n:"BrtBeginSparklineGroup", */
    T: 1
  },
  /*::[*/
  1042: {
    /* n:"BrtEndSparklineGroup", */
    T: -1
  },
  /*::[*/
  1043: {
    /* n:"BrtSparkline" */
  },
  /*::[*/
  1044: {
    /* n:"BrtSXDI14" */
  },
  /*::[*/
  1045: {
    /* n:"BrtWsFmtInfoEx14" */
  },
  /*::[*/
  1046: {
    /* n:"BrtBeginConditionalFormatting14", */
    T: 1
  },
  /*::[*/
  1047: {
    /* n:"BrtEndConditionalFormatting14", */
    T: -1
  },
  /*::[*/
  1048: {
    /* n:"BrtBeginCFRule14", */
    T: 1
  },
  /*::[*/
  1049: {
    /* n:"BrtEndCFRule14", */
    T: -1
  },
  /*::[*/
  1050: {
    /* n:"BrtCFVO14" */
  },
  /*::[*/
  1051: {
    /* n:"BrtBeginDatabar14", */
    T: 1
  },
  /*::[*/
  1052: {
    /* n:"BrtBeginIconSet14", */
    T: 1
  },
  /*::[*/
  1053: {
    /* n:"BrtDVal14", */
    f: ET
  },
  /*::[*/
  1054: {
    /* n:"BrtBeginDVals14", */
    T: 1
  },
  /*::[*/
  1055: {
    /* n:"BrtColor14" */
  },
  /*::[*/
  1056: {
    /* n:"BrtBeginSparklines", */
    T: 1
  },
  /*::[*/
  1057: {
    /* n:"BrtEndSparklines", */
    T: -1
  },
  /*::[*/
  1058: {
    /* n:"BrtBeginSparklineGroups", */
    T: 1
  },
  /*::[*/
  1059: {
    /* n:"BrtEndSparklineGroups", */
    T: -1
  },
  /*::[*/
  1061: {
    /* n:"BrtSXVD14" */
  },
  /*::[*/
  1062: {
    /* n:"BrtBeginSXView14", */
    T: 1
  },
  /*::[*/
  1063: {
    /* n:"BrtEndSXView14", */
    T: -1
  },
  /*::[*/
  1064: {
    /* n:"BrtBeginSXView16", */
    T: 1
  },
  /*::[*/
  1065: {
    /* n:"BrtEndSXView16", */
    T: -1
  },
  /*::[*/
  1066: {
    /* n:"BrtBeginPCD14", */
    T: 1
  },
  /*::[*/
  1067: {
    /* n:"BrtEndPCD14", */
    T: -1
  },
  /*::[*/
  1068: {
    /* n:"BrtBeginExtConn14", */
    T: 1
  },
  /*::[*/
  1069: {
    /* n:"BrtEndExtConn14", */
    T: -1
  },
  /*::[*/
  1070: {
    /* n:"BrtBeginSlicerCacheIDs", */
    T: 1
  },
  /*::[*/
  1071: {
    /* n:"BrtEndSlicerCacheIDs", */
    T: -1
  },
  /*::[*/
  1072: {
    /* n:"BrtBeginSlicerCacheID", */
    T: 1
  },
  /*::[*/
  1073: {
    /* n:"BrtEndSlicerCacheID", */
    T: -1
  },
  /*::[*/
  1075: {
    /* n:"BrtBeginSlicerCache", */
    T: 1
  },
  /*::[*/
  1076: {
    /* n:"BrtEndSlicerCache", */
    T: -1
  },
  /*::[*/
  1077: {
    /* n:"BrtBeginSlicerCacheDef", */
    T: 1
  },
  /*::[*/
  1078: {
    /* n:"BrtEndSlicerCacheDef", */
    T: -1
  },
  /*::[*/
  1079: {
    /* n:"BrtBeginSlicersEx", */
    T: 1
  },
  /*::[*/
  1080: {
    /* n:"BrtEndSlicersEx", */
    T: -1
  },
  /*::[*/
  1081: {
    /* n:"BrtBeginSlicerEx", */
    T: 1
  },
  /*::[*/
  1082: {
    /* n:"BrtEndSlicerEx", */
    T: -1
  },
  /*::[*/
  1083: {
    /* n:"BrtBeginSlicer", */
    T: 1
  },
  /*::[*/
  1084: {
    /* n:"BrtEndSlicer", */
    T: -1
  },
  /*::[*/
  1085: {
    /* n:"BrtSlicerCachePivotTables" */
  },
  /*::[*/
  1086: {
    /* n:"BrtBeginSlicerCacheOlapImpl", */
    T: 1
  },
  /*::[*/
  1087: {
    /* n:"BrtEndSlicerCacheOlapImpl", */
    T: -1
  },
  /*::[*/
  1088: {
    /* n:"BrtBeginSlicerCacheLevelsData", */
    T: 1
  },
  /*::[*/
  1089: {
    /* n:"BrtEndSlicerCacheLevelsData", */
    T: -1
  },
  /*::[*/
  1090: {
    /* n:"BrtBeginSlicerCacheLevelData", */
    T: 1
  },
  /*::[*/
  1091: {
    /* n:"BrtEndSlicerCacheLevelData", */
    T: -1
  },
  /*::[*/
  1092: {
    /* n:"BrtBeginSlicerCacheSiRanges", */
    T: 1
  },
  /*::[*/
  1093: {
    /* n:"BrtEndSlicerCacheSiRanges", */
    T: -1
  },
  /*::[*/
  1094: {
    /* n:"BrtBeginSlicerCacheSiRange", */
    T: 1
  },
  /*::[*/
  1095: {
    /* n:"BrtEndSlicerCacheSiRange", */
    T: -1
  },
  /*::[*/
  1096: {
    /* n:"BrtSlicerCacheOlapItem" */
  },
  /*::[*/
  1097: {
    /* n:"BrtBeginSlicerCacheSelections", */
    T: 1
  },
  /*::[*/
  1098: {
    /* n:"BrtSlicerCacheSelection" */
  },
  /*::[*/
  1099: {
    /* n:"BrtEndSlicerCacheSelections", */
    T: -1
  },
  /*::[*/
  1100: {
    /* n:"BrtBeginSlicerCacheNative", */
    T: 1
  },
  /*::[*/
  1101: {
    /* n:"BrtEndSlicerCacheNative", */
    T: -1
  },
  /*::[*/
  1102: {
    /* n:"BrtSlicerCacheNativeItem" */
  },
  /*::[*/
  1103: {
    /* n:"BrtRangeProtection14" */
  },
  /*::[*/
  1104: {
    /* n:"BrtRangeProtectionIso14" */
  },
  /*::[*/
  1105: {
    /* n:"BrtCellIgnoreEC14" */
  },
  /*::[*/
  1111: {
    /* n:"BrtList14" */
  },
  /*::[*/
  1112: {
    /* n:"BrtCFIcon" */
  },
  /*::[*/
  1113: {
    /* n:"BrtBeginSlicerCachesPivotCacheIDs", */
    T: 1
  },
  /*::[*/
  1114: {
    /* n:"BrtEndSlicerCachesPivotCacheIDs", */
    T: -1
  },
  /*::[*/
  1115: {
    /* n:"BrtBeginSlicers", */
    T: 1
  },
  /*::[*/
  1116: {
    /* n:"BrtEndSlicers", */
    T: -1
  },
  /*::[*/
  1117: {
    /* n:"BrtWbProp14" */
  },
  /*::[*/
  1118: {
    /* n:"BrtBeginSXEdit", */
    T: 1
  },
  /*::[*/
  1119: {
    /* n:"BrtEndSXEdit", */
    T: -1
  },
  /*::[*/
  1120: {
    /* n:"BrtBeginSXEdits", */
    T: 1
  },
  /*::[*/
  1121: {
    /* n:"BrtEndSXEdits", */
    T: -1
  },
  /*::[*/
  1122: {
    /* n:"BrtBeginSXChange", */
    T: 1
  },
  /*::[*/
  1123: {
    /* n:"BrtEndSXChange", */
    T: -1
  },
  /*::[*/
  1124: {
    /* n:"BrtBeginSXChanges", */
    T: 1
  },
  /*::[*/
  1125: {
    /* n:"BrtEndSXChanges", */
    T: -1
  },
  /*::[*/
  1126: {
    /* n:"BrtSXTupleItems" */
  },
  /*::[*/
  1128: {
    /* n:"BrtBeginSlicerStyle", */
    T: 1
  },
  /*::[*/
  1129: {
    /* n:"BrtEndSlicerStyle", */
    T: -1
  },
  /*::[*/
  1130: {
    /* n:"BrtSlicerStyleElement" */
  },
  /*::[*/
  1131: {
    /* n:"BrtBeginStyleSheetExt14", */
    T: 1
  },
  /*::[*/
  1132: {
    /* n:"BrtEndStyleSheetExt14", */
    T: -1
  },
  /*::[*/
  1133: {
    /* n:"BrtBeginSlicerCachesPivotCacheID", */
    T: 1
  },
  /*::[*/
  1134: {
    /* n:"BrtEndSlicerCachesPivotCacheID", */
    T: -1
  },
  /*::[*/
  1135: {
    /* n:"BrtBeginConditionalFormattings", */
    T: 1
  },
  /*::[*/
  1136: {
    /* n:"BrtEndConditionalFormattings", */
    T: -1
  },
  /*::[*/
  1137: {
    /* n:"BrtBeginPCDCalcMemExt", */
    T: 1
  },
  /*::[*/
  1138: {
    /* n:"BrtEndPCDCalcMemExt", */
    T: -1
  },
  /*::[*/
  1139: {
    /* n:"BrtBeginPCDCalcMemsExt", */
    T: 1
  },
  /*::[*/
  1140: {
    /* n:"BrtEndPCDCalcMemsExt", */
    T: -1
  },
  /*::[*/
  1141: {
    /* n:"BrtPCDField14" */
  },
  /*::[*/
  1142: {
    /* n:"BrtBeginSlicerStyles", */
    T: 1
  },
  /*::[*/
  1143: {
    /* n:"BrtEndSlicerStyles", */
    T: -1
  },
  /*::[*/
  1144: {
    /* n:"BrtBeginSlicerStyleElements", */
    T: 1
  },
  /*::[*/
  1145: {
    /* n:"BrtEndSlicerStyleElements", */
    T: -1
  },
  /*::[*/
  1146: {
    /* n:"BrtCFRuleExt" */
  },
  /*::[*/
  1147: {
    /* n:"BrtBeginSXCondFmt14", */
    T: 1
  },
  /*::[*/
  1148: {
    /* n:"BrtEndSXCondFmt14", */
    T: -1
  },
  /*::[*/
  1149: {
    /* n:"BrtBeginSXCondFmts14", */
    T: 1
  },
  /*::[*/
  1150: {
    /* n:"BrtEndSXCondFmts14", */
    T: -1
  },
  /*::[*/
  1152: {
    /* n:"BrtBeginSortCond14", */
    T: 1
  },
  /*::[*/
  1153: {
    /* n:"BrtEndSortCond14", */
    T: -1
  },
  /*::[*/
  1154: {
    /* n:"BrtEndDVals14", */
    T: -1
  },
  /*::[*/
  1155: {
    /* n:"BrtEndIconSet14", */
    T: -1
  },
  /*::[*/
  1156: {
    /* n:"BrtEndDatabar14", */
    T: -1
  },
  /*::[*/
  1157: {
    /* n:"BrtBeginColorScale14", */
    T: 1
  },
  /*::[*/
  1158: {
    /* n:"BrtEndColorScale14", */
    T: -1
  },
  /*::[*/
  1159: {
    /* n:"BrtBeginSxrules14", */
    T: 1
  },
  /*::[*/
  1160: {
    /* n:"BrtEndSxrules14", */
    T: -1
  },
  /*::[*/
  1161: {
    /* n:"BrtBeginPRule14", */
    T: 1
  },
  /*::[*/
  1162: {
    /* n:"BrtEndPRule14", */
    T: -1
  },
  /*::[*/
  1163: {
    /* n:"BrtBeginPRFilters14", */
    T: 1
  },
  /*::[*/
  1164: {
    /* n:"BrtEndPRFilters14", */
    T: -1
  },
  /*::[*/
  1165: {
    /* n:"BrtBeginPRFilter14", */
    T: 1
  },
  /*::[*/
  1166: {
    /* n:"BrtEndPRFilter14", */
    T: -1
  },
  /*::[*/
  1167: {
    /* n:"BrtBeginPRFItem14", */
    T: 1
  },
  /*::[*/
  1168: {
    /* n:"BrtEndPRFItem14", */
    T: -1
  },
  /*::[*/
  1169: {
    /* n:"BrtBeginCellIgnoreECs14", */
    T: 1
  },
  /*::[*/
  1170: {
    /* n:"BrtEndCellIgnoreECs14", */
    T: -1
  },
  /*::[*/
  1171: {
    /* n:"BrtDxf14" */
  },
  /*::[*/
  1172: {
    /* n:"BrtBeginDxF14s", */
    T: 1
  },
  /*::[*/
  1173: {
    /* n:"BrtEndDxf14s", */
    T: -1
  },
  /*::[*/
  1177: {
    /* n:"BrtFilter14" */
  },
  /*::[*/
  1178: {
    /* n:"BrtBeginCustomFilters14", */
    T: 1
  },
  /*::[*/
  1180: {
    /* n:"BrtCustomFilter14" */
  },
  /*::[*/
  1181: {
    /* n:"BrtIconFilter14" */
  },
  /*::[*/
  1182: {
    /* n:"BrtPivotCacheConnectionName" */
  },
  /*::[*/
  2048: {
    /* n:"BrtBeginDecoupledPivotCacheIDs", */
    T: 1
  },
  /*::[*/
  2049: {
    /* n:"BrtEndDecoupledPivotCacheIDs", */
    T: -1
  },
  /*::[*/
  2050: {
    /* n:"BrtDecoupledPivotCacheID" */
  },
  /*::[*/
  2051: {
    /* n:"BrtBeginPivotTableRefs", */
    T: 1
  },
  /*::[*/
  2052: {
    /* n:"BrtEndPivotTableRefs", */
    T: -1
  },
  /*::[*/
  2053: {
    /* n:"BrtPivotTableRef" */
  },
  /*::[*/
  2054: {
    /* n:"BrtSlicerCacheBookPivotTables" */
  },
  /*::[*/
  2055: {
    /* n:"BrtBeginSxvcells", */
    T: 1
  },
  /*::[*/
  2056: {
    /* n:"BrtEndSxvcells", */
    T: -1
  },
  /*::[*/
  2057: {
    /* n:"BrtBeginSxRow", */
    T: 1
  },
  /*::[*/
  2058: {
    /* n:"BrtEndSxRow", */
    T: -1
  },
  /*::[*/
  2060: {
    /* n:"BrtPcdCalcMem15" */
  },
  /*::[*/
  2067: {
    /* n:"BrtQsi15" */
  },
  /*::[*/
  2068: {
    /* n:"BrtBeginWebExtensions", */
    T: 1
  },
  /*::[*/
  2069: {
    /* n:"BrtEndWebExtensions", */
    T: -1
  },
  /*::[*/
  2070: {
    /* n:"BrtWebExtension" */
  },
  /*::[*/
  2071: {
    /* n:"BrtAbsPath15" */
  },
  /*::[*/
  2072: {
    /* n:"BrtBeginPivotTableUISettings", */
    T: 1
  },
  /*::[*/
  2073: {
    /* n:"BrtEndPivotTableUISettings", */
    T: -1
  },
  /*::[*/
  2075: {
    /* n:"BrtTableSlicerCacheIDs" */
  },
  /*::[*/
  2076: {
    /* n:"BrtTableSlicerCacheID" */
  },
  /*::[*/
  2077: {
    /* n:"BrtBeginTableSlicerCache", */
    T: 1
  },
  /*::[*/
  2078: {
    /* n:"BrtEndTableSlicerCache", */
    T: -1
  },
  /*::[*/
  2079: {
    /* n:"BrtSxFilter15" */
  },
  /*::[*/
  2080: {
    /* n:"BrtBeginTimelineCachePivotCacheIDs", */
    T: 1
  },
  /*::[*/
  2081: {
    /* n:"BrtEndTimelineCachePivotCacheIDs", */
    T: -1
  },
  /*::[*/
  2082: {
    /* n:"BrtTimelineCachePivotCacheID" */
  },
  /*::[*/
  2083: {
    /* n:"BrtBeginTimelineCacheIDs", */
    T: 1
  },
  /*::[*/
  2084: {
    /* n:"BrtEndTimelineCacheIDs", */
    T: -1
  },
  /*::[*/
  2085: {
    /* n:"BrtBeginTimelineCacheID", */
    T: 1
  },
  /*::[*/
  2086: {
    /* n:"BrtEndTimelineCacheID", */
    T: -1
  },
  /*::[*/
  2087: {
    /* n:"BrtBeginTimelinesEx", */
    T: 1
  },
  /*::[*/
  2088: {
    /* n:"BrtEndTimelinesEx", */
    T: -1
  },
  /*::[*/
  2089: {
    /* n:"BrtBeginTimelineEx", */
    T: 1
  },
  /*::[*/
  2090: {
    /* n:"BrtEndTimelineEx", */
    T: -1
  },
  /*::[*/
  2091: {
    /* n:"BrtWorkBookPr15" */
  },
  /*::[*/
  2092: {
    /* n:"BrtPCDH15" */
  },
  /*::[*/
  2093: {
    /* n:"BrtBeginTimelineStyle", */
    T: 1
  },
  /*::[*/
  2094: {
    /* n:"BrtEndTimelineStyle", */
    T: -1
  },
  /*::[*/
  2095: {
    /* n:"BrtTimelineStyleElement" */
  },
  /*::[*/
  2096: {
    /* n:"BrtBeginTimelineStylesheetExt15", */
    T: 1
  },
  /*::[*/
  2097: {
    /* n:"BrtEndTimelineStylesheetExt15", */
    T: -1
  },
  /*::[*/
  2098: {
    /* n:"BrtBeginTimelineStyles", */
    T: 1
  },
  /*::[*/
  2099: {
    /* n:"BrtEndTimelineStyles", */
    T: -1
  },
  /*::[*/
  2100: {
    /* n:"BrtBeginTimelineStyleElements", */
    T: 1
  },
  /*::[*/
  2101: {
    /* n:"BrtEndTimelineStyleElements", */
    T: -1
  },
  /*::[*/
  2102: {
    /* n:"BrtDxf15" */
  },
  /*::[*/
  2103: {
    /* n:"BrtBeginDxfs15", */
    T: 1
  },
  /*::[*/
  2104: {
    /* n:"BrtEndDxfs15", */
    T: -1
  },
  /*::[*/
  2105: {
    /* n:"BrtSlicerCacheHideItemsWithNoData" */
  },
  /*::[*/
  2106: {
    /* n:"BrtBeginItemUniqueNames", */
    T: 1
  },
  /*::[*/
  2107: {
    /* n:"BrtEndItemUniqueNames", */
    T: -1
  },
  /*::[*/
  2108: {
    /* n:"BrtItemUniqueName" */
  },
  /*::[*/
  2109: {
    /* n:"BrtBeginExtConn15", */
    T: 1
  },
  /*::[*/
  2110: {
    /* n:"BrtEndExtConn15", */
    T: -1
  },
  /*::[*/
  2111: {
    /* n:"BrtBeginOledbPr15", */
    T: 1
  },
  /*::[*/
  2112: {
    /* n:"BrtEndOledbPr15", */
    T: -1
  },
  /*::[*/
  2113: {
    /* n:"BrtBeginDataFeedPr15", */
    T: 1
  },
  /*::[*/
  2114: {
    /* n:"BrtEndDataFeedPr15", */
    T: -1
  },
  /*::[*/
  2115: {
    /* n:"BrtTextPr15" */
  },
  /*::[*/
  2116: {
    /* n:"BrtRangePr15" */
  },
  /*::[*/
  2117: {
    /* n:"BrtDbCommand15" */
  },
  /*::[*/
  2118: {
    /* n:"BrtBeginDbTables15", */
    T: 1
  },
  /*::[*/
  2119: {
    /* n:"BrtEndDbTables15", */
    T: -1
  },
  /*::[*/
  2120: {
    /* n:"BrtDbTable15" */
  },
  /*::[*/
  2121: {
    /* n:"BrtBeginDataModel", */
    T: 1
  },
  /*::[*/
  2122: {
    /* n:"BrtEndDataModel", */
    T: -1
  },
  /*::[*/
  2123: {
    /* n:"BrtBeginModelTables", */
    T: 1
  },
  /*::[*/
  2124: {
    /* n:"BrtEndModelTables", */
    T: -1
  },
  /*::[*/
  2125: {
    /* n:"BrtModelTable" */
  },
  /*::[*/
  2126: {
    /* n:"BrtBeginModelRelationships", */
    T: 1
  },
  /*::[*/
  2127: {
    /* n:"BrtEndModelRelationships", */
    T: -1
  },
  /*::[*/
  2128: {
    /* n:"BrtModelRelationship" */
  },
  /*::[*/
  2129: {
    /* n:"BrtBeginECTxtWiz15", */
    T: 1
  },
  /*::[*/
  2130: {
    /* n:"BrtEndECTxtWiz15", */
    T: -1
  },
  /*::[*/
  2131: {
    /* n:"BrtBeginECTWFldInfoLst15", */
    T: 1
  },
  /*::[*/
  2132: {
    /* n:"BrtEndECTWFldInfoLst15", */
    T: -1
  },
  /*::[*/
  2133: {
    /* n:"BrtBeginECTWFldInfo15", */
    T: 1
  },
  /*::[*/
  2134: {
    /* n:"BrtFieldListActiveItem" */
  },
  /*::[*/
  2135: {
    /* n:"BrtPivotCacheIdVersion" */
  },
  /*::[*/
  2136: {
    /* n:"BrtSXDI15" */
  },
  /*::[*/
  2137: {
    /* n:"BrtBeginModelTimeGroupings", */
    T: 1
  },
  /*::[*/
  2138: {
    /* n:"BrtEndModelTimeGroupings", */
    T: -1
  },
  /*::[*/
  2139: {
    /* n:"BrtBeginModelTimeGrouping", */
    T: 1
  },
  /*::[*/
  2140: {
    /* n:"BrtEndModelTimeGrouping", */
    T: -1
  },
  /*::[*/
  2141: {
    /* n:"BrtModelTimeGroupingCalcCol" */
  },
  /*::[*/
  3072: {
    /* n:"BrtUid" */
  },
  /*::[*/
  3073: {
    /* n:"BrtRevisionPtr" */
  },
  /*::[*/
  4096: {
    /* n:"BrtBeginDynamicArrayPr", */
    T: 1
  },
  /*::[*/
  4097: {
    /* n:"BrtEndDynamicArrayPr", */
    T: -1
  },
  /*::[*/
  5002: {
    /* n:"BrtBeginRichValueBlock", */
    T: 1
  },
  /*::[*/
  5003: {
    /* n:"BrtEndRichValueBlock", */
    T: -1
  },
  /*::[*/
  5081: {
    /* n:"BrtBeginRichFilters", */
    T: 1
  },
  /*::[*/
  5082: {
    /* n:"BrtEndRichFilters", */
    T: -1
  },
  /*::[*/
  5083: {
    /* n:"BrtRichFilter" */
  },
  /*::[*/
  5084: {
    /* n:"BrtBeginRichFilterColumn", */
    T: 1
  },
  /*::[*/
  5085: {
    /* n:"BrtEndRichFilterColumn", */
    T: -1
  },
  /*::[*/
  5086: {
    /* n:"BrtBeginCustomRichFilters", */
    T: 1
  },
  /*::[*/
  5087: {
    /* n:"BrtEndCustomRichFilters", */
    T: -1
  },
  /*::[*/
  5088: {
    /* n:"BrtCustomRichFilter" */
  },
  /*::[*/
  5089: {
    /* n:"BrtTop10RichFilter" */
  },
  /*::[*/
  5090: {
    /* n:"BrtDynamicRichFilter" */
  },
  /*::[*/
  5092: {
    /* n:"BrtBeginRichSortCondition", */
    T: 1
  },
  /*::[*/
  5093: {
    /* n:"BrtEndRichSortCondition", */
    T: -1
  },
  /*::[*/
  5094: {
    /* n:"BrtRichFilterDateGroupItem" */
  },
  /*::[*/
  5095: {
    /* n:"BrtBeginCalcFeatures", */
    T: 1
  },
  /*::[*/
  5096: {
    /* n:"BrtEndCalcFeatures", */
    T: -1
  },
  /*::[*/
  5097: {
    /* n:"BrtCalcFeature" */
  },
  /*::[*/
  5099: {
    /* n:"BrtExternalLinksPr" */
  },
  /*::[*/
  65535: { n: "" }
}, Sl = {
  /* [MS-XLS] 2.3 Record Enumeration 2021-08-17 */
  /*::[*/
  6: {
    /* n:"Formula", */
    f: pu
  },
  /*::[*/
  10: {
    /* n:"EOF", */
    f: ba
  },
  /*::[*/
  12: {
    /* n:"CalcCount", */
    f: Tr
  },
  //
  /*::[*/
  13: {
    /* n:"CalcMode", */
    f: Tr
  },
  //
  /*::[*/
  14: {
    /* n:"CalcPrecision", */
    f: _r
  },
  //
  /*::[*/
  15: {
    /* n:"CalcRefMode", */
    f: _r
  },
  //
  /*::[*/
  16: {
    /* n:"CalcDelta", */
    f: Xr
  },
  //
  /*::[*/
  17: {
    /* n:"CalcIter", */
    f: _r
  },
  //
  /*::[*/
  18: {
    /* n:"Protect", */
    f: _r
  },
  /*::[*/
  19: {
    /* n:"Password", */
    f: Tr
  },
  /*::[*/
  20: {
    /* n:"Header", */
    f: uh
  },
  /*::[*/
  21: {
    /* n:"Footer", */
    f: uh
  },
  /*::[*/
  23: {
    /* n:"ExternSheet", */
    f: Bv
  },
  /*::[*/
  24: {
    /* n:"Lbl", */
    f: ch
  },
  /*::[*/
  25: {
    /* n:"WinProtect", */
    f: _r
  },
  /*::[*/
  26: {
    /* n:"VerticalPageBreaks", */
  },
  /*::[*/
  27: {
    /* n:"HorizontalPageBreaks", */
  },
  /*::[*/
  28: {
    /* n:"Note", */
    f: E$
  },
  /*::[*/
  29: {
    /* n:"Selection", */
  },
  /*::[*/
  34: {
    /* n:"Date1904", */
    f: _r
  },
  /*::[*/
  35: {
    /* n:"ExternName", */
    f: lh
  },
  /*::[*/
  38: {
    /* n:"LeftMargin", */
    f: Xr
  },
  // *
  /*::[*/
  39: {
    /* n:"RightMargin", */
    f: Xr
  },
  // *
  /*::[*/
  40: {
    /* n:"TopMargin", */
    f: Xr
  },
  // *
  /*::[*/
  41: {
    /* n:"BottomMargin", */
    f: Xr
  },
  // *
  /*::[*/
  42: {
    /* n:"PrintRowCol", */
    f: _r
  },
  /*::[*/
  43: {
    /* n:"PrintGrid", */
    f: _r
  },
  /*::[*/
  47: {
    /* n:"FilePass", */
    f: OD
  },
  /*::[*/
  49: {
    /* n:"Font", */
    f: q6
  },
  /*::[*/
  51: {
    /* n:"PrintSize", */
    f: Tr
  },
  /*::[*/
  60: {
    /* n:"Continue", */
  },
  /*::[*/
  61: {
    /* n:"Window1", */
    f: K6
  },
  /*::[*/
  64: {
    /* n:"Backup", */
    f: _r
  },
  /*::[*/
  65: {
    /* n:"Pane", */
    f: J6
  },
  /*::[*/
  66: {
    /* n:"CodePage", */
    f: Tr
  },
  /*::[*/
  77: {
    /* n:"Pls", */
  },
  /*::[*/
  80: {
    /* n:"DCon", */
  },
  /*::[*/
  81: {
    /* n:"DConRef", */
  },
  /*::[*/
  82: {
    /* n:"DConName", */
  },
  /*::[*/
  85: {
    /* n:"DefColWidth", */
    f: Tr
  },
  /*::[*/
  89: {
    /* n:"XCT", */
  },
  /*::[*/
  90: {
    /* n:"CRN", */
  },
  /*::[*/
  91: {
    /* n:"FileSharing", */
  },
  /*::[*/
  92: {
    /* n:"WriteAccess", */
    f: M6
  },
  /*::[*/
  93: {
    /* n:"Obj", */
    f: S$
  },
  /*::[*/
  94: {
    /* n:"Uncalced", */
  },
  /*::[*/
  95: {
    /* n:"CalcSaveRecalc", */
    f: _r
  },
  //
  /*::[*/
  96: {
    /* n:"Template", */
  },
  /*::[*/
  97: {
    /* n:"Intl", */
  },
  /*::[*/
  99: {
    /* n:"ObjProtect", */
    f: _r
  },
  /*::[*/
  125: {
    /* n:"ColInfo", */
    f: Pv
  },
  /*::[*/
  128: {
    /* n:"Guts", */
    f: h$
  },
  /*::[*/
  129: {
    /* n:"WsBool", */
    f: L6
  },
  /*::[*/
  130: {
    /* n:"GridSet", */
    f: Tr
  },
  /*::[*/
  131: {
    /* n:"HCenter", */
    f: _r
  },
  /*::[*/
  132: {
    /* n:"VCenter", */
    f: _r
  },
  /*::[*/
  133: {
    /* n:"BoundSheet8", */
    f: N6
  },
  /*::[*/
  134: {
    /* n:"WriteProtect", */
  },
  /*::[*/
  140: {
    /* n:"Country", */
    f: M$
  },
  /*::[*/
  141: {
    /* n:"HideObj", */
    f: Tr
  },
  /*::[*/
  144: {
    /* n:"Sort", */
  },
  /*::[*/
  146: {
    /* n:"Palette", */
    f: N$
  },
  /*::[*/
  151: {
    /* n:"Sync", */
  },
  /*::[*/
  152: {
    /* n:"LPr", */
  },
  /*::[*/
  153: {
    /* n:"DxGCol", */
  },
  /*::[*/
  154: {
    /* n:"FnGroupName", */
  },
  /*::[*/
  155: {
    /* n:"FilterMode", */
  },
  /*::[*/
  156: {
    /* n:"BuiltInFnGroupCount", */
    f: Tr
  },
  /*::[*/
  157: {
    /* n:"AutoFilterInfo", */
  },
  /*::[*/
  158: {
    /* n:"AutoFilter", */
  },
  /*::[*/
  160: {
    /* n:"Scl", */
    f: G$
  },
  /*::[*/
  161: {
    /* n:"Setup", */
    f: W$
  },
  /*::[*/
  174: {
    /* n:"ScenMan", */
  },
  /*::[*/
  175: {
    /* n:"SCENARIO", */
  },
  /*::[*/
  176: {
    /* n:"SxView", */
  },
  /*::[*/
  177: {
    /* n:"Sxvd", */
  },
  /*::[*/
  178: {
    /* n:"SXVI", */
  },
  /*::[*/
  180: {
    /* n:"SxIvd", */
  },
  /*::[*/
  181: {
    /* n:"SXLI", */
  },
  /*::[*/
  182: {
    /* n:"SXPI", */
  },
  /*::[*/
  184: {
    /* n:"DocRoute", */
  },
  /*::[*/
  185: {
    /* n:"RecipName", */
  },
  /*::[*/
  189: {
    /* n:"MulRk", */
    f: l$
  },
  /*::[*/
  190: {
    /* n:"MulBlank", */
    f: c$
  },
  /*::[*/
  193: {
    /* n:"Mms", */
    f: ba
  },
  /*::[*/
  197: {
    /* n:"SXDI", */
  },
  /*::[*/
  198: {
    /* n:"SXDB", */
  },
  /*::[*/
  199: {
    /* n:"SXFDB", */
  },
  /*::[*/
  200: {
    /* n:"SXDBB", */
  },
  /*::[*/
  201: {
    /* n:"SXNum", */
  },
  /*::[*/
  202: {
    /* n:"SxBool", */
    f: _r
  },
  /*::[*/
  203: {
    /* n:"SxErr", */
  },
  /*::[*/
  204: {
    /* n:"SXInt", */
  },
  /*::[*/
  205: {
    /* n:"SXString", */
  },
  /*::[*/
  206: {
    /* n:"SXDtr", */
  },
  /*::[*/
  207: {
    /* n:"SxNil", */
  },
  /*::[*/
  208: {
    /* n:"SXTbl", */
  },
  /*::[*/
  209: {
    /* n:"SXTBRGIITM", */
  },
  /*::[*/
  210: {
    /* n:"SxTbpg", */
  },
  /*::[*/
  211: {
    /* n:"ObProj", */
  },
  /*::[*/
  213: {
    /* n:"SXStreamID", */
  },
  /*::[*/
  215: {
    /* n:"DBCell", */
  },
  /*::[*/
  216: {
    /* n:"SXRng", */
  },
  /*::[*/
  217: {
    /* n:"SxIsxoper", */
  },
  /*::[*/
  218: {
    /* n:"BookBool", */
    f: Tr
  },
  /*::[*/
  220: {
    /* n:"DbOrParamQry", */
  },
  /*::[*/
  221: {
    /* n:"ScenarioProtect", */
    f: _r
  },
  /*::[*/
  222: {
    /* n:"OleObjectSize", */
  },
  /*::[*/
  224: {
    /* n:"XF", */
    f: d$
  },
  /*::[*/
  225: {
    /* n:"InterfaceHdr", */
    f: P6
  },
  /*::[*/
  226: {
    /* n:"InterfaceEnd", */
    f: ba
  },
  /*::[*/
  227: {
    /* n:"SXVS", */
  },
  /*::[*/
  229: {
    /* n:"MergeCells", */
    f: k$
  },
  /*::[*/
  233: {
    /* n:"BkHim", */
  },
  /*::[*/
  235: {
    /* n:"MsoDrawingGroup", */
  },
  /*::[*/
  236: {
    /* n:"MsoDrawing", */
  },
  /*::[*/
  237: {
    /* n:"MsoDrawingSelection", */
  },
  /*::[*/
  239: {
    /* n:"PhoneticInfo", */
  },
  /*::[*/
  240: {
    /* n:"SxRule", */
  },
  /*::[*/
  241: {
    /* n:"SXEx", */
  },
  /*::[*/
  242: {
    /* n:"SxFilt", */
  },
  /*::[*/
  244: {
    /* n:"SxDXF", */
  },
  /*::[*/
  245: {
    /* n:"SxItm", */
  },
  /*::[*/
  246: {
    /* n:"SxName", */
  },
  /*::[*/
  247: {
    /* n:"SxSelect", */
  },
  /*::[*/
  248: {
    /* n:"SXPair", */
  },
  /*::[*/
  249: {
    /* n:"SxFmla", */
  },
  /*::[*/
  251: {
    /* n:"SxFormat", */
  },
  /*::[*/
  252: {
    /* n:"SST", */
    f: V6
  },
  /*::[*/
  253: {
    /* n:"LabelSst", */
    f: e$
  },
  /*::[*/
  255: {
    /* n:"ExtSST", */
    f: H6
  },
  /*::[*/
  256: {
    /* n:"SXVDEx", */
  },
  /*::[*/
  259: {
    /* n:"SXFormula", */
  },
  /*::[*/
  290: {
    /* n:"SXDBEx", */
  },
  /*::[*/
  311: {
    /* n:"RRDInsDel", */
  },
  /*::[*/
  312: {
    /* n:"RRDHead", */
  },
  /*::[*/
  315: {
    /* n:"RRDChgCell", */
  },
  /*::[*/
  317: {
    /* n:"RRTabId", */
    f: Ev
  },
  /*::[*/
  318: {
    /* n:"RRDRenSheet", */
  },
  /*::[*/
  319: {
    /* n:"RRSort", */
  },
  /*::[*/
  320: {
    /* n:"RRDMove", */
  },
  /*::[*/
  330: {
    /* n:"RRFormat", */
  },
  /*::[*/
  331: {
    /* n:"RRAutoFmt", */
  },
  /*::[*/
  333: {
    /* n:"RRInsertSh", */
  },
  /*::[*/
  334: {
    /* n:"RRDMoveBegin", */
  },
  /*::[*/
  335: {
    /* n:"RRDMoveEnd", */
  },
  /*::[*/
  336: {
    /* n:"RRDInsDelBegin", */
  },
  /*::[*/
  337: {
    /* n:"RRDInsDelEnd", */
  },
  /*::[*/
  338: {
    /* n:"RRDConflict", */
  },
  /*::[*/
  339: {
    /* n:"RRDDefName", */
  },
  /*::[*/
  340: {
    /* n:"RRDRstEtxp", */
  },
  /*::[*/
  351: {
    /* n:"LRng", */
  },
  /*::[*/
  352: {
    /* n:"UsesELFs", */
    f: _r
  },
  /*::[*/
  353: {
    /* n:"DSF", */
    f: ba
  },
  /*::[*/
  401: {
    /* n:"CUsr", */
  },
  /*::[*/
  402: {
    /* n:"CbUsr", */
  },
  /*::[*/
  403: {
    /* n:"UsrInfo", */
  },
  /*::[*/
  404: {
    /* n:"UsrExcl", */
  },
  /*::[*/
  405: {
    /* n:"FileLock", */
  },
  /*::[*/
  406: {
    /* n:"RRDInfo", */
  },
  /*::[*/
  407: {
    /* n:"BCUsrs", */
  },
  /*::[*/
  408: {
    /* n:"UsrChk", */
  },
  /*::[*/
  425: {
    /* n:"UserBView", */
  },
  /*::[*/
  426: {
    /* n:"UserSViewBegin", */
  },
  /*::[*/
  427: {
    /* n:"UserSViewEnd", */
  },
  /*::[*/
  428: {
    /* n:"RRDUserView", */
  },
  /*::[*/
  429: {
    /* n:"Qsi", */
  },
  /*::[*/
  430: {
    /* n:"SupBook", */
    f: g$
  },
  /*::[*/
  431: {
    /* n:"Prot4Rev", */
    f: _r
  },
  /*::[*/
  432: {
    /* n:"CondFmt", */
  },
  /*::[*/
  433: {
    /* n:"CF", */
  },
  /*::[*/
  434: {
    /* n:"DVal", */
  },
  /*::[*/
  437: {
    /* n:"DConBin", */
  },
  /*::[*/
  438: {
    /* n:"TxO", */
    f: A$
  },
  /*::[*/
  439: {
    /* n:"RefreshAll", */
    f: _r
  },
  //
  /*::[*/
  440: {
    /* n:"HLink", */
    f: R$
  },
  /*::[*/
  441: {
    /* n:"Lel", */
  },
  /*::[*/
  442: {
    /* n:"CodeName", */
    f: ks
  },
  /*::[*/
  443: {
    /* n:"SXFDBType", */
  },
  /*::[*/
  444: {
    /* n:"Prot4RevPass", */
    f: Tr
  },
  /*::[*/
  445: {
    /* n:"ObNoMacros", */
  },
  /*::[*/
  446: {
    /* n:"Dv", */
  },
  /*::[*/
  448: {
    /* n:"Excel9File", */
    f: ba
  },
  /*::[*/
  449: {
    /* n:"RecalcId", */
    f: G6,
    r: 2
  },
  /*::[*/
  450: {
    /* n:"EntExU2", */
    f: ba
  },
  /*::[*/
  512: {
    /* n:"Dimensions", */
    f: ih
  },
  /*::[*/
  513: {
    /* n:"Blank", */
    f: z$
  },
  /*::[*/
  515: {
    /* n:"Number", */
    f: p$
  },
  /*::[*/
  516: {
    /* n:"Label", */
    f: t$
  },
  /*::[*/
  517: {
    /* n:"BoolErr", */
    f: oh
  },
  /*::[*/
  519: {
    /* n:"String", */
    f: K$
  },
  /*::[*/
  520: {
    /* n:"Row", */
    f: j6
  },
  /*::[*/
  523: {
    /* n:"Index", */
  },
  /*::[*/
  545: {
    /* n:"Array", */
    f: fh
  },
  /*::[*/
  549: {
    /* n:"DefaultRowHeight", */
    f: nh
  },
  /*::[*/
  566: {
    /* n:"Table", */
  },
  /*::[*/
  574: {
    /* n:"Window2", */
    f: X6
  },
  /*::[*/
  638: {
    /* n:"RK", */
    f: u$
  },
  /*::[*/
  659: {
    /* n:"Style", */
  },
  /*::[*/
  1048: {
    /* n:"BigName", */
  },
  /*::[*/
  1054: {
    /* n:"Format", */
    f: n$
  },
  /*::[*/
  1084: {
    /* n:"ContinueBigName", */
  },
  /*::[*/
  1212: {
    /* n:"ShrFmla", */
    f: _$
  },
  /*::[*/
  2048: {
    /* n:"HLinkTooltip", */
    f: B$
  },
  /*::[*/
  2049: {
    /* n:"WebPub", */
  },
  /*::[*/
  2050: {
    /* n:"QsiSXTag", */
  },
  /*::[*/
  2051: {
    /* n:"DBQueryExt", */
  },
  /*::[*/
  2052: {
    /* n:"ExtString", */
  },
  /*::[*/
  2053: {
    /* n:"TxtQry", */
  },
  /*::[*/
  2054: {
    /* n:"Qsir", */
  },
  /*::[*/
  2055: {
    /* n:"Qsif", */
  },
  /*::[*/
  2056: {
    /* n:"RRDTQSIF", */
  },
  /*::[*/
  2057: {
    /* n:"BOF", */
    f: no
  },
  /*::[*/
  2058: {
    /* n:"OleDbConn", */
  },
  /*::[*/
  2059: {
    /* n:"WOpt", */
  },
  /*::[*/
  2060: {
    /* n:"SXViewEx", */
  },
  /*::[*/
  2061: {
    /* n:"SXTH", */
  },
  /*::[*/
  2062: {
    /* n:"SXPIEx", */
  },
  /*::[*/
  2063: {
    /* n:"SXVDTEx", */
  },
  /*::[*/
  2064: {
    /* n:"SXViewEx9", */
  },
  /*::[*/
  2066: {
    /* n:"ContinueFrt", */
  },
  /*::[*/
  2067: {
    /* n:"RealTimeData", */
  },
  /*::[*/
  2128: {
    /* n:"ChartFrtInfo", */
  },
  /*::[*/
  2129: {
    /* n:"FrtWrapper", */
  },
  /*::[*/
  2130: {
    /* n:"StartBlock", */
  },
  /*::[*/
  2131: {
    /* n:"EndBlock", */
  },
  /*::[*/
  2132: {
    /* n:"StartObject", */
  },
  /*::[*/
  2133: {
    /* n:"EndObject", */
  },
  /*::[*/
  2134: {
    /* n:"CatLab", */
  },
  /*::[*/
  2135: {
    /* n:"YMult", */
  },
  /*::[*/
  2136: {
    /* n:"SXViewLink", */
  },
  /*::[*/
  2137: {
    /* n:"PivotChartBits", */
  },
  /*::[*/
  2138: {
    /* n:"FrtFontList", */
  },
  /*::[*/
  2146: {
    /* n:"SheetExt", */
  },
  /*::[*/
  2147: {
    /* n:"BookExt", */
    r: 12
  },
  /*::[*/
  2148: {
    /* n:"SXAddl", */
  },
  /*::[*/
  2149: {
    /* n:"CrErr", */
  },
  /*::[*/
  2150: {
    /* n:"HFPicture", */
  },
  /*::[*/
  2151: {
    /* n:"FeatHdr", */
    f: ba
  },
  /*::[*/
  2152: {
    /* n:"Feat", */
  },
  /*::[*/
  2154: {
    /* n:"DataLabExt", */
  },
  /*::[*/
  2155: {
    /* n:"DataLabExtContents", */
  },
  /*::[*/
  2156: {
    /* n:"CellWatch", */
  },
  /*::[*/
  2161: {
    /* n:"FeatHdr11", */
  },
  /*::[*/
  2162: {
    /* n:"Feature11", */
  },
  /*::[*/
  2164: {
    /* n:"DropDownObjIds", */
  },
  /*::[*/
  2165: {
    /* n:"ContinueFrt11", */
  },
  /*::[*/
  2166: {
    /* n:"DConn", */
  },
  /*::[*/
  2167: {
    /* n:"List12", */
  },
  /*::[*/
  2168: {
    /* n:"Feature12", */
  },
  /*::[*/
  2169: {
    /* n:"CondFmt12", */
  },
  /*::[*/
  2170: {
    /* n:"CF12", */
  },
  /*::[*/
  2171: {
    /* n:"CFEx", */
  },
  /*::[*/
  2172: {
    /* n:"XFCRC", */
    f: U$,
    r: 12
  },
  /*::[*/
  2173: {
    /* n:"XFExt", */
    f: ME,
    r: 12
  },
  /*::[*/
  2174: {
    /* n:"AutoFilter12", */
  },
  /*::[*/
  2175: {
    /* n:"ContinueFrt12", */
  },
  /*::[*/
  2180: {
    /* n:"MDTInfo", */
  },
  /*::[*/
  2181: {
    /* n:"MDXStr", */
  },
  /*::[*/
  2182: {
    /* n:"MDXTuple", */
  },
  /*::[*/
  2183: {
    /* n:"MDXSet", */
  },
  /*::[*/
  2184: {
    /* n:"MDXProp", */
  },
  /*::[*/
  2185: {
    /* n:"MDXKPI", */
  },
  /*::[*/
  2186: {
    /* n:"MDB", */
  },
  /*::[*/
  2187: {
    /* n:"PLV", */
  },
  /*::[*/
  2188: {
    /* n:"Compat12", */
    f: _r,
    r: 12
  },
  /*::[*/
  2189: {
    /* n:"DXF", */
  },
  /*::[*/
  2190: {
    /* n:"TableStyles", */
    r: 12
  },
  /*::[*/
  2191: {
    /* n:"TableStyle", */
  },
  /*::[*/
  2192: {
    /* n:"TableStyleElement", */
  },
  /*::[*/
  2194: {
    /* n:"StyleExt", */
  },
  /*::[*/
  2195: {
    /* n:"NamePublish", */
  },
  /*::[*/
  2196: {
    /* n:"NameCmt", */
    f: w$,
    r: 12
  },
  /*::[*/
  2197: {
    /* n:"SortData", */
  },
  /*::[*/
  2198: {
    /* n:"Theme", */
    f: FE,
    r: 12
  },
  /*::[*/
  2199: {
    /* n:"GUIDTypeLib", */
  },
  /*::[*/
  2200: {
    /* n:"FnGrp12", */
  },
  /*::[*/
  2201: {
    /* n:"NameFnGrp12", */
  },
  /*::[*/
  2202: {
    /* n:"MTRSettings", */
    f: $$,
    r: 12
  },
  /*::[*/
  2203: {
    /* n:"CompressPictures", */
    f: ba
  },
  /*::[*/
  2204: {
    /* n:"HeaderFooter", */
  },
  /*::[*/
  2205: {
    /* n:"CrtLayout12", */
  },
  /*::[*/
  2206: {
    /* n:"CrtMlFrt", */
  },
  /*::[*/
  2207: {
    /* n:"CrtMlFrtContinue", */
  },
  /*::[*/
  2211: {
    /* n:"ForceFullCalculation", */
    f: z6
  },
  /*::[*/
  2212: {
    /* n:"ShapePropsStream", */
  },
  /*::[*/
  2213: {
    /* n:"TextPropsStream", */
  },
  /*::[*/
  2214: {
    /* n:"RichTextStream", */
  },
  /*::[*/
  2215: {
    /* n:"CrtLayout12A", */
  },
  /*::[*/
  4097: {
    /* n:"Units", */
  },
  /*::[*/
  4098: {
    /* n:"Chart", */
  },
  /*::[*/
  4099: {
    /* n:"Series", */
  },
  /*::[*/
  4102: {
    /* n:"DataFormat", */
  },
  /*::[*/
  4103: {
    /* n:"LineFormat", */
  },
  /*::[*/
  4105: {
    /* n:"MarkerFormat", */
  },
  /*::[*/
  4106: {
    /* n:"AreaFormat", */
  },
  /*::[*/
  4107: {
    /* n:"PieFormat", */
  },
  /*::[*/
  4108: {
    /* n:"AttachedLabel", */
  },
  /*::[*/
  4109: {
    /* n:"SeriesText", */
  },
  /*::[*/
  4116: {
    /* n:"ChartFormat", */
  },
  /*::[*/
  4117: {
    /* n:"Legend", */
  },
  /*::[*/
  4118: {
    /* n:"SeriesList", */
  },
  /*::[*/
  4119: {
    /* n:"Bar", */
  },
  /*::[*/
  4120: {
    /* n:"Line", */
  },
  /*::[*/
  4121: {
    /* n:"Pie", */
  },
  /*::[*/
  4122: {
    /* n:"Area", */
  },
  /*::[*/
  4123: {
    /* n:"Scatter", */
  },
  /*::[*/
  4124: {
    /* n:"CrtLine", */
  },
  /*::[*/
  4125: {
    /* n:"Axis", */
  },
  /*::[*/
  4126: {
    /* n:"Tick", */
  },
  /*::[*/
  4127: {
    /* n:"ValueRange", */
  },
  /*::[*/
  4128: {
    /* n:"CatSerRange", */
  },
  /*::[*/
  4129: {
    /* n:"AxisLine", */
  },
  /*::[*/
  4130: {
    /* n:"CrtLink", */
  },
  /*::[*/
  4132: {
    /* n:"DefaultText", */
  },
  /*::[*/
  4133: {
    /* n:"Text", */
  },
  /*::[*/
  4134: {
    /* n:"FontX", */
    f: Tr
  },
  /*::[*/
  4135: {
    /* n:"ObjectLink", */
  },
  /*::[*/
  4146: {
    /* n:"Frame", */
  },
  /*::[*/
  4147: {
    /* n:"Begin", */
  },
  /*::[*/
  4148: {
    /* n:"End", */
  },
  /*::[*/
  4149: {
    /* n:"PlotArea", */
  },
  /*::[*/
  4154: {
    /* n:"Chart3d", */
  },
  /*::[*/
  4156: {
    /* n:"PicF", */
  },
  /*::[*/
  4157: {
    /* n:"DropBar", */
  },
  /*::[*/
  4158: {
    /* n:"Radar", */
  },
  /*::[*/
  4159: {
    /* n:"Surf", */
  },
  /*::[*/
  4160: {
    /* n:"RadarArea", */
  },
  /*::[*/
  4161: {
    /* n:"AxisParent", */
  },
  /*::[*/
  4163: {
    /* n:"LegendException", */
  },
  /*::[*/
  4164: {
    /* n:"ShtProps", */
    f: H$
  },
  /*::[*/
  4165: {
    /* n:"SerToCrt", */
  },
  /*::[*/
  4166: {
    /* n:"AxesUsed", */
  },
  /*::[*/
  4168: {
    /* n:"SBaseRef", */
  },
  /*::[*/
  4170: {
    /* n:"SerParent", */
  },
  /*::[*/
  4171: {
    /* n:"SerAuxTrend", */
  },
  /*::[*/
  4174: {
    /* n:"IFmtRecord", */
  },
  /*::[*/
  4175: {
    /* n:"Pos", */
  },
  /*::[*/
  4176: {
    /* n:"AlRuns", */
  },
  /*::[*/
  4177: {
    /* n:"BRAI", */
  },
  /*::[*/
  4187: {
    /* n:"SerAuxErrBar", */
  },
  /*::[*/
  4188: {
    /* n:"ClrtClient", */
    f: L$
  },
  /*::[*/
  4189: {
    /* n:"SerFmt", */
  },
  /*::[*/
  4191: {
    /* n:"Chart3DBarShape", */
  },
  /*::[*/
  4192: {
    /* n:"Fbi", */
  },
  /*::[*/
  4193: {
    /* n:"BopPop", */
  },
  /*::[*/
  4194: {
    /* n:"AxcExt", */
  },
  /*::[*/
  4195: {
    /* n:"Dat", */
  },
  /*::[*/
  4196: {
    /* n:"PlotGrowth", */
  },
  /*::[*/
  4197: {
    /* n:"SIIndex", */
  },
  /*::[*/
  4198: {
    /* n:"GelFrame", */
  },
  /*::[*/
  4199: {
    /* n:"BopPopCustom", */
  },
  /*::[*/
  4200: {
    /* n:"Fbi2", */
  },
  /*::[*/
  0: {
    /* n:"Dimensions", */
    f: ih
  },
  /*::[*/
  1: {
    /* n:"BIFF2BLANK", */
  },
  /*::[*/
  2: {
    /* n:"BIFF2INT", */
    f: q$
  },
  /*::[*/
  3: {
    /* n:"BIFF2NUM", */
    f: Z$
  },
  /*::[*/
  4: {
    /* n:"BIFF2STR", */
    f: X$
  },
  /*::[*/
  5: {
    /* n:"BoolErr", */
    f: oh
  },
  /*::[*/
  7: {
    /* n:"String", */
    f: eD
  },
  /*::[*/
  8: {
    /* n:"BIFF2ROW", */
  },
  /*::[*/
  9: {
    /* n:"BOF", */
    f: no
  },
  /*::[*/
  11: {
    /* n:"Index", */
  },
  /*::[*/
  22: {
    /* n:"ExternCount", */
    f: Tr
  },
  /*::[*/
  30: {
    /* n:"BIFF2FORMAT", */
    f: s$
  },
  /*::[*/
  31: {
    /* n:"BIFF2FMTCNT", */
  },
  /* 16-bit cnt of BIFF2FORMAT records */
  /*::[*/
  32: {
    /* n:"BIFF2COLINFO", */
  },
  /*::[*/
  33: {
    /* n:"Array", */
    f: fh
  },
  /*::[*/
  36: {
    /* n:"COLWIDTH", */
  },
  /*::[*/
  37: {
    /* n:"DefaultRowHeight", */
    f: nh
  },
  // 0x2c ??
  // 0x2d ??
  // 0x2e ??
  // 0x30 FONTCOUNT: number of fonts
  /*::[*/
  50: {
    /* n:"BIFF2FONTXTRA", */
    f: rD
  },
  // 0x35: INFOOPTS
  // 0x36: TABLE (BIFF2 only)
  // 0x37: TABLE2 (BIFF2 only)
  // 0x38: WNDESK
  // 0x39 ??
  // 0x3a: BEGINPREF
  // 0x3b: ENDPREF
  /*::[*/
  62: {
    /* n:"BIFF2WINDOW2", */
  },
  // 0x3f ??
  // 0x46: SHOWSCROLL
  // 0x47: SHOWFORMULA
  // 0x48: STATUSBAR
  // 0x49: SHORTMENUS
  // 0x4A:
  // 0x4B:
  // 0x4C:
  // 0x4E:
  // 0x4F:
  // 0x58: TOOLBAR (BIFF3)
  /* - - - */
  /*::[*/
  52: {
    /* n:"DDEObjName", */
  },
  /*::[*/
  67: {
    /* n:"BIFF2XF", */
  },
  /*::[*/
  68: {
    /* n:"BIFF2XFINDEX", */
    f: Tr
  },
  /*::[*/
  69: {
    /* n:"BIFF2FONTCLR", */
  },
  /*::[*/
  86: {
    /* n:"BIFF4FMTCNT", */
  },
  /* 16-bit cnt, similar to BIFF2 */
  /*::[*/
  126: {
    /* n:"RK", */
  },
  /* Not necessarily same as 0x027e */
  /*::[*/
  127: {
    /* n:"ImData", */
    f: Y$
  },
  /*::[*/
  135: {
    /* n:"Addin", */
  },
  /*::[*/
  136: {
    /* n:"Edg", */
  },
  /*::[*/
  137: {
    /* n:"Pub", */
  },
  // 0x8A
  // 0x8B LH: alternate menu key flag (BIFF3/4)
  // 0x8E
  // 0x8F
  /*::[*/
  145: {
    /* n:"Sub", */
  },
  // 0x93 STYLE
  /*::[*/
  148: {
    /* n:"LHRecord", */
  },
  /*::[*/
  149: {
    /* n:"LHNGraph", */
  },
  /*::[*/
  150: {
    /* n:"Sound", */
  },
  // 0xA2 FNPROTO: function prototypes (BIFF4)
  // 0xA3
  // 0xA8
  /*::[*/
  169: {
    /* n:"CoordList", */
  },
  /*::[*/
  171: {
    /* n:"GCW", */
  },
  /*::[*/
  188: {
    /* n:"ShrFmla", */
  },
  /* Not necessarily same as 0x04bc */
  /*::[*/
  191: {
    /* n:"ToolbarHdr", */
  },
  /*::[*/
  192: {
    /* n:"ToolbarEnd", */
  },
  /*::[*/
  194: {
    /* n:"AddMenu", */
  },
  /*::[*/
  195: {
    /* n:"DelMenu", */
  },
  /*::[*/
  214: {
    /* n:"RString", */
    f: tD
  },
  /*::[*/
  223: {
    /* n:"UDDesc", */
  },
  /*::[*/
  234: {
    /* n:"TabIdConf", */
  },
  /*::[*/
  354: {
    /* n:"XL5Modify", */
  },
  /*::[*/
  421: {
    /* n:"FileSharing2", */
  },
  /*::[*/
  518: {
    /* n:"Formula", */
    f: pu
  },
  /*::[*/
  521: {
    /* n:"BOF", */
    f: no
  },
  /*::[*/
  536: {
    /* n:"Lbl", */
    f: ch
  },
  /*::[*/
  547: {
    /* n:"ExternName", */
    f: lh
  },
  /*::[*/
  561: {
    /* n:"Font", */
  },
  /*::[*/
  579: {
    /* n:"BIFF3XF", */
  },
  /*::[*/
  1030: {
    /* n:"Formula", */
    f: pu
  },
  /*::[*/
  1033: {
    /* n:"BOF", */
    f: no
  },
  /*::[*/
  1091: {
    /* n:"BIFF4XF", */
  },
  /*::[*/
  2157: {
    /* n:"FeatInfo", */
  },
  /*::[*/
  2163: {
    /* n:"FeatInfo11", */
  },
  /*::[*/
  2177: {
    /* n:"SXAddl12", */
  },
  /*::[*/
  2240: {
    /* n:"AutoWebPub", */
  },
  /*::[*/
  2241: {
    /* n:"ListObj", */
  },
  /*::[*/
  2242: {
    /* n:"ListField", */
  },
  /*::[*/
  2243: {
    /* n:"ListDV", */
  },
  /*::[*/
  2244: {
    /* n:"ListCondFmt", */
  },
  /*::[*/
  2245: {
    /* n:"ListCF", */
  },
  /*::[*/
  2246: {
    /* n:"FMQry", */
  },
  /*::[*/
  2247: {
    /* n:"FMSQry", */
  },
  /*::[*/
  2248: {
    /* n:"PLV", */
  },
  /*::[*/
  2249: {
    /* n:"LnExt", */
  },
  /*::[*/
  2250: {
    /* n:"MkrExt", */
  },
  /*::[*/
  2251: {
    /* n:"CrtCoopt", */
  },
  /*::[*/
  2262: {
    /* n:"FRTArchId$", */
    r: 12
  },
  /*::[*/
  29282: {}
};
function xe(e, r, t, a) {
  var n = r;
  if (!isNaN(n)) {
    var i = a || (t || []).length || 0, s = e.next(4);
    s.write_shift(2, n), s.write_shift(2, i), /*:: len != null &&*/
    i > 0 && Rc(t) && e.push(t);
  }
}
function QS(e, r, t, a) {
  var n = (t || []).length || 0;
  if (n <= 8224)
    return xe(e, r, t, n);
  var i = r;
  if (!isNaN(i)) {
    for (var s = t.parts || [], o = 0, u = 0, l = 0; l + (s[o] || 8224) <= 8224; )
      l += s[o] || 8224, o++;
    var c = e.next(4);
    for (c.write_shift(2, i), c.write_shift(2, l), e.push(t.slice(u, u + l)), u += l; u < n; ) {
      for (c = e.next(4), c.write_shift(2, 60), l = 0; l + (s[o] || 8224) <= 8224; )
        l += s[o] || 8224, o++;
      c.write_shift(2, l), e.push(t.slice(u, u + l)), u += l;
    }
  }
}
function Fs(e, r, t) {
  return e || (e = te(7)), e.write_shift(2, r), e.write_shift(2, t), e.write_shift(2, 0), e.write_shift(1, 0), e;
}
function eC(e, r, t, a) {
  var n = te(9);
  return Fs(n, e, r), kv(t, a || "b", n), n;
}
function rC(e, r, t) {
  var a = te(8 + 2 * t.length);
  return Fs(a, e, r), a.write_shift(1, t.length), a.write_shift(t.length, t, "sbcs"), a.l < a.length ? a.slice(0, a.l) : a;
}
function tC(e, r, t, a) {
  if (r.v != null)
    switch (r.t) {
      case "d":
      case "n":
        var n = r.t == "d" ? Ar(ur(r.v)) : r.v;
        n == (n | 0) && n >= 0 && n < 65536 ? xe(e, 2, Q$(t, a, n)) : xe(e, 3, J$(t, a, n));
        return;
      case "b":
      case "e":
        xe(e, 5, eC(t, a, r.v, r.t));
        return;
      case "s":
      case "str":
        xe(e, 4, rC(t, a, (r.v || "").slice(0, 255)));
        return;
    }
  xe(e, 1, Fs(null, t, a));
}
function aC(e, r, t, a) {
  var n = Array.isArray(r), i = Oe(r["!ref"] || "A1"), s, o = "", u = [];
  if (i.e.c > 255 || i.e.r > 16383) {
    if (a.WTF)
      throw new Error("Range " + (r["!ref"] || "A1") + " exceeds format limit A1:IV16384");
    i.e.c = Math.min(i.e.c, 255), i.e.r = Math.min(i.e.c, 16383), s = Ce(i);
  }
  for (var l = i.s.r; l <= i.e.r; ++l) {
    o = gr(l);
    for (var c = i.s.c; c <= i.e.c; ++c) {
      l === i.s.r && (u[c] = or(c)), s = u[c] + o;
      var f = n ? (r[l] || [])[c] : r[s];
      f && tC(e, f, l, c);
    }
  }
}
function nC(e, r) {
  for (var t = r || {}, a = ut(), n = 0, i = 0; i < e.SheetNames.length; ++i)
    e.SheetNames[i] == t.sheet && (n = i);
  if (n == 0 && t.sheet && e.SheetNames[0] != t.sheet)
    throw new Error("Sheet not found: " + t.sheet);
  return xe(a, t.biff == 4 ? 1033 : t.biff == 3 ? 521 : 9, Wc(e, 16, t)), aC(a, e.Sheets[e.SheetNames[n]], n, t), xe(a, 10), a.end();
}
function iC(e, r, t) {
  xe(e, 49, Q6({
    sz: 12,
    color: { theme: 1 },
    name: "Arial",
    family: 2,
    scheme: "minor"
  }, t));
}
function sC(e, r, t) {
  r && [[5, 8], [23, 26], [41, 44], [
    /*63*/
    50,
    /*66],[164,*/
    392
  ]].forEach(function(a) {
    for (var n = a[0]; n <= a[1]; ++n)
      r[n] != null && xe(e, 1054, i$(n, r[n], t));
  });
}
function oC(e, r) {
  var t = te(19);
  t.write_shift(4, 2151), t.write_shift(4, 0), t.write_shift(4, 0), t.write_shift(2, 3), t.write_shift(1, 1), t.write_shift(4, 0), xe(e, 2151, t), t = te(39), t.write_shift(4, 2152), t.write_shift(4, 0), t.write_shift(4, 0), t.write_shift(2, 3), t.write_shift(1, 0), t.write_shift(4, 0), t.write_shift(2, 1), t.write_shift(4, 4), t.write_shift(2, 0), Av(Oe(r["!ref"] || "A1"), t), t.write_shift(4, 4), xe(e, 2152, t);
}
function uC(e, r) {
  for (var t = 0; t < 16; ++t)
    xe(e, 224, sh({ numFmtId: 0, style: !0 }, 0, r));
  r.cellXfs.forEach(function(a) {
    xe(e, 224, sh(a, 0, r));
  });
}
function lC(e, r) {
  for (var t = 0; t < r["!links"].length; ++t) {
    var a = r["!links"][t];
    xe(e, 440, I$(a)), a[1].Tooltip && xe(e, 2048, P$(a));
  }
  delete r["!links"];
}
function cC(e, r) {
  if (r) {
    var t = 0;
    r.forEach(function(a, n) {
      ++t <= 256 && a && xe(e, 125, V$(_0(n, a), n));
    });
  }
}
function fC(e, r, t, a, n) {
  var i = 16 + Ha(n.cellXfs, r, n);
  if (r.v == null && !r.bf) {
    xe(e, 513, xn(t, a, i));
    return;
  }
  if (r.bf)
    xe(e, 6, L8(r, t, a, n, i));
  else
    switch (r.t) {
      case "d":
      case "n":
        var s = r.t == "d" ? Ar(ur(r.v)) : r.v;
        xe(e, 515, v$(t, a, s, i));
        break;
      case "b":
      case "e":
        xe(e, 517, m$(t, a, r.v, i, n, r.t));
        break;
      case "s":
      case "str":
        if (n.bookSST) {
          var o = Zc(n.Strings, r.v, n.revStrings);
          xe(e, 253, r$(t, a, o, i));
        } else
          xe(e, 516, a$(t, a, (r.v || "").slice(0, 255), i, n));
        break;
      default:
        xe(e, 513, xn(t, a, i));
    }
}
function dC(e, r, t) {
  var a = ut(), n = t.SheetNames[e], i = t.Sheets[n] || {}, s = (t || {}).Workbook || {}, o = (s.Sheets || [])[e] || {}, u = Array.isArray(i), l = r.biff == 8, c, f = "", h = [], d = Oe(i["!ref"] || "A1"), m = l ? 65536 : 16384;
  if (d.e.c > 255 || d.e.r >= m) {
    if (r.WTF)
      throw new Error("Range " + (i["!ref"] || "A1") + " exceeds format limit A1:IV16384");
    d.e.c = Math.min(d.e.c, 255), d.e.r = Math.min(d.e.c, m - 1);
  }
  xe(a, 2057, Wc(t, 16, r)), xe(a, 13, Dt(1)), xe(a, 12, Dt(100)), xe(a, 15, rt(!0)), xe(a, 17, rt(!1)), xe(a, 16, dn(1e-3)), xe(a, 95, rt(!0)), xe(a, 42, rt(!1)), xe(a, 43, rt(!1)), xe(a, 130, Dt(1)), xe(a, 128, x$()), xe(a, 131, rt(!1)), xe(a, 132, rt(!1)), l && cC(a, i["!cols"]), xe(a, 512, o$(d, r)), l && (i["!links"] = []);
  for (var x = d.s.r; x <= d.e.r; ++x) {
    f = gr(x);
    for (var p = d.s.c; p <= d.e.c; ++p) {
      x === d.s.r && (h[p] = or(p)), c = h[p] + f;
      var w = u ? (i[x] || [])[p] : i[c];
      w && (fC(a, w, x, p, r), l && w.l && i["!links"].push([c, w.l]));
    }
  }
  var D = o.CodeName || o.name || n;
  return l && xe(a, 574, Z6((s.Views || [])[0])), l && (i["!merges"] || []).length && xe(a, 229, T$(i["!merges"])), l && lC(a, i), xe(a, 442, Tv(D)), l && oC(a, i), xe(
    a,
    10
    /* EOF */
  ), a.end();
}
function hC(e, r, t) {
  var a = ut(), n = (e || {}).Workbook || {}, i = n.Sheets || [], s = (
    /*::((*/
    n.WBProps || {
      /*::CodeName:"ThisWorkbook"*/
    }
  ), o = t.biff == 8, u = t.biff == 5;
  if (xe(a, 2057, Wc(e, 5, t)), t.bookType == "xla" && xe(
    a,
    135
    /* Addin */
  ), xe(a, 225, o ? Dt(1200) : null), xe(a, 193, m6(2)), u && xe(
    a,
    191
    /* ToolbarHdr */
  ), u && xe(
    a,
    192
    /* ToolbarEnd */
  ), xe(
    a,
    226
    /* InterfaceEnd */
  ), xe(a, 92, O6("SheetJS", t)), xe(a, 66, Dt(o ? 1200 : 1252)), o && xe(a, 353, Dt(0)), o && xe(
    a,
    448
    /* Excel9File */
  ), xe(a, 317, j$(e.SheetNames.length)), o && e.vbaraw && xe(
    a,
    211
    /* ObProj */
  ), o && e.vbaraw) {
    var l = s.CodeName || "ThisWorkbook";
    xe(a, 442, Tv(l));
  }
  xe(a, 156, Dt(17)), xe(a, 25, rt(!1)), xe(a, 18, rt(!1)), xe(a, 19, Dt(0)), o && xe(a, 431, rt(!1)), o && xe(a, 444, Dt(0)), xe(a, 61, Y6()), xe(a, 64, rt(!1)), xe(a, 141, Dt(0)), xe(a, 34, rt(GT(e) == "true")), xe(a, 14, rt(!0)), o && xe(a, 439, rt(!1)), xe(a, 218, Dt(0)), iC(a, e, t), sC(a, e.SSF, t), uC(a, t), o && xe(a, 352, rt(!1));
  var c = a.end(), f = ut();
  o && xe(f, 140, O$()), o && t.Strings && QS(f, 252, W6(t.Strings)), xe(
    f,
    10
    /* EOF */
  );
  var h = f.end(), d = ut(), m = 0, x = 0;
  for (x = 0; x < e.SheetNames.length; ++x)
    m += (o ? 12 : 11) + (o ? 2 : 1) * e.SheetNames[x].length;
  var p = c.length + m + h.length;
  for (x = 0; x < e.SheetNames.length; ++x) {
    var w = i[x] || {};
    xe(d, 133, U6({ pos: p, hs: w.Hidden || 0, dt: 0, name: e.SheetNames[x] }, t)), p += r[x].length;
  }
  var D = d.end();
  if (m != D.length)
    throw new Error("BS8 " + m + " != " + D.length);
  var y = [];
  return c.length && y.push(c), D.length && y.push(D), h.length && y.push(h), Or(y);
}
function xC(e, r) {
  var t = r || {}, a = [];
  e && !e.SSF && (e.SSF = tr(Ee)), e && e.SSF && (hi(), $s(e.SSF), t.revssf = p0(e.SSF), t.revssf[e.SSF[65535]] = 0, t.ssf = e.SSF), t.Strings = /*::((*/
  [], t.Strings.Count = 0, t.Strings.Unique = 0, tf(t), t.cellXfs = [], Ha(t.cellXfs, {}, { revssf: { General: 0 } }), e.Props || (e.Props = {});
  for (var n = 0; n < e.SheetNames.length; ++n)
    a[a.length] = dC(n, t, e);
  return a.unshift(hC(e, a, t)), Or(a);
}
function b2(e, r) {
  for (var t = 0; t <= e.SheetNames.length; ++t) {
    var a = e.Sheets[e.SheetNames[t]];
    if (!(!a || !a["!ref"])) {
      var n = tt(a["!ref"]);
      n.e.c > 255 && typeof console < "u" && console.error && console.error("Worksheet '" + e.SheetNames[t] + "' extends beyond column IV (255).  Data may be lost.");
    }
  }
  var i = r || {};
  switch (i.biff || 2) {
    case 8:
    case 5:
      return xC(e, r);
    case 4:
    case 3:
    case 2:
      return nC(e, r);
  }
  throw new Error("invalid type " + i.bookType + " for BIFF");
}
function wh(e, r) {
  var t = r || {}, a = t.dense ? [] : {};
  e = e.replace(/<!--.*?-->/g, "");
  var n = e.match(/<table/i);
  if (!n)
    throw new Error("Invalid HTML: could not find <table>");
  var i = e.match(/<\/table/i), s = n.index, o = i && i.index || e.length, u = Q5(e.slice(s, o), /(:?<tr[^>]*>)/i, "<tr>"), l = -1, c = 0, f = 0, h = 0, d = { s: { r: 1e7, c: 1e7 }, e: { r: 0, c: 0 } }, m = [];
  for (s = 0; s < u.length; ++s) {
    var x = u[s].trim(), p = x.slice(0, 3).toLowerCase();
    if (p == "<tr") {
      if (++l, t.sheetRows && t.sheetRows <= l) {
        --l;
        break;
      }
      c = 0;
      continue;
    }
    if (!(p != "<td" && p != "<th")) {
      var w = x.split(/<\/t[dh]>/i);
      for (o = 0; o < w.length; ++o) {
        var D = w[o].trim();
        if (D.match(/<t[dh]/i)) {
          for (var y = D, B = 0; y.charAt(0) == "<" && (B = y.indexOf(">")) > -1; )
            y = y.slice(B + 1);
          for (var L = 0; L < m.length; ++L) {
            var U = m[L];
            U.s.c == c && U.s.r < l && l <= U.e.r && (c = U.e.c + 1, L = -1);
          }
          var k = Se(D.slice(0, D.indexOf(">")));
          h = k.colspan ? +k.colspan : 1, ((f = +k.rowspan) > 1 || h > 1) && m.push({ s: { r: l, c }, e: { r: l + (f || 1) - 1, c: c + h - 1 } });
          var v = k.t || k["data-t"] || "";
          if (!y.length) {
            c += h;
            continue;
          }
          if (y = Yp(y), d.s.r > l && (d.s.r = l), d.e.r < l && (d.e.r = l), d.s.c > c && (d.s.c = c), d.e.c < c && (d.e.c = c), !y.length) {
            c += h;
            continue;
          }
          var b = { t: "s", v: y };
          t.raw || !y.trim().length || v == "s" || (y === "TRUE" ? b = { t: "b", v: !0 } : y === "FALSE" ? b = { t: "b", v: !1 } : isNaN(Ot(y)) ? isNaN(oi(y).getDate()) || (b = { t: "d", v: ur(y) }, t.cellDates || (b = { t: "n", v: Ar(b.v) }), b.z = t.dateNF || Ee[14]) : b = { t: "n", v: Ot(y) }), t.dense ? (a[l] || (a[l] = []), a[l][c] = b) : a[Te({ r: l, c })] = b, c += h;
        }
      }
    }
  }
  return a["!ref"] = Ce(d), m.length && (a["!merges"] = m), a;
}
function w2(e, r, t, a) {
  for (var n = e["!merges"] || [], i = [], s = r.s.c; s <= r.e.c; ++s) {
    for (var o = 0, u = 0, l = 0; l < n.length; ++l)
      if (!(n[l].s.r > t || n[l].s.c > s) && !(n[l].e.r < t || n[l].e.c < s)) {
        if (n[l].s.r < t || n[l].s.c < s) {
          o = -1;
          break;
        }
        o = n[l].e.r - n[l].s.r + 1, u = n[l].e.c - n[l].s.c + 1;
        break;
      }
    if (!(o < 0)) {
      var c = Te({ r: t, c: s }), f = a.dense ? (e[t] || [])[s] : e[c], h = f && f.v != null && (f.h || Ec(f.w || (Yt(f), f.w) || "")) || "", d = {};
      o > 1 && (d.rowspan = o), u > 1 && (d.colspan = u), a.editable ? h = '<span contenteditable="true">' + h + "</span>" : f && (d["data-t"] = f && f.t || "z", f.v != null && (d["data-v"] = f.v), f.z != null && (d["data-z"] = f.z), f.l && (f.l.Target || "#").charAt(0) != "#" && (h = '<a href="' + f.l.Target + '">' + h + "</a>")), d.id = (a.id || "sjs") + "-" + c, i.push(he("td", h, d));
    }
  }
  var m = "<tr>";
  return m + i.join("") + "</tr>";
}
var _2 = '<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>', $2 = "</body></html>";
function mC(e, r) {
  var t = e.match(/<table[\s\S]*?>[\s\S]*?<\/table>/gi);
  if (!t || t.length == 0)
    throw new Error("Invalid HTML: could not find <table>");
  if (t.length == 1)
    return Wa(wh(t[0], r), r);
  var a = uf();
  return t.forEach(function(n, i) {
    lf(a, wh(n, r), "Sheet" + (i + 1));
  }), a;
}
function D2(e, r, t) {
  var a = [];
  return a.join("") + "<table" + (t && t.id ? ' id="' + t.id + '"' : "") + ">";
}
function E2(e, r) {
  var t = r || {}, a = t.header != null ? t.header : _2, n = t.footer != null ? t.footer : $2, i = [a], s = tt(e["!ref"]);
  t.dense = Array.isArray(e), i.push(D2(e, s, t));
  for (var o = s.s.r; o <= s.e.r; ++o)
    i.push(w2(e, s, o, t));
  return i.push("</table>" + n), i.join("");
}
function k2(e, r, t) {
  var a = t || {}, n = 0, i = 0;
  if (a.origin != null)
    if (typeof a.origin == "number")
      n = a.origin;
    else {
      var s = typeof a.origin == "string" ? fr(a.origin) : a.origin;
      n = s.r, i = s.c;
    }
  var o = r.getElementsByTagName("tr"), u = Math.min(a.sheetRows || 1e7, o.length), l = { s: { r: 0, c: 0 }, e: { r: n, c: i } };
  if (e["!ref"]) {
    var c = tt(e["!ref"]);
    l.s.r = Math.min(l.s.r, c.s.r), l.s.c = Math.min(l.s.c, c.s.c), l.e.r = Math.max(l.e.r, c.e.r), l.e.c = Math.max(l.e.c, c.e.c), n == -1 && (l.e.r = n = c.e.r + 1);
  }
  var f = [], h = 0, d = e["!rows"] || (e["!rows"] = []), m = 0, x = 0, p = 0, w = 0, D = 0, y = 0;
  for (e["!cols"] || (e["!cols"] = []); m < o.length && x < u; ++m) {
    var B = o[m];
    if (_h(B)) {
      if (a.display)
        continue;
      d[x] = { hidden: !0 };
    }
    var L = B.children;
    for (p = w = 0; p < L.length; ++p) {
      var U = L[p];
      if (!(a.display && _h(U))) {
        var k = U.hasAttribute("data-v") ? U.getAttribute("data-v") : U.hasAttribute("v") ? U.getAttribute("v") : Yp(U.innerHTML), v = U.getAttribute("data-z") || U.getAttribute("z");
        for (h = 0; h < f.length; ++h) {
          var b = f[h];
          b.s.c == w + i && b.s.r < x + n && x + n <= b.e.r && (w = b.e.c + 1 - i, h = -1);
        }
        y = +U.getAttribute("colspan") || 1, ((D = +U.getAttribute("rowspan") || 1) > 1 || y > 1) && f.push({ s: { r: x + n, c: w + i }, e: { r: x + n + (D || 1) - 1, c: w + i + (y || 1) - 1 } });
        var A = { t: "s", v: k }, T = U.getAttribute("data-t") || U.getAttribute("t") || "";
        k != null && (k.length == 0 ? A.t = T || "z" : a.raw || k.trim().length == 0 || T == "s" || (k === "TRUE" ? A = { t: "b", v: !0 } : k === "FALSE" ? A = { t: "b", v: !1 } : isNaN(Ot(k)) ? isNaN(oi(k).getDate()) || (A = { t: "d", v: ur(k) }, a.cellDates || (A = { t: "n", v: Ar(A.v) }), A.z = a.dateNF || Ee[14]) : A = { t: "n", v: Ot(k) })), A.z === void 0 && v != null && (A.z = v);
        var C = "", I = U.getElementsByTagName("A");
        if (I && I.length)
          for (var Y = 0; Y < I.length && !(I[Y].hasAttribute("href") && (C = I[Y].getAttribute("href"), C.charAt(0) != "#")); ++Y)
            ;
        C && C.charAt(0) != "#" && (A.l = { Target: C }), a.dense ? (e[x + n] || (e[x + n] = []), e[x + n][w + i] = A) : e[Te({ c: w + i, r: x + n })] = A, l.e.c < w + i && (l.e.c = w + i), w += y;
      }
    }
    ++x;
  }
  return f.length && (e["!merges"] = (e["!merges"] || []).concat(f)), l.e.r = Math.max(l.e.r, x - 1 + n), e["!ref"] = Ce(l), x >= u && (e["!fullref"] = Ce((l.e.r = o.length - m + x - 1 + n, l))), e;
}
function T2(e, r) {
  var t = r || {}, a = t.dense ? [] : {};
  return k2(a, e, r);
}
function pC(e, r) {
  return Wa(T2(e, r), r);
}
function _h(e) {
  var r = "", t = vC(e);
  return t && (r = t(e).getPropertyValue("display")), r || (r = e.style && e.style.display), r === "none";
}
function vC(e) {
  return e.ownerDocument.defaultView && typeof e.ownerDocument.defaultView.getComputedStyle == "function" ? e.ownerDocument.defaultView.getComputedStyle : typeof getComputedStyle == "function" ? getComputedStyle : null;
}
function gC(e) {
  var r = e.replace(/[\t\r\n]/g, " ").trim().replace(/ +/g, " ").replace(/<text:s\/>/g, " ").replace(/<text:s text:c="(\d+)"\/>/g, function(a, n) {
    return Array(parseInt(n, 10) + 1).join(" ");
  }).replace(/<text:tab[^>]*\/>/g, "	").replace(/<text:line-break\/>/g, `
`), t = We(r.replace(/<[^>]*>/g, ""));
  return [t];
}
var $h = {
  /* ods name: [short ssf fmt, long ssf fmt] */
  day: ["d", "dd"],
  month: ["m", "mm"],
  year: ["y", "yy"],
  hours: ["h", "hh"],
  minutes: ["m", "mm"],
  seconds: ["s", "ss"],
  "am-pm": ["A/P", "AM/PM"],
  "day-of-week": ["ddd", "dddd"],
  era: ["e", "ee"],
  /* there is no native representation of LO "Q" format */
  quarter: ["\\Qm", 'm\\"th quarter"']
};
function S2(e, r) {
  var t = r || {}, a = kc(e), n = [], i, s, o = { name: "" }, u = "", l = 0, c, f, h = {}, d = [], m = t.dense ? [] : {}, x, p, w = { value: "" }, D = "", y = 0, B = [], L = -1, U = -1, k = { s: { r: 1e6, c: 1e7 }, e: { r: 0, c: 0 } }, v = 0, b = {}, A = [], T = {}, C = 0, I = 0, Y = [], j = 1, J = 1, W = [], ce = { Names: [] }, V = {}, ee = ["", ""], de = [], F = {}, H = "", P = 0, N = !1, X = !1, ae = 0;
  for (is.lastIndex = 0, a = a.replace(/<!--([\s\S]*?)-->/mg, "").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm, ""); x = is.exec(a); )
    switch (x[3] = x[3].replace(/_.*$/, "")) {
      case "table":
      case "工作表":
        x[1] === "/" ? (k.e.c >= k.s.c && k.e.r >= k.s.r ? m["!ref"] = Ce(k) : m["!ref"] = "A1:A1", t.sheetRows > 0 && t.sheetRows <= k.e.r && (m["!fullref"] = m["!ref"], k.e.r = t.sheetRows - 1, m["!ref"] = Ce(k)), A.length && (m["!merges"] = A), Y.length && (m["!rows"] = Y), c.name = c.名称 || c.name, typeof JSON < "u" && JSON.stringify(c), d.push(c.name), h[c.name] = m, X = !1) : x[0].charAt(x[0].length - 2) !== "/" && (c = Se(x[0], !1), L = U = -1, k.s.r = k.s.c = 1e7, k.e.r = k.e.c = 0, m = t.dense ? [] : {}, A = [], Y = [], X = !0);
        break;
      case "table-row-group":
        x[1] === "/" ? --v : ++v;
        break;
      case "table-row":
      case "行":
        if (x[1] === "/") {
          L += j, j = 1;
          break;
        }
        if (f = Se(x[0], !1), f.行号 ? L = f.行号 - 1 : L == -1 && (L = 0), j = +f["number-rows-repeated"] || 1, j < 10)
          for (ae = 0; ae < j; ++ae)
            v > 0 && (Y[L + ae] = { level: v });
        U = -1;
        break;
      case "covered-table-cell":
        x[1] !== "/" && ++U, t.sheetStubs && (t.dense ? (m[L] || (m[L] = []), m[L][U] = { t: "z" }) : m[Te({ r: L, c: U })] = { t: "z" }), D = "", B = [];
        break;
      case "table-cell":
      case "数据":
        if (x[0].charAt(x[0].length - 2) === "/")
          ++U, w = Se(x[0], !1), J = parseInt(w["number-columns-repeated"] || "1", 10), p = {
            t: "z",
            v: null
            /*:: , z:null, w:"",c:[]*/
          }, w.formula && t.cellFormula != !1 && (p.f = gh(We(w.formula))), (w.数据类型 || w["value-type"]) == "string" && (p.t = "s", p.v = We(w["string-value"] || ""), t.dense ? (m[L] || (m[L] = []), m[L][U] = p) : m[Te({ r: L, c: U })] = p), U += J - 1;
        else if (x[1] !== "/") {
          ++U, D = "", y = 0, B = [], J = 1;
          var ie = j ? L + j - 1 : L;
          if (U > k.e.c && (k.e.c = U), U < k.s.c && (k.s.c = U), L < k.s.r && (k.s.r = L), ie > k.e.r && (k.e.r = ie), w = Se(x[0], !1), de = [], F = {}, p = {
            t: w.数据类型 || w["value-type"],
            v: null
            /*:: , z:null, w:"",c:[]*/
          }, t.cellFormula)
            if (w.formula && (w.formula = We(w.formula)), w["number-matrix-columns-spanned"] && w["number-matrix-rows-spanned"] && (C = parseInt(w["number-matrix-rows-spanned"], 10) || 0, I = parseInt(w["number-matrix-columns-spanned"], 10) || 0, T = { s: { r: L, c: U }, e: { r: L + C - 1, c: U + I - 1 } }, p.F = Ce(T), W.push([T, p.F])), w.formula)
              p.f = gh(w.formula);
            else
              for (ae = 0; ae < W.length; ++ae)
                L >= W[ae][0].s.r && L <= W[ae][0].e.r && U >= W[ae][0].s.c && U <= W[ae][0].e.c && (p.F = W[ae][1]);
          switch ((w["number-columns-spanned"] || w["number-rows-spanned"]) && (C = parseInt(w["number-rows-spanned"], 10) || 0, I = parseInt(w["number-columns-spanned"], 10) || 0, T = { s: { r: L, c: U }, e: { r: L + C - 1, c: U + I - 1 } }, A.push(T)), w["number-columns-repeated"] && (J = parseInt(w["number-columns-repeated"], 10)), p.t) {
            case "boolean":
              p.t = "b", p.v = sr(w["boolean-value"]);
              break;
            case "float":
              p.t = "n", p.v = parseFloat(w.value);
              break;
            case "percentage":
              p.t = "n", p.v = parseFloat(w.value);
              break;
            case "currency":
              p.t = "n", p.v = parseFloat(w.value);
              break;
            case "date":
              p.t = "d", p.v = ur(w["date-value"]), t.cellDates || (p.t = "n", p.v = Ar(p.v)), p.z = "m/d/yy";
              break;
            case "time":
              p.t = "n", p.v = Z5(w["time-value"]) / 86400, t.cellDates && (p.t = "d", p.v = v0(p.v)), p.z = "HH:MM:SS";
              break;
            case "number":
              p.t = "n", p.v = parseFloat(w.数据数值);
              break;
            default:
              if (p.t === "string" || p.t === "text" || !p.t)
                p.t = "s", w["string-value"] != null && (D = We(w["string-value"]), B = []);
              else
                throw new Error("Unsupported value type " + p.t);
          }
        } else {
          if (N = !1, p.t === "s" && (p.v = D || "", B.length && (p.R = B), N = y == 0), V.Target && (p.l = V), de.length > 0 && (p.c = de, de = []), D && t.cellText !== !1 && (p.w = D), N && (p.t = "z", delete p.v), (!N || t.sheetStubs) && !(t.sheetRows && t.sheetRows <= L))
            for (var q = 0; q < j; ++q) {
              if (J = parseInt(w["number-columns-repeated"] || "1", 10), t.dense)
                for (m[L + q] || (m[L + q] = []), m[L + q][U] = q == 0 ? p : tr(p); --J > 0; )
                  m[L + q][U + J] = tr(p);
              else
                for (m[Te({ r: L + q, c: U })] = p; --J > 0; )
                  m[Te({ r: L + q, c: U + J })] = tr(p);
              k.e.c <= U && (k.e.c = U);
            }
          J = parseInt(w["number-columns-repeated"] || "1", 10), U += J - 1, J = 0, p = {
            /*:: t:"", v:null, z:null, w:"",c:[]*/
          }, D = "", B = [];
        }
        V = {};
        break;
      case "document":
      case "document-content":
      case "电子表格文档":
      case "spreadsheet":
      case "主体":
      case "scripts":
      case "styles":
      case "font-face-decls":
      case "master-styles":
        if (x[1] === "/") {
          if ((i = n.pop())[0] !== x[3])
            throw "Bad state: " + i;
        } else
          x[0].charAt(x[0].length - 2) !== "/" && n.push([x[3], !0]);
        break;
      case "annotation":
        if (x[1] === "/") {
          if ((i = n.pop())[0] !== x[3])
            throw "Bad state: " + i;
          F.t = D, B.length && (F.R = B), F.a = H, de.push(F);
        } else
          x[0].charAt(x[0].length - 2) !== "/" && n.push([x[3], !1]);
        H = "", P = 0, D = "", y = 0, B = [];
        break;
      case "creator":
        x[1] === "/" ? H = a.slice(P, x.index) : P = x.index + x[0].length;
        break;
      case "meta":
      case "元数据":
      case "settings":
      case "config-item-set":
      case "config-item-map-indexed":
      case "config-item-map-entry":
      case "config-item-map-named":
      case "shapes":
      case "frame":
      case "text-box":
      case "image":
      case "data-pilot-tables":
      case "list-style":
      case "form":
      case "dde-links":
      case "event-listeners":
      case "chart":
        if (x[1] === "/") {
          if ((i = n.pop())[0] !== x[3])
            throw "Bad state: " + i;
        } else
          x[0].charAt(x[0].length - 2) !== "/" && n.push([x[3], !1]);
        D = "", y = 0, B = [];
        break;
      case "scientific-number":
        break;
      case "currency-symbol":
        break;
      case "currency-style":
        break;
      case "number-style":
      case "percentage-style":
      case "date-style":
      case "time-style":
        if (x[1] === "/") {
          if (b[o.name] = u, (i = n.pop())[0] !== x[3])
            throw "Bad state: " + i;
        } else
          x[0].charAt(x[0].length - 2) !== "/" && (u = "", o = Se(x[0], !1), n.push([x[3], !0]));
        break;
      case "script":
        break;
      case "libraries":
        break;
      case "automatic-styles":
        break;
      case "default-style":
      case "page-layout":
        break;
      case "style":
        break;
      case "map":
        break;
      case "font-face":
        break;
      case "paragraph-properties":
        break;
      case "table-properties":
        break;
      case "table-column-properties":
        break;
      case "table-row-properties":
        break;
      case "table-cell-properties":
        break;
      case "number":
        switch (n[n.length - 1][0]) {
          case "time-style":
          case "date-style":
            s = Se(x[0], !1), u += $h[x[3]][s.style === "long" ? 1 : 0];
            break;
        }
        break;
      case "fraction":
        break;
      case "day":
      case "month":
      case "year":
      case "era":
      case "day-of-week":
      case "week-of-year":
      case "quarter":
      case "hours":
      case "minutes":
      case "seconds":
      case "am-pm":
        switch (n[n.length - 1][0]) {
          case "time-style":
          case "date-style":
            s = Se(x[0], !1), u += $h[x[3]][s.style === "long" ? 1 : 0];
            break;
        }
        break;
      case "boolean-style":
        break;
      case "boolean":
        break;
      case "text-style":
        break;
      case "text":
        if (x[0].slice(-2) === "/>")
          break;
        if (x[1] === "/")
          switch (n[n.length - 1][0]) {
            case "number-style":
            case "date-style":
            case "time-style":
              u += a.slice(l, x.index);
              break;
          }
        else
          l = x.index + x[0].length;
        break;
      case "named-range":
        s = Se(x[0], !1), ee = vu(s["cell-range-address"]);
        var re = { Name: s.name, Ref: ee[0] + "!" + ee[1] };
        X && (re.Sheet = d.length), ce.Names.push(re);
        break;
      case "text-content":
        break;
      case "text-properties":
        break;
      case "embedded-text":
        break;
      case "body":
      case "电子表格":
        break;
      case "forms":
        break;
      case "table-column":
        break;
      case "table-header-rows":
        break;
      case "table-rows":
        break;
      case "table-column-group":
        break;
      case "table-header-columns":
        break;
      case "table-columns":
        break;
      case "null-date":
        break;
      case "graphic-properties":
        break;
      case "calculation-settings":
        break;
      case "named-expressions":
        break;
      case "label-range":
        break;
      case "label-ranges":
        break;
      case "named-expression":
        break;
      case "sort":
        break;
      case "sort-by":
        break;
      case "sort-groups":
        break;
      case "tab":
        break;
      case "line-break":
        break;
      case "span":
        break;
      case "p":
      case "文本串":
        if (["master-styles"].indexOf(n[n.length - 1][0]) > -1)
          break;
        if (x[1] === "/" && (!w || !w["string-value"])) {
          var ve = gC(a.slice(y, x.index));
          D = (D.length > 0 ? D + `
` : "") + ve[0];
        } else
          Se(x[0], !1), y = x.index + x[0].length;
        break;
      case "s":
        break;
      case "database-range":
        if (x[1] === "/")
          break;
        try {
          ee = vu(Se(x[0])["target-range-address"]), h[ee[0]]["!autofilter"] = { ref: ee[1] };
        } catch {
        }
        break;
      case "date":
        break;
      case "object":
        break;
      case "title":
      case "标题":
        break;
      case "desc":
        break;
      case "binary-data":
        break;
      case "table-source":
        break;
      case "scenario":
        break;
      case "iteration":
        break;
      case "content-validations":
        break;
      case "content-validation":
        break;
      case "help-message":
        break;
      case "error-message":
        break;
      case "database-ranges":
        break;
      case "filter":
        break;
      case "filter-and":
        break;
      case "filter-or":
        break;
      case "filter-condition":
        break;
      case "list-level-style-bullet":
        break;
      case "list-level-style-number":
        break;
      case "list-level-properties":
        break;
      case "sender-firstname":
      case "sender-lastname":
      case "sender-initials":
      case "sender-title":
      case "sender-position":
      case "sender-email":
      case "sender-phone-private":
      case "sender-fax":
      case "sender-company":
      case "sender-phone-work":
      case "sender-street":
      case "sender-city":
      case "sender-postal-code":
      case "sender-country":
      case "sender-state-or-province":
      case "author-name":
      case "author-initials":
      case "chapter":
      case "file-name":
      case "template-name":
      case "sheet-name":
        break;
      case "event-listener":
        break;
      case "initial-creator":
      case "creation-date":
      case "print-date":
      case "generator":
      case "document-statistic":
      case "user-defined":
      case "editing-duration":
      case "editing-cycles":
        break;
      case "config-item":
        break;
      case "page-number":
        break;
      case "page-count":
        break;
      case "time":
        break;
      case "cell-range-source":
        break;
      case "detective":
        break;
      case "operation":
        break;
      case "highlighted-range":
        break;
      case "data-pilot-table":
      case "source-cell-range":
      case "source-service":
      case "data-pilot-field":
      case "data-pilot-level":
      case "data-pilot-subtotals":
      case "data-pilot-subtotal":
      case "data-pilot-members":
      case "data-pilot-member":
      case "data-pilot-display-info":
      case "data-pilot-sort-info":
      case "data-pilot-layout-info":
      case "data-pilot-field-reference":
      case "data-pilot-groups":
      case "data-pilot-group":
      case "data-pilot-group-member":
        break;
      case "rect":
        break;
      case "dde-connection-decls":
      case "dde-connection-decl":
      case "dde-link":
      case "dde-source":
        break;
      case "properties":
        break;
      case "property":
        break;
      case "a":
        if (x[1] !== "/") {
          if (V = Se(x[0], !1), !V.href)
            break;
          V.Target = We(V.href), delete V.href, V.Target.charAt(0) == "#" && V.Target.indexOf(".") > -1 ? (ee = vu(V.Target.slice(1)), V.Target = "#" + ee[0] + "!" + ee[1]) : V.Target.match(/^\.\.[\\\/]/) && (V.Target = V.Target.slice(3));
        }
        break;
      case "table-protection":
        break;
      case "data-pilot-grand-total":
        break;
      case "office-document-common-attrs":
        break;
      default:
        switch (x[2]) {
          case "dc:":
          case "calcext:":
          case "loext:":
          case "ooo:":
          case "chartooo:":
          case "draw:":
          case "style:":
          case "chart:":
          case "form:":
          case "uof:":
          case "表:":
          case "字:":
            break;
          default:
            if (t.WTF)
              throw new Error(x);
        }
    }
  var M = {
    Sheets: h,
    SheetNames: d,
    Workbook: ce
  };
  return t.bookSheets && delete /*::(*/
  M.Sheets, M;
}
function Dh(e, r) {
  r = r || {}, _t(e, "META-INF/manifest.xml") && Z_(kr(e, "META-INF/manifest.xml"), r);
  var t = ht(e, "content.xml");
  if (!t)
    throw new Error("Missing content.xml in ODS / UOF file");
  var a = S2(Qe(t), r);
  return _t(e, "meta.xml") && (a.Props = xv(kr(e, "meta.xml"))), a;
}
function Eh(e, r) {
  return S2(e, r);
}
var yC = /* @__PURE__ */ function() {
  var e = [
    "<office:master-styles>",
    '<style:master-page style:name="mp1" style:page-layout-name="mp1">',
    "<style:header/>",
    '<style:header-left style:display="false"/>',
    "<style:footer/>",
    '<style:footer-left style:display="false"/>',
    "</style:master-page>",
    "</office:master-styles>"
  ].join(""), r = "<office:document-styles " + ns({
    "xmlns:office": "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
    "xmlns:table": "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
    "xmlns:style": "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
    "xmlns:text": "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
    "xmlns:draw": "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
    "xmlns:fo": "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xmlns:dc": "http://purl.org/dc/elements/1.1/",
    "xmlns:number": "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
    "xmlns:svg": "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
    "xmlns:of": "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
    "office:version": "1.2"
  }) + ">" + e + "</office:document-styles>";
  return function() {
    return $r + r;
  };
}(), kh = /* @__PURE__ */ function() {
  var e = function(i) {
    return Xe(i).replace(/  +/g, function(s) {
      return '<text:s text:c="' + s.length + '"/>';
    }).replace(/\t/g, "<text:tab/>").replace(/\n/g, "</text:p><text:p>").replace(/^ /, "<text:s/>").replace(/ $/, "<text:s/>");
  }, r = `          <table:table-cell />
`, t = `          <table:covered-table-cell/>
`, a = function(i, s, o) {
    var u = [];
    u.push('      <table:table table:name="' + Xe(s.SheetNames[o]) + `" table:style-name="ta1">
`);
    var l = 0, c = 0, f = tt(i["!ref"] || "A1"), h = i["!merges"] || [], d = 0, m = Array.isArray(i);
    if (i["!cols"])
      for (c = 0; c <= f.e.c; ++c)
        u.push("        <table:table-column" + (i["!cols"][c] ? ' table:style-name="co' + i["!cols"][c].ods + '"' : "") + `></table:table-column>
`);
    var x = "", p = i["!rows"] || [];
    for (l = 0; l < f.s.r; ++l)
      x = p[l] ? ' table:style-name="ro' + p[l].ods + '"' : "", u.push("        <table:table-row" + x + `></table:table-row>
`);
    for (; l <= f.e.r; ++l) {
      for (x = p[l] ? ' table:style-name="ro' + p[l].ods + '"' : "", u.push("        <table:table-row" + x + `>
`), c = 0; c < f.s.c; ++c)
        u.push(r);
      for (; c <= f.e.c; ++c) {
        var w = !1, D = {}, y = "";
        for (d = 0; d != h.length; ++d)
          if (!(h[d].s.c > c) && !(h[d].s.r > l) && !(h[d].e.c < c) && !(h[d].e.r < l)) {
            (h[d].s.c != c || h[d].s.r != l) && (w = !0), D["table:number-columns-spanned"] = h[d].e.c - h[d].s.c + 1, D["table:number-rows-spanned"] = h[d].e.r - h[d].s.r + 1;
            break;
          }
        if (w) {
          u.push(t);
          continue;
        }
        var B = Te({ r: l, c }), L = m ? (i[l] || [])[c] : i[B];
        if (L && L.f && (D["table:formula"] = Xe(j8(L.f)), L.F && L.F.slice(0, B.length) == B)) {
          var U = tt(L.F);
          D["table:number-matrix-columns-spanned"] = U.e.c - U.s.c + 1, D["table:number-matrix-rows-spanned"] = U.e.r - U.s.r + 1;
        }
        if (!L) {
          u.push(r);
          continue;
        }
        switch (L.t) {
          case "b":
            y = L.v ? "TRUE" : "FALSE", D["office:value-type"] = "boolean", D["office:boolean-value"] = L.v ? "true" : "false";
            break;
          case "n":
            y = L.w || String(L.v || 0), D["office:value-type"] = "float", D["office:value"] = L.v || 0;
            break;
          case "s":
          case "str":
            y = L.v == null ? "" : L.v, D["office:value-type"] = "string";
            break;
          case "d":
            y = L.w || ur(L.v).toISOString(), D["office:value-type"] = "date", D["office:date-value"] = ur(L.v).toISOString(), D["table:style-name"] = "ce1";
            break;
          default:
            u.push(r);
            continue;
        }
        var k = e(y);
        if (L.l && L.l.Target) {
          var v = L.l.Target;
          v = v.charAt(0) == "#" ? "#" + z8(v.slice(1)) : v, v.charAt(0) != "#" && !v.match(/^\w+:/) && (v = "../" + v), k = he("text:a", k, { "xlink:href": v.replace(/&/g, "&amp;") });
        }
        u.push("          " + he("table:table-cell", he("text:p", k, {}), D) + `
`);
      }
      u.push(`        </table:table-row>
`);
    }
    return u.push(`      </table:table>
`), u.join("");
  }, n = function(i, s) {
    i.push(` <office:automatic-styles>
`), i.push(`  <number:date-style style:name="N37" number:automatic-order="true">
`), i.push(`   <number:month number:style="long"/>
`), i.push(`   <number:text>/</number:text>
`), i.push(`   <number:day number:style="long"/>
`), i.push(`   <number:text>/</number:text>
`), i.push(`   <number:year/>
`), i.push(`  </number:date-style>
`);
    var o = 0;
    s.SheetNames.map(function(l) {
      return s.Sheets[l];
    }).forEach(function(l) {
      if (l && l["!cols"]) {
        for (var c = 0; c < l["!cols"].length; ++c)
          if (l["!cols"][c]) {
            var f = l["!cols"][c];
            if (f.width == null && f.wpx == null && f.wch == null)
              continue;
            Ma(f), f.ods = o;
            var h = l["!cols"][c].wpx + "px";
            i.push('  <style:style style:name="co' + o + `" style:family="table-column">
`), i.push('   <style:table-column-properties fo:break-before="auto" style:column-width="' + h + `"/>
`), i.push(`  </style:style>
`), ++o;
          }
      }
    });
    var u = 0;
    s.SheetNames.map(function(l) {
      return s.Sheets[l];
    }).forEach(function(l) {
      if (l && l["!rows"]) {
        for (var c = 0; c < l["!rows"].length; ++c)
          if (l["!rows"][c]) {
            l["!rows"][c].ods = u;
            var f = l["!rows"][c].hpx + "px";
            i.push('  <style:style style:name="ro' + u + `" style:family="table-row">
`), i.push('   <style:table-row-properties fo:break-before="auto" style:row-height="' + f + `"/>
`), i.push(`  </style:style>
`), ++u;
          }
      }
    }), i.push(`  <style:style style:name="ta1" style:family="table" style:master-page-name="mp1">
`), i.push(`   <style:table-properties table:display="true" style:writing-mode="lr-tb"/>
`), i.push(`  </style:style>
`), i.push(`  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>
`), i.push(` </office:automatic-styles>
`);
  };
  return function(s, o) {
    var u = [$r], l = ns({
      "xmlns:office": "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
      "xmlns:table": "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
      "xmlns:style": "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
      "xmlns:text": "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
      "xmlns:draw": "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
      "xmlns:fo": "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "xmlns:dc": "http://purl.org/dc/elements/1.1/",
      "xmlns:meta": "urn:oasis:names:tc:opendocument:xmlns:meta:1.0",
      "xmlns:number": "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
      "xmlns:presentation": "urn:oasis:names:tc:opendocument:xmlns:presentation:1.0",
      "xmlns:svg": "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
      "xmlns:chart": "urn:oasis:names:tc:opendocument:xmlns:chart:1.0",
      "xmlns:dr3d": "urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0",
      "xmlns:math": "http://www.w3.org/1998/Math/MathML",
      "xmlns:form": "urn:oasis:names:tc:opendocument:xmlns:form:1.0",
      "xmlns:script": "urn:oasis:names:tc:opendocument:xmlns:script:1.0",
      "xmlns:ooo": "http://openoffice.org/2004/office",
      "xmlns:ooow": "http://openoffice.org/2004/writer",
      "xmlns:oooc": "http://openoffice.org/2004/calc",
      "xmlns:dom": "http://www.w3.org/2001/xml-events",
      "xmlns:xforms": "http://www.w3.org/2002/xforms",
      "xmlns:xsd": "http://www.w3.org/2001/XMLSchema",
      "xmlns:xsi": "http://www.w3.org/2001/XMLSchema-instance",
      "xmlns:sheet": "urn:oasis:names:tc:opendocument:sh33tjs:1.0",
      "xmlns:rpt": "http://openoffice.org/2005/report",
      "xmlns:of": "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
      "xmlns:xhtml": "http://www.w3.org/1999/xhtml",
      "xmlns:grddl": "http://www.w3.org/2003/g/data-view#",
      "xmlns:tableooo": "http://openoffice.org/2009/table",
      "xmlns:drawooo": "http://openoffice.org/2010/draw",
      "xmlns:calcext": "urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0",
      "xmlns:loext": "urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0",
      "xmlns:field": "urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0",
      "xmlns:formx": "urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0",
      "xmlns:css3t": "http://www.w3.org/TR/css3-text/",
      "office:version": "1.2"
    }), c = ns({
      "xmlns:config": "urn:oasis:names:tc:opendocument:xmlns:config:1.0",
      "office:mimetype": "application/vnd.oasis.opendocument.spreadsheet"
    });
    o.bookType == "fods" ? (u.push("<office:document" + l + c + `>
`), u.push(hv().replace(/office:document-meta/g, "office:meta"))) : u.push("<office:document-content" + l + `>
`), n(u, s), u.push(`  <office:body>
`), u.push(`    <office:spreadsheet>
`);
    for (var f = 0; f != s.SheetNames.length; ++f)
      u.push(a(s.Sheets[s.SheetNames[f]], s, f));
    return u.push(`    </office:spreadsheet>
`), u.push(`  </office:body>
`), o.bookType == "fods" ? u.push("</office:document>") : u.push("</office:document-content>"), u.join("");
  };
}();
function C2(e, r) {
  if (r.bookType == "fods")
    return kh(e, r);
  var t = _c(), a = "", n = [], i = [];
  return a = "mimetype", Fe(t, a, "application/vnd.oasis.opendocument.spreadsheet"), a = "content.xml", Fe(t, a, kh(e, r)), n.push([a, "text/xml"]), i.push([a, "ContentFile"]), a = "styles.xml", Fe(t, a, yC(e, r)), n.push([a, "text/xml"]), i.push([a, "StylesFile"]), a = "meta.xml", Fe(t, a, $r + hv(
    /*::wb, opts*/
  )), n.push([a, "text/xml"]), i.push([a, "MetadataFile"]), a = "manifest.rdf", Fe(t, a, Q_(
    i
    /*, opts*/
  )), n.push([a, "application/rdf+xml"]), a = "META-INF/manifest.xml", Fe(t, a, J_(
    n
    /*, opts*/
  )), t;
}
/*! sheetjs (C) 2013-present SheetJS -- http://sheetjs.com */
function mn(e) {
  return new DataView(e.buffer, e.byteOffset, e.byteLength);
}
function Cl(e) {
  return typeof TextDecoder < "u" ? new TextDecoder().decode(e) : Qe(Va(e));
}
function bC(e) {
  return typeof TextEncoder < "u" ? new TextEncoder().encode(e) : dt(zt(e));
}
function wC(e, r) {
  e:
    for (var t = 0; t <= e.length - r.length; ++t) {
      for (var a = 0; a < r.length; ++a)
        if (e[t + a] != r[a])
          continue e;
      return !0;
    }
  return !1;
}
function La(e) {
  var r = e.reduce(function(n, i) {
    return n + i.length;
  }, 0), t = new Uint8Array(r), a = 0;
  return e.forEach(function(n) {
    t.set(n, a), a += n.length;
  }), t;
}
function Th(e) {
  return e -= e >> 1 & 1431655765, e = (e & 858993459) + (e >> 2 & 858993459), (e + (e >> 4) & 252645135) * 16843009 >>> 24;
}
function _C(e, r) {
  for (var t = (e[r + 15] & 127) << 7 | e[r + 14] >> 1, a = e[r + 14] & 1, n = r + 13; n >= r; --n)
    a = a * 256 + e[n];
  return (e[r + 15] & 128 ? -a : a) * Math.pow(10, t - 6176);
}
function $C(e, r, t) {
  var a = Math.floor(t == 0 ? 0 : Math.LOG10E * Math.log(Math.abs(t))) + 6176 - 20, n = t / Math.pow(10, a - 6176);
  e[r + 15] |= a >> 7, e[r + 14] |= (a & 127) << 1;
  for (var i = 0; n >= 1; ++i, n /= 256)
    e[r + i] = n & 255;
  e[r + 15] |= t >= 0 ? 0 : 128;
}
function ds(e, r) {
  var t = r ? r[0] : 0, a = e[t] & 127;
  e:
    if (e[t++] >= 128 && (a |= (e[t] & 127) << 7, e[t++] < 128 || (a |= (e[t] & 127) << 14, e[t++] < 128) || (a |= (e[t] & 127) << 21, e[t++] < 128) || (a += (e[t] & 127) * Math.pow(2, 28), ++t, e[t++] < 128) || (a += (e[t] & 127) * Math.pow(2, 35), ++t, e[t++] < 128) || (a += (e[t] & 127) * Math.pow(2, 42), ++t, e[t++] < 128)))
      break e;
  return r && (r[0] = t), a;
}
function Ke(e) {
  var r = new Uint8Array(7);
  r[0] = e & 127;
  var t = 1;
  e:
    if (e > 127) {
      if (r[t - 1] |= 128, r[t] = e >> 7 & 127, ++t, e <= 16383 || (r[t - 1] |= 128, r[t] = e >> 14 & 127, ++t, e <= 2097151) || (r[t - 1] |= 128, r[t] = e >> 21 & 127, ++t, e <= 268435455) || (r[t - 1] |= 128, r[t] = e / 256 >>> 21 & 127, ++t, e <= 34359738367) || (r[t - 1] |= 128, r[t] = e / 65536 >>> 21 & 127, ++t, e <= 4398046511103))
        break e;
      r[t - 1] |= 128, r[t] = e / 16777216 >>> 21 & 127, ++t;
    }
  return r.slice(0, t);
}
function yr(e) {
  var r = 0, t = e[r] & 127;
  e:
    if (e[r++] >= 128) {
      if (t |= (e[r] & 127) << 7, e[r++] < 128 || (t |= (e[r] & 127) << 14, e[r++] < 128) || (t |= (e[r] & 127) << 21, e[r++] < 128))
        break e;
      t |= (e[r] & 127) << 28;
    }
  return t;
}
function je(e) {
  for (var r = [], t = [0]; t[0] < e.length; ) {
    var a = t[0], n = ds(e, t), i = n & 7;
    n = Math.floor(n / 8);
    var s = 0, o;
    if (n == 0)
      break;
    switch (i) {
      case 0:
        {
          for (var u = t[0]; e[t[0]++] >= 128; )
            ;
          o = e.slice(u, t[0]);
        }
        break;
      case 5:
        s = 4, o = e.slice(t[0], t[0] + s), t[0] += s;
        break;
      case 1:
        s = 8, o = e.slice(t[0], t[0] + s), t[0] += s;
        break;
      case 2:
        s = ds(e, t), o = e.slice(t[0], t[0] + s), t[0] += s;
        break;
      case 3:
      case 4:
      default:
        throw new Error("PB Type ".concat(i, " for Field ").concat(n, " at offset ").concat(a));
    }
    var l = { data: o, type: i };
    r[n] == null ? r[n] = [l] : r[n].push(l);
  }
  return r;
}
function Ur(e) {
  var r = [];
  return e.forEach(function(t, a) {
    t.forEach(function(n) {
      n.data && (r.push(Ke(a * 8 + n.type)), n.type == 2 && r.push(Ke(n.data.length)), r.push(n.data));
    });
  }), La(r);
}
function ef(e, r) {
  return (e == null ? void 0 : e.map(function(t) {
    return r(t.data);
  })) || [];
}
function bt(e) {
  for (var r, t = [], a = [0]; a[0] < e.length; ) {
    var n = ds(e, a), i = je(e.slice(a[0], a[0] + n));
    a[0] += n;
    var s = {
      id: yr(i[1][0].data),
      messages: []
    };
    i[2].forEach(function(o) {
      var u = je(o.data), l = yr(u[3][0].data);
      s.messages.push({
        meta: u,
        data: e.slice(a[0], a[0] + l)
      }), a[0] += l;
    }), (r = i[3]) != null && r[0] && (s.merge = yr(i[3][0].data) >>> 0 > 0), t.push(s);
  }
  return t;
}
function Fn(e) {
  var r = [];
  return e.forEach(function(t) {
    var a = [];
    a[1] = [{ data: Ke(t.id), type: 0 }], a[2] = [], t.merge != null && (a[3] = [{ data: Ke(+!!t.merge), type: 0 }]);
    var n = [];
    t.messages.forEach(function(s) {
      n.push(s.data), s.meta[3] = [{ type: 0, data: Ke(s.data.length) }], a[2].push({ data: Ur(s.meta), type: 2 });
    });
    var i = Ur(a);
    r.push(Ke(i.length)), r.push(i), n.forEach(function(s) {
      return r.push(s);
    });
  }), La(r);
}
function DC(e, r) {
  if (e != 0)
    throw new Error("Unexpected Snappy chunk type ".concat(e));
  for (var t = [0], a = ds(r, t), n = []; t[0] < r.length; ) {
    var i = r[t[0]] & 3;
    if (i == 0) {
      var s = r[t[0]++] >> 2;
      if (s < 60)
        ++s;
      else {
        var o = s - 59;
        s = r[t[0]], o > 1 && (s |= r[t[0] + 1] << 8), o > 2 && (s |= r[t[0] + 2] << 16), o > 3 && (s |= r[t[0] + 3] << 24), s >>>= 0, s++, t[0] += o;
      }
      n.push(r.slice(t[0], t[0] + s)), t[0] += s;
      continue;
    } else {
      var u = 0, l = 0;
      if (i == 1 ? (l = (r[t[0]] >> 2 & 7) + 4, u = (r[t[0]++] & 224) << 3, u |= r[t[0]++]) : (l = (r[t[0]++] >> 2) + 1, i == 2 ? (u = r[t[0]] | r[t[0] + 1] << 8, t[0] += 2) : (u = (r[t[0]] | r[t[0] + 1] << 8 | r[t[0] + 2] << 16 | r[t[0] + 3] << 24) >>> 0, t[0] += 4)), n = [La(n)], u == 0)
        throw new Error("Invalid offset 0");
      if (u > n[0].length)
        throw new Error("Invalid offset beyond length");
      if (l >= u)
        for (n.push(n[0].slice(-u)), l -= u; l >= n[n.length - 1].length; )
          n.push(n[n.length - 1]), l -= n[n.length - 1].length;
      n.push(n[0].slice(-u, -u + l));
    }
  }
  var c = La(n);
  if (c.length != a)
    throw new Error("Unexpected length: ".concat(c.length, " != ").concat(a));
  return c;
}
function wt(e) {
  for (var r = [], t = 0; t < e.length; ) {
    var a = e[t++], n = e[t] | e[t + 1] << 8 | e[t + 2] << 16;
    t += 3, r.push(DC(a, e.slice(t, t + n))), t += n;
  }
  if (t !== e.length)
    throw new Error("data is not a valid framed stream!");
  return La(r);
}
function An(e) {
  for (var r = [], t = 0; t < e.length; ) {
    var a = Math.min(e.length - t, 268435455), n = new Uint8Array(4);
    r.push(n);
    var i = Ke(a), s = i.length;
    r.push(i), a <= 60 ? (s++, r.push(new Uint8Array([a - 1 << 2]))) : a <= 256 ? (s += 2, r.push(new Uint8Array([240, a - 1 & 255]))) : a <= 65536 ? (s += 3, r.push(new Uint8Array([244, a - 1 & 255, a - 1 >> 8 & 255]))) : a <= 16777216 ? (s += 4, r.push(new Uint8Array([248, a - 1 & 255, a - 1 >> 8 & 255, a - 1 >> 16 & 255]))) : a <= 4294967296 && (s += 5, r.push(new Uint8Array([252, a - 1 & 255, a - 1 >> 8 & 255, a - 1 >> 16 & 255, a - 1 >>> 24 & 255]))), r.push(e.slice(t, t + a)), s += a, n[0] = 0, n[1] = s & 255, n[2] = s >> 8 & 255, n[3] = s >> 16 & 255, t += a;
  }
  return La(r);
}
function EC(e, r, t, a) {
  var n = mn(e), i = n.getUint32(4, !0), s = (a > 1 ? 12 : 8) + Th(i & (a > 1 ? 3470 : 398)) * 4, o = -1, u = -1, l = NaN, c = new Date(2001, 0, 1);
  i & 512 && (o = n.getUint32(s, !0), s += 4), s += Th(i & (a > 1 ? 12288 : 4096)) * 4, i & 16 && (u = n.getUint32(s, !0), s += 4), i & 32 && (l = n.getFloat64(s, !0), s += 8), i & 64 && (c.setTime(c.getTime() + n.getFloat64(s, !0) * 1e3), s += 8);
  var f;
  switch (e[2]) {
    case 0:
      break;
    case 2:
      f = { t: "n", v: l };
      break;
    case 3:
      f = { t: "s", v: r[u] };
      break;
    case 5:
      f = { t: "d", v: c };
      break;
    case 6:
      f = { t: "b", v: l > 0 };
      break;
    case 7:
      f = { t: "n", v: l / 86400 };
      break;
    case 8:
      f = { t: "e", v: 0 };
      break;
    case 9:
      if (o > -1)
        f = { t: "s", v: t[o] };
      else if (u > -1)
        f = { t: "s", v: r[u] };
      else if (!isNaN(l))
        f = { t: "n", v: l };
      else
        throw new Error("Unsupported cell type ".concat(e.slice(0, 4)));
      break;
    default:
      throw new Error("Unsupported cell type ".concat(e.slice(0, 4)));
  }
  return f;
}
function kC(e, r, t) {
  var a = mn(e), n = a.getUint32(8, !0), i = 12, s = -1, o = -1, u = NaN, l = NaN, c = new Date(2001, 0, 1);
  n & 1 && (u = _C(e, i), i += 16), n & 2 && (l = a.getFloat64(i, !0), i += 8), n & 4 && (c.setTime(c.getTime() + a.getFloat64(i, !0) * 1e3), i += 8), n & 8 && (o = a.getUint32(i, !0), i += 4), n & 16 && (s = a.getUint32(i, !0), i += 4);
  var f;
  switch (e[1]) {
    case 0:
      break;
    case 2:
      f = { t: "n", v: u };
      break;
    case 3:
      f = { t: "s", v: r[o] };
      break;
    case 5:
      f = { t: "d", v: c };
      break;
    case 6:
      f = { t: "b", v: l > 0 };
      break;
    case 7:
      f = { t: "n", v: l / 86400 };
      break;
    case 8:
      f = { t: "e", v: 0 };
      break;
    case 9:
      if (s > -1)
        f = { t: "s", v: t[s] };
      else
        throw new Error("Unsupported cell type ".concat(e[1], " : ").concat(n & 31, " : ").concat(e.slice(0, 4)));
      break;
    case 10:
      f = { t: "n", v: u };
      break;
    default:
      throw new Error("Unsupported cell type ".concat(e[1], " : ").concat(n & 31, " : ").concat(e.slice(0, 4)));
  }
  return f;
}
function yu(e, r) {
  var t = new Uint8Array(32), a = mn(t), n = 12, i = 0;
  switch (t[0] = 5, e.t) {
    case "n":
      t[1] = 2, $C(t, n, e.v), i |= 1, n += 16;
      break;
    case "b":
      t[1] = 6, a.setFloat64(n, e.v ? 1 : 0, !0), i |= 2, n += 8;
      break;
    case "s":
      if (r.indexOf(e.v) == -1)
        throw new Error("Value ".concat(e.v, " missing from SST!"));
      t[1] = 3, a.setUint32(n, r.indexOf(e.v), !0), i |= 8, n += 4;
      break;
    default:
      throw "unsupported cell type " + e.t;
  }
  return a.setUint32(8, i, !0), t.slice(0, n);
}
function bu(e, r) {
  var t = new Uint8Array(32), a = mn(t), n = 12, i = 0;
  switch (t[0] = 3, e.t) {
    case "n":
      t[2] = 2, a.setFloat64(n, e.v, !0), i |= 32, n += 8;
      break;
    case "b":
      t[2] = 6, a.setFloat64(n, e.v ? 1 : 0, !0), i |= 32, n += 8;
      break;
    case "s":
      if (r.indexOf(e.v) == -1)
        throw new Error("Value ".concat(e.v, " missing from SST!"));
      t[2] = 3, a.setUint32(n, r.indexOf(e.v), !0), i |= 16, n += 4;
      break;
    default:
      throw "unsupported cell type " + e.t;
  }
  return a.setUint32(4, i, !0), t.slice(0, n);
}
function TC(e, r, t) {
  switch (e[0]) {
    case 0:
    case 1:
    case 2:
    case 3:
      return EC(e, r, t, e[0]);
    case 5:
      return kC(e, r, t);
    default:
      throw new Error("Unsupported payload version ".concat(e[0]));
  }
}
function zr(e) {
  var r = je(e);
  return ds(r[1][0].data);
}
function Sh(e, r) {
  var t = je(r.data), a = yr(t[1][0].data), n = t[3], i = [];
  return (n || []).forEach(function(s) {
    var o = je(s.data), u = yr(o[1][0].data) >>> 0;
    switch (a) {
      case 1:
        i[u] = Cl(o[3][0].data);
        break;
      case 8:
        {
          var l = e[zr(o[9][0].data)][0], c = je(l.data), f = e[zr(c[1][0].data)][0], h = yr(f.meta[1][0].data);
          if (h != 2001)
            throw new Error("2000 unexpected reference to ".concat(h));
          var d = je(f.data);
          i[u] = d[3].map(function(m) {
            return Cl(m.data);
          }).join("");
        }
        break;
    }
  }), i;
}
function SC(e, r) {
  var t, a, n, i, s, o, u, l, c, f, h, d, m, x, p = je(e), w = yr(p[1][0].data) >>> 0, D = yr(p[2][0].data) >>> 0, y = ((a = (t = p[8]) == null ? void 0 : t[0]) == null ? void 0 : a.data) && yr(p[8][0].data) > 0 || !1, B, L;
  if ((i = (n = p[7]) == null ? void 0 : n[0]) != null && i.data && r != 0)
    B = (o = (s = p[7]) == null ? void 0 : s[0]) == null ? void 0 : o.data, L = (l = (u = p[6]) == null ? void 0 : u[0]) == null ? void 0 : l.data;
  else if ((f = (c = p[4]) == null ? void 0 : c[0]) != null && f.data && r != 1)
    B = (d = (h = p[4]) == null ? void 0 : h[0]) == null ? void 0 : d.data, L = (x = (m = p[3]) == null ? void 0 : m[0]) == null ? void 0 : x.data;
  else
    throw "NUMBERS Tile missing ".concat(r, " cell storage");
  for (var U = y ? 4 : 1, k = mn(B), v = [], b = 0; b < B.length / 2; ++b) {
    var A = k.getUint16(b * 2, !0);
    A < 65535 && v.push([b, A]);
  }
  if (v.length != D)
    throw "Expected ".concat(D, " cells, found ").concat(v.length);
  var T = [];
  for (b = 0; b < v.length - 1; ++b)
    T[v[b][0]] = L.subarray(v[b][1] * U, v[b + 1][1] * U);
  return v.length >= 1 && (T[v[v.length - 1][0]] = L.subarray(v[v.length - 1][1] * U)), { R: w, cells: T };
}
function CC(e, r) {
  var t, a = je(r.data), n = (t = a == null ? void 0 : a[7]) != null && t[0] ? yr(a[7][0].data) >>> 0 > 0 ? 1 : 0 : -1, i = ef(a[5], function(s) {
    return SC(s, n);
  });
  return {
    nrows: yr(a[4][0].data) >>> 0,
    data: i.reduce(function(s, o) {
      return s[o.R] || (s[o.R] = []), o.cells.forEach(function(u, l) {
        if (s[o.R][l])
          throw new Error("Duplicate cell r=".concat(o.R, " c=").concat(l));
        s[o.R][l] = u;
      }), s;
    }, [])
  };
}
function FC(e, r, t) {
  var a, n = je(r.data), i = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } };
  if (i.e.r = (yr(n[6][0].data) >>> 0) - 1, i.e.r < 0)
    throw new Error("Invalid row varint ".concat(n[6][0].data));
  if (i.e.c = (yr(n[7][0].data) >>> 0) - 1, i.e.c < 0)
    throw new Error("Invalid col varint ".concat(n[7][0].data));
  t["!ref"] = Ce(i);
  var s = je(n[4][0].data), o = Sh(e, e[zr(s[4][0].data)][0]), u = (a = s[17]) != null && a[0] ? Sh(e, e[zr(s[17][0].data)][0]) : [], l = je(s[3][0].data), c = 0;
  l[1].forEach(function(f) {
    var h = je(f.data), d = e[zr(h[2][0].data)][0], m = yr(d.meta[1][0].data);
    if (m != 6002)
      throw new Error("6001 unexpected reference to ".concat(m));
    var x = CC(e, d);
    x.data.forEach(function(p, w) {
      p.forEach(function(D, y) {
        var B = Te({ r: c + w, c: y }), L = TC(D, o, u);
        L && (t[B] = L);
      });
    }), c += x.nrows;
  });
}
function AC(e, r) {
  var t = je(r.data), a = { "!ref": "A1" }, n = e[zr(t[2][0].data)], i = yr(n[0].meta[1][0].data);
  if (i != 6001)
    throw new Error("6000 unexpected reference to ".concat(i));
  return FC(e, n[0], a), a;
}
function RC(e, r) {
  var t, a = je(r.data), n = {
    name: (t = a[1]) != null && t[0] ? Cl(a[1][0].data) : "",
    sheets: []
  }, i = ef(a[2], zr);
  return i.forEach(function(s) {
    e[s].forEach(function(o) {
      var u = yr(o.meta[1][0].data);
      u == 6e3 && n.sheets.push(AC(e, o));
    });
  }), n;
}
function IC(e, r) {
  var t = uf(), a = je(r.data), n = ef(a[1], zr);
  if (n.forEach(function(i) {
    e[i].forEach(function(s) {
      var o = yr(s.meta[1][0].data);
      if (o == 2) {
        var u = RC(e, s);
        u.sheets.forEach(function(l, c) {
          lf(t, l, c == 0 ? u.name : u.name + "_" + c, !0);
        });
      }
    });
  }), t.SheetNames.length == 0)
    throw new Error("Empty NUMBERS file");
  return t;
}
function wu(e) {
  var r, t, a, n, i = {}, s = [];
  if (e.FullPaths.forEach(function(u) {
    if (u.match(/\.iwpv2/))
      throw new Error("Unsupported password protection");
  }), e.FileIndex.forEach(function(u) {
    if (u.name.match(/\.iwa$/)) {
      var l;
      try {
        l = wt(u.content);
      } catch (f) {
        return console.log("?? " + u.content.length + " " + (f.message || f));
      }
      var c;
      try {
        c = bt(l);
      } catch (f) {
        return console.log("## " + (f.message || f));
      }
      c.forEach(function(f) {
        i[f.id] = f.messages, s.push(f.id);
      });
    }
  }), !s.length)
    throw new Error("File has no messages");
  var o = ((n = (a = (t = (r = i == null ? void 0 : i[1]) == null ? void 0 : r[0]) == null ? void 0 : t.meta) == null ? void 0 : a[1]) == null ? void 0 : n[0].data) && yr(i[1][0].meta[1][0].data) == 1 && i[1][0];
  if (o || s.forEach(function(u) {
    i[u].forEach(function(l) {
      var c = yr(l.meta[1][0].data) >>> 0;
      if (c == 1)
        if (!o)
          o = l;
        else
          throw new Error("Document has multiple roots");
    });
  }), !o)
    throw new Error("Cannot find Document root");
  return IC(i, o);
}
function BC(e, r, t) {
  var a, n, i, s;
  if (!((a = e[6]) != null && a[0]) || !((n = e[7]) != null && n[0]))
    throw "Mutation only works on post-BNC storages!";
  var o = ((s = (i = e[8]) == null ? void 0 : i[0]) == null ? void 0 : s.data) && yr(e[8][0].data) > 0 || !1;
  if (o)
    throw "Math only works with normal offsets";
  for (var u = 0, l = mn(e[7][0].data), c = 0, f = [], h = mn(e[4][0].data), d = 0, m = [], x = 0; x < r.length; ++x) {
    if (r[x] == null) {
      l.setUint16(x * 2, 65535, !0), h.setUint16(x * 2, 65535);
      continue;
    }
    l.setUint16(x * 2, c, !0), h.setUint16(x * 2, d, !0);
    var p, w;
    switch (typeof r[x]) {
      case "string":
        p = yu({ t: "s", v: r[x] }, t), w = bu({ t: "s", v: r[x] }, t);
        break;
      case "number":
        p = yu({ t: "n", v: r[x] }, t), w = bu({ t: "n", v: r[x] }, t);
        break;
      case "boolean":
        p = yu({ t: "b", v: r[x] }, t), w = bu({ t: "b", v: r[x] }, t);
        break;
      default:
        throw new Error("Unsupported value " + r[x]);
    }
    f.push(p), c += p.length, m.push(w), d += w.length, ++u;
  }
  for (e[2][0].data = Ke(u); x < e[7][0].data.length / 2; ++x)
    l.setUint16(x * 2, 65535, !0), h.setUint16(x * 2, 65535, !0);
  return e[6][0].data = La(f), e[3][0].data = La(m), u;
}
function PC(e, r) {
  if (!r || !r.numbers)
    throw new Error("Must pass a `numbers` option -- check the README");
  var t = e.Sheets[e.SheetNames[0]];
  e.SheetNames.length > 1 && console.error("The Numbers writer currently writes only the first table");
  var a = tt(t["!ref"]);
  a.s.r = a.s.c = 0;
  var n = !1;
  a.e.c > 9 && (n = !0, a.e.c = 9), a.e.r > 49 && (n = !0, a.e.r = 49), n && console.error("The Numbers writer is currently limited to ".concat(Ce(a)));
  var i = qo(t, { range: a, header: 1 }), s = ["~Sh33tJ5~"];
  i.forEach(function(H) {
    return H.forEach(function(P) {
      typeof P == "string" && s.push(P);
    });
  });
  var o = {}, u = [], l = we.read(r.numbers, { type: "base64" });
  l.FileIndex.map(function(H, P) {
    return [H, l.FullPaths[P]];
  }).forEach(function(H) {
    var P = H[0], N = H[1];
    if (P.type == 2 && P.name.match(/\.iwa/)) {
      var X = P.content, ae = wt(X), ie = bt(ae);
      ie.forEach(function(q) {
        u.push(q.id), o[q.id] = { deps: [], location: N, type: yr(q.messages[0].meta[1][0].data) };
      });
    }
  }), u.sort(function(H, P) {
    return H - P;
  });
  var c = u.filter(function(H) {
    return H > 1;
  }).map(function(H) {
    return [H, Ke(H)];
  });
  l.FileIndex.map(function(H, P) {
    return [H, l.FullPaths[P]];
  }).forEach(function(H) {
    var P = H[0];
    if (H[1], !!P.name.match(/\.iwa/)) {
      var N = bt(wt(P.content));
      N.forEach(function(X) {
        X.messages.forEach(function(ae) {
          c.forEach(function(ie) {
            X.messages.some(function(q) {
              return yr(q.meta[1][0].data) != 11006 && wC(q.data, ie[1]);
            }) && o[ie[0]].deps.push(X.id);
          });
        });
      });
    }
  });
  for (var f = we.find(l, o[1].location), h = bt(wt(f.content)), d, m = 0; m < h.length; ++m) {
    var x = h[m];
    x.id == 1 && (d = x);
  }
  var p = zr(je(d.messages[0].data)[1][0].data);
  for (f = we.find(l, o[p].location), h = bt(wt(f.content)), m = 0; m < h.length; ++m)
    x = h[m], x.id == p && (d = x);
  for (p = zr(je(d.messages[0].data)[2][0].data), f = we.find(l, o[p].location), h = bt(wt(f.content)), m = 0; m < h.length; ++m)
    x = h[m], x.id == p && (d = x);
  for (p = zr(je(d.messages[0].data)[2][0].data), f = we.find(l, o[p].location), h = bt(wt(f.content)), m = 0; m < h.length; ++m)
    x = h[m], x.id == p && (d = x);
  var w = je(d.messages[0].data);
  {
    w[6][0].data = Ke(a.e.r + 1), w[7][0].data = Ke(a.e.c + 1);
    var D = zr(w[46][0].data), y = we.find(l, o[D].location), B = bt(wt(y.content));
    {
      for (var L = 0; L < B.length && B[L].id != D; ++L)
        ;
      if (B[L].id != D)
        throw "Bad ColumnRowUIDMapArchive";
      var U = je(B[L].messages[0].data);
      U[1] = [], U[2] = [], U[3] = [];
      for (var k = 0; k <= a.e.c; ++k) {
        var v = [];
        v[1] = v[2] = [{ type: 0, data: Ke(k + 420690) }], U[1].push({ type: 2, data: Ur(v) }), U[2].push({ type: 0, data: Ke(k) }), U[3].push({ type: 0, data: Ke(k) });
      }
      U[4] = [], U[5] = [], U[6] = [];
      for (var b = 0; b <= a.e.r; ++b)
        v = [], v[1] = v[2] = [{ type: 0, data: Ke(b + 726270) }], U[4].push({ type: 2, data: Ur(v) }), U[5].push({ type: 0, data: Ke(b) }), U[6].push({ type: 0, data: Ke(b) });
      B[L].messages[0].data = Ur(U);
    }
    y.content = An(Fn(B)), y.size = y.content.length, delete w[46];
    var A = je(w[4][0].data);
    {
      A[7][0].data = Ke(a.e.r + 1);
      var T = je(A[1][0].data), C = zr(T[2][0].data);
      y = we.find(l, o[C].location), B = bt(wt(y.content));
      {
        if (B[0].id != C)
          throw "Bad HeaderStorageBucket";
        var I = je(B[0].messages[0].data);
        for (b = 0; b < i.length; ++b) {
          var Y = je(I[2][0].data);
          Y[1][0].data = Ke(b), Y[4][0].data = Ke(i[b].length), I[2][b] = { type: I[2][0].type, data: Ur(Y) };
        }
        B[0].messages[0].data = Ur(I);
      }
      y.content = An(Fn(B)), y.size = y.content.length;
      var j = zr(A[2][0].data);
      y = we.find(l, o[j].location), B = bt(wt(y.content));
      {
        if (B[0].id != j)
          throw "Bad HeaderStorageBucket";
        for (I = je(B[0].messages[0].data), k = 0; k <= a.e.c; ++k)
          Y = je(I[2][0].data), Y[1][0].data = Ke(k), Y[4][0].data = Ke(a.e.r + 1), I[2][k] = { type: I[2][0].type, data: Ur(Y) };
        B[0].messages[0].data = Ur(I);
      }
      y.content = An(Fn(B)), y.size = y.content.length;
      var J = zr(A[4][0].data);
      (function() {
        for (var H = we.find(l, o[J].location), P = bt(wt(H.content)), N, X = 0; X < P.length; ++X) {
          var ae = P[X];
          ae.id == J && (N = ae);
        }
        var ie = je(N.messages[0].data);
        {
          ie[3] = [];
          var q = [];
          s.forEach(function(M, _e) {
            q[1] = [{ type: 0, data: Ke(_e) }], q[2] = [{ type: 0, data: Ke(1) }], q[3] = [{ type: 2, data: bC(M) }], ie[3].push({ type: 2, data: Ur(q) });
          });
        }
        N.messages[0].data = Ur(ie);
        var re = Fn(P), ve = An(re);
        H.content = ve, H.size = H.content.length;
      })();
      var W = je(A[3][0].data);
      {
        var ce = W[1][0];
        delete W[2];
        var V = je(ce.data);
        {
          var ee = zr(V[2][0].data);
          (function() {
            for (var H = we.find(l, o[ee].location), P = bt(wt(H.content)), N, X = 0; X < P.length; ++X) {
              var ae = P[X];
              ae.id == ee && (N = ae);
            }
            var ie = je(N.messages[0].data);
            {
              delete ie[6], delete W[7];
              var q = new Uint8Array(ie[5][0].data);
              ie[5] = [];
              for (var re = 0, ve = 0; ve <= a.e.r; ++ve) {
                var M = je(q);
                re += BC(M, i[ve], s), M[1][0].data = Ke(ve), ie[5].push({ data: Ur(M), type: 2 });
              }
              ie[1] = [{ type: 0, data: Ke(a.e.c + 1) }], ie[2] = [{ type: 0, data: Ke(a.e.r + 1) }], ie[3] = [{ type: 0, data: Ke(re) }], ie[4] = [{ type: 0, data: Ke(a.e.r + 1) }];
            }
            N.messages[0].data = Ur(ie);
            var _e = Fn(P), De = An(_e);
            H.content = De, H.size = H.content.length;
          })();
        }
        ce.data = Ur(V);
      }
      A[3][0].data = Ur(W);
    }
    w[4][0].data = Ur(A);
  }
  d.messages[0].data = Ur(w);
  var de = Fn(h), F = An(de);
  return f.content = F, f.size = f.content.length, l;
}
function F2(e) {
  return function(t) {
    for (var a = 0; a != e.length; ++a) {
      var n = e[a];
      t[n[0]] === void 0 && (t[n[0]] = n[1]), n[2] === "n" && (t[n[0]] = Number(t[n[0]]));
    }
  };
}
function rf(e) {
  F2([
    ["cellNF", !1],
    /* emit cell number format string as .z */
    ["cellHTML", !0],
    /* emit html string as .h */
    ["cellFormula", !0],
    /* emit formulae as .f */
    ["cellStyles", !1],
    /* emits style/theme as .s */
    ["cellText", !0],
    /* emit formatted text as .w */
    ["cellDates", !1],
    /* emit date cells with type `d` */
    ["sheetStubs", !1],
    /* emit empty cells */
    ["sheetRows", 0, "n"],
    /* read n rows (0 = read all rows) */
    ["bookDeps", !1],
    /* parse calculation chains */
    ["bookSheets", !1],
    /* only try to get sheet names (no Sheets) */
    ["bookProps", !1],
    /* only try to get properties (no Sheets) */
    ["bookFiles", !1],
    /* include raw file structure (keys, files, cfb) */
    ["bookVBA", !1],
    /* include vba raw data (vbaraw) */
    ["password", ""],
    /* password */
    ["WTF", !1]
    /* WTF mode (throws errors) */
  ])(e);
}
function tf(e) {
  F2([
    ["cellDates", !1],
    /* write date cells with type `d` */
    ["bookSST", !1],
    /* Generate Shared String Table */
    ["bookType", "xlsx"],
    /* Type of workbook (xlsx/m/b) */
    ["compression", !1],
    /* Use file compression */
    ["WTF", !1]
    /* WTF mode (throws errors) */
  ])(e);
}
function MC(e) {
  return Be.WS.indexOf(e) > -1 ? "sheet" : e == Be.CS ? "chart" : e == Be.DS ? "dialog" : e == Be.MS ? "macro" : e && e.length ? e : "sheet";
}
function OC(e, r) {
  if (!e)
    return 0;
  try {
    e = r.map(function(a) {
      return a.id || (a.id = a.strRelID), [a.name, e["!id"][a.id].Target, MC(e["!id"][a.id].Type)];
    });
  } catch {
    return null;
  }
  return !e || e.length === 0 ? null : e;
}
function LC(e, r, t, a, n, i, s, o, u, l, c, f) {
  try {
    i[a] = Wi(ht(e, t, !0), r);
    var h = kr(e, r), d;
    switch (o) {
      case "sheet":
        d = cS(h, r, n, u, i[a], l, c, f);
        break;
      case "chart":
        if (d = fS(h, r, n, u, i[a], l, c, f), !d || !d["!drawel"])
          break;
        var m = Mi(d["!drawel"].Target, r), x = ss(m), p = qE(ht(e, m, !0), Wi(ht(e, x, !0), m)), w = Mi(p, m), D = ss(w);
        d = NT(ht(e, w, !0), w, u, Wi(ht(e, D, !0), w), l, d);
        break;
      case "macro":
        d = dS(h, r, n, u, i[a], l, c, f);
        break;
      case "dialog":
        d = hS(h, r, n, u, i[a], l, c, f);
        break;
      default:
        throw new Error("Unrecognized sheet type " + o);
    }
    s[a] = d;
    var y = [];
    i && i[a] && br(i[a]).forEach(function(B) {
      var L = "";
      if (i[a][B].Type == Be.CMNT) {
        L = Mi(i[a][B].Target, r);
        var U = vS(kr(e, L, !0), L, u);
        if (!U || !U.length)
          return;
        hh(d, U, !1);
      }
      i[a][B].Type == Be.TCMNT && (L = Mi(i[a][B].Target, r), y = y.concat(e7(kr(e, L, !0), u)));
    }), y && y.length && hh(d, y, !0, u.people || []);
  } catch (B) {
    if (u.WTF)
      throw B;
  }
}
function gt(e) {
  return e.charAt(0) == "/" ? e.slice(1) : e;
}
function A2(e, r) {
  if (hi(), r = r || {}, rf(r), _t(e, "META-INF/manifest.xml") || _t(e, "objectdata.xml"))
    return Dh(e, r);
  if (_t(e, "Index/Document.iwa")) {
    if (typeof Uint8Array > "u")
      throw new Error("NUMBERS file parsing requires Uint8Array support");
    if (typeof wu < "u") {
      if (e.FileIndex)
        return wu(e);
      var t = we.utils.cfb_new();
      return Bd(e).forEach(function(Y) {
        Fe(t, Y, r_(e, Y));
      }), wu(t);
    }
    throw new Error("Unsupported NUMBERS file");
  }
  if (!_t(e, "[Content_Types].xml"))
    throw _t(e, "index.xml.gz") ? new Error("Unsupported NUMBERS 08 file") : _t(e, "index.xml") ? new Error("Unsupported NUMBERS 09 file") : new Error("Unsupported ZIP file");
  var a = Bd(e), n = Y_(ht(e, "[Content_Types].xml")), i = !1, s, o;
  if (n.workbooks.length === 0 && (o = "xl/workbook.xml", kr(e, o, !0) && n.workbooks.push(o)), n.workbooks.length === 0) {
    if (o = "xl/workbook.bin", !kr(e, o, !0))
      throw new Error("Could not find workbook");
    n.workbooks.push(o), i = !0;
  }
  n.workbooks[0].slice(-3) == "bin" && (i = !0);
  var u = {}, l = {};
  if (!r.bookSheets && !r.bookProps) {
    if (Hi = [], n.sst)
      try {
        Hi = pS(kr(e, gt(n.sst)), n.sst, r);
      } catch (Y) {
        if (r.WTF)
          throw Y;
      }
    r.cellStyles && n.themes.length && (u = mS(ht(e, n.themes[0].replace(/^\//, ""), !0) || "", n.themes[0], r)), n.style && (l = xS(kr(e, gt(n.style)), n.style, u, r));
  }
  n.links.map(function(Y) {
    try {
      var j = Wi(ht(e, ss(gt(Y))), Y);
      return yS(kr(e, gt(Y)), j, Y, r);
    } catch {
    }
  });
  var c = lS(kr(e, gt(n.workbooks[0])), n.workbooks[0], r), f = {}, h = "";
  n.coreprops.length && (h = kr(e, gt(n.coreprops[0]), !0), h && (f = xv(h)), n.extprops.length !== 0 && (h = kr(e, gt(n.extprops[0]), !0), h && r6(h, f, r)));
  var d = {};
  (!r.bookSheets || r.bookProps) && n.custprops.length !== 0 && (h = ht(e, gt(n.custprops[0]), !0), h && (d = a6(h, r)));
  var m = {};
  if ((r.bookSheets || r.bookProps) && (c.Sheets ? s = c.Sheets.map(function(j) {
    return j.name;
  }) : f.Worksheets && f.SheetNames.length > 0 && (s = f.SheetNames), r.bookProps && (m.Props = f, m.Custprops = d), r.bookSheets && typeof s < "u" && (m.SheetNames = s), r.bookSheets ? m.SheetNames : r.bookProps))
    return m;
  s = {};
  var x = {};
  r.bookDeps && n.calcchain && (x = gS(kr(e, gt(n.calcchain)), n.calcchain));
  var p = 0, w = {}, D, y;
  {
    var B = c.Sheets;
    f.Worksheets = B.length, f.SheetNames = [];
    for (var L = 0; L != B.length; ++L)
      f.SheetNames[L] = B[L].name;
  }
  var U = i ? "bin" : "xml", k = n.workbooks[0].lastIndexOf("/"), v = (n.workbooks[0].slice(0, k + 1) + "_rels/" + n.workbooks[0].slice(k + 1) + ".rels").replace(/^\//, "");
  _t(e, v) || (v = "xl/_rels/workbook." + U + ".rels");
  var b = Wi(ht(e, v, !0), v.replace(/_rels.*/, "s5s"));
  (n.metadata || []).length >= 1 && (r.xlmeta = bS(kr(e, gt(n.metadata[0])), n.metadata[0], r)), (n.people || []).length >= 1 && (r.people = t7(kr(e, gt(n.people[0])), r)), b && (b = OC(b, c.Sheets));
  var A = kr(e, "xl/worksheets/sheet.xml", !0) ? 1 : 0;
  e:
    for (p = 0; p != f.Worksheets; ++p) {
      var T = "sheet";
      if (b && b[p] ? (D = "xl/" + b[p][1].replace(/[\/]?xl\//, ""), _t(e, D) || (D = b[p][1]), _t(e, D) || (D = v.replace(/_rels\/.*$/, "") + b[p][1]), T = b[p][2]) : (D = "xl/worksheets/sheet" + (p + 1 - A) + "." + U, D = D.replace(/sheet0\./, "sheet.")), y = D.replace(/^(.*)(\/)([^\/]*)$/, "$1/_rels/$3.rels"), r && r.sheets != null)
        switch (typeof r.sheets) {
          case "number":
            if (p != r.sheets)
              continue e;
            break;
          case "string":
            if (f.SheetNames[p].toLowerCase() != r.sheets.toLowerCase())
              continue e;
            break;
          default:
            if (Array.isArray && Array.isArray(r.sheets)) {
              for (var C = !1, I = 0; I != r.sheets.length; ++I)
                typeof r.sheets[I] == "number" && r.sheets[I] == p && (C = 1), typeof r.sheets[I] == "string" && r.sheets[I].toLowerCase() == f.SheetNames[p].toLowerCase() && (C = 1);
              if (!C)
                continue e;
            }
        }
      LC(e, D, y, f.SheetNames[p], p, w, s, T, r, c, u, l);
    }
  return m = {
    Directory: n,
    Workbook: c,
    Props: f,
    Custprops: d,
    Deps: x,
    Sheets: s,
    SheetNames: f.SheetNames,
    Strings: Hi,
    Styles: l,
    Themes: u,
    SSF: tr(Ee)
  }, r && r.bookFiles && (e.files ? (m.keys = a, m.files = e.files) : (m.keys = [], m.files = {}, e.FullPaths.forEach(function(Y, j) {
    Y = Y.replace(/^Root Entry[\/]/, ""), m.keys.push(Y), m.files[Y] = e.FileIndex[j];
  }))), r && r.bookVBA && (n.vba.length > 0 ? m.vbaraw = kr(e, gt(n.vba[0]), !0) : n.defaults && n.defaults.bin === c7 && (m.vbaraw = kr(e, "xl/vbaProject.bin", !0))), m;
}
function NC(e, r) {
  var t = r || {}, a = "Workbook", n = we.find(e, a);
  try {
    if (a = "/!DataSpaces/Version", n = we.find(e, a), !n || !n.content)
      throw new Error("ECMA-376 Encrypted file missing " + a);
    if (wD(n.content), a = "/!DataSpaces/DataSpaceMap", n = we.find(e, a), !n || !n.content)
      throw new Error("ECMA-376 Encrypted file missing " + a);
    var i = $D(n.content);
    if (i.length !== 1 || i[0].comps.length !== 1 || i[0].comps[0].t !== 0 || i[0].name !== "StrongEncryptionDataSpace" || i[0].comps[0].v !== "EncryptedPackage")
      throw new Error("ECMA-376 Encrypted file bad " + a);
    if (a = "/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace", n = we.find(e, a), !n || !n.content)
      throw new Error("ECMA-376 Encrypted file missing " + a);
    var s = DD(n.content);
    if (s.length != 1 || s[0] != "StrongEncryptionTransform")
      throw new Error("ECMA-376 Encrypted file bad " + a);
    if (a = "/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary", n = we.find(e, a), !n || !n.content)
      throw new Error("ECMA-376 Encrypted file missing " + a);
    kD(n.content);
  } catch {
  }
  if (a = "/EncryptionInfo", n = we.find(e, a), !n || !n.content)
    throw new Error("ECMA-376 Encrypted file missing " + a);
  var o = TD(n.content);
  if (a = "/EncryptedPackage", n = we.find(e, a), !n || !n.content)
    throw new Error("ECMA-376 Encrypted file missing " + a);
  if (o[0] == 4 && typeof decrypt_agile < "u")
    return decrypt_agile(o[1], n.content, t.password || "", t);
  if (o[0] == 2 && typeof decrypt_std76 < "u")
    return decrypt_std76(o[1], n.content, t.password || "", t);
  throw new Error("File is password-protected");
}
function UC(e, r) {
  return r.bookType == "ods" ? C2(e, r) : r.bookType == "numbers" ? PC(e, r) : r.bookType == "xlsb" ? VC(e, r) : R2(e, r);
}
function VC(e, r) {
  On = 1024, e && !e.SSF && (e.SSF = tr(Ee)), e && e.SSF && (hi(), $s(e.SSF), r.revssf = p0(e.SSF), r.revssf[e.SSF[65535]] = 0, r.ssf = e.SSF), r.rels = {}, r.wbrels = {}, r.Strings = /*::((*/
  [], r.Strings.Count = 0, r.Strings.Unique = 0, ji ? r.revStrings = /* @__PURE__ */ new Map() : (r.revStrings = {}, r.revStrings.foo = [], delete r.revStrings.foo);
  var t = r.bookType == "xlsb" ? "bin" : "xml", a = Qv.indexOf(r.bookType) > -1, n = Uc();
  tf(r = r || {});
  var i = _c(), s = "", o = 0;
  if (r.cellXfs = [], Ha(r.cellXfs, {}, { revssf: { General: 0 } }), e.Props || (e.Props = {}), s = "docProps/core.xml", Fe(i, s, mv(e.Props, r)), n.coreprops.push(s), Ye(r.rels, 2, s, Be.CORE_PROPS), s = "docProps/app.xml", !(e.Props && e.Props.SheetNames))
    if (!e.Workbook || !e.Workbook.Sheets)
      e.Props.SheetNames = e.SheetNames;
    else {
      for (var u = [], l = 0; l < e.SheetNames.length; ++l)
        (e.Workbook.Sheets[l] || {}).Hidden != 2 && u.push(e.SheetNames[l]);
      e.Props.SheetNames = u;
    }
  for (e.Props.Worksheets = e.Props.SheetNames.length, Fe(i, s, gv(e.Props)), n.extprops.push(s), Ye(r.rels, 3, s, Be.EXT_PROPS), e.Custprops !== e.Props && br(e.Custprops || {}).length > 0 && (s = "docProps/custom.xml", Fe(i, s, yv(e.Custprops)), n.custprops.push(s), Ye(r.rels, 4, s, Be.CUST_PROPS)), o = 1; o <= e.SheetNames.length; ++o) {
    var c = { "!id": {} }, f = e.Sheets[e.SheetNames[o - 1]], h = (f || {})["!type"] || "sheet";
    switch (h) {
      case "chart":
      default:
        s = "xl/worksheets/sheet" + o + "." + t, Fe(i, s, _S(o - 1, s, r, e, c)), n.sheets.push(s), Ye(r.wbrels, -1, "worksheets/sheet" + o + "." + t, Be.WS[0]);
    }
    if (f) {
      var d = f["!comments"], m = !1, x = "";
      d && d.length > 0 && (x = "xl/comments" + o + "." + t, Fe(i, x, ES(d, x)), n.comments.push(x), Ye(c, -1, "../comments" + o + "." + t, Be.CMNT), m = !0), f["!legacy"] && m && Fe(i, "xl/drawings/vmlDrawing" + o + ".vml", Jv(o, f["!comments"])), delete f["!comments"], delete f["!legacy"];
    }
    c["!id"].rId1 && Fe(i, ss(s), Gn(c));
  }
  return r.Strings != null && r.Strings.length > 0 && (s = "xl/sharedStrings." + t, Fe(i, s, DS(r.Strings, s, r)), n.strs.push(s), Ye(r.wbrels, -1, "sharedStrings." + t, Be.SST)), s = "xl/workbook." + t, Fe(i, s, wS(e, s)), n.workbooks.push(s), Ye(r.rels, 1, s, Be.WB), s = "xl/theme/theme1.xml", Fe(i, s, Gc(e.Themes, r)), n.themes.push(s), Ye(r.wbrels, -1, "theme/theme1.xml", Be.THEME), s = "xl/styles." + t, Fe(i, s, $S(e, s, r)), n.styles.push(s), Ye(r.wbrels, -1, "styles." + t, Be.STY), e.vbaraw && a && (s = "xl/vbaProject.bin", Fe(i, s, e.vbaraw), n.vba.push(s), Ye(r.wbrels, -1, "vbaProject.bin", Be.VBA)), s = "xl/metadata." + t, Fe(i, s, kS(s)), n.metadata.push(s), Ye(r.wbrels, -1, "metadata." + t, Be.XLMETA), Fe(i, "[Content_Types].xml", dv(n, r)), Fe(i, "_rels/.rels", Gn(r.rels)), Fe(i, "xl/_rels/workbook." + t + ".rels", Gn(r.wbrels)), delete r.revssf, delete r.ssf, i;
}
function R2(e, r) {
  On = 1024, e && !e.SSF && (e.SSF = tr(Ee)), e && e.SSF && (hi(), $s(e.SSF), r.revssf = p0(e.SSF), r.revssf[e.SSF[65535]] = 0, r.ssf = e.SSF), r.rels = {}, r.wbrels = {}, r.Strings = /*::((*/
  [], r.Strings.Count = 0, r.Strings.Unique = 0, ji ? r.revStrings = /* @__PURE__ */ new Map() : (r.revStrings = {}, r.revStrings.foo = [], delete r.revStrings.foo);
  var t = "xml", a = Qv.indexOf(r.bookType) > -1, n = Uc();
  tf(r = r || {});
  var i = _c(), s = "", o = 0;
  if (r.cellXfs = [], Ha(r.cellXfs, {}, { revssf: { General: 0 } }), e.Props || (e.Props = {}), s = "docProps/core.xml", Fe(i, s, mv(e.Props, r)), n.coreprops.push(s), Ye(r.rels, 2, s, Be.CORE_PROPS), s = "docProps/app.xml", !(e.Props && e.Props.SheetNames))
    if (!e.Workbook || !e.Workbook.Sheets)
      e.Props.SheetNames = e.SheetNames;
    else {
      for (var u = [], l = 0; l < e.SheetNames.length; ++l)
        (e.Workbook.Sheets[l] || {}).Hidden != 2 && u.push(e.SheetNames[l]);
      e.Props.SheetNames = u;
    }
  e.Props.Worksheets = e.Props.SheetNames.length, Fe(i, s, gv(e.Props)), n.extprops.push(s), Ye(r.rels, 3, s, Be.EXT_PROPS), e.Custprops !== e.Props && br(e.Custprops || {}).length > 0 && (s = "docProps/custom.xml", Fe(i, s, yv(e.Custprops)), n.custprops.push(s), Ye(r.rels, 4, s, Be.CUST_PROPS));
  var c = ["SheetJ5"];
  for (r.tcid = 0, o = 1; o <= e.SheetNames.length; ++o) {
    var f = { "!id": {} }, h = e.Sheets[e.SheetNames[o - 1]], d = (h || {})["!type"] || "sheet";
    switch (d) {
      case "chart":
      default:
        s = "xl/worksheets/sheet" + o + "." + t, Fe(i, s, c2(o - 1, r, e, f)), n.sheets.push(s), Ye(r.wbrels, -1, "worksheets/sheet" + o + "." + t, Be.WS[0]);
    }
    if (h) {
      var m = h["!comments"], x = !1, p = "";
      if (m && m.length > 0) {
        var w = !1;
        m.forEach(function(D) {
          D[1].forEach(function(y) {
            y.T == !0 && (w = !0);
          });
        }), w && (p = "xl/threadedComments/threadedComment" + o + "." + t, Fe(i, p, r7(m, c, r)), n.threadedcomments.push(p), Ye(f, -1, "../threadedComments/threadedComment" + o + "." + t, Be.TCMNT)), p = "xl/comments" + o + "." + t, Fe(i, p, qv(m)), n.comments.push(p), Ye(f, -1, "../comments" + o + "." + t, Be.CMNT), x = !0;
      }
      h["!legacy"] && x && Fe(i, "xl/drawings/vmlDrawing" + o + ".vml", Jv(o, h["!comments"])), delete h["!comments"], delete h["!legacy"];
    }
    f["!id"].rId1 && Fe(i, ss(s), Gn(f));
  }
  return r.Strings != null && r.Strings.length > 0 && (s = "xl/sharedStrings." + t, Fe(i, s, Nv(r.Strings, r)), n.strs.push(s), Ye(r.wbrels, -1, "sharedStrings." + t, Be.SST)), s = "xl/workbook." + t, Fe(i, s, p2(e)), n.workbooks.push(s), Ye(r.rels, 1, s, Be.WB), s = "xl/theme/theme1.xml", Fe(i, s, Gc(e.Themes, r)), n.themes.push(s), Ye(r.wbrels, -1, "theme/theme1.xml", Be.THEME), s = "xl/styles." + t, Fe(i, s, Kv(e, r)), n.styles.push(s), Ye(r.wbrels, -1, "styles." + t, Be.STY), e.vbaraw && a && (s = "xl/vbaProject.bin", Fe(i, s, e.vbaraw), n.vba.push(s), Ye(r.wbrels, -1, "vbaProject.bin", Be.VBA)), s = "xl/metadata." + t, Fe(i, s, Zv()), n.metadata.push(s), Ye(r.wbrels, -1, "metadata." + t, Be.XLMETA), c.length > 1 && (s = "xl/persons/person.xml", Fe(i, s, a7(c)), n.people.push(s), Ye(r.wbrels, -1, "persons/person.xml", Be.PEOPLE)), Fe(i, "[Content_Types].xml", dv(n, r)), Fe(i, "_rels/.rels", Gn(r.rels)), Fe(i, "xl/_rels/workbook." + t + ".rels", Gn(r.wbrels)), delete r.revssf, delete r.ssf, i;
}
function af(e, r) {
  var t = "";
  switch ((r || {}).type || "base64") {
    case "buffer":
      return [e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]];
    case "base64":
      t = mt(e.slice(0, 12));
      break;
    case "binary":
      t = e;
      break;
    case "array":
      return [e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7]];
    default:
      throw new Error("Unrecognized type " + (r && r.type || "undefined"));
  }
  return [t.charCodeAt(0), t.charCodeAt(1), t.charCodeAt(2), t.charCodeAt(3), t.charCodeAt(4), t.charCodeAt(5), t.charCodeAt(6), t.charCodeAt(7)];
}
function WC(e, r) {
  return we.find(e, "EncryptedPackage") ? NC(e, r) : Qc(e, r);
}
function HC(e, r) {
  var t, a = e, n = r || {};
  return n.type || (n.type = Ie && Buffer.isBuffer(e) ? "buffer" : "base64"), t = zp(a, n), A2(t, n);
}
function I2(e, r) {
  var t = 0;
  e:
    for (; t < e.length; )
      switch (e.charCodeAt(t)) {
        case 10:
        case 13:
        case 32:
          ++t;
          break;
        case 60:
          return Tl(e.slice(t), r);
        default:
          break e;
      }
  return ui.to_workbook(e, r);
}
function jC(e, r) {
  var t = "", a = af(e, r);
  switch (r.type) {
    case "base64":
      t = mt(e);
      break;
    case "binary":
      t = e;
      break;
    case "buffer":
      t = e.toString("binary");
      break;
    case "array":
      t = fn(e);
      break;
    default:
      throw new Error("Unrecognized type " + r.type);
  }
  return a[0] == 239 && a[1] == 187 && a[2] == 191 && (t = Qe(t)), r.type = "binary", I2(t, r);
}
function zC(e, r) {
  var t = e;
  return r.type == "base64" && (t = mt(t)), t = Ue.utils.decode(1200, t.slice(2), "str"), r.type = "binary", I2(t, r);
}
function GC(e) {
  return e.match(/[^\x00-\x7F]/) ? zt(e) : e;
}
function _u(e, r, t, a) {
  return a ? (t.type = "string", ui.to_workbook(e, t)) : ui.to_workbook(r, t);
}
function Jo(e, r) {
  x0();
  var t = r || {};
  if (typeof ArrayBuffer < "u" && e instanceof ArrayBuffer)
    return Jo(new Uint8Array(e), (t = tr(t), t.type = "array", t));
  typeof Uint8Array < "u" && e instanceof Uint8Array && !t.type && (t.type = typeof Deno < "u" ? "buffer" : "array");
  var a = e, n = [0, 0, 0, 0], i = !1;
  if (t.cellStyles && (t.cellNF = !0, t.sheetStubs = !0), Yn = {}, t.dateNF && (Yn.dateNF = t.dateNF), t.type || (t.type = Ie && Buffer.isBuffer(e) ? "buffer" : "base64"), t.type == "file" && (t.type = Ie ? "buffer" : "binary", a = K5(e), typeof Uint8Array < "u" && !Ie && (t.type = "array")), t.type == "string" && (i = !0, t.type = "binary", t.codepage = 65001, a = GC(e)), t.type == "array" && typeof Uint8Array < "u" && e instanceof Uint8Array && typeof ArrayBuffer < "u") {
    var s = new ArrayBuffer(3), o = new Uint8Array(s);
    if (o.foo = "bar", !o.foo)
      return t = tr(t), t.type = "array", Jo(gc(a), t);
  }
  switch ((n = af(a, t))[0]) {
    case 208:
      if (n[1] === 207 && n[2] === 17 && n[3] === 224 && n[4] === 161 && n[5] === 177 && n[6] === 26 && n[7] === 225)
        return WC(we.read(a, t), t);
      break;
    case 9:
      if (n[1] <= 8)
        return Qc(a, t);
      break;
    case 60:
      return Tl(a, t);
    case 73:
      if (n[1] === 73 && n[2] === 42 && n[3] === 0)
        throw new Error("TIFF Image File is not a spreadsheet");
      if (n[1] === 68)
        return nD(a, t);
      break;
    case 84:
      if (n[1] === 65 && n[2] === 66 && n[3] === 76)
        return Ov.to_workbook(a, t);
      break;
    case 80:
      return n[1] === 75 && n[2] < 9 && n[3] < 9 ? HC(a, t) : _u(e, a, t, i);
    case 239:
      return n[3] === 60 ? Tl(a, t) : _u(e, a, t, i);
    case 255:
      if (n[1] === 254)
        return zC(a, t);
      if (n[1] === 0 && n[2] === 2 && n[3] === 0)
        return rn.to_workbook(a, t);
      break;
    case 0:
      if (n[1] === 0 && (n[2] >= 2 && n[3] === 0 || n[2] === 0 && (n[3] === 8 || n[3] === 9)))
        return rn.to_workbook(a, t);
      break;
    case 3:
    case 131:
    case 139:
    case 140:
      return kl.to_workbook(a, t);
    case 123:
      if (n[1] === 92 && n[2] === 114 && n[3] === 116)
        return jv.to_workbook(a, t);
      break;
    case 10:
    case 13:
    case 32:
      return jC(a, t);
    case 137:
      if (n[1] === 80 && n[2] === 78 && n[3] === 71)
        throw new Error("PNG Image File is not a spreadsheet");
      break;
  }
  return aD.indexOf(n[0]) > -1 && n[2] <= 12 && n[3] <= 31 ? kl.to_workbook(a, t) : _u(e, a, t, i);
}
function Ch(e, r) {
  var t = r || {};
  return t.type = "file", Jo(e, t);
}
function B2(e, r) {
  switch (r.type) {
    case "base64":
    case "binary":
      break;
    case "buffer":
    case "array":
      r.type = "";
      break;
    case "file":
      return Ds(r.file, we.write(e, { type: Ie ? "buffer" : "" }));
    case "string":
      throw new Error("'string' output type invalid for '" + r.bookType + "' files");
    default:
      throw new Error("Unrecognized type " + r.type);
  }
  return we.write(e, r);
}
function KC(e, r) {
  var t = tr(r || {}), a = UC(e, t);
  return P2(a, t);
}
function YC(e, r) {
  var t = tr(r || {}), a = R2(e, t);
  return P2(a, t);
}
function P2(e, r) {
  var t = {}, a = Ie ? "nodebuffer" : typeof Uint8Array < "u" ? "array" : "string";
  if (r.compression && (t.compression = "DEFLATE"), r.password)
    t.type = a;
  else
    switch (r.type) {
      case "base64":
        t.type = "base64";
        break;
      case "binary":
        t.type = "string";
        break;
      case "string":
        throw new Error("'string' output type invalid for '" + r.bookType + "' files");
      case "buffer":
      case "file":
        t.type = a;
        break;
      default:
        throw new Error("Unrecognized type " + r.type);
    }
  var n = e.FullPaths ? we.write(e, { fileType: "zip", type: (
    /*::(*/
    { nodebuffer: "buffer", string: "binary" }[t.type] || t.type
  ), compression: !!r.compression }) : e.generate(t);
  if (typeof Deno < "u" && typeof n == "string") {
    if (r.type == "binary" || r.type == "base64")
      return n;
    n = new Uint8Array(_s(n));
  }
  return r.password && typeof encrypt_agile < "u" ? B2(encrypt_agile(n, r.password), r) : r.type === "file" ? Ds(r.file, n) : r.type == "string" ? Qe(
    /*::(*/
    n
    /*:: :any)*/
  ) : n;
}
function XC(e, r) {
  var t = r || {}, a = qS(e, t);
  return B2(a, t);
}
function Wt(e, r, t) {
  t || (t = "");
  var a = t + e;
  switch (r.type) {
    case "base64":
      return rs(zt(a));
    case "binary":
      return zt(a);
    case "string":
      return e;
    case "file":
      return Ds(r.file, a, "utf8");
    case "buffer":
      return Ie ? xa(a, "utf8") : typeof TextEncoder < "u" ? new TextEncoder().encode(a) : Wt(a, { type: "binary" }).split("").map(function(n) {
        return n.charCodeAt(0);
      });
  }
  throw new Error("Unrecognized type " + r.type);
}
function ZC(e, r) {
  switch (r.type) {
    case "base64":
      return rs(e);
    case "binary":
      return e;
    case "string":
      return e;
    case "file":
      return Ds(r.file, e, "binary");
    case "buffer":
      return Ie ? xa(e, "binary") : e.split("").map(function(t) {
        return t.charCodeAt(0);
      });
  }
  throw new Error("Unrecognized type " + r.type);
}
function uo(e, r) {
  switch (r.type) {
    case "string":
    case "base64":
    case "binary":
      for (var t = "", a = 0; a < e.length; ++a)
        t += String.fromCharCode(e[a]);
      return r.type == "base64" ? rs(t) : r.type == "string" ? Qe(t) : t;
    case "file":
      return Ds(r.file, e);
    case "buffer":
      return e;
    default:
      throw new Error("Unrecognized type " + r.type);
  }
}
function nf(e, r) {
  x0(), m2(e);
  var t = tr(r || {});
  if (t.cellStyles && (t.cellNF = !0, t.sheetStubs = !0), t.type == "array") {
    t.type = "binary";
    var a = nf(e, t);
    return t.type = "array", _s(a);
  }
  return YC(e, t);
}
function As(e, r) {
  x0(), m2(e);
  var t = tr(r || {});
  if (t.cellStyles && (t.cellNF = !0, t.sheetStubs = !0), t.type == "array") {
    t.type = "binary";
    var a = As(e, t);
    return t.type = "array", _s(a);
  }
  var n = 0;
  if (t.sheet && (typeof t.sheet == "number" ? n = t.sheet : n = e.SheetNames.indexOf(t.sheet), !e.SheetNames[n]))
    throw new Error("Sheet not found: " + t.sheet + " : " + typeof t.sheet);
  switch (t.bookType || "xlsb") {
    case "xml":
    case "xlml":
      return Wt(zS(e, t), t);
    case "slk":
    case "sylk":
      return Wt(Mv.from_sheet(e.Sheets[e.SheetNames[n]], t), t);
    case "htm":
    case "html":
      return Wt(E2(e.Sheets[e.SheetNames[n]], t), t);
    case "txt":
      return ZC(L2(e.Sheets[e.SheetNames[n]], t), t);
    case "csv":
      return Wt(of(e.Sheets[e.SheetNames[n]], t), t, "\uFEFF");
    case "dif":
      return Wt(Ov.from_sheet(e.Sheets[e.SheetNames[n]], t), t);
    case "dbf":
      return uo(kl.from_sheet(e.Sheets[e.SheetNames[n]], t), t);
    case "prn":
      return Wt(ui.from_sheet(e.Sheets[e.SheetNames[n]], t), t);
    case "rtf":
      return Wt(jv.from_sheet(e.Sheets[e.SheetNames[n]], t), t);
    case "eth":
      return Wt(Lv.from_sheet(e.Sheets[e.SheetNames[n]], t), t);
    case "fods":
      return Wt(C2(e, t), t);
    case "wk1":
      return uo(rn.sheet_to_wk1(e.Sheets[e.SheetNames[n]], t), t);
    case "wk3":
      return uo(rn.book_to_wk3(e, t), t);
    case "biff2":
      t.biff || (t.biff = 2);
    case "biff3":
      t.biff || (t.biff = 3);
    case "biff4":
      return t.biff || (t.biff = 4), uo(b2(e, t), t);
    case "biff5":
      t.biff || (t.biff = 5);
    case "biff8":
    case "xla":
    case "xls":
      return t.biff || (t.biff = 8), XC(e, t);
    case "xlsx":
    case "xlsm":
    case "xlam":
    case "xlsb":
    case "numbers":
    case "ods":
      return KC(e, t);
    default:
      throw new Error("Unrecognized bookType |" + t.bookType + "|");
  }
}
function sf(e) {
  if (!e.bookType) {
    var r = {
      xls: "biff8",
      htm: "html",
      slk: "sylk",
      socialcalc: "eth",
      Sh33tJS: "WTF"
    }, t = e.file.slice(e.file.lastIndexOf(".")).toLowerCase();
    t.match(/^\.[a-z]+$/) && (e.bookType = t.slice(1)), e.bookType = r[e.bookType] || e.bookType;
  }
}
function Fh(e, r, t) {
  var a = t || {};
  return a.type = "file", a.file = r, sf(a), As(e, a);
}
function JC(e, r, t) {
  var a = t || {};
  return a.type = "file", a.file = r, sf(a), nf(e, a);
}
function qC(e, r, t, a) {
  var n = t || {};
  n.type = "file", n.file = e, sf(n), n.type = "buffer";
  var i = a;
  return i instanceof Function || (i = t), Ia.writeFile(e, As(r, n), i);
}
function M2(e, r, t, a, n, i, s, o) {
  var u = gr(t), l = o.defval, c = o.raw || !Object.prototype.hasOwnProperty.call(o, "raw"), f = !0, h = n === 1 ? [] : {};
  if (n !== 1)
    if (Object.defineProperty)
      try {
        Object.defineProperty(h, "__rowNum__", { value: t, enumerable: !1 });
      } catch {
        h.__rowNum__ = t;
      }
    else
      h.__rowNum__ = t;
  if (!s || e[t])
    for (var d = r.s.c; d <= r.e.c; ++d) {
      var m = s ? e[t][d] : e[a[d] + u];
      if (m === void 0 || m.t === void 0) {
        if (l === void 0)
          continue;
        i[d] != null && (h[i[d]] = l);
        continue;
      }
      var x = m.v;
      switch (m.t) {
        case "z":
          if (x == null)
            break;
          continue;
        case "e":
          x = x == 0 ? null : void 0;
          break;
        case "s":
        case "d":
        case "b":
        case "n":
          break;
        default:
          throw new Error("unrecognized type " + m.t);
      }
      if (i[d] != null) {
        if (x == null)
          if (m.t == "e" && x === null)
            h[i[d]] = null;
          else if (l !== void 0)
            h[i[d]] = l;
          else if (c && x === null)
            h[i[d]] = null;
          else
            continue;
        else
          h[i[d]] = c && (m.t !== "n" || m.t === "n" && o.rawNumbers !== !1) ? x : Yt(m, x, o);
        x != null && (f = !1);
      }
    }
  return { row: h, isempty: f };
}
function qo(e, r) {
  if (e == null || e["!ref"] == null)
    return [];
  var t = { t: "n", v: 0 }, a = 0, n = 1, i = [], s = 0, o = "", u = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } }, l = r || {}, c = l.range != null ? l.range : e["!ref"];
  switch (l.header === 1 ? a = 1 : l.header === "A" ? a = 2 : Array.isArray(l.header) ? a = 3 : l.header == null && (a = 0), typeof c) {
    case "string":
      u = Oe(c);
      break;
    case "number":
      u = Oe(e["!ref"]), u.s.r = c;
      break;
    default:
      u = c;
  }
  a > 0 && (n = 0);
  var f = gr(u.s.r), h = [], d = [], m = 0, x = 0, p = Array.isArray(e), w = u.s.r, D = 0, y = {};
  p && !e[w] && (e[w] = []);
  var B = l.skipHidden && e["!cols"] || [], L = l.skipHidden && e["!rows"] || [];
  for (D = u.s.c; D <= u.e.c; ++D)
    if (!(B[D] || {}).hidden)
      switch (h[D] = or(D), t = p ? e[w][D] : e[h[D] + f], a) {
        case 1:
          i[D] = D - u.s.c;
          break;
        case 2:
          i[D] = h[D];
          break;
        case 3:
          i[D] = l.header[D - u.s.c];
          break;
        default:
          if (t == null && (t = { w: "__EMPTY", t: "s" }), o = s = Yt(t, null, l), x = y[s] || 0, !x)
            y[s] = 1;
          else {
            do
              o = s + "_" + x++;
            while (y[o]);
            y[s] = x, y[o] = 1;
          }
          i[D] = o;
      }
  for (w = u.s.r + n; w <= u.e.r; ++w)
    if (!(L[w] || {}).hidden) {
      var U = M2(e, u, w, h, a, i, p, l);
      (U.isempty === !1 || (a === 1 ? l.blankrows !== !1 : l.blankrows)) && (d[m++] = U.row);
    }
  return d.length = m, d;
}
var Ah = /"/g;
function O2(e, r, t, a, n, i, s, o) {
  for (var u = !0, l = [], c = "", f = gr(t), h = r.s.c; h <= r.e.c; ++h)
    if (a[h]) {
      var d = o.dense ? (e[t] || [])[h] : e[a[h] + f];
      if (d == null)
        c = "";
      else if (d.v != null) {
        u = !1, c = "" + (o.rawNumbers && d.t == "n" ? d.v : Yt(d, null, o));
        for (var m = 0, x = 0; m !== c.length; ++m)
          if ((x = c.charCodeAt(m)) === n || x === i || x === 34 || o.forceQuotes) {
            c = '"' + c.replace(Ah, '""') + '"';
            break;
          }
        c == "ID" && (c = '"ID"');
      } else
        d.f != null && !d.F ? (u = !1, c = "=" + d.f, c.indexOf(",") >= 0 && (c = '"' + c.replace(Ah, '""') + '"')) : c = "";
      l.push(c);
    }
  return o.blankrows === !1 && u ? null : l.join(s);
}
function of(e, r) {
  var t = [], a = r ?? {};
  if (e == null || e["!ref"] == null)
    return "";
  var n = Oe(e["!ref"]), i = a.FS !== void 0 ? a.FS : ",", s = i.charCodeAt(0), o = a.RS !== void 0 ? a.RS : `
`, u = o.charCodeAt(0), l = new RegExp((i == "|" ? "\\|" : i) + "+$"), c = "", f = [];
  a.dense = Array.isArray(e);
  for (var h = a.skipHidden && e["!cols"] || [], d = a.skipHidden && e["!rows"] || [], m = n.s.c; m <= n.e.c; ++m)
    (h[m] || {}).hidden || (f[m] = or(m));
  for (var x = 0, p = n.s.r; p <= n.e.r; ++p)
    (d[p] || {}).hidden || (c = O2(e, n, p, f, s, u, i, a), c != null && (a.strip && (c = c.replace(l, "")), (c || a.blankrows !== !1) && t.push((x++ ? o : "") + c)));
  return delete a.dense, t.join("");
}
function L2(e, r) {
  r || (r = {}), r.FS = "	", r.RS = `
`;
  var t = of(e, r);
  if (typeof Ue > "u" || r.type == "string")
    return t;
  var a = Ue.utils.encode(1200, t, "str");
  return "ÿþ" + a;
}
function QC(e) {
  var r = "", t, a = "";
  if (e == null || e["!ref"] == null)
    return [];
  var n = Oe(e["!ref"]), i = "", s = [], o, u = [], l = Array.isArray(e);
  for (o = n.s.c; o <= n.e.c; ++o)
    s[o] = or(o);
  for (var c = n.s.r; c <= n.e.r; ++c)
    for (i = gr(c), o = n.s.c; o <= n.e.c; ++o)
      if (r = s[o] + i, t = l ? (e[c] || [])[o] : e[r], a = "", t !== void 0) {
        if (t.F != null) {
          if (r = t.F, !t.f)
            continue;
          a = t.f, r.indexOf(":") == -1 && (r = r + ":" + r);
        }
        if (t.f != null)
          a = t.f;
        else {
          if (t.t == "z")
            continue;
          if (t.t == "n" && t.v != null)
            a = "" + t.v;
          else if (t.t == "b")
            a = t.v ? "TRUE" : "FALSE";
          else if (t.w !== void 0)
            a = "'" + t.w;
          else {
            if (t.v === void 0)
              continue;
            t.t == "s" ? a = "'" + t.v : a = "" + t.v;
          }
        }
        u[u.length] = r + "=" + a;
      }
  return u;
}
function N2(e, r, t) {
  var a = t || {}, n = +!a.skipHeader, i = e || {}, s = 0, o = 0;
  if (i && a.origin != null)
    if (typeof a.origin == "number")
      s = a.origin;
    else {
      var u = typeof a.origin == "string" ? fr(a.origin) : a.origin;
      s = u.r, o = u.c;
    }
  var l, c = { s: { c: 0, r: 0 }, e: { c: o, r: s + r.length - 1 + n } };
  if (i["!ref"]) {
    var f = Oe(i["!ref"]);
    c.e.c = Math.max(c.e.c, f.e.c), c.e.r = Math.max(c.e.r, f.e.r), s == -1 && (s = f.e.r + 1, c.e.r = s + r.length - 1 + n);
  } else
    s == -1 && (s = 0, c.e.r = r.length - 1 + n);
  var h = a.header || [], d = 0;
  r.forEach(function(x, p) {
    br(x).forEach(function(w) {
      (d = h.indexOf(w)) == -1 && (h[d = h.length] = w);
      var D = x[w], y = "z", B = "", L = Te({ c: o + d, r: s + p + n });
      l = hs(i, L), D && typeof D == "object" && !(D instanceof Date) ? i[L] = D : (typeof D == "number" ? y = "n" : typeof D == "boolean" ? y = "b" : typeof D == "string" ? y = "s" : D instanceof Date ? (y = "d", a.cellDates || (y = "n", D = Ar(D)), B = a.dateNF || Ee[14]) : D === null && a.nullError && (y = "e", D = 0), l ? (l.t = y, l.v = D, delete l.w, delete l.R, B && (l.z = B)) : i[L] = l = { t: y, v: D }, B && (l.z = B));
    });
  }), c.e.c = Math.max(c.e.c, o + h.length - 1);
  var m = gr(s);
  if (n)
    for (d = 0; d < h.length; ++d)
      i[or(d + o) + m] = { t: "s", v: h[d] };
  return i["!ref"] = Ce(c), i;
}
function eF(e, r) {
  return N2(null, e, r);
}
function hs(e, r, t) {
  if (typeof r == "string") {
    if (Array.isArray(e)) {
      var a = fr(r);
      return e[a.r] || (e[a.r] = []), e[a.r][a.c] || (e[a.r][a.c] = { t: "z" });
    }
    return e[r] || (e[r] = { t: "z" });
  }
  return typeof r != "number" ? hs(e, Te(r)) : hs(e, Te({ r, c: t || 0 }));
}
function rF(e, r) {
  if (typeof r == "number") {
    if (r >= 0 && e.SheetNames.length > r)
      return r;
    throw new Error("Cannot find sheet # " + r);
  } else if (typeof r == "string") {
    var t = e.SheetNames.indexOf(r);
    if (t > -1)
      return t;
    throw new Error("Cannot find sheet name |" + r + "|");
  } else
    throw new Error("Cannot find sheet |" + r + "|");
}
function uf() {
  return { SheetNames: [], Sheets: {} };
}
function lf(e, r, t, a) {
  var n = 1;
  if (!t)
    for (; n <= 65535 && e.SheetNames.indexOf(t = "Sheet" + n) != -1; ++n, t = void 0)
      ;
  if (!t || e.SheetNames.length >= 65535)
    throw new Error("Too many worksheets");
  if (a && e.SheetNames.indexOf(t) >= 0) {
    var i = t.match(/(^.*?)(\d+)$/);
    n = i && +i[2] || 0;
    var s = i && i[1] || t;
    for (++n; n <= 65535 && e.SheetNames.indexOf(t = s + n) != -1; ++n)
      ;
  }
  if (x2(t), e.SheetNames.indexOf(t) >= 0)
    throw new Error("Worksheet with name |" + t + "| already exists!");
  return e.SheetNames.push(t), e.Sheets[t] = r, t;
}
function tF(e, r, t) {
  e.Workbook || (e.Workbook = {}), e.Workbook.Sheets || (e.Workbook.Sheets = []);
  var a = rF(e, r);
  switch (e.Workbook.Sheets[a] || (e.Workbook.Sheets[a] = {}), t) {
    case 0:
    case 1:
    case 2:
      break;
    default:
      throw new Error("Bad sheet visibility setting " + t);
  }
  e.Workbook.Sheets[a].Hidden = t;
}
function aF(e, r) {
  return e.z = r, e;
}
function U2(e, r, t) {
  return r ? (e.l = { Target: r }, t && (e.l.Tooltip = t)) : delete e.l, e;
}
function nF(e, r, t) {
  return U2(e, "#" + r, t);
}
function iF(e, r, t) {
  e.c || (e.c = []), e.c.push({ t: r, a: t || "SheetJS" });
}
function sF(e, r, t, a) {
  for (var n = typeof r != "string" ? r : Oe(r), i = typeof r == "string" ? r : Ce(r), s = n.s.r; s <= n.e.r; ++s)
    for (var o = n.s.c; o <= n.e.c; ++o) {
      var u = hs(e, s, o);
      u.t = "n", u.F = i, delete u.v, s == n.s.r && o == n.s.c && (u.f = t, a && (u.D = !0));
    }
  return e;
}
var go = {
  encode_col: or,
  encode_row: gr,
  encode_cell: Te,
  encode_range: Ce,
  decode_col: Bc,
  decode_row: Ic,
  split_cell: E_,
  decode_cell: fr,
  decode_range: tt,
  format_cell: Yt,
  sheet_add_aoa: iv,
  sheet_add_json: N2,
  sheet_add_dom: k2,
  aoa_to_sheet: mi,
  json_to_sheet: eF,
  table_to_sheet: T2,
  table_to_book: pC,
  sheet_to_csv: of,
  sheet_to_txt: L2,
  sheet_to_json: qo,
  sheet_to_html: E2,
  sheet_to_formulae: QC,
  sheet_to_row_object_array: qo,
  sheet_get_cell: hs,
  book_new: uf,
  book_append_sheet: lf,
  book_set_sheet_visibility: tF,
  cell_set_number_format: aF,
  cell_set_hyperlink: U2,
  cell_set_internal_link: nF,
  cell_add_comment: iF,
  sheet_set_array_formula: sF,
  consts: {
    SHEET_VISIBLE: 0,
    SHEET_HIDDEN: 1,
    SHEET_VERY_HIDDEN: 2
  }
}, $0;
function oF(e) {
  $0 = e;
}
function uF(e, r) {
  var t = $0(), a = r ?? {};
  if (e == null || e["!ref"] == null)
    return t.push(null), t;
  var n = Oe(e["!ref"]), i = a.FS !== void 0 ? a.FS : ",", s = i.charCodeAt(0), o = a.RS !== void 0 ? a.RS : `
`, u = o.charCodeAt(0), l = new RegExp((i == "|" ? "\\|" : i) + "+$"), c = "", f = [];
  a.dense = Array.isArray(e);
  for (var h = a.skipHidden && e["!cols"] || [], d = a.skipHidden && e["!rows"] || [], m = n.s.c; m <= n.e.c; ++m)
    (h[m] || {}).hidden || (f[m] = or(m));
  var x = n.s.r, p = !1, w = 0;
  return t._read = function() {
    if (!p)
      return p = !0, t.push("\uFEFF");
    for (; x <= n.e.r; )
      if (++x, !(d[x - 1] || {}).hidden && (c = O2(e, n, x - 1, f, s, u, i, a), c != null && (a.strip && (c = c.replace(l, "")), c || a.blankrows !== !1)))
        return t.push((w++ ? o : "") + c);
    return t.push(null);
  }, t;
}
function lF(e, r) {
  var t = $0(), a = r || {}, n = a.header != null ? a.header : _2, i = a.footer != null ? a.footer : $2;
  t.push(n);
  var s = tt(e["!ref"]);
  a.dense = Array.isArray(e), t.push(D2(e, s, a));
  var o = s.s.r, u = !1;
  return t._read = function() {
    if (o > s.e.r)
      return u || (u = !0, t.push("</table>" + i)), t.push(null);
    for (; o <= s.e.r; ) {
      t.push(w2(e, s, o, a)), ++o;
      break;
    }
  }, t;
}
function cF(e, r) {
  var t = $0({ objectMode: !0 });
  if (e == null || e["!ref"] == null)
    return t.push(null), t;
  var a = { t: "n", v: 0 }, n = 0, i = 1, s = [], o = 0, u = "", l = { s: { r: 0, c: 0 }, e: { r: 0, c: 0 } }, c = r || {}, f = c.range != null ? c.range : e["!ref"];
  switch (c.header === 1 ? n = 1 : c.header === "A" ? n = 2 : Array.isArray(c.header) && (n = 3), typeof f) {
    case "string":
      l = Oe(f);
      break;
    case "number":
      l = Oe(e["!ref"]), l.s.r = f;
      break;
    default:
      l = f;
  }
  n > 0 && (i = 0);
  var h = gr(l.s.r), d = [], m = 0, x = Array.isArray(e), p = l.s.r, w = 0, D = {};
  x && !e[p] && (e[p] = []);
  var y = c.skipHidden && e["!cols"] || [], B = c.skipHidden && e["!rows"] || [];
  for (w = l.s.c; w <= l.e.c; ++w)
    if (!(y[w] || {}).hidden)
      switch (d[w] = or(w), a = x ? e[p][w] : e[d[w] + h], n) {
        case 1:
          s[w] = w - l.s.c;
          break;
        case 2:
          s[w] = d[w];
          break;
        case 3:
          s[w] = c.header[w - l.s.c];
          break;
        default:
          if (a == null && (a = { w: "__EMPTY", t: "s" }), u = o = Yt(a, null, c), m = D[o] || 0, !m)
            D[o] = 1;
          else {
            do
              u = o + "_" + m++;
            while (D[u]);
            D[o] = m, D[u] = 1;
          }
          s[w] = u;
      }
  return p = l.s.r + i, t._read = function() {
    for (; p <= l.e.r; )
      if (!(B[p - 1] || {}).hidden) {
        var L = M2(e, l, p, d, n, s, x, c);
        if (++p, L.isempty === !1 || (n === 1 ? c.blankrows !== !1 : c.blankrows)) {
          t.push(L.row);
          return;
        }
      }
    return t.push(null);
  }, t;
}
var fF = {
  to_json: cF,
  to_html: lF,
  to_csv: uF,
  set_readable: oF
};
const dF = es.version, hF = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CFB: we,
  SSF: Np,
  parse_xlscfb: Qc,
  parse_zip: A2,
  read: Jo,
  readFile: Ch,
  readFileSync: Ch,
  set_cptable: p5,
  set_fs: z5,
  stream: fF,
  utils: go,
  version: dF,
  write: As,
  writeFile: Fh,
  writeFileAsync: qC,
  writeFileSync: Fh,
  writeFileXLSX: JC,
  writeXLSX: nf
}, Symbol.toStringTag, { value: "Module" })), Rh = [
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-excel"
], Ih = "text/csv", Bh = (e, r) => {
  d5.parse(e, {
    preview: 1e3,
    skipEmptyLines: !0,
    complete: (t) => {
      r(t.data);
    }
  });
}, xF = (e, r) => {
  var a, n;
  if (!e)
    return !1;
  const t = (n = (a = e == null ? void 0 : e.split(";")) == null ? void 0 : a[0]) == null ? void 0 : n.trim().toLowerCase();
  return r.some((i) => {
    var o, u, l;
    const s = (l = (u = (o = i == null ? void 0 : i.split) == null ? void 0 : o.call(i, ";")) == null ? void 0 : u[0]) == null ? void 0 : l.trim().toLowerCase();
    return t === s;
  });
}, P9 = (e, r, t) => {
  var i, s, o;
  const a = xF(e.type, [...Rh, Ih]), n = ((o = (s = (i = e.type) == null ? void 0 : i.split(";")) == null ? void 0 : s[0]) == null ? void 0 : o.trim().toLowerCase()) || e.type;
  a ? Rh.includes(n) ? Promise.resolve().then(() => hF).then((u) => {
    const l = u != null && u.default ? u.default : u, c = new FileReader();
    c.onload = (f) => {
      var p;
      const h = (p = f == null ? void 0 : f.target) == null ? void 0 : p.result, d = l.read(h, { type: "binary", sheetRows: 1e3 }), m = d.SheetNames[0], x = d.Sheets[m];
      if (x) {
        const w = l.utils.sheet_to_csv(x);
        Bh(w, r);
      }
    }, c.readAsBinaryString(e);
  }).catch(() => t == null ? void 0 : t()) : n === Ih && Bh(e, r) : t && t();
}, V2 = async (e, r) => {
  try {
    const t = window.document.createElement("a");
    t.href = window.URL.createObjectURL(e), t.download = r, document.body.appendChild(t), t.click(), document.body.removeChild(t);
  } catch (t) {
    console.error("error :", t);
  }
}, M9 = async (e, r) => {
  try {
    const a = await (await fetch(e)).blob();
    V2(a, r);
  } catch (t) {
    console.error("error :", t);
  }
}, O9 = async (e, r) => {
  try {
    const t = e.split(`\r
`).map((o) => o.split(",")), a = go.aoa_to_sheet(t), n = go.book_new();
    go.book_append_sheet(n, a, "Sheet1");
    const i = As(n, { bookType: "xlsx", type: "array" }), s = new Blob([i], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    });
    V2(s, r);
  } catch {
    Mh("Error while converting data to XLSX file", {
      variant: "error"
    });
  }
}, mF = (e) => !e || /^(?:(?:https?):\/\/)?(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(
  e
), L9 = (e) => {
  if (!mF(e))
    return "";
  e.startsWith("http") || (e = "https://" + e);
  let r = "";
  try {
    r = new URL(e).href;
  } catch {
    r = "";
  }
  return r;
}, pF = "_root_1fxlp_1", vF = "_react_aria_DateRangePicker_1fxlp_37", gF = "_react_aria_Group_1fxlp_43", yF = "_caretButton_1fxlp_46", bF = "_caretup_1fxlp_49", wF = "_input_1fxlp_52", _F = "_react_aria_Label_1fxlp_67", $F = "_react_aria_Button_1fxlp_114", DF = "_inputIcon_1fxlp_129", EF = "_inputContainer_1fxlp_147", kF = "_react_aria_Popover_1fxlp_158", TF = "_react_aria_Dialog_1fxlp_161", SF = "_react_aria_RangeCalendar_1fxlp_169", CF = "_react_aria_Heading_1fxlp_177", FF = "_react_aria_CalendarHeaderCell_1fxlp_217", AF = "_react_aria_CalendarGridBody_1fxlp_220", RF = "_react_aria_CalendarCell_1fxlp_224", mr = {
  root: pF,
  "variant-outlinedDash": "_variant-outlinedDash_1fxlp_8",
  "variant-outlined": "_variant-outlined_1fxlp_8",
  "size-medium": "_size-medium_1fxlp_18",
  "size-large": "_size-large_1fxlp_24",
  "size-small": "_size-small_1fxlp_30",
  react_aria_DateRangePicker: vF,
  react_aria_Group: gF,
  caretButton: yF,
  caretup: bF,
  input: wF,
  react_aria_Label: _F,
  react_aria_Button: $F,
  inputIcon: DF,
  inputContainer: EF,
  react_aria_Popover: kF,
  react_aria_Dialog: TF,
  react_aria_RangeCalendar: SF,
  react_aria_Heading: CF,
  react_aria_CalendarHeaderCell: FF,
  react_aria_CalendarGridBody: AF,
  react_aria_CalendarCell: RF
}, N9 = ({
  timezoneName: e,
  selectedDate: r,
  minValueParams: t,
  setHasError: a,
  triggerRef: n,
  maxValueParams: i,
  disabled: s = !1,
  label: o,
  variant: u = "outlined",
  onChange: l,
  hideCaret: c,
  size: f = "medium"
}) => {
  const [h, d] = Re.useState({
    min: new ot(
      Ne(e).year,
      Ne(e).month,
      Ne(e).day
    ).subtract({
      [(t == null ? void 0 : t.param) || "days"]: (t == null ? void 0 : t.subtractor) || 0
    }).toString(),
    max: new Ft(
      Ne(e).year,
      Ne(e).month,
      Ne(e).day,
      23,
      59,
      59
    ).subtract({
      [(i == null ? void 0 : i.param) || "days"]: (i == null ? void 0 : i.subtractor) || 0
    }).toString()
  }), [m, x] = Re.useState(!1), [p, w] = Re.useState(!1), D = Re.useRef(), [y, B] = Re.useState(), L = (k) => {
    const v = new ot(k.year, k.month, k.day);
    B(v.toDate(e).valueOf()), t && Er(v.toString()).compare(
      Er(h.min)
    ) < 0 || i && Er(v.toString()).compare(
      Er(h.max)
    ) > 0 ? x(!0) : x(!1);
  }, U = () => {
    y && l(y);
  };
  return Re.useEffect(() => {
    d({
      min: new ot(
        Ne(e).year,
        Ne(e).month,
        Ne(e).day
      ).subtract({
        [(t == null ? void 0 : t.param) || "days"]: (t == null ? void 0 : t.subtractor) || 0
      }).toString(),
      max: new ot(
        Ne(e).year,
        Ne(e).month,
        Ne(e).day
      ).subtract({
        [(i == null ? void 0 : i.param) || "days"]: (i == null ? void 0 : i.subtractor) || 0
      }).toString()
    });
  }, [
    i == null ? void 0 : i.param,
    i == null ? void 0 : i.subtractor,
    t == null ? void 0 : t.param,
    t == null ? void 0 : t.subtractor,
    e
  ]), Re.useEffect(() => {
    r && B(r);
  }, [r]), Re.useEffect(() => {
    a == null || a(m);
  }, [m]), y ? /* @__PURE__ */ le.jsx(
    st,
    {
      className: Za(
        mr.root,
        mr[`variant-${u}`],
        mr[`size-${f}`]
      ),
      children: /* @__PURE__ */ le.jsx(O1, { locale: "en-US", children: /* @__PURE__ */ le.jsxs(
        o5,
        {
          isDisabled: s,
          className: mr.react_aria_DateRangePicker,
          minValue: t ? Ea(h.min) : void 0,
          maxValue: i ? Ea(h.max) : void 0,
          granularity: "day",
          shouldForceLeadingZeros: !0,
          hideTimeZone: !0,
          value: pr(r, e),
          children: [
            /* @__PURE__ */ le.jsx($4, { className: mr.react_aria_Label, children: o }),
            /* @__PURE__ */ le.jsxs(
              _p,
              {
                className: mr.react_aria_Group,
                isInvalid: m,
                ref: D,
                children: [
                  /* @__PURE__ */ le.jsxs(st, { className: mr.inputContainer, children: [
                    /* @__PURE__ */ le.jsx(Nh, { className: mr.inputIcon }),
                    /* @__PURE__ */ le.jsx(st, { className: mr.input, children: `${vl(r, e)}` }),
                    c !== !0 && /* @__PURE__ */ le.jsx(
                      Uh,
                      {
                        className: Za(
                          p && mr.caretup,
                          mr.inputIcon,
                          mr.caretButton
                        )
                      }
                    )
                  ] }),
                  /* @__PURE__ */ le.jsx(
                    Ln,
                    {
                      onPress: () => {
                        w == null || w((k) => !k);
                      },
                      className: mr.react_aria_Button
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ le.jsx(
              Oh,
              {
                transitionDuration: 0,
                anchorEl: (n == null ? void 0 : n.current) || (D == null ? void 0 : D.current),
                anchorOrigin: { vertical: "bottom", horizontal: "left" },
                transformOrigin: { vertical: "top", horizontal: "left" },
                open: p,
                onClose: () => {
                  w == null || w(!1), B(r);
                },
                className: mr.react_aria_Popover,
                children: /* @__PURE__ */ le.jsxs(Dp, { className: mr.react_aria_Dialog, children: [
                  /* @__PURE__ */ le.jsxs(
                    Gw,
                    {
                      className: mr.react_aria_RangeCalendar,
                      minValue: t ? Ea(h.min) : void 0,
                      maxValue: i ? Ea(h.max) : void 0,
                      value: pr(
                        y,
                        e
                      ),
                      onChange: L,
                      children: [
                        /* @__PURE__ */ le.jsxs("header", { children: [
                          /* @__PURE__ */ le.jsx(Ln, { slot: "previous", className: mr.react_aria_Button, children: /* @__PURE__ */ le.jsx(Vh, { color: "secondary" }) }),
                          /* @__PURE__ */ le.jsx(
                            st,
                            {
                              sx: {
                                width: 100,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: 8
                              },
                              children: /* @__PURE__ */ le.jsx(kp, { className: mr.react_aria_Heading })
                            }
                          ),
                          /* @__PURE__ */ le.jsx(Ln, { slot: "next", className: mr.react_aria_Button, children: /* @__PURE__ */ le.jsx(Wh, { color: "secondary" }) })
                        ] }),
                        /* @__PURE__ */ le.jsx(st, { sx: { display: "flex", gap: 32, overflow: "auto" }, children: /* @__PURE__ */ le.jsxs(ml, { weekdayStyle: "short", children: [
                          /* @__PURE__ */ le.jsx(Mo, { children: (k) => /* @__PURE__ */ le.jsx(
                            Oo,
                            {
                              className: mr.react_aria_CalendarHeaderCell,
                              children: k
                            }
                          ) }),
                          /* @__PURE__ */ le.jsx(
                            Lo,
                            {
                              className: mr.react_aria_CalendarGridBody,
                              children: (k) => /* @__PURE__ */ le.jsx(
                                pl,
                                {
                                  className: mr.react_aria_CalendarCell,
                                  date: k
                                }
                              )
                            }
                          )
                        ] }) })
                      ]
                    }
                  ),
                  /* @__PURE__ */ le.jsx(
                    st,
                    {
                      sx: {
                        width: 100,
                        display: "flex"
                      },
                      children: /* @__PURE__ */ le.jsx(
                        Da,
                        {
                          onClick: () => {
                            U(), w(!1);
                          },
                          sx: { ml: "auto" },
                          children: "Apply"
                        }
                      )
                    }
                  )
                ] })
              }
            )
          ]
        }
      ) })
    }
  ) : null;
}, IF = "_root_1euw9_1", BF = "_react_aria_DateRangePicker_1euw9_37", PF = "_react_aria_Group_1euw9_48", MF = "_caretButton_1euw9_51", OF = "_caretup_1euw9_54", LF = "_input_1euw9_57", NF = "_react_aria_Label_1euw9_74", UF = "_react_aria_Button_1euw9_122", VF = "_inputIcon_1euw9_137", WF = "_inputContainer_1euw9_156", HF = "_react_aria_Popover_1euw9_167", jF = "_react_aria_Dialog_1euw9_170", zF = "_react_aria_RangeCalendar_1euw9_178", GF = "_react_aria_Heading_1euw9_186", KF = "_react_aria_CalendarHeaderCell_1euw9_226", YF = "_react_aria_CalendarGridBody_1euw9_229", XF = "_react_aria_CalendarCell_1euw9_233", qe = {
  root: IF,
  "variant-outlinedDash": "_variant-outlinedDash_1euw9_8",
  "variant-outlined": "_variant-outlined_1euw9_8",
  "size-medium": "_size-medium_1euw9_18",
  "size-large": "_size-large_1euw9_24",
  "size-small": "_size-small_1euw9_30",
  react_aria_DateRangePicker: BF,
  react_aria_Group: PF,
  caretButton: MF,
  caretup: OF,
  input: LF,
  react_aria_Label: NF,
  react_aria_Button: UF,
  inputIcon: VF,
  inputContainer: WF,
  react_aria_Popover: HF,
  react_aria_Dialog: jF,
  react_aria_RangeCalendar: zF,
  react_aria_Heading: GF,
  react_aria_CalendarHeaderCell: KF,
  react_aria_CalendarGridBody: YF,
  react_aria_CalendarCell: XF
}, U9 = ({
  label: e,
  onChange: r,
  hideCaret: t,
  dateRange: a,
  triggerRef: n,
  placeholder: i,
  setHasError: s,
  timezoneName: o,
  isPopoverOpen: u,
  minValueParams: l,
  maxValueParams: c,
  size: f = "medium",
  setIsPopoverOpen: h,
  optional: d = !1,
  disabled: m = !1,
  variant: x = "outlined",
  showPreselects: p = !0
}) => {
  const { startDate: w, endDate: D } = a, [y, B] = Re.useState({
    min: new ot(
      Ne(o).year,
      Ne(o).month,
      Ne(o).day
    ).subtract({
      [(l == null ? void 0 : l.param) || "days"]: (l == null ? void 0 : l.subtractor) || 0
    }).toString(),
    max: new ot(
      Ne(o).year,
      Ne(o).month,
      Ne(o).day
    ).subtract({
      [(c == null ? void 0 : c.param) || "days"]: (c == null ? void 0 : c.subtractor) || 0
    }).toString()
  }), [L, U] = Re.useState(!1), [k, v] = Re.useState(!1), [b, A] = Re.useState(!1), T = Re.useRef(), [C, I] = Re.useState(
    null
  ), [Y, j] = Re.useState(null), [J, W] = Re.useState(
    pr(D ?? 0, o)
  );
  Re.useEffect(() => {
    if (w)
      W(
        pr(w, o)
      );
    else {
      const P = zh(o).toDate().valueOf();
      W(pr(P, o));
    }
  }, [b, w, o]);
  const ce = (P) => {
    const N = new ot(
      P.start.year,
      P.start.month,
      P.start.day
    ), X = new Ft(
      P.end.year,
      P.end.month,
      P.end.day,
      23,
      59,
      59,
      0
    );
    I(N.toDate(o).valueOf()), j(X.toDate(o).valueOf()), l && Er(N.toString()).compare(
      Er(y.min)
    ) < 0 || c && Er(N.toString()).compare(
      Er(y.max)
    ) > 0 || c && Er(
      X.set({ hour: 0, minute: 0, second: 0 }).toString()
    ).compare(Er(y.max)) > 0 || l && Er(
      X.set({ hour: 0, minute: 0, second: 0 }).toString()
    ).compare(Er(y.min)) < 0 ? v(!0) : v(!1), N.toDate(o).valueOf() > X.toDate(o).valueOf() ? U(!0) : U(!1);
  }, V = () => {
    Y && C && r({ startDate: C, endDate: Y });
  }, ee = () => {
    const P = Ne(o).subtract({ days: 1 }), N = new ot(
      P.year,
      P.month,
      P.day
    ), X = new Ft(
      P.year,
      P.month,
      P.day,
      23,
      59,
      59,
      0
    );
    W(N), I(N.toDate(o).valueOf()), j(X.toDate(o).valueOf());
  }, de = () => {
    const P = Ne(o), N = new ot(
      P.year,
      P.month,
      P.day
    ), X = new Ft(
      P.year,
      P.month,
      P.day,
      23,
      59,
      59,
      0
    );
    W(X), I(N.toDate(o).valueOf()), j(X.toDate(o).valueOf());
  }, F = () => {
    const P = Ne(o), N = P.subtract({ days: 6 }), X = new Ft(
      P.year,
      P.month,
      P.day,
      23,
      59,
      59,
      0
    );
    W(X), I(N.toDate(o).valueOf()), j(X.toDate(o).valueOf());
  }, H = () => {
    const P = Ne(o), N = P.subtract({ months: 1 }), X = new Ft(
      P.year,
      P.month,
      P.day,
      23,
      59,
      59,
      0
    );
    W(X), I(N.toDate(o).valueOf()), j(X.toDate(o).valueOf());
  };
  return Re.useEffect(() => {
    B({
      min: new ot(
        Ne(o).year,
        Ne(o).month,
        Ne(o).day
      ).subtract({
        [(l == null ? void 0 : l.param) ?? "days"]: (l == null ? void 0 : l.subtractor) ?? 0
      }).toString(),
      max: new ot(
        Ne(o).year,
        Ne(o).month,
        Ne(o).day
      ).subtract({
        [(c == null ? void 0 : c.param) ?? "days"]: (c == null ? void 0 : c.subtractor) ?? 0
      }).toString()
    });
  }, [
    c == null ? void 0 : c.param,
    c == null ? void 0 : c.subtractor,
    l == null ? void 0 : l.param,
    l == null ? void 0 : l.subtractor,
    o
  ]), Re.useEffect(() => {
    let P = null, N = null;
    typeof C == "number" && C < Er(y.min).toDate(o).valueOf() && (P = Er(y.min).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toDate(o).valueOf()), typeof C == "number" && C > Er(y.max).toDate(o).valueOf() && (P = Er(y.max).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toDate(o).valueOf()), typeof Y == "number" && Y > Er(y.max).toDate(o).valueOf() && (N = Er(y.max).set({ hour: 23, minute: 59, second: 59, millisecond: 0 }).toDate(o).valueOf()), typeof Y == "number" && Y < Er(y.min).toDate(o).valueOf() && (N = Er(y.min).set({ hour: 23, minute: 59, second: 59, millisecond: 0 }).toDate(o).valueOf()), (typeof P == "number" || typeof N == "number") && (j(N ?? Y), I(P ?? C), r({
      startDate: P ?? C,
      endDate: N ?? Y
    }));
  }, [y]), Re.useEffect(() => {
    (typeof w == "number" || w === null) && I(w), (typeof D == "number" || D === null) && j(D);
  }, [D, w]), Re.useEffect(() => {
    s == null || s(L || k);
  }, [L, k]), /* @__PURE__ */ le.jsx(
    st,
    {
      className: Za(
        qe.root,
        qe[`variant-${x}`],
        qe[`size-${f}`]
      ),
      children: /* @__PURE__ */ le.jsx(O1, { locale: "en-US", children: /* @__PURE__ */ le.jsxs(
        l5,
        {
          isDisabled: m,
          className: qe.react_aria_DateRangePicker,
          minValue: l ? Ea(y.min) : void 0,
          maxValue: c ? Ea(y.max) : void 0,
          isInvalid: L,
          granularity: "day",
          shouldForceLeadingZeros: !0,
          hideTimeZone: !0,
          value: w && D ? {
            start: pr(
              w,
              o
            ),
            end: pr(
              D,
              o
            )
          } : void 0,
          children: [
            /* @__PURE__ */ le.jsx($4, { className: qe.react_aria_Label, children: e }),
            /* @__PURE__ */ le.jsxs(
              _p,
              {
                className: Za(
                  qe.react_aria_Group,
                  b ? "popover-open" : ""
                ),
                isInvalid: L || k,
                ref: T,
                children: [
                  /* @__PURE__ */ le.jsxs(st, { className: qe.inputContainer, children: [
                    /* @__PURE__ */ le.jsx(Nh, { className: qe.inputIcon }),
                    /* @__PURE__ */ le.jsx(st, { className: qe.input, children: C && Y ? `${vl(C, o)} - ${vl(Y, o)}` : /* @__PURE__ */ le.jsx(Bt, { sx: { textColor: "neutral-400" }, children: i }) }),
                    t !== !0 && d === !1 ? /* @__PURE__ */ le.jsx(
                      Uh,
                      {
                        onClick: () => A == null ? void 0 : A((P) => !P),
                        className: Za(
                          b && qe.caretup,
                          qe.inputIcon,
                          qe.caretButton
                        )
                      }
                    ) : null,
                    Y && Y && d ? /* @__PURE__ */ le.jsx(
                      H2,
                      {
                        onClick: () => {
                          I(null), j(null), r({
                            startDate: null,
                            endDate: null
                          }), A(!1);
                        },
                        className: Za(qe.inputIcon, qe.caretButton)
                      }
                    ) : null
                  ] }),
                  /* @__PURE__ */ le.jsx(
                    Ln,
                    {
                      onPress: () => {
                        A == null || A((P) => !P);
                      },
                      className: qe.react_aria_Button
                    }
                  )
                ]
              }
            ),
            L && /* @__PURE__ */ le.jsx(Bt, { sx: { fontSize: 12, textColor: "danger-500" }, children: "Start date must be before end date." }),
            k && /* @__PURE__ */ le.jsx(Bt, { sx: { fontSize: 12, textColor: "danger-500" }, children: "Selected date in out of range" }),
            /* @__PURE__ */ le.jsx(
              Oh,
              {
                transitionDuration: 0,
                anchorEl: (n == null ? void 0 : n.current) || (T == null ? void 0 : T.current),
                anchorOrigin: { vertical: "bottom", horizontal: "left" },
                transformOrigin: { vertical: "top", horizontal: "left" },
                open: u ?? b,
                onClose: () => {
                  h == null || h(!1), A == null || A(!1), j(D), I(w);
                },
                className: qe.react_aria_Popover,
                children: /* @__PURE__ */ le.jsxs(Dp, { className: qe.react_aria_Dialog, children: [
                  /* @__PURE__ */ le.jsxs(
                    Yw,
                    {
                      className: qe.react_aria_RangeCalendar,
                      visibleDuration: { months: 2 },
                      minValue: l ? Ea(y.min) : void 0,
                      maxValue: c ? Ea(y.max) : void 0,
                      value: C && Y ? {
                        start: pr(
                          C,
                          o
                        ),
                        end: pr(Y, o).set({
                          hour: 0,
                          minute: 0,
                          second: 0
                        })
                      } : {
                        start: pr(
                          0,
                          o
                        ),
                        end: pr(
                          0,
                          o
                        )
                      },
                      onChange: ce,
                      focusedValue: J,
                      onFocusChange: W,
                      children: [
                        /* @__PURE__ */ le.jsxs("header", { children: [
                          /* @__PURE__ */ le.jsx(Ln, { slot: "previous", className: qe.react_aria_Button, children: /* @__PURE__ */ le.jsx(Vh, { color: "secondary" }) }),
                          /* @__PURE__ */ le.jsx(
                            st,
                            {
                              sx: {
                                width: 100,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: 8
                              },
                              children: /* @__PURE__ */ le.jsx(kp, { className: qe.react_aria_Heading })
                            }
                          ),
                          /* @__PURE__ */ le.jsx(Ln, { slot: "next", className: qe.react_aria_Button, children: /* @__PURE__ */ le.jsx(Wh, { color: "secondary" }) })
                        ] }),
                        /* @__PURE__ */ le.jsxs(st, { sx: { display: "flex", gap: 32, overflow: "auto" }, children: [
                          /* @__PURE__ */ le.jsxs(ml, { weekdayStyle: "short", children: [
                            /* @__PURE__ */ le.jsx(
                              Mo,
                              {
                                className: qe.react_aria_CalendarGridHeader,
                                children: (P) => /* @__PURE__ */ le.jsx(
                                  Oo,
                                  {
                                    className: qe.react_aria_CalendarHeaderCell,
                                    children: P
                                  }
                                )
                              }
                            ),
                            /* @__PURE__ */ le.jsx(
                              Lo,
                              {
                                className: qe.react_aria_CalendarGridBody,
                                children: (P) => /* @__PURE__ */ le.jsx(
                                  pl,
                                  {
                                    className: qe.react_aria_CalendarCell,
                                    date: P
                                  }
                                )
                              }
                            )
                          ] }),
                          /* @__PURE__ */ le.jsxs(ml, { offset: { months: 1 }, weekdayStyle: "short", children: [
                            /* @__PURE__ */ le.jsx(Mo, { children: (P) => /* @__PURE__ */ le.jsx(
                              Oo,
                              {
                                className: qe.react_aria_CalendarHeaderCell,
                                children: P
                              }
                            ) }),
                            /* @__PURE__ */ le.jsx(
                              Lo,
                              {
                                className: qe.react_aria_CalendarGridBody,
                                children: (P) => /* @__PURE__ */ le.jsx(
                                  pl,
                                  {
                                    className: qe.react_aria_CalendarCell,
                                    date: P
                                  }
                                )
                              }
                            )
                          ] })
                        ] })
                      ]
                    }
                  ),
                  /* @__PURE__ */ le.jsxs(
                    st,
                    {
                      sx: {
                        width: 100,
                        display: "flex",
                        alignItems: "center"
                      },
                      children: [
                        p === !0 ? /* @__PURE__ */ le.jsxs(st, { sx: { display: "flex", gap: 8 }, children: [
                          /* @__PURE__ */ le.jsx(Da, { onClick: de, variant: "outlined", children: "Today" }),
                          /* @__PURE__ */ le.jsx(
                            Da,
                            {
                              onClick: ee,
                              variant: "outlined",
                              children: "Yesterday"
                            }
                          ),
                          /* @__PURE__ */ le.jsx(Da, { onClick: F, variant: "outlined", children: "Week" }),
                          /* @__PURE__ */ le.jsx(Da, { onClick: H, variant: "outlined", children: "Month" })
                        ] }) : null,
                        /* @__PURE__ */ le.jsx(
                          Da,
                          {
                            sx: { marginLeft: "auto" },
                            onClick: () => {
                              V(), A(!1);
                            },
                            children: "Apply"
                          }
                        )
                      ]
                    }
                  )
                ] })
              }
            )
          ]
        }
      ) })
    }
  );
}, V9 = (e) => {
  const {
    sampleFileURL: r,
    sampleFileName: t,
    onSampleDownloadSuccess: a,
    onSampleDownloadFailure: n,
    sampleFileText: i,
    buttonProps: s
  } = e, o = async () => {
    try {
      const l = await (await fetch(r)).blob(), c = window.document.createElement("a");
      c.href = window.URL.createObjectURL(l), c.download = t, document.body.appendChild(c), c.click(), document.body.removeChild(c), a == null || a();
    } catch (u) {
      n == null || n(u);
    }
  };
  return /* @__PURE__ */ le.jsx(
    Da,
    {
      variant: "text",
      startIcon: /* @__PURE__ */ le.jsx(j2, {}),
      onClick: o,
      ...s,
      children: i
    }
  );
}, W9 = (e) => {
  const { onUpload: r, fileTypes: t, uploadBtnText: a, uploadBtnVariant: n, buttonProps: i } = e, s = ye.useRef(null), [o, u] = ye.useState(""), l = () => {
    var f, h;
    return (h = (f = s.current) == null ? void 0 : f.click) == null ? void 0 : h.call(f);
  }, c = (f) => {
    f.target.files && (r(f.target.files), u(""));
  };
  return /* @__PURE__ */ le.jsxs(st, { children: [
    /* @__PURE__ */ le.jsx(
      "input",
      {
        type: "file",
        style: { display: "none" },
        ref: s,
        accept: t.map((f) => `.${f}`).join(", "),
        onChange: c,
        value: o
      }
    ),
    /* @__PURE__ */ le.jsx(
      Da,
      {
        startIcon: /* @__PURE__ */ le.jsx(z2, {}),
        variant: n,
        onClick: l,
        ...i,
        children: a
      }
    )
  ] });
};
let W2;
function H9(e) {
  W2 = e;
}
function Rs() {
  return W2 || Hh;
}
const ZF = (e) => {
  if (!Array.isArray(e))
    return [];
  const r = [];
  return [...new Set(e.map((a) => a.parentId))].forEach((a) => {
    var i;
    const n = e.filter((s) => s.parentId === a);
    r.push({
      value: a,
      label: (i = n[0]) == null ? void 0 : i.parentName,
      subRows: n.map((s) => ({
        label: s.name,
        value: s.iabCategoryId
      }))
    });
  }), r;
}, JF = 1, qF = 2, Ph = 3, $u = 4, QF = (e) => {
  if (typeof e != "object")
    return [];
  const r = [];
  return Object.keys(e).forEach((a) => {
    switch (a) {
      case "videoPlayerSizes":
        r.push({
          value: a,
          applicableCreativeTypeIds: [Ph, $u],
          label: "Player Sizes",
          subRows: e.videoPlayerSizes.map((n) => ({
            value: `size-${n.id}`,
            label: n.name
          }))
        });
        break;
      case "standardDimensions":
        r.push({
          value: a,
          label: "Display",
          applicableCreativeTypeIds: [JF, $u],
          subRows: e.standardDimensions.map((n) => ({
            value: `standard-${n.id}`,
            label: n.name
          }))
        });
        break;
      case "creativeDurations":
        r.unshift({
          value: a,
          label: "Duration",
          applicableCreativeTypeIds: [
            qF,
            Ph,
            $u
          ],
          subRows: e.creativeDurations.map((n) => ({
            value: `duration-${n.id}`,
            label: n.name
          }))
        });
        break;
    }
  }), r;
}, e9 = Re.forwardRef((e, r) => {
  const {
    multiple: t = !0,
    onChange: a,
    textFieldProps: n,
    applicableCreativeTypeIds: i,
    ...s
  } = e, o = an.useSelectAdvanceApiRef(), [u, l] = Re.useState({}), c = Re.useRef(u);
  c.current = u;
  const f = Re.useRef(
    new Map(Object.entries({}))
  ), h = an.DefaultListOptionItemWrapper(
    {
      disableCheckbox: !0,
      disableRowExpansion: !0,
      selectionStyle: "all",
      arrowPosition: "right"
    }
  ), { data: d, isLoading: m, isFetching: x } = f9(), p = (k) => {
    const v = {};
    f.current.clear();
    for (const [b, A] of Object.entries(k))
      v[b] = !0, f.current.set(b, A);
    l(v), a == null || a(
      Object.fromEntries(f.current.entries()),
      "apiAction"
    );
  }, w = Re.useMemo(() => {
    var k;
    if (!(m || x)) {
      if (!Array.isArray(d == null ? void 0 : d.data))
        return "error";
      if ((((k = d == null ? void 0 : d.data) == null ? void 0 : k.length) ?? 0) <= 0)
        return "noRows";
    }
  }, [d, m, x]), D = () => {
    const k = f.current.entries(), v = o.current.tableInstance.getRowModel().rowsById, b = {};
    for (const A of k) {
      const [T, C] = A;
      v[T] && (b[T] = C);
    }
    return b;
  }, y = (k) => {
    var j, J;
    const v = typeof k == "function" ? k(u) : k;
    if (t === !1) {
      const W = Object.keys(v)[0], V = (j = o.current.tableInstance.getRowModel().rowsById[W]) == null ? void 0 : j.original;
      f.current.clear(), f.current.set(W, V), l(k), typeof a == "function" && a(
        Object.fromEntries(f.current.entries()),
        "userAction"
      );
      return;
    }
    const b = Object.keys(v), A = D(), T = Object.keys(A), C = o.current.tableInstance.getRowModel().rowsById, I = b.filter(
      (W) => A[W] === void 0
    ), Y = T.filter(
      (W) => v[W] === void 0
    );
    for (const W of I)
      (J = C[W]) != null && J.original && f.current.set(W, C[W].original);
    for (const W of Y)
      f.current.delete(W);
    l(k), typeof a == "function" && a(
      Object.fromEntries(f.current.entries()),
      "userAction"
    );
  }, B = () => {
    l({}), c.current = {}, f.current.clear();
  };
  Re.useImperativeHandle(r, () => ({
    getRowSelection: () => c.current,
    getRowSelectionData: () => f.current,
    reset: B,
    initializeRowSelection: p
  }));
  const L = (k, v) => v.some((b) => k.includes(b)), U = i != null && i.length ? d == null ? void 0 : d.data.filter(
    (k) => L(
      i,
      k.applicableCreativeTypeIds
    )
  ) : d == null ? void 0 : d.data;
  return /* @__PURE__ */ le.jsx(
    xs,
    {
      label: "Creative Size",
      select: "advanceSelect",
      placeholder: "Select Creative Sizes",
      sx: { width: 100 },
      SelectProps: {
        ...s,
        hideSearch: !0,
        data: U,
        apiRef: o,
        multiple: t,
        loading: m || x,
        enableSubRowSelection: !0,
        defaultExpanded: !0,
        getSubRows: (k) => k.subRows ?? void 0,
        overlay: w,
        // @ts-ignore
        renderValue: () => {
          const k = Object.keys(c.current);
          if (t)
            return k.length ? `${k.length} Selected` : "​";
          {
            const v = k[0] ?? "", b = f.current.get(v);
            return /* @__PURE__ */ le.jsx(
              Lh,
              {
                TypgraphyProps: {
                  component: "span"
                },
                children: (b == null ? void 0 : b.label) ?? "​"
              }
            );
          }
        },
        renderListItem: h,
        // @ts-ignore
        renderOption: ({ row: k }) => {
          const v = k.original.label, b = !!k.original.subRows;
          return /* @__PURE__ */ le.jsx(Bt, { sx: { textWeight: b ? "demi" : void 0 }, children: v });
        }
      },
      value: u,
      onChange: y,
      ...n
    }
  );
});
e9.displayName = "CreativeSizesFilter";
const r9 = async ({
  queryKey: e
}) => {
  var n;
  const { isSelectAll: r, scope: t, ...a } = e[0];
  try {
    const i = await Rs().post("/v3/master/adcategories", a), { data: s, totalRecords: o, filteredRecords: u } = i.data.data;
    return {
      totalRecords: o,
      filteredRecords: u,
      data: ZF(s)
    };
  } catch (i) {
    return Promise.reject((n = i == null ? void 0 : i.response) == null ? void 0 : n.data);
  }
}, t9 = async () => {
  var e;
  try {
    const r = await Rs().get("/v3/master/creative-sizes");
    return {
      data: QF(
        r.data.data
      )
    };
  } catch (r) {
    return Promise.reject((e = r == null ? void 0 : r.response) == null ? void 0 : e.data);
  }
}, a9 = async ({
  queryKey: e
}) => {
  var t;
  const r = e[0];
  try {
    const a = await Rs().post("/v3/master/segment/device-type", r), { data: n, totalRecords: i, filteredRecords: s } = a.data.data;
    return {
      totalRecords: i,
      filteredRecords: s,
      data: n.map((o) => ({ value: o.id, label: o.name }))
    };
  } catch (a) {
    return Promise.reject((t = a == null ? void 0 : a.response) == null ? void 0 : t.data);
  }
}, n9 = async ({
  queryKey: e
}) => {
  var t;
  const r = e[0];
  try {
    const a = await Rs().post("/v3/master/segment/country", r), { data: n, totalRecords: i, filteredRecords: s } = a.data.data;
    return {
      totalRecords: i,
      filteredRecords: s,
      data: n.map((o) => ({ label: o.name, value: o.id }))
    };
  } catch (a) {
    return Promise.reject((t = a == null ? void 0 : a.response) == null ? void 0 : t.data);
  }
}, i9 = {
  keys: (e) => [e]
}, s9 = {
  keys: (e) => [{ scope: e }]
}, o9 = {
  keys: (e) => [e]
}, u9 = {
  keys: (e) => [e]
}, l9 = {
  keys: (e) => [{ scope: e }]
}, D0 = (e) => {
  var r, t;
  (t = Mh) == null || t(
    e.errorObjects ? (r = e.errorObjects[0]) == null ? void 0 : r.error : "Something went wrong!",
    {
      variant: "error"
    }
  );
}, c9 = (e, r) => ms(
  i9.keys({
    ...e,
    scope: "getAdCategoryData"
  }),
  r9,
  {
    onError: D0,
    enabled: r == null ? void 0 : r.enabled
  }
), f9 = (e) => ms(
  s9.keys("getCreativeSizes"),
  t9,
  {
    onError: D0,
    enabled: e == null ? void 0 : e.enabled
  }
), d9 = (e, r) => ms(
  o9.keys({
    ...e,
    scope: "getDeviceTypes"
  }),
  a9,
  {
    onError: D0,
    enabled: r == null ? void 0 : r.enabled
  }
), h9 = (e, r) => ms(
  u9.keys({
    ...e,
    scope: "getCountries"
  }),
  n9,
  {
    onError: D0,
    enabled: r == null ? void 0 : r.enabled
  }
), x9 = Re.forwardRef((e, r) => {
  const {
    multiple: t = !0,
    slotProps: a,
    onChange: n,
    textFieldProps: i,
    ...s
  } = e, o = an.useSelectAdvanceApiRef(), [u, l] = Re.useState(""), [c, f] = Re.useState({}), h = Re.useRef(c);
  h.current = c;
  const d = Qo(u, 250), m = Re.useRef(
    new Map(Object.entries({}))
  ), x = an.DefaultListOptionItemWrapper(
    {
      disableCheckbox: !0,
      disableRowExpansion: !0,
      selectionStyle: "all",
      arrowPosition: "right"
    }
  ), p = Re.useCallback(
    (A) => {
      l(A);
    },
    [l]
  ), {
    data: w,
    isLoading: D,
    isFetching: y
  } = c9({
    searchField: d
  }), B = (A) => {
    const T = {};
    m.current.clear();
    for (const [C, I] of Object.entries(A))
      T[C] = !0, m.current.set(C, I);
    f(T), n == null || n(
      Object.fromEntries(m.current.entries()),
      "apiAction"
    );
  }, L = d.trim() ? w == null ? void 0 : w.data.filter(
    (A) => A.subRows.some(
      (T) => T.label.trim().toLowerCase().includes(d.trim().toLowerCase())
    )
  ) : w == null ? void 0 : w.data, U = () => {
    if (!(D || y)) {
      if (!Array.isArray(w == null ? void 0 : w.data))
        return "error";
      if (((L == null ? void 0 : L.length) ?? 0) <= 0)
        return u ? "noResult" : "noRows";
    }
  }, k = () => {
    const A = m.current.entries(), T = o.current.tableInstance.getRowModel().rowsById, C = {};
    for (const I of A) {
      const [Y, j] = I;
      T[Y] && (C[Y] = j);
    }
    return C;
  }, v = (A) => {
    var ce, V;
    const T = typeof A == "function" ? A(c) : A;
    if (t === !1) {
      const ee = Object.keys(T)[0], F = (ce = o.current.tableInstance.getRowModel().rowsById[ee]) == null ? void 0 : ce.original;
      m.current.clear(), m.current.set(ee, F), f(A), typeof n == "function" && n(
        Object.fromEntries(m.current.entries()),
        "userAction"
      );
      return;
    }
    const C = Object.keys(T), I = k(), Y = Object.keys(I), j = o.current.tableInstance.getRowModel().rowsById, J = C.filter(
      (ee) => I[ee] === void 0
    ), W = Y.filter(
      (ee) => T[ee] === void 0
    );
    for (const ee of J)
      (V = j[ee]) != null && V.original && m.current.set(ee, j[ee].original);
    for (const ee of W)
      m.current.delete(ee);
    f(A), typeof n == "function" && n(
      Object.fromEntries(m.current.entries()),
      "userAction"
    );
  }, b = () => {
    p(""), f({}), h.current = {}, m.current.clear();
  };
  return Re.useImperativeHandle(r, () => ({
    getRowSelection: () => h.current,
    getRowSelectionData: () => m.current,
    getCurrentData: () => (w == null ? void 0 : w.data) ?? [],
    setSearch: p,
    reset: b,
    initializeRowSelection: B
  })), /* @__PURE__ */ le.jsx(
    xs,
    {
      label: "IAB Categories",
      select: "advanceSelect",
      placeholder: "Select IAB Categories",
      sx: { width: 100 },
      SelectProps: {
        slotProps: {
          ...a,
          InputBaseProps: {
            placeholder: "Search",
            ...a == null ? void 0 : a.InputBaseProps
          }
        },
        ...s,
        data: L ?? [],
        apiRef: o,
        inputValue: u,
        multiple: t,
        loading: D || y,
        enableSubRowSelection: !0,
        defaultExpanded: !0,
        getSubRows: (A) => A.subRows ?? void 0,
        overlay: U(),
        onInputChange: (A, T, C) => {
          C !== "reset" && p(T);
        },
        // @ts-ignore
        renderValue: () => {
          const A = Object.keys(h.current);
          if (t)
            return A.length ? `${A.length} Selected` : "​";
          {
            const T = A[0] ?? "", C = m.current.get(T);
            return /* @__PURE__ */ le.jsx(
              Lh,
              {
                TypgraphyProps: {
                  component: "span"
                },
                children: (C == null ? void 0 : C.label) ?? "​"
              }
            );
          }
        },
        renderListItem: x,
        // @ts-ignore
        renderOption: ({ row: A }) => {
          const T = A.original.label, C = !!A.original.subRows;
          return /* @__PURE__ */ le.jsx(Bt, { sx: { textWeight: C ? "demi" : void 0 }, children: T });
        }
        // onSelectAll: isSelectAll => {
        //   if (isSelectAll) {
        //     setIsSelectAll(isSelectAll)
        //   }
        // },
      },
      value: c,
      onChange: v,
      ...i
    }
  );
});
x9.displayName = "AdCategoriesFilter";
const j9 = () => {
  const e = Y2(), r = K2(), t = Re.useMemo(
    () => e == null ? void 0 : e.getDatadogInstance(),
    [e]
  ), a = r.matches[r.matches.length - 1];
  Re.useEffect(() => {
    t && t.startView({ name: a == null ? void 0 : a.routeId });
  }, [a == null ? void 0 : a.routeId, a == null ? void 0 : a.id]);
}, z9 = (e) => {
  const { textFieldProps: r, value: t, onChange: a } = e, [n, i] = Re.useState(""), s = Qo(n, 250), o = an.DefaultListOptionItemWrapper({
    disableCheckbox: !0,
    selectionStyle: "none",
    arrowPosition: "right"
  }), { data: u, isFetching: l, isLoading: c } = h9({ sortBy: "+id" }), f = (u == null ? void 0 : u.data) ?? [], h = s.trim() ? f.filter(
    (x) => x.label.trim().toLowerCase().includes(s.trim().toLowerCase())
  ) : f, d = () => {
    if (!(c || l)) {
      if (!Array.isArray(u == null ? void 0 : u.data))
        return "error";
      if (((h == null ? void 0 : h.length) ?? 0) <= 0)
        return n ? "noResult" : "noRows";
    }
  }, m = t.reduce(
    (x, p) => (x[p.value] = !0, x),
    {}
  );
  return /* @__PURE__ */ le.jsx(
    xs,
    {
      ...r,
      sx: { width: 100 },
      select: "advanceSelect",
      placeholder: "Select Country",
      label: "Country",
      SelectProps: {
        allowClearingSingleSelect: !0,
        data: h ?? [],
        multiple: !1,
        inputValue: n,
        onInputChange: (x, p, w) => {
          w !== "reset" && i(p);
        },
        rowCount: (h == null ? void 0 : h.length) ?? 0,
        overlay: d(),
        renderValue: (x) => {
          var p;
          return /* @__PURE__ */ le.jsx(Bt, { children: ((p = x == null ? void 0 : x[0]) == null ? void 0 : p.label) ?? "​" });
        },
        renderListItem: o,
        renderOption: ({ row: x }) => {
          const p = x.original.label;
          return /* @__PURE__ */ le.jsx(Bt, { children: p });
        }
      },
      value: m,
      onChange: (x) => {
        const p = x(m), w = Object.keys(p).map((y) => parseInt(y)), D = f == null ? void 0 : f.filter(
          (y) => w.includes(y == null ? void 0 : y.value)
        );
        a(D ?? []);
      }
    }
  );
}, G9 = (e) => {
  const { textFieldProps: r, value: t, onChange: a } = e, [n, i] = Re.useState(""), s = Qo(n, 250), { data: o, isLoading: u, isFetching: l } = d9(), c = an.DefaultListOptionItemWrapper({
    disableCheckbox: !0,
    selectionStyle: "none",
    arrowPosition: "right"
  }), f = s.trim() ? o == null ? void 0 : o.data.filter(
    (m) => m.label.trim().toLowerCase().includes(s.trim().toLowerCase())
  ) : o == null ? void 0 : o.data, h = () => {
    if (!(u || l)) {
      if (!Array.isArray(o == null ? void 0 : o.data))
        return "error";
      if (((f == null ? void 0 : f.length) ?? 0) <= 0)
        return n ? "noResult" : "noRows";
    }
  }, d = t.reduce(
    (m, x) => (m[x.value] = !0, m),
    {}
  );
  return /* @__PURE__ */ le.jsx(
    xs,
    {
      ...r,
      sx: { width: 100 },
      select: "advanceSelect",
      placeholder: "Select Device Types",
      label: "Device Types",
      SelectProps: {
        slotProps: { PaperProps: { sx: { height: "auto" } } },
        data: f ?? [],
        overlay: h(),
        multiple: !0,
        inputValue: n,
        onInputChange: (m, x, p) => {
          p !== "reset" && i(x);
        },
        rowCount: (f == null ? void 0 : f.length) ?? 0,
        renderValue: (m) => (
          // @ts-ignore
          /* @__PURE__ */ le.jsx(Bt, { children: `${m == null ? void 0 : m.length} Selected` })
        ),
        renderListItem: c,
        renderOption: ({ row: m }) => /* @__PURE__ */ le.jsx(Bt, { children: m.original.label })
      },
      value: d,
      onChange: (m) => {
        const x = m(d), p = Object.keys(x).map((D) => parseInt(D)), w = o == null ? void 0 : o.data.filter(
          (D) => p.includes(D == null ? void 0 : D.value)
        );
        a(w ?? []);
      }
    }
  );
}, m9 = async ({
  signal: e
}) => {
  var a, n;
  const { CancelToken: r } = Hh, t = r.source();
  e == null || e.addEventListener("abort", () => {
    t.cancel("/v3/master/timezones - Request cancelled");
  });
  try {
    const i = await Rs().get("/v3/master/timezones", {
      cancelToken: t.token
    });
    return (a = i == null ? void 0 : i.data) == null ? void 0 : a.data;
  } catch (i) {
    return Promise.reject(((n = i == null ? void 0 : i.response) == null ? void 0 : n.data) || i);
  }
}, p9 = (e) => {
  console.log({ e });
}, v9 = () => {
  const e = ms(
    l9.keys("getTimezoneList"),
    m9,
    {
      cacheTime: 1 / 0
    }
  );
  if (e.isError) {
    const r = e.error;
    p9(r);
  }
  return e;
}, K9 = (e) => {
  const { textFieldProps: r, value: t, onChange: a, variant: n, size: i = "medium" } = e, [s, o] = Re.useState(""), u = Qo(s, 250), l = an.DefaultListOptionItemWrapper({
    disableCheckbox: !0,
    selectionStyle: "none",
    arrowPosition: "right"
  }), { data: c, isFetching: f, isLoading: h } = v9(), d = (c == null ? void 0 : c.data) ?? [], m = u.trim() ? d.filter(
    (w) => w.label.trim().toLowerCase().includes(u.trim().toLowerCase())
  ) : d, x = () => {
    if (!(h || f)) {
      if (!Array.isArray(c == null ? void 0 : c.data))
        return "error";
      if (((m == null ? void 0 : m.length) ?? 0) <= 0)
        return s ? "noResult" : "noRows";
    }
  }, p = t.reduce(
    (w, D) => (w[D.id] = !0, w),
    {}
  );
  return /* @__PURE__ */ le.jsx(
    xs,
    {
      ...r,
      sx: { width: 100 },
      select: "advanceSelect",
      placeholder: "Select Timezone",
      variant: n,
      label: "Timezone",
      InputProps: {
        startAdornment: /* @__PURE__ */ le.jsx(G2, {})
      },
      size: i,
      SelectProps: {
        allowClearingSingleSelect: !0,
        data: m ?? [],
        multiple: !1,
        inputValue: s,
        loading: h,
        onInputChange: (w, D, y) => {
          y !== "reset" && o(D);
        },
        rowCount: (m == null ? void 0 : m.length) ?? 0,
        overlay: x(),
        getRowId: (w) => `${w.id}`,
        renderValue: () => {
          var w;
          return /* @__PURE__ */ le.jsx(Bt, { children: ((w = t == null ? void 0 : t[0]) == null ? void 0 : w.name) ?? "​" });
        },
        renderListItem: l,
        renderOption: ({ row: w }) => {
          const D = w.original.label;
          return /* @__PURE__ */ le.jsx(Bt, { children: D });
        }
      },
      value: p,
      onChange: (w) => {
        const D = w(p), y = Object.keys(D).map((L) => parseInt(L)), B = d == null ? void 0 : d.filter(
          (L) => y.includes(L == null ? void 0 : L.id)
        );
        a(B ?? []);
      }
    }
  );
};
export {
  x9 as AdCategoriesFilter,
  Ih as CSV_FORMAT,
  z9 as CountryFilter,
  e9 as CreativeSizesFilter,
  N9 as DatePicker,
  U9 as DateRangePicker,
  G9 as DeviceTypesFilter,
  Rh as EXCEL_FORMATS,
  V9 as SampleFile,
  K9 as TimezonePicker,
  W9 as UploadFile,
  H9 as attachIqmInstance,
  V2 as downloadBlob,
  O9 as downloadDataAsXLSXFile,
  M9 as downloadFile,
  vl as formatDateFromEpoch,
  P9 as getExcelOrCsvFileData,
  Rs as getInstance,
  L9 as getValidURL,
  B9 as handleTimezoneChange,
  xF as isValidFileType,
  ZF as normalizeAdCategoryData,
  QF as normalizeCreativeSizeData,
  c9 as useAdCategoryData,
  h9 as useCountriesData,
  f9 as useCreativeSizesData,
  j9 as useDatadogTrackViewsManually,
  d9 as useDeviceTypesData
};
//# sourceMappingURL=index.js.map
